
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7a32"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7a32"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2nzLi", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $1bb9784afa87e369$export$ffb0004e005737fa; }, function (v) { return $1bb9784afa87e369$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $1bb9784afa87e369$export$34b9dba7ce09269b; }, function (v) { return $1bb9784afa87e369$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $1bb9784afa87e369$export$25062201e9e25d76; }, function (v) { return $1bb9784afa87e369$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bb9784afa87e369$export$ffb0004e005737fa;
var $1bb9784afa87e369$export$34b9dba7ce09269b;
var $1bb9784afa87e369$export$25062201e9e25d76;
'use strict';

var $7fPBF = parcelRequire("7fPBF");
var $1bb9784afa87e369$var$k = Symbol.for("react.element"), $1bb9784afa87e369$var$l = Symbol.for("react.fragment"), $1bb9784afa87e369$var$m = Object.prototype.hasOwnProperty, $1bb9784afa87e369$var$n = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $1bb9784afa87e369$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1bb9784afa87e369$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$1bb9784afa87e369$var$m.call(a, b) && !$1bb9784afa87e369$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $1bb9784afa87e369$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $1bb9784afa87e369$var$n.current
    };
}
$1bb9784afa87e369$export$ffb0004e005737fa = $1bb9784afa87e369$var$l;
$1bb9784afa87e369$export$34b9dba7ce09269b = $1bb9784afa87e369$var$q;
$1bb9784afa87e369$export$25062201e9e25d76 = $1bb9784afa87e369$var$q;

});
parcelRegister("7fPBF", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fSPLm"));

});
parcelRegister("fSPLm", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $b9040d2deeb360f4$export$dca3b0875bd9a954; }, function (v) { return $b9040d2deeb360f4$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $b9040d2deeb360f4$export$16fa2f45be04daa8; }, function (v) { return $b9040d2deeb360f4$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b9040d2deeb360f4$export$ffb0004e005737fa; }, function (v) { return $b9040d2deeb360f4$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $b9040d2deeb360f4$export$e2c29f18771995cb; }, function (v) { return $b9040d2deeb360f4$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $b9040d2deeb360f4$export$221d75b3f55bb0bd; }, function (v) { return $b9040d2deeb360f4$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b9040d2deeb360f4$export$5f8d39834fd61797; }, function (v) { return $b9040d2deeb360f4$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b9040d2deeb360f4$export$74bf444e3cd11ea5; }, function (v) { return $b9040d2deeb360f4$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b9040d2deeb360f4$export$ae55be85d98224ed; }, function (v) { return $b9040d2deeb360f4$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $b9040d2deeb360f4$export$3ba232387fd5d6dd; }, function (v) { return $b9040d2deeb360f4$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $b9040d2deeb360f4$export$e530037191fcd5d7; }, function (v) { return $b9040d2deeb360f4$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $b9040d2deeb360f4$export$fd42f52fd3ae1109; }, function (v) { return $b9040d2deeb360f4$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $b9040d2deeb360f4$export$c8a8987d4410bf2d; }, function (v) { return $b9040d2deeb360f4$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $b9040d2deeb360f4$export$d38cd72104c1f0e9; }, function (v) { return $b9040d2deeb360f4$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43; }, function (v) { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $b9040d2deeb360f4$export$257a8862b851cb5b; }, function (v) { return $b9040d2deeb360f4$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $b9040d2deeb360f4$export$a8257692ac88316c; }, function (v) { return $b9040d2deeb360f4$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $b9040d2deeb360f4$export$488013bae63b21da; }, function (v) { return $b9040d2deeb360f4$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $b9040d2deeb360f4$export$7c73462e0d25e514; }, function (v) { return $b9040d2deeb360f4$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $b9040d2deeb360f4$export$7568632d0d33d16d; }, function (v) { return $b9040d2deeb360f4$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $b9040d2deeb360f4$export$88948ce120ea2619; }, function (v) { return $b9040d2deeb360f4$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $b9040d2deeb360f4$export$35808ee640e87ca7; }, function (v) { return $b9040d2deeb360f4$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $b9040d2deeb360f4$export$fae74005e78b1a27; }, function (v) { return $b9040d2deeb360f4$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e; }, function (v) { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $b9040d2deeb360f4$export$6a7bc4e911dc01cf; }, function (v) { return $b9040d2deeb360f4$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $b9040d2deeb360f4$export$6d9c69b0de29b591; }, function (v) { return $b9040d2deeb360f4$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $b9040d2deeb360f4$export$f680877a34711e37; }, function (v) { return $b9040d2deeb360f4$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $b9040d2deeb360f4$export$d5a552a76deda3c2; }, function (v) { return $b9040d2deeb360f4$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $b9040d2deeb360f4$export$aaabe4eda9ed9969; }, function (v) { return $b9040d2deeb360f4$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $b9040d2deeb360f4$export$e5c5a5f917a5871c; }, function (v) { return $b9040d2deeb360f4$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $b9040d2deeb360f4$export$1538c33de8887b59; }, function (v) { return $b9040d2deeb360f4$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $b9040d2deeb360f4$export$13e3392192263954; }, function (v) { return $b9040d2deeb360f4$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $b9040d2deeb360f4$export$b8f5890fc79d6aca; }, function (v) { return $b9040d2deeb360f4$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $b9040d2deeb360f4$export$60241385465d0a34; }, function (v) { return $b9040d2deeb360f4$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $b9040d2deeb360f4$export$306c0aa65ff9ec16; }, function (v) { return $b9040d2deeb360f4$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $b9040d2deeb360f4$export$7b286972b8d8ccbf; }, function (v) { return $b9040d2deeb360f4$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $b9040d2deeb360f4$export$83d89fbfd8236492; }, function (v) { return $b9040d2deeb360f4$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b9040d2deeb360f4$export$dca3b0875bd9a954;
var $b9040d2deeb360f4$export$16fa2f45be04daa8;
var $b9040d2deeb360f4$export$ffb0004e005737fa;
var $b9040d2deeb360f4$export$e2c29f18771995cb;
var $b9040d2deeb360f4$export$221d75b3f55bb0bd;
var $b9040d2deeb360f4$export$5f8d39834fd61797;
var $b9040d2deeb360f4$export$74bf444e3cd11ea5;
var $b9040d2deeb360f4$export$ae55be85d98224ed;
var $b9040d2deeb360f4$export$3ba232387fd5d6dd;
var $b9040d2deeb360f4$export$e530037191fcd5d7;
var $b9040d2deeb360f4$export$fd42f52fd3ae1109;
var $b9040d2deeb360f4$export$c8a8987d4410bf2d;
var $b9040d2deeb360f4$export$d38cd72104c1f0e9;
var $b9040d2deeb360f4$export$7d1e3a5e95ceca43;
var $b9040d2deeb360f4$export$257a8862b851cb5b;
var $b9040d2deeb360f4$export$a8257692ac88316c;
var $b9040d2deeb360f4$export$488013bae63b21da;
var $b9040d2deeb360f4$export$7c73462e0d25e514;
var $b9040d2deeb360f4$export$7568632d0d33d16d;
var $b9040d2deeb360f4$export$88948ce120ea2619;
var $b9040d2deeb360f4$export$35808ee640e87ca7;
var $b9040d2deeb360f4$export$fae74005e78b1a27;
var $b9040d2deeb360f4$export$dc8fbce3eb94dc1e;
var $b9040d2deeb360f4$export$6a7bc4e911dc01cf;
var $b9040d2deeb360f4$export$6d9c69b0de29b591;
var $b9040d2deeb360f4$export$f680877a34711e37;
var $b9040d2deeb360f4$export$d5a552a76deda3c2;
var $b9040d2deeb360f4$export$aaabe4eda9ed9969;
var $b9040d2deeb360f4$export$e5c5a5f917a5871c;
var $b9040d2deeb360f4$export$1538c33de8887b59;
var $b9040d2deeb360f4$export$13e3392192263954;
var $b9040d2deeb360f4$export$b8f5890fc79d6aca;
var $b9040d2deeb360f4$export$60241385465d0a34;
var $b9040d2deeb360f4$export$306c0aa65ff9ec16;
var $b9040d2deeb360f4$export$7b286972b8d8ccbf;
var $b9040d2deeb360f4$export$83d89fbfd8236492;
'use strict';
var $b9040d2deeb360f4$var$l = Symbol.for("react.element"), $b9040d2deeb360f4$var$n = Symbol.for("react.portal"), $b9040d2deeb360f4$var$p = Symbol.for("react.fragment"), $b9040d2deeb360f4$var$q = Symbol.for("react.strict_mode"), $b9040d2deeb360f4$var$r = Symbol.for("react.profiler"), $b9040d2deeb360f4$var$t = Symbol.for("react.provider"), $b9040d2deeb360f4$var$u = Symbol.for("react.context"), $b9040d2deeb360f4$var$v = Symbol.for("react.forward_ref"), $b9040d2deeb360f4$var$w = Symbol.for("react.suspense"), $b9040d2deeb360f4$var$x = Symbol.for("react.memo"), $b9040d2deeb360f4$var$y = Symbol.for("react.lazy"), $b9040d2deeb360f4$var$z = Symbol.iterator;
function $b9040d2deeb360f4$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b9040d2deeb360f4$var$z && a[$b9040d2deeb360f4$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b9040d2deeb360f4$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $b9040d2deeb360f4$var$C = Object.assign, $b9040d2deeb360f4$var$D = {};
function $b9040d2deeb360f4$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$D;
    this.updater = e || $b9040d2deeb360f4$var$B;
}
$b9040d2deeb360f4$var$E.prototype.isReactComponent = {};
$b9040d2deeb360f4$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$b9040d2deeb360f4$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $b9040d2deeb360f4$var$F() {}
$b9040d2deeb360f4$var$F.prototype = $b9040d2deeb360f4$var$E.prototype;
function $b9040d2deeb360f4$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$D;
    this.updater = e || $b9040d2deeb360f4$var$B;
}
var $b9040d2deeb360f4$var$H = $b9040d2deeb360f4$var$G.prototype = new $b9040d2deeb360f4$var$F;
$b9040d2deeb360f4$var$H.constructor = $b9040d2deeb360f4$var$G;
$b9040d2deeb360f4$var$C($b9040d2deeb360f4$var$H, $b9040d2deeb360f4$var$E.prototype);
$b9040d2deeb360f4$var$H.isPureReactComponent = !0;
var $b9040d2deeb360f4$var$I = Array.isArray, $b9040d2deeb360f4$var$J = Object.prototype.hasOwnProperty, $b9040d2deeb360f4$var$K = {
    current: null
}, $b9040d2deeb360f4$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b9040d2deeb360f4$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$b9040d2deeb360f4$var$J.call(b, d) && !$b9040d2deeb360f4$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $b9040d2deeb360f4$var$K.current
    };
}
function $b9040d2deeb360f4$var$N(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $b9040d2deeb360f4$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b9040d2deeb360f4$var$l;
}
function $b9040d2deeb360f4$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $b9040d2deeb360f4$var$P = /\/+/g;
function $b9040d2deeb360f4$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $b9040d2deeb360f4$var$escape("" + a.key) : b.toString(36);
}
function $b9040d2deeb360f4$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $b9040d2deeb360f4$var$l:
                case $b9040d2deeb360f4$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $b9040d2deeb360f4$var$Q(h, 0) : d, $b9040d2deeb360f4$var$I(c) ? (e = "", null != a && (e = a.replace($b9040d2deeb360f4$var$P, "$&/") + "/"), $b9040d2deeb360f4$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($b9040d2deeb360f4$var$O(c) && (c = $b9040d2deeb360f4$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($b9040d2deeb360f4$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($b9040d2deeb360f4$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $b9040d2deeb360f4$var$Q(k, g);
        h += $b9040d2deeb360f4$var$R(k, b, e, f, c);
    }
    else if (f = $b9040d2deeb360f4$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $b9040d2deeb360f4$var$Q(k, g++), h += $b9040d2deeb360f4$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $b9040d2deeb360f4$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $b9040d2deeb360f4$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $b9040d2deeb360f4$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $b9040d2deeb360f4$var$U = {
    current: null
}, $b9040d2deeb360f4$var$V = {
    transition: null
}, $b9040d2deeb360f4$var$W = {
    ReactCurrentDispatcher: $b9040d2deeb360f4$var$U,
    ReactCurrentBatchConfig: $b9040d2deeb360f4$var$V,
    ReactCurrentOwner: $b9040d2deeb360f4$var$K
};
function $b9040d2deeb360f4$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$b9040d2deeb360f4$export$dca3b0875bd9a954 = {
    map: $b9040d2deeb360f4$var$S,
    forEach: function(a, b, e) {
        $b9040d2deeb360f4$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $b9040d2deeb360f4$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $b9040d2deeb360f4$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$b9040d2deeb360f4$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$b9040d2deeb360f4$export$16fa2f45be04daa8 = $b9040d2deeb360f4$var$E;
$b9040d2deeb360f4$export$ffb0004e005737fa = $b9040d2deeb360f4$var$p;
$b9040d2deeb360f4$export$e2c29f18771995cb = $b9040d2deeb360f4$var$r;
$b9040d2deeb360f4$export$221d75b3f55bb0bd = $b9040d2deeb360f4$var$G;
$b9040d2deeb360f4$export$5f8d39834fd61797 = $b9040d2deeb360f4$var$q;
$b9040d2deeb360f4$export$74bf444e3cd11ea5 = $b9040d2deeb360f4$var$w;
$b9040d2deeb360f4$export$ae55be85d98224ed = $b9040d2deeb360f4$var$W;
$b9040d2deeb360f4$export$3ba232387fd5d6dd = $b9040d2deeb360f4$var$X;
$b9040d2deeb360f4$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $b9040d2deeb360f4$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $b9040d2deeb360f4$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$b9040d2deeb360f4$var$J.call(b, f) && !$b9040d2deeb360f4$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$b9040d2deeb360f4$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $b9040d2deeb360f4$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $b9040d2deeb360f4$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$b9040d2deeb360f4$export$c8a8987d4410bf2d = $b9040d2deeb360f4$var$M;
$b9040d2deeb360f4$export$d38cd72104c1f0e9 = function(a) {
    var b = $b9040d2deeb360f4$var$M.bind(null, a);
    b.type = a;
    return b;
};
$b9040d2deeb360f4$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$b9040d2deeb360f4$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$v,
        render: a
    };
};
$b9040d2deeb360f4$export$a8257692ac88316c = $b9040d2deeb360f4$var$O;
$b9040d2deeb360f4$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $b9040d2deeb360f4$var$T
    };
};
$b9040d2deeb360f4$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$b9040d2deeb360f4$export$7568632d0d33d16d = function(a) {
    var b = $b9040d2deeb360f4$var$V.transition;
    $b9040d2deeb360f4$var$V.transition = {};
    try {
        a();
    } finally{
        $b9040d2deeb360f4$var$V.transition = b;
    }
};
$b9040d2deeb360f4$export$88948ce120ea2619 = $b9040d2deeb360f4$var$X;
$b9040d2deeb360f4$export$35808ee640e87ca7 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useCallback(a, b);
};
$b9040d2deeb360f4$export$fae74005e78b1a27 = function(a) {
    return $b9040d2deeb360f4$var$U.current.useContext(a);
};
$b9040d2deeb360f4$export$dc8fbce3eb94dc1e = function() {};
$b9040d2deeb360f4$export$6a7bc4e911dc01cf = function(a) {
    return $b9040d2deeb360f4$var$U.current.useDeferredValue(a);
};
$b9040d2deeb360f4$export$6d9c69b0de29b591 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useEffect(a, b);
};
$b9040d2deeb360f4$export$f680877a34711e37 = function() {
    return $b9040d2deeb360f4$var$U.current.useId();
};
$b9040d2deeb360f4$export$d5a552a76deda3c2 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useImperativeHandle(a, b, e);
};
$b9040d2deeb360f4$export$aaabe4eda9ed9969 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useInsertionEffect(a, b);
};
$b9040d2deeb360f4$export$e5c5a5f917a5871c = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useLayoutEffect(a, b);
};
$b9040d2deeb360f4$export$1538c33de8887b59 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useMemo(a, b);
};
$b9040d2deeb360f4$export$13e3392192263954 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useReducer(a, b, e);
};
$b9040d2deeb360f4$export$b8f5890fc79d6aca = function(a) {
    return $b9040d2deeb360f4$var$U.current.useRef(a);
};
$b9040d2deeb360f4$export$60241385465d0a34 = function(a) {
    return $b9040d2deeb360f4$var$U.current.useState(a);
};
$b9040d2deeb360f4$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useSyncExternalStore(a, b, e);
};
$b9040d2deeb360f4$export$7b286972b8d8ccbf = function() {
    return $b9040d2deeb360f4$var$U.current.useTransition();
};
$b9040d2deeb360f4$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("6EA3T", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $4d82739dd229d539$export$ae55be85d98224ed; }, function (v) { return $4d82739dd229d539$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $4d82739dd229d539$export$d39a5bbd09211389; }, function (v) { return $4d82739dd229d539$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $4d82739dd229d539$export$882461b6382ed46c; }, function (v) { return $4d82739dd229d539$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $4d82739dd229d539$export$466bfc07425424d5; }, function (v) { return $4d82739dd229d539$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $4d82739dd229d539$export$cd75ccfd720a3cd4; }, function (v) { return $4d82739dd229d539$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $4d82739dd229d539$export$fa8d919ba61d84db; }, function (v) { return $4d82739dd229d539$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $4d82739dd229d539$export$757ceba2d55c277e; }, function (v) { return $4d82739dd229d539$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $4d82739dd229d539$export$b3890eb0ae9dca99; }, function (v) { return $4d82739dd229d539$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $4d82739dd229d539$export$502457920280e6be; }, function (v) { return $4d82739dd229d539$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $4d82739dd229d539$export$c78a37762a8d58e1; }, function (v) { return $4d82739dd229d539$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $4d82739dd229d539$export$dc54d992c10e8a18; }, function (v) { return $4d82739dd229d539$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $4d82739dd229d539$export$83d89fbfd8236492; }, function (v) { return $4d82739dd229d539$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $4d82739dd229d539$export$ae55be85d98224ed;
var $4d82739dd229d539$export$d39a5bbd09211389;
var $4d82739dd229d539$export$882461b6382ed46c;
var $4d82739dd229d539$export$466bfc07425424d5;
var $4d82739dd229d539$export$cd75ccfd720a3cd4;
var $4d82739dd229d539$export$fa8d919ba61d84db;
var $4d82739dd229d539$export$757ceba2d55c277e;
var $4d82739dd229d539$export$b3890eb0ae9dca99;
var $4d82739dd229d539$export$502457920280e6be;
var $4d82739dd229d539$export$c78a37762a8d58e1;
var $4d82739dd229d539$export$dc54d992c10e8a18;
var $4d82739dd229d539$export$83d89fbfd8236492;
'use strict';

var $7fPBF = parcelRequire("7fPBF");

var $33s19 = parcelRequire("33s19");
function $4d82739dd229d539$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $4d82739dd229d539$var$da = new Set, $4d82739dd229d539$var$ea = {};
function $4d82739dd229d539$var$fa(a, b) {
    $4d82739dd229d539$var$ha(a, b);
    $4d82739dd229d539$var$ha(a + "Capture", b);
}
function $4d82739dd229d539$var$ha(a, b) {
    $4d82739dd229d539$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$4d82739dd229d539$var$da.add(b[a]);
}
var $4d82739dd229d539$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $4d82739dd229d539$var$ja = Object.prototype.hasOwnProperty, $4d82739dd229d539$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $4d82739dd229d539$var$la = {}, $4d82739dd229d539$var$ma = {};
function $4d82739dd229d539$var$oa(a) {
    if ($4d82739dd229d539$var$ja.call($4d82739dd229d539$var$ma, a)) return !0;
    if ($4d82739dd229d539$var$ja.call($4d82739dd229d539$var$la, a)) return !1;
    if ($4d82739dd229d539$var$ka.test(a)) return $4d82739dd229d539$var$ma[a] = !0;
    $4d82739dd229d539$var$la[a] = !0;
    return !1;
}
function $4d82739dd229d539$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $4d82739dd229d539$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $4d82739dd229d539$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $4d82739dd229d539$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $4d82739dd229d539$var$ra = /[\-:]([a-z])/g;
function $4d82739dd229d539$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$4d82739dd229d539$var$z.xlinkHref = new $4d82739dd229d539$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $4d82739dd229d539$var$ta(a, b, c, d) {
    var e = $4d82739dd229d539$var$z.hasOwnProperty(b) ? $4d82739dd229d539$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $4d82739dd229d539$var$qa(b, c, e, d) && (c = null), d || null === e ? $4d82739dd229d539$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $4d82739dd229d539$var$ua = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $4d82739dd229d539$var$va = Symbol.for("react.element"), $4d82739dd229d539$var$wa = Symbol.for("react.portal"), $4d82739dd229d539$var$ya = Symbol.for("react.fragment"), $4d82739dd229d539$var$za = Symbol.for("react.strict_mode"), $4d82739dd229d539$var$Aa = Symbol.for("react.profiler"), $4d82739dd229d539$var$Ba = Symbol.for("react.provider"), $4d82739dd229d539$var$Ca = Symbol.for("react.context"), $4d82739dd229d539$var$Da = Symbol.for("react.forward_ref"), $4d82739dd229d539$var$Ea = Symbol.for("react.suspense"), $4d82739dd229d539$var$Fa = Symbol.for("react.suspense_list"), $4d82739dd229d539$var$Ga = Symbol.for("react.memo"), $4d82739dd229d539$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $4d82739dd229d539$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $4d82739dd229d539$var$Ja = Symbol.iterator;
function $4d82739dd229d539$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $4d82739dd229d539$var$Ja && a[$4d82739dd229d539$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $4d82739dd229d539$var$A = Object.assign, $4d82739dd229d539$var$La;
function $4d82739dd229d539$var$Ma(a) {
    if (void 0 === $4d82739dd229d539$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $4d82739dd229d539$var$La = b && b[1] || "";
    }
    return "\n" + $4d82739dd229d539$var$La + a;
}
var $4d82739dd229d539$var$Na = !1;
function $4d82739dd229d539$var$Oa(a, b) {
    if (!a || $4d82739dd229d539$var$Na) return "";
    $4d82739dd229d539$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $4d82739dd229d539$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $4d82739dd229d539$var$Ma(a) : "";
}
function $4d82739dd229d539$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $4d82739dd229d539$var$Ma(a.type);
        case 16:
            return $4d82739dd229d539$var$Ma("Lazy");
        case 13:
            return $4d82739dd229d539$var$Ma("Suspense");
        case 19:
            return $4d82739dd229d539$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $4d82739dd229d539$var$Oa(a.type, !1), a;
        case 11:
            return a = $4d82739dd229d539$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $4d82739dd229d539$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $4d82739dd229d539$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $4d82739dd229d539$var$ya:
            return "Fragment";
        case $4d82739dd229d539$var$wa:
            return "Portal";
        case $4d82739dd229d539$var$Aa:
            return "Profiler";
        case $4d82739dd229d539$var$za:
            return "StrictMode";
        case $4d82739dd229d539$var$Ea:
            return "Suspense";
        case $4d82739dd229d539$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $4d82739dd229d539$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $4d82739dd229d539$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $4d82739dd229d539$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $4d82739dd229d539$var$Ga:
            return b = a.displayName || null, null !== b ? b : $4d82739dd229d539$var$Qa(a.type) || "Memo";
        case $4d82739dd229d539$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $4d82739dd229d539$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $4d82739dd229d539$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $4d82739dd229d539$var$Qa(b);
        case 8:
            return b === $4d82739dd229d539$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $4d82739dd229d539$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $4d82739dd229d539$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $4d82739dd229d539$var$Ua(a) {
    var b = $4d82739dd229d539$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $4d82739dd229d539$var$Va(a) {
    a._valueTracker || (a._valueTracker = $4d82739dd229d539$var$Ua(a));
}
function $4d82739dd229d539$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $4d82739dd229d539$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $4d82739dd229d539$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $4d82739dd229d539$var$Ya(a, b) {
    var c = b.checked;
    return $4d82739dd229d539$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $4d82739dd229d539$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $4d82739dd229d539$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $4d82739dd229d539$var$ab(a, b) {
    b = b.checked;
    null != b && $4d82739dd229d539$var$ta(a, "checked", b, !1);
}
function $4d82739dd229d539$var$bb(a, b) {
    $4d82739dd229d539$var$ab(a, b);
    var c = $4d82739dd229d539$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $4d82739dd229d539$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $4d82739dd229d539$var$cb(a, b.type, $4d82739dd229d539$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $4d82739dd229d539$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $4d82739dd229d539$var$cb(a, b, c) {
    if ("number" !== b || $4d82739dd229d539$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $4d82739dd229d539$var$eb = Array.isArray;
function $4d82739dd229d539$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $4d82739dd229d539$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $4d82739dd229d539$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($4d82739dd229d539$var$p(91));
    return $4d82739dd229d539$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $4d82739dd229d539$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($4d82739dd229d539$var$p(92));
            if ($4d82739dd229d539$var$eb(c)) {
                if (1 < c.length) throw Error($4d82739dd229d539$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $4d82739dd229d539$var$Sa(c)
    };
}
function $4d82739dd229d539$var$ib(a, b) {
    var c = $4d82739dd229d539$var$Sa(b.value), d = $4d82739dd229d539$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $4d82739dd229d539$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $4d82739dd229d539$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $4d82739dd229d539$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $4d82739dd229d539$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $4d82739dd229d539$var$mb, $4d82739dd229d539$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $4d82739dd229d539$var$mb = $4d82739dd229d539$var$mb || document.createElement("div");
        $4d82739dd229d539$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $4d82739dd229d539$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $4d82739dd229d539$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $4d82739dd229d539$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $4d82739dd229d539$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($4d82739dd229d539$var$pb).forEach(function(a) {
    $4d82739dd229d539$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $4d82739dd229d539$var$pb[b] = $4d82739dd229d539$var$pb[a];
    });
});
function $4d82739dd229d539$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $4d82739dd229d539$var$pb.hasOwnProperty(a) && $4d82739dd229d539$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $4d82739dd229d539$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $4d82739dd229d539$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $4d82739dd229d539$var$tb = $4d82739dd229d539$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $4d82739dd229d539$var$ub(a, b) {
    if (b) {
        if ($4d82739dd229d539$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($4d82739dd229d539$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($4d82739dd229d539$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($4d82739dd229d539$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($4d82739dd229d539$var$p(62));
    }
}
function $4d82739dd229d539$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $4d82739dd229d539$var$wb = null;
function $4d82739dd229d539$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $4d82739dd229d539$var$yb = null, $4d82739dd229d539$var$zb = null, $4d82739dd229d539$var$Ab = null;
function $4d82739dd229d539$var$Bb(a) {
    if (a = $4d82739dd229d539$var$Cb(a)) {
        if ("function" !== typeof $4d82739dd229d539$var$yb) throw Error($4d82739dd229d539$var$p(280));
        var b = a.stateNode;
        b && (b = $4d82739dd229d539$var$Db(b), $4d82739dd229d539$var$yb(a.stateNode, a.type, b));
    }
}
function $4d82739dd229d539$var$Eb(a) {
    $4d82739dd229d539$var$zb ? $4d82739dd229d539$var$Ab ? $4d82739dd229d539$var$Ab.push(a) : $4d82739dd229d539$var$Ab = [
        a
    ] : $4d82739dd229d539$var$zb = a;
}
function $4d82739dd229d539$var$Fb() {
    if ($4d82739dd229d539$var$zb) {
        var a = $4d82739dd229d539$var$zb, b = $4d82739dd229d539$var$Ab;
        $4d82739dd229d539$var$Ab = $4d82739dd229d539$var$zb = null;
        $4d82739dd229d539$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$4d82739dd229d539$var$Bb(b[a]);
    }
}
function $4d82739dd229d539$var$Gb(a, b) {
    return a(b);
}
function $4d82739dd229d539$var$Hb() {}
var $4d82739dd229d539$var$Ib = !1;
function $4d82739dd229d539$var$Jb(a, b, c) {
    if ($4d82739dd229d539$var$Ib) return a(b, c);
    $4d82739dd229d539$var$Ib = !0;
    try {
        return $4d82739dd229d539$var$Gb(a, b, c);
    } finally{
        if ($4d82739dd229d539$var$Ib = !1, null !== $4d82739dd229d539$var$zb || null !== $4d82739dd229d539$var$Ab) $4d82739dd229d539$var$Hb(), $4d82739dd229d539$var$Fb();
    }
}
function $4d82739dd229d539$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $4d82739dd229d539$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($4d82739dd229d539$var$p(231, b, typeof c));
    return c;
}
var $4d82739dd229d539$var$Lb = !1;
if ($4d82739dd229d539$var$ia) try {
    var $4d82739dd229d539$var$Mb = {};
    Object.defineProperty($4d82739dd229d539$var$Mb, "passive", {
        get: function() {
            $4d82739dd229d539$var$Lb = !0;
        }
    });
    window.addEventListener("test", $4d82739dd229d539$var$Mb, $4d82739dd229d539$var$Mb);
    window.removeEventListener("test", $4d82739dd229d539$var$Mb, $4d82739dd229d539$var$Mb);
} catch (a) {
    $4d82739dd229d539$var$Lb = !1;
}
function $4d82739dd229d539$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $4d82739dd229d539$var$Ob = !1, $4d82739dd229d539$var$Pb = null, $4d82739dd229d539$var$Qb = !1, $4d82739dd229d539$var$Rb = null, $4d82739dd229d539$var$Sb = {
    onError: function(a) {
        $4d82739dd229d539$var$Ob = !0;
        $4d82739dd229d539$var$Pb = a;
    }
};
function $4d82739dd229d539$var$Tb(a, b, c, d, e, f, g, h, k) {
    $4d82739dd229d539$var$Ob = !1;
    $4d82739dd229d539$var$Pb = null;
    $4d82739dd229d539$var$Nb.apply($4d82739dd229d539$var$Sb, arguments);
}
function $4d82739dd229d539$var$Ub(a, b, c, d, e, f, g, h, k) {
    $4d82739dd229d539$var$Tb.apply(this, arguments);
    if ($4d82739dd229d539$var$Ob) {
        if ($4d82739dd229d539$var$Ob) {
            var l = $4d82739dd229d539$var$Pb;
            $4d82739dd229d539$var$Ob = !1;
            $4d82739dd229d539$var$Pb = null;
        } else throw Error($4d82739dd229d539$var$p(198));
        $4d82739dd229d539$var$Qb || ($4d82739dd229d539$var$Qb = !0, $4d82739dd229d539$var$Rb = l);
    }
}
function $4d82739dd229d539$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $4d82739dd229d539$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $4d82739dd229d539$var$Xb(a) {
    if ($4d82739dd229d539$var$Vb(a) !== a) throw Error($4d82739dd229d539$var$p(188));
}
function $4d82739dd229d539$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $4d82739dd229d539$var$Vb(a);
        if (null === b) throw Error($4d82739dd229d539$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $4d82739dd229d539$var$Xb(e), a;
                if (f === d) return $4d82739dd229d539$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($4d82739dd229d539$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($4d82739dd229d539$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($4d82739dd229d539$var$p(190));
    }
    if (3 !== c.tag) throw Error($4d82739dd229d539$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $4d82739dd229d539$var$Zb(a) {
    a = $4d82739dd229d539$var$Yb(a);
    return null !== a ? $4d82739dd229d539$var$$b(a) : null;
}
function $4d82739dd229d539$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $4d82739dd229d539$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $4d82739dd229d539$var$ac = $33s19.unstable_scheduleCallback, $4d82739dd229d539$var$bc = $33s19.unstable_cancelCallback, $4d82739dd229d539$var$cc = $33s19.unstable_shouldYield, $4d82739dd229d539$var$dc = $33s19.unstable_requestPaint, $4d82739dd229d539$var$B = $33s19.unstable_now, $4d82739dd229d539$var$ec = $33s19.unstable_getCurrentPriorityLevel, $4d82739dd229d539$var$fc = $33s19.unstable_ImmediatePriority, $4d82739dd229d539$var$gc = $33s19.unstable_UserBlockingPriority, $4d82739dd229d539$var$hc = $33s19.unstable_NormalPriority, $4d82739dd229d539$var$ic = $33s19.unstable_LowPriority, $4d82739dd229d539$var$jc = $33s19.unstable_IdlePriority, $4d82739dd229d539$var$kc = null, $4d82739dd229d539$var$lc = null;
function $4d82739dd229d539$var$mc(a) {
    if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onCommitFiberRoot) try {
        $4d82739dd229d539$var$lc.onCommitFiberRoot($4d82739dd229d539$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $4d82739dd229d539$var$oc = Math.clz32 ? Math.clz32 : $4d82739dd229d539$var$nc, $4d82739dd229d539$var$pc = Math.log, $4d82739dd229d539$var$qc = Math.LN2;
function $4d82739dd229d539$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($4d82739dd229d539$var$pc(a) / $4d82739dd229d539$var$qc | 0) | 0;
}
var $4d82739dd229d539$var$rc = 64, $4d82739dd229d539$var$sc = 4194304;
function $4d82739dd229d539$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $4d82739dd229d539$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $4d82739dd229d539$var$tc(h) : (f &= g, 0 !== f && (d = $4d82739dd229d539$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $4d82739dd229d539$var$tc(g) : 0 !== f && (d = $4d82739dd229d539$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $4d82739dd229d539$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $4d82739dd229d539$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $4d82739dd229d539$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $4d82739dd229d539$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $4d82739dd229d539$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $4d82739dd229d539$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $4d82739dd229d539$var$yc() {
    var a = $4d82739dd229d539$var$rc;
    $4d82739dd229d539$var$rc <<= 1;
    0 === ($4d82739dd229d539$var$rc & 4194240) && ($4d82739dd229d539$var$rc = 64);
    return a;
}
function $4d82739dd229d539$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $4d82739dd229d539$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $4d82739dd229d539$var$oc(b);
    a[b] = c;
}
function $4d82739dd229d539$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $4d82739dd229d539$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $4d82739dd229d539$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $4d82739dd229d539$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $4d82739dd229d539$var$C = 0;
function $4d82739dd229d539$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $4d82739dd229d539$var$Ec, $4d82739dd229d539$var$Fc, $4d82739dd229d539$var$Gc, $4d82739dd229d539$var$Hc, $4d82739dd229d539$var$Ic, $4d82739dd229d539$var$Jc = !1, $4d82739dd229d539$var$Kc = [], $4d82739dd229d539$var$Lc = null, $4d82739dd229d539$var$Mc = null, $4d82739dd229d539$var$Nc = null, $4d82739dd229d539$var$Oc = new Map, $4d82739dd229d539$var$Pc = new Map, $4d82739dd229d539$var$Qc = [], $4d82739dd229d539$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $4d82739dd229d539$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $4d82739dd229d539$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $4d82739dd229d539$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $4d82739dd229d539$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $4d82739dd229d539$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $4d82739dd229d539$var$Pc.delete(b.pointerId);
    }
}
function $4d82739dd229d539$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $4d82739dd229d539$var$Cb(b), null !== b && $4d82739dd229d539$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $4d82739dd229d539$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $4d82739dd229d539$var$Lc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $4d82739dd229d539$var$Mc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $4d82739dd229d539$var$Nc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $4d82739dd229d539$var$Oc.set(f, $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $4d82739dd229d539$var$Pc.set(f, $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $4d82739dd229d539$var$Vc(a) {
    var b = $4d82739dd229d539$var$Wc(a.target);
    if (null !== b) {
        var c = $4d82739dd229d539$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $4d82739dd229d539$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $4d82739dd229d539$var$Ic(a.priority, function() {
                        $4d82739dd229d539$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $4d82739dd229d539$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $4d82739dd229d539$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $4d82739dd229d539$var$wb = d;
            c.target.dispatchEvent(d);
            $4d82739dd229d539$var$wb = null;
        } else return b = $4d82739dd229d539$var$Cb(c), null !== b && $4d82739dd229d539$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $4d82739dd229d539$var$Zc(a, b, c) {
    $4d82739dd229d539$var$Xc(a) && c.delete(b);
}
function $4d82739dd229d539$var$$c() {
    $4d82739dd229d539$var$Jc = !1;
    null !== $4d82739dd229d539$var$Lc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Lc) && ($4d82739dd229d539$var$Lc = null);
    null !== $4d82739dd229d539$var$Mc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Mc) && ($4d82739dd229d539$var$Mc = null);
    null !== $4d82739dd229d539$var$Nc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Nc) && ($4d82739dd229d539$var$Nc = null);
    $4d82739dd229d539$var$Oc.forEach($4d82739dd229d539$var$Zc);
    $4d82739dd229d539$var$Pc.forEach($4d82739dd229d539$var$Zc);
}
function $4d82739dd229d539$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $4d82739dd229d539$var$Jc || ($4d82739dd229d539$var$Jc = !0, $33s19.unstable_scheduleCallback($33s19.unstable_NormalPriority, $4d82739dd229d539$var$$c)));
}
function $4d82739dd229d539$var$bd(a) {
    function b(b) {
        return $4d82739dd229d539$var$ad(b, a);
    }
    if (0 < $4d82739dd229d539$var$Kc.length) {
        $4d82739dd229d539$var$ad($4d82739dd229d539$var$Kc[0], a);
        for(var c = 1; c < $4d82739dd229d539$var$Kc.length; c++){
            var d = $4d82739dd229d539$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $4d82739dd229d539$var$Lc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Lc, a);
    null !== $4d82739dd229d539$var$Mc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Mc, a);
    null !== $4d82739dd229d539$var$Nc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Nc, a);
    $4d82739dd229d539$var$Oc.forEach(b);
    $4d82739dd229d539$var$Pc.forEach(b);
    for(c = 0; c < $4d82739dd229d539$var$Qc.length; c++)d = $4d82739dd229d539$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $4d82739dd229d539$var$Qc.length && (c = $4d82739dd229d539$var$Qc[0], null === c.blockedOn);)$4d82739dd229d539$var$Vc(c), null === c.blockedOn && $4d82739dd229d539$var$Qc.shift();
}
var $4d82739dd229d539$var$cd = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$dd = !0;
function $4d82739dd229d539$var$ed(a, b, c, d) {
    var e = $4d82739dd229d539$var$C, f = $4d82739dd229d539$var$cd.transition;
    $4d82739dd229d539$var$cd.transition = null;
    try {
        $4d82739dd229d539$var$C = 1, $4d82739dd229d539$var$fd(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$C = e, $4d82739dd229d539$var$cd.transition = f;
    }
}
function $4d82739dd229d539$var$gd(a, b, c, d) {
    var e = $4d82739dd229d539$var$C, f = $4d82739dd229d539$var$cd.transition;
    $4d82739dd229d539$var$cd.transition = null;
    try {
        $4d82739dd229d539$var$C = 4, $4d82739dd229d539$var$fd(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$C = e, $4d82739dd229d539$var$cd.transition = f;
    }
}
function $4d82739dd229d539$var$fd(a, b, c, d) {
    if ($4d82739dd229d539$var$dd) {
        var e = $4d82739dd229d539$var$Yc(a, b, c, d);
        if (null === e) $4d82739dd229d539$var$hd(a, b, d, $4d82739dd229d539$var$id, c), $4d82739dd229d539$var$Sc(a, d);
        else if ($4d82739dd229d539$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($4d82739dd229d539$var$Sc(a, d), b & 4 && -1 < $4d82739dd229d539$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $4d82739dd229d539$var$Cb(e);
                null !== f && $4d82739dd229d539$var$Ec(f);
                f = $4d82739dd229d539$var$Yc(a, b, c, d);
                null === f && $4d82739dd229d539$var$hd(a, b, d, $4d82739dd229d539$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $4d82739dd229d539$var$hd(a, b, d, null, c);
    }
}
var $4d82739dd229d539$var$id = null;
function $4d82739dd229d539$var$Yc(a, b, c, d) {
    $4d82739dd229d539$var$id = null;
    a = $4d82739dd229d539$var$xb(d);
    a = $4d82739dd229d539$var$Wc(a);
    if (null !== a) {
        if (b = $4d82739dd229d539$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $4d82739dd229d539$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $4d82739dd229d539$var$id = a;
    return null;
}
function $4d82739dd229d539$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($4d82739dd229d539$var$ec()){
                case $4d82739dd229d539$var$fc:
                    return 1;
                case $4d82739dd229d539$var$gc:
                    return 4;
                case $4d82739dd229d539$var$hc:
                case $4d82739dd229d539$var$ic:
                    return 16;
                case $4d82739dd229d539$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $4d82739dd229d539$var$kd = null, $4d82739dd229d539$var$ld = null, $4d82739dd229d539$var$md = null;
function $4d82739dd229d539$var$nd() {
    if ($4d82739dd229d539$var$md) return $4d82739dd229d539$var$md;
    var a, b = $4d82739dd229d539$var$ld, c = b.length, d, e = "value" in $4d82739dd229d539$var$kd ? $4d82739dd229d539$var$kd.value : $4d82739dd229d539$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $4d82739dd229d539$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $4d82739dd229d539$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $4d82739dd229d539$var$pd() {
    return !0;
}
function $4d82739dd229d539$var$qd() {
    return !1;
}
function $4d82739dd229d539$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $4d82739dd229d539$var$pd : $4d82739dd229d539$var$qd;
        this.isPropagationStopped = $4d82739dd229d539$var$qd;
        return this;
    }
    $4d82739dd229d539$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $4d82739dd229d539$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $4d82739dd229d539$var$pd);
        },
        persist: function() {},
        isPersistent: $4d82739dd229d539$var$pd
    });
    return b;
}
var $4d82739dd229d539$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $4d82739dd229d539$var$td = $4d82739dd229d539$var$rd($4d82739dd229d539$var$sd), $4d82739dd229d539$var$ud = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    view: 0,
    detail: 0
}), $4d82739dd229d539$var$vd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$ud), $4d82739dd229d539$var$wd, $4d82739dd229d539$var$xd, $4d82739dd229d539$var$yd, $4d82739dd229d539$var$Ad = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $4d82739dd229d539$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $4d82739dd229d539$var$yd && ($4d82739dd229d539$var$yd && "mousemove" === a.type ? ($4d82739dd229d539$var$wd = a.screenX - $4d82739dd229d539$var$yd.screenX, $4d82739dd229d539$var$xd = a.screenY - $4d82739dd229d539$var$yd.screenY) : $4d82739dd229d539$var$xd = $4d82739dd229d539$var$wd = 0, $4d82739dd229d539$var$yd = a);
        return $4d82739dd229d539$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $4d82739dd229d539$var$xd;
    }
}), $4d82739dd229d539$var$Bd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ad), $4d82739dd229d539$var$Cd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    dataTransfer: 0
}), $4d82739dd229d539$var$Dd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Cd), $4d82739dd229d539$var$Ed = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    relatedTarget: 0
}), $4d82739dd229d539$var$Fd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ed), $4d82739dd229d539$var$Gd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4d82739dd229d539$var$Hd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Gd), $4d82739dd229d539$var$Id = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $4d82739dd229d539$var$Jd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Id), $4d82739dd229d539$var$Kd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    data: 0
}), $4d82739dd229d539$var$Ld = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Kd), $4d82739dd229d539$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $4d82739dd229d539$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $4d82739dd229d539$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $4d82739dd229d539$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $4d82739dd229d539$var$Od[a]) ? !!b[a] : !1;
}
function $4d82739dd229d539$var$zd() {
    return $4d82739dd229d539$var$Pd;
}
var $4d82739dd229d539$var$Qd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $4d82739dd229d539$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $4d82739dd229d539$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $4d82739dd229d539$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $4d82739dd229d539$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $4d82739dd229d539$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $4d82739dd229d539$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $4d82739dd229d539$var$Rd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Qd), $4d82739dd229d539$var$Sd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $4d82739dd229d539$var$Td = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Sd), $4d82739dd229d539$var$Ud = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $4d82739dd229d539$var$zd
}), $4d82739dd229d539$var$Vd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ud), $4d82739dd229d539$var$Wd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4d82739dd229d539$var$Xd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Wd), $4d82739dd229d539$var$Yd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $4d82739dd229d539$var$Zd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Yd), $4d82739dd229d539$var$$d = [
    9,
    13,
    27,
    32
], $4d82739dd229d539$var$ae = $4d82739dd229d539$var$ia && "CompositionEvent" in window, $4d82739dd229d539$var$be = null;
$4d82739dd229d539$var$ia && "documentMode" in document && ($4d82739dd229d539$var$be = document.documentMode);
var $4d82739dd229d539$var$ce = $4d82739dd229d539$var$ia && "TextEvent" in window && !$4d82739dd229d539$var$be, $4d82739dd229d539$var$de = $4d82739dd229d539$var$ia && (!$4d82739dd229d539$var$ae || $4d82739dd229d539$var$be && 8 < $4d82739dd229d539$var$be && 11 >= $4d82739dd229d539$var$be), $4d82739dd229d539$var$ee = String.fromCharCode(32), $4d82739dd229d539$var$fe = !1;
function $4d82739dd229d539$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $4d82739dd229d539$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $4d82739dd229d539$var$ie = !1;
function $4d82739dd229d539$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $4d82739dd229d539$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $4d82739dd229d539$var$fe = !0;
            return $4d82739dd229d539$var$ee;
        case "textInput":
            return a = b.data, a === $4d82739dd229d539$var$ee && $4d82739dd229d539$var$fe ? null : a;
        default:
            return null;
    }
}
function $4d82739dd229d539$var$ke(a, b) {
    if ($4d82739dd229d539$var$ie) return "compositionend" === a || !$4d82739dd229d539$var$ae && $4d82739dd229d539$var$ge(a, b) ? (a = $4d82739dd229d539$var$nd(), $4d82739dd229d539$var$md = $4d82739dd229d539$var$ld = $4d82739dd229d539$var$kd = null, $4d82739dd229d539$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $4d82739dd229d539$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $4d82739dd229d539$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $4d82739dd229d539$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$4d82739dd229d539$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $4d82739dd229d539$var$ne(a, b, c, d) {
    $4d82739dd229d539$var$Eb(d);
    b = $4d82739dd229d539$var$oe(b, "onChange");
    0 < b.length && (c = new $4d82739dd229d539$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $4d82739dd229d539$var$pe = null, $4d82739dd229d539$var$qe = null;
function $4d82739dd229d539$var$re(a) {
    $4d82739dd229d539$var$se(a, 0);
}
function $4d82739dd229d539$var$te(a) {
    var b = $4d82739dd229d539$var$ue(a);
    if ($4d82739dd229d539$var$Wa(b)) return a;
}
function $4d82739dd229d539$var$ve(a, b) {
    if ("change" === a) return b;
}
var $4d82739dd229d539$var$we = !1;
if ($4d82739dd229d539$var$ia) {
    var $4d82739dd229d539$var$xe;
    if ($4d82739dd229d539$var$ia) {
        var $4d82739dd229d539$var$ye = "oninput" in document;
        if (!$4d82739dd229d539$var$ye) {
            var $4d82739dd229d539$var$ze = document.createElement("div");
            $4d82739dd229d539$var$ze.setAttribute("oninput", "return;");
            $4d82739dd229d539$var$ye = "function" === typeof $4d82739dd229d539$var$ze.oninput;
        }
        $4d82739dd229d539$var$xe = $4d82739dd229d539$var$ye;
    } else $4d82739dd229d539$var$xe = !1;
    $4d82739dd229d539$var$we = $4d82739dd229d539$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $4d82739dd229d539$var$Ae() {
    $4d82739dd229d539$var$pe && ($4d82739dd229d539$var$pe.detachEvent("onpropertychange", $4d82739dd229d539$var$Be), $4d82739dd229d539$var$qe = $4d82739dd229d539$var$pe = null);
}
function $4d82739dd229d539$var$Be(a) {
    if ("value" === a.propertyName && $4d82739dd229d539$var$te($4d82739dd229d539$var$qe)) {
        var b = [];
        $4d82739dd229d539$var$ne(b, $4d82739dd229d539$var$qe, a, $4d82739dd229d539$var$xb(a));
        $4d82739dd229d539$var$Jb($4d82739dd229d539$var$re, b);
    }
}
function $4d82739dd229d539$var$Ce(a, b, c) {
    "focusin" === a ? ($4d82739dd229d539$var$Ae(), $4d82739dd229d539$var$pe = b, $4d82739dd229d539$var$qe = c, $4d82739dd229d539$var$pe.attachEvent("onpropertychange", $4d82739dd229d539$var$Be)) : "focusout" === a && $4d82739dd229d539$var$Ae();
}
function $4d82739dd229d539$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $4d82739dd229d539$var$te($4d82739dd229d539$var$qe);
}
function $4d82739dd229d539$var$Ee(a, b) {
    if ("click" === a) return $4d82739dd229d539$var$te(b);
}
function $4d82739dd229d539$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $4d82739dd229d539$var$te(b);
}
function $4d82739dd229d539$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $4d82739dd229d539$var$He = "function" === typeof Object.is ? Object.is : $4d82739dd229d539$var$Ge;
function $4d82739dd229d539$var$Ie(a, b) {
    if ($4d82739dd229d539$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$4d82739dd229d539$var$ja.call(b, e) || !$4d82739dd229d539$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $4d82739dd229d539$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $4d82739dd229d539$var$Ke(a, b) {
    var c = $4d82739dd229d539$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $4d82739dd229d539$var$Je(c);
    }
}
function $4d82739dd229d539$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $4d82739dd229d539$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $4d82739dd229d539$var$Me() {
    for(var a = window, b = $4d82739dd229d539$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $4d82739dd229d539$var$Xa(a.document);
    }
    return b;
}
function $4d82739dd229d539$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $4d82739dd229d539$var$Oe(a) {
    var b = $4d82739dd229d539$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $4d82739dd229d539$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $4d82739dd229d539$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $4d82739dd229d539$var$Ke(c, f);
                var g = $4d82739dd229d539$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $4d82739dd229d539$var$Pe = $4d82739dd229d539$var$ia && "documentMode" in document && 11 >= document.documentMode, $4d82739dd229d539$var$Qe = null, $4d82739dd229d539$var$Re = null, $4d82739dd229d539$var$Se = null, $4d82739dd229d539$var$Te = !1;
function $4d82739dd229d539$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $4d82739dd229d539$var$Te || null == $4d82739dd229d539$var$Qe || $4d82739dd229d539$var$Qe !== $4d82739dd229d539$var$Xa(d) || (d = $4d82739dd229d539$var$Qe, "selectionStart" in d && $4d82739dd229d539$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $4d82739dd229d539$var$Se && $4d82739dd229d539$var$Ie($4d82739dd229d539$var$Se, d) || ($4d82739dd229d539$var$Se = d, d = $4d82739dd229d539$var$oe($4d82739dd229d539$var$Re, "onSelect"), 0 < d.length && (b = new $4d82739dd229d539$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $4d82739dd229d539$var$Qe)));
}
function $4d82739dd229d539$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $4d82739dd229d539$var$We = {
    animationend: $4d82739dd229d539$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $4d82739dd229d539$var$Ve("Animation", "AnimationIteration"),
    animationstart: $4d82739dd229d539$var$Ve("Animation", "AnimationStart"),
    transitionend: $4d82739dd229d539$var$Ve("Transition", "TransitionEnd")
}, $4d82739dd229d539$var$Xe = {}, $4d82739dd229d539$var$Ye = {};
$4d82739dd229d539$var$ia && ($4d82739dd229d539$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $4d82739dd229d539$var$We.animationend.animation, delete $4d82739dd229d539$var$We.animationiteration.animation, delete $4d82739dd229d539$var$We.animationstart.animation), "TransitionEvent" in window || delete $4d82739dd229d539$var$We.transitionend.transition);
function $4d82739dd229d539$var$Ze(a) {
    if ($4d82739dd229d539$var$Xe[a]) return $4d82739dd229d539$var$Xe[a];
    if (!$4d82739dd229d539$var$We[a]) return a;
    var b = $4d82739dd229d539$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $4d82739dd229d539$var$Ye) return $4d82739dd229d539$var$Xe[a] = b[c];
    return a;
}
var $4d82739dd229d539$var$$e = $4d82739dd229d539$var$Ze("animationend"), $4d82739dd229d539$var$af = $4d82739dd229d539$var$Ze("animationiteration"), $4d82739dd229d539$var$bf = $4d82739dd229d539$var$Ze("animationstart"), $4d82739dd229d539$var$cf = $4d82739dd229d539$var$Ze("transitionend"), $4d82739dd229d539$var$df = new Map, $4d82739dd229d539$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $4d82739dd229d539$var$ff(a, b) {
    $4d82739dd229d539$var$df.set(a, b);
    $4d82739dd229d539$var$fa(b, [
        a
    ]);
}
for(var $4d82739dd229d539$var$gf = 0; $4d82739dd229d539$var$gf < $4d82739dd229d539$var$ef.length; $4d82739dd229d539$var$gf++){
    var $4d82739dd229d539$var$hf = $4d82739dd229d539$var$ef[$4d82739dd229d539$var$gf], $4d82739dd229d539$var$jf = $4d82739dd229d539$var$hf.toLowerCase(), $4d82739dd229d539$var$kf = $4d82739dd229d539$var$hf[0].toUpperCase() + $4d82739dd229d539$var$hf.slice(1);
    $4d82739dd229d539$var$ff($4d82739dd229d539$var$jf, "on" + $4d82739dd229d539$var$kf);
}
$4d82739dd229d539$var$ff($4d82739dd229d539$var$$e, "onAnimationEnd");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$af, "onAnimationIteration");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$bf, "onAnimationStart");
$4d82739dd229d539$var$ff("dblclick", "onDoubleClick");
$4d82739dd229d539$var$ff("focusin", "onFocus");
$4d82739dd229d539$var$ff("focusout", "onBlur");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$cf, "onTransitionEnd");
$4d82739dd229d539$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$4d82739dd229d539$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$4d82739dd229d539$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$4d82739dd229d539$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$4d82739dd229d539$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$4d82739dd229d539$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$4d82739dd229d539$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$4d82739dd229d539$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$4d82739dd229d539$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$4d82739dd229d539$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $4d82739dd229d539$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $4d82739dd229d539$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($4d82739dd229d539$var$lf));
function $4d82739dd229d539$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $4d82739dd229d539$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $4d82739dd229d539$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4d82739dd229d539$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4d82739dd229d539$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($4d82739dd229d539$var$Qb) throw a = $4d82739dd229d539$var$Rb, $4d82739dd229d539$var$Qb = !1, $4d82739dd229d539$var$Rb = null, a;
}
function $4d82739dd229d539$var$D(a, b) {
    var c = b[$4d82739dd229d539$var$of];
    void 0 === c && (c = b[$4d82739dd229d539$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($4d82739dd229d539$var$pf(b, a, 2, !1), c.add(d));
}
function $4d82739dd229d539$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $4d82739dd229d539$var$pf(c, a, d, b);
}
var $4d82739dd229d539$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $4d82739dd229d539$var$sf(a) {
    if (!a[$4d82739dd229d539$var$rf]) {
        a[$4d82739dd229d539$var$rf] = !0;
        $4d82739dd229d539$var$da.forEach(function(b) {
            "selectionchange" !== b && ($4d82739dd229d539$var$mf.has(b) || $4d82739dd229d539$var$qf(b, !1, a), $4d82739dd229d539$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$4d82739dd229d539$var$rf] || (b[$4d82739dd229d539$var$rf] = !0, $4d82739dd229d539$var$qf("selectionchange", !1, b));
    }
}
function $4d82739dd229d539$var$pf(a, b, c, d) {
    switch($4d82739dd229d539$var$jd(b)){
        case 1:
            var e = $4d82739dd229d539$var$ed;
            break;
        case 4:
            e = $4d82739dd229d539$var$gd;
            break;
        default:
            e = $4d82739dd229d539$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$4d82739dd229d539$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $4d82739dd229d539$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $4d82739dd229d539$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $4d82739dd229d539$var$Jb(function() {
        var d = f, e = $4d82739dd229d539$var$xb(c), g = [];
        a: {
            var h = $4d82739dd229d539$var$df.get(a);
            if (void 0 !== h) {
                var k = $4d82739dd229d539$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $4d82739dd229d539$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $4d82739dd229d539$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $4d82739dd229d539$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $4d82739dd229d539$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $4d82739dd229d539$var$Vd;
                        break;
                    case $4d82739dd229d539$var$$e:
                    case $4d82739dd229d539$var$af:
                    case $4d82739dd229d539$var$bf:
                        k = $4d82739dd229d539$var$Hd;
                        break;
                    case $4d82739dd229d539$var$cf:
                        k = $4d82739dd229d539$var$Xd;
                        break;
                    case "scroll":
                        k = $4d82739dd229d539$var$vd;
                        break;
                    case "wheel":
                        k = $4d82739dd229d539$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $4d82739dd229d539$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $4d82739dd229d539$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $4d82739dd229d539$var$Kb(w, x), null != F && t.push($4d82739dd229d539$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $4d82739dd229d539$var$wb && (n = c.relatedTarget || c.fromElement) && ($4d82739dd229d539$var$Wc(n) || n[$4d82739dd229d539$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $4d82739dd229d539$var$Wc(n) : null, null !== n && (J = $4d82739dd229d539$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $4d82739dd229d539$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $4d82739dd229d539$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $4d82739dd229d539$var$ue(k);
                        u = null == n ? h : $4d82739dd229d539$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $4d82739dd229d539$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $4d82739dd229d539$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $4d82739dd229d539$var$vf(F))u++;
                            for(; 0 < w - u;)t = $4d82739dd229d539$var$vf(t), w--;
                            for(; 0 < u - w;)x = $4d82739dd229d539$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $4d82739dd229d539$var$vf(t);
                                x = $4d82739dd229d539$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $4d82739dd229d539$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $4d82739dd229d539$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $4d82739dd229d539$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $4d82739dd229d539$var$ve;
                else if ($4d82739dd229d539$var$me(h)) {
                    if ($4d82739dd229d539$var$we) na = $4d82739dd229d539$var$Fe;
                    else {
                        na = $4d82739dd229d539$var$De;
                        var xa = $4d82739dd229d539$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $4d82739dd229d539$var$Ee);
                if (na && (na = na(a, d))) {
                    $4d82739dd229d539$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $4d82739dd229d539$var$cb(h, "number", h.value);
            }
            xa = d ? $4d82739dd229d539$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($4d82739dd229d539$var$me(xa) || "true" === xa.contentEditable) $4d82739dd229d539$var$Qe = xa, $4d82739dd229d539$var$Re = d, $4d82739dd229d539$var$Se = null;
                    break;
                case "focusout":
                    $4d82739dd229d539$var$Se = $4d82739dd229d539$var$Re = $4d82739dd229d539$var$Qe = null;
                    break;
                case "mousedown":
                    $4d82739dd229d539$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $4d82739dd229d539$var$Te = !1;
                    $4d82739dd229d539$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($4d82739dd229d539$var$Pe) break;
                case "keydown":
                case "keyup":
                    $4d82739dd229d539$var$Ue(g, c, e);
            }
            var $a;
            if ($4d82739dd229d539$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $4d82739dd229d539$var$ie ? $4d82739dd229d539$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($4d82739dd229d539$var$de && "ko" !== c.locale && ($4d82739dd229d539$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $4d82739dd229d539$var$ie && ($a = $4d82739dd229d539$var$nd()) : ($4d82739dd229d539$var$kd = e, $4d82739dd229d539$var$ld = "value" in $4d82739dd229d539$var$kd ? $4d82739dd229d539$var$kd.value : $4d82739dd229d539$var$kd.textContent, $4d82739dd229d539$var$ie = !0)), xa = $4d82739dd229d539$var$oe(d, ba), 0 < xa.length && (ba = new $4d82739dd229d539$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $4d82739dd229d539$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $4d82739dd229d539$var$ce ? $4d82739dd229d539$var$je(a, c) : $4d82739dd229d539$var$ke(a, c)) d = $4d82739dd229d539$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $4d82739dd229d539$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $4d82739dd229d539$var$se(g, b);
    });
}
function $4d82739dd229d539$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $4d82739dd229d539$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $4d82739dd229d539$var$Kb(a, c), null != f && d.unshift($4d82739dd229d539$var$tf(a, f, e)), f = $4d82739dd229d539$var$Kb(a, b), null != f && d.push($4d82739dd229d539$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $4d82739dd229d539$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $4d82739dd229d539$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $4d82739dd229d539$var$Kb(c, f), null != k && g.unshift($4d82739dd229d539$var$tf(c, k, h))) : e || (k = $4d82739dd229d539$var$Kb(c, f), null != k && g.push($4d82739dd229d539$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $4d82739dd229d539$var$xf = /\r\n?/g, $4d82739dd229d539$var$yf = /\u0000|\uFFFD/g;
function $4d82739dd229d539$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($4d82739dd229d539$var$xf, "\n").replace($4d82739dd229d539$var$yf, "");
}
function $4d82739dd229d539$var$Af(a, b, c) {
    b = $4d82739dd229d539$var$zf(b);
    if ($4d82739dd229d539$var$zf(a) !== b && c) throw Error($4d82739dd229d539$var$p(425));
}
function $4d82739dd229d539$var$Bf() {}
var $4d82739dd229d539$var$Cf = null, $4d82739dd229d539$var$Df = null;
function $4d82739dd229d539$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $4d82739dd229d539$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $4d82739dd229d539$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $4d82739dd229d539$var$Hf = "function" === typeof Promise ? Promise : void 0, $4d82739dd229d539$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $4d82739dd229d539$var$Hf ? function(a) {
    return $4d82739dd229d539$var$Hf.resolve(null).then(a).catch($4d82739dd229d539$var$If);
} : $4d82739dd229d539$var$Ff;
function $4d82739dd229d539$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $4d82739dd229d539$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $4d82739dd229d539$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $4d82739dd229d539$var$bd(b);
}
function $4d82739dd229d539$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $4d82739dd229d539$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $4d82739dd229d539$var$Nf = Math.random().toString(36).slice(2), $4d82739dd229d539$var$Of = "__reactFiber$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Pf = "__reactProps$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$uf = "__reactContainer$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$of = "__reactEvents$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Qf = "__reactListeners$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Rf = "__reactHandles$" + $4d82739dd229d539$var$Nf;
function $4d82739dd229d539$var$Wc(a) {
    var b = a[$4d82739dd229d539$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$4d82739dd229d539$var$uf] || c[$4d82739dd229d539$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $4d82739dd229d539$var$Mf(a); null !== a;){
                if (c = a[$4d82739dd229d539$var$Of]) return c;
                a = $4d82739dd229d539$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $4d82739dd229d539$var$Cb(a) {
    a = a[$4d82739dd229d539$var$Of] || a[$4d82739dd229d539$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $4d82739dd229d539$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($4d82739dd229d539$var$p(33));
}
function $4d82739dd229d539$var$Db(a) {
    return a[$4d82739dd229d539$var$Pf] || null;
}
var $4d82739dd229d539$var$Sf = [], $4d82739dd229d539$var$Tf = -1;
function $4d82739dd229d539$var$Uf(a) {
    return {
        current: a
    };
}
function $4d82739dd229d539$var$E(a) {
    0 > $4d82739dd229d539$var$Tf || (a.current = $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf], $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf] = null, $4d82739dd229d539$var$Tf--);
}
function $4d82739dd229d539$var$G(a, b) {
    $4d82739dd229d539$var$Tf++;
    $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf] = a.current;
    a.current = b;
}
var $4d82739dd229d539$var$Vf = {}, $4d82739dd229d539$var$H = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$Vf), $4d82739dd229d539$var$Wf = $4d82739dd229d539$var$Uf(!1), $4d82739dd229d539$var$Xf = $4d82739dd229d539$var$Vf;
function $4d82739dd229d539$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $4d82739dd229d539$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $4d82739dd229d539$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $4d82739dd229d539$var$$f() {
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
}
function $4d82739dd229d539$var$ag(a, b, c) {
    if ($4d82739dd229d539$var$H.current !== $4d82739dd229d539$var$Vf) throw Error($4d82739dd229d539$var$p(168));
    $4d82739dd229d539$var$G($4d82739dd229d539$var$H, b);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, c);
}
function $4d82739dd229d539$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($4d82739dd229d539$var$p(108, $4d82739dd229d539$var$Ra(a) || "Unknown", e));
    return $4d82739dd229d539$var$A({}, c, d);
}
function $4d82739dd229d539$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $4d82739dd229d539$var$Vf;
    $4d82739dd229d539$var$Xf = $4d82739dd229d539$var$H.current;
    $4d82739dd229d539$var$G($4d82739dd229d539$var$H, a);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, $4d82739dd229d539$var$Wf.current);
    return !0;
}
function $4d82739dd229d539$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($4d82739dd229d539$var$p(169));
    c ? (a = $4d82739dd229d539$var$bg(a, b, $4d82739dd229d539$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf), $4d82739dd229d539$var$E($4d82739dd229d539$var$H), $4d82739dd229d539$var$G($4d82739dd229d539$var$H, a)) : $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, c);
}
var $4d82739dd229d539$var$eg = null, $4d82739dd229d539$var$fg = !1, $4d82739dd229d539$var$gg = !1;
function $4d82739dd229d539$var$hg(a) {
    null === $4d82739dd229d539$var$eg ? $4d82739dd229d539$var$eg = [
        a
    ] : $4d82739dd229d539$var$eg.push(a);
}
function $4d82739dd229d539$var$ig(a) {
    $4d82739dd229d539$var$fg = !0;
    $4d82739dd229d539$var$hg(a);
}
function $4d82739dd229d539$var$jg() {
    if (!$4d82739dd229d539$var$gg && null !== $4d82739dd229d539$var$eg) {
        $4d82739dd229d539$var$gg = !0;
        var a = 0, b = $4d82739dd229d539$var$C;
        try {
            var c = $4d82739dd229d539$var$eg;
            for($4d82739dd229d539$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $4d82739dd229d539$var$eg = null;
            $4d82739dd229d539$var$fg = !1;
        } catch (e) {
            throw null !== $4d82739dd229d539$var$eg && ($4d82739dd229d539$var$eg = $4d82739dd229d539$var$eg.slice(a + 1)), $4d82739dd229d539$var$ac($4d82739dd229d539$var$fc, $4d82739dd229d539$var$jg), e;
        } finally{
            $4d82739dd229d539$var$C = b, $4d82739dd229d539$var$gg = !1;
        }
    }
    return null;
}
var $4d82739dd229d539$var$kg = [], $4d82739dd229d539$var$lg = 0, $4d82739dd229d539$var$mg = null, $4d82739dd229d539$var$ng = 0, $4d82739dd229d539$var$og = [], $4d82739dd229d539$var$pg = 0, $4d82739dd229d539$var$qg = null, $4d82739dd229d539$var$rg = 1, $4d82739dd229d539$var$sg = "";
function $4d82739dd229d539$var$tg(a, b) {
    $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg++] = $4d82739dd229d539$var$ng;
    $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg++] = $4d82739dd229d539$var$mg;
    $4d82739dd229d539$var$mg = a;
    $4d82739dd229d539$var$ng = b;
}
function $4d82739dd229d539$var$ug(a, b, c) {
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$rg;
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$sg;
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$qg;
    $4d82739dd229d539$var$qg = a;
    var d = $4d82739dd229d539$var$rg;
    a = $4d82739dd229d539$var$sg;
    var e = 32 - $4d82739dd229d539$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $4d82739dd229d539$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $4d82739dd229d539$var$rg = 1 << 32 - $4d82739dd229d539$var$oc(b) + e | c << e | d;
        $4d82739dd229d539$var$sg = f + a;
    } else $4d82739dd229d539$var$rg = 1 << f | c << e | d, $4d82739dd229d539$var$sg = a;
}
function $4d82739dd229d539$var$vg(a) {
    null !== a.return && ($4d82739dd229d539$var$tg(a, 1), $4d82739dd229d539$var$ug(a, 1, 0));
}
function $4d82739dd229d539$var$wg(a) {
    for(; a === $4d82739dd229d539$var$mg;)$4d82739dd229d539$var$mg = $4d82739dd229d539$var$kg[--$4d82739dd229d539$var$lg], $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg] = null, $4d82739dd229d539$var$ng = $4d82739dd229d539$var$kg[--$4d82739dd229d539$var$lg], $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg] = null;
    for(; a === $4d82739dd229d539$var$qg;)$4d82739dd229d539$var$qg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null, $4d82739dd229d539$var$sg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null, $4d82739dd229d539$var$rg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null;
}
var $4d82739dd229d539$var$xg = null, $4d82739dd229d539$var$yg = null, $4d82739dd229d539$var$I = !1, $4d82739dd229d539$var$zg = null;
function $4d82739dd229d539$var$Ag(a, b) {
    var c = $4d82739dd229d539$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $4d82739dd229d539$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $4d82739dd229d539$var$qg ? {
                id: $4d82739dd229d539$var$rg,
                overflow: $4d82739dd229d539$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $4d82739dd229d539$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $4d82739dd229d539$var$Eg(a) {
    if ($4d82739dd229d539$var$I) {
        var b = $4d82739dd229d539$var$yg;
        if (b) {
            var c = b;
            if (!$4d82739dd229d539$var$Cg(a, b)) {
                if ($4d82739dd229d539$var$Dg(a)) throw Error($4d82739dd229d539$var$p(418));
                b = $4d82739dd229d539$var$Lf(c.nextSibling);
                var d = $4d82739dd229d539$var$xg;
                b && $4d82739dd229d539$var$Cg(a, b) ? $4d82739dd229d539$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $4d82739dd229d539$var$I = !1, $4d82739dd229d539$var$xg = a);
            }
        } else {
            if ($4d82739dd229d539$var$Dg(a)) throw Error($4d82739dd229d539$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $4d82739dd229d539$var$I = !1;
            $4d82739dd229d539$var$xg = a;
        }
    }
}
function $4d82739dd229d539$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $4d82739dd229d539$var$xg = a;
}
function $4d82739dd229d539$var$Gg(a) {
    if (a !== $4d82739dd229d539$var$xg) return !1;
    if (!$4d82739dd229d539$var$I) return $4d82739dd229d539$var$Fg(a), $4d82739dd229d539$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$4d82739dd229d539$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $4d82739dd229d539$var$yg)) {
        if ($4d82739dd229d539$var$Dg(a)) throw $4d82739dd229d539$var$Hg(), Error($4d82739dd229d539$var$p(418));
        for(; b;)$4d82739dd229d539$var$Ag(a, b), b = $4d82739dd229d539$var$Lf(b.nextSibling);
    }
    $4d82739dd229d539$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($4d82739dd229d539$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $4d82739dd229d539$var$yg = null;
        }
    } else $4d82739dd229d539$var$yg = $4d82739dd229d539$var$xg ? $4d82739dd229d539$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $4d82739dd229d539$var$Hg() {
    for(var a = $4d82739dd229d539$var$yg; a;)a = $4d82739dd229d539$var$Lf(a.nextSibling);
}
function $4d82739dd229d539$var$Ig() {
    $4d82739dd229d539$var$yg = $4d82739dd229d539$var$xg = null;
    $4d82739dd229d539$var$I = !1;
}
function $4d82739dd229d539$var$Jg(a) {
    null === $4d82739dd229d539$var$zg ? $4d82739dd229d539$var$zg = [
        a
    ] : $4d82739dd229d539$var$zg.push(a);
}
var $4d82739dd229d539$var$Kg = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig;
function $4d82739dd229d539$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($4d82739dd229d539$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($4d82739dd229d539$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($4d82739dd229d539$var$p(284));
        if (!c._owner) throw Error($4d82739dd229d539$var$p(290, a));
    }
    return a;
}
function $4d82739dd229d539$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($4d82739dd229d539$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $4d82739dd229d539$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $4d82739dd229d539$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $4d82739dd229d539$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $4d82739dd229d539$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $4d82739dd229d539$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $4d82739dd229d539$var$Ha && $4d82739dd229d539$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $4d82739dd229d539$var$Lg(a, b, c), d.return = a, d;
        d = $4d82739dd229d539$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $4d82739dd229d539$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $4d82739dd229d539$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $4d82739dd229d539$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $4d82739dd229d539$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $4d82739dd229d539$var$va:
                    return c = $4d82739dd229d539$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $4d82739dd229d539$var$Lg(a, null, b), c.return = a, c;
                case $4d82739dd229d539$var$wa:
                    return b = $4d82739dd229d539$var$Sg(b, a.mode, c), b.return = a, b;
                case $4d82739dd229d539$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($4d82739dd229d539$var$eb(b) || $4d82739dd229d539$var$Ka(b)) return b = $4d82739dd229d539$var$Tg(b, a.mode, c, null), b.return = a, b;
            $4d82739dd229d539$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $4d82739dd229d539$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $4d82739dd229d539$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $4d82739dd229d539$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($4d82739dd229d539$var$eb(c) || $4d82739dd229d539$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $4d82739dd229d539$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $4d82739dd229d539$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $4d82739dd229d539$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $4d82739dd229d539$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($4d82739dd229d539$var$eb(d) || $4d82739dd229d539$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $4d82739dd229d539$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $4d82739dd229d539$var$Ka(h);
        if ("function" !== typeof l) throw Error($4d82739dd229d539$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($4d82739dd229d539$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $4d82739dd229d539$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $4d82739dd229d539$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $4d82739dd229d539$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $4d82739dd229d539$var$Ha && $4d82739dd229d539$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $4d82739dd229d539$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $4d82739dd229d539$var$ya ? (d = $4d82739dd229d539$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $4d82739dd229d539$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $4d82739dd229d539$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $4d82739dd229d539$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $4d82739dd229d539$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $4d82739dd229d539$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($4d82739dd229d539$var$eb(f)) return n(a, d, f, h);
            if ($4d82739dd229d539$var$Ka(f)) return t(a, d, f, h);
            $4d82739dd229d539$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $4d82739dd229d539$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $4d82739dd229d539$var$Ug = $4d82739dd229d539$var$Og(!0), $4d82739dd229d539$var$Vg = $4d82739dd229d539$var$Og(!1), $4d82739dd229d539$var$Wg = $4d82739dd229d539$var$Uf(null), $4d82739dd229d539$var$Xg = null, $4d82739dd229d539$var$Yg = null, $4d82739dd229d539$var$Zg = null;
function $4d82739dd229d539$var$$g() {
    $4d82739dd229d539$var$Zg = $4d82739dd229d539$var$Yg = $4d82739dd229d539$var$Xg = null;
}
function $4d82739dd229d539$var$ah(a) {
    var b = $4d82739dd229d539$var$Wg.current;
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Wg);
    a._currentValue = b;
}
function $4d82739dd229d539$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $4d82739dd229d539$var$ch(a, b) {
    $4d82739dd229d539$var$Xg = a;
    $4d82739dd229d539$var$Zg = $4d82739dd229d539$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($4d82739dd229d539$var$dh = !0), a.firstContext = null);
}
function $4d82739dd229d539$var$eh(a) {
    var b = a._currentValue;
    if ($4d82739dd229d539$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $4d82739dd229d539$var$Yg) {
            if (null === $4d82739dd229d539$var$Xg) throw Error($4d82739dd229d539$var$p(308));
            $4d82739dd229d539$var$Yg = a;
            $4d82739dd229d539$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $4d82739dd229d539$var$Yg = $4d82739dd229d539$var$Yg.next = a;
    }
    return b;
}
var $4d82739dd229d539$var$fh = null;
function $4d82739dd229d539$var$gh(a) {
    null === $4d82739dd229d539$var$fh ? $4d82739dd229d539$var$fh = [
        a
    ] : $4d82739dd229d539$var$fh.push(a);
}
function $4d82739dd229d539$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $4d82739dd229d539$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $4d82739dd229d539$var$ih(a, d);
}
function $4d82739dd229d539$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $4d82739dd229d539$var$jh = !1;
function $4d82739dd229d539$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $4d82739dd229d539$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $4d82739dd229d539$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $4d82739dd229d539$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($4d82739dd229d539$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $4d82739dd229d539$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $4d82739dd229d539$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $4d82739dd229d539$var$ih(a, c);
}
function $4d82739dd229d539$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4d82739dd229d539$var$Cc(a, c);
    }
}
function $4d82739dd229d539$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $4d82739dd229d539$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $4d82739dd229d539$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $4d82739dd229d539$var$A({}, q, r);
                            break a;
                        case 2:
                            $4d82739dd229d539$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $4d82739dd229d539$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $4d82739dd229d539$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($4d82739dd229d539$var$p(191, e));
            e.call(d);
        }
    }
}
var $4d82739dd229d539$var$th = {}, $4d82739dd229d539$var$uh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$th), $4d82739dd229d539$var$vh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$th), $4d82739dd229d539$var$wh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$th);
function $4d82739dd229d539$var$xh(a) {
    if (a === $4d82739dd229d539$var$th) throw Error($4d82739dd229d539$var$p(174));
    return a;
}
function $4d82739dd229d539$var$yh(a, b) {
    $4d82739dd229d539$var$G($4d82739dd229d539$var$wh, b);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$vh, a);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$uh, $4d82739dd229d539$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $4d82739dd229d539$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $4d82739dd229d539$var$lb(b, a);
    }
    $4d82739dd229d539$var$E($4d82739dd229d539$var$uh);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$uh, b);
}
function $4d82739dd229d539$var$zh() {
    $4d82739dd229d539$var$E($4d82739dd229d539$var$uh);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$vh);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$wh);
}
function $4d82739dd229d539$var$Ah(a) {
    $4d82739dd229d539$var$xh($4d82739dd229d539$var$wh.current);
    var b = $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
    var c = $4d82739dd229d539$var$lb(b, a.type);
    b !== c && ($4d82739dd229d539$var$G($4d82739dd229d539$var$vh, a), $4d82739dd229d539$var$G($4d82739dd229d539$var$uh, c));
}
function $4d82739dd229d539$var$Bh(a) {
    $4d82739dd229d539$var$vh.current === a && ($4d82739dd229d539$var$E($4d82739dd229d539$var$uh), $4d82739dd229d539$var$E($4d82739dd229d539$var$vh));
}
var $4d82739dd229d539$var$L = $4d82739dd229d539$var$Uf(0);
function $4d82739dd229d539$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $4d82739dd229d539$var$Dh = [];
function $4d82739dd229d539$var$Eh() {
    for(var a = 0; a < $4d82739dd229d539$var$Dh.length; a++)$4d82739dd229d539$var$Dh[a]._workInProgressVersionPrimary = null;
    $4d82739dd229d539$var$Dh.length = 0;
}
var $4d82739dd229d539$var$Fh = $4d82739dd229d539$var$ua.ReactCurrentDispatcher, $4d82739dd229d539$var$Gh = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$Hh = 0, $4d82739dd229d539$var$M = null, $4d82739dd229d539$var$N = null, $4d82739dd229d539$var$O = null, $4d82739dd229d539$var$Ih = !1, $4d82739dd229d539$var$Jh = !1, $4d82739dd229d539$var$Kh = 0, $4d82739dd229d539$var$Lh = 0;
function $4d82739dd229d539$var$P() {
    throw Error($4d82739dd229d539$var$p(321));
}
function $4d82739dd229d539$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$4d82739dd229d539$var$He(a[c], b[c])) return !1;
    return !0;
}
function $4d82739dd229d539$var$Nh(a, b, c, d, e, f) {
    $4d82739dd229d539$var$Hh = f;
    $4d82739dd229d539$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $4d82739dd229d539$var$Fh.current = null === a || null === a.memoizedState ? $4d82739dd229d539$var$Oh : $4d82739dd229d539$var$Ph;
    a = c(d, e);
    if ($4d82739dd229d539$var$Jh) {
        f = 0;
        do {
            $4d82739dd229d539$var$Jh = !1;
            $4d82739dd229d539$var$Kh = 0;
            if (25 <= f) throw Error($4d82739dd229d539$var$p(301));
            f += 1;
            $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = null;
            b.updateQueue = null;
            $4d82739dd229d539$var$Fh.current = $4d82739dd229d539$var$Qh;
            a = c(d, e);
        }while ($4d82739dd229d539$var$Jh);
    }
    $4d82739dd229d539$var$Fh.current = $4d82739dd229d539$var$Rh;
    b = null !== $4d82739dd229d539$var$N && null !== $4d82739dd229d539$var$N.next;
    $4d82739dd229d539$var$Hh = 0;
    $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = $4d82739dd229d539$var$M = null;
    $4d82739dd229d539$var$Ih = !1;
    if (b) throw Error($4d82739dd229d539$var$p(300));
    return a;
}
function $4d82739dd229d539$var$Sh() {
    var a = 0 !== $4d82739dd229d539$var$Kh;
    $4d82739dd229d539$var$Kh = 0;
    return a;
}
function $4d82739dd229d539$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $4d82739dd229d539$var$O ? $4d82739dd229d539$var$M.memoizedState = $4d82739dd229d539$var$O = a : $4d82739dd229d539$var$O = $4d82739dd229d539$var$O.next = a;
    return $4d82739dd229d539$var$O;
}
function $4d82739dd229d539$var$Uh() {
    if (null === $4d82739dd229d539$var$N) {
        var a = $4d82739dd229d539$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $4d82739dd229d539$var$N.next;
    var b = null === $4d82739dd229d539$var$O ? $4d82739dd229d539$var$M.memoizedState : $4d82739dd229d539$var$O.next;
    if (null !== b) $4d82739dd229d539$var$O = b, $4d82739dd229d539$var$N = a;
    else {
        if (null === a) throw Error($4d82739dd229d539$var$p(310));
        $4d82739dd229d539$var$N = a;
        a = {
            memoizedState: $4d82739dd229d539$var$N.memoizedState,
            baseState: $4d82739dd229d539$var$N.baseState,
            baseQueue: $4d82739dd229d539$var$N.baseQueue,
            queue: $4d82739dd229d539$var$N.queue,
            next: null
        };
        null === $4d82739dd229d539$var$O ? $4d82739dd229d539$var$M.memoizedState = $4d82739dd229d539$var$O = a : $4d82739dd229d539$var$O = $4d82739dd229d539$var$O.next = a;
    }
    return $4d82739dd229d539$var$O;
}
function $4d82739dd229d539$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $4d82739dd229d539$var$Wh(a) {
    var b = $4d82739dd229d539$var$Uh(), c = b.queue;
    if (null === c) throw Error($4d82739dd229d539$var$p(311));
    c.lastRenderedReducer = a;
    var d = $4d82739dd229d539$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($4d82739dd229d539$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $4d82739dd229d539$var$M.lanes |= m;
                $4d82739dd229d539$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $4d82739dd229d539$var$He(d, b.memoizedState) || ($4d82739dd229d539$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $4d82739dd229d539$var$M.lanes |= f, $4d82739dd229d539$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $4d82739dd229d539$var$Xh(a) {
    var b = $4d82739dd229d539$var$Uh(), c = b.queue;
    if (null === c) throw Error($4d82739dd229d539$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $4d82739dd229d539$var$He(f, b.memoizedState) || ($4d82739dd229d539$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $4d82739dd229d539$var$Yh() {}
function $4d82739dd229d539$var$Zh(a, b) {
    var c = $4d82739dd229d539$var$M, d = $4d82739dd229d539$var$Uh(), e = b(), f = !$4d82739dd229d539$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $4d82739dd229d539$var$dh = !0);
    d = d.queue;
    $4d82739dd229d539$var$$h($4d82739dd229d539$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $4d82739dd229d539$var$O && $4d82739dd229d539$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $4d82739dd229d539$var$bi(9, $4d82739dd229d539$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $4d82739dd229d539$var$Q) throw Error($4d82739dd229d539$var$p(349));
        0 !== ($4d82739dd229d539$var$Hh & 30) || $4d82739dd229d539$var$di(c, b, e);
    }
    return e;
}
function $4d82739dd229d539$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $4d82739dd229d539$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4d82739dd229d539$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $4d82739dd229d539$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $4d82739dd229d539$var$ei(b) && $4d82739dd229d539$var$fi(a);
}
function $4d82739dd229d539$var$ai(a, b, c) {
    return c(function() {
        $4d82739dd229d539$var$ei(b) && $4d82739dd229d539$var$fi(a);
    });
}
function $4d82739dd229d539$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$4d82739dd229d539$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $4d82739dd229d539$var$fi(a) {
    var b = $4d82739dd229d539$var$ih(a, 1);
    null !== b && $4d82739dd229d539$var$gi(b, a, 1, -1);
}
function $4d82739dd229d539$var$hi(a) {
    var b = $4d82739dd229d539$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $4d82739dd229d539$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $4d82739dd229d539$var$ii.bind(null, $4d82739dd229d539$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $4d82739dd229d539$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $4d82739dd229d539$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4d82739dd229d539$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $4d82739dd229d539$var$ji() {
    return $4d82739dd229d539$var$Uh().memoizedState;
}
function $4d82739dd229d539$var$ki(a, b, c, d) {
    var e = $4d82739dd229d539$var$Th();
    $4d82739dd229d539$var$M.flags |= a;
    e.memoizedState = $4d82739dd229d539$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $4d82739dd229d539$var$li(a, b, c, d) {
    var e = $4d82739dd229d539$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $4d82739dd229d539$var$N) {
        var g = $4d82739dd229d539$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $4d82739dd229d539$var$Mh(d, g.deps)) {
            e.memoizedState = $4d82739dd229d539$var$bi(b, c, f, d);
            return;
        }
    }
    $4d82739dd229d539$var$M.flags |= a;
    e.memoizedState = $4d82739dd229d539$var$bi(1 | b, c, f, d);
}
function $4d82739dd229d539$var$mi(a, b) {
    return $4d82739dd229d539$var$ki(8390656, 8, a, b);
}
function $4d82739dd229d539$var$$h(a, b) {
    return $4d82739dd229d539$var$li(2048, 8, a, b);
}
function $4d82739dd229d539$var$ni(a, b) {
    return $4d82739dd229d539$var$li(4, 2, a, b);
}
function $4d82739dd229d539$var$oi(a, b) {
    return $4d82739dd229d539$var$li(4, 4, a, b);
}
function $4d82739dd229d539$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $4d82739dd229d539$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $4d82739dd229d539$var$li(4, 4, $4d82739dd229d539$var$pi.bind(null, b, a), c);
}
function $4d82739dd229d539$var$ri() {}
function $4d82739dd229d539$var$si(a, b) {
    var c = $4d82739dd229d539$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4d82739dd229d539$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4d82739dd229d539$var$ti(a, b) {
    var c = $4d82739dd229d539$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4d82739dd229d539$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4d82739dd229d539$var$ui(a, b, c) {
    if (0 === ($4d82739dd229d539$var$Hh & 21)) return a.baseState && (a.baseState = !1, $4d82739dd229d539$var$dh = !0), a.memoizedState = c;
    $4d82739dd229d539$var$He(c, b) || (c = $4d82739dd229d539$var$yc(), $4d82739dd229d539$var$M.lanes |= c, $4d82739dd229d539$var$rh |= c, a.baseState = !0);
    return b;
}
function $4d82739dd229d539$var$vi(a, b) {
    var c = $4d82739dd229d539$var$C;
    $4d82739dd229d539$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $4d82739dd229d539$var$Gh.transition;
    $4d82739dd229d539$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $4d82739dd229d539$var$C = c, $4d82739dd229d539$var$Gh.transition = d;
    }
}
function $4d82739dd229d539$var$wi() {
    return $4d82739dd229d539$var$Uh().memoizedState;
}
function $4d82739dd229d539$var$xi(a, b, c) {
    var d = $4d82739dd229d539$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4d82739dd229d539$var$zi(a)) $4d82739dd229d539$var$Ai(b, c);
    else if (c = $4d82739dd229d539$var$hh(a, b, c, d), null !== c) {
        var e = $4d82739dd229d539$var$R();
        $4d82739dd229d539$var$gi(c, a, d, e);
        $4d82739dd229d539$var$Bi(c, b, d);
    }
}
function $4d82739dd229d539$var$ii(a, b, c) {
    var d = $4d82739dd229d539$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4d82739dd229d539$var$zi(a)) $4d82739dd229d539$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($4d82739dd229d539$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $4d82739dd229d539$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $4d82739dd229d539$var$hh(a, b, e, d);
        null !== c && (e = $4d82739dd229d539$var$R(), $4d82739dd229d539$var$gi(c, a, d, e), $4d82739dd229d539$var$Bi(c, b, d));
    }
}
function $4d82739dd229d539$var$zi(a) {
    var b = a.alternate;
    return a === $4d82739dd229d539$var$M || null !== b && b === $4d82739dd229d539$var$M;
}
function $4d82739dd229d539$var$Ai(a, b) {
    $4d82739dd229d539$var$Jh = $4d82739dd229d539$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $4d82739dd229d539$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4d82739dd229d539$var$Cc(a, c);
    }
}
var $4d82739dd229d539$var$Rh = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: $4d82739dd229d539$var$P,
    useContext: $4d82739dd229d539$var$P,
    useEffect: $4d82739dd229d539$var$P,
    useImperativeHandle: $4d82739dd229d539$var$P,
    useInsertionEffect: $4d82739dd229d539$var$P,
    useLayoutEffect: $4d82739dd229d539$var$P,
    useMemo: $4d82739dd229d539$var$P,
    useReducer: $4d82739dd229d539$var$P,
    useRef: $4d82739dd229d539$var$P,
    useState: $4d82739dd229d539$var$P,
    useDebugValue: $4d82739dd229d539$var$P,
    useDeferredValue: $4d82739dd229d539$var$P,
    useTransition: $4d82739dd229d539$var$P,
    useMutableSource: $4d82739dd229d539$var$P,
    useSyncExternalStore: $4d82739dd229d539$var$P,
    useId: $4d82739dd229d539$var$P,
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Oh = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: function(a, b) {
        $4d82739dd229d539$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $4d82739dd229d539$var$eh,
    useEffect: $4d82739dd229d539$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $4d82739dd229d539$var$ki(4194308, 4, $4d82739dd229d539$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $4d82739dd229d539$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $4d82739dd229d539$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $4d82739dd229d539$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $4d82739dd229d539$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $4d82739dd229d539$var$xi.bind(null, $4d82739dd229d539$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $4d82739dd229d539$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $4d82739dd229d539$var$hi,
    useDebugValue: $4d82739dd229d539$var$ri,
    useDeferredValue: function(a) {
        return $4d82739dd229d539$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$hi(!1), b = a[0];
        a = $4d82739dd229d539$var$vi.bind(null, a[1]);
        $4d82739dd229d539$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $4d82739dd229d539$var$M, e = $4d82739dd229d539$var$Th();
        if ($4d82739dd229d539$var$I) {
            if (void 0 === c) throw Error($4d82739dd229d539$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $4d82739dd229d539$var$Q) throw Error($4d82739dd229d539$var$p(349));
            0 !== ($4d82739dd229d539$var$Hh & 30) || $4d82739dd229d539$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $4d82739dd229d539$var$mi($4d82739dd229d539$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $4d82739dd229d539$var$bi(9, $4d82739dd229d539$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $4d82739dd229d539$var$Th(), b = $4d82739dd229d539$var$Q.identifierPrefix;
        if ($4d82739dd229d539$var$I) {
            var c = $4d82739dd229d539$var$sg;
            var d = $4d82739dd229d539$var$rg;
            c = (d & ~(1 << 32 - $4d82739dd229d539$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $4d82739dd229d539$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $4d82739dd229d539$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Ph = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: $4d82739dd229d539$var$si,
    useContext: $4d82739dd229d539$var$eh,
    useEffect: $4d82739dd229d539$var$$h,
    useImperativeHandle: $4d82739dd229d539$var$qi,
    useInsertionEffect: $4d82739dd229d539$var$ni,
    useLayoutEffect: $4d82739dd229d539$var$oi,
    useMemo: $4d82739dd229d539$var$ti,
    useReducer: $4d82739dd229d539$var$Wh,
    useRef: $4d82739dd229d539$var$ji,
    useState: function() {
        return $4d82739dd229d539$var$Wh($4d82739dd229d539$var$Vh);
    },
    useDebugValue: $4d82739dd229d539$var$ri,
    useDeferredValue: function(a) {
        var b = $4d82739dd229d539$var$Uh();
        return $4d82739dd229d539$var$ui(b, $4d82739dd229d539$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$Wh($4d82739dd229d539$var$Vh)[0], b = $4d82739dd229d539$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4d82739dd229d539$var$Yh,
    useSyncExternalStore: $4d82739dd229d539$var$Zh,
    useId: $4d82739dd229d539$var$wi,
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Qh = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: $4d82739dd229d539$var$si,
    useContext: $4d82739dd229d539$var$eh,
    useEffect: $4d82739dd229d539$var$$h,
    useImperativeHandle: $4d82739dd229d539$var$qi,
    useInsertionEffect: $4d82739dd229d539$var$ni,
    useLayoutEffect: $4d82739dd229d539$var$oi,
    useMemo: $4d82739dd229d539$var$ti,
    useReducer: $4d82739dd229d539$var$Xh,
    useRef: $4d82739dd229d539$var$ji,
    useState: function() {
        return $4d82739dd229d539$var$Xh($4d82739dd229d539$var$Vh);
    },
    useDebugValue: $4d82739dd229d539$var$ri,
    useDeferredValue: function(a) {
        var b = $4d82739dd229d539$var$Uh();
        return null === $4d82739dd229d539$var$N ? b.memoizedState = a : $4d82739dd229d539$var$ui(b, $4d82739dd229d539$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$Xh($4d82739dd229d539$var$Vh)[0], b = $4d82739dd229d539$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4d82739dd229d539$var$Yh,
    useSyncExternalStore: $4d82739dd229d539$var$Zh,
    useId: $4d82739dd229d539$var$wi,
    unstable_isNewReconciler: !1
};
function $4d82739dd229d539$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $4d82739dd229d539$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $4d82739dd229d539$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $4d82739dd229d539$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $4d82739dd229d539$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $4d82739dd229d539$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4d82739dd229d539$var$R(), e = $4d82739dd229d539$var$yi(a), f = $4d82739dd229d539$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4d82739dd229d539$var$nh(a, f, e);
        null !== b && ($4d82739dd229d539$var$gi(b, a, e, d), $4d82739dd229d539$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4d82739dd229d539$var$R(), e = $4d82739dd229d539$var$yi(a), f = $4d82739dd229d539$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4d82739dd229d539$var$nh(a, f, e);
        null !== b && ($4d82739dd229d539$var$gi(b, a, e, d), $4d82739dd229d539$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $4d82739dd229d539$var$R(), d = $4d82739dd229d539$var$yi(a), e = $4d82739dd229d539$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $4d82739dd229d539$var$nh(a, e, d);
        null !== b && ($4d82739dd229d539$var$gi(b, a, d, c), $4d82739dd229d539$var$oh(b, a, d));
    }
};
function $4d82739dd229d539$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$4d82739dd229d539$var$Ie(c, d) || !$4d82739dd229d539$var$Ie(e, f) : !0;
}
function $4d82739dd229d539$var$Gi(a, b, c) {
    var d = !1, e = $4d82739dd229d539$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $4d82739dd229d539$var$eh(f) : (e = $4d82739dd229d539$var$Zf(b) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $4d82739dd229d539$var$Yf(a, e) : $4d82739dd229d539$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $4d82739dd229d539$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $4d82739dd229d539$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $4d82739dd229d539$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $4d82739dd229d539$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $4d82739dd229d539$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $4d82739dd229d539$var$eh(f) : (f = $4d82739dd229d539$var$Zf(b) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, e.context = $4d82739dd229d539$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($4d82739dd229d539$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $4d82739dd229d539$var$Ei.enqueueReplaceState(e, e.state, null), $4d82739dd229d539$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $4d82739dd229d539$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $4d82739dd229d539$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $4d82739dd229d539$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $4d82739dd229d539$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $4d82739dd229d539$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $4d82739dd229d539$var$Ni(a, b, c) {
    c = $4d82739dd229d539$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $4d82739dd229d539$var$Oi || ($4d82739dd229d539$var$Oi = !0, $4d82739dd229d539$var$Pi = d);
        $4d82739dd229d539$var$Li(a, b);
    };
    return c;
}
function $4d82739dd229d539$var$Qi(a, b, c) {
    c = $4d82739dd229d539$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $4d82739dd229d539$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $4d82739dd229d539$var$Li(a, b);
        "function" !== typeof d && (null === $4d82739dd229d539$var$Ri ? $4d82739dd229d539$var$Ri = new Set([
            this
        ]) : $4d82739dd229d539$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $4d82739dd229d539$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $4d82739dd229d539$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $4d82739dd229d539$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $4d82739dd229d539$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $4d82739dd229d539$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $4d82739dd229d539$var$mh(-1, 1), b.tag = 2, $4d82739dd229d539$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $4d82739dd229d539$var$Wi = $4d82739dd229d539$var$ua.ReactCurrentOwner, $4d82739dd229d539$var$dh = !1;
function $4d82739dd229d539$var$Xi(a, b, c, d) {
    b.child = null === a ? $4d82739dd229d539$var$Vg(b, null, c, d) : $4d82739dd229d539$var$Ug(b, a.child, c, d);
}
function $4d82739dd229d539$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $4d82739dd229d539$var$ch(b, e);
    d = $4d82739dd229d539$var$Nh(a, b, c, d, f, e);
    c = $4d82739dd229d539$var$Sh();
    if (null !== a && !$4d82739dd229d539$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4d82739dd229d539$var$Zi(a, b, e);
    $4d82739dd229d539$var$I && c && $4d82739dd229d539$var$vg(b);
    b.flags |= 1;
    $4d82739dd229d539$var$Xi(a, b, d, e);
    return b.child;
}
function $4d82739dd229d539$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$4d82739dd229d539$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $4d82739dd229d539$var$bj(a, b, f, d, e);
        a = $4d82739dd229d539$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $4d82739dd229d539$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $4d82739dd229d539$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $4d82739dd229d539$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $4d82739dd229d539$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($4d82739dd229d539$var$Ie(f, d) && a.ref === b.ref) {
            if ($4d82739dd229d539$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($4d82739dd229d539$var$dh = !0);
            else return b.lanes = a.lanes, $4d82739dd229d539$var$Zi(a, b, e);
        }
    }
    return $4d82739dd229d539$var$cj(a, b, c, d, e);
}
function $4d82739dd229d539$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj), $4d82739dd229d539$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj), $4d82739dd229d539$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj);
            $4d82739dd229d539$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj), $4d82739dd229d539$var$fj |= d;
    $4d82739dd229d539$var$Xi(a, b, e, c);
    return b.child;
}
function $4d82739dd229d539$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $4d82739dd229d539$var$cj(a, b, c, d, e) {
    var f = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current;
    f = $4d82739dd229d539$var$Yf(b, f);
    $4d82739dd229d539$var$ch(b, e);
    c = $4d82739dd229d539$var$Nh(a, b, c, d, f, e);
    d = $4d82739dd229d539$var$Sh();
    if (null !== a && !$4d82739dd229d539$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4d82739dd229d539$var$Zi(a, b, e);
    $4d82739dd229d539$var$I && d && $4d82739dd229d539$var$vg(b);
    b.flags |= 1;
    $4d82739dd229d539$var$Xi(a, b, c, e);
    return b.child;
}
function $4d82739dd229d539$var$hj(a, b, c, d, e) {
    if ($4d82739dd229d539$var$Zf(c)) {
        var f = !0;
        $4d82739dd229d539$var$cg(b);
    } else f = !1;
    $4d82739dd229d539$var$ch(b, e);
    if (null === b.stateNode) $4d82739dd229d539$var$ij(a, b), $4d82739dd229d539$var$Gi(b, c, d), $4d82739dd229d539$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $4d82739dd229d539$var$eh(l) : (l = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, l = $4d82739dd229d539$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $4d82739dd229d539$var$Hi(b, g, d, l);
        $4d82739dd229d539$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $4d82739dd229d539$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $4d82739dd229d539$var$Wf.current || $4d82739dd229d539$var$jh ? ("function" === typeof m && ($4d82739dd229d539$var$Di(b, c, m, d), k = b.memoizedState), (h = $4d82739dd229d539$var$jh || $4d82739dd229d539$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $4d82739dd229d539$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $4d82739dd229d539$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $4d82739dd229d539$var$eh(k) : (k = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, k = $4d82739dd229d539$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $4d82739dd229d539$var$Hi(b, g, d, k);
        $4d82739dd229d539$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $4d82739dd229d539$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $4d82739dd229d539$var$Wf.current || $4d82739dd229d539$var$jh ? ("function" === typeof y && ($4d82739dd229d539$var$Di(b, c, y, d), n = b.memoizedState), (l = $4d82739dd229d539$var$jh || $4d82739dd229d539$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $4d82739dd229d539$var$jj(a, b, c, d, f, e);
}
function $4d82739dd229d539$var$jj(a, b, c, d, e, f) {
    $4d82739dd229d539$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $4d82739dd229d539$var$dg(b, c, !1), $4d82739dd229d539$var$Zi(a, b, f);
    d = b.stateNode;
    $4d82739dd229d539$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $4d82739dd229d539$var$Ug(b, a.child, null, f), b.child = $4d82739dd229d539$var$Ug(b, null, h, f)) : $4d82739dd229d539$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $4d82739dd229d539$var$dg(b, c, !0);
    return b.child;
}
function $4d82739dd229d539$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $4d82739dd229d539$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $4d82739dd229d539$var$ag(a, b.context, !1);
    $4d82739dd229d539$var$yh(a, b.containerInfo);
}
function $4d82739dd229d539$var$lj(a, b, c, d, e) {
    $4d82739dd229d539$var$Ig();
    $4d82739dd229d539$var$Jg(e);
    b.flags |= 256;
    $4d82739dd229d539$var$Xi(a, b, c, d);
    return b.child;
}
var $4d82739dd229d539$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $4d82739dd229d539$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $4d82739dd229d539$var$oj(a, b, c) {
    var d = b.pendingProps, e = $4d82739dd229d539$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $4d82739dd229d539$var$G($4d82739dd229d539$var$L, e & 1);
    if (null === a) {
        $4d82739dd229d539$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $4d82739dd229d539$var$pj(g, d, 0, null), a = $4d82739dd229d539$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $4d82739dd229d539$var$nj(c), b.memoizedState = $4d82739dd229d539$var$mj, a) : $4d82739dd229d539$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $4d82739dd229d539$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $4d82739dd229d539$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $4d82739dd229d539$var$Pg(h, f) : (f = $4d82739dd229d539$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $4d82739dd229d539$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $4d82739dd229d539$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $4d82739dd229d539$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $4d82739dd229d539$var$qj(a, b) {
    b = $4d82739dd229d539$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $4d82739dd229d539$var$sj(a, b, c, d) {
    null !== d && $4d82739dd229d539$var$Jg(d);
    $4d82739dd229d539$var$Ug(b, a.child, null, c);
    a = $4d82739dd229d539$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $4d82739dd229d539$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $4d82739dd229d539$var$Ki(Error($4d82739dd229d539$var$p(422))), $4d82739dd229d539$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $4d82739dd229d539$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $4d82739dd229d539$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $4d82739dd229d539$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $4d82739dd229d539$var$nj(g);
        b.memoizedState = $4d82739dd229d539$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $4d82739dd229d539$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($4d82739dd229d539$var$p(419));
        d = $4d82739dd229d539$var$Ki(f, d, void 0);
        return $4d82739dd229d539$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($4d82739dd229d539$var$dh || h) {
        d = $4d82739dd229d539$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $4d82739dd229d539$var$ih(a, e), $4d82739dd229d539$var$gi(d, a, e, -1));
        }
        $4d82739dd229d539$var$tj();
        d = $4d82739dd229d539$var$Ki(Error($4d82739dd229d539$var$p(421)));
        return $4d82739dd229d539$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $4d82739dd229d539$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(e.nextSibling);
    $4d82739dd229d539$var$xg = b;
    $4d82739dd229d539$var$I = !0;
    $4d82739dd229d539$var$zg = null;
    null !== a && ($4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$rg, $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$sg, $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$qg, $4d82739dd229d539$var$rg = a.id, $4d82739dd229d539$var$sg = a.overflow, $4d82739dd229d539$var$qg = b);
    b = $4d82739dd229d539$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $4d82739dd229d539$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $4d82739dd229d539$var$bh(a.return, b, c);
}
function $4d82739dd229d539$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $4d82739dd229d539$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $4d82739dd229d539$var$Xi(a, b, d.children, c);
    d = $4d82739dd229d539$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $4d82739dd229d539$var$vj(a, c, b);
            else if (19 === a.tag) $4d82739dd229d539$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $4d82739dd229d539$var$G($4d82739dd229d539$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $4d82739dd229d539$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $4d82739dd229d539$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $4d82739dd229d539$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $4d82739dd229d539$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $4d82739dd229d539$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $4d82739dd229d539$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $4d82739dd229d539$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $4d82739dd229d539$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($4d82739dd229d539$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $4d82739dd229d539$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $4d82739dd229d539$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $4d82739dd229d539$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $4d82739dd229d539$var$kj(b);
            $4d82739dd229d539$var$Ig();
            break;
        case 5:
            $4d82739dd229d539$var$Ah(b);
            break;
        case 1:
            $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$cg(b);
            break;
        case 4:
            $4d82739dd229d539$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $4d82739dd229d539$var$G($4d82739dd229d539$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $4d82739dd229d539$var$oj(a, b, c);
                $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1);
                a = $4d82739dd229d539$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $4d82739dd229d539$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $4d82739dd229d539$var$dj(a, b, c);
    }
    return $4d82739dd229d539$var$Zi(a, b, c);
}
var $4d82739dd229d539$var$zj, $4d82739dd229d539$var$Aj, $4d82739dd229d539$var$Bj, $4d82739dd229d539$var$Cj;
$4d82739dd229d539$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$4d82739dd229d539$var$Aj = function() {};
$4d82739dd229d539$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $4d82739dd229d539$var$Ya(a, e);
                d = $4d82739dd229d539$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $4d82739dd229d539$var$A({}, e, {
                    value: void 0
                });
                d = $4d82739dd229d539$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $4d82739dd229d539$var$gb(a, e);
                d = $4d82739dd229d539$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $4d82739dd229d539$var$Bf);
        }
        $4d82739dd229d539$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($4d82739dd229d539$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($4d82739dd229d539$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $4d82739dd229d539$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$4d82739dd229d539$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $4d82739dd229d539$var$Dj(a, b) {
    if (!$4d82739dd229d539$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $4d82739dd229d539$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $4d82739dd229d539$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $4d82739dd229d539$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $4d82739dd229d539$var$S(b), null;
        case 1:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), $4d82739dd229d539$var$S(b), null;
        case 3:
            d = b.stateNode;
            $4d82739dd229d539$var$zh();
            $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
            $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
            $4d82739dd229d539$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $4d82739dd229d539$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $4d82739dd229d539$var$zg && ($4d82739dd229d539$var$Fj($4d82739dd229d539$var$zg), $4d82739dd229d539$var$zg = null));
            $4d82739dd229d539$var$Aj(a, b);
            $4d82739dd229d539$var$S(b);
            return null;
        case 5:
            $4d82739dd229d539$var$Bh(b);
            var e = $4d82739dd229d539$var$xh($4d82739dd229d539$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $4d82739dd229d539$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($4d82739dd229d539$var$p(166));
                    $4d82739dd229d539$var$S(b);
                    return null;
                }
                a = $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
                if ($4d82739dd229d539$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$4d82739dd229d539$var$Of] = b;
                    d[$4d82739dd229d539$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $4d82739dd229d539$var$D("cancel", d);
                            $4d82739dd229d539$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $4d82739dd229d539$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $4d82739dd229d539$var$lf.length; e++)$4d82739dd229d539$var$D($4d82739dd229d539$var$lf[e], d);
                            break;
                        case "source":
                            $4d82739dd229d539$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $4d82739dd229d539$var$D("error", d);
                            $4d82739dd229d539$var$D("load", d);
                            break;
                        case "details":
                            $4d82739dd229d539$var$D("toggle", d);
                            break;
                        case "input":
                            $4d82739dd229d539$var$Za(d, f);
                            $4d82739dd229d539$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $4d82739dd229d539$var$D("invalid", d);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$hb(d, f), $4d82739dd229d539$var$D("invalid", d);
                    }
                    $4d82739dd229d539$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $4d82739dd229d539$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $4d82739dd229d539$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $4d82739dd229d539$var$Va(d);
                            $4d82739dd229d539$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$Va(d);
                            $4d82739dd229d539$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $4d82739dd229d539$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $4d82739dd229d539$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$4d82739dd229d539$var$Of] = b;
                    a[$4d82739dd229d539$var$Pf] = d;
                    $4d82739dd229d539$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $4d82739dd229d539$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $4d82739dd229d539$var$D("cancel", a);
                                $4d82739dd229d539$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $4d82739dd229d539$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $4d82739dd229d539$var$lf.length; e++)$4d82739dd229d539$var$D($4d82739dd229d539$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $4d82739dd229d539$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $4d82739dd229d539$var$D("error", a);
                                $4d82739dd229d539$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $4d82739dd229d539$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $4d82739dd229d539$var$Za(a, d);
                                e = $4d82739dd229d539$var$Ya(a, d);
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $4d82739dd229d539$var$A({}, d, {
                                    value: void 0
                                });
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            case "textarea":
                                $4d82739dd229d539$var$hb(a, d);
                                e = $4d82739dd229d539$var$gb(a, d);
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $4d82739dd229d539$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $4d82739dd229d539$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $4d82739dd229d539$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $4d82739dd229d539$var$ob(a, k) : "number" === typeof k && $4d82739dd229d539$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($4d82739dd229d539$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $4d82739dd229d539$var$D("scroll", a) : null != k && $4d82739dd229d539$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $4d82739dd229d539$var$Va(a);
                                $4d82739dd229d539$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $4d82739dd229d539$var$Va(a);
                                $4d82739dd229d539$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $4d82739dd229d539$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $4d82739dd229d539$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $4d82739dd229d539$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $4d82739dd229d539$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $4d82739dd229d539$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $4d82739dd229d539$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($4d82739dd229d539$var$p(166));
                c = $4d82739dd229d539$var$xh($4d82739dd229d539$var$wh.current);
                $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
                if ($4d82739dd229d539$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$4d82739dd229d539$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $4d82739dd229d539$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $4d82739dd229d539$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$4d82739dd229d539$var$Of] = b, b.stateNode = d;
            }
            $4d82739dd229d539$var$S(b);
            return null;
        case 13:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($4d82739dd229d539$var$I && null !== $4d82739dd229d539$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $4d82739dd229d539$var$Hg(), $4d82739dd229d539$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $4d82739dd229d539$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($4d82739dd229d539$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($4d82739dd229d539$var$p(317));
                        f[$4d82739dd229d539$var$Of] = b;
                    } else $4d82739dd229d539$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $4d82739dd229d539$var$S(b);
                    f = !1;
                } else null !== $4d82739dd229d539$var$zg && ($4d82739dd229d539$var$Fj($4d82739dd229d539$var$zg), $4d82739dd229d539$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($4d82739dd229d539$var$L.current & 1) ? 0 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 3) : $4d82739dd229d539$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $4d82739dd229d539$var$S(b);
            return null;
        case 4:
            return $4d82739dd229d539$var$zh(), $4d82739dd229d539$var$Aj(a, b), null === a && $4d82739dd229d539$var$sf(b.stateNode.containerInfo), $4d82739dd229d539$var$S(b), null;
        case 10:
            return $4d82739dd229d539$var$ah(b.type._context), $4d82739dd229d539$var$S(b), null;
        case 17:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), $4d82739dd229d539$var$S(b), null;
        case 19:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
            f = b.memoizedState;
            if (null === f) return $4d82739dd229d539$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $4d82739dd229d539$var$Dj(f, !1);
                else {
                    if (0 !== $4d82739dd229d539$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $4d82739dd229d539$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $4d82739dd229d539$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $4d82739dd229d539$var$B() > $4d82739dd229d539$var$Gj && (b.flags |= 128, d = !0, $4d82739dd229d539$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $4d82739dd229d539$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $4d82739dd229d539$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$4d82739dd229d539$var$I) return $4d82739dd229d539$var$S(b), null;
                    } else 2 * $4d82739dd229d539$var$B() - f.renderingStartTime > $4d82739dd229d539$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $4d82739dd229d539$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $4d82739dd229d539$var$B(), b.sibling = null, c = $4d82739dd229d539$var$L.current, $4d82739dd229d539$var$G($4d82739dd229d539$var$L, d ? c & 1 | 2 : c & 1), b;
            $4d82739dd229d539$var$S(b);
            return null;
        case 22:
        case 23:
            return $4d82739dd229d539$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($4d82739dd229d539$var$fj & 1073741824) && ($4d82739dd229d539$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $4d82739dd229d539$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($4d82739dd229d539$var$p(156, b.tag));
}
function $4d82739dd229d539$var$Ij(a, b) {
    $4d82739dd229d539$var$wg(b);
    switch(b.tag){
        case 1:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $4d82739dd229d539$var$zh(), $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf), $4d82739dd229d539$var$E($4d82739dd229d539$var$H), $4d82739dd229d539$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $4d82739dd229d539$var$Bh(b), null;
        case 13:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($4d82739dd229d539$var$p(340));
                $4d82739dd229d539$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $4d82739dd229d539$var$E($4d82739dd229d539$var$L), null;
        case 4:
            return $4d82739dd229d539$var$zh(), null;
        case 10:
            return $4d82739dd229d539$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $4d82739dd229d539$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $4d82739dd229d539$var$Jj = !1, $4d82739dd229d539$var$U = !1, $4d82739dd229d539$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $4d82739dd229d539$var$V = null;
function $4d82739dd229d539$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $4d82739dd229d539$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $4d82739dd229d539$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $4d82739dd229d539$var$W(a, b, d);
    }
}
var $4d82739dd229d539$var$Nj = !1;
function $4d82739dd229d539$var$Oj(a, b) {
    $4d82739dd229d539$var$Cf = $4d82739dd229d539$var$dd;
    a = $4d82739dd229d539$var$Me();
    if ($4d82739dd229d539$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $4d82739dd229d539$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $4d82739dd229d539$var$dd = !1;
    for($4d82739dd229d539$var$V = b; null !== $4d82739dd229d539$var$V;)if (b = $4d82739dd229d539$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $4d82739dd229d539$var$V = a;
    else for(; null !== $4d82739dd229d539$var$V;){
        b = $4d82739dd229d539$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $4d82739dd229d539$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(163));
            }
        } catch (F) {
            $4d82739dd229d539$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $4d82739dd229d539$var$V = a;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
    n = $4d82739dd229d539$var$Nj;
    $4d82739dd229d539$var$Nj = !1;
    return n;
}
function $4d82739dd229d539$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $4d82739dd229d539$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $4d82739dd229d539$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $4d82739dd229d539$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $4d82739dd229d539$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $4d82739dd229d539$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$4d82739dd229d539$var$Of], delete b[$4d82739dd229d539$var$Pf], delete b[$4d82739dd229d539$var$of], delete b[$4d82739dd229d539$var$Qf], delete b[$4d82739dd229d539$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $4d82739dd229d539$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $4d82739dd229d539$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $4d82739dd229d539$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $4d82739dd229d539$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $4d82739dd229d539$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($4d82739dd229d539$var$Vj(a, b, c), a = a.sibling; null !== a;)$4d82739dd229d539$var$Vj(a, b, c), a = a.sibling;
}
function $4d82739dd229d539$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($4d82739dd229d539$var$Wj(a, b, c), a = a.sibling; null !== a;)$4d82739dd229d539$var$Wj(a, b, c), a = a.sibling;
}
var $4d82739dd229d539$var$X = null, $4d82739dd229d539$var$Xj = !1;
function $4d82739dd229d539$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$4d82739dd229d539$var$Zj(a, b, c), c = c.sibling;
}
function $4d82739dd229d539$var$Zj(a, b, c) {
    if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onCommitFiberUnmount) try {
        $4d82739dd229d539$var$lc.onCommitFiberUnmount($4d82739dd229d539$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $4d82739dd229d539$var$U || $4d82739dd229d539$var$Lj(c, b);
        case 6:
            var d = $4d82739dd229d539$var$X, e = $4d82739dd229d539$var$Xj;
            $4d82739dd229d539$var$X = null;
            $4d82739dd229d539$var$Yj(a, b, c);
            $4d82739dd229d539$var$X = d;
            $4d82739dd229d539$var$Xj = e;
            null !== $4d82739dd229d539$var$X && ($4d82739dd229d539$var$Xj ? (a = $4d82739dd229d539$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $4d82739dd229d539$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $4d82739dd229d539$var$X && ($4d82739dd229d539$var$Xj ? (a = $4d82739dd229d539$var$X, c = c.stateNode, 8 === a.nodeType ? $4d82739dd229d539$var$Kf(a.parentNode, c) : 1 === a.nodeType && $4d82739dd229d539$var$Kf(a, c), $4d82739dd229d539$var$bd(a)) : $4d82739dd229d539$var$Kf($4d82739dd229d539$var$X, c.stateNode));
            break;
        case 4:
            d = $4d82739dd229d539$var$X;
            e = $4d82739dd229d539$var$Xj;
            $4d82739dd229d539$var$X = c.stateNode.containerInfo;
            $4d82739dd229d539$var$Xj = !0;
            $4d82739dd229d539$var$Yj(a, b, c);
            $4d82739dd229d539$var$X = d;
            $4d82739dd229d539$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$4d82739dd229d539$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $4d82739dd229d539$var$Mj(c, b, g) : 0 !== (f & 4) && $4d82739dd229d539$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $4d82739dd229d539$var$Yj(a, b, c);
            break;
        case 1:
            if (!$4d82739dd229d539$var$U && ($4d82739dd229d539$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $4d82739dd229d539$var$W(c, b, h);
            }
            $4d82739dd229d539$var$Yj(a, b, c);
            break;
        case 21:
            $4d82739dd229d539$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($4d82739dd229d539$var$U = (d = $4d82739dd229d539$var$U) || null !== c.memoizedState, $4d82739dd229d539$var$Yj(a, b, c), $4d82739dd229d539$var$U = d) : $4d82739dd229d539$var$Yj(a, b, c);
            break;
        default:
            $4d82739dd229d539$var$Yj(a, b, c);
    }
}
function $4d82739dd229d539$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $4d82739dd229d539$var$Kj);
        b.forEach(function(b) {
            var d = $4d82739dd229d539$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $4d82739dd229d539$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $4d82739dd229d539$var$X = h.stateNode;
                        $4d82739dd229d539$var$Xj = !1;
                        break a;
                    case 3:
                        $4d82739dd229d539$var$X = h.stateNode.containerInfo;
                        $4d82739dd229d539$var$Xj = !0;
                        break a;
                    case 4:
                        $4d82739dd229d539$var$X = h.stateNode.containerInfo;
                        $4d82739dd229d539$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $4d82739dd229d539$var$X) throw Error($4d82739dd229d539$var$p(160));
            $4d82739dd229d539$var$Zj(f, g, e);
            $4d82739dd229d539$var$X = null;
            $4d82739dd229d539$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $4d82739dd229d539$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$4d82739dd229d539$var$dk(b, a), b = b.sibling;
}
function $4d82739dd229d539$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 4) {
                try {
                    $4d82739dd229d539$var$Pj(3, a, a.return), $4d82739dd229d539$var$Qj(3, a);
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
                try {
                    $4d82739dd229d539$var$Pj(5, a, a.return);
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            d & 512 && null !== c && $4d82739dd229d539$var$Lj(c, c.return);
            break;
        case 5:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            d & 512 && null !== c && $4d82739dd229d539$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $4d82739dd229d539$var$ob(e, "");
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $4d82739dd229d539$var$ab(e, f);
                    $4d82739dd229d539$var$vb(h, g);
                    var l = $4d82739dd229d539$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $4d82739dd229d539$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $4d82739dd229d539$var$nb(e, q) : "children" === m ? $4d82739dd229d539$var$ob(e, q) : $4d82739dd229d539$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $4d82739dd229d539$var$bb(e, f);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $4d82739dd229d539$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $4d82739dd229d539$var$fb(e, !!f.multiple, f.defaultValue, !0) : $4d82739dd229d539$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$4d82739dd229d539$var$Pf] = f;
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($4d82739dd229d539$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $4d82739dd229d539$var$bd(b.containerInfo);
            } catch (t) {
                $4d82739dd229d539$var$W(a, a.return, t);
            }
            break;
        case 4:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            break;
        case 13:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($4d82739dd229d539$var$fk = $4d82739dd229d539$var$B()));
            d & 4 && $4d82739dd229d539$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($4d82739dd229d539$var$U = (l = $4d82739dd229d539$var$U) || m, $4d82739dd229d539$var$ck(b, a), $4d82739dd229d539$var$U = l) : $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($4d82739dd229d539$var$V = a, m = a.child; null !== m;){
                    for(q = $4d82739dd229d539$var$V = m; null !== $4d82739dd229d539$var$V;){
                        r = $4d82739dd229d539$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $4d82739dd229d539$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $4d82739dd229d539$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $4d82739dd229d539$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $4d82739dd229d539$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $4d82739dd229d539$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $4d82739dd229d539$var$V = y) : $4d82739dd229d539$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $4d82739dd229d539$var$rb("display", g));
                            } catch (t) {
                                $4d82739dd229d539$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $4d82739dd229d539$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            d & 4 && $4d82739dd229d539$var$ak(a);
            break;
        case 21:
            break;
        default:
            $4d82739dd229d539$var$ck(b, a), $4d82739dd229d539$var$ek(a);
    }
}
function $4d82739dd229d539$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($4d82739dd229d539$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($4d82739dd229d539$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($4d82739dd229d539$var$ob(e, ""), d.flags &= -33);
                    var f = $4d82739dd229d539$var$Uj(a);
                    $4d82739dd229d539$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $4d82739dd229d539$var$Uj(a);
                    $4d82739dd229d539$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(161));
            }
        } catch (k) {
            $4d82739dd229d539$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $4d82739dd229d539$var$hk(a, b, c) {
    $4d82739dd229d539$var$V = a;
    $4d82739dd229d539$var$ik(a, b, c);
}
function $4d82739dd229d539$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $4d82739dd229d539$var$V;){
        var e = $4d82739dd229d539$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $4d82739dd229d539$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $4d82739dd229d539$var$U;
                h = $4d82739dd229d539$var$Jj;
                var l = $4d82739dd229d539$var$U;
                $4d82739dd229d539$var$Jj = g;
                if (($4d82739dd229d539$var$U = k) && !l) for($4d82739dd229d539$var$V = e; null !== $4d82739dd229d539$var$V;)g = $4d82739dd229d539$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $4d82739dd229d539$var$jk(e) : null !== k ? (k.return = g, $4d82739dd229d539$var$V = k) : $4d82739dd229d539$var$jk(e);
                for(; null !== f;)$4d82739dd229d539$var$V = f, $4d82739dd229d539$var$ik(f, b, c), f = f.sibling;
                $4d82739dd229d539$var$V = e;
                $4d82739dd229d539$var$Jj = h;
                $4d82739dd229d539$var$U = l;
            }
            $4d82739dd229d539$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $4d82739dd229d539$var$V = f) : $4d82739dd229d539$var$kk(a, b, c);
    }
}
function $4d82739dd229d539$var$kk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $4d82739dd229d539$var$U || $4d82739dd229d539$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$4d82739dd229d539$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $4d82739dd229d539$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $4d82739dd229d539$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $4d82739dd229d539$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $4d82739dd229d539$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($4d82739dd229d539$var$p(163));
                }
                $4d82739dd229d539$var$U || b.flags & 512 && $4d82739dd229d539$var$Rj(b);
            } catch (r) {
                $4d82739dd229d539$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4d82739dd229d539$var$V = c;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
function $4d82739dd229d539$var$gk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4d82739dd229d539$var$V = c;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
function $4d82739dd229d539$var$jk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $4d82739dd229d539$var$Qj(4, b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $4d82739dd229d539$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $4d82739dd229d539$var$Rj(b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $4d82739dd229d539$var$Rj(b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $4d82739dd229d539$var$W(b, b.return, k);
        }
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $4d82739dd229d539$var$V = h;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
var $4d82739dd229d539$var$lk = Math.ceil, $4d82739dd229d539$var$mk = $4d82739dd229d539$var$ua.ReactCurrentDispatcher, $4d82739dd229d539$var$nk = $4d82739dd229d539$var$ua.ReactCurrentOwner, $4d82739dd229d539$var$ok = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$K = 0, $4d82739dd229d539$var$Q = null, $4d82739dd229d539$var$Y = null, $4d82739dd229d539$var$Z = 0, $4d82739dd229d539$var$fj = 0, $4d82739dd229d539$var$ej = $4d82739dd229d539$var$Uf(0), $4d82739dd229d539$var$T = 0, $4d82739dd229d539$var$pk = null, $4d82739dd229d539$var$rh = 0, $4d82739dd229d539$var$qk = 0, $4d82739dd229d539$var$rk = 0, $4d82739dd229d539$var$sk = null, $4d82739dd229d539$var$tk = null, $4d82739dd229d539$var$fk = 0, $4d82739dd229d539$var$Gj = Infinity, $4d82739dd229d539$var$uk = null, $4d82739dd229d539$var$Oi = !1, $4d82739dd229d539$var$Pi = null, $4d82739dd229d539$var$Ri = null, $4d82739dd229d539$var$vk = !1, $4d82739dd229d539$var$wk = null, $4d82739dd229d539$var$xk = 0, $4d82739dd229d539$var$yk = 0, $4d82739dd229d539$var$zk = null, $4d82739dd229d539$var$Ak = -1, $4d82739dd229d539$var$Bk = 0;
function $4d82739dd229d539$var$R() {
    return 0 !== ($4d82739dd229d539$var$K & 6) ? $4d82739dd229d539$var$B() : -1 !== $4d82739dd229d539$var$Ak ? $4d82739dd229d539$var$Ak : $4d82739dd229d539$var$Ak = $4d82739dd229d539$var$B();
}
function $4d82739dd229d539$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($4d82739dd229d539$var$K & 2) && 0 !== $4d82739dd229d539$var$Z) return $4d82739dd229d539$var$Z & -$4d82739dd229d539$var$Z;
    if (null !== $4d82739dd229d539$var$Kg.transition) return 0 === $4d82739dd229d539$var$Bk && ($4d82739dd229d539$var$Bk = $4d82739dd229d539$var$yc()), $4d82739dd229d539$var$Bk;
    a = $4d82739dd229d539$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $4d82739dd229d539$var$jd(a.type);
    return a;
}
function $4d82739dd229d539$var$gi(a, b, c, d) {
    if (50 < $4d82739dd229d539$var$yk) throw $4d82739dd229d539$var$yk = 0, $4d82739dd229d539$var$zk = null, Error($4d82739dd229d539$var$p(185));
    $4d82739dd229d539$var$Ac(a, c, d);
    if (0 === ($4d82739dd229d539$var$K & 2) || a !== $4d82739dd229d539$var$Q) a === $4d82739dd229d539$var$Q && (0 === ($4d82739dd229d539$var$K & 2) && ($4d82739dd229d539$var$qk |= c), 4 === $4d82739dd229d539$var$T && $4d82739dd229d539$var$Ck(a, $4d82739dd229d539$var$Z)), $4d82739dd229d539$var$Dk(a, d), 1 === c && 0 === $4d82739dd229d539$var$K && 0 === (b.mode & 1) && ($4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$fg && $4d82739dd229d539$var$jg());
}
function $4d82739dd229d539$var$Dk(a, b) {
    var c = a.callbackNode;
    $4d82739dd229d539$var$wc(a, b);
    var d = $4d82739dd229d539$var$uc(a, a === $4d82739dd229d539$var$Q ? $4d82739dd229d539$var$Z : 0);
    if (0 === d) null !== c && $4d82739dd229d539$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $4d82739dd229d539$var$bc(c);
        if (1 === b) 0 === a.tag ? $4d82739dd229d539$var$ig($4d82739dd229d539$var$Ek.bind(null, a)) : $4d82739dd229d539$var$hg($4d82739dd229d539$var$Ek.bind(null, a)), $4d82739dd229d539$var$Jf(function() {
            0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$jg();
        }), c = null;
        else {
            switch($4d82739dd229d539$var$Dc(d)){
                case 1:
                    c = $4d82739dd229d539$var$fc;
                    break;
                case 4:
                    c = $4d82739dd229d539$var$gc;
                    break;
                case 16:
                    c = $4d82739dd229d539$var$hc;
                    break;
                case 536870912:
                    c = $4d82739dd229d539$var$jc;
                    break;
                default:
                    c = $4d82739dd229d539$var$hc;
            }
            c = $4d82739dd229d539$var$Fk(c, $4d82739dd229d539$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $4d82739dd229d539$var$Gk(a, b) {
    $4d82739dd229d539$var$Ak = -1;
    $4d82739dd229d539$var$Bk = 0;
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    var c = a.callbackNode;
    if ($4d82739dd229d539$var$Hk() && a.callbackNode !== c) return null;
    var d = $4d82739dd229d539$var$uc(a, a === $4d82739dd229d539$var$Q ? $4d82739dd229d539$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $4d82739dd229d539$var$Ik(a, d);
    else {
        b = d;
        var e = $4d82739dd229d539$var$K;
        $4d82739dd229d539$var$K |= 2;
        var f = $4d82739dd229d539$var$Jk();
        if ($4d82739dd229d539$var$Q !== a || $4d82739dd229d539$var$Z !== b) $4d82739dd229d539$var$uk = null, $4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$Kk(a, b);
        for(;;)try {
            $4d82739dd229d539$var$Lk();
            break;
        } catch (h) {
            $4d82739dd229d539$var$Mk(a, h);
        }
        $4d82739dd229d539$var$$g();
        $4d82739dd229d539$var$mk.current = f;
        $4d82739dd229d539$var$K = e;
        null !== $4d82739dd229d539$var$Y ? b = 0 : ($4d82739dd229d539$var$Q = null, $4d82739dd229d539$var$Z = 0, b = $4d82739dd229d539$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $4d82739dd229d539$var$xc(a), 0 !== e && (d = e, b = $4d82739dd229d539$var$Nk(a, e)));
        if (1 === b) throw c = $4d82739dd229d539$var$pk, $4d82739dd229d539$var$Kk(a, 0), $4d82739dd229d539$var$Ck(a, d), $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), c;
        if (6 === b) $4d82739dd229d539$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$4d82739dd229d539$var$Ok(e) && (b = $4d82739dd229d539$var$Ik(a, d), 2 === b && (f = $4d82739dd229d539$var$xc(a), 0 !== f && (d = f, b = $4d82739dd229d539$var$Nk(a, f))), 1 === b)) throw c = $4d82739dd229d539$var$pk, $4d82739dd229d539$var$Kk(a, 0), $4d82739dd229d539$var$Ck(a, d), $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($4d82739dd229d539$var$p(345));
                case 2:
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                case 3:
                    $4d82739dd229d539$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $4d82739dd229d539$var$fk + 500 - $4d82739dd229d539$var$B(), 10 < b)) {
                        if (0 !== $4d82739dd229d539$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $4d82739dd229d539$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $4d82739dd229d539$var$Ff($4d82739dd229d539$var$Pk.bind(null, a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk), b);
                        break;
                    }
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                case 4:
                    $4d82739dd229d539$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $4d82739dd229d539$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $4d82739dd229d539$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $4d82739dd229d539$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $4d82739dd229d539$var$Ff($4d82739dd229d539$var$Pk.bind(null, a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk), d);
                        break;
                    }
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                case 5:
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(329));
            }
        }
    }
    $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B());
    return a.callbackNode === c ? $4d82739dd229d539$var$Gk.bind(null, a) : null;
}
function $4d82739dd229d539$var$Nk(a, b) {
    var c = $4d82739dd229d539$var$sk;
    a.current.memoizedState.isDehydrated && ($4d82739dd229d539$var$Kk(a, b).flags |= 256);
    a = $4d82739dd229d539$var$Ik(a, b);
    2 !== a && (b = $4d82739dd229d539$var$tk, $4d82739dd229d539$var$tk = c, null !== b && $4d82739dd229d539$var$Fj(b));
    return a;
}
function $4d82739dd229d539$var$Fj(a) {
    null === $4d82739dd229d539$var$tk ? $4d82739dd229d539$var$tk = a : $4d82739dd229d539$var$tk.push.apply($4d82739dd229d539$var$tk, a);
}
function $4d82739dd229d539$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$4d82739dd229d539$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $4d82739dd229d539$var$Ck(a, b) {
    b &= ~$4d82739dd229d539$var$rk;
    b &= ~$4d82739dd229d539$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $4d82739dd229d539$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $4d82739dd229d539$var$Ek(a) {
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    $4d82739dd229d539$var$Hk();
    var b = $4d82739dd229d539$var$uc(a, 0);
    if (0 === (b & 1)) return $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), null;
    var c = $4d82739dd229d539$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $4d82739dd229d539$var$xc(a);
        0 !== d && (b = d, c = $4d82739dd229d539$var$Nk(a, d));
    }
    if (1 === c) throw c = $4d82739dd229d539$var$pk, $4d82739dd229d539$var$Kk(a, 0), $4d82739dd229d539$var$Ck(a, b), $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), c;
    if (6 === c) throw Error($4d82739dd229d539$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
    $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B());
    return null;
}
function $4d82739dd229d539$var$Qk(a, b) {
    var c = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 1;
    try {
        return a(b);
    } finally{
        $4d82739dd229d539$var$K = c, 0 === $4d82739dd229d539$var$K && ($4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$fg && $4d82739dd229d539$var$jg());
    }
}
function $4d82739dd229d539$var$Rk(a) {
    null !== $4d82739dd229d539$var$wk && 0 === $4d82739dd229d539$var$wk.tag && 0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$Hk();
    var b = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 1;
    var c = $4d82739dd229d539$var$ok.transition, d = $4d82739dd229d539$var$C;
    try {
        if ($4d82739dd229d539$var$ok.transition = null, $4d82739dd229d539$var$C = 1, a) return a();
    } finally{
        $4d82739dd229d539$var$C = d, $4d82739dd229d539$var$ok.transition = c, $4d82739dd229d539$var$K = b, 0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$jg();
    }
}
function $4d82739dd229d539$var$Hj() {
    $4d82739dd229d539$var$fj = $4d82739dd229d539$var$ej.current;
    $4d82739dd229d539$var$E($4d82739dd229d539$var$ej);
}
function $4d82739dd229d539$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $4d82739dd229d539$var$Gf(c));
    if (null !== $4d82739dd229d539$var$Y) for(c = $4d82739dd229d539$var$Y.return; null !== c;){
        var d = c;
        $4d82739dd229d539$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $4d82739dd229d539$var$$f();
                break;
            case 3:
                $4d82739dd229d539$var$zh();
                $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
                $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
                $4d82739dd229d539$var$Eh();
                break;
            case 5:
                $4d82739dd229d539$var$Bh(d);
                break;
            case 4:
                $4d82739dd229d539$var$zh();
                break;
            case 13:
                $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
                break;
            case 19:
                $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
                break;
            case 10:
                $4d82739dd229d539$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $4d82739dd229d539$var$Hj();
        }
        c = c.return;
    }
    $4d82739dd229d539$var$Q = a;
    $4d82739dd229d539$var$Y = a = $4d82739dd229d539$var$Pg(a.current, null);
    $4d82739dd229d539$var$Z = $4d82739dd229d539$var$fj = b;
    $4d82739dd229d539$var$T = 0;
    $4d82739dd229d539$var$pk = null;
    $4d82739dd229d539$var$rk = $4d82739dd229d539$var$qk = $4d82739dd229d539$var$rh = 0;
    $4d82739dd229d539$var$tk = $4d82739dd229d539$var$sk = null;
    if (null !== $4d82739dd229d539$var$fh) {
        for(b = 0; b < $4d82739dd229d539$var$fh.length; b++)if (c = $4d82739dd229d539$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $4d82739dd229d539$var$fh = null;
    }
    return a;
}
function $4d82739dd229d539$var$Mk(a, b) {
    do {
        var c = $4d82739dd229d539$var$Y;
        try {
            $4d82739dd229d539$var$$g();
            $4d82739dd229d539$var$Fh.current = $4d82739dd229d539$var$Rh;
            if ($4d82739dd229d539$var$Ih) {
                for(var d = $4d82739dd229d539$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $4d82739dd229d539$var$Ih = !1;
            }
            $4d82739dd229d539$var$Hh = 0;
            $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = $4d82739dd229d539$var$M = null;
            $4d82739dd229d539$var$Jh = !1;
            $4d82739dd229d539$var$Kh = 0;
            $4d82739dd229d539$var$nk.current = null;
            if (null === c || null === c.return) {
                $4d82739dd229d539$var$T = 1;
                $4d82739dd229d539$var$pk = b;
                $4d82739dd229d539$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $4d82739dd229d539$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $4d82739dd229d539$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $4d82739dd229d539$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $4d82739dd229d539$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $4d82739dd229d539$var$Si(f, l, b);
                            $4d82739dd229d539$var$tj();
                            break a;
                        }
                        k = Error($4d82739dd229d539$var$p(426));
                    }
                } else if ($4d82739dd229d539$var$I && h.mode & 1) {
                    var J = $4d82739dd229d539$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $4d82739dd229d539$var$Vi(J, g, h, f, b);
                        $4d82739dd229d539$var$Jg($4d82739dd229d539$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $4d82739dd229d539$var$Ji(k, h);
                4 !== $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 2);
                null === $4d82739dd229d539$var$sk ? $4d82739dd229d539$var$sk = [
                    f
                ] : $4d82739dd229d539$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $4d82739dd229d539$var$Ni(f, k, b);
                            $4d82739dd229d539$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $4d82739dd229d539$var$Ri || !$4d82739dd229d539$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $4d82739dd229d539$var$Qi(f, h, b);
                                $4d82739dd229d539$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $4d82739dd229d539$var$Sk(c);
        } catch (na) {
            b = na;
            $4d82739dd229d539$var$Y === c && null !== c && ($4d82739dd229d539$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $4d82739dd229d539$var$Jk() {
    var a = $4d82739dd229d539$var$mk.current;
    $4d82739dd229d539$var$mk.current = $4d82739dd229d539$var$Rh;
    return null === a ? $4d82739dd229d539$var$Rh : a;
}
function $4d82739dd229d539$var$tj() {
    if (0 === $4d82739dd229d539$var$T || 3 === $4d82739dd229d539$var$T || 2 === $4d82739dd229d539$var$T) $4d82739dd229d539$var$T = 4;
    null === $4d82739dd229d539$var$Q || 0 === ($4d82739dd229d539$var$rh & 268435455) && 0 === ($4d82739dd229d539$var$qk & 268435455) || $4d82739dd229d539$var$Ck($4d82739dd229d539$var$Q, $4d82739dd229d539$var$Z);
}
function $4d82739dd229d539$var$Ik(a, b) {
    var c = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 2;
    var d = $4d82739dd229d539$var$Jk();
    if ($4d82739dd229d539$var$Q !== a || $4d82739dd229d539$var$Z !== b) $4d82739dd229d539$var$uk = null, $4d82739dd229d539$var$Kk(a, b);
    for(;;)try {
        $4d82739dd229d539$var$Tk();
        break;
    } catch (e) {
        $4d82739dd229d539$var$Mk(a, e);
    }
    $4d82739dd229d539$var$$g();
    $4d82739dd229d539$var$K = c;
    $4d82739dd229d539$var$mk.current = d;
    if (null !== $4d82739dd229d539$var$Y) throw Error($4d82739dd229d539$var$p(261));
    $4d82739dd229d539$var$Q = null;
    $4d82739dd229d539$var$Z = 0;
    return $4d82739dd229d539$var$T;
}
function $4d82739dd229d539$var$Tk() {
    for(; null !== $4d82739dd229d539$var$Y;)$4d82739dd229d539$var$Uk($4d82739dd229d539$var$Y);
}
function $4d82739dd229d539$var$Lk() {
    for(; null !== $4d82739dd229d539$var$Y && !$4d82739dd229d539$var$cc();)$4d82739dd229d539$var$Uk($4d82739dd229d539$var$Y);
}
function $4d82739dd229d539$var$Uk(a) {
    var b = $4d82739dd229d539$var$Vk(a.alternate, a, $4d82739dd229d539$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $4d82739dd229d539$var$Sk(a) : $4d82739dd229d539$var$Y = b;
    $4d82739dd229d539$var$nk.current = null;
}
function $4d82739dd229d539$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $4d82739dd229d539$var$Ej(c, b, $4d82739dd229d539$var$fj), null !== c) {
                $4d82739dd229d539$var$Y = c;
                return;
            }
        } else {
            c = $4d82739dd229d539$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $4d82739dd229d539$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $4d82739dd229d539$var$T = 6;
                $4d82739dd229d539$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $4d82739dd229d539$var$Y = b;
            return;
        }
        $4d82739dd229d539$var$Y = b = a;
    }while (null !== b);
    0 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 5);
}
function $4d82739dd229d539$var$Pk(a, b, c) {
    var d = $4d82739dd229d539$var$C, e = $4d82739dd229d539$var$ok.transition;
    try {
        $4d82739dd229d539$var$ok.transition = null, $4d82739dd229d539$var$C = 1, $4d82739dd229d539$var$Wk(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$ok.transition = e, $4d82739dd229d539$var$C = d;
    }
    return null;
}
function $4d82739dd229d539$var$Wk(a, b, c, d) {
    do $4d82739dd229d539$var$Hk();
    while (null !== $4d82739dd229d539$var$wk);
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($4d82739dd229d539$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $4d82739dd229d539$var$Bc(a, f);
    a === $4d82739dd229d539$var$Q && ($4d82739dd229d539$var$Y = $4d82739dd229d539$var$Q = null, $4d82739dd229d539$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $4d82739dd229d539$var$vk || ($4d82739dd229d539$var$vk = !0, $4d82739dd229d539$var$Fk($4d82739dd229d539$var$hc, function() {
        $4d82739dd229d539$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $4d82739dd229d539$var$ok.transition;
        $4d82739dd229d539$var$ok.transition = null;
        var g = $4d82739dd229d539$var$C;
        $4d82739dd229d539$var$C = 1;
        var h = $4d82739dd229d539$var$K;
        $4d82739dd229d539$var$K |= 4;
        $4d82739dd229d539$var$nk.current = null;
        $4d82739dd229d539$var$Oj(a, c);
        $4d82739dd229d539$var$dk(c, a);
        $4d82739dd229d539$var$Oe($4d82739dd229d539$var$Df);
        $4d82739dd229d539$var$dd = !!$4d82739dd229d539$var$Cf;
        $4d82739dd229d539$var$Df = $4d82739dd229d539$var$Cf = null;
        a.current = c;
        $4d82739dd229d539$var$hk(c, a, e);
        $4d82739dd229d539$var$dc();
        $4d82739dd229d539$var$K = h;
        $4d82739dd229d539$var$C = g;
        $4d82739dd229d539$var$ok.transition = f;
    } else a.current = c;
    $4d82739dd229d539$var$vk && ($4d82739dd229d539$var$vk = !1, $4d82739dd229d539$var$wk = a, $4d82739dd229d539$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($4d82739dd229d539$var$Ri = null);
    $4d82739dd229d539$var$mc(c.stateNode, d);
    $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($4d82739dd229d539$var$Oi) throw $4d82739dd229d539$var$Oi = !1, a = $4d82739dd229d539$var$Pi, $4d82739dd229d539$var$Pi = null, a;
    0 !== ($4d82739dd229d539$var$xk & 1) && 0 !== a.tag && $4d82739dd229d539$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $4d82739dd229d539$var$zk ? $4d82739dd229d539$var$yk++ : ($4d82739dd229d539$var$yk = 0, $4d82739dd229d539$var$zk = a) : $4d82739dd229d539$var$yk = 0;
    $4d82739dd229d539$var$jg();
    return null;
}
function $4d82739dd229d539$var$Hk() {
    if (null !== $4d82739dd229d539$var$wk) {
        var a = $4d82739dd229d539$var$Dc($4d82739dd229d539$var$xk), b = $4d82739dd229d539$var$ok.transition, c = $4d82739dd229d539$var$C;
        try {
            $4d82739dd229d539$var$ok.transition = null;
            $4d82739dd229d539$var$C = 16 > a ? 16 : a;
            if (null === $4d82739dd229d539$var$wk) var d = !1;
            else {
                a = $4d82739dd229d539$var$wk;
                $4d82739dd229d539$var$wk = null;
                $4d82739dd229d539$var$xk = 0;
                if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(331));
                var e = $4d82739dd229d539$var$K;
                $4d82739dd229d539$var$K |= 4;
                for($4d82739dd229d539$var$V = a.current; null !== $4d82739dd229d539$var$V;){
                    var f = $4d82739dd229d539$var$V, g = f.child;
                    if (0 !== ($4d82739dd229d539$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($4d82739dd229d539$var$V = l; null !== $4d82739dd229d539$var$V;){
                                    var m = $4d82739dd229d539$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $4d82739dd229d539$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $4d82739dd229d539$var$V = q;
                                    else for(; null !== $4d82739dd229d539$var$V;){
                                        m = $4d82739dd229d539$var$V;
                                        var r = m.sibling, y = m.return;
                                        $4d82739dd229d539$var$Sj(m);
                                        if (m === l) {
                                            $4d82739dd229d539$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $4d82739dd229d539$var$V = r;
                                            break;
                                        }
                                        $4d82739dd229d539$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $4d82739dd229d539$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $4d82739dd229d539$var$V = g;
                    else b: for(; null !== $4d82739dd229d539$var$V;){
                        f = $4d82739dd229d539$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $4d82739dd229d539$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $4d82739dd229d539$var$V = x;
                            break b;
                        }
                        $4d82739dd229d539$var$V = f.return;
                    }
                }
                var w = a.current;
                for($4d82739dd229d539$var$V = w; null !== $4d82739dd229d539$var$V;){
                    g = $4d82739dd229d539$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $4d82739dd229d539$var$V = u;
                    else b: for(g = w; null !== $4d82739dd229d539$var$V;){
                        h = $4d82739dd229d539$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $4d82739dd229d539$var$Qj(9, h);
                            }
                        } catch (na) {
                            $4d82739dd229d539$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $4d82739dd229d539$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $4d82739dd229d539$var$V = F;
                            break b;
                        }
                        $4d82739dd229d539$var$V = h.return;
                    }
                }
                $4d82739dd229d539$var$K = e;
                $4d82739dd229d539$var$jg();
                if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onPostCommitFiberRoot) try {
                    $4d82739dd229d539$var$lc.onPostCommitFiberRoot($4d82739dd229d539$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $4d82739dd229d539$var$C = c, $4d82739dd229d539$var$ok.transition = b;
        }
    }
    return !1;
}
function $4d82739dd229d539$var$Xk(a, b, c) {
    b = $4d82739dd229d539$var$Ji(c, b);
    b = $4d82739dd229d539$var$Ni(a, b, 1);
    a = $4d82739dd229d539$var$nh(a, b, 1);
    b = $4d82739dd229d539$var$R();
    null !== a && ($4d82739dd229d539$var$Ac(a, 1, b), $4d82739dd229d539$var$Dk(a, b));
}
function $4d82739dd229d539$var$W(a, b, c) {
    if (3 === a.tag) $4d82739dd229d539$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $4d82739dd229d539$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $4d82739dd229d539$var$Ri || !$4d82739dd229d539$var$Ri.has(d))) {
                a = $4d82739dd229d539$var$Ji(c, a);
                a = $4d82739dd229d539$var$Qi(b, a, 1);
                b = $4d82739dd229d539$var$nh(b, a, 1);
                a = $4d82739dd229d539$var$R();
                null !== b && ($4d82739dd229d539$var$Ac(b, 1, a), $4d82739dd229d539$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $4d82739dd229d539$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $4d82739dd229d539$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $4d82739dd229d539$var$Q === a && ($4d82739dd229d539$var$Z & c) === c && (4 === $4d82739dd229d539$var$T || 3 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$Z & 130023424) === $4d82739dd229d539$var$Z && 500 > $4d82739dd229d539$var$B() - $4d82739dd229d539$var$fk ? $4d82739dd229d539$var$Kk(a, 0) : $4d82739dd229d539$var$rk |= c);
    $4d82739dd229d539$var$Dk(a, b);
}
function $4d82739dd229d539$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $4d82739dd229d539$var$sc, $4d82739dd229d539$var$sc <<= 1, 0 === ($4d82739dd229d539$var$sc & 130023424) && ($4d82739dd229d539$var$sc = 4194304)));
    var c = $4d82739dd229d539$var$R();
    a = $4d82739dd229d539$var$ih(a, b);
    null !== a && ($4d82739dd229d539$var$Ac(a, b, c), $4d82739dd229d539$var$Dk(a, c));
}
function $4d82739dd229d539$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $4d82739dd229d539$var$Yk(a, c);
}
function $4d82739dd229d539$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($4d82739dd229d539$var$p(314));
    }
    null !== d && d.delete(b);
    $4d82739dd229d539$var$Yk(a, c);
}
var $4d82739dd229d539$var$Vk;
$4d82739dd229d539$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $4d82739dd229d539$var$Wf.current) $4d82739dd229d539$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $4d82739dd229d539$var$dh = !1, $4d82739dd229d539$var$yj(a, b, c);
            $4d82739dd229d539$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $4d82739dd229d539$var$dh = !1, $4d82739dd229d539$var$I && 0 !== (b.flags & 1048576) && $4d82739dd229d539$var$ug(b, $4d82739dd229d539$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $4d82739dd229d539$var$ij(a, b);
            a = b.pendingProps;
            var e = $4d82739dd229d539$var$Yf(b, $4d82739dd229d539$var$H.current);
            $4d82739dd229d539$var$ch(b, c);
            e = $4d82739dd229d539$var$Nh(null, b, d, a, e, c);
            var f = $4d82739dd229d539$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $4d82739dd229d539$var$Zf(d) ? (f = !0, $4d82739dd229d539$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $4d82739dd229d539$var$kh(b), e.updater = $4d82739dd229d539$var$Ei, b.stateNode = e, e._reactInternals = b, $4d82739dd229d539$var$Ii(b, d, a, c), b = $4d82739dd229d539$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $4d82739dd229d539$var$I && f && $4d82739dd229d539$var$vg(b), $4d82739dd229d539$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $4d82739dd229d539$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $4d82739dd229d539$var$Zk(d);
                a = $4d82739dd229d539$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $4d82739dd229d539$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $4d82739dd229d539$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $4d82739dd229d539$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $4d82739dd229d539$var$$i(null, b, d, $4d82739dd229d539$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($4d82739dd229d539$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $4d82739dd229d539$var$kj(b);
                if (null === a) throw Error($4d82739dd229d539$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $4d82739dd229d539$var$lh(a, b);
                $4d82739dd229d539$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $4d82739dd229d539$var$Ji(Error($4d82739dd229d539$var$p(423)), b);
                        b = $4d82739dd229d539$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $4d82739dd229d539$var$Ji(Error($4d82739dd229d539$var$p(424)), b);
                        b = $4d82739dd229d539$var$lj(a, b, d, c, e);
                        break a;
                    } else for($4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(b.stateNode.containerInfo.firstChild), $4d82739dd229d539$var$xg = b, $4d82739dd229d539$var$I = !0, $4d82739dd229d539$var$zg = null, c = $4d82739dd229d539$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $4d82739dd229d539$var$Ig();
                    if (d === e) {
                        b = $4d82739dd229d539$var$Zi(a, b, c);
                        break a;
                    }
                    $4d82739dd229d539$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $4d82739dd229d539$var$Ah(b), null === a && $4d82739dd229d539$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $4d82739dd229d539$var$Ef(d, e) ? g = null : null !== f && $4d82739dd229d539$var$Ef(d, f) && (b.flags |= 32), $4d82739dd229d539$var$gj(a, b), $4d82739dd229d539$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $4d82739dd229d539$var$Eg(b), null;
        case 13:
            return $4d82739dd229d539$var$oj(a, b, c);
        case 4:
            return $4d82739dd229d539$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $4d82739dd229d539$var$Ug(b, null, d, c) : $4d82739dd229d539$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$Yi(a, b, d, e, c);
        case 7:
            return $4d82739dd229d539$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $4d82739dd229d539$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $4d82739dd229d539$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $4d82739dd229d539$var$G($4d82739dd229d539$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($4d82739dd229d539$var$He(f.value, g)) {
                        if (f.children === e.children && !$4d82739dd229d539$var$Wf.current) {
                            b = $4d82739dd229d539$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $4d82739dd229d539$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $4d82739dd229d539$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($4d82739dd229d539$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $4d82739dd229d539$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $4d82739dd229d539$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $4d82739dd229d539$var$ch(b, c), e = $4d82739dd229d539$var$eh(e), d = d(e), b.flags |= 1, $4d82739dd229d539$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $4d82739dd229d539$var$Ci(d, b.pendingProps), e = $4d82739dd229d539$var$Ci(d.type, e), $4d82739dd229d539$var$$i(a, b, d, e, c);
        case 15:
            return $4d82739dd229d539$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$ij(a, b), b.tag = 1, $4d82739dd229d539$var$Zf(d) ? (a = !0, $4d82739dd229d539$var$cg(b)) : a = !1, $4d82739dd229d539$var$ch(b, c), $4d82739dd229d539$var$Gi(b, d, e), $4d82739dd229d539$var$Ii(b, d, e, c), $4d82739dd229d539$var$jj(null, b, d, !0, a, c);
        case 19:
            return $4d82739dd229d539$var$xj(a, b, c);
        case 22:
            return $4d82739dd229d539$var$dj(a, b, c);
    }
    throw Error($4d82739dd229d539$var$p(156, b.tag));
};
function $4d82739dd229d539$var$Fk(a, b) {
    return $4d82739dd229d539$var$ac(a, b);
}
function $4d82739dd229d539$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $4d82739dd229d539$var$Bg(a, b, c, d) {
    return new $4d82739dd229d539$var$$k(a, b, c, d);
}
function $4d82739dd229d539$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $4d82739dd229d539$var$Zk(a) {
    if ("function" === typeof a) return $4d82739dd229d539$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $4d82739dd229d539$var$Da) return 11;
        if (a === $4d82739dd229d539$var$Ga) return 14;
    }
    return 2;
}
function $4d82739dd229d539$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $4d82739dd229d539$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $4d82739dd229d539$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $4d82739dd229d539$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $4d82739dd229d539$var$ya:
            return $4d82739dd229d539$var$Tg(c.children, e, f, b);
        case $4d82739dd229d539$var$za:
            g = 8;
            e |= 8;
            break;
        case $4d82739dd229d539$var$Aa:
            return a = $4d82739dd229d539$var$Bg(12, c, b, e | 2), a.elementType = $4d82739dd229d539$var$Aa, a.lanes = f, a;
        case $4d82739dd229d539$var$Ea:
            return a = $4d82739dd229d539$var$Bg(13, c, b, e), a.elementType = $4d82739dd229d539$var$Ea, a.lanes = f, a;
        case $4d82739dd229d539$var$Fa:
            return a = $4d82739dd229d539$var$Bg(19, c, b, e), a.elementType = $4d82739dd229d539$var$Fa, a.lanes = f, a;
        case $4d82739dd229d539$var$Ia:
            return $4d82739dd229d539$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $4d82739dd229d539$var$Ba:
                    g = 10;
                    break a;
                case $4d82739dd229d539$var$Ca:
                    g = 9;
                    break a;
                case $4d82739dd229d539$var$Da:
                    g = 11;
                    break a;
                case $4d82739dd229d539$var$Ga:
                    g = 14;
                    break a;
                case $4d82739dd229d539$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($4d82739dd229d539$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $4d82739dd229d539$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $4d82739dd229d539$var$Tg(a, b, c, d) {
    a = $4d82739dd229d539$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $4d82739dd229d539$var$pj(a, b, c, d) {
    a = $4d82739dd229d539$var$Bg(22, a, d, b);
    a.elementType = $4d82739dd229d539$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $4d82739dd229d539$var$Qg(a, b, c) {
    a = $4d82739dd229d539$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $4d82739dd229d539$var$Sg(a, b, c) {
    b = $4d82739dd229d539$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $4d82739dd229d539$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $4d82739dd229d539$var$zc(0);
    this.expirationTimes = $4d82739dd229d539$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $4d82739dd229d539$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $4d82739dd229d539$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $4d82739dd229d539$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $4d82739dd229d539$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $4d82739dd229d539$var$kh(f);
    return a;
}
function $4d82739dd229d539$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4d82739dd229d539$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $4d82739dd229d539$var$dl(a) {
    if (!a) return $4d82739dd229d539$var$Vf;
    a = a._reactInternals;
    a: {
        if ($4d82739dd229d539$var$Vb(a) !== a || 1 !== a.tag) throw Error($4d82739dd229d539$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($4d82739dd229d539$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($4d82739dd229d539$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($4d82739dd229d539$var$Zf(c)) return $4d82739dd229d539$var$bg(a, c, b);
    }
    return b;
}
function $4d82739dd229d539$var$el(a, b, c, d, e, f, g, h, k) {
    a = $4d82739dd229d539$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $4d82739dd229d539$var$dl(null);
    c = a.current;
    d = $4d82739dd229d539$var$R();
    e = $4d82739dd229d539$var$yi(c);
    f = $4d82739dd229d539$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $4d82739dd229d539$var$nh(c, f, e);
    a.current.lanes = e;
    $4d82739dd229d539$var$Ac(a, e, d);
    $4d82739dd229d539$var$Dk(a, d);
    return a;
}
function $4d82739dd229d539$var$fl(a, b, c, d) {
    var e = b.current, f = $4d82739dd229d539$var$R(), g = $4d82739dd229d539$var$yi(e);
    c = $4d82739dd229d539$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $4d82739dd229d539$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $4d82739dd229d539$var$nh(e, b, g);
    null !== a && ($4d82739dd229d539$var$gi(a, e, g, f), $4d82739dd229d539$var$oh(a, e, g));
    return g;
}
function $4d82739dd229d539$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $4d82739dd229d539$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $4d82739dd229d539$var$il(a, b) {
    $4d82739dd229d539$var$hl(a, b);
    (a = a.alternate) && $4d82739dd229d539$var$hl(a, b);
}
function $4d82739dd229d539$var$jl() {
    return null;
}
var $4d82739dd229d539$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $4d82739dd229d539$var$ll(a) {
    this._internalRoot = a;
}
$4d82739dd229d539$var$ml.prototype.render = $4d82739dd229d539$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($4d82739dd229d539$var$p(409));
    $4d82739dd229d539$var$fl(a, b, null, null);
};
$4d82739dd229d539$var$ml.prototype.unmount = $4d82739dd229d539$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $4d82739dd229d539$var$Rk(function() {
            $4d82739dd229d539$var$fl(null, a, null, null);
        });
        b[$4d82739dd229d539$var$uf] = null;
    }
};
function $4d82739dd229d539$var$ml(a) {
    this._internalRoot = a;
}
$4d82739dd229d539$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $4d82739dd229d539$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $4d82739dd229d539$var$Qc.length && 0 !== b && b < $4d82739dd229d539$var$Qc[c].priority; c++);
        $4d82739dd229d539$var$Qc.splice(c, 0, a);
        0 === c && $4d82739dd229d539$var$Vc(a);
    }
};
function $4d82739dd229d539$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $4d82739dd229d539$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $4d82739dd229d539$var$pl() {}
function $4d82739dd229d539$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $4d82739dd229d539$var$gl(g);
                f.call(a);
            };
        }
        var g = $4d82739dd229d539$var$el(b, d, a, 0, null, !1, !1, "", $4d82739dd229d539$var$pl);
        a._reactRootContainer = g;
        a[$4d82739dd229d539$var$uf] = g.current;
        $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
        $4d82739dd229d539$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $4d82739dd229d539$var$gl(k);
            h.call(a);
        };
    }
    var k = $4d82739dd229d539$var$bl(a, 0, !1, null, null, !1, !1, "", $4d82739dd229d539$var$pl);
    a._reactRootContainer = k;
    a[$4d82739dd229d539$var$uf] = k.current;
    $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
    $4d82739dd229d539$var$Rk(function() {
        $4d82739dd229d539$var$fl(b, k, c, d);
    });
    return k;
}
function $4d82739dd229d539$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $4d82739dd229d539$var$gl(g);
                h.call(a);
            };
        }
        $4d82739dd229d539$var$fl(b, g, a, e);
    } else g = $4d82739dd229d539$var$ql(c, b, a, e, d);
    return $4d82739dd229d539$var$gl(g);
}
$4d82739dd229d539$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $4d82739dd229d539$var$tc(b.pendingLanes);
                0 !== c && ($4d82739dd229d539$var$Cc(b, c | 1), $4d82739dd229d539$var$Dk(b, $4d82739dd229d539$var$B()), 0 === ($4d82739dd229d539$var$K & 6) && ($4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$jg()));
            }
            break;
        case 13:
            $4d82739dd229d539$var$Rk(function() {
                var b = $4d82739dd229d539$var$ih(a, 1);
                if (null !== b) {
                    var c = $4d82739dd229d539$var$R();
                    $4d82739dd229d539$var$gi(b, a, 1, c);
                }
            }), $4d82739dd229d539$var$il(a, 1);
    }
};
$4d82739dd229d539$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $4d82739dd229d539$var$ih(a, 134217728);
        if (null !== b) {
            var c = $4d82739dd229d539$var$R();
            $4d82739dd229d539$var$gi(b, a, 134217728, c);
        }
        $4d82739dd229d539$var$il(a, 134217728);
    }
};
$4d82739dd229d539$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $4d82739dd229d539$var$yi(a), c = $4d82739dd229d539$var$ih(a, b);
        if (null !== c) {
            var d = $4d82739dd229d539$var$R();
            $4d82739dd229d539$var$gi(c, a, b, d);
        }
        $4d82739dd229d539$var$il(a, b);
    }
};
$4d82739dd229d539$var$Hc = function() {
    return $4d82739dd229d539$var$C;
};
$4d82739dd229d539$var$Ic = function(a, b) {
    var c = $4d82739dd229d539$var$C;
    try {
        return $4d82739dd229d539$var$C = a, b();
    } finally{
        $4d82739dd229d539$var$C = c;
    }
};
$4d82739dd229d539$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $4d82739dd229d539$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $4d82739dd229d539$var$Db(d);
                        if (!e) throw Error($4d82739dd229d539$var$p(90));
                        $4d82739dd229d539$var$Wa(d);
                        $4d82739dd229d539$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $4d82739dd229d539$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $4d82739dd229d539$var$fb(a, !!c.multiple, b, !1);
    }
};
$4d82739dd229d539$var$Gb = $4d82739dd229d539$var$Qk;
$4d82739dd229d539$var$Hb = $4d82739dd229d539$var$Rk;
var $4d82739dd229d539$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $4d82739dd229d539$var$Cb,
        $4d82739dd229d539$var$ue,
        $4d82739dd229d539$var$Db,
        $4d82739dd229d539$var$Eb,
        $4d82739dd229d539$var$Fb,
        $4d82739dd229d539$var$Qk
    ]
}, $4d82739dd229d539$var$tl = {
    findFiberByHostInstance: $4d82739dd229d539$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $4d82739dd229d539$var$ul = {
    bundleType: $4d82739dd229d539$var$tl.bundleType,
    version: $4d82739dd229d539$var$tl.version,
    rendererPackageName: $4d82739dd229d539$var$tl.rendererPackageName,
    rendererConfig: $4d82739dd229d539$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $4d82739dd229d539$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $4d82739dd229d539$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $4d82739dd229d539$var$tl.findFiberByHostInstance || $4d82739dd229d539$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $4d82739dd229d539$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$4d82739dd229d539$var$vl.isDisabled && $4d82739dd229d539$var$vl.supportsFiber) try {
        $4d82739dd229d539$var$kc = $4d82739dd229d539$var$vl.inject($4d82739dd229d539$var$ul), $4d82739dd229d539$var$lc = $4d82739dd229d539$var$vl;
    } catch (a) {}
}
$4d82739dd229d539$export$ae55be85d98224ed = $4d82739dd229d539$var$sl;
$4d82739dd229d539$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$4d82739dd229d539$var$nl(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$cl(a, b, null, c);
};
$4d82739dd229d539$export$882461b6382ed46c = function(a, b) {
    if (!$4d82739dd229d539$var$nl(a)) throw Error($4d82739dd229d539$var$p(299));
    var c = !1, d = "", e = $4d82739dd229d539$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $4d82739dd229d539$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$4d82739dd229d539$var$uf] = b.current;
    $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $4d82739dd229d539$var$ll(b);
};
$4d82739dd229d539$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($4d82739dd229d539$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($4d82739dd229d539$var$p(268, a));
    }
    a = $4d82739dd229d539$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$4d82739dd229d539$export$cd75ccfd720a3cd4 = function(a) {
    return $4d82739dd229d539$var$Rk(a);
};
$4d82739dd229d539$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$4d82739dd229d539$var$ol(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$rl(null, a, b, !0, c);
};
$4d82739dd229d539$export$757ceba2d55c277e = function(a, b, c) {
    if (!$4d82739dd229d539$var$nl(a)) throw Error($4d82739dd229d539$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $4d82739dd229d539$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $4d82739dd229d539$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$4d82739dd229d539$var$uf] = b.current;
    $4d82739dd229d539$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $4d82739dd229d539$var$ml(b);
};
$4d82739dd229d539$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$4d82739dd229d539$var$ol(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$rl(null, a, b, !1, c);
};
$4d82739dd229d539$export$502457920280e6be = function(a) {
    if (!$4d82739dd229d539$var$ol(a)) throw Error($4d82739dd229d539$var$p(40));
    return a._reactRootContainer ? ($4d82739dd229d539$var$Rk(function() {
        $4d82739dd229d539$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$4d82739dd229d539$var$uf] = null;
        });
    }), !0) : !1;
};
$4d82739dd229d539$export$c78a37762a8d58e1 = $4d82739dd229d539$var$Qk;
$4d82739dd229d539$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$4d82739dd229d539$var$ol(c)) throw Error($4d82739dd229d539$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($4d82739dd229d539$var$p(38));
    return $4d82739dd229d539$var$rl(a, b, c, !1, d);
};
$4d82739dd229d539$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("33s19", function(module, exports) {
'use strict';

module.exports = (parcelRequire("a0C75"));

});
parcelRegister("a0C75", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $749777fefd570b40$export$c4744153514ff05d; }, function (v) { return $749777fefd570b40$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $749777fefd570b40$export$3e506c1ccc9cc1a7; }, function (v) { return $749777fefd570b40$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $749777fefd570b40$export$e26fe2ed2fa76875; }, function (v) { return $749777fefd570b40$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $749777fefd570b40$export$502329bbf4b505b1; }, function (v) { return $749777fefd570b40$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $749777fefd570b40$export$6e3807111c4874c4; }, function (v) { return $749777fefd570b40$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $749777fefd570b40$export$c27134553091fb3a; }, function (v) { return $749777fefd570b40$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $749777fefd570b40$export$33ee1acdc04fd2a2; }, function (v) { return $749777fefd570b40$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $749777fefd570b40$export$b00a404bbd5edef2; }, function (v) { return $749777fefd570b40$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $749777fefd570b40$export$8352ce38b91d0c62; }, function (v) { return $749777fefd570b40$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $749777fefd570b40$export$d66a1c1c77bd778b; }, function (v) { return $749777fefd570b40$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $749777fefd570b40$export$d3dfb8e4810cb555; }, function (v) { return $749777fefd570b40$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $749777fefd570b40$export$839f9183b0465a69; }, function (v) { return $749777fefd570b40$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $749777fefd570b40$export$72fdf0e06517287b; }, function (v) { return $749777fefd570b40$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $749777fefd570b40$export$4b844e58a3e414b4; }, function (v) { return $749777fefd570b40$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $749777fefd570b40$export$816d2913ae6b83b1; }, function (v) { return $749777fefd570b40$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $749777fefd570b40$export$61bcfe829111a1d0; }, function (v) { return $749777fefd570b40$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $749777fefd570b40$export$7ee8c9beb337bc3f; }, function (v) { return $749777fefd570b40$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $749777fefd570b40$export$b5836b71941fa3ed; }, function (v) { return $749777fefd570b40$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $749777fefd570b40$export$cf845f2c119da08a; }, function (v) { return $749777fefd570b40$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $749777fefd570b40$export$c4744153514ff05d;
var $749777fefd570b40$export$3e506c1ccc9cc1a7;
var $749777fefd570b40$export$e26fe2ed2fa76875;
var $749777fefd570b40$export$502329bbf4b505b1;
var $749777fefd570b40$export$6e3807111c4874c4;
var $749777fefd570b40$export$c27134553091fb3a;
var $749777fefd570b40$export$33ee1acdc04fd2a2;
var $749777fefd570b40$export$b00a404bbd5edef2;
var $749777fefd570b40$export$8352ce38b91d0c62;
var $749777fefd570b40$export$d66a1c1c77bd778b;
var $749777fefd570b40$export$d3dfb8e4810cb555;
var $749777fefd570b40$export$839f9183b0465a69;
var $749777fefd570b40$export$72fdf0e06517287b;
var $749777fefd570b40$export$4b844e58a3e414b4;
var $749777fefd570b40$export$816d2913ae6b83b1;
var $749777fefd570b40$export$61bcfe829111a1d0;
var $749777fefd570b40$export$7ee8c9beb337bc3f;
var $749777fefd570b40$export$b5836b71941fa3ed;
var $749777fefd570b40$export$cf845f2c119da08a;
'use strict';
function $749777fefd570b40$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $749777fefd570b40$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $749777fefd570b40$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $749777fefd570b40$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $749777fefd570b40$var$g(C, c)) n < e && 0 > $749777fefd570b40$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $749777fefd570b40$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $749777fefd570b40$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $749777fefd570b40$var$l = performance;
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$l.now();
    };
} else {
    var $749777fefd570b40$var$p = Date, $749777fefd570b40$var$q = $749777fefd570b40$var$p.now();
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$p.now() - $749777fefd570b40$var$q;
    };
}
var $749777fefd570b40$var$r = [], $749777fefd570b40$var$t = [], $749777fefd570b40$var$u = 1, $749777fefd570b40$var$v = null, $749777fefd570b40$var$y = 3, $749777fefd570b40$var$z = !1, $749777fefd570b40$var$A = !1, $749777fefd570b40$var$B = !1, $749777fefd570b40$var$D = "function" === typeof setTimeout ? setTimeout : null, $749777fefd570b40$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $749777fefd570b40$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $749777fefd570b40$var$G(a) {
    for(var b = $749777fefd570b40$var$h($749777fefd570b40$var$t); null !== b;){
        if (null === b.callback) $749777fefd570b40$var$k($749777fefd570b40$var$t);
        else if (b.startTime <= a) $749777fefd570b40$var$k($749777fefd570b40$var$t), b.sortIndex = b.expirationTime, $749777fefd570b40$var$f($749777fefd570b40$var$r, b);
        else break;
        b = $749777fefd570b40$var$h($749777fefd570b40$var$t);
    }
}
function $749777fefd570b40$var$H(a) {
    $749777fefd570b40$var$B = !1;
    $749777fefd570b40$var$G(a);
    if (!$749777fefd570b40$var$A) {
        if (null !== $749777fefd570b40$var$h($749777fefd570b40$var$r)) $749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J);
        else {
            var b = $749777fefd570b40$var$h($749777fefd570b40$var$t);
            null !== b && $749777fefd570b40$var$K($749777fefd570b40$var$H, b.startTime - a);
        }
    }
}
function $749777fefd570b40$var$J(a, b) {
    $749777fefd570b40$var$A = !1;
    $749777fefd570b40$var$B && ($749777fefd570b40$var$B = !1, $749777fefd570b40$var$E($749777fefd570b40$var$L), $749777fefd570b40$var$L = -1);
    $749777fefd570b40$var$z = !0;
    var c = $749777fefd570b40$var$y;
    try {
        $749777fefd570b40$var$G(b);
        for($749777fefd570b40$var$v = $749777fefd570b40$var$h($749777fefd570b40$var$r); null !== $749777fefd570b40$var$v && (!($749777fefd570b40$var$v.expirationTime > b) || a && !$749777fefd570b40$var$M());){
            var d = $749777fefd570b40$var$v.callback;
            if ("function" === typeof d) {
                $749777fefd570b40$var$v.callback = null;
                $749777fefd570b40$var$y = $749777fefd570b40$var$v.priorityLevel;
                var e = d($749777fefd570b40$var$v.expirationTime <= b);
                b = $749777fefd570b40$export$c4744153514ff05d();
                "function" === typeof e ? $749777fefd570b40$var$v.callback = e : $749777fefd570b40$var$v === $749777fefd570b40$var$h($749777fefd570b40$var$r) && $749777fefd570b40$var$k($749777fefd570b40$var$r);
                $749777fefd570b40$var$G(b);
            } else $749777fefd570b40$var$k($749777fefd570b40$var$r);
            $749777fefd570b40$var$v = $749777fefd570b40$var$h($749777fefd570b40$var$r);
        }
        if (null !== $749777fefd570b40$var$v) var w = !0;
        else {
            var m = $749777fefd570b40$var$h($749777fefd570b40$var$t);
            null !== m && $749777fefd570b40$var$K($749777fefd570b40$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $749777fefd570b40$var$v = null, $749777fefd570b40$var$y = c, $749777fefd570b40$var$z = !1;
    }
}
var $749777fefd570b40$var$N = !1, $749777fefd570b40$var$O = null, $749777fefd570b40$var$L = -1, $749777fefd570b40$var$P = 5, $749777fefd570b40$var$Q = -1;
function $749777fefd570b40$var$M() {
    return $749777fefd570b40$export$c4744153514ff05d() - $749777fefd570b40$var$Q < $749777fefd570b40$var$P ? !1 : !0;
}
function $749777fefd570b40$var$R() {
    if (null !== $749777fefd570b40$var$O) {
        var a = $749777fefd570b40$export$c4744153514ff05d();
        $749777fefd570b40$var$Q = a;
        var b = !0;
        try {
            b = $749777fefd570b40$var$O(!0, a);
        } finally{
            b ? $749777fefd570b40$var$S() : ($749777fefd570b40$var$N = !1, $749777fefd570b40$var$O = null);
        }
    } else $749777fefd570b40$var$N = !1;
}
var $749777fefd570b40$var$S;
if ("function" === typeof $749777fefd570b40$var$F) $749777fefd570b40$var$S = function() {
    $749777fefd570b40$var$F($749777fefd570b40$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $749777fefd570b40$var$T = new MessageChannel, $749777fefd570b40$var$U = $749777fefd570b40$var$T.port2;
    $749777fefd570b40$var$T.port1.onmessage = $749777fefd570b40$var$R;
    $749777fefd570b40$var$S = function() {
        $749777fefd570b40$var$U.postMessage(null);
    };
} else $749777fefd570b40$var$S = function() {
    $749777fefd570b40$var$D($749777fefd570b40$var$R, 0);
};
function $749777fefd570b40$var$I(a) {
    $749777fefd570b40$var$O = a;
    $749777fefd570b40$var$N || ($749777fefd570b40$var$N = !0, $749777fefd570b40$var$S());
}
function $749777fefd570b40$var$K(a, b) {
    $749777fefd570b40$var$L = $749777fefd570b40$var$D(function() {
        a($749777fefd570b40$export$c4744153514ff05d());
    }, b);
}
$749777fefd570b40$export$3e506c1ccc9cc1a7 = 5;
$749777fefd570b40$export$e26fe2ed2fa76875 = 1;
$749777fefd570b40$export$502329bbf4b505b1 = 4;
$749777fefd570b40$export$6e3807111c4874c4 = 3;
$749777fefd570b40$export$c27134553091fb3a = null;
$749777fefd570b40$export$33ee1acdc04fd2a2 = 2;
$749777fefd570b40$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$749777fefd570b40$export$8352ce38b91d0c62 = function() {
    $749777fefd570b40$var$A || $749777fefd570b40$var$z || ($749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J));
};
$749777fefd570b40$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $749777fefd570b40$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$749777fefd570b40$export$d3dfb8e4810cb555 = function() {
    return $749777fefd570b40$var$y;
};
$749777fefd570b40$export$839f9183b0465a69 = function() {
    return $749777fefd570b40$var$h($749777fefd570b40$var$r);
};
$749777fefd570b40$export$72fdf0e06517287b = function(a) {
    switch($749777fefd570b40$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $749777fefd570b40$var$y;
    }
    var c = $749777fefd570b40$var$y;
    $749777fefd570b40$var$y = b;
    try {
        return a();
    } finally{
        $749777fefd570b40$var$y = c;
    }
};
$749777fefd570b40$export$4b844e58a3e414b4 = function() {};
$749777fefd570b40$export$816d2913ae6b83b1 = function() {};
$749777fefd570b40$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $749777fefd570b40$var$y;
    $749777fefd570b40$var$y = a;
    try {
        return b();
    } finally{
        $749777fefd570b40$var$y = c;
    }
};
$749777fefd570b40$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $749777fefd570b40$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $749777fefd570b40$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $749777fefd570b40$var$f($749777fefd570b40$var$t, a), null === $749777fefd570b40$var$h($749777fefd570b40$var$r) && a === $749777fefd570b40$var$h($749777fefd570b40$var$t) && ($749777fefd570b40$var$B ? ($749777fefd570b40$var$E($749777fefd570b40$var$L), $749777fefd570b40$var$L = -1) : $749777fefd570b40$var$B = !0, $749777fefd570b40$var$K($749777fefd570b40$var$H, c - d))) : (a.sortIndex = e, $749777fefd570b40$var$f($749777fefd570b40$var$r, a), $749777fefd570b40$var$A || $749777fefd570b40$var$z || ($749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J)));
    return a;
};
$749777fefd570b40$export$b5836b71941fa3ed = $749777fefd570b40$var$M;
$749777fefd570b40$export$cf845f2c119da08a = function(a) {
    var b = $749777fefd570b40$var$y;
    return function() {
        var c = $749777fefd570b40$var$y;
        $749777fefd570b40$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $749777fefd570b40$var$y = c;
        }
    };
};

});



parcelRegister("gzcup", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("diYUK")).default; });

var $diYUK = parcelRequire("diYUK");

});
parcelRegister("diYUK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9afc3518733c6a5e$export$2e2bcd8739ae039; });
/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/internal-babel-macros/MuiError.macro` instead.
 * @param {number} code
 */ function $9afc3518733c6a5e$export$2e2bcd8739ae039(code) {
    // Apply babel-plugin-transform-template-literals in loose mode
    // loose mode is safe if we're concatenating primitives
    // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose
    /* eslint-disable prefer-template */ let url = 'https://mui.com/production-error/?code=' + code;
    for(let i = 1; i < arguments.length; i += 1)// rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
    return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
/* eslint-enable prefer-template */ }

});


parcelRegister("8m7yE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("5mrJy")).default; });

var $5mrJy = parcelRequire("5mrJy");

});
parcelRegister("5mrJy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3e74852d812b8b64$export$2e2bcd8739ae039; });
function $3e74852d812b8b64$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $3e74852d812b8b64$export$2e2bcd8739ae039 = $3e74852d812b8b64$var$clamp;

});


parcelRegister("3oWWu", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $27a155bcdd967657$export$2b8d127b894957b9; }, function (v) { return $27a155bcdd967657$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $27a155bcdd967657$export$cea3a54a6425200c; }, function (v) { return $27a155bcdd967657$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $27a155bcdd967657$export$a7c73072b1a182ae; }, function (v) { return $27a155bcdd967657$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $27a155bcdd967657$export$9f27bc3417b4524d; }, function (v) { return $27a155bcdd967657$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $27a155bcdd967657$export$db77ccec0bb4ccac; }, function (v) { return $27a155bcdd967657$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $27a155bcdd967657$export$8392c0c9d3dcbd35; }, function (v) { return $27a155bcdd967657$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $27a155bcdd967657$export$ffb0004e005737fa; }, function (v) { return $27a155bcdd967657$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $27a155bcdd967657$export$b624eff549462981; }, function (v) { return $27a155bcdd967657$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $27a155bcdd967657$export$7897aa7841a5380c; }, function (v) { return $27a155bcdd967657$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $27a155bcdd967657$export$602eac185826482c; }, function (v) { return $27a155bcdd967657$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $27a155bcdd967657$export$e2c29f18771995cb; }, function (v) { return $27a155bcdd967657$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $27a155bcdd967657$export$5f8d39834fd61797; }, function (v) { return $27a155bcdd967657$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $27a155bcdd967657$export$74bf444e3cd11ea5; }, function (v) { return $27a155bcdd967657$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $27a155bcdd967657$export$92387174baf9b227; }, function (v) { return $27a155bcdd967657$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $27a155bcdd967657$export$ec112efeb987d9c6; }, function (v) { return $27a155bcdd967657$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $27a155bcdd967657$export$b706b080d889d2c9; }, function (v) { return $27a155bcdd967657$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $27a155bcdd967657$export$5be5a87408f70ddc; }, function (v) { return $27a155bcdd967657$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $27a155bcdd967657$export$45a5e7f76e0caa8d; }, function (v) { return $27a155bcdd967657$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $27a155bcdd967657$export$455c2e768291efa6; }, function (v) { return $27a155bcdd967657$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $27a155bcdd967657$export$9522e17588c12572; }, function (v) { return $27a155bcdd967657$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $27a155bcdd967657$export$2110ac352bb060b9; }, function (v) { return $27a155bcdd967657$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $27a155bcdd967657$export$56885ab8b9c456ab; }, function (v) { return $27a155bcdd967657$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $27a155bcdd967657$export$d927fcb6adf8f9de; }, function (v) { return $27a155bcdd967657$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $27a155bcdd967657$export$b82d16f27459e05a; }, function (v) { return $27a155bcdd967657$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $27a155bcdd967657$export$522c17b4f5e123e8; }, function (v) { return $27a155bcdd967657$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $27a155bcdd967657$export$1aabd8a0274ecfd6; }, function (v) { return $27a155bcdd967657$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $27a155bcdd967657$export$9b621391a187a31a; }, function (v) { return $27a155bcdd967657$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $27a155bcdd967657$export$f5bbd400c2f4426f; }, function (v) { return $27a155bcdd967657$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $27a155bcdd967657$export$2b8d127b894957b9;
var $27a155bcdd967657$export$cea3a54a6425200c;
var $27a155bcdd967657$export$a7c73072b1a182ae;
var $27a155bcdd967657$export$9f27bc3417b4524d;
var $27a155bcdd967657$export$db77ccec0bb4ccac;
var $27a155bcdd967657$export$8392c0c9d3dcbd35;
var $27a155bcdd967657$export$ffb0004e005737fa;
var $27a155bcdd967657$export$b624eff549462981;
var $27a155bcdd967657$export$7897aa7841a5380c;
var $27a155bcdd967657$export$602eac185826482c;
var $27a155bcdd967657$export$e2c29f18771995cb;
var $27a155bcdd967657$export$5f8d39834fd61797;
var $27a155bcdd967657$export$74bf444e3cd11ea5;
var $27a155bcdd967657$export$92387174baf9b227;
var $27a155bcdd967657$export$ec112efeb987d9c6;
var $27a155bcdd967657$export$b706b080d889d2c9;
var $27a155bcdd967657$export$5be5a87408f70ddc;
var $27a155bcdd967657$export$45a5e7f76e0caa8d;
var $27a155bcdd967657$export$455c2e768291efa6;
var $27a155bcdd967657$export$9522e17588c12572;
var $27a155bcdd967657$export$2110ac352bb060b9;
var $27a155bcdd967657$export$56885ab8b9c456ab;
var $27a155bcdd967657$export$d927fcb6adf8f9de;
var $27a155bcdd967657$export$b82d16f27459e05a;
var $27a155bcdd967657$export$522c17b4f5e123e8;
var $27a155bcdd967657$export$1aabd8a0274ecfd6;
var $27a155bcdd967657$export$9b621391a187a31a;
var $27a155bcdd967657$export$f5bbd400c2f4426f;
'use strict';
var $27a155bcdd967657$var$b = "function" === typeof Symbol && Symbol.for, $27a155bcdd967657$var$c = $27a155bcdd967657$var$b ? Symbol.for("react.element") : 60103, $27a155bcdd967657$var$d = $27a155bcdd967657$var$b ? Symbol.for("react.portal") : 60106, $27a155bcdd967657$var$e = $27a155bcdd967657$var$b ? Symbol.for("react.fragment") : 60107, $27a155bcdd967657$var$f = $27a155bcdd967657$var$b ? Symbol.for("react.strict_mode") : 60108, $27a155bcdd967657$var$g = $27a155bcdd967657$var$b ? Symbol.for("react.profiler") : 60114, $27a155bcdd967657$var$h = $27a155bcdd967657$var$b ? Symbol.for("react.provider") : 60109, $27a155bcdd967657$var$k = $27a155bcdd967657$var$b ? Symbol.for("react.context") : 60110, $27a155bcdd967657$var$l = $27a155bcdd967657$var$b ? Symbol.for("react.async_mode") : 60111, $27a155bcdd967657$var$m = $27a155bcdd967657$var$b ? Symbol.for("react.concurrent_mode") : 60111, $27a155bcdd967657$var$n = $27a155bcdd967657$var$b ? Symbol.for("react.forward_ref") : 60112, $27a155bcdd967657$var$p = $27a155bcdd967657$var$b ? Symbol.for("react.suspense") : 60113, $27a155bcdd967657$var$q = $27a155bcdd967657$var$b ? Symbol.for("react.suspense_list") : 60120, $27a155bcdd967657$var$r = $27a155bcdd967657$var$b ? Symbol.for("react.memo") : 60115, $27a155bcdd967657$var$t = $27a155bcdd967657$var$b ? Symbol.for("react.lazy") : 60116, $27a155bcdd967657$var$v = $27a155bcdd967657$var$b ? Symbol.for("react.block") : 60121, $27a155bcdd967657$var$w = $27a155bcdd967657$var$b ? Symbol.for("react.fundamental") : 60117, $27a155bcdd967657$var$x = $27a155bcdd967657$var$b ? Symbol.for("react.responder") : 60118, $27a155bcdd967657$var$y = $27a155bcdd967657$var$b ? Symbol.for("react.scope") : 60119;
function $27a155bcdd967657$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $27a155bcdd967657$var$c:
                switch(a = a.type, a){
                    case $27a155bcdd967657$var$l:
                    case $27a155bcdd967657$var$m:
                    case $27a155bcdd967657$var$e:
                    case $27a155bcdd967657$var$g:
                    case $27a155bcdd967657$var$f:
                    case $27a155bcdd967657$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $27a155bcdd967657$var$k:
                            case $27a155bcdd967657$var$n:
                            case $27a155bcdd967657$var$t:
                            case $27a155bcdd967657$var$r:
                            case $27a155bcdd967657$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $27a155bcdd967657$var$d:
                return u;
        }
    }
}
function $27a155bcdd967657$var$A(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$m;
}
$27a155bcdd967657$export$2b8d127b894957b9 = $27a155bcdd967657$var$l;
$27a155bcdd967657$export$cea3a54a6425200c = $27a155bcdd967657$var$m;
$27a155bcdd967657$export$a7c73072b1a182ae = $27a155bcdd967657$var$k;
$27a155bcdd967657$export$9f27bc3417b4524d = $27a155bcdd967657$var$h;
$27a155bcdd967657$export$db77ccec0bb4ccac = $27a155bcdd967657$var$c;
$27a155bcdd967657$export$8392c0c9d3dcbd35 = $27a155bcdd967657$var$n;
$27a155bcdd967657$export$ffb0004e005737fa = $27a155bcdd967657$var$e;
$27a155bcdd967657$export$b624eff549462981 = $27a155bcdd967657$var$t;
$27a155bcdd967657$export$7897aa7841a5380c = $27a155bcdd967657$var$r;
$27a155bcdd967657$export$602eac185826482c = $27a155bcdd967657$var$d;
$27a155bcdd967657$export$e2c29f18771995cb = $27a155bcdd967657$var$g;
$27a155bcdd967657$export$5f8d39834fd61797 = $27a155bcdd967657$var$f;
$27a155bcdd967657$export$74bf444e3cd11ea5 = $27a155bcdd967657$var$p;
$27a155bcdd967657$export$92387174baf9b227 = function(a) {
    return $27a155bcdd967657$var$A(a) || $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$l;
};
$27a155bcdd967657$export$ec112efeb987d9c6 = $27a155bcdd967657$var$A;
$27a155bcdd967657$export$b706b080d889d2c9 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$k;
};
$27a155bcdd967657$export$5be5a87408f70ddc = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$h;
};
$27a155bcdd967657$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $27a155bcdd967657$var$c;
};
$27a155bcdd967657$export$455c2e768291efa6 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$n;
};
$27a155bcdd967657$export$9522e17588c12572 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$e;
};
$27a155bcdd967657$export$2110ac352bb060b9 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$t;
};
$27a155bcdd967657$export$56885ab8b9c456ab = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$r;
};
$27a155bcdd967657$export$d927fcb6adf8f9de = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$d;
};
$27a155bcdd967657$export$b82d16f27459e05a = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$g;
};
$27a155bcdd967657$export$522c17b4f5e123e8 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$f;
};
$27a155bcdd967657$export$1aabd8a0274ecfd6 = function(a) {
    return $27a155bcdd967657$var$z(a) === $27a155bcdd967657$var$p;
};
$27a155bcdd967657$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $27a155bcdd967657$var$e || a === $27a155bcdd967657$var$m || a === $27a155bcdd967657$var$g || a === $27a155bcdd967657$var$f || a === $27a155bcdd967657$var$p || a === $27a155bcdd967657$var$q || "object" === typeof a && null !== a && (a.$$typeof === $27a155bcdd967657$var$t || a.$$typeof === $27a155bcdd967657$var$r || a.$$typeof === $27a155bcdd967657$var$h || a.$$typeof === $27a155bcdd967657$var$k || a.$$typeof === $27a155bcdd967657$var$n || a.$$typeof === $27a155bcdd967657$var$w || a.$$typeof === $27a155bcdd967657$var$x || a.$$typeof === $27a155bcdd967657$var$y || a.$$typeof === $27a155bcdd967657$var$v);
};
$27a155bcdd967657$export$f5bbd400c2f4426f = $27a155bcdd967657$var$z;

});

parcelRegister("cvBp9", function(module, exports) {
function $91b5651481cc9d5c$var$_extends() {
    return module.exports = $91b5651481cc9d5c$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $91b5651481cc9d5c$var$_extends.apply(null, arguments);
}
module.exports = $91b5651481cc9d5c$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5VCcJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $450fe936b88a7a32$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "internal_processStyles", function () { return $450fe936b88a7a32$export$e00380445f2b9e0c; });
$parcel$export(module.exports, "internal_serializeStyles", function () { return $450fe936b88a7a32$export$13a2d3ef13012b32; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("6te04")).T; });
$parcel$export(module.exports, "keyframes", function () { return (parcelRequire("5nUae")).keyframes; });
$parcel$export(module.exports, "css", function () { return (parcelRequire("5nUae")).css; });
$parcel$export(module.exports, "StyledEngineProvider", function () { return (parcelRequire("e6xq6")).default; });
$parcel$export(module.exports, "GlobalStyles", function () { return (parcelRequire("5tMhb")).default; });
/**
 * @mui/styled-engine v5.18.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $70jUf = parcelRequire("70jUf");

var $6lPck = parcelRequire("6lPck");
parcelRequire("5nUae");
var $6te04 = parcelRequire("6te04");
var $5nUae = parcelRequire("5nUae");

var $e6xq6 = parcelRequire("e6xq6");

var $5tMhb = parcelRequire("5tMhb");
'use client';
function $450fe936b88a7a32$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $70jUf.default)(tag, options);
    var styles, style;
    return stylesFactory;
}
const $450fe936b88a7a32$export$e00380445f2b9e0c = (tag, processor)=>{
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
};
// Emotion only accepts an array, but we want to avoid allocations
const $450fe936b88a7a32$var$wrapper = [];
function $450fe936b88a7a32$export$13a2d3ef13012b32(styles) {
    $450fe936b88a7a32$var$wrapper[0] = styles;
    return (0, $6lPck.serializeStyles)($450fe936b88a7a32$var$wrapper);
}

});
parcelRegister("70jUf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5197f9709daec52b$export$2e2bcd8739ae039; });

var $lmsDT = parcelRequire("lmsDT");
parcelRequire("cvBp9");

parcelRequire("6lPck");
parcelRequire("9uXao");
parcelRequire("80dPg");
parcelRequire("7fPBF");
parcelRequire("9YmaI");
var $5197f9709daec52b$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $5197f9709daec52b$export$2e2bcd8739ae039 = (0, $lmsDT.default).bind(null);
$5197f9709daec52b$var$tags.forEach(function(tagName) {
    $5197f9709daec52b$export$2e2bcd8739ae039[tagName] = $5197f9709daec52b$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("lmsDT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8d1dedc3623dfeb$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");
parcelRequire("5nUae");
var $6te04 = parcelRequire("6te04");

var $6lPck = parcelRequire("6lPck");

var $9uXao = parcelRequire("9uXao");

var $80dPg = parcelRequire("80dPg");

var $7fPBF = parcelRequire("7fPBF");

var $9YmaI = parcelRequire("9YmaI");
var $f8d1dedc3623dfeb$var$isBrowser = typeof document !== 'undefined';
var $f8d1dedc3623dfeb$var$isDevelopment = false;
var $f8d1dedc3623dfeb$var$testOmitPropsOnStringTag = (0, $9YmaI.default);
var $f8d1dedc3623dfeb$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $f8d1dedc3623dfeb$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $f8d1dedc3623dfeb$var$testOmitPropsOnStringTag : $f8d1dedc3623dfeb$var$testOmitPropsOnComponent;
};
var $f8d1dedc3623dfeb$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $f8d1dedc3623dfeb$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $80dPg.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $9uXao.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $80dPg.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$f8d1dedc3623dfeb$var$isBrowser && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $7fPBF.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $f8d1dedc3623dfeb$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $f8d1dedc3623dfeb$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $f8d1dedc3623dfeb$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $6te04.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $7fPBF.useContext((0, $6te04.T));
            }
            if (typeof props.className === 'string') className = (0, $80dPg.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $6lPck.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $f8d1dedc3623dfeb$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($f8d1dedc3623dfeb$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $7fPBF.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $f8d1dedc3623dfeb$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $kY3Ke.default)({}, options, nextOptions, {
                shouldForwardProp: $f8d1dedc3623dfeb$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("kY3Ke", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f43c50d92a19d876$export$2e2bcd8739ae039; });
function $f43c50d92a19d876$export$2e2bcd8739ae039() {
    return $f43c50d92a19d876$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f43c50d92a19d876$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("5nUae", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $3ebaaabf76fb5db5$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $3ebaaabf76fb5db5$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $3ebaaabf76fb5db5$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("6te04")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("6te04")).w; });

var $6te04 = parcelRequire("6te04");

var $7fPBF = parcelRequire("7fPBF");

var $80dPg = parcelRequire("80dPg");

var $9uXao = parcelRequire("9uXao");

var $6lPck = parcelRequire("6lPck");
parcelRequire("3mESc");
parcelRequire("cvBp9");
parcelRequire("lT6zG");

parcelRequire("8Ae2G");
var $3ebaaabf76fb5db5$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $6te04.h).call(props, 'css')) return $7fPBF.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $6te04.E);
    createElementArgArray[1] = (0, $6te04.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $7fPBF.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($3ebaaabf76fb5db5$export$c8a8987d4410bf2d || ($3ebaaabf76fb5db5$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $3ebaaabf76fb5db5$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $6te04.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $6lPck.serializeStyles)([
        styles
    ], undefined, $7fPBF.useContext((0, $6te04.T)));
    if (!(0, $6te04.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $7fPBF.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $7fPBF.useRef();
    (0, $9uXao.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $9uXao.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $80dPg.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $3ebaaabf76fb5db5$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $6lPck.serializeStyles)(args);
}
function $3ebaaabf76fb5db5$export$d25ddfdf17c3ad3e() {
    var insertable = $3ebaaabf76fb5db5$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $3ebaaabf76fb5db5$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $3ebaaabf76fb5db5$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $80dPg.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $3ebaaabf76fb5db5$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    var rules = (0, $9uXao.useInsertionEffectAlwaysWithSyncFallback)(function() {
        var rules = '';
        for(var i = 0; i < serializedArr.length; i++){
            var res = (0, $80dPg.insertStyles)(cache, serializedArr[i], false);
            if (!(0, $6te04.i) && res !== undefined) rules += res;
        }
        if (!(0, $6te04.i)) return rules;
    });
    if (!(0, $6te04.i) && rules.length !== 0) {
        var _ref2;
        return /*#__PURE__*/ $7fPBF.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedArr.map(function(serialized) {
            return serialized.name;
        }).join(' '), _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $3ebaaabf76fb5db5$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $6te04.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $6te04.a)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $6lPck.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $80dPg.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $6te04.a)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $3ebaaabf76fb5db5$var$merge(cache.registered, css, $3ebaaabf76fb5db5$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $7fPBF.useContext((0, $6te04.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($3ebaaabf76fb5db5$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});

});
parcelRegister("6te04", function(module, exports) {

$parcel$export(module.exports, "a", function () { return $4b604f9ff2f6f5b8$export$407448d2b89b1813; });
$parcel$export(module.exports, "i", function () { return $4b604f9ff2f6f5b8$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "C", function () { return $4b604f9ff2f6f5b8$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $4b604f9ff2f6f5b8$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $4b604f9ff2f6f5b8$export$971d5caa766a69d7; });
$parcel$export(module.exports, "h", function () { return $4b604f9ff2f6f5b8$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "c", function () { return $4b604f9ff2f6f5b8$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $4b604f9ff2f6f5b8$export$a9c23c6ac3fc3eca; });

var $7fPBF = parcelRequire("7fPBF");

var $3mESc = parcelRequire("3mESc");

var $kY3Ke = parcelRequire("kY3Ke");

var $lT6zG = parcelRequire("lT6zG");

var $10FT7 = parcelRequire("10FT7");

var $80dPg = parcelRequire("80dPg");

var $6lPck = parcelRequire("6lPck");

var $9uXao = parcelRequire("9uXao");
var $4b604f9ff2f6f5b8$export$407448d2b89b1813 = false;
var $4b604f9ff2f6f5b8$export$23f2a1d2818174ef = typeof document !== 'undefined';
var $4b604f9ff2f6f5b8$var$EmotionCacheContext = /* #__PURE__ */ $7fPBF.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $3mESc.default)({
    key: 'css'
}) : null);
var $4b604f9ff2f6f5b8$export$e7094788287c5e9b = $4b604f9ff2f6f5b8$var$EmotionCacheContext.Provider;
var $4b604f9ff2f6f5b8$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $7fPBF.useContext)($4b604f9ff2f6f5b8$var$EmotionCacheContext);
};
var $4b604f9ff2f6f5b8$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $7fPBF.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $7fPBF.useContext)($4b604f9ff2f6f5b8$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$4b604f9ff2f6f5b8$export$23f2a1d2818174ef) $4b604f9ff2f6f5b8$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $7fPBF.useContext)($4b604f9ff2f6f5b8$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $3mESc.default)({
                key: 'css'
            });
            return /*#__PURE__*/ $7fPBF.createElement($4b604f9ff2f6f5b8$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $4b604f9ff2f6f5b8$export$971d5caa766a69d7 = /* #__PURE__ */ $7fPBF.createContext({});
var $4b604f9ff2f6f5b8$export$3b14a55fb2447963 = function useTheme() {
    return $7fPBF.useContext($4b604f9ff2f6f5b8$export$971d5caa766a69d7);
};
var $4b604f9ff2f6f5b8$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $kY3Ke.default)({}, outerTheme, theme);
};
var $4b604f9ff2f6f5b8$var$createCacheWithTheme = /* #__PURE__ */ (0, $lT6zG.default)(function(outerTheme) {
    return (0, $lT6zG.default)(function(theme) {
        return $4b604f9ff2f6f5b8$var$getTheme(outerTheme, theme);
    });
});
var $4b604f9ff2f6f5b8$export$8b22cf2602fb60ce = function ThemeProvider(props) {
    var theme = $7fPBF.useContext($4b604f9ff2f6f5b8$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $4b604f9ff2f6f5b8$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $7fPBF.createElement($4b604f9ff2f6f5b8$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $4b604f9ff2f6f5b8$export$4368d992c4eafac0(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $7fPBF.forwardRef(function render(props, ref) {
        var theme = $7fPBF.useContext($4b604f9ff2f6f5b8$export$971d5caa766a69d7);
        return /*#__PURE__*/ $7fPBF.createElement(Component, (0, $kY3Ke.default)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $10FT7.default)(WithTheme, Component);
}
var $4b604f9ff2f6f5b8$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $4b604f9ff2f6f5b8$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $4b604f9ff2f6f5b8$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($4b604f9ff2f6f5b8$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$4b604f9ff2f6f5b8$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $4b604f9ff2f6f5b8$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $80dPg.registerStyles)(cache, serialized, isStringTag);
    var rules = (0, $9uXao.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $80dPg.insertStyles)(cache, serialized, isStringTag);
    });
    if (!$4b604f9ff2f6f5b8$export$23f2a1d2818174ef && rules !== undefined) {
        var _ref2;
        var serializedNames = serialized.name;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            next = next.next;
        }
        return /*#__PURE__*/ $7fPBF.createElement("style", (_ref2 = {}, _ref2["data-emotion"] = cache.key + " " + serializedNames, _ref2.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref2.nonce = cache.sheet.nonce, _ref2));
    }
    return null;
};
var $4b604f9ff2f6f5b8$var$Emotion = /* #__PURE__ */ $4b604f9ff2f6f5b8$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$4b604f9ff2f6f5b8$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $80dPg.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $6lPck.serializeStyles)(registeredStyles, undefined, $7fPBF.useContext($4b604f9ff2f6f5b8$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($4b604f9ff2f6f5b8$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $4b604f9ff2f6f5b8$var$typePropName && !$4b604f9ff2f6f5b8$export$407448d2b89b1813) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($4b604f9ff2f6f5b8$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $7fPBF.createElement(WrappedComponent, newProps));
});
var $4b604f9ff2f6f5b8$export$a9c23c6ac3fc3eca = $4b604f9ff2f6f5b8$var$Emotion;

});
parcelRegister("3mESc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $273321b94be832ab$export$2e2bcd8739ae039; });

var $4cVy4 = parcelRequire("4cVy4");

var $cByrN = parcelRequire("cByrN");

var $lT6zG = parcelRequire("lT6zG");

var $4AWAi = parcelRequire("4AWAi");
var $273321b94be832ab$var$isBrowser = typeof document !== 'undefined';
var $273321b94be832ab$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $cByrN.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $cByrN.token)(character)) break;
        (0, $cByrN.next)();
    }
    return (0, $cByrN.slice)(begin, (0, $cByrN.position));
};
var $273321b94be832ab$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $cByrN.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $cByrN.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $273321b94be832ab$var$identifierWithPointTracking((0, $cByrN.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $cByrN.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $cByrN.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $cByrN.from)(character);
    }
    while (character = (0, $cByrN.next)());
    return parsed;
};
var $273321b94be832ab$var$getRules = function getRules(value, points) {
    return (0, $cByrN.dealloc)($273321b94be832ab$var$toRules((0, $cByrN.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $273321b94be832ab$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $273321b94be832ab$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$273321b94be832ab$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $273321b94be832ab$var$fixedElements.set(element, true);
    var points = [];
    var rules = $273321b94be832ab$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $273321b94be832ab$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $273321b94be832ab$var$prefix(value, length) {
    switch((0, $cByrN.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $cByrN.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $cByrN.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MOZ) + value + (0, $cByrN.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + value + value;
        // order
        case 6165:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.replace)(value, /(\w+).+(:[^]+)/, (0, $cByrN.WEBKIT) + 'box-$1$2' + (0, $cByrN.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + 'flex-item-' + (0, $cByrN.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + 'flex-line-pack' + (0, $cByrN.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $cByrN.WEBKIT) + 'box-' + (0, $cByrN.replace)(value, '-grow', '') + (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $cByrN.WEBKIT) + (0, $cByrN.replace)(value, /([^-])(transform)/g, '$1' + (0, $cByrN.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $cByrN.replace)((0, $cByrN.replace)((0, $cByrN.replace)(value, /(zoom-|grab)/, (0, $cByrN.WEBKIT) + '$1'), /(image-set)/, (0, $cByrN.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $cByrN.replace)(value, /(image-set\([^]*)/, (0, $cByrN.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $cByrN.replace)((0, $cByrN.replace)(value, /(.+:)(flex-)?(.*)/, (0, $cByrN.WEBKIT) + 'box-pack:$3' + (0, $cByrN.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $cByrN.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $cByrN.replace)(value, /(.+)-inline(.+)/, (0, $cByrN.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $cByrN.strlen)(value) - 1 - length > 6) switch((0, $cByrN.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $cByrN.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $cByrN.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $cByrN.WEBKIT) + '$2-$3' + '$1' + (0, $cByrN.MOZ) + ((0, $cByrN.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $cByrN.indexof)(value, 'stretch') ? $273321b94be832ab$var$prefix((0, $cByrN.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $cByrN.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $cByrN.charat)(value, (0, $cByrN.strlen)(value) - 3 - (~(0, $cByrN.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $cByrN.replace)(value, ':', ':' + (0, $cByrN.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $cByrN.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $cByrN.WEBKIT) + ((0, $cByrN.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $cByrN.WEBKIT) + '$2$3' + '$1' + (0, $cByrN.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $cByrN.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + (0, $cByrN.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $cByrN.WEBKIT) + value + (0, $cByrN.MS) + value + value;
    }
    return value;
}
var $273321b94be832ab$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $cByrN.DECLARATION:
                element["return"] = $273321b94be832ab$var$prefix(element.value, element.length);
                break;
            case 0, $cByrN.KEYFRAMES:
                return (0, $cByrN.serialize)([
                    (0, $cByrN.copy)(element, {
                        value: (0, $cByrN.replace)(element.value, '@', '@' + (0, $cByrN.WEBKIT))
                    })
                ], callback);
            case 0, $cByrN.RULESET:
                if (element.length) return (0, $cByrN.combine)(element.props, function(value) {
                    switch((0, $cByrN.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $cByrN.serialize)([
                                (0, $cByrN.copy)(element, {
                                    props: [
                                        (0, $cByrN.replace)(value, /:(read-\w+)/, ':' + (0, $cByrN.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $cByrN.serialize)([
                                (0, $cByrN.copy)(element, {
                                    props: [
                                        (0, $cByrN.replace)(value, /:(plac\w+)/, ':' + (0, $cByrN.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $cByrN.copy)(element, {
                                    props: [
                                        (0, $cByrN.replace)(value, /:(plac\w+)/, ':' + (0, $cByrN.MOZ) + '$1')
                                    ]
                                }),
                                (0, $cByrN.copy)(element, {
                                    props: [
                                        (0, $cByrN.replace)(value, /:(plac\w+)/, (0, $cByrN.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $273321b94be832ab$var$getServerStylisCache = $273321b94be832ab$var$isBrowser ? undefined : (0, $lT6zG.default)(function() {
    return (0, $4AWAi.default)(function() {
        return {};
    });
});
var $273321b94be832ab$var$defaultStylisPlugins = [
    $273321b94be832ab$var$prefixer
];
var $273321b94be832ab$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if ($273321b94be832ab$var$isBrowser && key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $273321b94be832ab$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    if ($273321b94be832ab$var$isBrowser) {
        container = options.container || document.head;
        Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
        document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
            var attrib = node.getAttribute("data-emotion").split(' ');
            for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
            nodesToHydrate.push(node);
        });
    }
    var _insert;
    var omnipresentPlugins = [
        $273321b94be832ab$var$compat,
        $273321b94be832ab$var$removeLabel
    ];
    if (!$273321b94be832ab$var$getServerStylisCache) {
        var currentSheet;
        var finalizingPlugins = [
            (0, $cByrN.stringify),
            (0, $cByrN.rulesheet)(function(rule) {
                currentSheet.insert(rule);
            })
        ];
        var serializer = (0, $cByrN.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
        var stylis = function stylis(styles) {
            return (0, $cByrN.serialize)((0, $cByrN.compile)(styles), serializer);
        };
        _insert = function insert(selector, serialized, sheet, shouldCache) {
            currentSheet = sheet;
            stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            if (shouldCache) cache.inserted[serialized.name] = true;
        };
    } else {
        var _finalizingPlugins = [
            (0, $cByrN.stringify)
        ];
        var _serializer = (0, $cByrN.middleware)(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));
        var _stylis = function _stylis(styles) {
            return (0, $cByrN.serialize)((0, $cByrN.compile)(styles), _serializer);
        };
        var serverStylisCache = $273321b94be832ab$var$getServerStylisCache(stylisPlugins)(key);
        var getRules = function getRules(selector, serialized) {
            var name = serialized.name;
            if (serverStylisCache[name] === undefined) serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
            return serverStylisCache[name];
        };
        _insert = function _insert(selector, serialized, sheet, shouldCache) {
            var name = serialized.name;
            var rules = getRules(selector, serialized);
            if (cache.compat === undefined) {
                // in regular mode, we don't set the styles on the inserted cache
                // since we don't need to and that would be wasting memory
                // we return them so that they are rendered in a style tag
                if (shouldCache) cache.inserted[name] = true;
                return rules;
            } else {
                // in compat mode, we put the styles on the inserted cache so
                // that emotion-server can pull out the styles
                // except when we don't want to cache it which was in Global but now
                // is nowhere but we don't want to do a major right now
                // and just in case we're going to leave the case here
                // it's also not affecting client side bundle size
                // so it's really not a big deal
                if (shouldCache) cache.inserted[name] = rules;
                else return rules;
            }
        };
    }
    var cache = {
        key: key,
        sheet: new (0, $4cVy4.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("4cVy4", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $3104ec53a35158ff$export$9d753cd7ae895cce; });
var $3104ec53a35158ff$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $3104ec53a35158ff$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $3104ec53a35158ff$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $3104ec53a35158ff$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$3104ec53a35158ff$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($3104ec53a35158ff$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $3104ec53a35158ff$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("cByrN", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $83f8df0fc4bef2f6$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $83f8df0fc4bef2f6$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $83f8df0fc4bef2f6$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $83f8df0fc4bef2f6$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $83f8df0fc4bef2f6$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $83f8df0fc4bef2f6$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $83f8df0fc4bef2f6$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $83f8df0fc4bef2f6$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $83f8df0fc4bef2f6$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $83f8df0fc4bef2f6$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $83f8df0fc4bef2f6$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $83f8df0fc4bef2f6$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $83f8df0fc4bef2f6$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $83f8df0fc4bef2f6$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $83f8df0fc4bef2f6$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $83f8df0fc4bef2f6$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $83f8df0fc4bef2f6$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $83f8df0fc4bef2f6$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $83f8df0fc4bef2f6$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $83f8df0fc4bef2f6$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $83f8df0fc4bef2f6$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $83f8df0fc4bef2f6$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $83f8df0fc4bef2f6$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $83f8df0fc4bef2f6$export$38bcb760f1d4871c; });
var $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 = "-ms-";
var $83f8df0fc4bef2f6$export$2c0f367103c8d01c = "-moz-";
var $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 = "-webkit-";
var $83f8df0fc4bef2f6$export$a29989082612d0d9 = "comm";
var $83f8df0fc4bef2f6$export$aa3a2e812ca8570d = "rule";
var $83f8df0fc4bef2f6$export$527d108ccf083c2b = "decl";
var $83f8df0fc4bef2f6$export$d3d35020fa5b54f0 = "@page";
var $83f8df0fc4bef2f6$export$500415a86c544f73 = "@media";
var $83f8df0fc4bef2f6$export$a763edbf796b780a = "@import";
var $83f8df0fc4bef2f6$export$2790aeb8b4e5c826 = "@charset";
var $83f8df0fc4bef2f6$export$1cc683e23b84b133 = "@viewport";
var $83f8df0fc4bef2f6$export$9447a5efea57e862 = "@supports";
var $83f8df0fc4bef2f6$export$ef011b4e114b1fba = "@document";
var $83f8df0fc4bef2f6$export$6aad947bda0f3f46 = "@namespace";
var $83f8df0fc4bef2f6$export$b44a8529a35fcb60 = "@keyframes";
var $83f8df0fc4bef2f6$export$2c16de31893252e6 = "@font-face";
var $83f8df0fc4bef2f6$export$3d846dd52e150c6f = "@counter-style";
var $83f8df0fc4bef2f6$export$22314bfbb57653fe = "@font-feature-values";
var $83f8df0fc4bef2f6$export$d773506282b3cfe6 = "@layer";
var $83f8df0fc4bef2f6$export$2335f513bbd82c6d = Math.abs;
var $83f8df0fc4bef2f6$export$6788812c4e6611e6 = String.fromCharCode;
var $83f8df0fc4bef2f6$export$e6e34fd1f2686227 = Object.assign;
function $83f8df0fc4bef2f6$export$d6af199866bfb566(e, r) {
    return $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 0)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 1)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 2)) << 2 ^ $83f8df0fc4bef2f6$export$a9db5e087081082d(e, 3) : 0;
}
function $83f8df0fc4bef2f6$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $83f8df0fc4bef2f6$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $83f8df0fc4bef2f6$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $83f8df0fc4bef2f6$export$36776f635604f274(e) {
    return e.length;
}
function $83f8df0fc4bef2f6$export$f9084667e487ed46(e) {
    return e.length;
}
function $83f8df0fc4bef2f6$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $83f8df0fc4bef2f6$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c = 1;
var $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1;
var $83f8df0fc4bef2f6$export$f24224f1c91d8156 = 0;
var $83f8df0fc4bef2f6$export$5880b8b5730aff45 = 0;
var $83f8df0fc4bef2f6$export$c0306caf338ac095 = 0;
var $83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = "";
function $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c,
        column: $83f8df0fc4bef2f6$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $83f8df0fc4bef2f6$export$784d13d8ee351f07(e, r) {
    return $83f8df0fc4bef2f6$export$e6e34fd1f2686227($83f8df0fc4bef2f6$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $83f8df0fc4bef2f6$export$eba6f6f03b0a92e7() {
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$232faf9add678146() {
    $83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$5880b8b5730aff45 > 0 ? $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, --$83f8df0fc4bef2f6$export$5880b8b5730aff45) : 0;
    if ($83f8df0fc4bef2f6$export$4e0c71f277ca26b3--, $83f8df0fc4bef2f6$export$c0306caf338ac095 === 10) $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c--;
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$48cfd1e771a65c4f() {
    $83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$5880b8b5730aff45 < $83f8df0fc4bef2f6$export$f24224f1c91d8156 ? $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, $83f8df0fc4bef2f6$export$5880b8b5730aff45++) : 0;
    if ($83f8df0fc4bef2f6$export$4e0c71f277ca26b3++, $83f8df0fc4bef2f6$export$c0306caf338ac095 === 10) $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c++;
    return $83f8df0fc4bef2f6$export$c0306caf338ac095;
}
function $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() {
    return $83f8df0fc4bef2f6$export$a9db5e087081082d($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, $83f8df0fc4bef2f6$export$5880b8b5730aff45);
}
function $83f8df0fc4bef2f6$export$e88cb2efb12ae807() {
    return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
}
function $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, r) {
    return $83f8df0fc4bef2f6$export$2f35ab04d2335697($83f8df0fc4bef2f6$export$30a86d91af8ff6e6, e, r);
}
function $83f8df0fc4bef2f6$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $83f8df0fc4bef2f6$export$2de70f21292aac9e(e) {
    return $83f8df0fc4bef2f6$export$53f1d5ea8de3d7c = $83f8df0fc4bef2f6$export$4e0c71f277ca26b3 = 1, $83f8df0fc4bef2f6$export$f24224f1c91d8156 = $83f8df0fc4bef2f6$export$36776f635604f274($83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = e), $83f8df0fc4bef2f6$export$5880b8b5730aff45 = 0, [];
}
function $83f8df0fc4bef2f6$export$45918ac1574455b1(e) {
    return $83f8df0fc4bef2f6$export$30a86d91af8ff6e6 = "", e;
}
function $83f8df0fc4bef2f6$export$410ac95b9ec204b8(e) {
    return $83f8df0fc4bef2f6$export$87c2784dc9fc4ab($83f8df0fc4bef2f6$export$58adb3bec8346d0f($83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1, $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $83f8df0fc4bef2f6$export$660b2ee2d4fb4eff(e) {
    return $83f8df0fc4bef2f6$export$45918ac1574455b1($83f8df0fc4bef2f6$export$5f8c09e3ae6f64e1($83f8df0fc4bef2f6$export$2de70f21292aac9e(e)));
}
function $83f8df0fc4bef2f6$export$7af1228ff777d175(e) {
    while($83f8df0fc4bef2f6$export$c0306caf338ac095 = $83f8df0fc4bef2f6$export$4d3fb11e950abb9e())if ($83f8df0fc4bef2f6$export$c0306caf338ac095 < 33) $83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
    else break;
    return $83f8df0fc4bef2f6$export$9e1725a4cfeada27(e) > 2 || $83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $83f8df0fc4bef2f6$export$5f8c09e3ae6f64e1(e) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())switch($83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$c0306caf338ac095)){
        case 0:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$c2ab62c7bf24634($83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$410ac95b9ec204b8($83f8df0fc4bef2f6$export$c0306caf338ac095), e);
            break;
        default:
            $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$6788812c4e6611e6($83f8df0fc4bef2f6$export$c0306caf338ac095), e);
    }
    return e;
}
function $83f8df0fc4bef2f6$export$955ba06d119e085e(e, r) {
    while(--r && $83f8df0fc4bef2f6$export$48cfd1e771a65c4f())if ($83f8df0fc4bef2f6$export$c0306caf338ac095 < 48 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 102 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 57 && $83f8df0fc4bef2f6$export$c0306caf338ac095 < 65 || $83f8df0fc4bef2f6$export$c0306caf338ac095 > 70 && $83f8df0fc4bef2f6$export$c0306caf338ac095 < 97) break;
    return $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, $83f8df0fc4bef2f6$export$e88cb2efb12ae807() + (r < 6 && $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() == 32 && $83f8df0fc4bef2f6$export$48cfd1e771a65c4f() == 32));
}
function $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())switch($83f8df0fc4bef2f6$export$c0306caf338ac095){
        case e:
            return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $83f8df0fc4bef2f6$export$c889f2fcc19dbf12($83f8df0fc4bef2f6$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $83f8df0fc4bef2f6$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
            break;
    }
    return $83f8df0fc4bef2f6$export$5880b8b5730aff45;
}
function $83f8df0fc4bef2f6$export$4254d4e2b3745c4c(e, r) {
    while($83f8df0fc4bef2f6$export$48cfd1e771a65c4f())if (e + $83f8df0fc4bef2f6$export$c0306caf338ac095 === 57) break;
    else if (e + $83f8df0fc4bef2f6$export$c0306caf338ac095 === 84 && $83f8df0fc4bef2f6$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $83f8df0fc4bef2f6$export$58adb3bec8346d0f(r, $83f8df0fc4bef2f6$export$5880b8b5730aff45 - 1) + "*" + $83f8df0fc4bef2f6$export$6788812c4e6611e6(e === 47 ? e : $83f8df0fc4bef2f6$export$48cfd1e771a65c4f());
}
function $83f8df0fc4bef2f6$export$c2ab62c7bf24634(e) {
    while(!$83f8df0fc4bef2f6$export$9e1725a4cfeada27($83f8df0fc4bef2f6$export$4d3fb11e950abb9e()))$83f8df0fc4bef2f6$export$48cfd1e771a65c4f();
    return $83f8df0fc4bef2f6$export$58adb3bec8346d0f(e, $83f8df0fc4bef2f6$export$5880b8b5730aff45);
}
function $83f8df0fc4bef2f6$export$ef7acd7185315e22(e) {
    return $83f8df0fc4bef2f6$export$45918ac1574455b1($83f8df0fc4bef2f6$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $83f8df0fc4bef2f6$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $83f8df0fc4bef2f6$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $83f8df0fc4bef2f6$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $83f8df0fc4bef2f6$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($83f8df0fc4bef2f6$export$f8e21b1e77979a08(j += $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $83f8df0fc4bef2f6$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $83f8df0fc4bef2f6$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $83f8df0fc4bef2f6$export$955ba06d119e085e($83f8df0fc4bef2f6$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($83f8df0fc4bef2f6$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$4a34f930e789283c($83f8df0fc4bef2f6$export$4254d4e2b3745c4c($83f8df0fc4bef2f6$export$48cfd1e771a65c4f(), $83f8df0fc4bef2f6$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $83f8df0fc4bef2f6$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $83f8df0fc4bef2f6$export$36776f635604f274(j) - l) $83f8df0fc4bef2f6$export$10d8903dec122b9d(p > 32 ? $83f8df0fc4bef2f6$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $83f8df0fc4bef2f6$export$f8483753829ec8f3($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $83f8df0fc4bef2f6$export$10d8903dec122b9d(y = $83f8df0fc4bef2f6$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $83f8df0fc4bef2f6$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $83f8df0fc4bef2f6$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $83f8df0fc4bef2f6$export$98e6a39c04603d36(e, y, y, n && $83f8df0fc4bef2f6$export$10d8903dec122b9d($83f8df0fc4bef2f6$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $83f8df0fc4bef2f6$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $83f8df0fc4bef2f6$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $83f8df0fc4bef2f6$export$232faf9add678146() == 125) continue;
            }
            switch(j += $83f8df0fc4bef2f6$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($83f8df0fc4bef2f6$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($83f8df0fc4bef2f6$export$4d3fb11e950abb9e() === 45) j += $83f8df0fc4bef2f6$export$410ac95b9ec204b8($83f8df0fc4bef2f6$export$48cfd1e771a65c4f());
                    v = $83f8df0fc4bef2f6$export$4d3fb11e950abb9e(), o = l = $83f8df0fc4bef2f6$export$36776f635604f274(g = j += $83f8df0fc4bef2f6$export$c2ab62c7bf24634($83f8df0fc4bef2f6$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $83f8df0fc4bef2f6$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $83f8df0fc4bef2f6$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $83f8df0fc4bef2f6$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, v + 1, v = $83f8df0fc4bef2f6$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $83f8df0fc4bef2f6$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, s === 0 ? $83f8df0fc4bef2f6$export$aa3a2e812ca8570d : i, f, o, l);
}
function $83f8df0fc4bef2f6$export$4a34f930e789283c(e, r, a) {
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, $83f8df0fc4bef2f6$export$a29989082612d0d9, $83f8df0fc4bef2f6$export$6788812c4e6611e6($83f8df0fc4bef2f6$export$eba6f6f03b0a92e7()), $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $83f8df0fc4bef2f6$export$f8483753829ec8f3(e, r, a, n) {
    return $83f8df0fc4bef2f6$export$35059013cd4a06db(e, r, a, $83f8df0fc4bef2f6$export$527d108ccf083c2b, $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, 0, n), $83f8df0fc4bef2f6$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $83f8df0fc4bef2f6$export$82e9f45cca5ba907(n, c, s) {
    switch($83f8df0fc4bef2f6$export$d6af199866bfb566(n, c)){
        case 5103:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $83f8df0fc4bef2f6$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-$1$2" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-item-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-row-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-line-pack" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-" + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-grow", "") + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "box-pack:$3" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-column-align" + $83f8df0fc4bef2f6$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(s, "span") ? $83f8df0fc4bef2f6$export$4659b591c19bdf3d(s, /\d+/) : +$83f8df0fc4bef2f6$export$4659b591c19bdf3d(s, /\d+/) - +$83f8df0fc4bef2f6$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $83f8df0fc4bef2f6$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($83f8df0fc4bef2f6$export$36776f635604f274(n) - 1 - c > 6) switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$83f8df0fc4bef2f6$export$f8e21b1e77979a08(n, "stretch") ? $83f8df0fc4bef2f6$export$82e9f45cca5ba907($83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, c + 6) === 121) return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, ":", ":" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($83f8df0fc4bef2f6$export$a9db5e087081082d(n, $83f8df0fc4bef2f6$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + ($83f8df0fc4bef2f6$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, ":", ":" + $83f8df0fc4bef2f6$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $83f8df0fc4bef2f6$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $83f8df0fc4bef2f6$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $83f8df0fc4bef2f6$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $83f8df0fc4bef2f6$export$a763edbf796b780a:
        case $83f8df0fc4bef2f6$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $83f8df0fc4bef2f6$export$a29989082612d0d9:
            return "";
        case $83f8df0fc4bef2f6$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $83f8df0fc4bef2f6$export$36776f635604f274(a = $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $83f8df0fc4bef2f6$export$5a7767152ae0305f(e) {
    var r = $83f8df0fc4bef2f6$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $83f8df0fc4bef2f6$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $83f8df0fc4bef2f6$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $83f8df0fc4bef2f6$export$527d108ccf083c2b:
                n.return = $83f8df0fc4bef2f6$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $83f8df0fc4bef2f6$export$b44a8529a35fcb60:
                return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                    $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                        value: $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
                if (n.length) return $83f8df0fc4bef2f6$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($83f8df0fc4bef2f6$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $83f8df0fc4bef2f6$export$dfdc1655ccc5b9cb([
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $83f8df0fc4bef2f6$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $83f8df0fc4bef2f6$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $83f8df0fc4bef2f6$export$784d13d8ee351f07(n, {
                                    props: [
                                        $83f8df0fc4bef2f6$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $83f8df0fc4bef2f6$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $83f8df0fc4bef2f6$export$76a88f7de6507443(e) {
    switch(e.type){
        case $83f8df0fc4bef2f6$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $83f8df0fc4bef2f6$export$1be1fc439b849fdf($83f8df0fc4bef2f6$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($83f8df0fc4bef2f6$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $83f8df0fc4bef2f6$export$2f35ab04d2335697(r, 1, $83f8df0fc4bef2f6$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $83f8df0fc4bef2f6$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $83f8df0fc4bef2f6$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $83f8df0fc4bef2f6$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("lT6zG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fef3d59b736200bc$export$2e2bcd8739ae039; });
var $fef3d59b736200bc$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("4AWAi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3587f7e2ed7416b3$export$2e2bcd8739ae039; });
function $3587f7e2ed7416b3$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("10FT7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0bc6489980e08e1c$export$2e2bcd8739ae039; });

var $8Ae2G = parcelRequire("8Ae2G");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $0bc6489980e08e1c$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8Ae2G)))(targetComponent, sourceComponent);
};

});
parcelRegister("8Ae2G", function(module, exports) {
'use strict';

var $dOv1V = parcelRequire("dOv1V");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $63fc9407ef8fcdfe$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $63fc9407ef8fcdfe$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $63fc9407ef8fcdfe$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $63fc9407ef8fcdfe$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $63fc9407ef8fcdfe$var$TYPE_STATICS = {};
$63fc9407ef8fcdfe$var$TYPE_STATICS[$dOv1V.ForwardRef] = $63fc9407ef8fcdfe$var$FORWARD_REF_STATICS;
$63fc9407ef8fcdfe$var$TYPE_STATICS[$dOv1V.Memo] = $63fc9407ef8fcdfe$var$MEMO_STATICS;
function $63fc9407ef8fcdfe$var$getStatics(component) {
    // React v16.11 and below
    if ($dOv1V.isMemo(component)) return $63fc9407ef8fcdfe$var$MEMO_STATICS;
     // React v16.12 and above
    return $63fc9407ef8fcdfe$var$TYPE_STATICS[component['$$typeof']] || $63fc9407ef8fcdfe$var$REACT_STATICS;
}
var $63fc9407ef8fcdfe$var$defineProperty = Object.defineProperty;
var $63fc9407ef8fcdfe$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $63fc9407ef8fcdfe$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $63fc9407ef8fcdfe$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $63fc9407ef8fcdfe$var$getPrototypeOf = Object.getPrototypeOf;
var $63fc9407ef8fcdfe$var$objectPrototype = Object.prototype;
function $63fc9407ef8fcdfe$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($63fc9407ef8fcdfe$var$objectPrototype) {
            var inheritedComponent = $63fc9407ef8fcdfe$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $63fc9407ef8fcdfe$var$objectPrototype) $63fc9407ef8fcdfe$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $63fc9407ef8fcdfe$var$getOwnPropertyNames(sourceComponent);
        if ($63fc9407ef8fcdfe$var$getOwnPropertySymbols) keys = keys.concat($63fc9407ef8fcdfe$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $63fc9407ef8fcdfe$var$getStatics(targetComponent);
        var sourceStatics = $63fc9407ef8fcdfe$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$63fc9407ef8fcdfe$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $63fc9407ef8fcdfe$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $63fc9407ef8fcdfe$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $63fc9407ef8fcdfe$var$hoistNonReactStatics;

});
parcelRegister("dOv1V", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3oWWu"));

});



parcelRegister("80dPg", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $5d390c582efd47c3$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $5d390c582efd47c3$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $5d390c582efd47c3$export$6f077d94b33a01aa; });
var $5d390c582efd47c3$var$isBrowser = typeof document !== 'undefined';
function $5d390c582efd47c3$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $5d390c582efd47c3$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $5d390c582efd47c3$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $5d390c582efd47c3$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $5d390c582efd47c3$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var stylesForSSR = '';
        var current = serialized;
        do {
            var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            if (!$5d390c582efd47c3$var$isBrowser && maybeStyles !== undefined) stylesForSSR += maybeStyles;
            current = current.next;
        }while (current !== undefined);
        if (!$5d390c582efd47c3$var$isBrowser && stylesForSSR.length !== 0) return stylesForSSR;
    }
};

});

parcelRegister("6lPck", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $49fc6b0b9a1bf345$export$6321afa313b251b5; });

var $1OEsj = parcelRequire("1OEsj");

var $cfR4M = parcelRequire("cfR4M");

var $4AWAi = parcelRequire("4AWAi");
var $49fc6b0b9a1bf345$var$isDevelopment = false;
var $49fc6b0b9a1bf345$var$hyphenateRegex = /[A-Z]|^ms/g;
var $49fc6b0b9a1bf345$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $49fc6b0b9a1bf345$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $49fc6b0b9a1bf345$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $49fc6b0b9a1bf345$var$processStyleName = /* #__PURE__ */ (0, $4AWAi.default)(function(styleName) {
    return $49fc6b0b9a1bf345$var$isCustomProperty(styleName) ? styleName : styleName.replace($49fc6b0b9a1bf345$var$hyphenateRegex, '-$&').toLowerCase();
});
var $49fc6b0b9a1bf345$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($49fc6b0b9a1bf345$var$animationRegex, function(match, p1, p2) {
                $49fc6b0b9a1bf345$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $49fc6b0b9a1bf345$var$cursor
                };
                return p1;
            });
    }
    if ((0, $cfR4M.default)[key] !== 1 && !$49fc6b0b9a1bf345$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $49fc6b0b9a1bf345$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $49fc6b0b9a1bf345$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $49fc6b0b9a1bf345$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $49fc6b0b9a1bf345$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $49fc6b0b9a1bf345$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $49fc6b0b9a1bf345$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $49fc6b0b9a1bf345$var$cursor;
                var result = interpolation(mergedProps);
                $49fc6b0b9a1bf345$var$cursor = previousCursor;
                return $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $49fc6b0b9a1bf345$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($49fc6b0b9a1bf345$var$isProcessableValue(asString)) string += $49fc6b0b9a1bf345$var$processStyleName(key) + ":" + $49fc6b0b9a1bf345$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $49fc6b0b9a1bf345$var$isDevelopment) throw new Error($49fc6b0b9a1bf345$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($49fc6b0b9a1bf345$var$isProcessableValue(value[_i])) string += $49fc6b0b9a1bf345$var$processStyleName(key) + ":" + $49fc6b0b9a1bf345$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $49fc6b0b9a1bf345$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $49fc6b0b9a1bf345$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $49fc6b0b9a1bf345$var$cursor;
function $49fc6b0b9a1bf345$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $49fc6b0b9a1bf345$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $49fc6b0b9a1bf345$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $49fc6b0b9a1bf345$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $49fc6b0b9a1bf345$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $1OEsj.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $49fc6b0b9a1bf345$var$cursor
    };
}

});
parcelRegister("1OEsj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1529d79d9aa6f066$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $1529d79d9aa6f066$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("cfR4M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ec00e8a3ecbe6f7$export$2e2bcd8739ae039; });
var $8ec00e8a3ecbe6f7$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("9uXao", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $6ea4cfa701df259a$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $6ea4cfa701df259a$export$811a713a7276cb9d; });

var $7fPBF = parcelRequire("7fPBF");
var $6ea4cfa701df259a$var$isBrowser = typeof document !== 'undefined';
var $6ea4cfa701df259a$var$syncFallback = function syncFallback(create) {
    return create();
};
var $6ea4cfa701df259a$var$useInsertionEffect = $7fPBF.useInsertionEffect ? $7fPBF.useInsertionEffect : false;
var $6ea4cfa701df259a$export$db21c7ffa21794e7 = !$6ea4cfa701df259a$var$isBrowser ? $6ea4cfa701df259a$var$syncFallback : $6ea4cfa701df259a$var$useInsertionEffect || $6ea4cfa701df259a$var$syncFallback;
var $6ea4cfa701df259a$export$811a713a7276cb9d = $6ea4cfa701df259a$var$useInsertionEffect || $7fPBF.useLayoutEffect;

});



parcelRegister("9YmaI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $742aea85e4e67b26$export$2e2bcd8739ae039; });

var $4AWAi = parcelRequire("4AWAi");
// eslint-disable-next-line no-undef
var $742aea85e4e67b26$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $742aea85e4e67b26$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $4AWAi.default)(function(prop) {
    return $742aea85e4e67b26$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});



parcelRegister("e6xq6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a44b8cbd62c27155$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $6te04 = parcelRequire("6te04");

var $3mESc = parcelRequire("3mESc");

var $bbzbN = parcelRequire("bbzbN");
'use client';
function $a44b8cbd62c27155$var$getCache(injectFirst, enableCssLayer) {
    const emotionCache = (0, $3mESc.default)({
        key: 'css',
        prepend: injectFirst
    });
    if (enableCssLayer) {
        const prevInsert = emotionCache.insert;
        emotionCache.insert = (...args)=>{
            if (!args[1].styles.match(/^@layer\s+[^{]*$/)) // avoid nested @layer
            args[1].styles = `@layer mui {${args[1].styles}}`;
            return prevInsert(...args);
        };
    }
    return emotionCache;
}
const $a44b8cbd62c27155$var$cacheMap = new Map();
function $a44b8cbd62c27155$export$2e2bcd8739ae039(props) {
    const { injectFirst: injectFirst, enableCssLayer: enableCssLayer, children: children } = props;
    const cache = $7fPBF.useMemo(()=>{
        const cacheKey = `${injectFirst}-${enableCssLayer}`;
        if (typeof document === 'object' && $a44b8cbd62c27155$var$cacheMap.has(cacheKey)) return $a44b8cbd62c27155$var$cacheMap.get(cacheKey);
        const fresh = $a44b8cbd62c27155$var$getCache(injectFirst, enableCssLayer);
        $a44b8cbd62c27155$var$cacheMap.set(cacheKey, fresh);
        return fresh;
    }, [
        injectFirst,
        enableCssLayer
    ]);
    if (injectFirst || enableCssLayer) return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6te04.C), {
        value: cache,
        children: children
    });
    return children;
}

});
parcelRegister("bbzbN", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2nzLi"));

});


parcelRegister("5tMhb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fd51bd676aa60b7$export$2e2bcd8739ae039; });
parcelRequire("7fPBF");


var $5nUae = parcelRequire("5nUae");

var $bbzbN = parcelRequire("bbzbN");
'use client';
function $3fd51bd676aa60b7$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $3fd51bd676aa60b7$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($3fd51bd676aa60b7$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5nUae.Global), {
        styles: globalStyles
    });
}

});


parcelRegister("3oBOp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("iCiVn")).default; });

var $iCiVn = parcelRequire("iCiVn");

});
parcelRegister("iCiVn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8da749d88f71122$export$2e2bcd8739ae039; });

var $diYUK = parcelRequire("diYUK");
function $d8da749d88f71122$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $diYUK.default)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}

});


parcelRegister("ehv4n", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("bXHHW")).default; });

var $bXHHW = parcelRequire("bXHHW");
$parcel$exportWildcard(module.exports, $bXHHW);

});
parcelRegister("bXHHW", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getFunctionName", function () { return $8b571bd6b8501d36$export$aad197c7121a6651; });
$parcel$export(module.exports, "default", function () { return $8b571bd6b8501d36$export$2e2bcd8739ae039; });

var $j2VHG = parcelRequire("j2VHG");
// Simplified polyfill for IE11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
const $8b571bd6b8501d36$var$fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function $8b571bd6b8501d36$export$aad197c7121a6651(fn) {
    const match = `${fn}`.match($8b571bd6b8501d36$var$fnNameMatchRegex);
    const name = match && match[1];
    return name || '';
}
function $8b571bd6b8501d36$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || $8b571bd6b8501d36$export$aad197c7121a6651(Component) || fallback;
}
function $8b571bd6b8501d36$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $8b571bd6b8501d36$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $8b571bd6b8501d36$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $8b571bd6b8501d36$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $j2VHG.ForwardRef:
            return $8b571bd6b8501d36$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $j2VHG.Memo:
            return $8b571bd6b8501d36$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}

});
parcelRegister("j2VHG", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9kHYF"));

});
parcelRegister("9kHYF", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $6cb818575e31460e$export$a7c73072b1a182ae; }, function (v) { return $6cb818575e31460e$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $6cb818575e31460e$export$9f27bc3417b4524d; }, function (v) { return $6cb818575e31460e$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $6cb818575e31460e$export$db77ccec0bb4ccac; }, function (v) { return $6cb818575e31460e$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $6cb818575e31460e$export$8392c0c9d3dcbd35; }, function (v) { return $6cb818575e31460e$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $6cb818575e31460e$export$ffb0004e005737fa; }, function (v) { return $6cb818575e31460e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $6cb818575e31460e$export$b624eff549462981; }, function (v) { return $6cb818575e31460e$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $6cb818575e31460e$export$7897aa7841a5380c; }, function (v) { return $6cb818575e31460e$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $6cb818575e31460e$export$602eac185826482c; }, function (v) { return $6cb818575e31460e$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $6cb818575e31460e$export$e2c29f18771995cb; }, function (v) { return $6cb818575e31460e$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $6cb818575e31460e$export$5f8d39834fd61797; }, function (v) { return $6cb818575e31460e$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $6cb818575e31460e$export$74bf444e3cd11ea5; }, function (v) { return $6cb818575e31460e$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $6cb818575e31460e$export$998bcd577473dd93; }, function (v) { return $6cb818575e31460e$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $6cb818575e31460e$export$b706b080d889d2c9; }, function (v) { return $6cb818575e31460e$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $6cb818575e31460e$export$5be5a87408f70ddc; }, function (v) { return $6cb818575e31460e$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $6cb818575e31460e$export$45a5e7f76e0caa8d; }, function (v) { return $6cb818575e31460e$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $6cb818575e31460e$export$455c2e768291efa6; }, function (v) { return $6cb818575e31460e$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $6cb818575e31460e$export$9522e17588c12572; }, function (v) { return $6cb818575e31460e$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $6cb818575e31460e$export$2110ac352bb060b9; }, function (v) { return $6cb818575e31460e$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $6cb818575e31460e$export$56885ab8b9c456ab; }, function (v) { return $6cb818575e31460e$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $6cb818575e31460e$export$d927fcb6adf8f9de; }, function (v) { return $6cb818575e31460e$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $6cb818575e31460e$export$b82d16f27459e05a; }, function (v) { return $6cb818575e31460e$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $6cb818575e31460e$export$522c17b4f5e123e8; }, function (v) { return $6cb818575e31460e$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $6cb818575e31460e$export$1aabd8a0274ecfd6; }, function (v) { return $6cb818575e31460e$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $6cb818575e31460e$export$3d6c20d97e46b957; }, function (v) { return $6cb818575e31460e$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $6cb818575e31460e$export$9b621391a187a31a; }, function (v) { return $6cb818575e31460e$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $6cb818575e31460e$export$f5bbd400c2f4426f; }, function (v) { return $6cb818575e31460e$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6cb818575e31460e$export$a7c73072b1a182ae;
var $6cb818575e31460e$export$9f27bc3417b4524d;
var $6cb818575e31460e$export$db77ccec0bb4ccac;
var $6cb818575e31460e$export$8392c0c9d3dcbd35;
var $6cb818575e31460e$export$ffb0004e005737fa;
var $6cb818575e31460e$export$b624eff549462981;
var $6cb818575e31460e$export$7897aa7841a5380c;
var $6cb818575e31460e$export$602eac185826482c;
var $6cb818575e31460e$export$e2c29f18771995cb;
var $6cb818575e31460e$export$5f8d39834fd61797;
var $6cb818575e31460e$export$74bf444e3cd11ea5;
var $6cb818575e31460e$export$998bcd577473dd93;
var $6cb818575e31460e$export$b706b080d889d2c9;
var $6cb818575e31460e$export$5be5a87408f70ddc;
var $6cb818575e31460e$export$45a5e7f76e0caa8d;
var $6cb818575e31460e$export$455c2e768291efa6;
var $6cb818575e31460e$export$9522e17588c12572;
var $6cb818575e31460e$export$2110ac352bb060b9;
var $6cb818575e31460e$export$56885ab8b9c456ab;
var $6cb818575e31460e$export$d927fcb6adf8f9de;
var $6cb818575e31460e$export$b82d16f27459e05a;
var $6cb818575e31460e$export$522c17b4f5e123e8;
var $6cb818575e31460e$export$1aabd8a0274ecfd6;
var $6cb818575e31460e$export$3d6c20d97e46b957;
var $6cb818575e31460e$export$9b621391a187a31a;
var $6cb818575e31460e$export$f5bbd400c2f4426f;
"use strict";
var $6cb818575e31460e$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $6cb818575e31460e$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $6cb818575e31460e$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $6cb818575e31460e$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $6cb818575e31460e$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
Symbol.for("react.provider");
var $6cb818575e31460e$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $6cb818575e31460e$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $6cb818575e31460e$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $6cb818575e31460e$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $6cb818575e31460e$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $6cb818575e31460e$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $6cb818575e31460e$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $6cb818575e31460e$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $6cb818575e31460e$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $6cb818575e31460e$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $6cb818575e31460e$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $6cb818575e31460e$var$REACT_FRAGMENT_TYPE:
                    case $6cb818575e31460e$var$REACT_PROFILER_TYPE:
                    case $6cb818575e31460e$var$REACT_STRICT_MODE_TYPE:
                    case $6cb818575e31460e$var$REACT_SUSPENSE_TYPE:
                    case $6cb818575e31460e$var$REACT_SUSPENSE_LIST_TYPE:
                    case $6cb818575e31460e$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $6cb818575e31460e$var$REACT_CONTEXT_TYPE:
                            case $6cb818575e31460e$var$REACT_FORWARD_REF_TYPE:
                            case $6cb818575e31460e$var$REACT_LAZY_TYPE:
                            case $6cb818575e31460e$var$REACT_MEMO_TYPE:
                                return object;
                            case $6cb818575e31460e$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $6cb818575e31460e$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$6cb818575e31460e$export$a7c73072b1a182ae = $6cb818575e31460e$var$REACT_CONSUMER_TYPE;
$6cb818575e31460e$export$9f27bc3417b4524d = $6cb818575e31460e$var$REACT_CONTEXT_TYPE;
$6cb818575e31460e$export$db77ccec0bb4ccac = $6cb818575e31460e$var$REACT_ELEMENT_TYPE;
$6cb818575e31460e$export$8392c0c9d3dcbd35 = $6cb818575e31460e$var$REACT_FORWARD_REF_TYPE;
$6cb818575e31460e$export$ffb0004e005737fa = $6cb818575e31460e$var$REACT_FRAGMENT_TYPE;
$6cb818575e31460e$export$b624eff549462981 = $6cb818575e31460e$var$REACT_LAZY_TYPE;
$6cb818575e31460e$export$7897aa7841a5380c = $6cb818575e31460e$var$REACT_MEMO_TYPE;
$6cb818575e31460e$export$602eac185826482c = $6cb818575e31460e$var$REACT_PORTAL_TYPE;
$6cb818575e31460e$export$e2c29f18771995cb = $6cb818575e31460e$var$REACT_PROFILER_TYPE;
$6cb818575e31460e$export$5f8d39834fd61797 = $6cb818575e31460e$var$REACT_STRICT_MODE_TYPE;
$6cb818575e31460e$export$74bf444e3cd11ea5 = $6cb818575e31460e$var$REACT_SUSPENSE_TYPE;
$6cb818575e31460e$export$998bcd577473dd93 = $6cb818575e31460e$var$REACT_SUSPENSE_LIST_TYPE;
$6cb818575e31460e$export$b706b080d889d2c9 = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_CONSUMER_TYPE;
};
$6cb818575e31460e$export$5be5a87408f70ddc = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_CONTEXT_TYPE;
};
$6cb818575e31460e$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $6cb818575e31460e$var$REACT_ELEMENT_TYPE;
};
$6cb818575e31460e$export$455c2e768291efa6 = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_FORWARD_REF_TYPE;
};
$6cb818575e31460e$export$9522e17588c12572 = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_FRAGMENT_TYPE;
};
$6cb818575e31460e$export$2110ac352bb060b9 = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_LAZY_TYPE;
};
$6cb818575e31460e$export$56885ab8b9c456ab = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_MEMO_TYPE;
};
$6cb818575e31460e$export$d927fcb6adf8f9de = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_PORTAL_TYPE;
};
$6cb818575e31460e$export$b82d16f27459e05a = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_PROFILER_TYPE;
};
$6cb818575e31460e$export$522c17b4f5e123e8 = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_STRICT_MODE_TYPE;
};
$6cb818575e31460e$export$1aabd8a0274ecfd6 = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_SUSPENSE_TYPE;
};
$6cb818575e31460e$export$3d6c20d97e46b957 = function(object) {
    return $6cb818575e31460e$var$typeOf(object) === $6cb818575e31460e$var$REACT_SUSPENSE_LIST_TYPE;
};
$6cb818575e31460e$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $6cb818575e31460e$var$REACT_FRAGMENT_TYPE || type === $6cb818575e31460e$var$REACT_PROFILER_TYPE || type === $6cb818575e31460e$var$REACT_STRICT_MODE_TYPE || type === $6cb818575e31460e$var$REACT_SUSPENSE_TYPE || type === $6cb818575e31460e$var$REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $6cb818575e31460e$var$REACT_LAZY_TYPE || type.$$typeof === $6cb818575e31460e$var$REACT_MEMO_TYPE || type.$$typeof === $6cb818575e31460e$var$REACT_CONTEXT_TYPE || type.$$typeof === $6cb818575e31460e$var$REACT_CONSUMER_TYPE || type.$$typeof === $6cb818575e31460e$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $6cb818575e31460e$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$6cb818575e31460e$export$f5bbd400c2f4426f = $6cb818575e31460e$var$typeOf;

});




parcelRegister("1ifJj", function(module, exports) {
function $0f13ac86de1755d2$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $0f13ac86de1755d2$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("eqNKX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("2G6xE")).default; });
$parcel$export(module.exports, "private_createBreakpoints", function () { return (parcelRequire("iZrRs")).default; });
$parcel$export(module.exports, "unstable_applyStyles", function () { return (parcelRequire("56TFl")).default; });

var $2G6xE = parcelRequire("2G6xE");

var $iZrRs = parcelRequire("iZrRs");

var $56TFl = parcelRequire("56TFl");

});
parcelRegister("2G6xE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f34940f58017e5f$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $3wRTY = parcelRequire("3wRTY");

var $iZrRs = parcelRequire("iZrRs");

var $l8Cag = parcelRequire("l8Cag");

var $GLqnW = parcelRequire("GLqnW");

var $8M6a3 = parcelRequire("8M6a3");

var $hXGiu = parcelRequire("hXGiu");

var $56TFl = parcelRequire("56TFl");
const $1f34940f58017e5f$var$_excluded = [
    "breakpoints",
    "palette",
    "spacing",
    "shape"
];
function $1f34940f58017e5f$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {} } = options, other = (0, $cFLic.default)(options, $1f34940f58017e5f$var$_excluded);
    const breakpoints = (0, $iZrRs.default)(breakpointsInput);
    const spacing = (0, $GLqnW.default)(spacingInput);
    let muiTheme = (0, $3wRTY.default)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: (0, $kY3Ke.default)({
            mode: 'light'
        }, paletteInput),
        spacing: spacing,
        shape: (0, $kY3Ke.default)({}, (0, $l8Cag.default), shapeInput)
    }, other);
    muiTheme.applyStyles = (0, $56TFl.default);
    muiTheme = args.reduce((acc, argument)=>(0, $3wRTY.default)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = (0, $kY3Ke.default)({}, (0, $hXGiu.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $8M6a3.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $1f34940f58017e5f$export$2e2bcd8739ae039 = $1f34940f58017e5f$var$createTheme;

});
parcelRegister("cFLic", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $939dffaddf93a85b$export$2e2bcd8739ae039; });
function $939dffaddf93a85b$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("3wRTY", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $291e2c063c5d6173$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "default", function () { return $291e2c063c5d6173$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");
function $291e2c063c5d6173$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $291e2c063c5d6173$var$deepClone(source) {
    if (/*#__PURE__*/ $7fPBF.isValidElement(source) || !$291e2c063c5d6173$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $291e2c063c5d6173$var$deepClone(source[key]);
    });
    return output;
}
function $291e2c063c5d6173$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? (0, $kY3Ke.default)({}, target) : target;
    if ($291e2c063c5d6173$export$53b83ca8eaab0383(target) && $291e2c063c5d6173$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $7fPBF.isValidElement(source[key])) output[key] = source[key];
        else if ($291e2c063c5d6173$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $291e2c063c5d6173$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $291e2c063c5d6173$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $291e2c063c5d6173$export$53b83ca8eaab0383(source[key]) ? $291e2c063c5d6173$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}

});

parcelRegister("iZrRs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dd33892704fa9f8b$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");
const $dd33892704fa9f8b$var$_excluded = [
    "values",
    "unit",
    "step"
];
const $dd33892704fa9f8b$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $dd33892704fa9f8b$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return (0, $kY3Ke.default)({}, acc, {
            [obj.key]: obj.val
        });
    }, {});
};
function $dd33892704fa9f8b$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5 } = breakpoints, other = (0, $cFLic.default)(breakpoints, $dd33892704fa9f8b$var$_excluded);
    const sortedValues = $dd33892704fa9f8b$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return (0, $kY3Ke.default)({
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit
    }, other);
}

});

parcelRegister("l8Cag", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f637f3037d6dee04$export$2e2bcd8739ae039; });
const $f637f3037d6dee04$var$shape = {
    borderRadius: 4
};
var $f637f3037d6dee04$export$2e2bcd8739ae039 = $f637f3037d6dee04$var$shape;

});

parcelRegister("GLqnW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0808b5e3ab0ab6d4$export$2e2bcd8739ae039; });

var $5z69T = parcelRequire("5z69T");
function $0808b5e3ab0ab6d4$export$2e2bcd8739ae039(spacingInput = 8) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
    // Smaller components, such as icons, can align to a 4dp grid.
    // https://m2.material.io/design/layout/understanding-layout.html
    const transform = (0, $5z69T.createUnarySpacing)({
        spacing: spacingInput
    });
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}

});
parcelRegister("5z69T", function(module, exports) {

$parcel$export(module.exports, "createUnaryUnit", function () { return $40d4ff9e66a5531b$export$cb5ee237cce814a2; });
$parcel$export(module.exports, "createUnarySpacing", function () { return $40d4ff9e66a5531b$export$1def6f833384e3d1; });
$parcel$export(module.exports, "getValue", function () { return $40d4ff9e66a5531b$export$bf7199a9ebcb84a9; });
$parcel$export(module.exports, "margin", function () { return $40d4ff9e66a5531b$export$7ede87f9b603dd3c; });
$parcel$export(module.exports, "padding", function () { return $40d4ff9e66a5531b$export$6f98e8eaf0be1996; });


var $cvrkU = parcelRequire("cvrkU");

var $190Wm = parcelRequire("190Wm");

var $4So0q = parcelRequire("4So0q");

var $dMDTp = parcelRequire("dMDTp");
const $40d4ff9e66a5531b$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $40d4ff9e66a5531b$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $40d4ff9e66a5531b$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $40d4ff9e66a5531b$var$getCssProperties = (0, $dMDTp.default)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($40d4ff9e66a5531b$var$aliases[prop]) prop = $40d4ff9e66a5531b$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $40d4ff9e66a5531b$var$properties[a];
    const direction = $40d4ff9e66a5531b$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $40d4ff9e66a5531b$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $40d4ff9e66a5531b$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $40d4ff9e66a5531b$var$spacingKeys = [
    ...$40d4ff9e66a5531b$export$aab52a0dde05ad8a,
    ...$40d4ff9e66a5531b$export$f8397d44f03ab6ad
];
function $40d4ff9e66a5531b$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    var _getPath;
    const themeSpacing = (_getPath = (0, $190Wm.getPath)(theme, themeKey, false)) != null ? _getPath : defaultValue;
    if (typeof themeSpacing === 'number') return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing * abs;
    };
    if (Array.isArray(themeSpacing)) return (abs)=>{
        if (typeof abs === 'string') return abs;
        return themeSpacing[abs];
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $40d4ff9e66a5531b$export$1def6f833384e3d1(theme) {
    return $40d4ff9e66a5531b$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $40d4ff9e66a5531b$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    const abs = Math.abs(propValue);
    const transformed = transformer(abs);
    if (propValue >= 0) return transformed;
    if (typeof transformed === 'number') return -transformed;
    return `-${transformed}`;
}
function $40d4ff9e66a5531b$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $40d4ff9e66a5531b$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $40d4ff9e66a5531b$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (keys.indexOf(prop) === -1) return null;
    const cssProperties = $40d4ff9e66a5531b$var$getCssProperties(prop);
    const styleFromPropValue = $40d4ff9e66a5531b$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $cvrkU.handleBreakpoints)(props, propValue, styleFromPropValue);
}
function $40d4ff9e66a5531b$var$style(props, keys) {
    const transformer = $40d4ff9e66a5531b$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$40d4ff9e66a5531b$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $4So0q.default), {});
}
function $40d4ff9e66a5531b$export$7ede87f9b603dd3c(props) {
    return $40d4ff9e66a5531b$var$style(props, $40d4ff9e66a5531b$export$aab52a0dde05ad8a);
}
$40d4ff9e66a5531b$export$7ede87f9b603dd3c.propTypes = {};
$40d4ff9e66a5531b$export$7ede87f9b603dd3c.filterProps = $40d4ff9e66a5531b$export$aab52a0dde05ad8a;
function $40d4ff9e66a5531b$export$6f98e8eaf0be1996(props) {
    return $40d4ff9e66a5531b$var$style(props, $40d4ff9e66a5531b$export$f8397d44f03ab6ad);
}
$40d4ff9e66a5531b$export$6f98e8eaf0be1996.propTypes = {};
$40d4ff9e66a5531b$export$6f98e8eaf0be1996.filterProps = $40d4ff9e66a5531b$export$f8397d44f03ab6ad;
function $40d4ff9e66a5531b$var$spacing(props) {
    return $40d4ff9e66a5531b$var$style(props, $40d4ff9e66a5531b$var$spacingKeys);
}
$40d4ff9e66a5531b$var$spacing.propTypes = {};
$40d4ff9e66a5531b$var$spacing.filterProps = $40d4ff9e66a5531b$var$spacingKeys;
var $40d4ff9e66a5531b$export$2e2bcd8739ae039 = $40d4ff9e66a5531b$var$spacing;

});
parcelRegister("cvrkU", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $91ad95ac62846a03$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "handleBreakpoints", function () { return $91ad95ac62846a03$export$88347efdb2e19abd; });
$parcel$export(module.exports, "createEmptyBreakpointObject", function () { return $91ad95ac62846a03$export$1f2600516e91381f; });
$parcel$export(module.exports, "removeUnusedBreakpoints", function () { return $91ad95ac62846a03$export$8922c90b6e020726; });

var $kY3Ke = parcelRequire("kY3Ke");


var $3wRTY = parcelRequire("3wRTY");

var $4So0q = parcelRequire("4So0q");
const $91ad95ac62846a03$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $91ad95ac62846a03$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$91ad95ac62846a03$export$68c286be0e7e55b7[key]}px)`
};
function $91ad95ac62846a03$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $91ad95ac62846a03$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $91ad95ac62846a03$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            // key is breakpoint
            if (Object.keys(themeBreakpoints.values || $91ad95ac62846a03$export$68c286be0e7e55b7).indexOf(breakpoint) !== -1) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $91ad95ac62846a03$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $91ad95ac62846a03$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction((0, $kY3Ke.default)({
                    theme: theme
                }, props[key]));
            }
            return acc;
        }, null);
        return (0, $4So0q.default)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $91ad95ac62846a03$export$1f2600516e91381f(breakpointsInput = {}) {
    var _breakpointsInput$key;
    const breakpointsInOrder = (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $91ad95ac62846a03$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $91ad95ac62846a03$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $91ad95ac62846a03$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $3wRTY.default)(prev, next), {});
    return $91ad95ac62846a03$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $91ad95ac62846a03$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $91ad95ac62846a03$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $91ad95ac62846a03$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $91ad95ac62846a03$export$2e2bcd8739ae039 = $91ad95ac62846a03$var$breakpoints;

});
parcelRegister("4So0q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38ced3a04f47cab4$export$2e2bcd8739ae039; });

var $3wRTY = parcelRequire("3wRTY");
function $38ced3a04f47cab4$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $3wRTY.default)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $38ced3a04f47cab4$export$2e2bcd8739ae039 = $38ced3a04f47cab4$var$merge;

});


parcelRegister("190Wm", function(module, exports) {

$parcel$export(module.exports, "getPath", function () { return $0d575c74131361b5$export$2aa3fd96c49a84a8; });
$parcel$export(module.exports, "getStyleValue", function () { return $0d575c74131361b5$export$741ad47189a64aa0; });
$parcel$export(module.exports, "default", function () { return $0d575c74131361b5$export$2e2bcd8739ae039; });

var $iCiVn = parcelRequire("iCiVn");


var $cvrkU = parcelRequire("cvrkU");
function $0d575c74131361b5$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $0d575c74131361b5$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $0d575c74131361b5$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $0d575c74131361b5$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $0d575c74131361b5$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $0d575c74131361b5$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $0d575c74131361b5$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $iCiVn.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $cvrkU.handleBreakpoints)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $0d575c74131361b5$export$2e2bcd8739ae039 = $0d575c74131361b5$var$style;

});

parcelRegister("dMDTp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a08eb3ea758ca121$export$2e2bcd8739ae039; });
function $a08eb3ea758ca121$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});



parcelRegister("8M6a3", function(module, exports) {

$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return $663795ec7cbfcd06$export$7d53d8bf2911e013; });
$parcel$export(module.exports, "default", function () { return $663795ec7cbfcd06$export$2e2bcd8739ae039; });

var $iCiVn = parcelRequire("iCiVn");

var $4So0q = parcelRequire("4So0q");

var $190Wm = parcelRequire("190Wm");

var $cvrkU = parcelRequire("cvrkU");

var $hXGiu = parcelRequire("hXGiu");
function $663795ec7cbfcd06$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $663795ec7cbfcd06$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $663795ec7cbfcd06$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $190Wm.getPath)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $190Wm.getStyleValue)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $190Wm.getStyleValue)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $iCiVn.default)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $cvrkU.handleBreakpoints)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        var _theme$unstable_sxCon;
        const { sx: sx, theme: theme = {}, nested: nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = (_theme$unstable_sxCon = theme.unstable_sxConfig) != null ? _theme$unstable_sxCon : (0, $hXGiu.default);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $cvrkU.createEmptyBreakpointObject)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $663795ec7cbfcd06$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $4So0q.default)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $cvrkU.handleBreakpoints)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($663795ec7cbfcd06$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme,
                                nested: true
                            });
                            else css = (0, $4So0q.default)(css, breakpointsValues);
                        }
                    } else css = (0, $4So0q.default)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $cvrkU.removeUnusedBreakpoints)(breakpointsKeys, css)
            };
            return (0, $cvrkU.removeUnusedBreakpoints)(breakpointsKeys, css);
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $663795ec7cbfcd06$var$styleFunctionSx = $663795ec7cbfcd06$export$7d53d8bf2911e013();
$663795ec7cbfcd06$var$styleFunctionSx.filterProps = [
    'sx'
];
var $663795ec7cbfcd06$export$2e2bcd8739ae039 = $663795ec7cbfcd06$var$styleFunctionSx;

});
parcelRegister("hXGiu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d138c1b003d294d5$export$2e2bcd8739ae039; });

var $5z69T = parcelRequire("5z69T");

var $brmMH = parcelRequire("brmMH");

var $aoYMG = parcelRequire("aoYMG");

var $lzsJx = parcelRequire("lzsJx");

var $8LvXe = parcelRequire("8LvXe");
const $d138c1b003d294d5$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $brmMH.borderTransform)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $brmMH.borderTransform)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $brmMH.borderTransform)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $brmMH.borderTransform)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $brmMH.borderTransform)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $brmMH.borderTransform)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $brmMH.borderRadius)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $lzsJx.paletteTransform)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $lzsJx.paletteTransform)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $lzsJx.paletteTransform)
    },
    // spacing
    p: {
        style: (0, $5z69T.padding)
    },
    pt: {
        style: (0, $5z69T.padding)
    },
    pr: {
        style: (0, $5z69T.padding)
    },
    pb: {
        style: (0, $5z69T.padding)
    },
    pl: {
        style: (0, $5z69T.padding)
    },
    px: {
        style: (0, $5z69T.padding)
    },
    py: {
        style: (0, $5z69T.padding)
    },
    padding: {
        style: (0, $5z69T.padding)
    },
    paddingTop: {
        style: (0, $5z69T.padding)
    },
    paddingRight: {
        style: (0, $5z69T.padding)
    },
    paddingBottom: {
        style: (0, $5z69T.padding)
    },
    paddingLeft: {
        style: (0, $5z69T.padding)
    },
    paddingX: {
        style: (0, $5z69T.padding)
    },
    paddingY: {
        style: (0, $5z69T.padding)
    },
    paddingInline: {
        style: (0, $5z69T.padding)
    },
    paddingInlineStart: {
        style: (0, $5z69T.padding)
    },
    paddingInlineEnd: {
        style: (0, $5z69T.padding)
    },
    paddingBlock: {
        style: (0, $5z69T.padding)
    },
    paddingBlockStart: {
        style: (0, $5z69T.padding)
    },
    paddingBlockEnd: {
        style: (0, $5z69T.padding)
    },
    m: {
        style: (0, $5z69T.margin)
    },
    mt: {
        style: (0, $5z69T.margin)
    },
    mr: {
        style: (0, $5z69T.margin)
    },
    mb: {
        style: (0, $5z69T.margin)
    },
    ml: {
        style: (0, $5z69T.margin)
    },
    mx: {
        style: (0, $5z69T.margin)
    },
    my: {
        style: (0, $5z69T.margin)
    },
    margin: {
        style: (0, $5z69T.margin)
    },
    marginTop: {
        style: (0, $5z69T.margin)
    },
    marginRight: {
        style: (0, $5z69T.margin)
    },
    marginBottom: {
        style: (0, $5z69T.margin)
    },
    marginLeft: {
        style: (0, $5z69T.margin)
    },
    marginX: {
        style: (0, $5z69T.margin)
    },
    marginY: {
        style: (0, $5z69T.margin)
    },
    marginInline: {
        style: (0, $5z69T.margin)
    },
    marginInlineStart: {
        style: (0, $5z69T.margin)
    },
    marginInlineEnd: {
        style: (0, $5z69T.margin)
    },
    marginBlock: {
        style: (0, $5z69T.margin)
    },
    marginBlockStart: {
        style: (0, $5z69T.margin)
    },
    marginBlockEnd: {
        style: (0, $5z69T.margin)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $aoYMG.gap)
    },
    rowGap: {
        style: (0, $aoYMG.rowGap)
    },
    columnGap: {
        style: (0, $aoYMG.columnGap)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $8LvXe.sizingTransform)
    },
    maxWidth: {
        style: (0, $8LvXe.maxWidth)
    },
    minWidth: {
        transform: (0, $8LvXe.sizingTransform)
    },
    height: {
        transform: (0, $8LvXe.sizingTransform)
    },
    maxHeight: {
        transform: (0, $8LvXe.sizingTransform)
    },
    minHeight: {
        transform: (0, $8LvXe.sizingTransform)
    },
    boxSizing: {},
    // typography
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $d138c1b003d294d5$export$2e2bcd8739ae039 = $d138c1b003d294d5$var$defaultSxConfig;

});
parcelRegister("brmMH", function(module, exports) {

$parcel$export(module.exports, "borderTransform", function () { return $8543e3d4e0a2f626$export$34e2febe53ae29cc; });
$parcel$export(module.exports, "borderRadius", function () { return $8543e3d4e0a2f626$export$7a57f79000377ca2; });


var $190Wm = parcelRequire("190Wm");

var $eB9d8 = parcelRequire("eB9d8");

var $5z69T = parcelRequire("5z69T");

var $cvrkU = parcelRequire("cvrkU");
function $8543e3d4e0a2f626$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $8543e3d4e0a2f626$var$createBorderStyle(prop, transform) {
    return (0, $190Wm.default)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $8543e3d4e0a2f626$export$1edee58a52776cd9 = $8543e3d4e0a2f626$var$createBorderStyle('border', $8543e3d4e0a2f626$export$34e2febe53ae29cc);
const $8543e3d4e0a2f626$export$f9a7b6bd24892946 = $8543e3d4e0a2f626$var$createBorderStyle('borderTop', $8543e3d4e0a2f626$export$34e2febe53ae29cc);
const $8543e3d4e0a2f626$export$5abca33e6be905d2 = $8543e3d4e0a2f626$var$createBorderStyle('borderRight', $8543e3d4e0a2f626$export$34e2febe53ae29cc);
const $8543e3d4e0a2f626$export$e2ce9f12a980a822 = $8543e3d4e0a2f626$var$createBorderStyle('borderBottom', $8543e3d4e0a2f626$export$34e2febe53ae29cc);
const $8543e3d4e0a2f626$export$47658cca1a909427 = $8543e3d4e0a2f626$var$createBorderStyle('borderLeft', $8543e3d4e0a2f626$export$34e2febe53ae29cc);
const $8543e3d4e0a2f626$export$e7fb0694ba2404fc = $8543e3d4e0a2f626$var$createBorderStyle('borderColor');
const $8543e3d4e0a2f626$export$126a92c968acdb85 = $8543e3d4e0a2f626$var$createBorderStyle('borderTopColor');
const $8543e3d4e0a2f626$export$85cc51cb8fbb8c0e = $8543e3d4e0a2f626$var$createBorderStyle('borderRightColor');
const $8543e3d4e0a2f626$export$340b0327727f6d1a = $8543e3d4e0a2f626$var$createBorderStyle('borderBottomColor');
const $8543e3d4e0a2f626$export$60beef91a985b4bf = $8543e3d4e0a2f626$var$createBorderStyle('borderLeftColor');
const $8543e3d4e0a2f626$export$f9258c55612cbed7 = $8543e3d4e0a2f626$var$createBorderStyle('outline', $8543e3d4e0a2f626$export$34e2febe53ae29cc);
const $8543e3d4e0a2f626$export$621fe586efeb64b9 = $8543e3d4e0a2f626$var$createBorderStyle('outlineColor');
const $8543e3d4e0a2f626$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $5z69T.createUnaryUnit)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $5z69T.getValue)(transformer, propValue)
            });
        return (0, $cvrkU.handleBreakpoints)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$8543e3d4e0a2f626$export$7a57f79000377ca2.propTypes = {};
$8543e3d4e0a2f626$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $8543e3d4e0a2f626$var$borders = (0, $eB9d8.default)($8543e3d4e0a2f626$export$1edee58a52776cd9, $8543e3d4e0a2f626$export$f9a7b6bd24892946, $8543e3d4e0a2f626$export$5abca33e6be905d2, $8543e3d4e0a2f626$export$e2ce9f12a980a822, $8543e3d4e0a2f626$export$47658cca1a909427, $8543e3d4e0a2f626$export$e7fb0694ba2404fc, $8543e3d4e0a2f626$export$126a92c968acdb85, $8543e3d4e0a2f626$export$85cc51cb8fbb8c0e, $8543e3d4e0a2f626$export$340b0327727f6d1a, $8543e3d4e0a2f626$export$60beef91a985b4bf, $8543e3d4e0a2f626$export$7a57f79000377ca2, $8543e3d4e0a2f626$export$f9258c55612cbed7, $8543e3d4e0a2f626$export$621fe586efeb64b9);
var $8543e3d4e0a2f626$export$2e2bcd8739ae039 = $8543e3d4e0a2f626$var$borders;

});
parcelRegister("eB9d8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa0baa79cee865b3$export$2e2bcd8739ae039; });

var $4So0q = parcelRequire("4So0q");
function $aa0baa79cee865b3$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $4So0q.default)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $aa0baa79cee865b3$export$2e2bcd8739ae039 = $aa0baa79cee865b3$var$compose;

});


parcelRegister("aoYMG", function(module, exports) {

$parcel$export(module.exports, "gap", function () { return $792b4bc41110be3c$export$5df9adcb0db95e1e; });
$parcel$export(module.exports, "columnGap", function () { return $792b4bc41110be3c$export$ec60d70ff941a580; });
$parcel$export(module.exports, "rowGap", function () { return $792b4bc41110be3c$export$8a833ffa5f5dbeda; });

var $190Wm = parcelRequire("190Wm");

var $eB9d8 = parcelRequire("eB9d8");

var $5z69T = parcelRequire("5z69T");

var $cvrkU = parcelRequire("cvrkU");

const $792b4bc41110be3c$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $5z69T.createUnaryUnit)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $5z69T.getValue)(transformer, propValue)
            });
        return (0, $cvrkU.handleBreakpoints)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$792b4bc41110be3c$export$5df9adcb0db95e1e.propTypes = {};
$792b4bc41110be3c$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $792b4bc41110be3c$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $5z69T.createUnaryUnit)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $5z69T.getValue)(transformer, propValue)
            });
        return (0, $cvrkU.handleBreakpoints)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$792b4bc41110be3c$export$ec60d70ff941a580.propTypes = {};
$792b4bc41110be3c$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $792b4bc41110be3c$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $5z69T.createUnaryUnit)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $5z69T.getValue)(transformer, propValue)
            });
        return (0, $cvrkU.handleBreakpoints)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$792b4bc41110be3c$export$8a833ffa5f5dbeda.propTypes = {};
$792b4bc41110be3c$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $792b4bc41110be3c$export$baf44164ca3a34e8 = (0, $190Wm.default)({
    prop: 'gridColumn'
});
const $792b4bc41110be3c$export$8f7213a1cd01e832 = (0, $190Wm.default)({
    prop: 'gridRow'
});
const $792b4bc41110be3c$export$b0e0abbc49ba668 = (0, $190Wm.default)({
    prop: 'gridAutoFlow'
});
const $792b4bc41110be3c$export$bcd8b929d4b4142 = (0, $190Wm.default)({
    prop: 'gridAutoColumns'
});
const $792b4bc41110be3c$export$e5039a674e14c828 = (0, $190Wm.default)({
    prop: 'gridAutoRows'
});
const $792b4bc41110be3c$export$42bd9088661ffb03 = (0, $190Wm.default)({
    prop: 'gridTemplateColumns'
});
const $792b4bc41110be3c$export$920682ae05b999bc = (0, $190Wm.default)({
    prop: 'gridTemplateRows'
});
const $792b4bc41110be3c$export$1b88fbdd482fd33a = (0, $190Wm.default)({
    prop: 'gridTemplateAreas'
});
const $792b4bc41110be3c$export$bdb486e40d52d26f = (0, $190Wm.default)({
    prop: 'gridArea'
});
const $792b4bc41110be3c$var$grid = (0, $eB9d8.default)($792b4bc41110be3c$export$5df9adcb0db95e1e, $792b4bc41110be3c$export$ec60d70ff941a580, $792b4bc41110be3c$export$8a833ffa5f5dbeda, $792b4bc41110be3c$export$baf44164ca3a34e8, $792b4bc41110be3c$export$8f7213a1cd01e832, $792b4bc41110be3c$export$b0e0abbc49ba668, $792b4bc41110be3c$export$bcd8b929d4b4142, $792b4bc41110be3c$export$e5039a674e14c828, $792b4bc41110be3c$export$42bd9088661ffb03, $792b4bc41110be3c$export$920682ae05b999bc, $792b4bc41110be3c$export$1b88fbdd482fd33a, $792b4bc41110be3c$export$bdb486e40d52d26f);
var $792b4bc41110be3c$export$2e2bcd8739ae039 = $792b4bc41110be3c$var$grid;

});

parcelRegister("lzsJx", function(module, exports) {

$parcel$export(module.exports, "paletteTransform", function () { return $fb4327c08e40e84e$export$dbaffd4420ea0ac6; });

var $190Wm = parcelRequire("190Wm");

var $eB9d8 = parcelRequire("eB9d8");
function $fb4327c08e40e84e$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $fb4327c08e40e84e$export$35e9368ef982300f = (0, $190Wm.default)({
    prop: 'color',
    themeKey: 'palette',
    transform: $fb4327c08e40e84e$export$dbaffd4420ea0ac6
});
const $fb4327c08e40e84e$export$2506f56c10355b33 = (0, $190Wm.default)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $fb4327c08e40e84e$export$dbaffd4420ea0ac6
});
const $fb4327c08e40e84e$export$8c5a050822fd698c = (0, $190Wm.default)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $fb4327c08e40e84e$export$dbaffd4420ea0ac6
});
const $fb4327c08e40e84e$var$palette = (0, $eB9d8.default)($fb4327c08e40e84e$export$35e9368ef982300f, $fb4327c08e40e84e$export$2506f56c10355b33, $fb4327c08e40e84e$export$8c5a050822fd698c);
var $fb4327c08e40e84e$export$2e2bcd8739ae039 = $fb4327c08e40e84e$var$palette;

});

parcelRegister("8LvXe", function(module, exports) {

$parcel$export(module.exports, "sizingTransform", function () { return $661b7ffebb8ef134$export$8afece71750ec241; });
$parcel$export(module.exports, "maxWidth", function () { return $661b7ffebb8ef134$export$488fda99655ff65a; });

var $190Wm = parcelRequire("190Wm");

var $eB9d8 = parcelRequire("eB9d8");

var $cvrkU = parcelRequire("cvrkU");
function $661b7ffebb8ef134$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $661b7ffebb8ef134$export$7e3df82ee760448c = (0, $190Wm.default)({
    prop: 'width',
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            var _props$theme, _props$theme2;
            const breakpoint = ((_props$theme = props.theme) == null || (_props$theme = _props$theme.breakpoints) == null || (_props$theme = _props$theme.values) == null ? void 0 : _props$theme[propValue]) || (0, $cvrkU.values)[propValue];
            if (!breakpoint) return {
                maxWidth: $661b7ffebb8ef134$export$8afece71750ec241(propValue)
            };
            if (((_props$theme2 = props.theme) == null || (_props$theme2 = _props$theme2.breakpoints) == null ? void 0 : _props$theme2.unit) !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $cvrkU.handleBreakpoints)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$661b7ffebb8ef134$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $661b7ffebb8ef134$export$ee148fbbe8357dd2 = (0, $190Wm.default)({
    prop: 'minWidth',
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$ac607276a8fe9f0a = (0, $190Wm.default)({
    prop: 'height',
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$dc0d8bd0b94f8570 = (0, $190Wm.default)({
    prop: 'maxHeight',
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$a43cf604e12f3b17 = (0, $190Wm.default)({
    prop: 'minHeight',
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$ffed9f14fb65e276 = (0, $190Wm.default)({
    prop: 'size',
    cssProperty: 'width',
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$905076ed6620e671 = (0, $190Wm.default)({
    prop: 'size',
    cssProperty: 'height',
    transform: $661b7ffebb8ef134$export$8afece71750ec241
});
const $661b7ffebb8ef134$export$6ccc93f785106a58 = (0, $190Wm.default)({
    prop: 'boxSizing'
});
const $661b7ffebb8ef134$var$sizing = (0, $eB9d8.default)($661b7ffebb8ef134$export$7e3df82ee760448c, $661b7ffebb8ef134$export$488fda99655ff65a, $661b7ffebb8ef134$export$ee148fbbe8357dd2, $661b7ffebb8ef134$export$ac607276a8fe9f0a, $661b7ffebb8ef134$export$dc0d8bd0b94f8570, $661b7ffebb8ef134$export$a43cf604e12f3b17, $661b7ffebb8ef134$export$6ccc93f785106a58);
var $661b7ffebb8ef134$export$2e2bcd8739ae039 = $661b7ffebb8ef134$var$sizing;

});



parcelRegister("56TFl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b88b157d6186746$export$2e2bcd8739ae039; });
/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/experimental-api/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 *
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={theme => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $3b88b157d6186746$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars && typeof theme.getColorSchemeSelector === 'function') {
        // If CssVarsProvider is used as a provider,
        // returns '* :where([data-mui-color-scheme="light|dark"]) &'
        const selector = theme.getColorSchemeSelector(key).replace(/(\[[^\]]+\])/, '*:where($1)');
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}

});



parcelRegister("3aVNX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("8M6a3")).default; });
$parcel$export(module.exports, "unstable_createStyleFunctionSx", function () { return (parcelRequire("8M6a3")).unstable_createStyleFunctionSx; });
$parcel$export(module.exports, "extendSxProp", function () { return (parcelRequire("mqrnX")).default; });
$parcel$export(module.exports, "unstable_defaultSxConfig", function () { return (parcelRequire("hXGiu")).default; });

var $8M6a3 = parcelRequire("8M6a3");

var $mqrnX = parcelRequire("mqrnX");

var $hXGiu = parcelRequire("hXGiu");

});
parcelRegister("mqrnX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $043690c2de8ba6fa$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $3wRTY = parcelRequire("3wRTY");

var $hXGiu = parcelRequire("hXGiu");
const $043690c2de8ba6fa$var$_excluded = [
    "sx"
];
const $043690c2de8ba6fa$var$splitProps = (props)=>{
    var _props$theme$unstable, _props$theme;
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = (_props$theme$unstable = props == null || (_props$theme = props.theme) == null ? void 0 : _props$theme.unstable_sxConfig) != null ? _props$theme$unstable : (0, $hXGiu.default);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $043690c2de8ba6fa$export$2e2bcd8739ae039(props) {
    const { sx: inSx } = props, other = (0, $cFLic.default)(props, $043690c2de8ba6fa$var$_excluded);
    const { systemProps: systemProps, otherProps: otherProps } = $043690c2de8ba6fa$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $3wRTY.isPlainObject)(result)) return systemProps;
        return (0, $kY3Ke.default)({}, systemProps, result);
    };
    else finalSx = (0, $kY3Ke.default)({}, systemProps, inSx);
    return (0, $kY3Ke.default)({}, otherProps, {
        sx: finalSx
    });
}

});


parcelRegister("3xowt", function(module, exports) {
"use strict";
'use client';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $6PKLM.default;
    }
});

var $6PKLM = parcelRequire("6PKLM");

});
parcelRegister("6PKLM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f9bc8f83648f682$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");

var $freJ2 = parcelRequire("freJ2");

var $bbzbN = parcelRequire("bbzbN");
'use client';
function $4f9bc8f83648f682$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $freJ2.default), (0, $kY3Ke.default)({
            "data-testid": `${displayName}Icon`,
            ref: ref
        }, props, {
            children: path
        }));
    }
    Component.muiName = (0, $freJ2.default).muiName;
    return /*#__PURE__*/ $7fPBF.memo(/*#__PURE__*/ $7fPBF.forwardRef(Component));
}

});
parcelRegister("freJ2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b3d4ccc5f426d62a$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $b6UUh = parcelRequire("b6UUh");

var $iVAEr = parcelRequire("iVAEr");

var $kDBhE = parcelRequire("kDBhE");

var $6VWZo = parcelRequire("6VWZo");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $b3d4ccc5f426d62a$var$_excluded = [
    "children",
    "className",
    "color",
    "component",
    "fontSize",
    "htmlColor",
    "inheritViewBox",
    "titleAccess",
    "viewBox"
];
const $b3d4ccc5f426d62a$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $b6UUh.default)(color)}`,
            `fontSize${(0, $b6UUh.default)(fontSize)}`
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $6VWZo.getSvgIconUtilityClass), classes);
};
const $b3d4ccc5f426d62a$var$SvgIconRoot = (0, $kDBhE.default)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $b6UUh.default)(ownerState.color)}`],
            styles[`fontSize${(0, $b6UUh.default)(ownerState.fontSize)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$transitions, _theme$transitions$cr, _theme$transitions2, _theme$typography, _theme$typography$pxT, _theme$typography2, _theme$typography2$px, _theme$typography3, _theme$typography3$px, _palette$ownerState$c, _palette, _palette2, _palette3;
    return {
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        // the <svg> will define the property that has `currentColor`
        // for example heroicons uses fill="none" and stroke="currentColor"
        fill: ownerState.hasSvgAsChild ? undefined : 'currentColor',
        flexShrink: 0,
        transition: (_theme$transitions = theme.transitions) == null || (_theme$transitions$cr = _theme$transitions.create) == null ? void 0 : _theme$transitions$cr.call(_theme$transitions, 'fill', {
            duration: (_theme$transitions2 = theme.transitions) == null || (_theme$transitions2 = _theme$transitions2.duration) == null ? void 0 : _theme$transitions2.shorter
        }),
        fontSize: ({
            inherit: 'inherit',
            small: ((_theme$typography = theme.typography) == null || (_theme$typography$pxT = _theme$typography.pxToRem) == null ? void 0 : _theme$typography$pxT.call(_theme$typography, 20)) || '1.25rem',
            medium: ((_theme$typography2 = theme.typography) == null || (_theme$typography2$px = _theme$typography2.pxToRem) == null ? void 0 : _theme$typography2$px.call(_theme$typography2, 24)) || '1.5rem',
            large: ((_theme$typography3 = theme.typography) == null || (_theme$typography3$px = _theme$typography3.pxToRem) == null ? void 0 : _theme$typography3$px.call(_theme$typography3, 35)) || '2.1875rem'
        })[ownerState.fontSize],
        // TODO v5 deprecate, v6 remove for sx
        color: (_palette$ownerState$c = (_palette = (theme.vars || theme).palette) == null || (_palette = _palette[ownerState.color]) == null ? void 0 : _palette.main) != null ? _palette$ownerState$c : ({
            action: (_palette2 = (theme.vars || theme).palette) == null || (_palette2 = _palette2.action) == null ? void 0 : _palette2.active,
            disabled: (_palette3 = (theme.vars || theme).palette) == null || (_palette3 = _palette3.action) == null ? void 0 : _palette3.disabled,
            inherit: undefined
        })[ownerState.color]
    };
});
const $b3d4ccc5f426d62a$var$SvgIcon = /*#__PURE__*/ $7fPBF.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24' } = props, other = (0, $cFLic.default)(props, $b3d4ccc5f426d62a$var$_excluded);
    const hasSvgAsChild = /*#__PURE__*/ $7fPBF.isValidElement(children) && children.type === 'svg';
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    });
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $b3d4ccc5f426d62a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($b3d4ccc5f426d62a$var$SvgIconRoot, (0, $kY3Ke.default)({
        as: component,
        className: (0, $hngXp.default)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref
    }, more, other, hasSvgAsChild && children.props, {
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $bbzbN.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    }));
});
$b3d4ccc5f426d62a$var$SvgIcon.muiName = 'SvgIcon';
var $b3d4ccc5f426d62a$export$2e2bcd8739ae039 = $b3d4ccc5f426d62a$var$SvgIcon;

});
parcelRegister("hngXp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07a883fe7c352c85$export$2e2bcd8739ae039; });
function $07a883fe7c352c85$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $07a883fe7c352c85$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $07a883fe7c352c85$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $07a883fe7c352c85$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $07a883fe7c352c85$export$2e2bcd8739ae039 = $07a883fe7c352c85$export$4f5d2d50c9deca37;

});

parcelRegister("cFCqu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93971f0806345477$export$2e2bcd8739ae039; });
function $93971f0806345477$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    Object.keys(slots).forEach(// `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (slot)=>{
        output[slot] = slots[slot].reduce((acc, key)=>{
            if (key) {
                const utilityClass = getUtilityClass(key);
                if (utilityClass !== '') acc.push(utilityClass);
                if (classes && classes[key]) acc.push(classes[key]);
            }
            return acc;
        }, []).join(' ');
    });
    return output;
}

});

parcelRegister("b6UUh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $816c65c0e1f7082c$export$2e2bcd8739ae039; });

var $iCiVn = parcelRequire("iCiVn");
var $816c65c0e1f7082c$export$2e2bcd8739ae039 = (0, $iCiVn.default);

});

parcelRegister("iVAEr", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $dc79fb0f6686e80b$export$2440da353cedad43; });

var $kY3Ke = parcelRequire("kY3Ke");
parcelRequire("7fPBF");


var $7eatR = parcelRequire("7eatR");

var $bbzbN = parcelRequire("bbzbN");
'use client';
function $dc79fb0f6686e80b$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7eatR.default), (0, $kY3Ke.default)({}, props));
}
var $dc79fb0f6686e80b$export$2e2bcd8739ae039 = $dc79fb0f6686e80b$var$DefaultPropsProvider;
function $dc79fb0f6686e80b$export$2440da353cedad43(params) {
    return (0, $7eatR.useDefaultProps)(params);
}

});
parcelRegister("7eatR", function(module, exports) {

$parcel$export(module.exports, "useDefaultProps", function () { return $5431f86afe49fae8$export$2440da353cedad43; });
$parcel$export(module.exports, "default", function () { return $5431f86afe49fae8$export$2e2bcd8739ae039; });

var $7fPBF = parcelRequire("7fPBF");


var $gjk5S = parcelRequire("gjk5S");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $5431f86afe49fae8$var$PropsContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
function $5431f86afe49fae8$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $bbzbN.jsx)($5431f86afe49fae8$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $5431f86afe49fae8$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $gjk5S.default)(config.defaultProps, props);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $gjk5S.default)(config, props);
    return props;
}
function $5431f86afe49fae8$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $7fPBF.useContext($5431f86afe49fae8$var$PropsContext);
    return $5431f86afe49fae8$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $5431f86afe49fae8$export$2e2bcd8739ae039 = $5431f86afe49fae8$var$DefaultPropsProvider;

});
parcelRegister("gjk5S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bdfe01df7c24351f$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");
function $bdfe01df7c24351f$export$2e2bcd8739ae039(defaultProps, props) {
    const output = (0, $kY3Ke.default)({}, props);
    Object.keys(defaultProps).forEach((propName)=>{
        if (propName.toString().match(/^(components|slots)$/)) output[propName] = (0, $kY3Ke.default)({}, defaultProps[propName], output[propName]);
        else if (propName.toString().match(/^(componentsProps|slotProps)$/)) {
            const defaultSlotProps = defaultProps[propName] || {};
            const slotProps = props[propName];
            output[propName] = {};
            if (!slotProps || !Object.keys(slotProps)) // Reduce the iteration if the slot props is empty
            output[propName] = defaultSlotProps;
            else if (!defaultSlotProps || !Object.keys(defaultSlotProps)) // Reduce the iteration if the default slot props is empty
            output[propName] = slotProps;
            else {
                output[propName] = (0, $kY3Ke.default)({}, slotProps);
                Object.keys(defaultSlotProps).forEach((slotPropName)=>{
                    output[propName][slotPropName] = $bdfe01df7c24351f$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName]);
                });
            }
        } else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    });
    return output;
}

});



parcelRegister("kDBhE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0645ef192f222f7$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "rootShouldForwardProp", function () { return (parcelRequire("HgAeG")).default; });

var $9xny7 = parcelRequire("9xny7");

var $9P91Y = parcelRequire("9P91Y");

var $jwhZE = parcelRequire("jwhZE");

var $HgAeG = parcelRequire("HgAeG");

'use client';
const $f0645ef192f222f7$var$styled = (0, (/*@__PURE__*/$parcel$interopDefault($9xny7)))({
    themeId: (0, $jwhZE.default),
    defaultTheme: $9P91Y.default,
    rootShouldForwardProp: $HgAeG.default
});
var $f0645ef192f222f7$export$2e2bcd8739ae039 = $f0645ef192f222f7$var$styled;

});
parcelRegister("9xny7", function(module, exports) {
"use strict";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6f197680cb170281$var$createStyled;
module.exports.shouldForwardProp = $6f197680cb170281$var$shouldForwardProp;
module.exports.systemDefaultTheme = void 0;

var $6f197680cb170281$var$_extends2 = $62qsu((parcelRequire("cvBp9")));

var $6f197680cb170281$var$_objectWithoutPropertiesLoose2 = $62qsu((parcelRequire("1ifJj")));

var $6f197680cb170281$var$_styledEngine = $6f197680cb170281$var$_interopRequireWildcard((parcelRequire("5VCcJ")));

var $3wRTY = parcelRequire("3wRTY");

var $6f197680cb170281$var$_capitalize = $62qsu((parcelRequire("3oBOp")));

var $6f197680cb170281$var$_getDisplayName = $62qsu((parcelRequire("ehv4n")));

var $6f197680cb170281$var$_createTheme = $62qsu((parcelRequire("eqNKX")));

var $6f197680cb170281$var$_styleFunctionSx = $62qsu((parcelRequire("3aVNX")));
const $6f197680cb170281$var$_excluded = [
    "ownerState"
], $6f197680cb170281$var$_excluded2 = [
    "variants"
], $6f197680cb170281$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
/* eslint-disable no-underscore-dangle */ function $6f197680cb170281$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($6f197680cb170281$var$_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function $6f197680cb170281$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = $6f197680cb170281$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function $6f197680cb170281$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $6f197680cb170281$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
// Update /system/styled/#api in case if this changes
function $6f197680cb170281$var$shouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $6f197680cb170281$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
const $6f197680cb170281$var$systemDefaultTheme = module.exports.systemDefaultTheme = (0, $6f197680cb170281$var$_createTheme.default)();
const $6f197680cb170281$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $6f197680cb170281$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $6f197680cb170281$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $6f197680cb170281$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $6f197680cb170281$var$processStyleArg(callableStyle, _ref, layerName) {
    let { ownerState: ownerState } = _ref, props = (0, $6f197680cb170281$var$_objectWithoutPropertiesLoose2.default)(_ref, $6f197680cb170281$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $6f197680cb170281$var$_extends2.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$6f197680cb170281$var$processStyleArg(resolvedStyle, (0, $6f197680cb170281$var$_extends2.default)({
            ownerState: ownerState
        }, props), layerName));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $6f197680cb170281$var$_objectWithoutPropertiesLoose2.default)(resolvedStylesArg, $6f197680cb170281$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $6f197680cb170281$var$_extends2.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                const variantStyle = typeof variant.style === 'function' ? variant.style((0, $6f197680cb170281$var$_extends2.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style;
                result.push(layerName ? $6f197680cb170281$var$shallowLayer((0, $6f197680cb170281$var$_styledEngine.internal_serializeStyles)(variantStyle), layerName) : variantStyle);
            }
        });
        return result;
    }
    return layerName ? $6f197680cb170281$var$shallowLayer((0, $6f197680cb170281$var$_styledEngine.internal_serializeStyles)(resolvedStylesArg), layerName) : resolvedStylesArg;
}
function $6f197680cb170281$var$createStyled(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $6f197680cb170281$var$systemDefaultTheme, rootShouldForwardProp: rootShouldForwardProp = $6f197680cb170281$var$shouldForwardProp, slotShouldForwardProp: slotShouldForwardProp = $6f197680cb170281$var$shouldForwardProp } = input;
    const systemSx = (props)=>{
        return (0, $6f197680cb170281$var$_styleFunctionSx.default)((0, $6f197680cb170281$var$_extends2.default)({}, props, {
            theme: $6f197680cb170281$var$resolveTheme((0, $6f197680cb170281$var$_extends2.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $6f197680cb170281$var$_styledEngine.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $6f197680cb170281$var$defaultOverridesResolver($6f197680cb170281$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $6f197680cb170281$var$_objectWithoutPropertiesLoose2.default)(inputOptions, $6f197680cb170281$var$_excluded3);
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $6f197680cb170281$var$shouldForwardProp;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($6f197680cb170281$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $6f197680cb170281$var$_styledEngine.default)(tag, (0, $6f197680cb170281$var$_extends2.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $3wRTY.isPlainObject)(stylesArg)) return (props)=>{
                const theme = $6f197680cb170281$var$resolveTheme({
                    theme: props.theme,
                    defaultTheme: defaultTheme,
                    themeId: themeId
                });
                return $6f197680cb170281$var$processStyleArg(stylesArg, (0, $6f197680cb170281$var$_extends2.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? layerName : undefined);
            };
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $6f197680cb170281$var$resolveTheme((0, $6f197680cb170281$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $6f197680cb170281$var$processStyleArg(slotStyle, (0, $6f197680cb170281$var$_extends2.default)({}, props, {
                        theme: theme
                    }), theme.modularCssLayers ? 'theme' : undefined);
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $6f197680cb170281$var$resolveTheme((0, $6f197680cb170281$var$_extends2.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $6f197680cb170281$var$processStyleArg({
                    variants: themeVariants
                }, (0, $6f197680cb170281$var$_extends2.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}

});
parcelRegister("62qsu", function(module, exports) {
function $4657741705a128f0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $4657741705a128f0$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("9P91Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $726fe1d2377a5002$export$2e2bcd8739ae039; });

var $hmhHQ = parcelRequire("hmhHQ");
'use client';
const $726fe1d2377a5002$var$defaultTheme = (0, $hmhHQ.default)();
var $726fe1d2377a5002$export$2e2bcd8739ae039 = $726fe1d2377a5002$var$defaultTheme;

});
parcelRegister("hmhHQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca3239ce6bf6e490$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $diYUK = parcelRequire("diYUK");

var $3wRTY = parcelRequire("3wRTY");

var $hXGiu = parcelRequire("hXGiu");
var $8M6a3 = parcelRequire("8M6a3");

var $2G6xE = parcelRequire("2G6xE");


var $oPCQw = parcelRequire("oPCQw");

var $G7KID = parcelRequire("G7KID");

var $5vuSA = parcelRequire("5vuSA");

var $3jGgo = parcelRequire("3jGgo");

var $kjiCM = parcelRequire("kjiCM");

var $eGmqa = parcelRequire("eGmqa");
const $ca3239ce6bf6e490$var$_excluded = [
    "breakpoints",
    "mixins",
    "spacing",
    "palette",
    "transitions",
    "typography",
    "shape"
];
function $ca3239ce6bf6e490$var$createTheme(options = {}, ...args) {
    const { mixins: mixinsInput = {}, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {} } = options, other = (0, $cFLic.default)(options, $ca3239ce6bf6e490$var$_excluded);
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateCssVars` is the closest identifier for checking that the `options` is a result of `extendTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateCssVars === undefined) throw new Error((0, $diYUK.default)(18));
    const palette = (0, $G7KID.default)(paletteInput);
    const systemTheme = (0, $2G6xE.default)(options);
    let muiTheme = (0, $3wRTY.default)(systemTheme, {
        mixins: (0, $oPCQw.default)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $3jGgo.default).slice(),
        typography: (0, $5vuSA.default)(palette, typographyInput),
        transitions: (0, $kjiCM.default)(transitionsInput),
        zIndex: (0, $kY3Ke.default)({}, (0, $eGmqa.default))
    });
    muiTheme = (0, $3wRTY.default)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $3wRTY.default)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = (0, $kY3Ke.default)({}, (0, $hXGiu.default), other == null ? void 0 : other.unstable_sxConfig);
    muiTheme.unstable_sx = function sx(props) {
        return (0, $8M6a3.default)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
let $ca3239ce6bf6e490$var$warnedOnce = false;
function $ca3239ce6bf6e490$export$c469355549431d9b(...args) {
    return $ca3239ce6bf6e490$var$createTheme(...args);
}
var $ca3239ce6bf6e490$export$2e2bcd8739ae039 = $ca3239ce6bf6e490$var$createTheme;

});
parcelRegister("oPCQw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04aa49c3b5b31b02$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");
function $04aa49c3b5b31b02$export$2e2bcd8739ae039(breakpoints, mixins) {
    return (0, $kY3Ke.default)({
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        }
    }, mixins);
}

});

parcelRegister("G7KID", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07e9efd96a5c6f8a$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $diYUK = parcelRequire("diYUK");

var $3wRTY = parcelRequire("3wRTY");

var $7jL4F = parcelRequire("7jL4F");

var $6akYf = parcelRequire("6akYf");

var $2nhXL = parcelRequire("2nhXL");

var $3Ctzq = parcelRequire("3Ctzq");

var $9PTBs = parcelRequire("9PTBs");

var $5WQac = parcelRequire("5WQac");

var $gal31 = parcelRequire("gal31");

var $1Btry = parcelRequire("1Btry");

var $hnm6Q = parcelRequire("hnm6Q");
const $07e9efd96a5c6f8a$var$_excluded = [
    "mode",
    "contrastThreshold",
    "tonalOffset"
];
const $07e9efd96a5c6f8a$export$a43af521ac8c3202 = {
    // The colors used to style the text.
    text: {
        // The most important text.
        primary: 'rgba(0, 0, 0, 0.87)',
        // Secondary text.
        secondary: 'rgba(0, 0, 0, 0.6)',
        // Disabled text have even lower visual prominence.
        disabled: 'rgba(0, 0, 0, 0.38)'
    },
    // The color used to divide different elements.
    divider: 'rgba(0, 0, 0, 0.12)',
    // The background colors used to style the surfaces.
    // Consistency between these values is important.
    background: {
        paper: (0, $6akYf.default).white,
        default: (0, $6akYf.default).white
    },
    // The colors used to style the action elements.
    action: {
        // The color of an active action like an icon button.
        active: 'rgba(0, 0, 0, 0.54)',
        // The color of an hovered action.
        hover: 'rgba(0, 0, 0, 0.04)',
        hoverOpacity: 0.04,
        // The color of a selected action.
        selected: 'rgba(0, 0, 0, 0.08)',
        selectedOpacity: 0.08,
        // The color of a disabled action.
        disabled: 'rgba(0, 0, 0, 0.26)',
        // The background color of a disabled action.
        disabledBackground: 'rgba(0, 0, 0, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(0, 0, 0, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.12
    }
};
const $07e9efd96a5c6f8a$export$55ce6f3a06c59543 = {
    text: {
        primary: (0, $6akYf.default).white,
        secondary: 'rgba(255, 255, 255, 0.7)',
        disabled: 'rgba(255, 255, 255, 0.5)',
        icon: 'rgba(255, 255, 255, 0.5)'
    },
    divider: 'rgba(255, 255, 255, 0.12)',
    background: {
        paper: '#121212',
        default: '#121212'
    },
    action: {
        active: (0, $6akYf.default).white,
        hover: 'rgba(255, 255, 255, 0.08)',
        hoverOpacity: 0.08,
        selected: 'rgba(255, 255, 255, 0.16)',
        selectedOpacity: 0.16,
        disabled: 'rgba(255, 255, 255, 0.3)',
        disabledBackground: 'rgba(255, 255, 255, 0.12)',
        disabledOpacity: 0.38,
        focus: 'rgba(255, 255, 255, 0.12)',
        focusOpacity: 0.12,
        activatedOpacity: 0.24
    }
};
function $07e9efd96a5c6f8a$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $7jL4F.lighten)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $7jL4F.darken)(intent.main, tonalOffsetDark);
    }
}
function $07e9efd96a5c6f8a$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $gal31.default)[200],
        light: (0, $gal31.default)[50],
        dark: (0, $gal31.default)[400]
    };
    return {
        main: (0, $gal31.default)[700],
        light: (0, $gal31.default)[400],
        dark: (0, $gal31.default)[800]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $3Ctzq.default)[200],
        light: (0, $3Ctzq.default)[50],
        dark: (0, $3Ctzq.default)[400]
    };
    return {
        main: (0, $3Ctzq.default)[500],
        light: (0, $3Ctzq.default)[300],
        dark: (0, $3Ctzq.default)[700]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $9PTBs.default)[500],
        light: (0, $9PTBs.default)[300],
        dark: (0, $9PTBs.default)[700]
    };
    return {
        main: (0, $9PTBs.default)[700],
        light: (0, $9PTBs.default)[400],
        dark: (0, $9PTBs.default)[800]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $1Btry.default)[400],
        light: (0, $1Btry.default)[300],
        dark: (0, $1Btry.default)[700]
    };
    return {
        main: (0, $1Btry.default)[700],
        light: (0, $1Btry.default)[500],
        dark: (0, $1Btry.default)[900]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $hnm6Q.default)[400],
        light: (0, $hnm6Q.default)[300],
        dark: (0, $hnm6Q.default)[700]
    };
    return {
        main: (0, $hnm6Q.default)[800],
        light: (0, $hnm6Q.default)[500],
        dark: (0, $hnm6Q.default)[900]
    };
}
function $07e9efd96a5c6f8a$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $5WQac.default)[400],
        light: (0, $5WQac.default)[300],
        dark: (0, $5WQac.default)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $5WQac.default)[500],
        dark: (0, $5WQac.default)[900]
    };
}
function $07e9efd96a5c6f8a$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2 } = palette, other = (0, $cFLic.default)(palette, $07e9efd96a5c6f8a$var$_excluded);
    const primary = palette.primary || $07e9efd96a5c6f8a$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $07e9efd96a5c6f8a$var$getDefaultSecondary(mode);
    const error = palette.error || $07e9efd96a5c6f8a$var$getDefaultError(mode);
    const info = palette.info || $07e9efd96a5c6f8a$var$getDefaultInfo(mode);
    const success = palette.success || $07e9efd96a5c6f8a$var$getDefaultSuccess(mode);
    const warning = palette.warning || $07e9efd96a5c6f8a$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        const contrastText = (0, $7jL4F.getContrastRatio)(background, $07e9efd96a5c6f8a$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $07e9efd96a5c6f8a$export$55ce6f3a06c59543.text.primary : $07e9efd96a5c6f8a$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = (0, $kY3Ke.default)({}, color);
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $diYUK.default)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $diYUK.default)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        $07e9efd96a5c6f8a$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
        $07e9efd96a5c6f8a$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    const modes = {
        dark: $07e9efd96a5c6f8a$export$55ce6f3a06c59543,
        light: $07e9efd96a5c6f8a$export$a43af521ac8c3202
    };
    const paletteOutput = (0, $3wRTY.default)((0, $kY3Ke.default)({
        // A collection of common colors.
        common: (0, $kY3Ke.default)({}, (0, $6akYf.default)),
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $2nhXL.default,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset
    }, modes[mode]), other);
    return paletteOutput;
}

});
parcelRegister("7jL4F", function(module, exports) {
"use strict";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.alpha = $553ed2baba4347ed$var$alpha;
module.exports.blend = $553ed2baba4347ed$var$blend;
module.exports.colorChannel = void 0;
module.exports.darken = $553ed2baba4347ed$var$darken;
module.exports.decomposeColor = $553ed2baba4347ed$var$decomposeColor;
module.exports.emphasize = $553ed2baba4347ed$var$emphasize;
module.exports.getContrastRatio = $553ed2baba4347ed$var$getContrastRatio;
module.exports.getLuminance = $553ed2baba4347ed$var$getLuminance;
module.exports.hexToRgb = $553ed2baba4347ed$var$hexToRgb;
module.exports.hslToRgb = $553ed2baba4347ed$var$hslToRgb;
module.exports.lighten = $553ed2baba4347ed$var$lighten;
module.exports.private_safeAlpha = $553ed2baba4347ed$var$private_safeAlpha;
module.exports.private_safeColorChannel = void 0;
module.exports.private_safeDarken = $553ed2baba4347ed$var$private_safeDarken;
module.exports.private_safeEmphasize = $553ed2baba4347ed$var$private_safeEmphasize;
module.exports.private_safeLighten = $553ed2baba4347ed$var$private_safeLighten;
module.exports.recomposeColor = $553ed2baba4347ed$var$recomposeColor;
module.exports.rgbToHex = $553ed2baba4347ed$var$rgbToHex;

var $553ed2baba4347ed$var$_formatMuiErrorMessage2 = $62qsu((parcelRequire("gzcup")));

var $553ed2baba4347ed$var$_clamp = $62qsu((parcelRequire("8m7yE")));
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $553ed2baba4347ed$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $553ed2baba4347ed$var$_clamp.default)(value, min, max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */ function $553ed2baba4347ed$var$hexToRgb(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $553ed2baba4347ed$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */ function $553ed2baba4347ed$var$decomposeColor(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $553ed2baba4347ed$var$decomposeColor($553ed2baba4347ed$var$hexToRgb(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if ([
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].indexOf(type) === -1) throw new Error((0, $553ed2baba4347ed$var$_formatMuiErrorMessage2.default)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if ([
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].indexOf(colorSpace) === -1) throw new Error((0, $553ed2baba4347ed$var$_formatMuiErrorMessage2.default)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
/**
 * Returns a channel created from the input color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {string} - The channel for the color, that can be used in rgba or hsla colors
 */ const $553ed2baba4347ed$var$colorChannel = (color)=>{
    const decomposedColor = $553ed2baba4347ed$var$decomposeColor(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.indexOf('hsl') !== -1 && idx !== 0 ? `${val}%` : val).join(' ');
};
module.exports.colorChannel = $553ed2baba4347ed$var$colorChannel;
const $553ed2baba4347ed$var$private_safeColorChannel = (color, warning)=>{
    try {
        return $553ed2baba4347ed$var$colorChannel(color);
    } catch (error) {
        return color;
    }
};
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla', 'color'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */ module.exports.private_safeColorChannel = $553ed2baba4347ed$var$private_safeColorChannel;
function $553ed2baba4347ed$var$recomposeColor(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.indexOf('rgb') !== -1) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */ function $553ed2baba4347ed$var$rgbToHex(color) {
    // Idempotent
    if (color.indexOf('#') === 0) return color;
    const { values: values } = $553ed2baba4347ed$var$decomposeColor(color);
    return `#${values.map((n, i)=>$553ed2baba4347ed$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */ function $553ed2baba4347ed$var$hslToRgb(color) {
    color = $553ed2baba4347ed$var$decomposeColor(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $553ed2baba4347ed$var$recomposeColor({
        type: type,
        values: rgb
    });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */ function $553ed2baba4347ed$var$getLuminance(color) {
    color = $553ed2baba4347ed$var$decomposeColor(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $553ed2baba4347ed$var$decomposeColor($553ed2baba4347ed$var$hslToRgb(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */ function $553ed2baba4347ed$var$getContrastRatio(foreground, background) {
    const lumA = $553ed2baba4347ed$var$getLuminance(foreground);
    const lumB = $553ed2baba4347ed$var$getLuminance(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $553ed2baba4347ed$var$alpha(color, value) {
    color = $553ed2baba4347ed$var$decomposeColor(color);
    value = $553ed2baba4347ed$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $553ed2baba4347ed$var$recomposeColor(color);
}
function $553ed2baba4347ed$var$private_safeAlpha(color, value, warning) {
    try {
        return $553ed2baba4347ed$var$alpha(color, value);
    } catch (error) {
        return color;
    }
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $553ed2baba4347ed$var$darken(color, coefficient) {
    color = $553ed2baba4347ed$var$decomposeColor(color);
    coefficient = $553ed2baba4347ed$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] *= 1 - coefficient;
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $553ed2baba4347ed$var$recomposeColor(color);
}
function $553ed2baba4347ed$var$private_safeDarken(color, coefficient, warning) {
    try {
        return $553ed2baba4347ed$var$darken(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $553ed2baba4347ed$var$lighten(color, coefficient) {
    color = $553ed2baba4347ed$var$decomposeColor(color);
    coefficient = $553ed2baba4347ed$var$clampWrapper(coefficient);
    if (color.type.indexOf('hsl') !== -1) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.indexOf('rgb') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.indexOf('color') !== -1) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $553ed2baba4347ed$var$recomposeColor(color);
}
function $553ed2baba4347ed$var$private_safeLighten(color, coefficient, warning) {
    try {
        return $553ed2baba4347ed$var$lighten(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */ function $553ed2baba4347ed$var$emphasize(color, coefficient = 0.15) {
    return $553ed2baba4347ed$var$getLuminance(color) > 0.5 ? $553ed2baba4347ed$var$darken(color, coefficient) : $553ed2baba4347ed$var$lighten(color, coefficient);
}
function $553ed2baba4347ed$var$private_safeEmphasize(color, coefficient, warning) {
    try {
        return $553ed2baba4347ed$var$emphasize(color, coefficient);
    } catch (error) {
        return color;
    }
}
/**
 * Blend a transparent overlay color with a background color, resulting in a single
 * RGB color.
 * @param {string} background - CSS color
 * @param {string} overlay - CSS color
 * @param {number} opacity - Opacity multiplier in the range 0 - 1
 * @param {number} [gamma=1.0] - Gamma correction factor. For gamma-correct blending, 2.2 is usual.
 */ function $553ed2baba4347ed$var$blend(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $553ed2baba4347ed$var$decomposeColor(background);
    const overlayColor = $553ed2baba4347ed$var$decomposeColor(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $553ed2baba4347ed$var$recomposeColor({
        type: 'rgb',
        values: rgb
    });
}

});

parcelRegister("6akYf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $47d3f19e39b3b144$export$2e2bcd8739ae039; });
const $47d3f19e39b3b144$var$common = {
    black: '#000',
    white: '#fff'
};
var $47d3f19e39b3b144$export$2e2bcd8739ae039 = $47d3f19e39b3b144$var$common;

});

parcelRegister("2nhXL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1baba9d0f229a247$export$2e2bcd8739ae039; });
const $1baba9d0f229a247$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $1baba9d0f229a247$export$2e2bcd8739ae039 = $1baba9d0f229a247$var$grey;

});

parcelRegister("3Ctzq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a2bdbc6cce4aa96$export$2e2bcd8739ae039; });
const $2a2bdbc6cce4aa96$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $2a2bdbc6cce4aa96$export$2e2bcd8739ae039 = $2a2bdbc6cce4aa96$var$purple;

});

parcelRegister("9PTBs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $72940215fdf862f4$export$2e2bcd8739ae039; });
const $72940215fdf862f4$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $72940215fdf862f4$export$2e2bcd8739ae039 = $72940215fdf862f4$var$red;

});

parcelRegister("5WQac", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $454ad523c90fa85d$export$2e2bcd8739ae039; });
const $454ad523c90fa85d$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $454ad523c90fa85d$export$2e2bcd8739ae039 = $454ad523c90fa85d$var$orange;

});

parcelRegister("gal31", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc4de82bafd68977$export$2e2bcd8739ae039; });
const $bc4de82bafd68977$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $bc4de82bafd68977$export$2e2bcd8739ae039 = $bc4de82bafd68977$var$blue;

});

parcelRegister("1Btry", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $12b015f9ee6c8f9f$export$2e2bcd8739ae039; });
const $12b015f9ee6c8f9f$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $12b015f9ee6c8f9f$export$2e2bcd8739ae039 = $12b015f9ee6c8f9f$var$lightBlue;

});

parcelRegister("hnm6Q", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ca65bc19996a7eac$export$2e2bcd8739ae039; });
const $ca65bc19996a7eac$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $ca65bc19996a7eac$export$2e2bcd8739ae039 = $ca65bc19996a7eac$var$green;

});


parcelRegister("5vuSA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4027cd084802bc60$export$2e2bcd8739ae039; });

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $3wRTY = parcelRequire("3wRTY");
const $4027cd084802bc60$var$_excluded = [
    "fontFamily",
    "fontSize",
    "fontWeightLight",
    "fontWeightRegular",
    "fontWeightMedium",
    "fontWeightBold",
    "htmlFontSize",
    "allVariants",
    "pxToRem"
];
function $4027cd084802bc60$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $4027cd084802bc60$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $4027cd084802bc60$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $4027cd084802bc60$export$2e2bcd8739ae039(palette, typography) {
    const _ref = typeof typography === 'function' ? typography(palette) : typography, { fontFamily: fontFamily = $4027cd084802bc60$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2 } = _ref, other = (0, $cFLic.default)(_ref, $4027cd084802bc60$var$_excluded);
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>(0, $kY3Ke.default)({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight
        }, fontFamily === $4027cd084802bc60$var$defaultFontFamily ? {
            letterSpacing: `${$4027cd084802bc60$var$round(letterSpacing / size)}em`
        } : {}, casing, allVariants);
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $4027cd084802bc60$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $4027cd084802bc60$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $3wRTY.default)((0, $kY3Ke.default)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold
    }, variants), other, {
        clone: false // No need to clone deep
    });
}

});

parcelRegister("3jGgo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $26a3ee12a0d43232$export$2e2bcd8739ae039; });
const $26a3ee12a0d43232$var$shadowKeyUmbraOpacity = 0.2;
const $26a3ee12a0d43232$var$shadowKeyPenumbraOpacity = 0.14;
const $26a3ee12a0d43232$var$shadowAmbientShadowOpacity = 0.12;
function $26a3ee12a0d43232$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$26a3ee12a0d43232$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$26a3ee12a0d43232$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$26a3ee12a0d43232$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $26a3ee12a0d43232$var$shadows = [
    'none',
    $26a3ee12a0d43232$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $26a3ee12a0d43232$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $26a3ee12a0d43232$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $26a3ee12a0d43232$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $26a3ee12a0d43232$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $26a3ee12a0d43232$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $26a3ee12a0d43232$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $26a3ee12a0d43232$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $26a3ee12a0d43232$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $26a3ee12a0d43232$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $26a3ee12a0d43232$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $26a3ee12a0d43232$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $26a3ee12a0d43232$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $26a3ee12a0d43232$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $26a3ee12a0d43232$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $26a3ee12a0d43232$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $26a3ee12a0d43232$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $26a3ee12a0d43232$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $26a3ee12a0d43232$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $26a3ee12a0d43232$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $26a3ee12a0d43232$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $26a3ee12a0d43232$export$2e2bcd8739ae039 = $26a3ee12a0d43232$var$shadows;

});

parcelRegister("kjiCM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec94076b9ecccee1$export$2e2bcd8739ae039; });

var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");
const $ec94076b9ecccee1$var$_excluded = [
    "duration",
    "easing",
    "delay"
];
const $ec94076b9ecccee1$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $ec94076b9ecccee1$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $ec94076b9ecccee1$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $ec94076b9ecccee1$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
    return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}
function $ec94076b9ecccee1$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = (0, $kY3Ke.default)({}, $ec94076b9ecccee1$export$24c5ac7c37452e7d, inputTransitions.easing);
    const mergedDuration = (0, $kY3Ke.default)({}, $ec94076b9ecccee1$export$1f34108aa9eb96ab, inputTransitions.duration);
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0 } = options, other = (0, $cFLic.default)(options, $ec94076b9ecccee1$var$_excluded);
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $ec94076b9ecccee1$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $ec94076b9ecccee1$var$formatMs(delay)}`).join(',');
    };
    return (0, $kY3Ke.default)({
        getAutoHeightDuration: $ec94076b9ecccee1$var$getAutoHeightDuration,
        create: create
    }, inputTransitions, {
        easing: mergedEasing,
        duration: mergedDuration
    });
}

});

parcelRegister("eGmqa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ab06614e124e32b2$export$2e2bcd8739ae039; });
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $ab06614e124e32b2$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $ab06614e124e32b2$export$2e2bcd8739ae039 = $ab06614e124e32b2$var$zIndex;

});



parcelRegister("jwhZE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e35ef6915a224202$export$2e2bcd8739ae039; });
var $e35ef6915a224202$export$2e2bcd8739ae039 = '$$material';

});

parcelRegister("HgAeG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0820e164eb5fbaff$export$2e2bcd8739ae039; });

var $yfUan = parcelRequire("yfUan");
const $0820e164eb5fbaff$var$rootShouldForwardProp = (prop)=>(0, $yfUan.default)(prop) && prop !== 'classes';
var $0820e164eb5fbaff$export$2e2bcd8739ae039 = $0820e164eb5fbaff$var$rootShouldForwardProp;

});
parcelRegister("yfUan", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $066f83798075d563$export$2e2bcd8739ae039; });
// copied from @mui/system/createStyled
function $066f83798075d563$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $066f83798075d563$export$2e2bcd8739ae039 = $066f83798075d563$var$slotShouldForwardProp;

});



parcelRegister("6VWZo", function(module, exports) {

$parcel$export(module.exports, "getSvgIconUtilityClass", function () { return $50c5d2f6ad13a504$export$c7c50641356bdfa5; });

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $50c5d2f6ad13a504$export$c7c50641356bdfa5(slot) {
    return (0, $k6RDS.default)('MuiSvgIcon', slot);
}
const $50c5d2f6ad13a504$var$svgIconClasses = (0, $4jzsB.default)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $50c5d2f6ad13a504$export$2e2bcd8739ae039 = $50c5d2f6ad13a504$var$svgIconClasses;

});
parcelRegister("4jzsB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32447174989d1976$export$2e2bcd8739ae039; });

var $k6RDS = parcelRequire("k6RDS");
function $32447174989d1976$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $k6RDS.default)(componentName, slot, globalStatePrefix);
    });
    return result;
}

});
parcelRegister("k6RDS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ea3dfa6b173640a4$export$2e2bcd8739ae039; });

var $kU6nt = parcelRequire("kU6nt");
const $ea3dfa6b173640a4$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $ea3dfa6b173640a4$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $ea3dfa6b173640a4$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $kU6nt.default).generate(componentName)}-${slot}`;
}
function $ea3dfa6b173640a4$export$34c0130b1f3e8ae3(slot) {
    return $ea3dfa6b173640a4$export$9d6b9120de57c54[slot] !== undefined;
}

});
parcelRegister("kU6nt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f37dfc12e5d89c96$export$2e2bcd8739ae039; });
const $f37dfc12e5d89c96$var$defaultGenerator = (componentName)=>componentName;
const $f37dfc12e5d89c96$var$createClassNameGenerator = ()=>{
    let generate = $f37dfc12e5d89c96$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $f37dfc12e5d89c96$var$defaultGenerator;
        }
    };
};
const $f37dfc12e5d89c96$var$ClassNameGenerator = $f37dfc12e5d89c96$var$createClassNameGenerator();
var $f37dfc12e5d89c96$export$2e2bcd8739ae039 = $f37dfc12e5d89c96$var$ClassNameGenerator;

});








var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
var $f11ec298ebcca059$exports = {};

$parcel$export($f11ec298ebcca059$exports, "createRoot", function () { return $f11ec298ebcca059$export$882461b6382ed46c; }, function (v) { return $f11ec298ebcca059$export$882461b6382ed46c = v; });
$parcel$export($f11ec298ebcca059$exports, "hydrateRoot", function () { return $f11ec298ebcca059$export$757ceba2d55c277e; }, function (v) { return $f11ec298ebcca059$export$757ceba2d55c277e = v; });
var $f11ec298ebcca059$export$882461b6382ed46c;
var $f11ec298ebcca059$export$757ceba2d55c277e;
'use strict';
var $b4ba1c853f6e1116$exports = {};
'use strict';
function $b4ba1c853f6e1116$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b4ba1c853f6e1116$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b4ba1c853f6e1116$var$checkDCE();

$b4ba1c853f6e1116$exports = (parcelRequire("6EA3T"));


var $f11ec298ebcca059$var$i;
$f11ec298ebcca059$export$882461b6382ed46c = $b4ba1c853f6e1116$exports.createRoot;
$f11ec298ebcca059$export$757ceba2d55c277e = $b4ba1c853f6e1116$exports.hydrateRoot;




var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");
/**
 * React Router DOM v6.30.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7fPBF = parcelRequire("7fPBF");

/**
 * React Router v6.30.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7fPBF = parcelRequire("7fPBF");
/**
 * @remix-run/router v1.23.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $55100129ab36ed65$var$_extends() {
    $55100129ab36ed65$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $55100129ab36ed65$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $55100129ab36ed65$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($55100129ab36ed65$export$e19cd5f9376f8cee || ($55100129ab36ed65$export$e19cd5f9376f8cee = {}));
const $55100129ab36ed65$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $55100129ab36ed65$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $55100129ab36ed65$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $55100129ab36ed65$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $55100129ab36ed65$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $55100129ab36ed65$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
    }
    return $55100129ab36ed65$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $55100129ab36ed65$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $55100129ab36ed65$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $55100129ab36ed65$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $55100129ab36ed65$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $55100129ab36ed65$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $55100129ab36ed65$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $55100129ab36ed65$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $55100129ab36ed65$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $55100129ab36ed65$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $55100129ab36ed65$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $55100129ab36ed65$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $55100129ab36ed65$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $55100129ab36ed65$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $55100129ab36ed65$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $55100129ab36ed65$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($55100129ab36ed65$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
        let location = $55100129ab36ed65$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $55100129ab36ed65$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        let location = $55100129ab36ed65$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $55100129ab36ed65$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $55100129ab36ed65$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($55100129ab36ed65$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($55100129ab36ed65$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $55100129ab36ed65$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($55100129ab36ed65$var$ResultType || ($55100129ab36ed65$var$ResultType = {}));
const $55100129ab36ed65$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $55100129ab36ed65$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $55100129ab36ed65$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $55100129ab36ed65$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $55100129ab36ed65$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($55100129ab36ed65$var$isIndexRoute(route)) {
            let indexRoute = $55100129ab36ed65$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $55100129ab36ed65$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $55100129ab36ed65$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $55100129ab36ed65$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $55100129ab36ed65$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $55100129ab36ed65$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $55100129ab36ed65$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $55100129ab36ed65$var$flattenRoutes(routes);
    $55100129ab36ed65$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $55100129ab36ed65$export$30d21fd6d7295f52(pathname);
        matches = $55100129ab36ed65$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $55100129ab36ed65$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $55100129ab36ed65$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $55100129ab36ed65$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $55100129ab36ed65$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $55100129ab36ed65$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $55100129ab36ed65$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $55100129ab36ed65$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $55100129ab36ed65$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $55100129ab36ed65$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $55100129ab36ed65$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $55100129ab36ed65$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $55100129ab36ed65$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $55100129ab36ed65$var$paramRe = /^:[\w-]+$/;
const $55100129ab36ed65$var$dynamicSegmentValue = 3;
const $55100129ab36ed65$var$indexRouteValue = 2;
const $55100129ab36ed65$var$emptySegmentValue = 1;
const $55100129ab36ed65$var$staticSegmentValue = 10;
const $55100129ab36ed65$var$splatPenalty = -2;
const $55100129ab36ed65$var$isSplat = (s)=>s === "*";
function $55100129ab36ed65$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($55100129ab36ed65$var$isSplat)) initialScore += $55100129ab36ed65$var$splatPenalty;
    if (index) initialScore += $55100129ab36ed65$var$indexRouteValue;
    return segments.filter((s)=>!$55100129ab36ed65$var$isSplat(s)).reduce((score, segment)=>score + ($55100129ab36ed65$var$paramRe.test(segment) ? $55100129ab36ed65$var$dynamicSegmentValue : segment === "" ? $55100129ab36ed65$var$emptySegmentValue : $55100129ab36ed65$var$staticSegmentValue), initialScore);
}
function $55100129ab36ed65$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $55100129ab36ed65$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $55100129ab36ed65$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $55100129ab36ed65$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $55100129ab36ed65$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $55100129ab36ed65$export$a5c6d149b50c1d86($55100129ab36ed65$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $55100129ab36ed65$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $55100129ab36ed65$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $55100129ab36ed65$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $55100129ab36ed65$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $55100129ab36ed65$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $55100129ab36ed65$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $55100129ab36ed65$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $55100129ab36ed65$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $55100129ab36ed65$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $55100129ab36ed65$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $55100129ab36ed65$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $55100129ab36ed65$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $55100129ab36ed65$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $55100129ab36ed65$var$normalizeSearch(search),
        hash: $55100129ab36ed65$var$normalizeHash(hash)
    };
}
function $55100129ab36ed65$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $55100129ab36ed65$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $55100129ab36ed65$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $55100129ab36ed65$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $55100129ab36ed65$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $55100129ab36ed65$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $55100129ab36ed65$export$8ccf933b0513f8d0(toArg);
    else {
        to = $55100129ab36ed65$var$_extends({}, toArg);
        $55100129ab36ed65$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $55100129ab36ed65$var$getInvalidPathError("?", "pathname", "search", to));
        $55100129ab36ed65$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $55100129ab36ed65$var$getInvalidPathError("#", "pathname", "hash", to));
        $55100129ab36ed65$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $55100129ab36ed65$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $55100129ab36ed65$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $55100129ab36ed65$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $55100129ab36ed65$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $55100129ab36ed65$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $55100129ab36ed65$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $55100129ab36ed65$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $55100129ab36ed65$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $55100129ab36ed65$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $55100129ab36ed65$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $55100129ab36ed65$export$4051a07651545597(data, init) {
    return new $55100129ab36ed65$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $55100129ab36ed65$export$42a99a7a4bc0e76a extends Error {
}
class $55100129ab36ed65$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $55100129ab36ed65$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $55100129ab36ed65$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $55100129ab36ed65$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $55100129ab36ed65$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $55100129ab36ed65$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $55100129ab36ed65$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $55100129ab36ed65$var$unwrapTrackedPromise(value) {
    if (!$55100129ab36ed65$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $55100129ab36ed65$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $55100129ab36ed65$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $55100129ab36ed65$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $55100129ab36ed65$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $55100129ab36ed65$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $55100129ab36ed65$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $55100129ab36ed65$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $55100129ab36ed65$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $55100129ab36ed65$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $55100129ab36ed65$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $55100129ab36ed65$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $55100129ab36ed65$var$validMutationMethods = new Set($55100129ab36ed65$var$validMutationMethodsArr);
const $55100129ab36ed65$var$validRequestMethodsArr = [
    "get",
    ...$55100129ab36ed65$var$validMutationMethodsArr
];
const $55100129ab36ed65$var$validRequestMethods = new Set($55100129ab36ed65$var$validRequestMethodsArr);
const $55100129ab36ed65$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $55100129ab36ed65$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $55100129ab36ed65$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $55100129ab36ed65$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $55100129ab36ed65$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $55100129ab36ed65$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $55100129ab36ed65$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $55100129ab36ed65$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $55100129ab36ed65$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $55100129ab36ed65$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $55100129ab36ed65$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $55100129ab36ed65$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $55100129ab36ed65$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$55100129ab36ed65$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$55100129ab36ed65$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $55100129ab36ed65$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $55100129ab36ed65$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $55100129ab36ed65$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $55100129ab36ed65$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$55100129ab36ed65$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($55100129ab36ed65$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $55100129ab36ed65$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $55100129ab36ed65$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $55100129ab36ed65$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $55100129ab36ed65$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $55100129ab36ed65$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($55100129ab36ed65$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $55100129ab36ed65$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $55100129ab36ed65$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $55100129ab36ed65$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $55100129ab36ed65$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $55100129ab36ed65$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $55100129ab36ed65$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $55100129ab36ed65$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $55100129ab36ed65$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $55100129ab36ed65$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $55100129ab36ed65$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $55100129ab36ed65$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $55100129ab36ed65$var$findNearestBoundary(matches).route.id,
            {
                type: $55100129ab36ed65$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $55100129ab36ed65$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($55100129ab36ed65$var$isErrorResult(result) && $55100129ab36ed65$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $55100129ab36ed65$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $55100129ab36ed65$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $55100129ab36ed65$var$_extends({
            matches: updatedMatches || matches
        }, $55100129ab36ed65$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $55100129ab36ed65$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $55100129ab36ed65$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $55100129ab36ed65$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $55100129ab36ed65$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $55100129ab36ed65$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $55100129ab36ed65$var$ResultType.error,
            error: $55100129ab36ed65$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($55100129ab36ed65$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $55100129ab36ed65$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($55100129ab36ed65$var$isDeferredResult(result)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $55100129ab36ed65$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $55100129ab36ed65$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($55100129ab36ed65$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $55100129ab36ed65$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $55100129ab36ed65$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $55100129ab36ed65$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $55100129ab36ed65$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $55100129ab36ed65$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $55100129ab36ed65$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $55100129ab36ed65$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $55100129ab36ed65$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$55100129ab36ed65$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $55100129ab36ed65$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $55100129ab36ed65$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $55100129ab36ed65$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $55100129ab36ed65$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $55100129ab36ed65$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $55100129ab36ed65$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $55100129ab36ed65$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $55100129ab36ed65$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $55100129ab36ed65$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($55100129ab36ed65$var$isRedirectResult(actionResult) || $55100129ab36ed65$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($55100129ab36ed65$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $55100129ab36ed65$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($55100129ab36ed65$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($55100129ab36ed65$var$isDeferredResult(actionResult)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $55100129ab36ed65$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $55100129ab36ed65$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $55100129ab36ed65$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $55100129ab36ed65$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $55100129ab36ed65$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $55100129ab36ed65$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $55100129ab36ed65$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $55100129ab36ed65$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $55100129ab36ed65$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $55100129ab36ed65$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $55100129ab36ed65$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $55100129ab36ed65$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($55100129ab36ed65$var$isDeferredResult(result)) result = await $55100129ab36ed65$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($55100129ab36ed65$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $55100129ab36ed65$export$3e9cee6b33872309(!$55100129ab36ed65$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $55100129ab36ed65$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $55100129ab36ed65$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $55100129ab36ed65$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($55100129ab36ed65$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $55100129ab36ed65$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $55100129ab36ed65$export$e19cd5f9376f8cee.Replace : $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $55100129ab36ed65$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($55100129ab36ed65$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $55100129ab36ed65$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $55100129ab36ed65$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $55100129ab36ed65$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $55100129ab36ed65$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $55100129ab36ed65$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($55100129ab36ed65$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $55100129ab36ed65$var$ResultType.redirect,
                response: $55100129ab36ed65$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $55100129ab36ed65$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $55100129ab36ed65$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $55100129ab36ed65$var$ResultType.error,
                    error: $55100129ab36ed65$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $55100129ab36ed65$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $55100129ab36ed65$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $55100129ab36ed65$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $55100129ab36ed65$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $55100129ab36ed65$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $55100129ab36ed65$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $55100129ab36ed65$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $55100129ab36ed65$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $55100129ab36ed65$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $55100129ab36ed65$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$55100129ab36ed65$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $55100129ab36ed65$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $55100129ab36ed65$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $55100129ab36ed65$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $55100129ab36ed65$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $55100129ab36ed65$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $55100129ab36ed65$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $55100129ab36ed65$export$4d0306f8f6a4585b = Symbol("deferred");
function $55100129ab36ed65$export$3336b097a6fbc59a(routes, opts) {
    $55100129ab36ed65$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $55100129ab36ed65$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $55100129ab36ed65$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $55100129ab36ed65$var$createLocation("", $55100129ab36ed65$export$fe53371bee54353d(url), null, "default");
        let matches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$55100129ab36ed65$var$isValidMethod(method) && method !== "HEAD") {
            let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($55100129ab36ed65$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $55100129ab36ed65$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $55100129ab36ed65$var$createLocation("", $55100129ab36ed65$export$fe53371bee54353d(url), null, "default");
        let matches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$55100129ab36ed65$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $55100129ab36ed65$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $55100129ab36ed65$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $55100129ab36ed65$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($55100129ab36ed65$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$55100129ab36ed65$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $55100129ab36ed65$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($55100129ab36ed65$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $55100129ab36ed65$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $55100129ab36ed65$var$isResponse(result) ? result : $55100129ab36ed65$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($55100129ab36ed65$var$isDataStrategyResult(e) && $55100129ab36ed65$var$isResponse(e.result)) {
                if (e.type === $55100129ab36ed65$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($55100129ab36ed65$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $55100129ab36ed65$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $55100129ab36ed65$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($55100129ab36ed65$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($55100129ab36ed65$var$isDeferredResult(result)) {
            let error = $55100129ab36ed65$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $55100129ab36ed65$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($55100129ab36ed65$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $55100129ab36ed65$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $55100129ab36ed65$var$_extends({}, context, {
                statusCode: $55100129ab36ed65$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $55100129ab36ed65$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $55100129ab36ed65$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $55100129ab36ed65$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $55100129ab36ed65$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $55100129ab36ed65$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $55100129ab36ed65$var$callDataStrategyImpl(dataStrategy || $55100129ab36ed65$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($55100129ab36ed65$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $55100129ab36ed65$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($55100129ab36ed65$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $55100129ab36ed65$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $55100129ab36ed65$export$fec11da027c70692(routes, context, error) {
    let newContext = $55100129ab36ed65$var$_extends({}, context, {
        statusCode: $55100129ab36ed65$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $55100129ab36ed65$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $55100129ab36ed65$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $55100129ab36ed65$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $55100129ab36ed65$export$cae722b0cc860f13(to ? to : ".", $55100129ab36ed65$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $55100129ab36ed65$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $55100129ab36ed65$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $55100129ab36ed65$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $55100129ab36ed65$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $55100129ab36ed65$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$55100129ab36ed65$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$55100129ab36ed65$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $55100129ab36ed65$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $55100129ab36ed65$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $55100129ab36ed65$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$55100129ab36ed65$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$55100129ab36ed65$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $55100129ab36ed65$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $55100129ab36ed65$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $55100129ab36ed65$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $55100129ab36ed65$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $55100129ab36ed65$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($55100129ab36ed65$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $55100129ab36ed65$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $55100129ab36ed65$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $55100129ab36ed65$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $55100129ab36ed65$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $55100129ab36ed65$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($55100129ab36ed65$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $55100129ab36ed65$var$shouldRevalidateLoader(match, $55100129ab36ed65$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $55100129ab36ed65$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $55100129ab36ed65$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $55100129ab36ed65$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $55100129ab36ed65$var$shouldRevalidateLoader(fetcherMatch, $55100129ab36ed65$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $55100129ab36ed65$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $55100129ab36ed65$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $55100129ab36ed65$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $55100129ab36ed65$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $55100129ab36ed65$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $55100129ab36ed65$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$55100129ab36ed65$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $55100129ab36ed65$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$55100129ab36ed65$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $55100129ab36ed65$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $55100129ab36ed65$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $55100129ab36ed65$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$55100129ab36ed65$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $55100129ab36ed65$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $55100129ab36ed65$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $55100129ab36ed65$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $55100129ab36ed65$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $55100129ab36ed65$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $55100129ab36ed65$var$ResultType.data,
                result: undefined
            });
        };
        return $55100129ab36ed65$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $55100129ab36ed65$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $55100129ab36ed65$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $55100129ab36ed65$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $55100129ab36ed65$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $55100129ab36ed65$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $55100129ab36ed65$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($55100129ab36ed65$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $55100129ab36ed65$var$ResultType.error,
                error: e
            };
        }
        if (type === $55100129ab36ed65$var$ResultType.error) return {
            type: $55100129ab36ed65$var$ResultType.error,
            error: new $55100129ab36ed65$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $55100129ab36ed65$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $55100129ab36ed65$var$ResultType.error) {
        if ($55100129ab36ed65$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $55100129ab36ed65$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $55100129ab36ed65$var$ResultType.error,
                error: new $55100129ab36ed65$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $55100129ab36ed65$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $55100129ab36ed65$var$ResultType.error,
            error: result,
            statusCode: $55100129ab36ed65$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($55100129ab36ed65$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $55100129ab36ed65$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($55100129ab36ed65$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $55100129ab36ed65$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $55100129ab36ed65$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $55100129ab36ed65$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $55100129ab36ed65$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$55100129ab36ed65$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $55100129ab36ed65$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $55100129ab36ed65$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($55100129ab36ed65$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $55100129ab36ed65$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $55100129ab36ed65$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($55100129ab36ed65$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $55100129ab36ed65$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $55100129ab36ed65$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $55100129ab36ed65$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $55100129ab36ed65$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $55100129ab36ed65$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $55100129ab36ed65$export$3e9cee6b33872309(!$55100129ab36ed65$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $55100129ab36ed65$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($55100129ab36ed65$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $55100129ab36ed65$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $55100129ab36ed65$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($55100129ab36ed65$var$isErrorResult(result)) {
            let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $55100129ab36ed65$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($55100129ab36ed65$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $55100129ab36ed65$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($55100129ab36ed65$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $55100129ab36ed65$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $55100129ab36ed65$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $55100129ab36ed65$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $55100129ab36ed65$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $55100129ab36ed65$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $55100129ab36ed65$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $55100129ab36ed65$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $55100129ab36ed65$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $55100129ab36ed65$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($55100129ab36ed65$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $55100129ab36ed65$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(path) : path;
    return $55100129ab36ed65$export$fe53371bee54353d($55100129ab36ed65$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $55100129ab36ed65$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $55100129ab36ed65$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $55100129ab36ed65$var$ResultType.data || result.type === $55100129ab36ed65$var$ResultType.error);
}
function $55100129ab36ed65$var$isRedirectDataStrategyResultResult(result) {
    return $55100129ab36ed65$var$isResponse(result.result) && $55100129ab36ed65$var$redirectStatusCodes.has(result.result.status);
}
function $55100129ab36ed65$var$isDeferredResult(result) {
    return result.type === $55100129ab36ed65$var$ResultType.deferred;
}
function $55100129ab36ed65$var$isErrorResult(result) {
    return result.type === $55100129ab36ed65$var$ResultType.error;
}
function $55100129ab36ed65$var$isRedirectResult(result) {
    return (result && result.type) === $55100129ab36ed65$var$ResultType.redirect;
}
function $55100129ab36ed65$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $55100129ab36ed65$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $55100129ab36ed65$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $55100129ab36ed65$var$isRedirectResponse(result) {
    if (!$55100129ab36ed65$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $55100129ab36ed65$var$isValidMethod(method) {
    return $55100129ab36ed65$var$validRequestMethods.has(method.toLowerCase());
}
function $55100129ab36ed65$var$isMutationMethod(method) {
    return $55100129ab36ed65$var$validMutationMethods.has(method.toLowerCase());
}
async function $55100129ab36ed65$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$55100129ab36ed65$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($55100129ab36ed65$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $55100129ab36ed65$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $55100129ab36ed65$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($55100129ab36ed65$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $55100129ab36ed65$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $55100129ab36ed65$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $55100129ab36ed65$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $55100129ab36ed65$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $55100129ab36ed65$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $55100129ab36ed65$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $55100129ab36ed65$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $55100129ab36ed65$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $55100129ab36ed65$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $55100129ab36ed65$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $55100129ab36ed65$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $55100129ab36ed65$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $55100129ab36ed65$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $55100129ab36ed65$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $55100129ab36ed65$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $55100129ab36ed65$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $55100129ab36ed65$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($55100129ab36ed65$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $55100129ab36ed65$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($55100129ab36ed65$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $55100129ab36ed65$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}


function $d9fd026bfea79ab9$var$_extends() {
    $d9fd026bfea79ab9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d9fd026bfea79ab9$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $d9fd026bfea79ab9$export$3add0d5dce533e2e = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$145dfa71566a64dc = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$var$AwaitContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $d9fd026bfea79ab9$export$26749e8557646306 = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$c7914228fb69b0f5 = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$9072aa6dd1f93057 = /*#__PURE__*/ $7fPBF.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $d9fd026bfea79ab9$var$RouteErrorContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $d9fd026bfea79ab9$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $d9fd026bfea79ab9$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $d9fd026bfea79ab9$export$9c954a9d03d32f4a() {
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $d9fd026bfea79ab9$export$45d76561a5302f2b() {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $d9fd026bfea79ab9$export$1b3f31771c5d07c() {
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $d9fd026bfea79ab9$export$6c330e8992e8a295(pattern) {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    return $7fPBF.useMemo(()=>(0, $55100129ab36ed65$export$81336c211d5ff295)(pattern, (0, $55100129ab36ed65$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $d9fd026bfea79ab9$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $d9fd026bfea79ab9$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $7fPBF.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $d9fd026bfea79ab9$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $d9fd026bfea79ab9$var$useNavigateStable() : $d9fd026bfea79ab9$var$useNavigateUnstable();
}
function $d9fd026bfea79ab9$var$useNavigateUnstable() {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let dataRouterContext = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $55100129ab36ed65$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $7fPBF.useRef(false);
    $d9fd026bfea79ab9$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7fPBF.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $55100129ab36ed65$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $d9fd026bfea79ab9$var$OutletContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $d9fd026bfea79ab9$export$4138103a3ae699cc() {
    return $7fPBF.useContext($d9fd026bfea79ab9$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $d9fd026bfea79ab9$export$a3be3530d8e40d0b(context) {
    let outlet = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $d9fd026bfea79ab9$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $d9fd026bfea79ab9$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $55100129ab36ed65$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $7fPBF.useMemo(()=>(0, $55100129ab36ed65$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $d9fd026bfea79ab9$export$5d3fca4a98652595(routes, locationArg) {
    return $d9fd026bfea79ab9$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $d9fd026bfea79ab9$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: parentMatches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $55100129ab36ed65$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $55100129ab36ed65$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $d9fd026bfea79ab9$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $55100129ab36ed65$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $d9fd026bfea79ab9$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $55100129ab36ed65$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $d9fd026bfea79ab9$var$DefaultErrorComponent() {
    let error = $d9fd026bfea79ab9$export$ed527bf60f6e05f2();
    let message = (0, $55100129ab36ed65$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $7fPBF.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $7fPBF.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $d9fd026bfea79ab9$var$defaultErrorElement = /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$DefaultErrorComponent, null);
class $d9fd026bfea79ab9$var$RenderErrorBoundary extends $7fPBF.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $d9fd026bfea79ab9$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $d9fd026bfea79ab9$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $d9fd026bfea79ab9$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $d9fd026bfea79ab9$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $7fPBF.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $d9fd026bfea79ab9$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($d9fd026bfea79ab9$var$DataRouterHook || {});
var $d9fd026bfea79ab9$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($d9fd026bfea79ab9$var$DataRouterStateHook || {});
function $d9fd026bfea79ab9$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $d9fd026bfea79ab9$var$useDataRouterContext(hookName) {
    let ctx = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e);
    !ctx && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return ctx;
}
function $d9fd026bfea79ab9$var$useDataRouterState(hookName) {
    let state = $7fPBF.useContext($d9fd026bfea79ab9$export$145dfa71566a64dc);
    !state && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return state;
}
function $d9fd026bfea79ab9$var$useRouteContext(hookName) {
    let route = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    !route && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $d9fd026bfea79ab9$var$useCurrentRouteId(hookName) {
    let route = $d9fd026bfea79ab9$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $d9fd026bfea79ab9$export$5fc8298006ad9e58() {
    return $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $d9fd026bfea79ab9$export$d0fd4b7106de2769() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $d9fd026bfea79ab9$export$600dc272ed516c15() {
    let dataRouterContext = $d9fd026bfea79ab9$var$useDataRouterContext($d9fd026bfea79ab9$var$DataRouterHook.UseRevalidator);
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRevalidator);
    return $7fPBF.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $d9fd026bfea79ab9$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseMatches);
    return $7fPBF.useMemo(()=>matches.map((m)=>(0, $55100129ab36ed65$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $d9fd026bfea79ab9$export$1448a5050d252c4d() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseLoaderData);
    let routeId = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $d9fd026bfea79ab9$export$fd5d37484eab868d(routeId) {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $d9fd026bfea79ab9$export$fdc00f3f26066d5e() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseActionData);
    let routeId = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $d9fd026bfea79ab9$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $7fPBF.useContext($d9fd026bfea79ab9$var$RouteErrorContext);
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteError);
    let routeId = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $d9fd026bfea79ab9$export$78a72ddb39bdd145() {
    let value = $7fPBF.useContext($d9fd026bfea79ab9$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $d9fd026bfea79ab9$export$17f53340677d5831() {
    let value = $7fPBF.useContext($d9fd026bfea79ab9$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $d9fd026bfea79ab9$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $d9fd026bfea79ab9$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $d9fd026bfea79ab9$var$useDataRouterContext($d9fd026bfea79ab9$var$DataRouterHook.UseBlocker);
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $7fPBF.useState("");
    let blockerFunction = $7fPBF.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $d9fd026bfea79ab9$var$_extends({}, currentLocation, {
                pathname: (0, $55100129ab36ed65$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $d9fd026bfea79ab9$var$_extends({}, nextLocation, {
                pathname: (0, $55100129ab36ed65$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $7fPBF.useEffect(()=>{
        let key = String(++$d9fd026bfea79ab9$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $7fPBF.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $55100129ab36ed65$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $d9fd026bfea79ab9$var$useNavigateStable() {
    let { router: router } = $d9fd026bfea79ab9$var$useDataRouterContext($d9fd026bfea79ab9$var$DataRouterHook.UseNavigateStable);
    let id = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $7fPBF.useRef(false);
    $d9fd026bfea79ab9$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7fPBF.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $d9fd026bfea79ab9$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $d9fd026bfea79ab9$var$alreadyWarned$1 = {};
function $d9fd026bfea79ab9$var$warningOnce(key, cond, message) {
    if (!cond && !$d9fd026bfea79ab9$var$alreadyWarned$1[key]) $d9fd026bfea79ab9$var$alreadyWarned$1[key] = true;
}
const $d9fd026bfea79ab9$var$alreadyWarned = {};
function $d9fd026bfea79ab9$var$warnOnce(key, message) {}
const $d9fd026bfea79ab9$var$logDeprecation = (flag, msg, link)=>$d9fd026bfea79ab9$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $d9fd026bfea79ab9$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $d9fd026bfea79ab9$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $d9fd026bfea79ab9$var$START_TRANSITION = "startTransition";
const $d9fd026bfea79ab9$var$startTransitionImpl = $7fPBF[$d9fd026bfea79ab9$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $d9fd026bfea79ab9$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $7fPBF.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        if (v7_startTransition && $d9fd026bfea79ab9$var$startTransitionImpl) $d9fd026bfea79ab9$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $7fPBF.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $7fPBF.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $7fPBF.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7fPBF.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $7fPBF.useEffect(()=>$d9fd026bfea79ab9$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $d9fd026bfea79ab9$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $d9fd026bfea79ab9$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $d9fd026bfea79ab9$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55100129ab36ed65$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $d9fd026bfea79ab9$var$startTransitionImpl ? $d9fd026bfea79ab9$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7fPBF.useEffect(()=>$d9fd026bfea79ab9$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $d9fd026bfea79ab9$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let navigate = $d9fd026bfea79ab9$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $55100129ab36ed65$export$cae722b0cc860f13)(to, (0, $55100129ab36ed65$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $7fPBF.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $d9fd026bfea79ab9$export$910ae8079b2c2852(props) {
    return $d9fd026bfea79ab9$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $d9fd026bfea79ab9$export$e7b0ac011bb776c6(_props) {
    (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $d9fd026bfea79ab9$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $55100129ab36ed65$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $7fPBF.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $d9fd026bfea79ab9$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $55100129ab36ed65$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $7fPBF.useMemo(()=>{
        let trailingPathname = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $d9fd026bfea79ab9$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $d9fd026bfea79ab9$export$5d3fca4a98652595($d9fd026bfea79ab9$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $d9fd026bfea79ab9$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$ResolveAwait, null, children));
}
var $d9fd026bfea79ab9$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($d9fd026bfea79ab9$var$AwaitRenderStatus || {});
const $d9fd026bfea79ab9$var$neverSettledPromise = new Promise(()=>{});
class $d9fd026bfea79ab9$var$AwaitErrorBoundary extends $7fPBF.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $d9fd026bfea79ab9$var$AwaitRenderStatus.error : "_data" in promise ? $d9fd026bfea79ab9$var$AwaitRenderStatus.success : $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error && promise._error instanceof (0, $55100129ab36ed65$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $d9fd026bfea79ab9$var$neverSettledPromise;
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $d9fd026bfea79ab9$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $d9fd026bfea79ab9$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $d9fd026bfea79ab9$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $7fPBF.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $7fPBF.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $d9fd026bfea79ab9$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $d9fd026bfea79ab9$export$e7b0ac011bb776c6) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $d9fd026bfea79ab9$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $d9fd026bfea79ab9$export$daf73786167a7f72(matches) {
    return $d9fd026bfea79ab9$var$_renderMatches(matches);
}
function $d9fd026bfea79ab9$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $7fPBF.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $7fPBF.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $7fPBF.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $d9fd026bfea79ab9$export$f30f7e456d254e83(routes, opts) {
    return (0, $55100129ab36ed65$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $d9fd026bfea79ab9$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $55100129ab36ed65$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $d9fd026bfea79ab9$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $a0cf24fd73ae067c$var$_extends() {
    $a0cf24fd73ae067c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a0cf24fd73ae067c$var$_extends.apply(this, arguments);
}
function $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $a0cf24fd73ae067c$var$defaultMethod = "get";
const $a0cf24fd73ae067c$var$defaultEncType = "application/x-www-form-urlencoded";
function $a0cf24fd73ae067c$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $a0cf24fd73ae067c$var$isButtonElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $a0cf24fd73ae067c$var$isFormElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $a0cf24fd73ae067c$var$isInputElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $a0cf24fd73ae067c$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $a0cf24fd73ae067c$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$a0cf24fd73ae067c$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $a0cf24fd73ae067c$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $a0cf24fd73ae067c$var$_formDataSupportsSubmitter = null;
function $a0cf24fd73ae067c$var$isFormDataSubmitterSupported() {
    if ($a0cf24fd73ae067c$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $a0cf24fd73ae067c$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $a0cf24fd73ae067c$var$_formDataSupportsSubmitter = true;
    }
    return $a0cf24fd73ae067c$var$_formDataSupportsSubmitter;
}
const $a0cf24fd73ae067c$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $a0cf24fd73ae067c$var$getFormEncType(encType) {
    if (encType != null && !$a0cf24fd73ae067c$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $a0cf24fd73ae067c$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($a0cf24fd73ae067c$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $55100129ab36ed65$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $a0cf24fd73ae067c$var$defaultMethod;
        encType = $a0cf24fd73ae067c$var$getFormEncType(target.getAttribute("enctype")) || $a0cf24fd73ae067c$var$defaultEncType;
        formData = new FormData(target);
    } else if ($a0cf24fd73ae067c$var$isButtonElement(target) || $a0cf24fd73ae067c$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $55100129ab36ed65$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $a0cf24fd73ae067c$var$defaultMethod;
        encType = $a0cf24fd73ae067c$var$getFormEncType(target.getAttribute("formenctype")) || $a0cf24fd73ae067c$var$getFormEncType(form.getAttribute("enctype")) || $a0cf24fd73ae067c$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$a0cf24fd73ae067c$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($a0cf24fd73ae067c$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $a0cf24fd73ae067c$var$defaultMethod;
        action = null;
        encType = $a0cf24fd73ae067c$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $a0cf24fd73ae067c$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $a0cf24fd73ae067c$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $a0cf24fd73ae067c$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $a0cf24fd73ae067c$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $a0cf24fd73ae067c$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $a0cf24fd73ae067c$export$1f3f55432a00e06d(routes, opts) {
    return (0, $55100129ab36ed65$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $a0cf24fd73ae067c$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $55100129ab36ed65$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $a0cf24fd73ae067c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $d9fd026bfea79ab9$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $a0cf24fd73ae067c$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $55100129ab36ed65$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $a0cf24fd73ae067c$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $55100129ab36ed65$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $a0cf24fd73ae067c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $d9fd026bfea79ab9$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $a0cf24fd73ae067c$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $a0cf24fd73ae067c$var$_extends({}, state, {
        errors: $a0cf24fd73ae067c$var$deserializeErrors(state.errors)
    });
    return state;
}
function $a0cf24fd73ae067c$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $55100129ab36ed65$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $a0cf24fd73ae067c$export$7ad602f0e94e62d1 = /*#__PURE__*/ $7fPBF.createContext({
    isTransitioning: false
});
const $a0cf24fd73ae067c$export$148fd98d095596d4 = /*#__PURE__*/ $7fPBF.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $a0cf24fd73ae067c$var$START_TRANSITION = "startTransition";
const $a0cf24fd73ae067c$var$startTransitionImpl = $7fPBF[$a0cf24fd73ae067c$var$START_TRANSITION];
const $a0cf24fd73ae067c$var$FLUSH_SYNC = "flushSync";
const $a0cf24fd73ae067c$var$flushSyncImpl = $b4ba1c853f6e1116$exports[$a0cf24fd73ae067c$var$FLUSH_SYNC];
const $a0cf24fd73ae067c$var$USE_ID = "useId";
const $a0cf24fd73ae067c$var$useIdImpl = $7fPBF[$a0cf24fd73ae067c$var$USE_ID];
function $a0cf24fd73ae067c$var$startTransitionSafe(cb) {
    if ($a0cf24fd73ae067c$var$startTransitionImpl) $a0cf24fd73ae067c$var$startTransitionImpl(cb);
    else cb();
}
function $a0cf24fd73ae067c$var$flushSyncSafe(cb) {
    if ($a0cf24fd73ae067c$var$flushSyncImpl) $a0cf24fd73ae067c$var$flushSyncImpl(cb);
    else cb();
}
class $a0cf24fd73ae067c$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $a0cf24fd73ae067c$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $7fPBF.useState(router.state);
    let [pendingState, setPendingState] = $7fPBF.useState();
    let [vtContext, setVtContext] = $7fPBF.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $7fPBF.useState();
    let [transition, setTransition] = $7fPBF.useState();
    let [interruption, setInterruption] = $7fPBF.useState();
    let fetcherData = $7fPBF.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $7fPBF.useCallback((cb)=>{
        if (v7_startTransition) $a0cf24fd73ae067c$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $7fPBF.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $a0cf24fd73ae067c$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $a0cf24fd73ae067c$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $a0cf24fd73ae067c$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $a0cf24fd73ae067c$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $a0cf24fd73ae067c$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $7fPBF.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $7fPBF.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $a0cf24fd73ae067c$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $7fPBF.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $7fPBF.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $7fPBF.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $7fPBF.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $7fPBF.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7fPBF.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $7fPBF.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $7fPBF.useEffect(()=>(0, $d9fd026bfea79ab9$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $a0cf24fd73ae067c$var$MemoizedDataRoutes = /*#__PURE__*/ $7fPBF.memo($a0cf24fd73ae067c$var$DataRoutes);
function $a0cf24fd73ae067c$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $d9fd026bfea79ab9$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $a0cf24fd73ae067c$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55100129ab36ed65$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $a0cf24fd73ae067c$var$startTransitionImpl ? $a0cf24fd73ae067c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7fPBF.useEffect(()=>(0, $d9fd026bfea79ab9$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $a0cf24fd73ae067c$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55100129ab36ed65$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $a0cf24fd73ae067c$var$startTransitionImpl ? $a0cf24fd73ae067c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7fPBF.useEffect(()=>(0, $d9fd026bfea79ab9$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $a0cf24fd73ae067c$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $a0cf24fd73ae067c$var$startTransitionImpl ? $a0cf24fd73ae067c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7fPBF.useEffect(()=>(0, $d9fd026bfea79ab9$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $a0cf24fd73ae067c$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $a0cf24fd73ae067c$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $a0cf24fd73ae067c$export$a6c7ac8248d6e38a = /*#__PURE__*/ $7fPBF.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref7, $a0cf24fd73ae067c$var$_excluded);
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $a0cf24fd73ae067c$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($a0cf24fd73ae067c$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $d9fd026bfea79ab9$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $a0cf24fd73ae067c$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $7fPBF.createElement("a", $a0cf24fd73ae067c$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $a0cf24fd73ae067c$export$b0d92dbee9b5b60d = /*#__PURE__*/ $7fPBF.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref8, $a0cf24fd73ae067c$var$_excluded2);
    let path = (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let routerState = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $a0cf24fd73ae067c$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$a6c7ac8248d6e38a, $a0cf24fd73ae067c$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $a0cf24fd73ae067c$export$a7fed597f4b8afd8 = /*#__PURE__*/ $7fPBF.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $a0cf24fd73ae067c$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref9, $a0cf24fd73ae067c$var$_excluded3);
    let submit = $a0cf24fd73ae067c$export$47c85c6e3a081d3();
    let formAction = $a0cf24fd73ae067c$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $7fPBF.createElement("form", $a0cf24fd73ae067c$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $a0cf24fd73ae067c$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $a0cf24fd73ae067c$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $a0cf24fd73ae067c$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($a0cf24fd73ae067c$var$DataRouterHook || ($a0cf24fd73ae067c$var$DataRouterHook = {}));
var $a0cf24fd73ae067c$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($a0cf24fd73ae067c$var$DataRouterStateHook || ($a0cf24fd73ae067c$var$DataRouterStateHook = {}));
// Internal hooks
function $a0cf24fd73ae067c$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $a0cf24fd73ae067c$var$useDataRouterContext(hookName) {
    let ctx = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$3add0d5dce533e2e));
    !ctx && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return ctx;
}
function $a0cf24fd73ae067c$var$useDataRouterState(hookName) {
    let state = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$145dfa71566a64dc));
    !state && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $a0cf24fd73ae067c$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let path = (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $7fPBF.useCallback((event)=>{
        if ($a0cf24fd73ae067c$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $55100129ab36ed65$export$fe53371bee54353d)(location) === (0, $55100129ab36ed65$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $a0cf24fd73ae067c$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $7fPBF.useRef($a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $7fPBF.useRef(false);
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let searchParams = $7fPBF.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $a0cf24fd73ae067c$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    let setSearchParams = $7fPBF.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $a0cf24fd73ae067c$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $a0cf24fd73ae067c$var$fetcherId = 0;
let $a0cf24fd73ae067c$var$getUniqueFetcherId = ()=>"__" + String(++$a0cf24fd73ae067c$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $a0cf24fd73ae067c$export$47c85c6e3a081d3() {
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let currentRouteId = (0, $d9fd026bfea79ab9$export$5fc8298006ad9e58)();
    return $7fPBF.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $a0cf24fd73ae067c$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $a0cf24fd73ae067c$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $a0cf24fd73ae067c$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $a0cf24fd73ae067c$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let routeContext = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$9072aa6dd1f93057));
    !routeContext && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $a0cf24fd73ae067c$var$_extends({}, (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $55100129ab36ed65$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $a0cf24fd73ae067c$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseFetcher);
    let state = $a0cf24fd73ae067c$var$useDataRouterState($a0cf24fd73ae067c$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $7fPBF.useContext($a0cf24fd73ae067c$export$148fd98d095596d4);
    let route = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    !route && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $a0cf24fd73ae067c$var$useIdImpl ? $a0cf24fd73ae067c$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $7fPBF.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($a0cf24fd73ae067c$var$getUniqueFetcherId());
    // Registration/cleanup
    $7fPBF.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $7fPBF.useCallback((href, opts)=>{
        !routeId && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $a0cf24fd73ae067c$export$47c85c6e3a081d3();
    let submit = $7fPBF.useCallback((target, opts)=>{
        submitImpl(target, $a0cf24fd73ae067c$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $7fPBF.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $7fPBF.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$a7fed597f4b8afd8, $a0cf24fd73ae067c$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $55100129ab36ed65$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $7fPBF.useMemo(()=>$a0cf24fd73ae067c$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $a0cf24fd73ae067c$export$fa996778a3a31087() {
    let state = $a0cf24fd73ae067c$var$useDataRouterState($a0cf24fd73ae067c$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $a0cf24fd73ae067c$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $a0cf24fd73ae067c$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $a0cf24fd73ae067c$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $a0cf24fd73ae067c$var$useDataRouterState($a0cf24fd73ae067c$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let matches = (0, $d9fd026bfea79ab9$export$2378eb7f5ff86053)();
    let navigation = (0, $d9fd026bfea79ab9$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $7fPBF.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $a0cf24fd73ae067c$var$usePageHide($7fPBF.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $a0cf24fd73ae067c$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($a0cf24fd73ae067c$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $a0cf24fd73ae067c$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($a0cf24fd73ae067c$var$_extends({}, location, {
                    pathname: (0, $55100129ab36ed65$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($a0cf24fd73ae067c$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $a0cf24fd73ae067c$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $7fPBF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $a0cf24fd73ae067c$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $7fPBF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $a0cf24fd73ae067c$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $d9fd026bfea79ab9$export$b273b3273281a049)(when);
    $7fPBF.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $7fPBF.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $a0cf24fd73ae067c$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $7fPBF.useContext($a0cf24fd73ae067c$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { basename: basename } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.useViewTransitionState);
    let path = (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $55100129ab36ed65$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $55100129ab36ed65$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $hmhHQ = parcelRequire("hmhHQ");
var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");
parcelRequire("7fPBF");


var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
const $c21ce0253dc11cd3$var$ThemeContext = /*#__PURE__*/ $7fPBF.createContext(null);
var $c21ce0253dc11cd3$export$2e2bcd8739ae039 = $c21ce0253dc11cd3$var$ThemeContext;


function $b5dba0f0f3e50f8f$export$2e2bcd8739ae039() {
    const theme = $7fPBF.useContext((0, $c21ce0253dc11cd3$export$2e2bcd8739ae039));
    return theme;
}


var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");




const $24ebfb3bf89f6ffe$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $24ebfb3bf89f6ffe$export$2e2bcd8739ae039 = $24ebfb3bf89f6ffe$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';



var $bbzbN = parcelRequire("bbzbN");
function $f311b16c4b43b6fd$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return (0, $kY3Ke.default)({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $f311b16c4b43b6fd$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $b5dba0f0f3e50f8f$export$2e2bcd8739ae039)();
    const theme = $7fPBF.useMemo(()=>{
        const output = outerTheme === null ? localTheme : $f311b16c4b43b6fd$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $24ebfb3bf89f6ffe$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c21ce0253dc11cd3$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $f311b16c4b43b6fd$export$2e2bcd8739ae039 = $f311b16c4b43b6fd$var$ThemeProvider;



parcelRequire("5nUae");
var $6te04 = parcelRequire("6te04");

var $7fPBF = parcelRequire("7fPBF");
parcelRequire("5nUae");
var $6te04 = parcelRequire("6te04");
'use client';
function $5e16ee62ac64bb0b$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $5e16ee62ac64bb0b$var$useTheme(defaultTheme = null) {
    const contextTheme = $7fPBF.useContext((0, $6te04.T));
    return !contextTheme || $5e16ee62ac64bb0b$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $5e16ee62ac64bb0b$export$2e2bcd8739ae039 = $5e16ee62ac64bb0b$var$useTheme;



var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $bbzbN = parcelRequire("bbzbN");
const $ef654b446fc390d6$var$_excluded = [
    "value"
];
const $ef654b446fc390d6$var$RtlContext = /*#__PURE__*/ $7fPBF.createContext();
function $ef654b446fc390d6$var$RtlProvider(_ref) {
    let { value: value } = _ref, props = (0, $cFLic.default)(_ref, $ef654b446fc390d6$var$_excluded);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($ef654b446fc390d6$var$RtlContext.Provider, (0, $kY3Ke.default)({
        value: value != null ? value : true
    }, props));
}
const $ef654b446fc390d6$export$b2dd014b6c321cb = ()=>{
    const value = $7fPBF.useContext($ef654b446fc390d6$var$RtlContext);
    return value != null ? value : false;
};
var $ef654b446fc390d6$export$2e2bcd8739ae039 = $ef654b446fc390d6$var$RtlProvider;



var $7eatR = parcelRequire("7eatR");
parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $fd3794ae41ea97a8$var$useEnhancedEffect = typeof window !== 'undefined' ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;
var $fd3794ae41ea97a8$export$2e2bcd8739ae039 = $fd3794ae41ea97a8$var$useEnhancedEffect;



var $7fPBF = parcelRequire("7fPBF");
'use client';
let $46f5b561912058f9$var$globalId = 0;
function $46f5b561912058f9$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $7fPBF.useState(idOverride);
    const id = idOverride || defaultId;
    $7fPBF.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $46f5b561912058f9$var$globalId += 1;
            setDefaultId(`mui-${$46f5b561912058f9$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// downstream bundlers may remove unnecessary concatenation, but won't remove toString call -- Workaround for https://github.com/webpack/webpack/issues/14814
const $46f5b561912058f9$var$maybeReactUseId = $7fPBF['useId'.toString()];
function $46f5b561912058f9$export$2e2bcd8739ae039(idOverride) {
    if ($46f5b561912058f9$var$maybeReactUseId !== undefined) {
        const reactId = $46f5b561912058f9$var$maybeReactUseId();
        return idOverride != null ? idOverride : reactId;
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $46f5b561912058f9$var$useGlobalId(idOverride);
}


parcelRequire("7fPBF");


var $5VCcJ = parcelRequire("5VCcJ");
var $5tMhb = parcelRequire("5tMhb");

var $2G6xE = parcelRequire("2G6xE");

'use client';
const $328672c8d07e1c59$export$35e57303dbd8a66 = (0, $2G6xE.default)();
function $328672c8d07e1c59$var$useTheme(defaultTheme = $328672c8d07e1c59$export$35e57303dbd8a66) {
    return (0, $5e16ee62ac64bb0b$export$2e2bcd8739ae039)(defaultTheme);
}
var $328672c8d07e1c59$export$2e2bcd8739ae039 = $328672c8d07e1c59$var$useTheme;



var $bbzbN = parcelRequire("bbzbN");
'use client';
function $ee13700d4d997375$var$wrapGlobalLayer(styles) {
    const serialized = (0, $5VCcJ.internal_serializeStyles)(styles);
    if (styles !== serialized && serialized.styles) {
        if (!serialized.styles.match(/^@layer\s+[^{]*$/)) // If the styles are not already wrapped in a layer, wrap them in a global layer.
        serialized.styles = `@layer global{${serialized.styles}}`;
        return serialized;
    }
    return styles;
}
function $ee13700d4d997375$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $328672c8d07e1c59$export$2e2bcd8739ae039)(defaultTheme);
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
    if (resolvedTheme.modularCssLayers) {
        if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg)=>{
            if (typeof styleArg === 'function') return $ee13700d4d997375$var$wrapGlobalLayer(styleArg(resolvedTheme));
            return $ee13700d4d997375$var$wrapGlobalLayer(styleArg);
        });
        else globalStyles = $ee13700d4d997375$var$wrapGlobalLayer(globalStyles);
    }
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5tMhb.default), {
        styles: globalStyles
    });
}
var $ee13700d4d997375$export$2e2bcd8739ae039 = $ee13700d4d997375$var$GlobalStyles;




var $bbzbN = parcelRequire("bbzbN");
'use client';
function $eab94dcf3e175f98$export$2e2bcd8739ae039(theme) {
    const upperTheme = (0, $5e16ee62ac64bb0b$export$2e2bcd8739ae039)();
    const id = (0, $46f5b561912058f9$export$2e2bcd8739ae039)() || '';
    const { modularCssLayers: modularCssLayers } = theme;
    let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
    if (!modularCssLayers || upperTheme !== null) // skip this hook if upper theme exists.
    layerOrder = '';
    else if (typeof modularCssLayers === 'string') layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
    else layerOrder = `@layer ${layerOrder};`;
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        const head = document.querySelector('head');
        if (!head) return;
        const firstChild = head.firstChild;
        if (layerOrder) {
            var _firstChild$hasAttrib;
            // Only insert if first child doesn't have data-mui-layer-order attribute
            if (firstChild && (_firstChild$hasAttrib = firstChild.hasAttribute) != null && _firstChild$hasAttrib.call(firstChild, 'data-mui-layer-order') && firstChild.getAttribute('data-mui-layer-order') === id) return;
            const styleElement = document.createElement('style');
            styleElement.setAttribute('data-mui-layer-order', id);
            styleElement.textContent = layerOrder;
            head.prepend(styleElement);
        } else {
            var _head$querySelector;
            (_head$querySelector = head.querySelector(`style[data-mui-layer-order="${id}"]`)) == null || _head$querySelector.remove();
        }
    }, [
        layerOrder,
        id
    ]);
    if (!layerOrder) return null;
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ee13700d4d997375$export$2e2bcd8739ae039), {
        styles: layerOrder
    });
}



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $cac97cfcc46fa531$var$EMPTY_THEME = {};
function $cac97cfcc46fa531$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $7fPBF.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? (0, $kY3Ke.default)({}, upperTheme, {
                [themeId]: mergedTheme
            }) : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? (0, $kY3Ke.default)({}, upperTheme, {
            [themeId]: localTheme
        }) : (0, $kY3Ke.default)({}, upperTheme, localTheme);
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $cac97cfcc46fa531$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $5e16ee62ac64bb0b$export$2e2bcd8739ae039)($cac97cfcc46fa531$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $b5dba0f0f3e50f8f$export$2e2bcd8739ae039)() || $cac97cfcc46fa531$var$EMPTY_THEME;
    const engineTheme = $cac97cfcc46fa531$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $cac97cfcc46fa531$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = engineTheme.direction === 'rtl';
    const layerOrder = (0, $eab94dcf3e175f98$export$2e2bcd8739ae039)(engineTheme);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f311b16c4b43b6fd$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6te04.T).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ef654b446fc390d6$export$2e2bcd8739ae039), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $7eatR.default), {
                    value: engineTheme == null ? void 0 : engineTheme.components,
                    children: [
                        layerOrder,
                        children
                    ]
                })
            })
        })
    });
}
var $cac97cfcc46fa531$export$2e2bcd8739ae039 = $cac97cfcc46fa531$var$ThemeProvider;



var $jwhZE = parcelRequire("jwhZE");

var $bbzbN = parcelRequire("bbzbN");
'use client';
const $b8226d5132dedede$var$_excluded = [
    "theme"
];
function $b8226d5132dedede$export$2e2bcd8739ae039(_ref) {
    let { theme: themeInput } = _ref, props = (0, $cFLic.default)(_ref, $b8226d5132dedede$var$_excluded);
    const scopedTheme = themeInput[0, $jwhZE.default];
    let finalTheme = scopedTheme || themeInput;
    if (typeof themeInput !== 'function') {
        if (scopedTheme && !scopedTheme.vars) finalTheme = (0, $kY3Ke.default)({}, scopedTheme, {
            vars: null
        });
        else if (themeInput && !themeInput.vars) finalTheme = (0, $kY3Ke.default)({}, themeInput, {
            vars: null
        });
    }
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $cac97cfcc46fa531$export$2e2bcd8739ae039), (0, $kY3Ke.default)({}, props, {
        themeId: scopedTheme ? (0, $jwhZE.default) : undefined,
        theme: finalTheme
    }));
}



var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $iVAEr = parcelRequire("iVAEr");

var $kY3Ke = parcelRequire("kY3Ke");
parcelRequire("7fPBF");



var $9P91Y = parcelRequire("9P91Y");

var $jwhZE = parcelRequire("jwhZE");

var $bbzbN = parcelRequire("bbzbN");
'use client';
function $a50e20ff7f02e09b$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ee13700d4d997375$export$2e2bcd8739ae039), (0, $kY3Ke.default)({}, props, {
        defaultTheme: (0, $9P91Y.default),
        themeId: (0, $jwhZE.default)
    }));
}
var $a50e20ff7f02e09b$export$2e2bcd8739ae039 = $a50e20ff7f02e09b$var$GlobalStyles;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $81465d564338b8cb$export$c0bb0b647f701bb5 = (theme, enableColorScheme)=>(0, $kY3Ke.default)({
        WebkitFontSmoothing: 'antialiased',
        // Antialiasing.
        MozOsxFontSmoothing: 'grayscale',
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: 'border-box',
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: '100%'
    }, enableColorScheme && !theme.vars && {
        colorScheme: theme.palette.mode
    });
const $81465d564338b8cb$export$32180ef41b15b513 = (theme)=>(0, $kY3Ke.default)({
        color: (theme.vars || theme).palette.text.primary
    }, theme.typography.body1, {
        backgroundColor: (theme.vars || theme).palette.background.default,
        '@media print': {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
const $81465d564338b8cb$export$9dd6ff9ea0189349 = (theme, enableColorScheme = false)=>{
    var _theme$components;
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        var _scheme$palette;
        colorSchemeStyles[theme.getColorSchemeSelector(key).replace(/\s*&/, '')] = {
            colorScheme: (_scheme$palette = scheme.palette) == null ? void 0 : _scheme$palette.mode
        };
    });
    let defaultStyles = (0, $kY3Ke.default)({
        html: $81465d564338b8cb$export$c0bb0b647f701bb5(theme, enableColorScheme),
        '*, *::before, *::after': {
            boxSizing: 'inherit'
        },
        'strong, b': {
            fontWeight: theme.typography.fontWeightBold
        },
        body: (0, $kY3Ke.default)({
            margin: 0
        }, $81465d564338b8cb$export$32180ef41b15b513(theme), {
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            '&::backdrop': {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        })
    }, colorSchemeStyles);
    const themeOverrides = (_theme$components = theme.components) == null || (_theme$components = _theme$components.MuiCssBaseline) == null ? void 0 : _theme$components.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $81465d564338b8cb$var$CssBaseline(inProps) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiCssBaseline'
    });
    const { children: children, enableColorScheme: enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($7fPBF.Fragment, {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a50e20ff7f02e09b$export$2e2bcd8739ae039), {
                styles: (theme)=>$81465d564338b8cb$export$9dd6ff9ea0189349(theme, enableColorScheme)
            }),
            children
        ]
    });
}
var $81465d564338b8cb$export$2e2bcd8739ae039 = $81465d564338b8cb$var$CssBaseline;


/*! @azure/msal-browser v3.30.0 2025-08-05 */ /*! @azure/msal-browser v3.30.0 2025-08-05 */ /*! @azure/msal-browser v3.30.0 2025-08-05 */ /*! @azure/msal-browser v3.30.0 2025-08-05 */ /*! @azure/msal-common v14.16.1 2025-08-05 */ /*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $08c107807d753255$export$a002182e51710d39 = {
    LIBRARY_NAME: "MSAL.JS",
    SKU: "msal.js.common",
    // Prefix for all library cache entries
    CACHE_PREFIX: "msal",
    // default authority
    DEFAULT_AUTHORITY: "https://login.microsoftonline.com/common/",
    DEFAULT_AUTHORITY_HOST: "login.microsoftonline.com",
    DEFAULT_COMMON_TENANT: "common",
    // ADFS String
    ADFS: "adfs",
    DSTS: "dstsv2",
    // Default AAD Instance Discovery Endpoint
    AAD_INSTANCE_DISCOVERY_ENDPT: "https://login.microsoftonline.com/common/discovery/instance?api-version=1.1&authorization_endpoint=",
    // CIAM URL
    CIAM_AUTH_URL: ".ciamlogin.com",
    AAD_TENANT_DOMAIN_SUFFIX: ".onmicrosoft.com",
    // Resource delimiter - used for certain cache entries
    RESOURCE_DELIM: "|",
    // Placeholder for non-existent account ids/objects
    NO_ACCOUNT: "NO_ACCOUNT",
    // Claims
    CLAIMS: "claims",
    // Consumer UTID
    CONSUMER_UTID: "9188040d-6c67-4c5b-b112-36a304b66dad",
    // Default scopes
    OPENID_SCOPE: "openid",
    PROFILE_SCOPE: "profile",
    OFFLINE_ACCESS_SCOPE: "offline_access",
    EMAIL_SCOPE: "email",
    // Default response type for authorization code flow
    CODE_RESPONSE_TYPE: "code",
    CODE_GRANT_TYPE: "authorization_code",
    RT_GRANT_TYPE: "refresh_token",
    FRAGMENT_RESPONSE_MODE: "fragment",
    S256_CODE_CHALLENGE_METHOD: "S256",
    URL_FORM_CONTENT_TYPE: "application/x-www-form-urlencoded;charset=utf-8",
    AUTHORIZATION_PENDING: "authorization_pending",
    NOT_DEFINED: "not_defined",
    EMPTY_STRING: "",
    NOT_APPLICABLE: "N/A",
    NOT_AVAILABLE: "Not Available",
    FORWARD_SLASH: "/",
    IMDS_ENDPOINT: "http://169.254.169.254/metadata/instance/compute/location",
    IMDS_VERSION: "2020-06-01",
    IMDS_TIMEOUT: 2000,
    AZURE_REGION_AUTO_DISCOVER_FLAG: "TryAutoDetect",
    REGIONAL_AUTH_PUBLIC_CLOUD_SUFFIX: "login.microsoft.com",
    KNOWN_PUBLIC_CLOUDS: [
        "login.microsoftonline.com",
        "login.windows.net",
        "login.microsoft.com",
        "sts.windows.net"
    ],
    TOKEN_RESPONSE_TYPE: "token",
    ID_TOKEN_RESPONSE_TYPE: "id_token",
    SHR_NONCE_VALIDITY: 240,
    INVALID_INSTANCE: "invalid_instance"
};
const $08c107807d753255$export$2b71909294c66558 = {
    SUCCESS: 200,
    SUCCESS_RANGE_START: 200,
    SUCCESS_RANGE_END: 299,
    REDIRECT: 302,
    CLIENT_ERROR: 400,
    CLIENT_ERROR_RANGE_START: 400,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    NOT_FOUND: 404,
    REQUEST_TIMEOUT: 408,
    TOO_MANY_REQUESTS: 429,
    CLIENT_ERROR_RANGE_END: 499,
    SERVER_ERROR: 500,
    SERVER_ERROR_RANGE_START: 500,
    SERVICE_UNAVAILABLE: 503,
    GATEWAY_TIMEOUT: 504,
    SERVER_ERROR_RANGE_END: 599,
    MULTI_SIDED_ERROR: 600
};
const $08c107807d753255$export$893b1b5b686d84ef = [
    $08c107807d753255$export$a002182e51710d39.OPENID_SCOPE,
    $08c107807d753255$export$a002182e51710d39.PROFILE_SCOPE,
    $08c107807d753255$export$a002182e51710d39.OFFLINE_ACCESS_SCOPE
];
const $08c107807d753255$export$268e88275f5afab2 = [
    ...$08c107807d753255$export$893b1b5b686d84ef,
    $08c107807d753255$export$a002182e51710d39.EMAIL_SCOPE
];
/**
 * Request header names
 */ const $08c107807d753255$export$28d77f87efed1d88 = {
    CONTENT_TYPE: "Content-Type",
    CONTENT_LENGTH: "Content-Length",
    RETRY_AFTER: "Retry-After",
    CCS_HEADER: "X-AnchorMailbox",
    WWWAuthenticate: "WWW-Authenticate",
    AuthenticationInfo: "Authentication-Info",
    X_MS_REQUEST_ID: "x-ms-request-id",
    X_MS_HTTP_VERSION: "x-ms-httpver"
};
/**
 * Persistent cache keys MSAL which stay while user is logged in.
 */ const $08c107807d753255$export$81ab9ba9bd28255c = {
    ID_TOKEN: "idtoken",
    CLIENT_INFO: "client.info",
    ADAL_ID_TOKEN: "adal.idtoken",
    ERROR: "error",
    ERROR_DESC: "error.description",
    ACTIVE_ACCOUNT: "active-account",
    ACTIVE_ACCOUNT_FILTERS: "active-account-filters"
};
/**
 * String constants related to AAD Authority
 */ const $08c107807d753255$export$e18ac120172ed505 = {
    COMMON: "common",
    ORGANIZATIONS: "organizations",
    CONSUMERS: "consumers"
};
/**
 * Claims request keys
 */ const $08c107807d753255$export$c125cda26c71ef54 = {
    ACCESS_TOKEN: "access_token",
    XMS_CC: "xms_cc"
};
/**
 * we considered making this "enum" in the request instead of string, however it looks like the allowed list of
 * prompt values kept changing over past couple of years. There are some undocumented prompt values for some
 * internal partners too, hence the choice of generic "string" type instead of the "enum"
 */ const $08c107807d753255$export$49a06cbda5acaa5 = {
    LOGIN: "login",
    SELECT_ACCOUNT: "select_account",
    CONSENT: "consent",
    NONE: "none",
    CREATE: "create",
    NO_SESSION: "no_session"
};
/**
 * allowed values for codeVerifier
 */ const $08c107807d753255$export$a1fe36237c1cc863 = {
    PLAIN: "plain",
    S256: "S256"
};
/**
 * allowed values for server response type
 */ const $08c107807d753255$export$b34cb6fbea2adc44 = {
    QUERY: "query",
    FRAGMENT: "fragment"
};
/**
 * allowed values for response_mode
 */ const $08c107807d753255$export$f990a5bae1260b8c = {
    ...$08c107807d753255$export$b34cb6fbea2adc44,
    FORM_POST: "form_post"
};
/**
 * allowed grant_type
 */ const $08c107807d753255$export$ce68f19b50b39c0b = {
    IMPLICIT_GRANT: "implicit",
    AUTHORIZATION_CODE_GRANT: "authorization_code",
    CLIENT_CREDENTIALS_GRANT: "client_credentials",
    RESOURCE_OWNER_PASSWORD_GRANT: "password",
    REFRESH_TOKEN_GRANT: "refresh_token",
    DEVICE_CODE_GRANT: "device_code",
    JWT_BEARER: "urn:ietf:params:oauth:grant-type:jwt-bearer"
};
/**
 * Account types in Cache
 */ const $08c107807d753255$export$23244fafa2e7f55c = {
    MSSTS_ACCOUNT_TYPE: "MSSTS",
    ADFS_ACCOUNT_TYPE: "ADFS",
    MSAV1_ACCOUNT_TYPE: "MSA",
    GENERIC_ACCOUNT_TYPE: "Generic"
};
/**
 * Separators used in cache
 */ const $08c107807d753255$export$520854da2ba5d734 = {
    CACHE_KEY_SEPARATOR: "-",
    CLIENT_INFO_SEPARATOR: "."
};
/**
 * Credential Type stored in the cache
 */ const $08c107807d753255$export$eca2dc7e6e608a68 = {
    ID_TOKEN: "IdToken",
    ACCESS_TOKEN: "AccessToken",
    ACCESS_TOKEN_WITH_AUTH_SCHEME: "AccessToken_With_AuthScheme",
    REFRESH_TOKEN: "RefreshToken"
};
/**
 * Combine all cache types
 */ const $08c107807d753255$export$ba193b555633db78 = {
    ADFS: 1001,
    MSA: 1002,
    MSSTS: 1003,
    GENERIC: 1004,
    ACCESS_TOKEN: 2001,
    REFRESH_TOKEN: 2002,
    ID_TOKEN: 2003,
    APP_METADATA: 3001,
    UNDEFINED: 9999
};
/**
 * More Cache related constants
 */ const $08c107807d753255$export$7e1bea6dc1b6b32e = "appmetadata";
const $08c107807d753255$export$476989d62bcb4c85 = "client_info";
const $08c107807d753255$export$978fe7ab5e74b539 = "1";
const $08c107807d753255$export$d483f966e66f4db5 = {
    CACHE_KEY: "authority-metadata",
    REFRESH_TIME_SECONDS: 86400
};
const $08c107807d753255$export$5d365d77acfcb55d = {
    CONFIG: "config",
    CACHE: "cache",
    NETWORK: "network",
    HARDCODED_VALUES: "hardcoded_values"
};
const $08c107807d753255$export$30fa4ad28fb9feeb = {
    SCHEMA_VERSION: 5,
    MAX_CUR_HEADER_BYTES: 80,
    MAX_LAST_HEADER_BYTES: 330,
    MAX_CACHED_ERRORS: 50,
    CACHE_KEY: "server-telemetry",
    CATEGORY_SEPARATOR: "|",
    VALUE_SEPARATOR: ",",
    OVERFLOW_TRUE: "1",
    OVERFLOW_FALSE: "0",
    UNKNOWN_ERROR: "unknown_error"
};
/**
 * Type of the authentication request
 */ const $08c107807d753255$export$901491a717da2ba5 = {
    BEARER: "Bearer",
    POP: "pop",
    SSH: "ssh-cert"
};
/**
 * Constants related to throttling
 */ const $08c107807d753255$export$a2330d6808e6d893 = {
    // Default time to throttle RequestThumbprint in seconds
    DEFAULT_THROTTLE_TIME_SECONDS: 60,
    // Default maximum time to throttle in seconds, overrides what the server sends back
    DEFAULT_MAX_THROTTLE_TIME_SECONDS: 3600,
    // Prefix for storing throttling entries
    THROTTLING_PREFIX: "throttling",
    // Value assigned to the x-ms-lib-capability header to indicate to the server the library supports throttling
    X_MS_LIB_CAPABILITY_VALUE: "retry-after, h429"
};
const $08c107807d753255$export$b8e9cd941e8016ac = {
    INVALID_GRANT_ERROR: "invalid_grant",
    CLIENT_MISMATCH_ERROR: "client_mismatch"
};
/**
 * Password grant parameters
 */ const $08c107807d753255$export$fa8b29062cab1da = {
    username: "username",
    password: "password"
};
/**
 * Response codes
 */ const $08c107807d753255$export$20ba0879771a17be = {
    httpSuccess: 200,
    httpBadRequest: 400
};
/**
 * Region Discovery Sources
 */ const $08c107807d753255$export$3d4a3e11df589b40 = {
    FAILED_AUTO_DETECTION: "1",
    INTERNAL_CACHE: "2",
    ENVIRONMENT_VARIABLE: "3",
    IMDS: "4"
};
/**
 * Region Discovery Outcomes
 */ const $08c107807d753255$export$92a685f9218422bd = {
    CONFIGURED_MATCHES_DETECTED: "1",
    CONFIGURED_NO_AUTO_DETECTION: "2",
    CONFIGURED_NOT_DETECTED: "3",
    AUTO_DETECTION_REQUESTED_SUCCESSFUL: "4",
    AUTO_DETECTION_REQUESTED_FAILED: "5"
};
/**
 * Specifies the reason for fetching the access token from the identity provider
 */ const $08c107807d753255$export$aa4af185ea049f6b = {
    // When a token is found in the cache or the cache is not supposed to be hit when making the request
    NOT_APPLICABLE: "0",
    // When the token request goes to the identity provider because force_refresh was set to true. Also occurs if claims were requested
    FORCE_REFRESH_OR_CLAIMS: "1",
    // When the token request goes to the identity provider because no cached access token exists
    NO_CACHED_ACCESS_TOKEN: "2",
    // When the token request goes to the identity provider because cached access token expired
    CACHED_ACCESS_TOKEN_EXPIRED: "3",
    // When the token request goes to the identity provider because refresh_in was used and the existing token needs to be refreshed
    PROACTIVELY_REFRESHED: "4"
};
const $08c107807d753255$export$fe5c42ed17efe603 = {
    Jwt: "JWT",
    Jwk: "JWK",
    Pop: "pop"
};
const $08c107807d753255$export$14c29d43b22a755f = 86400000;
// Token renewal offset default in seconds
const $08c107807d753255$export$8d50f42618161d1a = 300;


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Log message level.
 */ var $4643cd557adfd6d5$export$243e62d78d3b544d;
(function(LogLevel) {
    LogLevel[LogLevel["Error"] = 0] = "Error";
    LogLevel[LogLevel["Warning"] = 1] = "Warning";
    LogLevel[LogLevel["Info"] = 2] = "Info";
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
    LogLevel[LogLevel["Trace"] = 4] = "Trace";
})($4643cd557adfd6d5$export$243e62d78d3b544d || ($4643cd557adfd6d5$export$243e62d78d3b544d = {}));
/**
 * Class which facilitates logging of messages to a specific place.
 */ class $4643cd557adfd6d5$export$efa9a398d6368992 {
    constructor(loggerOptions, packageName, packageVersion){
        // Current log level, defaults to info.
        this.level = $4643cd557adfd6d5$export$243e62d78d3b544d.Info;
        const defaultLoggerCallback = ()=>{
            return;
        };
        const setLoggerOptions = loggerOptions || $4643cd557adfd6d5$export$efa9a398d6368992.createDefaultLoggerOptions();
        this.localCallback = setLoggerOptions.loggerCallback || defaultLoggerCallback;
        this.piiLoggingEnabled = setLoggerOptions.piiLoggingEnabled || false;
        this.level = typeof setLoggerOptions.logLevel === "number" ? setLoggerOptions.logLevel : $4643cd557adfd6d5$export$243e62d78d3b544d.Info;
        this.correlationId = setLoggerOptions.correlationId || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING;
        this.packageName = packageName || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING;
        this.packageVersion = packageVersion || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING;
    }
    static createDefaultLoggerOptions() {
        return {
            loggerCallback: ()=>{
            // allow users to not set loggerCallback
            },
            piiLoggingEnabled: false,
            logLevel: $4643cd557adfd6d5$export$243e62d78d3b544d.Info
        };
    }
    /**
     * Create new Logger with existing configurations.
     */ clone(packageName, packageVersion, correlationId) {
        return new $4643cd557adfd6d5$export$efa9a398d6368992({
            loggerCallback: this.localCallback,
            piiLoggingEnabled: this.piiLoggingEnabled,
            logLevel: this.level,
            correlationId: correlationId || this.correlationId
        }, packageName, packageVersion);
    }
    /**
     * Log message with required options.
     */ logMessage(logMessage, options) {
        if (options.logLevel > this.level || !this.piiLoggingEnabled && options.containsPii) return;
        const timestamp = new Date().toUTCString();
        // Add correlationId to logs if set, correlationId provided on log messages take precedence
        const logHeader = `[${timestamp}] : [${options.correlationId || this.correlationId || ""}]`;
        const log = `${logHeader} : ${this.packageName}@${this.packageVersion} : ${$4643cd557adfd6d5$export$243e62d78d3b544d[options.logLevel]} - ${logMessage}`;
        // debug(`msal:${LogLevel[options.logLevel]}${options.containsPii ? "-Pii": Constants.EMPTY_STRING}${options.context ? `:${options.context}` : Constants.EMPTY_STRING}`)(logMessage);
        this.executeCallback(options.logLevel, log, options.containsPii || false);
    }
    /**
     * Execute callback with message.
     */ executeCallback(level, message, containsPii) {
        if (this.localCallback) this.localCallback(level, message, containsPii);
    }
    /**
     * Logs error messages.
     */ error(message, correlationId) {
        this.logMessage(message, {
            logLevel: $4643cd557adfd6d5$export$243e62d78d3b544d.Error,
            containsPii: false,
            correlationId: correlationId || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs error messages with PII.
     */ errorPii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $4643cd557adfd6d5$export$243e62d78d3b544d.Error,
            containsPii: true,
            correlationId: correlationId || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs warning messages.
     */ warning(message, correlationId) {
        this.logMessage(message, {
            logLevel: $4643cd557adfd6d5$export$243e62d78d3b544d.Warning,
            containsPii: false,
            correlationId: correlationId || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs warning messages with PII.
     */ warningPii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $4643cd557adfd6d5$export$243e62d78d3b544d.Warning,
            containsPii: true,
            correlationId: correlationId || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs info messages.
     */ info(message, correlationId) {
        this.logMessage(message, {
            logLevel: $4643cd557adfd6d5$export$243e62d78d3b544d.Info,
            containsPii: false,
            correlationId: correlationId || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs info messages with PII.
     */ infoPii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $4643cd557adfd6d5$export$243e62d78d3b544d.Info,
            containsPii: true,
            correlationId: correlationId || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs verbose messages.
     */ verbose(message, correlationId) {
        this.logMessage(message, {
            logLevel: $4643cd557adfd6d5$export$243e62d78d3b544d.Verbose,
            containsPii: false,
            correlationId: correlationId || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs verbose messages with PII.
     */ verbosePii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $4643cd557adfd6d5$export$243e62d78d3b544d.Verbose,
            containsPii: true,
            correlationId: correlationId || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs trace messages.
     */ trace(message, correlationId) {
        this.logMessage(message, {
            logLevel: $4643cd557adfd6d5$export$243e62d78d3b544d.Trace,
            containsPii: false,
            correlationId: correlationId || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Logs trace messages with PII.
     */ tracePii(message, correlationId) {
        this.logMessage(message, {
            logLevel: $4643cd557adfd6d5$export$243e62d78d3b544d.Trace,
            containsPii: true,
            correlationId: correlationId || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING
        });
    }
    /**
     * Returns whether PII Logging is enabled or not.
     */ isPiiLoggingEnabled() {
        return this.piiLoggingEnabled || false;
    }
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ /*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Protocol modes supported by MSAL.
 */ const $a47d2ec0503d310c$export$73a3e3dedd37150d = {
    AAD: "AAD",
    OIDC: "OIDC"
};

/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $7ae45af95b45dab9$export$4cda21933050d9ec = {
    // AzureCloudInstance is not specified.
    None: "none",
    // Microsoft Azure public cloud
    AzurePublic: "https://login.microsoftonline.com",
    // Microsoft PPE
    AzurePpe: "https://login.windows-ppe.net",
    // Microsoft Chinese national/regional cloud
    AzureChina: "https://login.chinacloudapi.cn",
    // Microsoft German national/regional cloud ("Black Forest")
    AzureGermany: "https://login.microsoftonline.de",
    // US Government cloud
    AzureUsGovernment: "https://login.microsoftonline.us"
};

/*! @azure/msal-common v14.16.1 2025-08-05 */ /*! @azure/msal-common v14.16.1 2025-08-05 */ /*! @azure/msal-common v14.16.1 2025-08-05 */ /*! @azure/msal-common v14.16.1 2025-08-05 */ 
var $c741bd9c870ee400$exports = {};

$parcel$export($c741bd9c870ee400$exports, "unexpectedError", function () { return $c741bd9c870ee400$export$efbc88c27b0be04; });
$parcel$export($c741bd9c870ee400$exports, "postRequestFailed", function () { return $c741bd9c870ee400$export$7a1e28a7b60ca602; });
/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * AuthErrorMessage class containing string constants used by error codes and messages.
 */ const $c741bd9c870ee400$export$efbc88c27b0be04 = "unexpected_error";
const $c741bd9c870ee400$export$7a1e28a7b60ca602 = "post_request_failed";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $53b49d8334c1646a$export$cd5f04206718d3a5 = {
    [(0, $c741bd9c870ee400$export$efbc88c27b0be04)]: "Unexpected error in authentication.",
    [(0, $c741bd9c870ee400$export$7a1e28a7b60ca602)]: "Post request failed from the network, could be a 4xx/5xx or a network unavailability. Please check the exact error code for details."
};
/**
 * AuthErrorMessage class containing string constants used by error codes and messages.
 * @deprecated Use AuthErrorCodes instead
 */ const $53b49d8334c1646a$export$930cbd4733f218f0 = {
    unexpectedError: {
        code: (0, $c741bd9c870ee400$export$efbc88c27b0be04),
        desc: $53b49d8334c1646a$export$cd5f04206718d3a5[0, $c741bd9c870ee400$export$efbc88c27b0be04]
    },
    postRequestFailed: {
        code: (0, $c741bd9c870ee400$export$7a1e28a7b60ca602),
        desc: $53b49d8334c1646a$export$cd5f04206718d3a5[0, $c741bd9c870ee400$export$7a1e28a7b60ca602]
    }
};
/**
 * General error class thrown by the MSAL.js library.
 */ class $53b49d8334c1646a$export$145273558d58e0ac extends Error {
    constructor(errorCode, errorMessage, suberror){
        const errorString = errorMessage ? `${errorCode}: ${errorMessage}` : errorCode;
        super(errorString);
        Object.setPrototypeOf(this, $53b49d8334c1646a$export$145273558d58e0ac.prototype);
        this.errorCode = errorCode || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING;
        this.errorMessage = errorMessage || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING;
        this.subError = suberror || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING;
        this.name = "AuthError";
    }
    setCorrelationId(correlationId) {
        this.correlationId = correlationId;
    }
}
function $53b49d8334c1646a$export$eb157f7636c79bd2(code, additionalMessage) {
    return new $53b49d8334c1646a$export$145273558d58e0ac(code, additionalMessage ? `${$53b49d8334c1646a$export$cd5f04206718d3a5[code]} ${additionalMessage}` : $53b49d8334c1646a$export$cd5f04206718d3a5[code]);
}


var $9f4ee6b47026c448$exports = {};

$parcel$export($9f4ee6b47026c448$exports, "clientInfoDecodingError", function () { return $9f4ee6b47026c448$export$ccdf48c387c47b82; });
$parcel$export($9f4ee6b47026c448$exports, "clientInfoEmptyError", function () { return $9f4ee6b47026c448$export$12315251e24e0181; });
$parcel$export($9f4ee6b47026c448$exports, "tokenParsingError", function () { return $9f4ee6b47026c448$export$ad362b2e3a260143; });
$parcel$export($9f4ee6b47026c448$exports, "nullOrEmptyToken", function () { return $9f4ee6b47026c448$export$78d01e29cb494be2; });
$parcel$export($9f4ee6b47026c448$exports, "endpointResolutionError", function () { return $9f4ee6b47026c448$export$c9fcc93738cc2bc3; });
$parcel$export($9f4ee6b47026c448$exports, "networkError", function () { return $9f4ee6b47026c448$export$4358cbadf08aa73; });
$parcel$export($9f4ee6b47026c448$exports, "openIdConfigError", function () { return $9f4ee6b47026c448$export$73566da29bc073eb; });
$parcel$export($9f4ee6b47026c448$exports, "hashNotDeserialized", function () { return $9f4ee6b47026c448$export$14c4d54a8414667f; });
$parcel$export($9f4ee6b47026c448$exports, "invalidState", function () { return $9f4ee6b47026c448$export$72a77317632c052b; });
$parcel$export($9f4ee6b47026c448$exports, "stateMismatch", function () { return $9f4ee6b47026c448$export$6a56d8f882843cd8; });
$parcel$export($9f4ee6b47026c448$exports, "stateNotFound", function () { return $9f4ee6b47026c448$export$ef9214cfa5960fc; });
$parcel$export($9f4ee6b47026c448$exports, "nonceMismatch", function () { return $9f4ee6b47026c448$export$edd0491c2c280be7; });
$parcel$export($9f4ee6b47026c448$exports, "authTimeNotFound", function () { return $9f4ee6b47026c448$export$43356944266c945e; });
$parcel$export($9f4ee6b47026c448$exports, "maxAgeTranspired", function () { return $9f4ee6b47026c448$export$f95fb86904f89749; });
$parcel$export($9f4ee6b47026c448$exports, "multipleMatchingTokens", function () { return $9f4ee6b47026c448$export$47c50a2451614107; });
$parcel$export($9f4ee6b47026c448$exports, "multipleMatchingAccounts", function () { return $9f4ee6b47026c448$export$2804a8b1b4c3be8b; });
$parcel$export($9f4ee6b47026c448$exports, "multipleMatchingAppMetadata", function () { return $9f4ee6b47026c448$export$575bb2924bcd0084; });
$parcel$export($9f4ee6b47026c448$exports, "requestCannotBeMade", function () { return $9f4ee6b47026c448$export$4ac9fb1f531eded7; });
$parcel$export($9f4ee6b47026c448$exports, "cannotRemoveEmptyScope", function () { return $9f4ee6b47026c448$export$f7a276c01beb068a; });
$parcel$export($9f4ee6b47026c448$exports, "cannotAppendScopeSet", function () { return $9f4ee6b47026c448$export$93883786cf4a4a27; });
$parcel$export($9f4ee6b47026c448$exports, "emptyInputScopeSet", function () { return $9f4ee6b47026c448$export$41e2ce5958c42c83; });
$parcel$export($9f4ee6b47026c448$exports, "deviceCodePollingCancelled", function () { return $9f4ee6b47026c448$export$e3af42f9856ab2a; });
$parcel$export($9f4ee6b47026c448$exports, "deviceCodeExpired", function () { return $9f4ee6b47026c448$export$c0ef55deeb5e30d5; });
$parcel$export($9f4ee6b47026c448$exports, "deviceCodeUnknownError", function () { return $9f4ee6b47026c448$export$4a9e9cce395ba70c; });
$parcel$export($9f4ee6b47026c448$exports, "noAccountInSilentRequest", function () { return $9f4ee6b47026c448$export$5a3c7d1c90ac9220; });
$parcel$export($9f4ee6b47026c448$exports, "invalidCacheRecord", function () { return $9f4ee6b47026c448$export$d396103576f879cc; });
$parcel$export($9f4ee6b47026c448$exports, "invalidCacheEnvironment", function () { return $9f4ee6b47026c448$export$dedc648643245fa1; });
$parcel$export($9f4ee6b47026c448$exports, "noAccountFound", function () { return $9f4ee6b47026c448$export$b98ebfe073f0162f; });
$parcel$export($9f4ee6b47026c448$exports, "noCryptoObject", function () { return $9f4ee6b47026c448$export$c39e501a22cba395; });
$parcel$export($9f4ee6b47026c448$exports, "unexpectedCredentialType", function () { return $9f4ee6b47026c448$export$21fdd1f95350cd6d; });
$parcel$export($9f4ee6b47026c448$exports, "invalidAssertion", function () { return $9f4ee6b47026c448$export$e168896c692fb06b; });
$parcel$export($9f4ee6b47026c448$exports, "invalidClientCredential", function () { return $9f4ee6b47026c448$export$c483ba88a47982b1; });
$parcel$export($9f4ee6b47026c448$exports, "tokenRefreshRequired", function () { return $9f4ee6b47026c448$export$e23b692cce0c7779; });
$parcel$export($9f4ee6b47026c448$exports, "userTimeoutReached", function () { return $9f4ee6b47026c448$export$afbb99ff17e87b86; });
$parcel$export($9f4ee6b47026c448$exports, "tokenClaimsCnfRequiredForSignedJwt", function () { return $9f4ee6b47026c448$export$6f89b8a7d491b526; });
$parcel$export($9f4ee6b47026c448$exports, "authorizationCodeMissingFromServerResponse", function () { return $9f4ee6b47026c448$export$93625fc864d26bba; });
$parcel$export($9f4ee6b47026c448$exports, "bindingKeyNotRemoved", function () { return $9f4ee6b47026c448$export$5765db5d84418d29; });
$parcel$export($9f4ee6b47026c448$exports, "endSessionEndpointNotSupported", function () { return $9f4ee6b47026c448$export$c3bd741c16a889f3; });
$parcel$export($9f4ee6b47026c448$exports, "keyIdMissing", function () { return $9f4ee6b47026c448$export$3c9338a50e294d1; });
$parcel$export($9f4ee6b47026c448$exports, "noNetworkConnectivity", function () { return $9f4ee6b47026c448$export$31ae862f18c3b2b7; });
$parcel$export($9f4ee6b47026c448$exports, "userCanceled", function () { return $9f4ee6b47026c448$export$8ee329e65a880ec7; });
$parcel$export($9f4ee6b47026c448$exports, "missingTenantIdError", function () { return $9f4ee6b47026c448$export$8c321d057617a458; });
$parcel$export($9f4ee6b47026c448$exports, "methodNotImplemented", function () { return $9f4ee6b47026c448$export$24176fc1f15eea22; });
$parcel$export($9f4ee6b47026c448$exports, "nestedAppAuthBridgeDisabled", function () { return $9f4ee6b47026c448$export$3078b0202fe7eea3; });
/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $9f4ee6b47026c448$export$ccdf48c387c47b82 = "client_info_decoding_error";
const $9f4ee6b47026c448$export$12315251e24e0181 = "client_info_empty_error";
const $9f4ee6b47026c448$export$ad362b2e3a260143 = "token_parsing_error";
const $9f4ee6b47026c448$export$78d01e29cb494be2 = "null_or_empty_token";
const $9f4ee6b47026c448$export$c9fcc93738cc2bc3 = "endpoints_resolution_error";
const $9f4ee6b47026c448$export$4358cbadf08aa73 = "network_error";
const $9f4ee6b47026c448$export$73566da29bc073eb = "openid_config_error";
const $9f4ee6b47026c448$export$14c4d54a8414667f = "hash_not_deserialized";
const $9f4ee6b47026c448$export$72a77317632c052b = "invalid_state";
const $9f4ee6b47026c448$export$6a56d8f882843cd8 = "state_mismatch";
const $9f4ee6b47026c448$export$ef9214cfa5960fc = "state_not_found";
const $9f4ee6b47026c448$export$edd0491c2c280be7 = "nonce_mismatch";
const $9f4ee6b47026c448$export$43356944266c945e = "auth_time_not_found";
const $9f4ee6b47026c448$export$f95fb86904f89749 = "max_age_transpired";
const $9f4ee6b47026c448$export$47c50a2451614107 = "multiple_matching_tokens";
const $9f4ee6b47026c448$export$2804a8b1b4c3be8b = "multiple_matching_accounts";
const $9f4ee6b47026c448$export$575bb2924bcd0084 = "multiple_matching_appMetadata";
const $9f4ee6b47026c448$export$4ac9fb1f531eded7 = "request_cannot_be_made";
const $9f4ee6b47026c448$export$f7a276c01beb068a = "cannot_remove_empty_scope";
const $9f4ee6b47026c448$export$93883786cf4a4a27 = "cannot_append_scopeset";
const $9f4ee6b47026c448$export$41e2ce5958c42c83 = "empty_input_scopeset";
const $9f4ee6b47026c448$export$e3af42f9856ab2a = "device_code_polling_cancelled";
const $9f4ee6b47026c448$export$c0ef55deeb5e30d5 = "device_code_expired";
const $9f4ee6b47026c448$export$4a9e9cce395ba70c = "device_code_unknown_error";
const $9f4ee6b47026c448$export$5a3c7d1c90ac9220 = "no_account_in_silent_request";
const $9f4ee6b47026c448$export$d396103576f879cc = "invalid_cache_record";
const $9f4ee6b47026c448$export$dedc648643245fa1 = "invalid_cache_environment";
const $9f4ee6b47026c448$export$b98ebfe073f0162f = "no_account_found";
const $9f4ee6b47026c448$export$c39e501a22cba395 = "no_crypto_object";
const $9f4ee6b47026c448$export$21fdd1f95350cd6d = "unexpected_credential_type";
const $9f4ee6b47026c448$export$e168896c692fb06b = "invalid_assertion";
const $9f4ee6b47026c448$export$c483ba88a47982b1 = "invalid_client_credential";
const $9f4ee6b47026c448$export$e23b692cce0c7779 = "token_refresh_required";
const $9f4ee6b47026c448$export$afbb99ff17e87b86 = "user_timeout_reached";
const $9f4ee6b47026c448$export$6f89b8a7d491b526 = "token_claims_cnf_required_for_signedjwt";
const $9f4ee6b47026c448$export$93625fc864d26bba = "authorization_code_missing_from_server_response";
const $9f4ee6b47026c448$export$5765db5d84418d29 = "binding_key_not_removed";
const $9f4ee6b47026c448$export$c3bd741c16a889f3 = "end_session_endpoint_not_supported";
const $9f4ee6b47026c448$export$3c9338a50e294d1 = "key_id_missing";
const $9f4ee6b47026c448$export$31ae862f18c3b2b7 = "no_network_connectivity";
const $9f4ee6b47026c448$export$8ee329e65a880ec7 = "user_canceled";
const $9f4ee6b47026c448$export$8c321d057617a458 = "missing_tenant_id_error";
const $9f4ee6b47026c448$export$24176fc1f15eea22 = "method_not_implemented";
const $9f4ee6b47026c448$export$3078b0202fe7eea3 = "nested_app_auth_bridge_disabled";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * ClientAuthErrorMessage class containing string constants used by error codes and messages.
 */ const $8382ef0ce9eb98e6$export$8190ec70cbf7ec08 = {
    [(0, $9f4ee6b47026c448$export$ccdf48c387c47b82)]: "The client info could not be parsed/decoded correctly",
    [(0, $9f4ee6b47026c448$export$12315251e24e0181)]: "The client info was empty",
    [(0, $9f4ee6b47026c448$export$ad362b2e3a260143)]: "Token cannot be parsed",
    [(0, $9f4ee6b47026c448$export$78d01e29cb494be2)]: "The token is null or empty",
    [(0, $9f4ee6b47026c448$export$c9fcc93738cc2bc3)]: "Endpoints cannot be resolved",
    [(0, $9f4ee6b47026c448$export$4358cbadf08aa73)]: "Network request failed",
    [(0, $9f4ee6b47026c448$export$73566da29bc073eb)]: "Could not retrieve endpoints. Check your authority and verify the .well-known/openid-configuration endpoint returns the required endpoints.",
    [(0, $9f4ee6b47026c448$export$14c4d54a8414667f)]: "The hash parameters could not be deserialized",
    [(0, $9f4ee6b47026c448$export$72a77317632c052b)]: "State was not the expected format",
    [(0, $9f4ee6b47026c448$export$6a56d8f882843cd8)]: "State mismatch error",
    [(0, $9f4ee6b47026c448$export$ef9214cfa5960fc)]: "State not found",
    [(0, $9f4ee6b47026c448$export$edd0491c2c280be7)]: "Nonce mismatch error",
    [(0, $9f4ee6b47026c448$export$43356944266c945e)]: "Max Age was requested and the ID token is missing the auth_time variable. auth_time is an optional claim and is not enabled by default - it must be enabled. See https://aka.ms/msaljs/optional-claims for more information.",
    [(0, $9f4ee6b47026c448$export$f95fb86904f89749)]: "Max Age is set to 0, or too much time has elapsed since the last end-user authentication.",
    [(0, $9f4ee6b47026c448$export$47c50a2451614107)]: "The cache contains multiple tokens satisfying the requirements. Call AcquireToken again providing more requirements such as authority or account.",
    [(0, $9f4ee6b47026c448$export$2804a8b1b4c3be8b)]: "The cache contains multiple accounts satisfying the given parameters. Please pass more info to obtain the correct account",
    [(0, $9f4ee6b47026c448$export$575bb2924bcd0084)]: "The cache contains multiple appMetadata satisfying the given parameters. Please pass more info to obtain the correct appMetadata",
    [(0, $9f4ee6b47026c448$export$4ac9fb1f531eded7)]: "Token request cannot be made without authorization code or refresh token.",
    [(0, $9f4ee6b47026c448$export$f7a276c01beb068a)]: "Cannot remove null or empty scope from ScopeSet",
    [(0, $9f4ee6b47026c448$export$93883786cf4a4a27)]: "Cannot append ScopeSet",
    [(0, $9f4ee6b47026c448$export$41e2ce5958c42c83)]: "Empty input ScopeSet cannot be processed",
    [(0, $9f4ee6b47026c448$export$e3af42f9856ab2a)]: "Caller has cancelled token endpoint polling during device code flow by setting DeviceCodeRequest.cancel = true.",
    [(0, $9f4ee6b47026c448$export$c0ef55deeb5e30d5)]: "Device code is expired.",
    [(0, $9f4ee6b47026c448$export$4a9e9cce395ba70c)]: "Device code stopped polling for unknown reasons.",
    [(0, $9f4ee6b47026c448$export$5a3c7d1c90ac9220)]: "Please pass an account object, silent flow is not supported without account information",
    [(0, $9f4ee6b47026c448$export$d396103576f879cc)]: "Cache record object was null or undefined.",
    [(0, $9f4ee6b47026c448$export$dedc648643245fa1)]: "Invalid environment when attempting to create cache entry",
    [(0, $9f4ee6b47026c448$export$b98ebfe073f0162f)]: "No account found in cache for given key.",
    [(0, $9f4ee6b47026c448$export$c39e501a22cba395)]: "No crypto object detected.",
    [(0, $9f4ee6b47026c448$export$21fdd1f95350cd6d)]: "Unexpected credential type.",
    [(0, $9f4ee6b47026c448$export$e168896c692fb06b)]: "Client assertion must meet requirements described in https://tools.ietf.org/html/rfc7515",
    [(0, $9f4ee6b47026c448$export$c483ba88a47982b1)]: "Client credential (secret, certificate, or assertion) must not be empty when creating a confidential client. An application should at most have one credential",
    [(0, $9f4ee6b47026c448$export$e23b692cce0c7779)]: "Cannot return token from cache because it must be refreshed. This may be due to one of the following reasons: forceRefresh parameter is set to true, claims have been requested, there is no cached access token or it is expired.",
    [(0, $9f4ee6b47026c448$export$afbb99ff17e87b86)]: "User defined timeout for device code polling reached",
    [(0, $9f4ee6b47026c448$export$6f89b8a7d491b526)]: "Cannot generate a POP jwt if the token_claims are not populated",
    [(0, $9f4ee6b47026c448$export$93625fc864d26bba)]: "Server response does not contain an authorization code to proceed",
    [(0, $9f4ee6b47026c448$export$5765db5d84418d29)]: "Could not remove the credential's binding key from storage.",
    [(0, $9f4ee6b47026c448$export$c3bd741c16a889f3)]: "The provided authority does not support logout",
    [(0, $9f4ee6b47026c448$export$3c9338a50e294d1)]: "A keyId value is missing from the requested bound token's cache record and is required to match the token to it's stored binding key.",
    [(0, $9f4ee6b47026c448$export$31ae862f18c3b2b7)]: "No network connectivity. Check your internet connection.",
    [(0, $9f4ee6b47026c448$export$8ee329e65a880ec7)]: "User cancelled the flow.",
    [(0, $9f4ee6b47026c448$export$8c321d057617a458)]: "A tenant id - not common, organizations, or consumers - must be specified when using the client_credentials flow.",
    [(0, $9f4ee6b47026c448$export$24176fc1f15eea22)]: "This method has not been implemented",
    [(0, $9f4ee6b47026c448$export$3078b0202fe7eea3)]: "The nested app auth bridge is disabled"
};
/**
 * String constants used by error codes and messages.
 * @deprecated Use ClientAuthErrorCodes instead
 */ const $8382ef0ce9eb98e6$export$51eee17394e135b = {
    clientInfoDecodingError: {
        code: (0, $9f4ee6b47026c448$export$ccdf48c387c47b82),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$ccdf48c387c47b82]
    },
    clientInfoEmptyError: {
        code: (0, $9f4ee6b47026c448$export$12315251e24e0181),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$12315251e24e0181]
    },
    tokenParsingError: {
        code: (0, $9f4ee6b47026c448$export$ad362b2e3a260143),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$ad362b2e3a260143]
    },
    nullOrEmptyToken: {
        code: (0, $9f4ee6b47026c448$export$78d01e29cb494be2),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$78d01e29cb494be2]
    },
    endpointResolutionError: {
        code: (0, $9f4ee6b47026c448$export$c9fcc93738cc2bc3),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$c9fcc93738cc2bc3]
    },
    networkError: {
        code: (0, $9f4ee6b47026c448$export$4358cbadf08aa73),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$4358cbadf08aa73]
    },
    unableToGetOpenidConfigError: {
        code: (0, $9f4ee6b47026c448$export$73566da29bc073eb),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$73566da29bc073eb]
    },
    hashNotDeserialized: {
        code: (0, $9f4ee6b47026c448$export$14c4d54a8414667f),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$14c4d54a8414667f]
    },
    invalidStateError: {
        code: (0, $9f4ee6b47026c448$export$72a77317632c052b),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$72a77317632c052b]
    },
    stateMismatchError: {
        code: (0, $9f4ee6b47026c448$export$6a56d8f882843cd8),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$6a56d8f882843cd8]
    },
    stateNotFoundError: {
        code: (0, $9f4ee6b47026c448$export$ef9214cfa5960fc),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$ef9214cfa5960fc]
    },
    nonceMismatchError: {
        code: (0, $9f4ee6b47026c448$export$edd0491c2c280be7),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$edd0491c2c280be7]
    },
    authTimeNotFoundError: {
        code: (0, $9f4ee6b47026c448$export$43356944266c945e),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$43356944266c945e]
    },
    maxAgeTranspired: {
        code: (0, $9f4ee6b47026c448$export$f95fb86904f89749),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$f95fb86904f89749]
    },
    multipleMatchingTokens: {
        code: (0, $9f4ee6b47026c448$export$47c50a2451614107),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$47c50a2451614107]
    },
    multipleMatchingAccounts: {
        code: (0, $9f4ee6b47026c448$export$2804a8b1b4c3be8b),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$2804a8b1b4c3be8b]
    },
    multipleMatchingAppMetadata: {
        code: (0, $9f4ee6b47026c448$export$575bb2924bcd0084),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$575bb2924bcd0084]
    },
    tokenRequestCannotBeMade: {
        code: (0, $9f4ee6b47026c448$export$4ac9fb1f531eded7),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$4ac9fb1f531eded7]
    },
    removeEmptyScopeError: {
        code: (0, $9f4ee6b47026c448$export$f7a276c01beb068a),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$f7a276c01beb068a]
    },
    appendScopeSetError: {
        code: (0, $9f4ee6b47026c448$export$93883786cf4a4a27),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$93883786cf4a4a27]
    },
    emptyInputScopeSetError: {
        code: (0, $9f4ee6b47026c448$export$41e2ce5958c42c83),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$41e2ce5958c42c83]
    },
    DeviceCodePollingCancelled: {
        code: (0, $9f4ee6b47026c448$export$e3af42f9856ab2a),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$e3af42f9856ab2a]
    },
    DeviceCodeExpired: {
        code: (0, $9f4ee6b47026c448$export$c0ef55deeb5e30d5),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$c0ef55deeb5e30d5]
    },
    DeviceCodeUnknownError: {
        code: (0, $9f4ee6b47026c448$export$4a9e9cce395ba70c),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$4a9e9cce395ba70c]
    },
    NoAccountInSilentRequest: {
        code: (0, $9f4ee6b47026c448$export$5a3c7d1c90ac9220),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$5a3c7d1c90ac9220]
    },
    invalidCacheRecord: {
        code: (0, $9f4ee6b47026c448$export$d396103576f879cc),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$d396103576f879cc]
    },
    invalidCacheEnvironment: {
        code: (0, $9f4ee6b47026c448$export$dedc648643245fa1),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$dedc648643245fa1]
    },
    noAccountFound: {
        code: (0, $9f4ee6b47026c448$export$b98ebfe073f0162f),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$b98ebfe073f0162f]
    },
    noCryptoObj: {
        code: (0, $9f4ee6b47026c448$export$c39e501a22cba395),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$c39e501a22cba395]
    },
    unexpectedCredentialType: {
        code: (0, $9f4ee6b47026c448$export$21fdd1f95350cd6d),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$21fdd1f95350cd6d]
    },
    invalidAssertion: {
        code: (0, $9f4ee6b47026c448$export$e168896c692fb06b),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$e168896c692fb06b]
    },
    invalidClientCredential: {
        code: (0, $9f4ee6b47026c448$export$c483ba88a47982b1),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$c483ba88a47982b1]
    },
    tokenRefreshRequired: {
        code: (0, $9f4ee6b47026c448$export$e23b692cce0c7779),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$e23b692cce0c7779]
    },
    userTimeoutReached: {
        code: (0, $9f4ee6b47026c448$export$afbb99ff17e87b86),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$afbb99ff17e87b86]
    },
    tokenClaimsRequired: {
        code: (0, $9f4ee6b47026c448$export$6f89b8a7d491b526),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$6f89b8a7d491b526]
    },
    noAuthorizationCodeFromServer: {
        code: (0, $9f4ee6b47026c448$export$93625fc864d26bba),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$93625fc864d26bba]
    },
    bindingKeyNotRemovedError: {
        code: (0, $9f4ee6b47026c448$export$5765db5d84418d29),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$5765db5d84418d29]
    },
    logoutNotSupported: {
        code: (0, $9f4ee6b47026c448$export$c3bd741c16a889f3),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$c3bd741c16a889f3]
    },
    keyIdMissing: {
        code: (0, $9f4ee6b47026c448$export$3c9338a50e294d1),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$3c9338a50e294d1]
    },
    noNetworkConnectivity: {
        code: (0, $9f4ee6b47026c448$export$31ae862f18c3b2b7),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$31ae862f18c3b2b7]
    },
    userCanceledError: {
        code: (0, $9f4ee6b47026c448$export$8ee329e65a880ec7),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$8ee329e65a880ec7]
    },
    missingTenantIdError: {
        code: (0, $9f4ee6b47026c448$export$8c321d057617a458),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$8c321d057617a458]
    },
    nestedAppAuthBridgeDisabled: {
        code: (0, $9f4ee6b47026c448$export$3078b0202fe7eea3),
        desc: $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[0, $9f4ee6b47026c448$export$3078b0202fe7eea3]
    }
};
/**
 * Error thrown when there is an error in the client code running on the browser.
 */ class $8382ef0ce9eb98e6$export$a839ff85a7957561 extends (0, $53b49d8334c1646a$export$145273558d58e0ac) {
    constructor(errorCode, additionalMessage){
        super(errorCode, additionalMessage ? `${$8382ef0ce9eb98e6$export$8190ec70cbf7ec08[errorCode]}: ${additionalMessage}` : $8382ef0ce9eb98e6$export$8190ec70cbf7ec08[errorCode]);
        this.name = "ClientAuthError";
        Object.setPrototypeOf(this, $8382ef0ce9eb98e6$export$a839ff85a7957561.prototype);
    }
}
function $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3(errorCode, additionalMessage) {
    return new $8382ef0ce9eb98e6$export$a839ff85a7957561(errorCode, additionalMessage);
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $f03a022fda639465$export$865f57d401606752 = {
    createNewGuid: ()=>{
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    },
    base64Decode: ()=>{
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    },
    base64Encode: ()=>{
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    },
    base64UrlEncode: ()=>{
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    },
    encodeKid: ()=>{
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    },
    async getPublicKeyThumbprint () {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    },
    async removeTokenBindingKey () {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    },
    async clearKeystore () {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    },
    async signJwt () {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    },
    async hashString () {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    }
};




/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/* eslint-disable header/header */ const $a15c066c8ddfab99$export$a8ff84c12d48cfa6 = "@azure/msal-common";
const $a15c066c8ddfab99$export$83d89fbfd8236492 = "14.16.1";



/*! @azure/msal-common v14.16.1 2025-08-05 */ 
var $bd840ab348a8e6dd$exports = {};

$parcel$export($bd840ab348a8e6dd$exports, "generateCredentialKey", function () { return $bd840ab348a8e6dd$export$1aaa1362083ec7a3; });
$parcel$export($bd840ab348a8e6dd$exports, "createIdTokenEntity", function () { return $bd840ab348a8e6dd$export$d8a173a23f325769; });
$parcel$export($bd840ab348a8e6dd$exports, "createAccessTokenEntity", function () { return $bd840ab348a8e6dd$export$fa005e75d915b6db; });
$parcel$export($bd840ab348a8e6dd$exports, "createRefreshTokenEntity", function () { return $bd840ab348a8e6dd$export$9095b5885dfa55cc; });
$parcel$export($bd840ab348a8e6dd$exports, "isCredentialEntity", function () { return $bd840ab348a8e6dd$export$b8fc93e8af17dc04; });
$parcel$export($bd840ab348a8e6dd$exports, "isAccessTokenEntity", function () { return $bd840ab348a8e6dd$export$d7e6bcc84cf680df; });
$parcel$export($bd840ab348a8e6dd$exports, "isIdTokenEntity", function () { return $bd840ab348a8e6dd$export$71eec93d11c94dfc; });
$parcel$export($bd840ab348a8e6dd$exports, "isRefreshTokenEntity", function () { return $bd840ab348a8e6dd$export$f1bb3af43d5b8bc7; });
$parcel$export($bd840ab348a8e6dd$exports, "isServerTelemetryEntity", function () { return $bd840ab348a8e6dd$export$7ad16989078344e5; });
$parcel$export($bd840ab348a8e6dd$exports, "isThrottlingEntity", function () { return $bd840ab348a8e6dd$export$7e43cc7efaf4bec2; });
$parcel$export($bd840ab348a8e6dd$exports, "generateAppMetadataKey", function () { return $bd840ab348a8e6dd$export$ddbc6773ab812685; });
$parcel$export($bd840ab348a8e6dd$exports, "isAppMetadataEntity", function () { return $bd840ab348a8e6dd$export$bb2a01b66d0b3486; });
$parcel$export($bd840ab348a8e6dd$exports, "isAuthorityMetadataEntity", function () { return $bd840ab348a8e6dd$export$6231cab310116b3c; });
$parcel$export($bd840ab348a8e6dd$exports, "generateAuthorityMetadataExpiresAt", function () { return $bd840ab348a8e6dd$export$90f464c4238c27e5; });
$parcel$export($bd840ab348a8e6dd$exports, "updateAuthorityEndpointMetadata", function () { return $bd840ab348a8e6dd$export$ef87e8fbd8af5f96; });
$parcel$export($bd840ab348a8e6dd$exports, "updateCloudDiscoveryMetadata", function () { return $bd840ab348a8e6dd$export$6d4972e1d88c8518; });
$parcel$export($bd840ab348a8e6dd$exports, "isAuthorityMetadataExpired", function () { return $bd840ab348a8e6dd$export$b96839cf63a15b0f; });
/*! @azure/msal-common v14.16.1 2025-08-05 */ var $dfbf8cbb9a592daa$exports = {};

$parcel$export($dfbf8cbb9a592daa$exports, "extractTokenClaims", function () { return $dfbf8cbb9a592daa$export$8a59e6f35fb00518; });
$parcel$export($dfbf8cbb9a592daa$exports, "getJWSPayload", function () { return $dfbf8cbb9a592daa$export$b9f318d6daf53c97; });
$parcel$export($dfbf8cbb9a592daa$exports, "checkMaxAge", function () { return $dfbf8cbb9a592daa$export$ee7a34ea7880144c; });
/*! @azure/msal-common v14.16.1 2025-08-05 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Extract token by decoding the rawToken
 *
 * @param encodedToken
 */ function $dfbf8cbb9a592daa$export$8a59e6f35fb00518(encodedToken, base64Decode) {
    const jswPayload = $dfbf8cbb9a592daa$export$b9f318d6daf53c97(encodedToken);
    // token will be decoded to get the username
    try {
        // base64Decode() should throw an error if there is an issue
        const base64Decoded = base64Decode(jswPayload);
        return JSON.parse(base64Decoded);
    } catch (err) {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$ad362b2e3a260143));
    }
}
/**
 * decode a JWT
 *
 * @param authToken
 */ function $dfbf8cbb9a592daa$export$b9f318d6daf53c97(authToken) {
    if (!authToken) throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$78d01e29cb494be2));
    const tokenPartsRegex = /^([^\.\s]*)\.([^\.\s]+)\.([^\.\s]*)$/;
    const matches = tokenPartsRegex.exec(authToken);
    if (!matches || matches.length < 4) throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$ad362b2e3a260143));
    /**
     * const crackedToken = {
     *  header: matches[1],
     *  JWSPayload: matches[2],
     *  JWSSig: matches[3],
     * };
     */ return matches[2];
}
/**
 * Determine if the token's max_age has transpired
 */ function $dfbf8cbb9a592daa$export$ee7a34ea7880144c(authTime, maxAge) {
    /*
     * per https://openid.net/specs/openid-connect-core-1_0.html#AuthRequest
     * To force an immediate re-authentication: If an app requires that a user re-authenticate prior to access,
     * provide a value of 0 for the max_age parameter and the AS will force a fresh login.
     */ const fiveMinuteSkew = 300000; // five minutes in milliseconds
    if (maxAge === 0 || Date.now() - fiveMinuteSkew > authTime + maxAge) throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$f95fb86904f89749));
}




var $7dce75f27affa532$exports = {};

$parcel$export($7dce75f27affa532$exports, "nowSeconds", function () { return $7dce75f27affa532$export$ae62599a119ac50a; });
$parcel$export($7dce75f27affa532$exports, "isTokenExpired", function () { return $7dce75f27affa532$export$b007d77a962aa175; });
$parcel$export($7dce75f27affa532$exports, "wasClockTurnedBack", function () { return $7dce75f27affa532$export$8961be72dcbc368e; });
$parcel$export($7dce75f27affa532$exports, "delay", function () { return $7dce75f27affa532$export$1391212d75b2ee65; });
/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Utility functions for managing date and time operations.
 */ /**
 * return the current time in Unix time (seconds).
 */ function $7dce75f27affa532$export$ae62599a119ac50a() {
    // Date.getTime() returns in milliseconds.
    return Math.round(new Date().getTime() / 1000.0);
}
/**
 * check if a token is expired based on given UTC time in seconds.
 * @param expiresOn
 */ function $7dce75f27affa532$export$b007d77a962aa175(expiresOn, offset) {
    // check for access token expiry
    const expirationSec = Number(expiresOn) || 0;
    const offsetCurrentTimeSec = $7dce75f27affa532$export$ae62599a119ac50a() + offset;
    // If current time + offset is greater than token expiration time, then token is expired.
    return offsetCurrentTimeSec > expirationSec;
}
/**
 * If the current time is earlier than the time that a token was cached at, we must discard the token
 * i.e. The system clock was turned back after acquiring the cached token
 * @param cachedAt
 * @param offset
 */ function $7dce75f27affa532$export$8961be72dcbc368e(cachedAt) {
    const cachedAtSec = Number(cachedAt);
    return cachedAtSec > $7dce75f27affa532$export$ae62599a119ac50a();
}
/**
 * Waits for t number of milliseconds
 * @param t number
 * @param value T
 */ function $7dce75f27affa532$export$1391212d75b2ee65(t, value) {
    return new Promise((resolve)=>setTimeout(()=>resolve(value), t));
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Cache Key: <home_account_id>-<environment>-<credential_type>-<client_id or familyId>-<realm>-<scopes>-<claims hash>-<scheme>
 * IdToken Example: uid.utid-login.microsoftonline.com-idtoken-app_client_id-contoso.com
 * AccessToken Example: uid.utid-login.microsoftonline.com-accesstoken-app_client_id-contoso.com-scope1 scope2--pop
 * RefreshToken Example: uid.utid-login.microsoftonline.com-refreshtoken-1-contoso.com
 * @param credentialEntity
 * @returns
 */ function $bd840ab348a8e6dd$export$1aaa1362083ec7a3(credentialEntity) {
    const credentialKey = [
        $bd840ab348a8e6dd$var$generateAccountId(credentialEntity),
        $bd840ab348a8e6dd$var$generateCredentialId(credentialEntity),
        $bd840ab348a8e6dd$var$generateTarget(credentialEntity),
        $bd840ab348a8e6dd$var$generateClaimsHash(credentialEntity),
        $bd840ab348a8e6dd$var$generateScheme(credentialEntity)
    ];
    return credentialKey.join((0, $08c107807d753255$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
}
/**
 * Create IdTokenEntity
 * @param homeAccountId
 * @param authenticationResult
 * @param clientId
 * @param authority
 */ function $bd840ab348a8e6dd$export$d8a173a23f325769(homeAccountId, environment, idToken, clientId, tenantId) {
    const idTokenEntity = {
        credentialType: (0, $08c107807d753255$export$eca2dc7e6e608a68).ID_TOKEN,
        homeAccountId: homeAccountId,
        environment: environment,
        clientId: clientId,
        secret: idToken,
        realm: tenantId
    };
    return idTokenEntity;
}
/**
 * Create AccessTokenEntity
 * @param homeAccountId
 * @param environment
 * @param accessToken
 * @param clientId
 * @param tenantId
 * @param scopes
 * @param expiresOn
 * @param extExpiresOn
 */ function $bd840ab348a8e6dd$export$fa005e75d915b6db(homeAccountId, environment, accessToken, clientId, tenantId, scopes, expiresOn, extExpiresOn, base64Decode, refreshOn, tokenType, userAssertionHash, keyId, requestedClaims, requestedClaimsHash) {
    const atEntity = {
        homeAccountId: homeAccountId,
        credentialType: (0, $08c107807d753255$export$eca2dc7e6e608a68).ACCESS_TOKEN,
        secret: accessToken,
        cachedAt: (0, $7dce75f27affa532$export$ae62599a119ac50a)().toString(),
        expiresOn: expiresOn.toString(),
        extendedExpiresOn: extExpiresOn.toString(),
        environment: environment,
        clientId: clientId,
        realm: tenantId,
        target: scopes,
        tokenType: tokenType || (0, $08c107807d753255$export$901491a717da2ba5).BEARER
    };
    if (userAssertionHash) atEntity.userAssertionHash = userAssertionHash;
    if (refreshOn) atEntity.refreshOn = refreshOn.toString();
    if (requestedClaims) {
        atEntity.requestedClaims = requestedClaims;
        atEntity.requestedClaimsHash = requestedClaimsHash;
    }
    /*
     * Create Access Token With Auth Scheme instead of regular access token
     * Cast to lower to handle "bearer" from ADFS
     */ if (atEntity.tokenType?.toLowerCase() !== (0, $08c107807d753255$export$901491a717da2ba5).BEARER.toLowerCase()) {
        atEntity.credentialType = (0, $08c107807d753255$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME;
        switch(atEntity.tokenType){
            case (0, $08c107807d753255$export$901491a717da2ba5).POP:
                // Make sure keyId is present and add it to credential
                const tokenClaims = (0, $dfbf8cbb9a592daa$export$8a59e6f35fb00518)(accessToken, base64Decode);
                if (!tokenClaims?.cnf?.kid) throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$6f89b8a7d491b526));
                atEntity.keyId = tokenClaims.cnf.kid;
                break;
            case (0, $08c107807d753255$export$901491a717da2ba5).SSH:
                atEntity.keyId = keyId;
        }
    }
    return atEntity;
}
/**
 * Create RefreshTokenEntity
 * @param homeAccountId
 * @param authenticationResult
 * @param clientId
 * @param authority
 */ function $bd840ab348a8e6dd$export$9095b5885dfa55cc(homeAccountId, environment, refreshToken, clientId, familyId, userAssertionHash, expiresOn) {
    const rtEntity = {
        credentialType: (0, $08c107807d753255$export$eca2dc7e6e608a68).REFRESH_TOKEN,
        homeAccountId: homeAccountId,
        environment: environment,
        clientId: clientId,
        secret: refreshToken
    };
    if (userAssertionHash) rtEntity.userAssertionHash = userAssertionHash;
    if (familyId) rtEntity.familyId = familyId;
    if (expiresOn) rtEntity.expiresOn = expiresOn.toString();
    return rtEntity;
}
function $bd840ab348a8e6dd$export$b8fc93e8af17dc04(entity) {
    return entity.hasOwnProperty("homeAccountId") && entity.hasOwnProperty("environment") && entity.hasOwnProperty("credentialType") && entity.hasOwnProperty("clientId") && entity.hasOwnProperty("secret");
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $bd840ab348a8e6dd$export$d7e6bcc84cf680df(entity) {
    if (!entity) return false;
    return $bd840ab348a8e6dd$export$b8fc93e8af17dc04(entity) && entity.hasOwnProperty("realm") && entity.hasOwnProperty("target") && (entity["credentialType"] === (0, $08c107807d753255$export$eca2dc7e6e608a68).ACCESS_TOKEN || entity["credentialType"] === (0, $08c107807d753255$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME);
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $bd840ab348a8e6dd$export$71eec93d11c94dfc(entity) {
    if (!entity) return false;
    return $bd840ab348a8e6dd$export$b8fc93e8af17dc04(entity) && entity.hasOwnProperty("realm") && entity["credentialType"] === (0, $08c107807d753255$export$eca2dc7e6e608a68).ID_TOKEN;
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $bd840ab348a8e6dd$export$f1bb3af43d5b8bc7(entity) {
    if (!entity) return false;
    return $bd840ab348a8e6dd$export$b8fc93e8af17dc04(entity) && entity["credentialType"] === (0, $08c107807d753255$export$eca2dc7e6e608a68).REFRESH_TOKEN;
}
/**
 * Generate Account Id key component as per the schema: <home_account_id>-<environment>
 */ function $bd840ab348a8e6dd$var$generateAccountId(credentialEntity) {
    const accountId = [
        credentialEntity.homeAccountId,
        credentialEntity.environment
    ];
    return accountId.join((0, $08c107807d753255$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
}
/**
 * Generate Credential Id key component as per the schema: <credential_type>-<client_id>-<realm>
 */ function $bd840ab348a8e6dd$var$generateCredentialId(credentialEntity) {
    const clientOrFamilyId = credentialEntity.credentialType === (0, $08c107807d753255$export$eca2dc7e6e608a68).REFRESH_TOKEN ? credentialEntity.familyId || credentialEntity.clientId : credentialEntity.clientId;
    const credentialId = [
        credentialEntity.credentialType,
        clientOrFamilyId,
        credentialEntity.realm || ""
    ];
    return credentialId.join((0, $08c107807d753255$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
}
/**
 * Generate target key component as per schema: <target>
 */ function $bd840ab348a8e6dd$var$generateTarget(credentialEntity) {
    return (credentialEntity.target || "").toLowerCase();
}
/**
 * Generate requested claims key component as per schema: <requestedClaims>
 */ function $bd840ab348a8e6dd$var$generateClaimsHash(credentialEntity) {
    return (credentialEntity.requestedClaimsHash || "").toLowerCase();
}
/**
 * Generate scheme key componenet as per schema: <scheme>
 */ function $bd840ab348a8e6dd$var$generateScheme(credentialEntity) {
    /*
     * PoP Tokens and SSH certs include scheme in cache key
     * Cast to lowercase to handle "bearer" from ADFS
     */ return credentialEntity.tokenType && credentialEntity.tokenType.toLowerCase() !== (0, $08c107807d753255$export$901491a717da2ba5).BEARER.toLowerCase() ? credentialEntity.tokenType.toLowerCase() : "";
}
/**
 * validates if a given cache entry is "Telemetry", parses <key,value>
 * @param key
 * @param entity
 */ function $bd840ab348a8e6dd$export$7ad16989078344e5(key, entity) {
    const validateKey = key.indexOf((0, $08c107807d753255$export$30fa4ad28fb9feeb).CACHE_KEY) === 0;
    let validateEntity = true;
    if (entity) validateEntity = entity.hasOwnProperty("failedRequests") && entity.hasOwnProperty("errors") && entity.hasOwnProperty("cacheHits");
    return validateKey && validateEntity;
}
/**
 * validates if a given cache entry is "Throttling", parses <key,value>
 * @param key
 * @param entity
 */ function $bd840ab348a8e6dd$export$7e43cc7efaf4bec2(key, entity) {
    let validateKey = false;
    if (key) validateKey = key.indexOf((0, $08c107807d753255$export$a2330d6808e6d893).THROTTLING_PREFIX) === 0;
    let validateEntity = true;
    if (entity) validateEntity = entity.hasOwnProperty("throttleTime");
    return validateKey && validateEntity;
}
/**
 * Generate AppMetadata Cache Key as per the schema: appmetadata-<environment>-<client_id>
 */ function $bd840ab348a8e6dd$export$ddbc6773ab812685({ environment: environment, clientId: clientId }) {
    const appMetaDataKeyArray = [
        (0, $08c107807d753255$export$7e1bea6dc1b6b32e),
        environment,
        clientId
    ];
    return appMetaDataKeyArray.join((0, $08c107807d753255$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
}
/*
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $bd840ab348a8e6dd$export$bb2a01b66d0b3486(key, entity) {
    if (!entity) return false;
    return key.indexOf((0, $08c107807d753255$export$7e1bea6dc1b6b32e)) === 0 && entity.hasOwnProperty("clientId") && entity.hasOwnProperty("environment");
}
/**
 * Validates an entity: checks for all expected params
 * @param entity
 */ function $bd840ab348a8e6dd$export$6231cab310116b3c(key, entity) {
    if (!entity) return false;
    return key.indexOf((0, $08c107807d753255$export$d483f966e66f4db5).CACHE_KEY) === 0 && entity.hasOwnProperty("aliases") && entity.hasOwnProperty("preferred_cache") && entity.hasOwnProperty("preferred_network") && entity.hasOwnProperty("canonical_authority") && entity.hasOwnProperty("authorization_endpoint") && entity.hasOwnProperty("token_endpoint") && entity.hasOwnProperty("issuer") && entity.hasOwnProperty("aliasesFromNetwork") && entity.hasOwnProperty("endpointsFromNetwork") && entity.hasOwnProperty("expiresAt") && entity.hasOwnProperty("jwks_uri");
}
/**
 * Reset the exiresAt value
 */ function $bd840ab348a8e6dd$export$90f464c4238c27e5() {
    return (0, $7dce75f27affa532$export$ae62599a119ac50a)() + (0, $08c107807d753255$export$d483f966e66f4db5).REFRESH_TIME_SECONDS;
}
function $bd840ab348a8e6dd$export$ef87e8fbd8af5f96(authorityMetadata, updatedValues, fromNetwork) {
    authorityMetadata.authorization_endpoint = updatedValues.authorization_endpoint;
    authorityMetadata.token_endpoint = updatedValues.token_endpoint;
    authorityMetadata.end_session_endpoint = updatedValues.end_session_endpoint;
    authorityMetadata.issuer = updatedValues.issuer;
    authorityMetadata.endpointsFromNetwork = fromNetwork;
    authorityMetadata.jwks_uri = updatedValues.jwks_uri;
}
function $bd840ab348a8e6dd$export$6d4972e1d88c8518(authorityMetadata, updatedValues, fromNetwork) {
    authorityMetadata.aliases = updatedValues.aliases;
    authorityMetadata.preferred_cache = updatedValues.preferred_cache;
    authorityMetadata.preferred_network = updatedValues.preferred_network;
    authorityMetadata.aliasesFromNetwork = fromNetwork;
}
/**
 * Returns whether or not the data needs to be refreshed
 */ function $bd840ab348a8e6dd$export$b96839cf63a15b0f(metadata) {
    return metadata.expiresAt <= (0, $7dce75f27affa532$export$ae62599a119ac50a)();
}


/*! @azure/msal-common v14.16.1 2025-08-05 */ /*! @azure/msal-common v14.16.1 2025-08-05 */ 
var $f66a3d6fc9f2eb73$exports = {};

$parcel$export($f66a3d6fc9f2eb73$exports, "redirectUriEmpty", function () { return $f66a3d6fc9f2eb73$export$7a02f9bdce79dd4e; });
$parcel$export($f66a3d6fc9f2eb73$exports, "claimsRequestParsingError", function () { return $f66a3d6fc9f2eb73$export$561c97672a478709; });
$parcel$export($f66a3d6fc9f2eb73$exports, "authorityUriInsecure", function () { return $f66a3d6fc9f2eb73$export$f77c6af656c8444b; });
$parcel$export($f66a3d6fc9f2eb73$exports, "urlParseError", function () { return $f66a3d6fc9f2eb73$export$ee2a1a3389f75508; });
$parcel$export($f66a3d6fc9f2eb73$exports, "urlEmptyError", function () { return $f66a3d6fc9f2eb73$export$859df485a5e0f239; });
$parcel$export($f66a3d6fc9f2eb73$exports, "emptyInputScopesError", function () { return $f66a3d6fc9f2eb73$export$6ac27379c42383f; });
$parcel$export($f66a3d6fc9f2eb73$exports, "invalidPromptValue", function () { return $f66a3d6fc9f2eb73$export$ccbe5d2d7c960c35; });
$parcel$export($f66a3d6fc9f2eb73$exports, "invalidClaims", function () { return $f66a3d6fc9f2eb73$export$96e755c70e0d0e34; });
$parcel$export($f66a3d6fc9f2eb73$exports, "tokenRequestEmpty", function () { return $f66a3d6fc9f2eb73$export$eca67ff7a91fed9d; });
$parcel$export($f66a3d6fc9f2eb73$exports, "logoutRequestEmpty", function () { return $f66a3d6fc9f2eb73$export$9eb2eeb401492d88; });
$parcel$export($f66a3d6fc9f2eb73$exports, "invalidCodeChallengeMethod", function () { return $f66a3d6fc9f2eb73$export$b8d8b332f17376dc; });
$parcel$export($f66a3d6fc9f2eb73$exports, "pkceParamsMissing", function () { return $f66a3d6fc9f2eb73$export$2da3866b327f1753; });
$parcel$export($f66a3d6fc9f2eb73$exports, "invalidCloudDiscoveryMetadata", function () { return $f66a3d6fc9f2eb73$export$92a2985751150ca5; });
$parcel$export($f66a3d6fc9f2eb73$exports, "invalidAuthorityMetadata", function () { return $f66a3d6fc9f2eb73$export$edb4d5942bc8ccff; });
$parcel$export($f66a3d6fc9f2eb73$exports, "untrustedAuthority", function () { return $f66a3d6fc9f2eb73$export$50c3162fda5f57; });
$parcel$export($f66a3d6fc9f2eb73$exports, "missingSshJwk", function () { return $f66a3d6fc9f2eb73$export$8fbed44b22d9136f; });
$parcel$export($f66a3d6fc9f2eb73$exports, "missingSshKid", function () { return $f66a3d6fc9f2eb73$export$b728bd8a588956c; });
$parcel$export($f66a3d6fc9f2eb73$exports, "missingNonceAuthenticationHeader", function () { return $f66a3d6fc9f2eb73$export$4f88b4462bcef15f; });
$parcel$export($f66a3d6fc9f2eb73$exports, "invalidAuthenticationHeader", function () { return $f66a3d6fc9f2eb73$export$bea58e1a2e503b59; });
$parcel$export($f66a3d6fc9f2eb73$exports, "cannotSetOIDCOptions", function () { return $f66a3d6fc9f2eb73$export$a5c9fbb90473dca2; });
$parcel$export($f66a3d6fc9f2eb73$exports, "cannotAllowNativeBroker", function () { return $f66a3d6fc9f2eb73$export$26a4f4cbf9747475; });
$parcel$export($f66a3d6fc9f2eb73$exports, "authorityMismatch", function () { return $f66a3d6fc9f2eb73$export$91415fb6baea5d09; });
/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $f66a3d6fc9f2eb73$export$7a02f9bdce79dd4e = "redirect_uri_empty";
const $f66a3d6fc9f2eb73$export$561c97672a478709 = "claims_request_parsing_error";
const $f66a3d6fc9f2eb73$export$f77c6af656c8444b = "authority_uri_insecure";
const $f66a3d6fc9f2eb73$export$ee2a1a3389f75508 = "url_parse_error";
const $f66a3d6fc9f2eb73$export$859df485a5e0f239 = "empty_url_error";
const $f66a3d6fc9f2eb73$export$6ac27379c42383f = "empty_input_scopes_error";
const $f66a3d6fc9f2eb73$export$ccbe5d2d7c960c35 = "invalid_prompt_value";
const $f66a3d6fc9f2eb73$export$96e755c70e0d0e34 = "invalid_claims";
const $f66a3d6fc9f2eb73$export$eca67ff7a91fed9d = "token_request_empty";
const $f66a3d6fc9f2eb73$export$9eb2eeb401492d88 = "logout_request_empty";
const $f66a3d6fc9f2eb73$export$b8d8b332f17376dc = "invalid_code_challenge_method";
const $f66a3d6fc9f2eb73$export$2da3866b327f1753 = "pkce_params_missing";
const $f66a3d6fc9f2eb73$export$92a2985751150ca5 = "invalid_cloud_discovery_metadata";
const $f66a3d6fc9f2eb73$export$edb4d5942bc8ccff = "invalid_authority_metadata";
const $f66a3d6fc9f2eb73$export$50c3162fda5f57 = "untrusted_authority";
const $f66a3d6fc9f2eb73$export$8fbed44b22d9136f = "missing_ssh_jwk";
const $f66a3d6fc9f2eb73$export$b728bd8a588956c = "missing_ssh_kid";
const $f66a3d6fc9f2eb73$export$4f88b4462bcef15f = "missing_nonce_authentication_header";
const $f66a3d6fc9f2eb73$export$bea58e1a2e503b59 = "invalid_authentication_header";
const $f66a3d6fc9f2eb73$export$a5c9fbb90473dca2 = "cannot_set_OIDCOptions";
const $f66a3d6fc9f2eb73$export$26a4f4cbf9747475 = "cannot_allow_native_broker";
const $f66a3d6fc9f2eb73$export$91415fb6baea5d09 = "authority_mismatch";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $a6f096219dc1b547$export$45752b5111a13710 = {
    [(0, $f66a3d6fc9f2eb73$export$7a02f9bdce79dd4e)]: "A redirect URI is required for all calls, and none has been set.",
    [(0, $f66a3d6fc9f2eb73$export$561c97672a478709)]: "Could not parse the given claims request object.",
    [(0, $f66a3d6fc9f2eb73$export$f77c6af656c8444b)]: "Authority URIs must use https.  Please see here for valid authority configuration options: https://docs.microsoft.com/en-us/azure/active-directory/develop/msal-js-initializing-client-applications#configuration-options",
    [(0, $f66a3d6fc9f2eb73$export$ee2a1a3389f75508)]: "URL could not be parsed into appropriate segments.",
    [(0, $f66a3d6fc9f2eb73$export$859df485a5e0f239)]: "URL was empty or null.",
    [(0, $f66a3d6fc9f2eb73$export$6ac27379c42383f)]: "Scopes cannot be passed as null, undefined or empty array because they are required to obtain an access token.",
    [(0, $f66a3d6fc9f2eb73$export$ccbe5d2d7c960c35)]: "Please see here for valid configuration options: https://azuread.github.io/microsoft-authentication-library-for-js/ref/modules/_azure_msal_common.html#commonauthorizationurlrequest",
    [(0, $f66a3d6fc9f2eb73$export$96e755c70e0d0e34)]: "Given claims parameter must be a stringified JSON object.",
    [(0, $f66a3d6fc9f2eb73$export$eca67ff7a91fed9d)]: "Token request was empty and not found in cache.",
    [(0, $f66a3d6fc9f2eb73$export$9eb2eeb401492d88)]: "The logout request was null or undefined.",
    [(0, $f66a3d6fc9f2eb73$export$b8d8b332f17376dc)]: 'code_challenge_method passed is invalid. Valid values are "plain" and "S256".',
    [(0, $f66a3d6fc9f2eb73$export$2da3866b327f1753)]: "Both params: code_challenge and code_challenge_method are to be passed if to be sent in the request",
    [(0, $f66a3d6fc9f2eb73$export$92a2985751150ca5)]: "Invalid cloudDiscoveryMetadata provided. Must be a stringified JSON object containing tenant_discovery_endpoint and metadata fields",
    [(0, $f66a3d6fc9f2eb73$export$edb4d5942bc8ccff)]: "Invalid authorityMetadata provided. Must by a stringified JSON object containing authorization_endpoint, token_endpoint, issuer fields.",
    [(0, $f66a3d6fc9f2eb73$export$50c3162fda5f57)]: "The provided authority is not a trusted authority. Please include this authority in the knownAuthorities config parameter.",
    [(0, $f66a3d6fc9f2eb73$export$8fbed44b22d9136f)]: "Missing sshJwk in SSH certificate request. A stringified JSON Web Key is required when using the SSH authentication scheme.",
    [(0, $f66a3d6fc9f2eb73$export$b728bd8a588956c)]: "Missing sshKid in SSH certificate request. A string that uniquely identifies the public SSH key is required when using the SSH authentication scheme.",
    [(0, $f66a3d6fc9f2eb73$export$4f88b4462bcef15f)]: "Unable to find an authentication header containing server nonce. Either the Authentication-Info or WWW-Authenticate headers must be present in order to obtain a server nonce.",
    [(0, $f66a3d6fc9f2eb73$export$bea58e1a2e503b59)]: "Invalid authentication header provided",
    [(0, $f66a3d6fc9f2eb73$export$a5c9fbb90473dca2)]: "Cannot set OIDCOptions parameter. Please change the protocol mode to OIDC or use a non-Microsoft authority.",
    [(0, $f66a3d6fc9f2eb73$export$26a4f4cbf9747475)]: "Cannot set allowNativeBroker parameter to true when not in AAD protocol mode.",
    [(0, $f66a3d6fc9f2eb73$export$91415fb6baea5d09)]: "Authority mismatch error. Authority provided in login request or PublicClientApplication config does not match the environment of the provided account. Please use a matching account or make an interactive request to login to this authority."
};
/**
 * ClientConfigurationErrorMessage class containing string constants used by error codes and messages.
 * @deprecated Use ClientConfigurationErrorCodes instead
 */ const $a6f096219dc1b547$export$8a1024301e8298df = {
    redirectUriNotSet: {
        code: (0, $f66a3d6fc9f2eb73$export$7a02f9bdce79dd4e),
        desc: $a6f096219dc1b547$export$45752b5111a13710[0, $f66a3d6fc9f2eb73$export$7a02f9bdce79dd4e]
    },
    claimsRequestParsingError: {
        code: (0, $f66a3d6fc9f2eb73$export$561c97672a478709),
        desc: $a6f096219dc1b547$export$45752b5111a13710[0, $f66a3d6fc9f2eb73$export$561c97672a478709]
    },
    authorityUriInsecure: {
        code: (0, $f66a3d6fc9f2eb73$export$f77c6af656c8444b),
        desc: $a6f096219dc1b547$export$45752b5111a13710[0, $f66a3d6fc9f2eb73$export$f77c6af656c8444b]
    },
    urlParseError: {
        code: (0, $f66a3d6fc9f2eb73$export$ee2a1a3389f75508),
        desc: $a6f096219dc1b547$export$45752b5111a13710[0, $f66a3d6fc9f2eb73$export$ee2a1a3389f75508]
    },
    urlEmptyError: {
        code: (0, $f66a3d6fc9f2eb73$export$859df485a5e0f239),
        desc: $a6f096219dc1b547$export$45752b5111a13710[0, $f66a3d6fc9f2eb73$export$859df485a5e0f239]
    },
    emptyScopesError: {
        code: (0, $f66a3d6fc9f2eb73$export$6ac27379c42383f),
        desc: $a6f096219dc1b547$export$45752b5111a13710[0, $f66a3d6fc9f2eb73$export$6ac27379c42383f]
    },
    invalidPrompt: {
        code: (0, $f66a3d6fc9f2eb73$export$ccbe5d2d7c960c35),
        desc: $a6f096219dc1b547$export$45752b5111a13710[0, $f66a3d6fc9f2eb73$export$ccbe5d2d7c960c35]
    },
    invalidClaimsRequest: {
        code: (0, $f66a3d6fc9f2eb73$export$96e755c70e0d0e34),
        desc: $a6f096219dc1b547$export$45752b5111a13710[0, $f66a3d6fc9f2eb73$export$96e755c70e0d0e34]
    },
    tokenRequestEmptyError: {
        code: (0, $f66a3d6fc9f2eb73$export$eca67ff7a91fed9d),
        desc: $a6f096219dc1b547$export$45752b5111a13710[0, $f66a3d6fc9f2eb73$export$eca67ff7a91fed9d]
    },
    logoutRequestEmptyError: {
        code: (0, $f66a3d6fc9f2eb73$export$9eb2eeb401492d88),
        desc: $a6f096219dc1b547$export$45752b5111a13710[0, $f66a3d6fc9f2eb73$export$9eb2eeb401492d88]
    },
    invalidCodeChallengeMethod: {
        code: (0, $f66a3d6fc9f2eb73$export$b8d8b332f17376dc),
        desc: $a6f096219dc1b547$export$45752b5111a13710[0, $f66a3d6fc9f2eb73$export$b8d8b332f17376dc]
    },
    invalidCodeChallengeParams: {
        code: (0, $f66a3d6fc9f2eb73$export$2da3866b327f1753),
        desc: $a6f096219dc1b547$export$45752b5111a13710[0, $f66a3d6fc9f2eb73$export$2da3866b327f1753]
    },
    invalidCloudDiscoveryMetadata: {
        code: (0, $f66a3d6fc9f2eb73$export$92a2985751150ca5),
        desc: $a6f096219dc1b547$export$45752b5111a13710[0, $f66a3d6fc9f2eb73$export$92a2985751150ca5]
    },
    invalidAuthorityMetadata: {
        code: (0, $f66a3d6fc9f2eb73$export$edb4d5942bc8ccff),
        desc: $a6f096219dc1b547$export$45752b5111a13710[0, $f66a3d6fc9f2eb73$export$edb4d5942bc8ccff]
    },
    untrustedAuthority: {
        code: (0, $f66a3d6fc9f2eb73$export$50c3162fda5f57),
        desc: $a6f096219dc1b547$export$45752b5111a13710[0, $f66a3d6fc9f2eb73$export$50c3162fda5f57]
    },
    missingSshJwk: {
        code: (0, $f66a3d6fc9f2eb73$export$8fbed44b22d9136f),
        desc: $a6f096219dc1b547$export$45752b5111a13710[0, $f66a3d6fc9f2eb73$export$8fbed44b22d9136f]
    },
    missingSshKid: {
        code: (0, $f66a3d6fc9f2eb73$export$b728bd8a588956c),
        desc: $a6f096219dc1b547$export$45752b5111a13710[0, $f66a3d6fc9f2eb73$export$b728bd8a588956c]
    },
    missingNonceAuthenticationHeader: {
        code: (0, $f66a3d6fc9f2eb73$export$4f88b4462bcef15f),
        desc: $a6f096219dc1b547$export$45752b5111a13710[0, $f66a3d6fc9f2eb73$export$4f88b4462bcef15f]
    },
    invalidAuthenticationHeader: {
        code: (0, $f66a3d6fc9f2eb73$export$bea58e1a2e503b59),
        desc: $a6f096219dc1b547$export$45752b5111a13710[0, $f66a3d6fc9f2eb73$export$bea58e1a2e503b59]
    },
    cannotSetOIDCOptions: {
        code: (0, $f66a3d6fc9f2eb73$export$a5c9fbb90473dca2),
        desc: $a6f096219dc1b547$export$45752b5111a13710[0, $f66a3d6fc9f2eb73$export$a5c9fbb90473dca2]
    },
    cannotAllowNativeBroker: {
        code: (0, $f66a3d6fc9f2eb73$export$26a4f4cbf9747475),
        desc: $a6f096219dc1b547$export$45752b5111a13710[0, $f66a3d6fc9f2eb73$export$26a4f4cbf9747475]
    },
    authorityMismatch: {
        code: (0, $f66a3d6fc9f2eb73$export$91415fb6baea5d09),
        desc: $a6f096219dc1b547$export$45752b5111a13710[0, $f66a3d6fc9f2eb73$export$91415fb6baea5d09]
    }
};
/**
 * Error thrown when there is an error in configuration of the MSAL.js library.
 */ class $a6f096219dc1b547$export$ac9d9d20c2327339 extends (0, $53b49d8334c1646a$export$145273558d58e0ac) {
    constructor(errorCode){
        super(errorCode, $a6f096219dc1b547$export$45752b5111a13710[errorCode]);
        this.name = "ClientConfigurationError";
        Object.setPrototypeOf(this, $a6f096219dc1b547$export$ac9d9d20c2327339.prototype);
    }
}
function $a6f096219dc1b547$export$5d63d098f4f130a1(errorCode) {
    return new $a6f096219dc1b547$export$ac9d9d20c2327339(errorCode);
}


/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * @hidden
 */ class $5d9dc3fc4be02ef2$export$ecc754f99843e759 {
    /**
     * Check if stringified object is empty
     * @param strObj
     */ static isEmptyObj(strObj) {
        if (strObj) try {
            const obj = JSON.parse(strObj);
            return Object.keys(obj).length === 0;
        } catch (e) {}
        return true;
    }
    static startsWith(str, search) {
        return str.indexOf(search) === 0;
    }
    static endsWith(str, search) {
        return str.length >= search.length && str.lastIndexOf(search) === str.length - search.length;
    }
    /**
     * Parses string into an object.
     *
     * @param query
     */ static queryStringToObject(query) {
        const obj = {};
        const params = query.split("&");
        const decode = (s)=>decodeURIComponent(s.replace(/\+/g, " "));
        params.forEach((pair)=>{
            if (pair.trim()) {
                const [key, value] = pair.split(/=(.+)/g, 2); // Split on the first occurence of the '=' character
                if (key && value) obj[decode(key)] = decode(value);
            }
        });
        return obj;
    }
    /**
     * Trims entries in an array.
     *
     * @param arr
     */ static trimArrayEntries(arr) {
        return arr.map((entry)=>entry.trim());
    }
    /**
     * Removes empty strings from array
     * @param arr
     */ static removeEmptyStringsFromArray(arr) {
        return arr.filter((entry)=>{
            return !!entry;
        });
    }
    /**
     * Attempts to parse a string into JSON
     * @param str
     */ static jsonParseHelper(str) {
        try {
            return JSON.parse(str);
        } catch (e) {
            return null;
        }
    }
    /**
     * Tests if a given string matches a given pattern, with support for wildcards and queries.
     * @param pattern Wildcard pattern to string match. Supports "*" for wildcards and "?" for queries
     * @param input String to match against
     */ static matchPattern(pattern, input) {
        /**
         * Wildcard support: https://stackoverflow.com/a/3117248/4888559
         * Queries: replaces "?" in string with escaped "\?" for regex test
         */ // eslint-disable-next-line security/detect-non-literal-regexp
        const regex = new RegExp(pattern.replace(/\\/g, "\\\\").replace(/\*/g, "[^ ]*").replace(/\?/g, "\\?"));
        return regex.test(input);
    }
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The ScopeSet class creates a set of scopes. Scopes are case-insensitive, unique values, so the Set object in JS makes
 * the most sense to implement for this class. All scopes are trimmed and converted to lower case strings in intersection and union functions
 * to ensure uniqueness of strings.
 */ class $d671ba25592fe375$export$b9b82b0f94ae1f99 {
    constructor(inputScopes){
        // Filter empty string and null/undefined array items
        const scopeArr = inputScopes ? (0, $5d9dc3fc4be02ef2$export$ecc754f99843e759).trimArrayEntries([
            ...inputScopes
        ]) : [];
        const filteredInput = scopeArr ? (0, $5d9dc3fc4be02ef2$export$ecc754f99843e759).removeEmptyStringsFromArray(scopeArr) : [];
        // Validate and filter scopes (validate function throws if validation fails)
        this.validateInputScopes(filteredInput);
        this.scopes = new Set(); // Iterator in constructor not supported by IE11
        filteredInput.forEach((scope)=>this.scopes.add(scope));
    }
    /**
     * Factory method to create ScopeSet from space-delimited string
     * @param inputScopeString
     * @param appClientId
     * @param scopesRequired
     */ static fromString(inputScopeString) {
        const scopeString = inputScopeString || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING;
        const inputScopes = scopeString.split(" ");
        return new $d671ba25592fe375$export$b9b82b0f94ae1f99(inputScopes);
    }
    /**
     * Creates the set of scopes to search for in cache lookups
     * @param inputScopeString
     * @returns
     */ static createSearchScopes(inputScopeString) {
        const scopeSet = new $d671ba25592fe375$export$b9b82b0f94ae1f99(inputScopeString);
        if (!scopeSet.containsOnlyOIDCScopes()) scopeSet.removeOIDCScopes();
        else scopeSet.removeScope((0, $08c107807d753255$export$a002182e51710d39).OFFLINE_ACCESS_SCOPE);
        return scopeSet;
    }
    /**
     * Used to validate the scopes input parameter requested  by the developer.
     * @param {Array<string>} inputScopes - Developer requested permissions. Not all scopes are guaranteed to be included in the access token returned.
     * @param {boolean} scopesRequired - Boolean indicating whether the scopes array is required or not
     */ validateInputScopes(inputScopes) {
        // Check if scopes are required but not given or is an empty array
        if (!inputScopes || inputScopes.length < 1) throw (0, $a6f096219dc1b547$export$5d63d098f4f130a1)((0, $f66a3d6fc9f2eb73$export$6ac27379c42383f));
    }
    /**
     * Check if a given scope is present in this set of scopes.
     * @param scope
     */ containsScope(scope) {
        const lowerCaseScopes = this.printScopesLowerCase().split(" ");
        const lowerCaseScopesSet = new $d671ba25592fe375$export$b9b82b0f94ae1f99(lowerCaseScopes);
        // compare lowercase scopes
        return scope ? lowerCaseScopesSet.scopes.has(scope.toLowerCase()) : false;
    }
    /**
     * Check if a set of scopes is present in this set of scopes.
     * @param scopeSet
     */ containsScopeSet(scopeSet) {
        if (!scopeSet || scopeSet.scopes.size <= 0) return false;
        return this.scopes.size >= scopeSet.scopes.size && scopeSet.asArray().every((scope)=>this.containsScope(scope));
    }
    /**
     * Check if set of scopes contains only the defaults
     */ containsOnlyOIDCScopes() {
        let defaultScopeCount = 0;
        (0, $08c107807d753255$export$268e88275f5afab2).forEach((defaultScope)=>{
            if (this.containsScope(defaultScope)) defaultScopeCount += 1;
        });
        return this.scopes.size === defaultScopeCount;
    }
    /**
     * Appends single scope if passed
     * @param newScope
     */ appendScope(newScope) {
        if (newScope) this.scopes.add(newScope.trim());
    }
    /**
     * Appends multiple scopes if passed
     * @param newScopes
     */ appendScopes(newScopes) {
        try {
            newScopes.forEach((newScope)=>this.appendScope(newScope));
        } catch (e) {
            throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$93883786cf4a4a27));
        }
    }
    /**
     * Removes element from set of scopes.
     * @param scope
     */ removeScope(scope) {
        if (!scope) throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$f7a276c01beb068a));
        this.scopes.delete(scope.trim());
    }
    /**
     * Removes default scopes from set of scopes
     * Primarily used to prevent cache misses if the default scopes are not returned from the server
     */ removeOIDCScopes() {
        (0, $08c107807d753255$export$268e88275f5afab2).forEach((defaultScope)=>{
            this.scopes.delete(defaultScope);
        });
    }
    /**
     * Combines an array of scopes with the current set of scopes.
     * @param otherScopes
     */ unionScopeSets(otherScopes) {
        if (!otherScopes) throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$41e2ce5958c42c83));
        const unionScopes = new Set(); // Iterator in constructor not supported in IE11
        otherScopes.scopes.forEach((scope)=>unionScopes.add(scope.toLowerCase()));
        this.scopes.forEach((scope)=>unionScopes.add(scope.toLowerCase()));
        return unionScopes;
    }
    /**
     * Check if scopes intersect between this set and another.
     * @param otherScopes
     */ intersectingScopeSets(otherScopes) {
        if (!otherScopes) throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$41e2ce5958c42c83));
        // Do not allow OIDC scopes to be the only intersecting scopes
        if (!otherScopes.containsOnlyOIDCScopes()) otherScopes.removeOIDCScopes();
        const unionScopes = this.unionScopeSets(otherScopes);
        const sizeOtherScopes = otherScopes.getScopeCount();
        const sizeThisScopes = this.getScopeCount();
        const sizeUnionScopes = unionScopes.size;
        return sizeUnionScopes < sizeThisScopes + sizeOtherScopes;
    }
    /**
     * Returns size of set of scopes.
     */ getScopeCount() {
        return this.scopes.size;
    }
    /**
     * Returns the scopes as an array of string values
     */ asArray() {
        const array = [];
        this.scopes.forEach((val)=>array.push(val));
        return array;
    }
    /**
     * Prints scopes into a space-delimited string
     */ printScopes() {
        if (this.scopes) {
            const scopeArr = this.asArray();
            return scopeArr.join(" ");
        }
        return (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING;
    }
    /**
     * Prints scopes into a space-delimited lower-case string (used for caching)
     */ printScopesLowerCase() {
        return this.printScopes().toLowerCase();
    }
}


/*! @azure/msal-common v14.16.1 2025-08-05 */ 
/*! @azure/msal-common v14.16.1 2025-08-05 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Function to build a client info object from server clientInfo string
 * @param rawClientInfo
 * @param crypto
 */ function $8647f63f1ec6244a$export$575e1419cfbab7f8(rawClientInfo, base64Decode) {
    if (!rawClientInfo) throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$12315251e24e0181));
    try {
        const decodedClientInfo = base64Decode(rawClientInfo);
        return JSON.parse(decodedClientInfo);
    } catch (e) {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$ccdf48c387c47b82));
    }
}
/**
 * Function to build a client info object from cached homeAccountId string
 * @param homeAccountId
 */ function $8647f63f1ec6244a$export$63508a6d6b7dbe07(homeAccountId) {
    if (!homeAccountId) throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$ccdf48c387c47b82));
    const clientInfoParts = homeAccountId.split((0, $08c107807d753255$export$520854da2ba5d734).CLIENT_INFO_SEPARATOR, 2);
    return {
        uid: clientInfoParts[0],
        utid: clientInfoParts.length < 2 ? (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING : clientInfoParts[1]
    };
}


/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns true if tenantId matches the utid portion of homeAccountId
 * @param tenantId
 * @param homeAccountId
 * @returns
 */ function $2b6041b9fe3f70e1$export$bc62fd222eddc2d7(tenantId, homeAccountId) {
    return !!tenantId && !!homeAccountId && tenantId === homeAccountId.split(".")[1];
}
/**
 * Build tenant profile
 * @param homeAccountId - Home account identifier for this account object
 * @param localAccountId - Local account identifer for this account object
 * @param tenantId - Full tenant or organizational id that this account belongs to
 * @param idTokenClaims - Claims from the ID token
 * @returns
 */ function $2b6041b9fe3f70e1$export$924857724cb21ba4(homeAccountId, localAccountId, tenantId, idTokenClaims) {
    if (idTokenClaims) {
        const { oid: oid, sub: sub, tid: tid, name: name, tfp: tfp, acr: acr } = idTokenClaims;
        /**
         * Since there is no way to determine if the authority is AAD or B2C, we exhaust all the possible claims that can serve as tenant ID with the following precedence:
         * tid - TenantID claim that identifies the tenant that issued the token in AAD. Expected in all AAD ID tokens, not present in B2C ID Tokens.
         * tfp - Trust Framework Policy claim that identifies the policy that was used to authenticate the user. Functions as tenant for B2C scenarios.
         * acr - Authentication Context Class Reference claim used only with older B2C policies. Fallback in case tfp is not present, but likely won't be present anyway.
         */ const tenantId = tid || tfp || acr || "";
        return {
            tenantId: tenantId,
            localAccountId: oid || sub || "",
            name: name,
            isHomeTenant: $2b6041b9fe3f70e1$export$bc62fd222eddc2d7(tenantId, homeAccountId)
        };
    } else return {
        tenantId: tenantId,
        localAccountId: localAccountId,
        isHomeTenant: $2b6041b9fe3f70e1$export$bc62fd222eddc2d7(tenantId, homeAccountId)
    };
}
/**
 * Replaces account info that varies by tenant profile sourced from the ID token claims passed in with the tenant-specific account info
 * @param baseAccountInfo
 * @param idTokenClaims
 * @returns
 */ function $2b6041b9fe3f70e1$export$452a054c78b83dad(baseAccountInfo, tenantProfile, idTokenClaims, idTokenSecret) {
    let updatedAccountInfo = baseAccountInfo;
    // Tenant Profile overrides passed in account info
    if (tenantProfile) {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { isHomeTenant: isHomeTenant, ...tenantProfileOverride } = tenantProfile;
        updatedAccountInfo = {
            ...baseAccountInfo,
            ...tenantProfileOverride
        };
    }
    // ID token claims override passed in account info and tenant profile
    if (idTokenClaims) {
        // Ignore isHomeTenant, loginHint, and sid which are part of tenant profile but not base account info
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { isHomeTenant: isHomeTenant, ...claimsSourcedTenantProfile } = $2b6041b9fe3f70e1$export$924857724cb21ba4(baseAccountInfo.homeAccountId, baseAccountInfo.localAccountId, baseAccountInfo.tenantId, idTokenClaims);
        updatedAccountInfo = {
            ...updatedAccountInfo,
            ...claimsSourcedTenantProfile,
            idTokenClaims: idTokenClaims,
            idToken: idTokenSecret
        };
        return updatedAccountInfo;
    }
    return updatedAccountInfo;
}



/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Authority types supported by MSAL.
 */ const $177318b44e15a6f4$export$cd82032b224a3839 = {
    Default: 0,
    Adfs: 1,
    Dsts: 2,
    Ciam: 3
};


/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Gets tenantId from available ID token claims to set as credential realm with the following precedence:
 * 1. tid - if the token is acquired from an Azure AD tenant tid will be present
 * 2. tfp - if the token is acquired from a modern B2C tenant tfp should be present
 * 3. acr - if the token is acquired from a legacy B2C tenant acr should be present
 * Downcased to match the realm case-insensitive comparison requirements
 * @param idTokenClaims
 * @returns
 */ function $72bd70d616a36606$export$8e1decb9a5e2932(idTokenClaims) {
    if (idTokenClaims) {
        const tenantId = idTokenClaims.tid || idTokenClaims.tfp || idTokenClaims.acr;
        return tenantId || null;
    }
    return null;
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Type that defines required and optional parameters for an Account field (based on universal cache schema implemented by all MSALs).
 *
 * Key : Value Schema
 *
 * Key: <home_account_id>-<environment>-<realm*>
 *
 * Value Schema:
 * {
 *      homeAccountId: home account identifier for the auth scheme,
 *      environment: entity that issued the token, represented as a full host
 *      realm: Full tenant or organizational identifier that the account belongs to
 *      localAccountId: Original tenant-specific accountID, usually used for legacy cases
 *      username: primary username that represents the user, usually corresponds to preferred_username in the v2 endpt
 *      authorityType: Accounts authority type as a string
 *      name: Full name for the account, including given name and family name,
 *      lastModificationTime: last time this entity was modified in the cache
 *      lastModificationApp:
 *      nativeAccountId: Account identifier on the native device
 *      tenantProfiles: Array of tenant profile objects for each tenant that the account has authenticated with in the browser
 * }
 * @internal
 */ class $35a4414ce05ac30e$export$680160523e6bfa6a {
    /**
     * Generate Account Id key component as per the schema: <home_account_id>-<environment>
     */ generateAccountId() {
        const accountId = [
            this.homeAccountId,
            this.environment
        ];
        return accountId.join((0, $08c107807d753255$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
    }
    /**
     * Generate Account Cache Key as per the schema: <home_account_id>-<environment>-<realm*>
     */ generateAccountKey() {
        return $35a4414ce05ac30e$export$680160523e6bfa6a.generateAccountCacheKey({
            homeAccountId: this.homeAccountId,
            environment: this.environment,
            tenantId: this.realm,
            username: this.username,
            localAccountId: this.localAccountId
        });
    }
    /**
     * Returns the AccountInfo interface for this account.
     */ getAccountInfo() {
        return {
            homeAccountId: this.homeAccountId,
            environment: this.environment,
            tenantId: this.realm,
            username: this.username,
            localAccountId: this.localAccountId,
            name: this.name,
            nativeAccountId: this.nativeAccountId,
            authorityType: this.authorityType,
            // Deserialize tenant profiles array into a Map
            tenantProfiles: new Map((this.tenantProfiles || []).map((tenantProfile)=>{
                return [
                    tenantProfile.tenantId,
                    tenantProfile
                ];
            }))
        };
    }
    /**
     * Returns true if the account entity is in single tenant format (outdated), false otherwise
     */ isSingleTenant() {
        return !this.tenantProfiles;
    }
    /**
     * Generates account key from interface
     * @param accountInterface
     */ static generateAccountCacheKey(accountInterface) {
        const homeTenantId = accountInterface.homeAccountId.split(".")[1];
        const accountKey = [
            accountInterface.homeAccountId,
            accountInterface.environment || "",
            homeTenantId || accountInterface.tenantId || ""
        ];
        return accountKey.join((0, $08c107807d753255$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).toLowerCase();
    }
    /**
     * Build Account cache from IdToken, clientInfo and authority/policy. Associated with AAD.
     * @param accountDetails
     */ static createAccount(accountDetails, authority, base64Decode) {
        const account = new $35a4414ce05ac30e$export$680160523e6bfa6a();
        if (authority.authorityType === (0, $177318b44e15a6f4$export$cd82032b224a3839).Adfs) account.authorityType = (0, $08c107807d753255$export$23244fafa2e7f55c).ADFS_ACCOUNT_TYPE;
        else if (authority.protocolMode === (0, $a47d2ec0503d310c$export$73a3e3dedd37150d).AAD) account.authorityType = (0, $08c107807d753255$export$23244fafa2e7f55c).MSSTS_ACCOUNT_TYPE;
        else account.authorityType = (0, $08c107807d753255$export$23244fafa2e7f55c).GENERIC_ACCOUNT_TYPE;
        let clientInfo;
        if (accountDetails.clientInfo && base64Decode) clientInfo = (0, $8647f63f1ec6244a$export$575e1419cfbab7f8)(accountDetails.clientInfo, base64Decode);
        account.clientInfo = accountDetails.clientInfo;
        account.homeAccountId = accountDetails.homeAccountId;
        account.nativeAccountId = accountDetails.nativeAccountId;
        const env = accountDetails.environment || authority && authority.getPreferredCache();
        if (!env) throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$dedc648643245fa1));
        account.environment = env;
        // non AAD scenarios can have empty realm
        account.realm = clientInfo?.utid || (0, $72bd70d616a36606$export$8e1decb9a5e2932)(accountDetails.idTokenClaims) || "";
        // How do you account for MSA CID here?
        account.localAccountId = clientInfo?.uid || accountDetails.idTokenClaims?.oid || accountDetails.idTokenClaims?.sub || "";
        /*
         * In B2C scenarios the emails claim is used instead of preferred_username and it is an array.
         * In most cases it will contain a single email. This field should not be relied upon if a custom
         * policy is configured to return more than 1 email.
         */ const preferredUsername = accountDetails.idTokenClaims?.preferred_username || accountDetails.idTokenClaims?.upn;
        const email = accountDetails.idTokenClaims?.emails ? accountDetails.idTokenClaims.emails[0] : null;
        account.username = preferredUsername || email || "";
        account.name = accountDetails.idTokenClaims?.name || "";
        account.cloudGraphHostName = accountDetails.cloudGraphHostName;
        account.msGraphHost = accountDetails.msGraphHost;
        if (accountDetails.tenantProfiles) account.tenantProfiles = accountDetails.tenantProfiles;
        else {
            const tenantProfile = (0, $2b6041b9fe3f70e1$export$924857724cb21ba4)(accountDetails.homeAccountId, account.localAccountId, account.realm, accountDetails.idTokenClaims);
            account.tenantProfiles = [
                tenantProfile
            ];
        }
        return account;
    }
    /**
     * Creates an AccountEntity object from AccountInfo
     * @param accountInfo
     * @param cloudGraphHostName
     * @param msGraphHost
     * @returns
     */ static createFromAccountInfo(accountInfo, cloudGraphHostName, msGraphHost) {
        const account = new $35a4414ce05ac30e$export$680160523e6bfa6a();
        account.authorityType = accountInfo.authorityType || (0, $08c107807d753255$export$23244fafa2e7f55c).GENERIC_ACCOUNT_TYPE;
        account.homeAccountId = accountInfo.homeAccountId;
        account.localAccountId = accountInfo.localAccountId;
        account.nativeAccountId = accountInfo.nativeAccountId;
        account.realm = accountInfo.tenantId;
        account.environment = accountInfo.environment;
        account.username = accountInfo.username;
        account.name = accountInfo.name;
        account.cloudGraphHostName = cloudGraphHostName;
        account.msGraphHost = msGraphHost;
        // Serialize tenant profiles map into an array
        account.tenantProfiles = Array.from(accountInfo.tenantProfiles?.values() || []);
        return account;
    }
    /**
     * Generate HomeAccountId from server response
     * @param serverClientInfo
     * @param authType
     */ static generateHomeAccountId(serverClientInfo, authType, logger, cryptoObj, idTokenClaims) {
        // since ADFS/DSTS do not have tid and does not set client_info
        if (!(authType === (0, $177318b44e15a6f4$export$cd82032b224a3839).Adfs || authType === (0, $177318b44e15a6f4$export$cd82032b224a3839).Dsts)) {
            // for cases where there is clientInfo
            if (serverClientInfo) try {
                const clientInfo = (0, $8647f63f1ec6244a$export$575e1419cfbab7f8)(serverClientInfo, cryptoObj.base64Decode);
                if (clientInfo.uid && clientInfo.utid) return `${clientInfo.uid}.${clientInfo.utid}`;
            } catch (e) {}
            logger.warning("No client info in response");
        }
        // default to "sub" claim
        return idTokenClaims?.sub || "";
    }
    /**
     * Validates an entity: checks for all expected params
     * @param entity
     */ static isAccountEntity(entity) {
        if (!entity) return false;
        return entity.hasOwnProperty("homeAccountId") && entity.hasOwnProperty("environment") && entity.hasOwnProperty("realm") && entity.hasOwnProperty("localAccountId") && entity.hasOwnProperty("username") && entity.hasOwnProperty("authorityType");
    }
    /**
     * Helper function to determine whether 2 accountInfo objects represent the same account
     * @param accountA
     * @param accountB
     * @param compareClaims - If set to true idTokenClaims will also be compared to determine account equality
     */ static accountInfoIsEqual(accountA, accountB, compareClaims) {
        if (!accountA || !accountB) return false;
        let claimsMatch = true; // default to true so as to not fail comparison below if compareClaims: false
        if (compareClaims) {
            const accountAClaims = accountA.idTokenClaims || {};
            const accountBClaims = accountB.idTokenClaims || {};
            // issued at timestamp and nonce are expected to change each time a new id token is acquired
            claimsMatch = accountAClaims.iat === accountBClaims.iat && accountAClaims.nonce === accountBClaims.nonce;
        }
        return accountA.homeAccountId === accountB.homeAccountId && accountA.localAccountId === accountB.localAccountId && accountA.username === accountB.username && accountA.tenantId === accountB.tenantId && accountA.environment === accountB.environment && accountA.nativeAccountId === accountB.nativeAccountId && claimsMatch;
    }
}






/*! @azure/msal-common v14.16.1 2025-08-05 */ /*! @azure/msal-common v14.16.1 2025-08-05 */ 


var $cdc672602db089f1$exports = {};

$parcel$export($cdc672602db089f1$exports, "stripLeadingHashOrQuery", function () { return $cdc672602db089f1$export$fe89dd256736a6b3; });
$parcel$export($cdc672602db089f1$exports, "getDeserializedResponse", function () { return $cdc672602db089f1$export$f98e0976781b1204; });
/*! @azure/msal-common v14.16.1 2025-08-05 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Parses hash string from given string. Returns empty string if no hash symbol is found.
 * @param hashString
 */ function $cdc672602db089f1$export$fe89dd256736a6b3(responseString) {
    if (responseString.startsWith("#/")) return responseString.substring(2);
    else if (responseString.startsWith("#") || responseString.startsWith("?")) return responseString.substring(1);
    return responseString;
}
/**
 * Returns URL hash as server auth code response object.
 */ function $cdc672602db089f1$export$f98e0976781b1204(responseString) {
    // Check if given hash is empty
    if (!responseString || responseString.indexOf("=") < 0) return null;
    try {
        // Strip the # or ? symbol if present
        const normalizedResponse = $cdc672602db089f1$export$fe89dd256736a6b3(responseString);
        // If # symbol was not present, above will return empty string, so give original hash value
        const deserializedHash = Object.fromEntries(new URLSearchParams(normalizedResponse));
        // Check for known response properties
        if (deserializedHash.code || deserializedHash.error || deserializedHash.error_description || deserializedHash.state) return deserializedHash;
    } catch (e) {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$14c4d54a8414667f));
    }
    return null;
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Url object class which can perform various transformations on url strings.
 */ class $ff2860ddbc741970$export$3abcdca7229e54f2 {
    get urlString() {
        return this._urlString;
    }
    constructor(url){
        this._urlString = url;
        if (!this._urlString) // Throws error if url is empty
        throw (0, $a6f096219dc1b547$export$5d63d098f4f130a1)((0, $f66a3d6fc9f2eb73$export$859df485a5e0f239));
        if (!url.includes("#")) this._urlString = $ff2860ddbc741970$export$3abcdca7229e54f2.canonicalizeUri(url);
    }
    /**
     * Ensure urls are lower case and end with a / character.
     * @param url
     */ static canonicalizeUri(url) {
        if (url) {
            let lowerCaseUrl = url.toLowerCase();
            if ((0, $5d9dc3fc4be02ef2$export$ecc754f99843e759).endsWith(lowerCaseUrl, "?")) lowerCaseUrl = lowerCaseUrl.slice(0, -1);
            else if ((0, $5d9dc3fc4be02ef2$export$ecc754f99843e759).endsWith(lowerCaseUrl, "?/")) lowerCaseUrl = lowerCaseUrl.slice(0, -2);
            if (!(0, $5d9dc3fc4be02ef2$export$ecc754f99843e759).endsWith(lowerCaseUrl, "/")) lowerCaseUrl += "/";
            return lowerCaseUrl;
        }
        return url;
    }
    /**
     * Throws if urlString passed is not a valid authority URI string.
     */ validateAsUri() {
        // Attempts to parse url for uri components
        let components;
        try {
            components = this.getUrlComponents();
        } catch (e) {
            throw (0, $a6f096219dc1b547$export$5d63d098f4f130a1)((0, $f66a3d6fc9f2eb73$export$ee2a1a3389f75508));
        }
        // Throw error if URI or path segments are not parseable.
        if (!components.HostNameAndPort || !components.PathSegments) throw (0, $a6f096219dc1b547$export$5d63d098f4f130a1)((0, $f66a3d6fc9f2eb73$export$ee2a1a3389f75508));
        // Throw error if uri is insecure.
        if (!components.Protocol || components.Protocol.toLowerCase() !== "https:") throw (0, $a6f096219dc1b547$export$5d63d098f4f130a1)((0, $f66a3d6fc9f2eb73$export$f77c6af656c8444b));
    }
    /**
     * Given a url and a query string return the url with provided query string appended
     * @param url
     * @param queryString
     */ static appendQueryString(url, queryString) {
        if (!queryString) return url;
        return url.indexOf("?") < 0 ? `${url}?${queryString}` : `${url}&${queryString}`;
    }
    /**
     * Returns a url with the hash removed
     * @param url
     */ static removeHashFromUrl(url) {
        return $ff2860ddbc741970$export$3abcdca7229e54f2.canonicalizeUri(url.split("#")[0]);
    }
    /**
     * Given a url like https://a:b/common/d?e=f#g, and a tenantId, returns https://a:b/tenantId/d
     * @param href The url
     * @param tenantId The tenant id to replace
     */ replaceTenantPath(tenantId) {
        const urlObject = this.getUrlComponents();
        const pathArray = urlObject.PathSegments;
        if (tenantId && pathArray.length !== 0 && (pathArray[0] === (0, $08c107807d753255$export$e18ac120172ed505).COMMON || pathArray[0] === (0, $08c107807d753255$export$e18ac120172ed505).ORGANIZATIONS)) pathArray[0] = tenantId;
        return $ff2860ddbc741970$export$3abcdca7229e54f2.constructAuthorityUriFromObject(urlObject);
    }
    /**
     * Parses out the components from a url string.
     * @returns An object with the various components. Please cache this value insted of calling this multiple times on the same url.
     */ getUrlComponents() {
        // https://gist.github.com/curtisz/11139b2cfcaef4a261e0
        const regEx = RegExp("^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?");
        // If url string does not match regEx, we throw an error
        const match = this.urlString.match(regEx);
        if (!match) throw (0, $a6f096219dc1b547$export$5d63d098f4f130a1)((0, $f66a3d6fc9f2eb73$export$ee2a1a3389f75508));
        // Url component object
        const urlComponents = {
            Protocol: match[1],
            HostNameAndPort: match[4],
            AbsolutePath: match[5],
            QueryString: match[7]
        };
        let pathSegments = urlComponents.AbsolutePath.split("/");
        pathSegments = pathSegments.filter((val)=>val && val.length > 0); // remove empty elements
        urlComponents.PathSegments = pathSegments;
        if (urlComponents.QueryString && urlComponents.QueryString.endsWith("/")) urlComponents.QueryString = urlComponents.QueryString.substring(0, urlComponents.QueryString.length - 1);
        return urlComponents;
    }
    static getDomainFromUrl(url) {
        const regEx = RegExp("^([^:/?#]+://)?([^/?#]*)");
        const match = url.match(regEx);
        if (!match) throw (0, $a6f096219dc1b547$export$5d63d098f4f130a1)((0, $f66a3d6fc9f2eb73$export$ee2a1a3389f75508));
        return match[2];
    }
    static getAbsoluteUrl(relativeUrl, baseUrl) {
        if (relativeUrl[0] === (0, $08c107807d753255$export$a002182e51710d39).FORWARD_SLASH) {
            const url = new $ff2860ddbc741970$export$3abcdca7229e54f2(baseUrl);
            const baseComponents = url.getUrlComponents();
            return baseComponents.Protocol + "//" + baseComponents.HostNameAndPort + relativeUrl;
        }
        return relativeUrl;
    }
    static constructAuthorityUriFromObject(urlObject) {
        return new $ff2860ddbc741970$export$3abcdca7229e54f2(urlObject.Protocol + "//" + urlObject.HostNameAndPort + "/" + urlObject.PathSegments.join("/"));
    }
    /**
     * Check if the hash of the URL string contains known properties
     * @deprecated This API will be removed in a future version
     */ static hashContainsKnownProperties(response) {
        return !!(0, $cdc672602db089f1$export$f98e0976781b1204)(response);
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $1d18a42dbb0c24e8$export$223f43dfec89cb87 = {
    endpointMetadata: {
        "login.microsoftonline.com": {
            token_endpoint: "https://login.microsoftonline.com/{tenantid}/oauth2/v2.0/token",
            jwks_uri: "https://login.microsoftonline.com/{tenantid}/discovery/v2.0/keys",
            issuer: "https://login.microsoftonline.com/{tenantid}/v2.0",
            authorization_endpoint: "https://login.microsoftonline.com/{tenantid}/oauth2/v2.0/authorize",
            end_session_endpoint: "https://login.microsoftonline.com/{tenantid}/oauth2/v2.0/logout"
        },
        "login.chinacloudapi.cn": {
            token_endpoint: "https://login.chinacloudapi.cn/{tenantid}/oauth2/v2.0/token",
            jwks_uri: "https://login.chinacloudapi.cn/{tenantid}/discovery/v2.0/keys",
            issuer: "https://login.partner.microsoftonline.cn/{tenantid}/v2.0",
            authorization_endpoint: "https://login.chinacloudapi.cn/{tenantid}/oauth2/v2.0/authorize",
            end_session_endpoint: "https://login.chinacloudapi.cn/{tenantid}/oauth2/v2.0/logout"
        },
        "login.microsoftonline.us": {
            token_endpoint: "https://login.microsoftonline.us/{tenantid}/oauth2/v2.0/token",
            jwks_uri: "https://login.microsoftonline.us/{tenantid}/discovery/v2.0/keys",
            issuer: "https://login.microsoftonline.us/{tenantid}/v2.0",
            authorization_endpoint: "https://login.microsoftonline.us/{tenantid}/oauth2/v2.0/authorize",
            end_session_endpoint: "https://login.microsoftonline.us/{tenantid}/oauth2/v2.0/logout"
        }
    },
    instanceDiscoveryMetadata: {
        tenant_discovery_endpoint: "https://{canonicalAuthority}/v2.0/.well-known/openid-configuration",
        metadata: [
            {
                preferred_network: "login.microsoftonline.com",
                preferred_cache: "login.windows.net",
                aliases: [
                    "login.microsoftonline.com",
                    "login.windows.net",
                    "login.microsoft.com",
                    "sts.windows.net"
                ]
            },
            {
                preferred_network: "login.partner.microsoftonline.cn",
                preferred_cache: "login.partner.microsoftonline.cn",
                aliases: [
                    "login.partner.microsoftonline.cn",
                    "login.chinacloudapi.cn"
                ]
            },
            {
                preferred_network: "login.microsoftonline.de",
                preferred_cache: "login.microsoftonline.de",
                aliases: [
                    "login.microsoftonline.de"
                ]
            },
            {
                preferred_network: "login.microsoftonline.us",
                preferred_cache: "login.microsoftonline.us",
                aliases: [
                    "login.microsoftonline.us",
                    "login.usgovcloudapi.net"
                ]
            },
            {
                preferred_network: "login-us.microsoftonline.com",
                preferred_cache: "login-us.microsoftonline.com",
                aliases: [
                    "login-us.microsoftonline.com"
                ]
            }
        ]
    }
};
const $1d18a42dbb0c24e8$export$f612854287391207 = $1d18a42dbb0c24e8$export$223f43dfec89cb87.endpointMetadata;
const $1d18a42dbb0c24e8$export$a21acafc3b6f5582 = $1d18a42dbb0c24e8$export$223f43dfec89cb87.instanceDiscoveryMetadata;
const $1d18a42dbb0c24e8$export$7d026f079148cd31 = new Set();
$1d18a42dbb0c24e8$export$a21acafc3b6f5582.metadata.forEach((metadataEntry)=>{
    metadataEntry.aliases.forEach((alias)=>{
        $1d18a42dbb0c24e8$export$7d026f079148cd31.add(alias);
    });
});
/**
 * Attempts to get an aliases array from the static authority metadata sources based on the canonical authority host
 * @param staticAuthorityOptions
 * @param logger
 * @returns
 */ function $1d18a42dbb0c24e8$export$2c21adf4b4d4efc0(staticAuthorityOptions, logger) {
    let staticAliases;
    const canonicalAuthority = staticAuthorityOptions.canonicalAuthority;
    if (canonicalAuthority) {
        const authorityHost = new (0, $ff2860ddbc741970$export$3abcdca7229e54f2)(canonicalAuthority).getUrlComponents().HostNameAndPort;
        staticAliases = $1d18a42dbb0c24e8$export$d195904946de56a1(authorityHost, staticAuthorityOptions.cloudDiscoveryMetadata?.metadata, (0, $08c107807d753255$export$5d365d77acfcb55d).CONFIG, logger) || $1d18a42dbb0c24e8$export$d195904946de56a1(authorityHost, $1d18a42dbb0c24e8$export$a21acafc3b6f5582.metadata, (0, $08c107807d753255$export$5d365d77acfcb55d).HARDCODED_VALUES, logger) || staticAuthorityOptions.knownAuthorities;
    }
    return staticAliases || [];
}
/**
 * Returns aliases for from the raw cloud discovery metadata passed in
 * @param authorityHost
 * @param rawCloudDiscoveryMetadata
 * @returns
 */ function $1d18a42dbb0c24e8$export$d195904946de56a1(authorityHost, cloudDiscoveryMetadata, source, logger) {
    logger?.trace(`getAliasesFromMetadata called with source: ${source}`);
    if (authorityHost && cloudDiscoveryMetadata) {
        const metadata = $1d18a42dbb0c24e8$export$6e21098ea6e60dc(cloudDiscoveryMetadata, authorityHost);
        if (metadata) {
            logger?.trace(`getAliasesFromMetadata: found cloud discovery metadata in ${source}, returning aliases`);
            return metadata.aliases;
        } else logger?.trace(`getAliasesFromMetadata: did not find cloud discovery metadata in ${source}`);
    }
    return null;
}
/**
 * Get cloud discovery metadata for common authorities
 */ function $1d18a42dbb0c24e8$export$1b1433f93c9873f(authorityHost) {
    const metadata = $1d18a42dbb0c24e8$export$6e21098ea6e60dc($1d18a42dbb0c24e8$export$a21acafc3b6f5582.metadata, authorityHost);
    return metadata;
}
/**
 * Searches instance discovery network response for the entry that contains the host in the aliases list
 * @param response
 * @param authority
 */ function $1d18a42dbb0c24e8$export$6e21098ea6e60dc(response, authorityHost) {
    for(let i = 0; i < response.length; i++){
        const metadata = response[i];
        if (metadata.aliases.includes(authorityHost)) return metadata;
    }
    return null;
}


/*! @azure/msal-common v14.16.1 2025-08-05 */ var $20d5d8804295d8ea$exports = {};

$parcel$export($20d5d8804295d8ea$exports, "cacheQuotaExceeded", function () { return $20d5d8804295d8ea$export$e55c8be2f026d30a; });
$parcel$export($20d5d8804295d8ea$exports, "cacheErrorUnknown", function () { return $20d5d8804295d8ea$export$6f650427f72a7890; });
/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $20d5d8804295d8ea$export$e55c8be2f026d30a = "cache_quota_exceeded";
const $20d5d8804295d8ea$export$6f650427f72a7890 = "cache_error_unknown";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $812f0ad9daef6a7a$export$7ab11f0b2c87dadd = {
    [(0, $20d5d8804295d8ea$export$e55c8be2f026d30a)]: "Exceeded cache storage capacity.",
    [(0, $20d5d8804295d8ea$export$6f650427f72a7890)]: "Unexpected error occurred when using cache storage."
};
/**
 * Error thrown when there is an error with the cache
 */ class $812f0ad9daef6a7a$export$78ff06e91c3de382 extends Error {
    constructor(errorCode, errorMessage){
        const message = errorMessage || ($812f0ad9daef6a7a$export$7ab11f0b2c87dadd[errorCode] ? $812f0ad9daef6a7a$export$7ab11f0b2c87dadd[errorCode] : $812f0ad9daef6a7a$export$7ab11f0b2c87dadd[0, $20d5d8804295d8ea$export$6f650427f72a7890]);
        super(`${errorCode}: ${message}`);
        Object.setPrototypeOf(this, $812f0ad9daef6a7a$export$78ff06e91c3de382.prototype);
        this.name = "CacheError";
        this.errorCode = errorCode;
        this.errorMessage = message;
    }
}
/**
 * Helper function to wrap browser errors in a CacheError object
 * @param e
 * @returns
 */ function $812f0ad9daef6a7a$export$2056718aee1b1d88(e) {
    if (!(e instanceof Error)) return new $812f0ad9daef6a7a$export$78ff06e91c3de382((0, $20d5d8804295d8ea$export$6f650427f72a7890));
    if (e.name === "QuotaExceededError" || e.name === "NS_ERROR_DOM_QUOTA_REACHED" || e.message.includes("exceeded the quota")) return new $812f0ad9daef6a7a$export$78ff06e91c3de382((0, $20d5d8804295d8ea$export$e55c8be2f026d30a));
    else return new $812f0ad9daef6a7a$export$78ff06e91c3de382(e.name, e.message);
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Interface class which implement cache storage functions used by MSAL to perform validity checks, and store tokens.
 * @internal
 */ class $4ffcb9b8559edbe4$export$996e3ea69314b5c6 {
    constructor(clientId, cryptoImpl, logger, staticAuthorityOptions){
        this.clientId = clientId;
        this.cryptoImpl = cryptoImpl;
        this.commonLogger = logger.clone((0, $a15c066c8ddfab99$export$a8ff84c12d48cfa6), (0, $a15c066c8ddfab99$export$83d89fbfd8236492));
        this.staticAuthorityOptions = staticAuthorityOptions;
    }
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(correlationId, accountFilter) {
        return this.buildTenantProfiles(this.getAccountsFilteredBy(accountFilter || {}, correlationId), correlationId, accountFilter);
    }
    /**
     * Gets first tenanted AccountInfo object found based on provided filters
     */ getAccountInfoFilteredBy(accountFilter, correlationId) {
        const allAccounts = this.getAllAccounts(correlationId, accountFilter);
        if (allAccounts.length > 1) {
            // If one or more accounts are found, prioritize accounts that have an ID token
            const sortedAccounts = allAccounts.sort((account)=>{
                return account.idTokenClaims ? -1 : 1;
            });
            return sortedAccounts[0];
        } else if (allAccounts.length === 1) // If only one account is found, return it regardless of whether a matching ID token was found
        return allAccounts[0];
        else return null;
    }
    /**
     * Returns a single matching
     * @param accountFilter
     * @returns
     */ getBaseAccountInfo(accountFilter, correlationId) {
        const accountEntities = this.getAccountsFilteredBy(accountFilter, correlationId);
        if (accountEntities.length > 0) return accountEntities[0].getAccountInfo();
        else return null;
    }
    /**
     * Matches filtered account entities with cached ID tokens that match the tenant profile-specific account filters
     * and builds the account info objects from the matching ID token's claims
     * @param cachedAccounts
     * @param accountFilter
     * @returns Array of AccountInfo objects that match account and tenant profile filters
     */ buildTenantProfiles(cachedAccounts, correlationId, accountFilter) {
        return cachedAccounts.flatMap((accountEntity)=>{
            return this.getTenantProfilesFromAccountEntity(accountEntity, correlationId, accountFilter?.tenantId, accountFilter);
        });
    }
    getTenantedAccountInfoByFilter(accountInfo, tokenKeys, tenantProfile, correlationId, tenantProfileFilter) {
        let tenantedAccountInfo = null;
        let idTokenClaims;
        if (tenantProfileFilter) {
            if (!this.tenantProfileMatchesFilter(tenantProfile, tenantProfileFilter)) return null;
        }
        const idToken = this.getIdToken(accountInfo, correlationId, tokenKeys, tenantProfile.tenantId);
        if (idToken) {
            idTokenClaims = (0, $dfbf8cbb9a592daa$export$8a59e6f35fb00518)(idToken.secret, this.cryptoImpl.base64Decode);
            if (!this.idTokenClaimsMatchTenantProfileFilter(idTokenClaims, tenantProfileFilter)) // ID token sourced claims don't match so this tenant profile is not a match
            return null;
        }
        // Expand tenant profile into account info based on matching tenant profile and if available matching ID token claims
        tenantedAccountInfo = (0, $2b6041b9fe3f70e1$export$452a054c78b83dad)(accountInfo, tenantProfile, idTokenClaims, idToken?.secret);
        return tenantedAccountInfo;
    }
    getTenantProfilesFromAccountEntity(accountEntity, correlationId, targetTenantId, tenantProfileFilter) {
        const accountInfo = accountEntity.getAccountInfo();
        let searchTenantProfiles = accountInfo.tenantProfiles || new Map();
        const tokenKeys = this.getTokenKeys();
        // If a tenant ID was provided, only return the tenant profile for that tenant ID if it exists
        if (targetTenantId) {
            const tenantProfile = searchTenantProfiles.get(targetTenantId);
            if (tenantProfile) // Reduce search field to just this tenant profile
            searchTenantProfiles = new Map([
                [
                    targetTenantId,
                    tenantProfile
                ]
            ]);
            else // No tenant profile for search tenant ID, return empty array
            return [];
        }
        const matchingTenantProfiles = [];
        searchTenantProfiles.forEach((tenantProfile)=>{
            const tenantedAccountInfo = this.getTenantedAccountInfoByFilter(accountInfo, tokenKeys, tenantProfile, correlationId, tenantProfileFilter);
            if (tenantedAccountInfo) matchingTenantProfiles.push(tenantedAccountInfo);
        });
        return matchingTenantProfiles;
    }
    tenantProfileMatchesFilter(tenantProfile, tenantProfileFilter) {
        if (!!tenantProfileFilter.localAccountId && !this.matchLocalAccountIdFromTenantProfile(tenantProfile, tenantProfileFilter.localAccountId)) return false;
        if (!!tenantProfileFilter.name && !(tenantProfile.name === tenantProfileFilter.name)) return false;
        if (tenantProfileFilter.isHomeTenant !== undefined && !(tenantProfile.isHomeTenant === tenantProfileFilter.isHomeTenant)) return false;
        return true;
    }
    idTokenClaimsMatchTenantProfileFilter(idTokenClaims, tenantProfileFilter) {
        // Tenant Profile filtering
        if (tenantProfileFilter) {
            if (!!tenantProfileFilter.localAccountId && !this.matchLocalAccountIdFromTokenClaims(idTokenClaims, tenantProfileFilter.localAccountId)) return false;
            if (!!tenantProfileFilter.loginHint && !this.matchLoginHintFromTokenClaims(idTokenClaims, tenantProfileFilter.loginHint)) return false;
            if (!!tenantProfileFilter.username && !this.matchUsername(idTokenClaims.preferred_username, tenantProfileFilter.username)) return false;
            if (!!tenantProfileFilter.name && !this.matchName(idTokenClaims, tenantProfileFilter.name)) return false;
            if (!!tenantProfileFilter.sid && !this.matchSid(idTokenClaims, tenantProfileFilter.sid)) return false;
        }
        return true;
    }
    /**
     * saves a cache record
     * @param cacheRecord {CacheRecord}
     * @param storeInCache {?StoreInCache}
     * @param correlationId {?string} correlation id
     */ async saveCacheRecord(cacheRecord, correlationId, storeInCache) {
        if (!cacheRecord) throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$d396103576f879cc));
        try {
            if (!!cacheRecord.account) this.setAccount(cacheRecord.account, correlationId);
            if (!!cacheRecord.idToken && storeInCache?.idToken !== false) this.setIdTokenCredential(cacheRecord.idToken, correlationId);
            if (!!cacheRecord.accessToken && storeInCache?.accessToken !== false) await this.saveAccessToken(cacheRecord.accessToken, correlationId);
            if (!!cacheRecord.refreshToken && storeInCache?.refreshToken !== false) this.setRefreshTokenCredential(cacheRecord.refreshToken, correlationId);
            if (!!cacheRecord.appMetadata) this.setAppMetadata(cacheRecord.appMetadata, correlationId);
        } catch (e) {
            this.commonLogger?.error(`CacheManager.saveCacheRecord: failed`);
            if (e instanceof (0, $53b49d8334c1646a$export$145273558d58e0ac)) throw e;
            else throw (0, $812f0ad9daef6a7a$export$2056718aee1b1d88)(e);
        }
    }
    /**
     * saves access token credential
     * @param credential
     */ async saveAccessToken(credential, correlationId) {
        const accessTokenFilter = {
            clientId: credential.clientId,
            credentialType: credential.credentialType,
            environment: credential.environment,
            homeAccountId: credential.homeAccountId,
            realm: credential.realm,
            tokenType: credential.tokenType,
            requestedClaimsHash: credential.requestedClaimsHash
        };
        const tokenKeys = this.getTokenKeys();
        const currentScopes = (0, $d671ba25592fe375$export$b9b82b0f94ae1f99).fromString(credential.target);
        tokenKeys.accessToken.forEach((key)=>{
            if (!this.accessTokenKeyMatchesFilter(key, accessTokenFilter, false)) return;
            const tokenEntity = this.getAccessTokenCredential(key, correlationId);
            if (tokenEntity && this.credentialMatchesFilter(tokenEntity, accessTokenFilter)) {
                const tokenScopeSet = (0, $d671ba25592fe375$export$b9b82b0f94ae1f99).fromString(tokenEntity.target);
                if (tokenScopeSet.intersectingScopeSets(currentScopes)) this.removeAccessToken(key, correlationId);
            }
        });
        this.setAccessTokenCredential(credential, correlationId);
    }
    /**
     * Retrieve account entities matching all provided tenant-agnostic filters; if no filter is set, get all account entities in the cache
     * Not checking for casing as keys are all generated in lower case, remember to convert to lower case if object properties are compared
     * @param accountFilter - An object containing Account properties to filter by
     */ getAccountsFilteredBy(accountFilter, correlationId) {
        const allAccountKeys = this.getAccountKeys();
        const matchingAccounts = [];
        allAccountKeys.forEach((cacheKey)=>{
            if (!this.isAccountKey(cacheKey, accountFilter.homeAccountId)) // Don't parse value if the key doesn't match the account filters
            return;
            const entity = this.getAccount(cacheKey, correlationId, this.commonLogger);
            // Match base account fields
            if (!entity) return;
            if (!!accountFilter.homeAccountId && !this.matchHomeAccountId(entity, accountFilter.homeAccountId)) return;
            if (!!accountFilter.username && !this.matchUsername(entity.username, accountFilter.username)) return;
            if (!!accountFilter.environment && !this.matchEnvironment(entity, accountFilter.environment)) return;
            if (!!accountFilter.realm && !this.matchRealm(entity, accountFilter.realm)) return;
            if (!!accountFilter.nativeAccountId && !this.matchNativeAccountId(entity, accountFilter.nativeAccountId)) return;
            if (!!accountFilter.authorityType && !this.matchAuthorityType(entity, accountFilter.authorityType)) return;
            // If at least one tenant profile matches the tenant profile filter, add the account to the list of matching accounts
            const tenantProfileFilter = {
                localAccountId: accountFilter?.localAccountId,
                name: accountFilter?.name
            };
            const matchingTenantProfiles = entity.tenantProfiles?.filter((tenantProfile)=>{
                return this.tenantProfileMatchesFilter(tenantProfile, tenantProfileFilter);
            });
            if (matchingTenantProfiles && matchingTenantProfiles.length === 0) // No tenant profile for this account matches filter, don't add to list of matching accounts
            return;
            matchingAccounts.push(entity);
        });
        return matchingAccounts;
    }
    /**
     * Returns true if the given key matches our account key schema. Also matches homeAccountId and/or tenantId if provided
     * @param key
     * @param homeAccountId
     * @param tenantId
     * @returns
     */ isAccountKey(key, homeAccountId, tenantId) {
        if (key.split((0, $08c107807d753255$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).length < 3) // Account cache keys contain 3 items separated by '-' (each item may also contain '-')
        return false;
        if (homeAccountId && !key.toLowerCase().includes(homeAccountId.toLowerCase())) return false;
        if (tenantId && !key.toLowerCase().includes(tenantId.toLowerCase())) return false;
        // Do not check environment as aliasing can cause false negatives
        return true;
    }
    /**
     * Returns true if the given key matches our credential key schema.
     * @param key
     */ isCredentialKey(key) {
        if (key.split((0, $08c107807d753255$export$520854da2ba5d734).CACHE_KEY_SEPARATOR).length < 6) // Credential cache keys contain 6 items separated by '-' (each item may also contain '-')
        return false;
        const lowerCaseKey = key.toLowerCase();
        // Credential keys must indicate what credential type they represent
        if (lowerCaseKey.indexOf((0, $08c107807d753255$export$eca2dc7e6e608a68).ID_TOKEN.toLowerCase()) === -1 && lowerCaseKey.indexOf((0, $08c107807d753255$export$eca2dc7e6e608a68).ACCESS_TOKEN.toLowerCase()) === -1 && lowerCaseKey.indexOf((0, $08c107807d753255$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME.toLowerCase()) === -1 && lowerCaseKey.indexOf((0, $08c107807d753255$export$eca2dc7e6e608a68).REFRESH_TOKEN.toLowerCase()) === -1) return false;
        if (lowerCaseKey.indexOf((0, $08c107807d753255$export$eca2dc7e6e608a68).REFRESH_TOKEN.toLowerCase()) > -1) {
            // Refresh tokens must contain the client id or family id
            const clientIdValidation = `${(0, $08c107807d753255$export$eca2dc7e6e608a68).REFRESH_TOKEN}${(0, $08c107807d753255$export$520854da2ba5d734).CACHE_KEY_SEPARATOR}${this.clientId}${(0, $08c107807d753255$export$520854da2ba5d734).CACHE_KEY_SEPARATOR}`;
            const familyIdValidation = `${(0, $08c107807d753255$export$eca2dc7e6e608a68).REFRESH_TOKEN}${(0, $08c107807d753255$export$520854da2ba5d734).CACHE_KEY_SEPARATOR}${(0, $08c107807d753255$export$978fe7ab5e74b539)}${(0, $08c107807d753255$export$520854da2ba5d734).CACHE_KEY_SEPARATOR}`;
            if (lowerCaseKey.indexOf(clientIdValidation.toLowerCase()) === -1 && lowerCaseKey.indexOf(familyIdValidation.toLowerCase()) === -1) return false;
        } else if (lowerCaseKey.indexOf(this.clientId.toLowerCase()) === -1) // Tokens must contain the clientId
        return false;
        return true;
    }
    /**
     * Returns whether or not the given credential entity matches the filter
     * @param entity
     * @param filter
     * @returns
     */ credentialMatchesFilter(entity, filter) {
        if (!!filter.clientId && !this.matchClientId(entity, filter.clientId)) return false;
        if (!!filter.userAssertionHash && !this.matchUserAssertionHash(entity, filter.userAssertionHash)) return false;
        /*
         * homeAccountId can be undefined, and we want to filter out cached items that have a homeAccountId of ""
         * because we don't want a client_credential request to return a cached token that has a homeAccountId
         */ if (typeof filter.homeAccountId === "string" && !this.matchHomeAccountId(entity, filter.homeAccountId)) return false;
        if (!!filter.environment && !this.matchEnvironment(entity, filter.environment)) return false;
        if (!!filter.realm && !this.matchRealm(entity, filter.realm)) return false;
        if (!!filter.credentialType && !this.matchCredentialType(entity, filter.credentialType)) return false;
        if (!!filter.familyId && !this.matchFamilyId(entity, filter.familyId)) return false;
        /*
         * idTokens do not have "target", target specific refreshTokens do exist for some types of authentication
         * Resource specific refresh tokens case will be added when the support is deemed necessary
         */ if (!!filter.target && !this.matchTarget(entity, filter.target)) return false;
        // If request OR cached entity has requested Claims Hash, check if they match
        if (filter.requestedClaimsHash || entity.requestedClaimsHash) {
            // Don't match if either is undefined or they are different
            if (entity.requestedClaimsHash !== filter.requestedClaimsHash) return false;
        }
        // Access Token with Auth Scheme specific matching
        if (entity.credentialType === (0, $08c107807d753255$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME) {
            if (!!filter.tokenType && !this.matchTokenType(entity, filter.tokenType)) return false;
            // KeyId (sshKid) in request must match cached SSH certificate keyId because SSH cert is bound to a specific key
            if (filter.tokenType === (0, $08c107807d753255$export$901491a717da2ba5).SSH) {
                if (filter.keyId && !this.matchKeyId(entity, filter.keyId)) return false;
            }
        }
        return true;
    }
    /**
     * retrieve appMetadata matching all provided filters; if no filter is set, get all appMetadata
     * @param filter
     */ getAppMetadataFilteredBy(filter) {
        const allCacheKeys = this.getKeys();
        const matchingAppMetadata = {};
        allCacheKeys.forEach((cacheKey)=>{
            // don't parse any non-appMetadata type cache entities
            if (!this.isAppMetadata(cacheKey)) return;
            // Attempt retrieval
            const entity = this.getAppMetadata(cacheKey);
            if (!entity) return;
            if (!!filter.environment && !this.matchEnvironment(entity, filter.environment)) return;
            if (!!filter.clientId && !this.matchClientId(entity, filter.clientId)) return;
            matchingAppMetadata[cacheKey] = entity;
        });
        return matchingAppMetadata;
    }
    /**
     * retrieve authorityMetadata that contains a matching alias
     * @param filter
     */ getAuthorityMetadataByAlias(host) {
        const allCacheKeys = this.getAuthorityMetadataKeys();
        let matchedEntity = null;
        allCacheKeys.forEach((cacheKey)=>{
            // don't parse any non-authorityMetadata type cache entities
            if (!this.isAuthorityMetadata(cacheKey) || cacheKey.indexOf(this.clientId) === -1) return;
            // Attempt retrieval
            const entity = this.getAuthorityMetadata(cacheKey);
            if (!entity) return;
            if (entity.aliases.indexOf(host) === -1) return;
            matchedEntity = entity;
        });
        return matchedEntity;
    }
    /**
     * Removes all accounts and related tokens from cache.
     */ async removeAllAccounts(correlationId) {
        const allAccountKeys = this.getAccountKeys();
        const removedAccounts = [];
        allAccountKeys.forEach((cacheKey)=>{
            removedAccounts.push(this.removeAccount(cacheKey, correlationId));
        });
        await Promise.all(removedAccounts);
    }
    /**
     * Removes the account and related tokens for a given account key
     * @param account
     */ async removeAccount(accountKey, correlationId) {
        const account = this.getAccount(accountKey, correlationId, this.commonLogger);
        if (!account) return;
        await this.removeAccountContext(account, correlationId);
        this.removeItem(accountKey, correlationId);
    }
    /**
     * Removes credentials associated with the provided account
     * @param account
     */ async removeAccountContext(account, correlationId) {
        const allTokenKeys = this.getTokenKeys();
        const accountId = account.generateAccountId();
        allTokenKeys.idToken.forEach((key)=>{
            if (key.indexOf(accountId) === 0) this.removeIdToken(key, correlationId);
        });
        allTokenKeys.accessToken.forEach((key)=>{
            if (key.indexOf(accountId) === 0) this.removeAccessToken(key, correlationId);
        });
        allTokenKeys.refreshToken.forEach((key)=>{
            if (key.indexOf(accountId) === 0) this.removeRefreshToken(key, correlationId);
        });
        this.getKeys().forEach((key)=>{
            if (key.includes(accountId)) this.removeItem(key, correlationId);
        });
    }
    /**
     * Migrates a single-tenant account and all it's associated alternate cross-tenant account objects in the
     * cache into a condensed multi-tenant account object with tenant profiles.
     * @param accountKey
     * @param accountEntity
     * @param logger
     * @returns
     */ updateOutdatedCachedAccount(accountKey, accountEntity, correlationId, logger) {
        // Only update if account entity is defined and has no tenantProfiles object (is outdated)
        if (accountEntity && accountEntity.isSingleTenant()) {
            this.commonLogger?.verbose("updateOutdatedCachedAccount: Found a single-tenant (outdated) account entity in the cache, migrating to multi-tenant account entity");
            // Get keys of all accounts belonging to user
            const matchingAccountKeys = this.getAccountKeys().filter((key)=>{
                return key.startsWith(accountEntity.homeAccountId);
            });
            // Get all account entities belonging to user
            const accountsToMerge = [];
            matchingAccountKeys.forEach((key)=>{
                const account = this.getCachedAccountEntity(key, correlationId);
                if (account) accountsToMerge.push(account);
            });
            // Set base account to home account if available, any account if not
            const baseAccount = accountsToMerge.find((account)=>{
                return (0, $2b6041b9fe3f70e1$export$bc62fd222eddc2d7)(account.realm, account.homeAccountId);
            }) || accountsToMerge[0];
            // Populate tenant profiles built from each account entity belonging to the user
            baseAccount.tenantProfiles = accountsToMerge.map((account)=>{
                return {
                    tenantId: account.realm,
                    localAccountId: account.localAccountId,
                    name: account.name,
                    isHomeTenant: (0, $2b6041b9fe3f70e1$export$bc62fd222eddc2d7)(account.realm, account.homeAccountId)
                };
            });
            const updatedAccount = $4ffcb9b8559edbe4$export$996e3ea69314b5c6.toObject(new (0, $35a4414ce05ac30e$export$680160523e6bfa6a)(), {
                ...baseAccount
            });
            const newAccountKey = updatedAccount.generateAccountKey();
            // Clear cache of legacy account objects that have been collpsed into tenant profiles
            matchingAccountKeys.forEach((key)=>{
                if (key !== newAccountKey) this.removeOutdatedAccount(accountKey, correlationId);
            });
            // Cache updated account object
            this.setAccount(updatedAccount, correlationId);
            logger?.verbose("Updated an outdated account entity in the cache");
            return updatedAccount;
        }
        // No update is necessary
        return accountEntity;
    }
    /**
     * returns a boolean if the given credential is removed
     * @param credential
     */ removeAccessToken(key, correlationId) {
        const credential = this.getAccessTokenCredential(key, correlationId);
        this.removeItem(key, correlationId);
        if (!credential || credential.credentialType.toLowerCase() !== (0, $08c107807d753255$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME.toLowerCase() || credential.tokenType !== (0, $08c107807d753255$export$901491a717da2ba5).POP) return;
        // Remove Token Binding Key from key store for PoP Tokens Credentials
        const kid = credential.keyId;
        if (kid) this.cryptoImpl.removeTokenBindingKey(kid).catch(()=>{
            this.commonLogger.error("Binding key could not be removed");
        });
    }
    /**
     * Removes all app metadata objects from cache.
     */ removeAppMetadata(correlationId) {
        const allCacheKeys = this.getKeys();
        allCacheKeys.forEach((cacheKey)=>{
            if (this.isAppMetadata(cacheKey)) this.removeItem(cacheKey, correlationId);
        });
        return true;
    }
    /**
     * Retrieve AccountEntity from cache
     * @param account
     */ readAccountFromCache(account, correlationId) {
        const accountKey = (0, $35a4414ce05ac30e$export$680160523e6bfa6a).generateAccountCacheKey(account);
        return this.getAccount(accountKey, correlationId, this.commonLogger);
    }
    /**
     * Retrieve IdTokenEntity from cache
     * @param account {AccountInfo}
     * @param tokenKeys {?TokenKeys}
     * @param targetRealm {?string}
     * @param performanceClient {?IPerformanceClient}
     * @param correlationId {?string}
     */ getIdToken(account, correlationId, tokenKeys, targetRealm, performanceClient) {
        this.commonLogger.trace("CacheManager - getIdToken called");
        const idTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: (0, $08c107807d753255$export$eca2dc7e6e608a68).ID_TOKEN,
            clientId: this.clientId,
            realm: targetRealm
        };
        const idTokenMap = this.getIdTokensByFilter(idTokenFilter, correlationId, tokenKeys);
        const numIdTokens = idTokenMap.size;
        if (numIdTokens < 1) {
            this.commonLogger.info("CacheManager:getIdToken - No token found");
            return null;
        } else if (numIdTokens > 1) {
            let tokensToBeRemoved = idTokenMap;
            // Multiple tenant profiles and no tenant specified, pick home account
            if (!targetRealm) {
                const homeIdTokenMap = new Map();
                idTokenMap.forEach((idToken, key)=>{
                    if (idToken.realm === account.tenantId) homeIdTokenMap.set(key, idToken);
                });
                const numHomeIdTokens = homeIdTokenMap.size;
                if (numHomeIdTokens < 1) {
                    this.commonLogger.info("CacheManager:getIdToken - Multiple ID tokens found for account but none match account entity tenant id, returning first result");
                    return idTokenMap.values().next().value;
                } else if (numHomeIdTokens === 1) {
                    this.commonLogger.info("CacheManager:getIdToken - Multiple ID tokens found for account, defaulting to home tenant profile");
                    return homeIdTokenMap.values().next().value;
                } else // Multiple ID tokens for home tenant profile, remove all and return null
                tokensToBeRemoved = homeIdTokenMap;
            }
            // Multiple tokens for a single tenant profile, remove all and return null
            this.commonLogger.info("CacheManager:getIdToken - Multiple matching ID tokens found, clearing them");
            tokensToBeRemoved.forEach((idToken, key)=>{
                this.removeIdToken(key, correlationId);
            });
            if (performanceClient && correlationId) performanceClient.addFields({
                multiMatchedID: idTokenMap.size
            }, correlationId);
            return null;
        }
        this.commonLogger.info("CacheManager:getIdToken - Returning ID token");
        return idTokenMap.values().next().value;
    }
    /**
     * Gets all idTokens matching the given filter
     * @param filter
     * @returns
     */ getIdTokensByFilter(filter, correlationId, tokenKeys) {
        const idTokenKeys = tokenKeys && tokenKeys.idToken || this.getTokenKeys().idToken;
        const idTokens = new Map();
        idTokenKeys.forEach((key)=>{
            if (!this.idTokenKeyMatchesFilter(key, {
                clientId: this.clientId,
                ...filter
            })) return;
            const idToken = this.getIdTokenCredential(key, correlationId);
            if (idToken && this.credentialMatchesFilter(idToken, filter)) idTokens.set(key, idToken);
        });
        return idTokens;
    }
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     * @returns
     */ idTokenKeyMatchesFilter(inputKey, filter) {
        const key = inputKey.toLowerCase();
        if (filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        return true;
    }
    /**
     * Removes idToken from the cache
     * @param key
     */ removeIdToken(key, correlationId) {
        this.removeItem(key, correlationId);
    }
    /**
     * Removes refresh token from the cache
     * @param key
     */ removeRefreshToken(key, correlationId) {
        this.removeItem(key, correlationId);
    }
    /**
     * Retrieve AccessTokenEntity from cache
     * @param account {AccountInfo}
     * @param request {BaseAuthRequest}
     * @param tokenKeys {?TokenKeys}
     * @param performanceClient {?IPerformanceClient}
     * @param correlationId {?string}
     */ getAccessToken(account, request, tokenKeys, targetRealm, performanceClient) {
        this.commonLogger.trace("CacheManager - getAccessToken called");
        const scopes = (0, $d671ba25592fe375$export$b9b82b0f94ae1f99).createSearchScopes(request.scopes);
        const authScheme = request.authenticationScheme || (0, $08c107807d753255$export$901491a717da2ba5).BEARER;
        /*
         * Distinguish between Bearer and PoP/SSH token cache types
         * Cast to lowercase to handle "bearer" from ADFS
         */ const credentialType = authScheme && authScheme.toLowerCase() !== (0, $08c107807d753255$export$901491a717da2ba5).BEARER.toLowerCase() ? (0, $08c107807d753255$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME : (0, $08c107807d753255$export$eca2dc7e6e608a68).ACCESS_TOKEN;
        const accessTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: credentialType,
            clientId: this.clientId,
            realm: targetRealm || account.tenantId,
            target: scopes,
            tokenType: authScheme,
            keyId: request.sshKid,
            requestedClaimsHash: request.requestedClaimsHash
        };
        const accessTokenKeys = tokenKeys && tokenKeys.accessToken || this.getTokenKeys().accessToken;
        const accessTokens = [];
        accessTokenKeys.forEach((key)=>{
            // Validate key
            if (this.accessTokenKeyMatchesFilter(key, accessTokenFilter, true)) {
                const accessToken = this.getAccessTokenCredential(key, request.correlationId);
                // Validate value
                if (accessToken && this.credentialMatchesFilter(accessToken, accessTokenFilter)) accessTokens.push(accessToken);
            }
        });
        const numAccessTokens = accessTokens.length;
        if (numAccessTokens < 1) {
            this.commonLogger.info("CacheManager:getAccessToken - No token found");
            return null;
        } else if (numAccessTokens > 1) {
            this.commonLogger.info("CacheManager:getAccessToken - Multiple access tokens found, clearing them");
            accessTokens.forEach((accessToken)=>{
                this.removeAccessToken((0, $bd840ab348a8e6dd$export$1aaa1362083ec7a3)(accessToken), request.correlationId);
            });
            if (performanceClient && request.correlationId) performanceClient.addFields({
                multiMatchedAT: accessTokens.length
            }, request.correlationId);
            return null;
        }
        this.commonLogger.info("CacheManager:getAccessToken - Returning access token");
        return accessTokens[0];
    }
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     * @param keyMustContainAllScopes
     * @returns
     */ accessTokenKeyMatchesFilter(inputKey, filter, keyMustContainAllScopes) {
        const key = inputKey.toLowerCase();
        if (filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        if (filter.realm && key.indexOf(filter.realm.toLowerCase()) === -1) return false;
        if (filter.requestedClaimsHash && key.indexOf(filter.requestedClaimsHash.toLowerCase()) === -1) return false;
        if (filter.target) {
            const scopes = filter.target.asArray();
            for(let i = 0; i < scopes.length; i++){
                if (keyMustContainAllScopes && !key.includes(scopes[i].toLowerCase())) // When performing a cache lookup a missing scope would be a cache miss
                return false;
                else if (!keyMustContainAllScopes && key.includes(scopes[i].toLowerCase())) // When performing a cache write, any token with a subset of requested scopes should be replaced
                return true;
            }
        }
        return true;
    }
    /**
     * Gets all access tokens matching the filter
     * @param filter
     * @returns
     */ getAccessTokensByFilter(filter, correlationId) {
        const tokenKeys = this.getTokenKeys();
        const accessTokens = [];
        tokenKeys.accessToken.forEach((key)=>{
            if (!this.accessTokenKeyMatchesFilter(key, filter, true)) return;
            const accessToken = this.getAccessTokenCredential(key, correlationId);
            if (accessToken && this.credentialMatchesFilter(accessToken, filter)) accessTokens.push(accessToken);
        });
        return accessTokens;
    }
    /**
     * Helper to retrieve the appropriate refresh token from cache
     * @param account {AccountInfo}
     * @param familyRT {boolean}
     * @param tokenKeys {?TokenKeys}
     * @param performanceClient {?IPerformanceClient}
     * @param correlationId {?string}
     */ getRefreshToken(account, familyRT, correlationId, tokenKeys, performanceClient) {
        this.commonLogger.trace("CacheManager - getRefreshToken called");
        const id = familyRT ? (0, $08c107807d753255$export$978fe7ab5e74b539) : undefined;
        const refreshTokenFilter = {
            homeAccountId: account.homeAccountId,
            environment: account.environment,
            credentialType: (0, $08c107807d753255$export$eca2dc7e6e608a68).REFRESH_TOKEN,
            clientId: this.clientId,
            familyId: id
        };
        const refreshTokenKeys = tokenKeys && tokenKeys.refreshToken || this.getTokenKeys().refreshToken;
        const refreshTokens = [];
        refreshTokenKeys.forEach((key)=>{
            // Validate key
            if (this.refreshTokenKeyMatchesFilter(key, refreshTokenFilter)) {
                const refreshToken = this.getRefreshTokenCredential(key, correlationId);
                // Validate value
                if (refreshToken && this.credentialMatchesFilter(refreshToken, refreshTokenFilter)) refreshTokens.push(refreshToken);
            }
        });
        const numRefreshTokens = refreshTokens.length;
        if (numRefreshTokens < 1) {
            this.commonLogger.info("CacheManager:getRefreshToken - No refresh token found.");
            return null;
        }
        // address the else case after remove functions address environment aliases
        if (numRefreshTokens > 1 && performanceClient && correlationId) performanceClient.addFields({
            multiMatchedRT: numRefreshTokens
        }, correlationId);
        this.commonLogger.info("CacheManager:getRefreshToken - returning refresh token");
        return refreshTokens[0];
    }
    /**
     * Validate the cache key against filter before retrieving and parsing cache value
     * @param key
     * @param filter
     */ refreshTokenKeyMatchesFilter(inputKey, filter) {
        const key = inputKey.toLowerCase();
        if (filter.familyId && key.indexOf(filter.familyId.toLowerCase()) === -1) return false;
        // If familyId is used, clientId is not in the key
        if (!filter.familyId && filter.clientId && key.indexOf(filter.clientId.toLowerCase()) === -1) return false;
        if (filter.homeAccountId && key.indexOf(filter.homeAccountId.toLowerCase()) === -1) return false;
        return true;
    }
    /**
     * Retrieve AppMetadataEntity from cache
     */ readAppMetadataFromCache(environment) {
        const appMetadataFilter = {
            environment: environment,
            clientId: this.clientId
        };
        const appMetadata = this.getAppMetadataFilteredBy(appMetadataFilter);
        const appMetadataEntries = Object.keys(appMetadata).map((key)=>appMetadata[key]);
        const numAppMetadata = appMetadataEntries.length;
        if (numAppMetadata < 1) return null;
        else if (numAppMetadata > 1) throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$575bb2924bcd0084));
        return appMetadataEntries[0];
    }
    /**
     * Return the family_id value associated  with FOCI
     * @param environment
     * @param clientId
     */ isAppMetadataFOCI(environment) {
        const appMetadata = this.readAppMetadataFromCache(environment);
        return !!(appMetadata && appMetadata.familyId === (0, $08c107807d753255$export$978fe7ab5e74b539));
    }
    /**
     * helper to match account ids
     * @param value
     * @param homeAccountId
     */ matchHomeAccountId(entity, homeAccountId) {
        return !!(typeof entity.homeAccountId === "string" && homeAccountId === entity.homeAccountId);
    }
    /**
     * helper to match account ids
     * @param entity
     * @param localAccountId
     * @returns
     */ matchLocalAccountIdFromTokenClaims(tokenClaims, localAccountId) {
        const idTokenLocalAccountId = tokenClaims.oid || tokenClaims.sub;
        return localAccountId === idTokenLocalAccountId;
    }
    matchLocalAccountIdFromTenantProfile(tenantProfile, localAccountId) {
        return tenantProfile.localAccountId === localAccountId;
    }
    /**
     * helper to match names
     * @param entity
     * @param name
     * @returns true if the downcased name properties are present and match in the filter and the entity
     */ matchName(claims, name) {
        return !!(name.toLowerCase() === claims.name?.toLowerCase());
    }
    /**
     * helper to match usernames
     * @param entity
     * @param username
     * @returns
     */ matchUsername(cachedUsername, filterUsername) {
        return !!(cachedUsername && typeof cachedUsername === "string" && filterUsername?.toLowerCase() === cachedUsername.toLowerCase());
    }
    /**
     * helper to match assertion
     * @param value
     * @param oboAssertion
     */ matchUserAssertionHash(entity, userAssertionHash) {
        return !!(entity.userAssertionHash && userAssertionHash === entity.userAssertionHash);
    }
    /**
     * helper to match environment
     * @param value
     * @param environment
     */ matchEnvironment(entity, environment) {
        // Check static authority options first for cases where authority metadata has not been resolved and cached yet
        if (this.staticAuthorityOptions) {
            const staticAliases = (0, $1d18a42dbb0c24e8$export$2c21adf4b4d4efc0)(this.staticAuthorityOptions, this.commonLogger);
            if (staticAliases.includes(environment) && staticAliases.includes(entity.environment)) return true;
        }
        // Query metadata cache if no static authority configuration has aliases that match enviroment
        const cloudMetadata = this.getAuthorityMetadataByAlias(environment);
        if (cloudMetadata && cloudMetadata.aliases.indexOf(entity.environment) > -1) return true;
        return false;
    }
    /**
     * helper to match credential type
     * @param entity
     * @param credentialType
     */ matchCredentialType(entity, credentialType) {
        return entity.credentialType && credentialType.toLowerCase() === entity.credentialType.toLowerCase();
    }
    /**
     * helper to match client ids
     * @param entity
     * @param clientId
     */ matchClientId(entity, clientId) {
        return !!(entity.clientId && clientId === entity.clientId);
    }
    /**
     * helper to match family ids
     * @param entity
     * @param familyId
     */ matchFamilyId(entity, familyId) {
        return !!(entity.familyId && familyId === entity.familyId);
    }
    /**
     * helper to match realm
     * @param entity
     * @param realm
     */ matchRealm(entity, realm) {
        return !!(entity.realm?.toLowerCase() === realm.toLowerCase());
    }
    /**
     * helper to match nativeAccountId
     * @param entity
     * @param nativeAccountId
     * @returns boolean indicating the match result
     */ matchNativeAccountId(entity, nativeAccountId) {
        return !!(entity.nativeAccountId && nativeAccountId === entity.nativeAccountId);
    }
    /**
     * helper to match loginHint which can be either:
     * 1. login_hint ID token claim
     * 2. username in cached account object
     * 3. upn in ID token claims
     * @param entity
     * @param loginHint
     * @returns
     */ matchLoginHintFromTokenClaims(tokenClaims, loginHint) {
        if (tokenClaims.login_hint === loginHint) return true;
        if (tokenClaims.preferred_username === loginHint) return true;
        if (tokenClaims.upn === loginHint) return true;
        return false;
    }
    /**
     * Helper to match sid
     * @param entity
     * @param sid
     * @returns true if the sid claim is present and matches the filter
     */ matchSid(idTokenClaims, sid) {
        return idTokenClaims.sid === sid;
    }
    matchAuthorityType(entity, authorityType) {
        return !!(entity.authorityType && authorityType.toLowerCase() === entity.authorityType.toLowerCase());
    }
    /**
     * Returns true if the target scopes are a subset of the current entity's scopes, false otherwise.
     * @param entity
     * @param target
     */ matchTarget(entity, target) {
        const isNotAccessTokenCredential = entity.credentialType !== (0, $08c107807d753255$export$eca2dc7e6e608a68).ACCESS_TOKEN && entity.credentialType !== (0, $08c107807d753255$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME;
        if (isNotAccessTokenCredential || !entity.target) return false;
        const entityScopeSet = (0, $d671ba25592fe375$export$b9b82b0f94ae1f99).fromString(entity.target);
        return entityScopeSet.containsScopeSet(target);
    }
    /**
     * Returns true if the credential's tokenType or Authentication Scheme matches the one in the request, false otherwise
     * @param entity
     * @param tokenType
     */ matchTokenType(entity, tokenType) {
        return !!(entity.tokenType && entity.tokenType === tokenType);
    }
    /**
     * Returns true if the credential's keyId matches the one in the request, false otherwise
     * @param entity
     * @param keyId
     */ matchKeyId(entity, keyId) {
        return !!(entity.keyId && entity.keyId === keyId);
    }
    /**
     * returns if a given cache entity is of the type appmetadata
     * @param key
     */ isAppMetadata(key) {
        return key.indexOf((0, $08c107807d753255$export$7e1bea6dc1b6b32e)) !== -1;
    }
    /**
     * returns if a given cache entity is of the type authoritymetadata
     * @param key
     */ isAuthorityMetadata(key) {
        return key.indexOf((0, $08c107807d753255$export$d483f966e66f4db5).CACHE_KEY) !== -1;
    }
    /**
     * returns cache key used for cloud instance metadata
     */ generateAuthorityMetadataCacheKey(authority) {
        return `${(0, $08c107807d753255$export$d483f966e66f4db5).CACHE_KEY}-${this.clientId}-${authority}`;
    }
    /**
     * Helper to convert serialized data to object
     * @param obj
     * @param json
     */ static toObject(obj, json) {
        for(const propertyName in json)obj[propertyName] = json[propertyName];
        return obj;
    }
}
/** @internal */ class $4ffcb9b8559edbe4$export$b7254d304b3004b6 extends $4ffcb9b8559edbe4$export$996e3ea69314b5c6 {
    setAccount() {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    }
    getAccount() {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    }
    getCachedAccountEntity() {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    }
    setIdTokenCredential() {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    }
    getIdTokenCredential() {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    }
    setAccessTokenCredential() {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    }
    getAccessTokenCredential() {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    }
    setRefreshTokenCredential() {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    }
    getRefreshTokenCredential() {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    }
    setAppMetadata() {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    }
    getAppMetadata() {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    }
    setServerTelemetry() {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    }
    getServerTelemetry() {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    }
    setAuthorityMetadata() {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    }
    getAuthorityMetadata() {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    }
    getAuthorityMetadataKeys() {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    }
    setThrottlingCache() {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    }
    getThrottlingCache() {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    }
    removeItem() {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    }
    getKeys() {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    }
    getAccountKeys() {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    }
    getTokenKeys() {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    }
    updateCredentialCacheKey() {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    }
    removeOutdatedAccount() {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    }
}





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $44a243886d8c290a$export$f7a7dd6bfc156d75 = {
    tokenRenewalOffsetSeconds: (0, $08c107807d753255$export$8d50f42618161d1a),
    preventCorsPreflight: false
};
const $44a243886d8c290a$var$DEFAULT_LOGGER_IMPLEMENTATION = {
    loggerCallback: ()=>{
    // allow users to not set loggerCallback
    },
    piiLoggingEnabled: false,
    logLevel: (0, $4643cd557adfd6d5$export$243e62d78d3b544d).Info,
    correlationId: (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING
};
const $44a243886d8c290a$var$DEFAULT_CACHE_OPTIONS = {
    claimsBasedCachingEnabled: false
};
const $44a243886d8c290a$var$DEFAULT_NETWORK_IMPLEMENTATION = {
    async sendGetRequestAsync () {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    },
    async sendPostRequestAsync () {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22));
    }
};
const $44a243886d8c290a$var$DEFAULT_LIBRARY_INFO = {
    sku: (0, $08c107807d753255$export$a002182e51710d39).SKU,
    version: (0, $a15c066c8ddfab99$export$83d89fbfd8236492),
    cpu: (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING,
    os: (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING
};
const $44a243886d8c290a$var$DEFAULT_CLIENT_CREDENTIALS = {
    clientSecret: (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING,
    clientAssertion: undefined
};
const $44a243886d8c290a$var$DEFAULT_AZURE_CLOUD_OPTIONS = {
    azureCloudInstance: (0, $7ae45af95b45dab9$export$4cda21933050d9ec).None,
    tenant: `${(0, $08c107807d753255$export$a002182e51710d39).DEFAULT_COMMON_TENANT}`
};
const $44a243886d8c290a$var$DEFAULT_TELEMETRY_OPTIONS = {
    application: {
        appName: "",
        appVersion: ""
    }
};
/**
 * Function that sets the default options when not explicitly configured from app developer
 *
 * @param Configuration
 *
 * @returns Configuration
 */ function $44a243886d8c290a$export$57a091701dcdabb2({ authOptions: userAuthOptions, systemOptions: userSystemOptions, loggerOptions: userLoggerOption, cacheOptions: userCacheOptions, storageInterface: storageImplementation, networkInterface: networkImplementation, cryptoInterface: cryptoImplementation, clientCredentials: clientCredentials, libraryInfo: libraryInfo, telemetry: telemetry, serverTelemetryManager: serverTelemetryManager, persistencePlugin: persistencePlugin, serializableCache: serializableCache }) {
    const loggerOptions = {
        ...$44a243886d8c290a$var$DEFAULT_LOGGER_IMPLEMENTATION,
        ...userLoggerOption
    };
    return {
        authOptions: $44a243886d8c290a$var$buildAuthOptions(userAuthOptions),
        systemOptions: {
            ...$44a243886d8c290a$export$f7a7dd6bfc156d75,
            ...userSystemOptions
        },
        loggerOptions: loggerOptions,
        cacheOptions: {
            ...$44a243886d8c290a$var$DEFAULT_CACHE_OPTIONS,
            ...userCacheOptions
        },
        storageInterface: storageImplementation || new (0, $4ffcb9b8559edbe4$export$b7254d304b3004b6)(userAuthOptions.clientId, (0, $f03a022fda639465$export$865f57d401606752), new (0, $4643cd557adfd6d5$export$efa9a398d6368992)(loggerOptions)),
        networkInterface: networkImplementation || $44a243886d8c290a$var$DEFAULT_NETWORK_IMPLEMENTATION,
        cryptoInterface: cryptoImplementation || (0, $f03a022fda639465$export$865f57d401606752),
        clientCredentials: clientCredentials || $44a243886d8c290a$var$DEFAULT_CLIENT_CREDENTIALS,
        libraryInfo: {
            ...$44a243886d8c290a$var$DEFAULT_LIBRARY_INFO,
            ...libraryInfo
        },
        telemetry: {
            ...$44a243886d8c290a$var$DEFAULT_TELEMETRY_OPTIONS,
            ...telemetry
        },
        serverTelemetryManager: serverTelemetryManager || null,
        persistencePlugin: persistencePlugin || null,
        serializableCache: serializableCache || null
    };
}
/**
 * Construct authoptions from the client and platform passed values
 * @param authOptions
 */ function $44a243886d8c290a$var$buildAuthOptions(authOptions) {
    return {
        clientCapabilities: [],
        azureCloudOptions: $44a243886d8c290a$var$DEFAULT_AZURE_CLOUD_OPTIONS,
        skipAuthorityMetadataCache: false,
        instanceAware: false,
        ...authOptions
    };
}
/**
 * Returns true if config has protocolMode set to ProtocolMode.OIDC, false otherwise
 * @param ClientConfiguration
 */ function $44a243886d8c290a$export$25afa7198c2ed9b9(config) {
    return config.authOptions.authority.options.protocolMode === (0, $a47d2ec0503d310c$export$73a3e3dedd37150d).OIDC;
}

/*! @azure/msal-common v14.16.1 2025-08-05 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $3957fd5ca920db1c$export$6d95060a8ed7155a = {
    sendGetRequestAsync: ()=>{
        return Promise.reject((0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22)));
    },
    sendPostRequestAsync: ()=>{
        return Promise.reject((0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$24176fc1f15eea22)));
    }
};

/*! @azure/msal-common v14.16.1 2025-08-05 */ /*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Enumeration of operations that are instrumented by have their performance measured by the PerformanceClient.
 *
 * @export
 * @enum {number}
 */ const $32170abc11155933$export$2f2811a3e1b21823 = {
    /**
     * acquireTokenByCode API (msal-browser and msal-node).
     * Used to acquire tokens by trading an authorization code against the token endpoint.
     */ AcquireTokenByCode: "acquireTokenByCode",
    /**
     * acquireTokenByRefreshToken API (msal-browser and msal-node).
     * Used to renew an access token using a refresh token against the token endpoint.
     */ AcquireTokenByRefreshToken: "acquireTokenByRefreshToken",
    /**
     * acquireTokenSilent API (msal-browser and msal-node).
     * Used to silently acquire a new access token (from the cache or the network).
     */ AcquireTokenSilent: "acquireTokenSilent",
    /**
     * acquireTokenSilentAsync (msal-browser).
     * Internal API for acquireTokenSilent.
     */ AcquireTokenSilentAsync: "acquireTokenSilentAsync",
    /**
     * acquireTokenPopup (msal-browser).
     * Used to acquire a new access token interactively through pop ups
     */ AcquireTokenPopup: "acquireTokenPopup",
    /**
     * acquireTokenPreRedirect (msal-browser).
     * First part of the redirect flow.
     * Used to acquire a new access token interactively through redirects.
     */ AcquireTokenPreRedirect: "acquireTokenPreRedirect",
    /**
     * acquireTokenRedirect (msal-browser).
     * Second part of the redirect flow.
     * Used to acquire a new access token interactively through redirects.
     */ AcquireTokenRedirect: "acquireTokenRedirect",
    /**
     * getPublicKeyThumbprint API in CryptoOpts class (msal-browser).
     * Used to generate a public/private keypair and generate a public key thumbprint for pop requests.
     */ CryptoOptsGetPublicKeyThumbprint: "cryptoOptsGetPublicKeyThumbprint",
    /**
     * signJwt API in CryptoOpts class (msal-browser).
     * Used to signed a pop token.
     */ CryptoOptsSignJwt: "cryptoOptsSignJwt",
    /**
     * acquireToken API in the SilentCacheClient class (msal-browser).
     * Used to read access tokens from the cache.
     */ SilentCacheClientAcquireToken: "silentCacheClientAcquireToken",
    /**
     * acquireToken API in the SilentIframeClient class (msal-browser).
     * Used to acquire a new set of tokens from the authorize endpoint in a hidden iframe.
     */ SilentIframeClientAcquireToken: "silentIframeClientAcquireToken",
    AwaitConcurrentIframe: "awaitConcurrentIframe",
    /**
     * acquireToken API in SilentRereshClient (msal-browser).
     * Used to acquire a new set of tokens from the token endpoint using a refresh token.
     */ SilentRefreshClientAcquireToken: "silentRefreshClientAcquireToken",
    /**
     * ssoSilent API (msal-browser).
     * Used to silently acquire an authorization code and set of tokens using a hidden iframe.
     */ SsoSilent: "ssoSilent",
    /**
     * getDiscoveredAuthority API in StandardInteractionClient class (msal-browser).
     * Used to load authority metadata for a request.
     */ StandardInteractionClientGetDiscoveredAuthority: "standardInteractionClientGetDiscoveredAuthority",
    /**
     * acquireToken APIs in msal-browser.
     * Used to make an /authorize endpoint call with native brokering enabled.
     */ FetchAccountIdWithNativeBroker: "fetchAccountIdWithNativeBroker",
    /**
     * acquireToken API in NativeInteractionClient class (msal-browser).
     * Used to acquire a token from Native component when native brokering is enabled.
     */ NativeInteractionClientAcquireToken: "nativeInteractionClientAcquireToken",
    /**
     * Time spent creating default headers for requests to token endpoint
     */ BaseClientCreateTokenRequestHeaders: "baseClientCreateTokenRequestHeaders",
    /**
     * Time spent sending/waiting for the response of a request to the token endpoint
     */ NetworkClientSendPostRequestAsync: "networkClientSendPostRequestAsync",
    RefreshTokenClientExecutePostToTokenEndpoint: "refreshTokenClientExecutePostToTokenEndpoint",
    AuthorizationCodeClientExecutePostToTokenEndpoint: "authorizationCodeClientExecutePostToTokenEndpoint",
    /**
     * Used to measure the time taken for completing embedded-broker handshake (PW-Broker).
     */ BrokerHandhshake: "brokerHandshake",
    /**
     * acquireTokenByRefreshToken API in BrokerClientApplication (PW-Broker) .
     */ AcquireTokenByRefreshTokenInBroker: "acquireTokenByRefreshTokenInBroker",
    /**
     * Time taken for token acquisition by broker
     */ AcquireTokenByBroker: "acquireTokenByBroker",
    /**
     * Time spent on the network for refresh token acquisition
     */ RefreshTokenClientExecuteTokenRequest: "refreshTokenClientExecuteTokenRequest",
    /**
     * Time taken for acquiring refresh token , records RT size
     */ RefreshTokenClientAcquireToken: "refreshTokenClientAcquireToken",
    /**
     * Time taken for acquiring cached refresh token
     */ RefreshTokenClientAcquireTokenWithCachedRefreshToken: "refreshTokenClientAcquireTokenWithCachedRefreshToken",
    /**
     * acquireTokenByRefreshToken API in RefreshTokenClient (msal-common).
     */ RefreshTokenClientAcquireTokenByRefreshToken: "refreshTokenClientAcquireTokenByRefreshToken",
    /**
     * Helper function to create token request body in RefreshTokenClient (msal-common).
     */ RefreshTokenClientCreateTokenRequestBody: "refreshTokenClientCreateTokenRequestBody",
    /**
     * acquireTokenFromCache (msal-browser).
     * Internal API for acquiring token from cache
     */ AcquireTokenFromCache: "acquireTokenFromCache",
    SilentFlowClientAcquireCachedToken: "silentFlowClientAcquireCachedToken",
    SilentFlowClientGenerateResultFromCacheRecord: "silentFlowClientGenerateResultFromCacheRecord",
    /**
     * acquireTokenBySilentIframe (msal-browser).
     * Internal API for acquiring token by silent Iframe
     */ AcquireTokenBySilentIframe: "acquireTokenBySilentIframe",
    /**
     * Internal API for initializing base request in BaseInteractionClient (msal-browser)
     */ InitializeBaseRequest: "initializeBaseRequest",
    /**
     * Internal API for initializing silent request in SilentCacheClient (msal-browser)
     */ InitializeSilentRequest: "initializeSilentRequest",
    InitializeClientApplication: "initializeClientApplication",
    /**
     * Helper function in SilentIframeClient class (msal-browser).
     */ SilentIframeClientTokenHelper: "silentIframeClientTokenHelper",
    /**
     * SilentHandler
     */ SilentHandlerInitiateAuthRequest: "silentHandlerInitiateAuthRequest",
    SilentHandlerMonitorIframeForHash: "silentHandlerMonitorIframeForHash",
    SilentHandlerLoadFrame: "silentHandlerLoadFrame",
    SilentHandlerLoadFrameSync: "silentHandlerLoadFrameSync",
    /**
     * Helper functions in StandardInteractionClient class (msal-browser)
     */ StandardInteractionClientCreateAuthCodeClient: "standardInteractionClientCreateAuthCodeClient",
    StandardInteractionClientGetClientConfiguration: "standardInteractionClientGetClientConfiguration",
    StandardInteractionClientInitializeAuthorizationRequest: "standardInteractionClientInitializeAuthorizationRequest",
    StandardInteractionClientInitializeAuthorizationCodeRequest: "standardInteractionClientInitializeAuthorizationCodeRequest",
    /**
     * getAuthCodeUrl API (msal-browser and msal-node).
     */ GetAuthCodeUrl: "getAuthCodeUrl",
    /**
     * Functions from InteractionHandler (msal-browser)
     */ HandleCodeResponseFromServer: "handleCodeResponseFromServer",
    HandleCodeResponse: "handleCodeResponse",
    UpdateTokenEndpointAuthority: "updateTokenEndpointAuthority",
    /**
     * APIs in Authorization Code Client (msal-common)
     */ AuthClientAcquireToken: "authClientAcquireToken",
    AuthClientExecuteTokenRequest: "authClientExecuteTokenRequest",
    AuthClientCreateTokenRequestBody: "authClientCreateTokenRequestBody",
    AuthClientCreateQueryString: "authClientCreateQueryString",
    /**
     * Generate functions in PopTokenGenerator (msal-common)
     */ PopTokenGenerateCnf: "popTokenGenerateCnf",
    PopTokenGenerateKid: "popTokenGenerateKid",
    /**
     * handleServerTokenResponse API in ResponseHandler (msal-common)
     */ HandleServerTokenResponse: "handleServerTokenResponse",
    DeserializeResponse: "deserializeResponse",
    /**
     * Authority functions
     */ AuthorityFactoryCreateDiscoveredInstance: "authorityFactoryCreateDiscoveredInstance",
    AuthorityResolveEndpointsAsync: "authorityResolveEndpointsAsync",
    AuthorityResolveEndpointsFromLocalSources: "authorityResolveEndpointsFromLocalSources",
    AuthorityGetCloudDiscoveryMetadataFromNetwork: "authorityGetCloudDiscoveryMetadataFromNetwork",
    AuthorityUpdateCloudDiscoveryMetadata: "authorityUpdateCloudDiscoveryMetadata",
    AuthorityGetEndpointMetadataFromNetwork: "authorityGetEndpointMetadataFromNetwork",
    AuthorityUpdateEndpointMetadata: "authorityUpdateEndpointMetadata",
    AuthorityUpdateMetadataWithRegionalInformation: "authorityUpdateMetadataWithRegionalInformation",
    /**
     * Region Discovery functions
     */ RegionDiscoveryDetectRegion: "regionDiscoveryDetectRegion",
    RegionDiscoveryGetRegionFromIMDS: "regionDiscoveryGetRegionFromIMDS",
    RegionDiscoveryGetCurrentVersion: "regionDiscoveryGetCurrentVersion",
    AcquireTokenByCodeAsync: "acquireTokenByCodeAsync",
    GetEndpointMetadataFromNetwork: "getEndpointMetadataFromNetwork",
    GetCloudDiscoveryMetadataFromNetworkMeasurement: "getCloudDiscoveryMetadataFromNetworkMeasurement",
    HandleRedirectPromiseMeasurement: "handleRedirectPromise",
    HandleNativeRedirectPromiseMeasurement: "handleNativeRedirectPromise",
    UpdateCloudDiscoveryMetadataMeasurement: "updateCloudDiscoveryMetadataMeasurement",
    UsernamePasswordClientAcquireToken: "usernamePasswordClientAcquireToken",
    NativeMessageHandlerHandshake: "nativeMessageHandlerHandshake",
    NativeGenerateAuthResult: "nativeGenerateAuthResult",
    RemoveHiddenIframe: "removeHiddenIframe",
    /**
     * Cache operations
     */ ClearTokensAndKeysWithClaims: "clearTokensAndKeysWithClaims",
    CacheManagerGetRefreshToken: "cacheManagerGetRefreshToken",
    /**
     * Crypto Operations
     */ GeneratePkceCodes: "generatePkceCodes",
    GenerateCodeVerifier: "generateCodeVerifier",
    GenerateCodeChallengeFromVerifier: "generateCodeChallengeFromVerifier",
    Sha256Digest: "sha256Digest",
    GetRandomValues: "getRandomValues"
};
const $32170abc11155933$export$8dc198b6eb7c4c72 = new Map([
    [
        $32170abc11155933$export$2f2811a3e1b21823.AcquireTokenByCode,
        "ATByCode"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.AcquireTokenByRefreshToken,
        "ATByRT"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.AcquireTokenSilent,
        "ATS"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.AcquireTokenSilentAsync,
        "ATSAsync"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.AcquireTokenPopup,
        "ATPopup"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.AcquireTokenRedirect,
        "ATRedirect"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.CryptoOptsGetPublicKeyThumbprint,
        "CryptoGetPKThumb"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.CryptoOptsSignJwt,
        "CryptoSignJwt"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.SilentCacheClientAcquireToken,
        "SltCacheClientAT"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.SilentIframeClientAcquireToken,
        "SltIframeClientAT"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.SilentRefreshClientAcquireToken,
        "SltRClientAT"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.SsoSilent,
        "SsoSlt"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.StandardInteractionClientGetDiscoveredAuthority,
        "StdIntClientGetDiscAuth"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.FetchAccountIdWithNativeBroker,
        "FetchAccIdWithNtvBroker"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.NativeInteractionClientAcquireToken,
        "NtvIntClientAT"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.BaseClientCreateTokenRequestHeaders,
        "BaseClientCreateTReqHead"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.NetworkClientSendPostRequestAsync,
        "NetClientSendPost"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.RefreshTokenClientExecutePostToTokenEndpoint,
        "RTClientExecPost"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.AuthorizationCodeClientExecutePostToTokenEndpoint,
        "AuthCodeClientExecPost"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.BrokerHandhshake,
        "BrokerHandshake"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.AcquireTokenByRefreshTokenInBroker,
        "ATByRTInBroker"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.AcquireTokenByBroker,
        "ATByBroker"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.RefreshTokenClientExecuteTokenRequest,
        "RTClientExecTReq"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.RefreshTokenClientAcquireToken,
        "RTClientAT"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.RefreshTokenClientAcquireTokenWithCachedRefreshToken,
        "RTClientATWithCachedRT"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.RefreshTokenClientAcquireTokenByRefreshToken,
        "RTClientATByRT"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.RefreshTokenClientCreateTokenRequestBody,
        "RTClientCreateTReqBody"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.AcquireTokenFromCache,
        "ATFromCache"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.SilentFlowClientAcquireCachedToken,
        "SltFlowClientATCached"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.SilentFlowClientGenerateResultFromCacheRecord,
        "SltFlowClientGenResFromCache"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.AcquireTokenBySilentIframe,
        "ATBySltIframe"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.InitializeBaseRequest,
        "InitBaseReq"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.InitializeSilentRequest,
        "InitSltReq"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.InitializeClientApplication,
        "InitClientApplication"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.SilentIframeClientTokenHelper,
        "SIClientTHelper"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.SilentHandlerInitiateAuthRequest,
        "SHandlerInitAuthReq"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.SilentHandlerMonitorIframeForHash,
        "SltHandlerMonitorIframeForHash"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.SilentHandlerLoadFrame,
        "SHandlerLoadFrame"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.SilentHandlerLoadFrameSync,
        "SHandlerLoadFrameSync"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.StandardInteractionClientCreateAuthCodeClient,
        "StdIntClientCreateAuthCodeClient"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.StandardInteractionClientGetClientConfiguration,
        "StdIntClientGetClientConf"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.StandardInteractionClientInitializeAuthorizationRequest,
        "StdIntClientInitAuthReq"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.StandardInteractionClientInitializeAuthorizationCodeRequest,
        "StdIntClientInitAuthCodeReq"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.GetAuthCodeUrl,
        "GetAuthCodeUrl"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.HandleCodeResponseFromServer,
        "HandleCodeResFromServer"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.HandleCodeResponse,
        "HandleCodeResp"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.UpdateTokenEndpointAuthority,
        "UpdTEndpointAuth"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.AuthClientAcquireToken,
        "AuthClientAT"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.AuthClientExecuteTokenRequest,
        "AuthClientExecTReq"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.AuthClientCreateTokenRequestBody,
        "AuthClientCreateTReqBody"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.AuthClientCreateQueryString,
        "AuthClientCreateQueryStr"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.PopTokenGenerateCnf,
        "PopTGenCnf"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.PopTokenGenerateKid,
        "PopTGenKid"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.HandleServerTokenResponse,
        "HandleServerTRes"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.DeserializeResponse,
        "DeserializeRes"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.AuthorityFactoryCreateDiscoveredInstance,
        "AuthFactCreateDiscInst"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.AuthorityResolveEndpointsAsync,
        "AuthResolveEndpointsAsync"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.AuthorityResolveEndpointsFromLocalSources,
        "AuthResolveEndpointsFromLocal"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.AuthorityGetCloudDiscoveryMetadataFromNetwork,
        "AuthGetCDMetaFromNet"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.AuthorityUpdateCloudDiscoveryMetadata,
        "AuthUpdCDMeta"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.AuthorityGetEndpointMetadataFromNetwork,
        "AuthUpdCDMetaFromNet"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.AuthorityUpdateEndpointMetadata,
        "AuthUpdEndpointMeta"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.AuthorityUpdateMetadataWithRegionalInformation,
        "AuthUpdMetaWithRegInfo"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.RegionDiscoveryDetectRegion,
        "RegDiscDetectReg"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.RegionDiscoveryGetRegionFromIMDS,
        "RegDiscGetRegFromIMDS"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.RegionDiscoveryGetCurrentVersion,
        "RegDiscGetCurrentVer"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.AcquireTokenByCodeAsync,
        "ATByCodeAsync"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.GetEndpointMetadataFromNetwork,
        "GetEndpointMetaFromNet"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.GetCloudDiscoveryMetadataFromNetworkMeasurement,
        "GetCDMetaFromNet"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.HandleRedirectPromiseMeasurement,
        "HandleRedirectPromise"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.HandleNativeRedirectPromiseMeasurement,
        "HandleNtvRedirectPromise"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.UpdateCloudDiscoveryMetadataMeasurement,
        "UpdateCDMeta"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.UsernamePasswordClientAcquireToken,
        "UserPassClientAT"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.NativeMessageHandlerHandshake,
        "NtvMsgHandlerHandshake"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.NativeGenerateAuthResult,
        "NtvGenAuthRes"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.RemoveHiddenIframe,
        "RemoveHiddenIframe"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.ClearTokensAndKeysWithClaims,
        "ClearTAndKeysWithClaims"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.CacheManagerGetRefreshToken,
        "CacheManagerGetRT"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.GeneratePkceCodes,
        "GenPkceCodes"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.GenerateCodeVerifier,
        "GenCodeVerifier"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.GenerateCodeChallengeFromVerifier,
        "GenCodeChallengeFromVerifier"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.Sha256Digest,
        "Sha256Digest"
    ],
    [
        $32170abc11155933$export$2f2811a3e1b21823.GetRandomValues,
        "GetRandomValues"
    ]
]);
/**
 * State of the performance event.
 *
 * @export
 * @enum {number}
 */ const $32170abc11155933$export$bc3547c8ae7b1db = {
    NotStarted: 0,
    InProgress: 1,
    Completed: 2
};
const $32170abc11155933$export$f16d39729f4b7302 = new Set([
    "accessTokenSize",
    "durationMs",
    "idTokenSize",
    "matsSilentStatus",
    "matsHttpStatus",
    "refreshTokenSize",
    "queuedTimeMs",
    "startTimeMs",
    "status",
    "multiMatchedAT",
    "multiMatchedID",
    "multiMatchedRT"
]);


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $1b6245e94168f9ed$export$647004217f4122f0 {
    startMeasurement() {
        return;
    }
    endMeasurement() {
        return;
    }
    flushMeasurement() {
        return null;
    }
}
class $1b6245e94168f9ed$export$c70f2989a65fda3e {
    generateId() {
        return "callback-id";
    }
    startMeasurement(measureName, correlationId) {
        return {
            end: ()=>null,
            discard: ()=>{},
            add: ()=>{},
            increment: ()=>{},
            event: {
                eventId: this.generateId(),
                status: (0, $32170abc11155933$export$bc3547c8ae7b1db).InProgress,
                authority: "",
                libraryName: "",
                libraryVersion: "",
                clientId: "",
                name: measureName,
                startTimeMs: Date.now(),
                correlationId: correlationId || ""
            },
            measurement: new $1b6245e94168f9ed$export$647004217f4122f0()
        };
    }
    startPerformanceMeasurement() {
        return new $1b6245e94168f9ed$export$647004217f4122f0();
    }
    calculateQueuedTime() {
        return 0;
    }
    addQueueMeasurement() {
        return;
    }
    setPreQueueTime() {
        return;
    }
    endMeasurement() {
        return null;
    }
    discardMeasurements() {
        return;
    }
    removePerformanceCallback() {
        return true;
    }
    addPerformanceCallback() {
        return "";
    }
    emitEvents() {
        return;
    }
    addFields() {
        return;
    }
    incrementFields() {
        return;
    }
    cacheEventByCorrelationId() {
        return;
    }
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Constants
 */ const $091acf4c2675819b$export$a0a689e4294b9880 = {
    /**
     * Interaction in progress cache value
     */ INTERACTION_IN_PROGRESS_VALUE: "interaction_in_progress",
    /**
     * Invalid grant error code
     */ INVALID_GRANT_ERROR: "invalid_grant",
    /**
     * Default popup window width
     */ POPUP_WIDTH: 483,
    /**
     * Default popup window height
     */ POPUP_HEIGHT: 600,
    /**
     * Name of the popup window starts with
     */ POPUP_NAME_PREFIX: "msal",
    /**
     * Default popup monitor poll interval in milliseconds
     */ DEFAULT_POLL_INTERVAL_MS: 30,
    /**
     * Msal-browser SKU
     */ MSAL_SKU: "msal.js.browser"
};
const $091acf4c2675819b$export$fec113838800867f = {
    CHANNEL_ID: "53ee284d-920a-4b59-9d30-a60315b26836",
    PREFERRED_EXTENSION_ID: "ppnbnpeolgkicgegkbkbjmhlideopiji",
    MATS_TELEMETRY: "MATS"
};
const $091acf4c2675819b$export$3536098be6c7dadb = {
    HandshakeRequest: "Handshake",
    HandshakeResponse: "HandshakeResponse",
    GetToken: "GetToken",
    Response: "Response"
};
const $091acf4c2675819b$export$573384e47a12d835 = {
    LocalStorage: "localStorage",
    SessionStorage: "sessionStorage",
    MemoryStorage: "memoryStorage"
};
/**
 * HTTP Request types supported by MSAL.
 */ const $091acf4c2675819b$export$c774c31b4c31da8 = {
    GET: "GET",
    POST: "POST"
};
/**
 * Temporary cache keys for MSAL, deleted after any request.
 */ const $091acf4c2675819b$export$21d55bedf0d269fb = {
    AUTHORITY: "authority",
    ACQUIRE_TOKEN_ACCOUNT: "acquireToken.account",
    SESSION_STATE: "session.state",
    REQUEST_STATE: "request.state",
    NONCE_IDTOKEN: "nonce.id_token",
    ORIGIN_URI: "request.origin",
    RENEW_STATUS: "token.renew.status",
    URL_HASH: "urlHash",
    REQUEST_PARAMS: "request.params",
    SCOPES: "scopes",
    INTERACTION_STATUS_KEY: "interaction.status",
    CCS_CREDENTIAL: "ccs.credential",
    CORRELATION_ID: "request.correlationId",
    NATIVE_REQUEST: "request.native",
    REDIRECT_CONTEXT: "request.redirect.context"
};
const $091acf4c2675819b$export$f6ce23cce692699f = {
    ACCOUNT_KEYS: "msal.account.keys",
    TOKEN_KEYS: "msal.token.keys",
    VERSION: "msal.version"
};
/**
 * Cache keys stored in-memory
 */ const $091acf4c2675819b$export$8f546f90896bcfa9 = {
    WRAPPER_SKU: "wrapper.sku",
    WRAPPER_VER: "wrapper.version"
};
/**
 * API Codes for Telemetry purposes.
 * Before adding a new code you must claim it in the MSAL Telemetry tracker as these number spaces are shared across all MSALs
 * 0-99 Silent Flow
 * 800-899 Auth Code Flow
 */ const $091acf4c2675819b$export$192d74ad69b40705 = {
    acquireTokenRedirect: 861,
    acquireTokenPopup: 862,
    ssoSilent: 863,
    acquireTokenSilent_authCode: 864,
    handleRedirectPromise: 865,
    acquireTokenByCode: 866,
    acquireTokenSilent_silentFlow: 61,
    logout: 961,
    logoutPopup: 962
};
/*
 * Interaction type of the API - used for state and telemetry
 */ var $091acf4c2675819b$export$4ec29255e7e7f68f;
(function(InteractionType) {
    InteractionType["Redirect"] = "redirect";
    InteractionType["Popup"] = "popup";
    InteractionType["Silent"] = "silent";
    InteractionType["None"] = "none";
})($091acf4c2675819b$export$4ec29255e7e7f68f || ($091acf4c2675819b$export$4ec29255e7e7f68f = {}));
/**
 * Types of interaction currently in progress.
 * Used in events in wrapper libraries to invoke functions when certain interaction is in progress or all interactions are complete.
 */ const $091acf4c2675819b$export$bec20eda0179362b = {
    /**
     * Initial status before interaction occurs
     */ Startup: "startup",
    /**
     * Status set when all login calls occuring
     */ Login: "login",
    /**
     * Status set when logout call occuring
     */ Logout: "logout",
    /**
     * Status set for acquireToken calls
     */ AcquireToken: "acquireToken",
    /**
     * Status set for ssoSilent calls
     */ SsoSilent: "ssoSilent",
    /**
     * Status set when handleRedirect in progress
     */ HandleRedirect: "handleRedirect",
    /**
     * Status set when interaction is complete
     */ None: "none"
};
const $091acf4c2675819b$export$7e12949cd6884193 = {
    scopes: (0, $08c107807d753255$export$893b1b5b686d84ef)
};
/**
 * JWK Key Format string (Type MUST be defined for window crypto APIs)
 */ const $091acf4c2675819b$export$1294c3e3f84694cd = "jwk";
// Supported wrapper SKUs
const $091acf4c2675819b$export$8abb9de997bb4e44 = {
    React: "@azure/msal-react",
    Angular: "@azure/msal-angular"
};
// DatabaseStorage Constants
const $091acf4c2675819b$export$3c22ff8b64b8f565 = "msal.db";
const $091acf4c2675819b$export$6a9022b4c5fcea02 = 1;
const $091acf4c2675819b$export$9d785db034fb436f = `${$091acf4c2675819b$export$3c22ff8b64b8f565}.keys`;
const $091acf4c2675819b$export$4394baa7e922d42d = {
    /*
     * acquireTokenSilent will attempt to retrieve an access token from the cache. If the access token is expired
     * or cannot be found the refresh token will be used to acquire a new one. Finally, if the refresh token
     * is expired acquireTokenSilent will attempt to acquire new access and refresh tokens.
     */ Default: 0,
    /*
     * acquireTokenSilent will only look for access tokens in the cache. It will not attempt to renew access or
     * refresh tokens.
     */ AccessToken: 1,
    /*
     * acquireTokenSilent will attempt to retrieve an access token from the cache. If the access token is expired or
     * cannot be found, the refresh token will be used to acquire a new one. If the refresh token is expired, it
     * will not be renewed and acquireTokenSilent will fail.
     */ AccessTokenAndRefreshToken: 2,
    /*
     * acquireTokenSilent will not attempt to retrieve access tokens from the cache and will instead attempt to
     * exchange the cached refresh token for a new access token. If the refresh token is expired, it will not be
     * renewed and acquireTokenSilent will fail.
     */ RefreshToken: 3,
    /*
     * acquireTokenSilent will not look in the cache for the access token. It will go directly to network with the
     * cached refresh token. If the refresh token is expired an attempt will be made to renew it. This is equivalent to
     * setting "forceRefresh: true".
     */ RefreshTokenAndNetwork: 4,
    /*
     * acquireTokenSilent will attempt to renew both access and refresh tokens. It will not look in the cache. This will
     * always fail if 3rd party cookies are blocked by the browser.
     */ Skip: 5
};
const $091acf4c2675819b$export$736180706fb122ee = [
    $091acf4c2675819b$export$4394baa7e922d42d.Default,
    $091acf4c2675819b$export$4394baa7e922d42d.Skip,
    $091acf4c2675819b$export$4394baa7e922d42d.RefreshTokenAndNetwork
];
const $091acf4c2675819b$export$b28668d53eb57e63 = "msal.browser.log.level";
const $091acf4c2675819b$export$d9bc1c202a3825f1 = "msal.browser.log.pii";
const $091acf4c2675819b$export$54408f0b0cf727d4 = "msal.browser.performance.enabled";


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $a838f8b4c4f03b05$export$d0d362a73d466c9b {
    /**
     * Navigates to other pages within the same web application
     * @param url
     * @param options
     */ navigateInternal(url, options) {
        return $a838f8b4c4f03b05$export$d0d362a73d466c9b.defaultNavigateWindow(url, options);
    }
    /**
     * Navigates to other pages outside the web application i.e. the Identity Provider
     * @param url
     * @param options
     */ navigateExternal(url, options) {
        return $a838f8b4c4f03b05$export$d0d362a73d466c9b.defaultNavigateWindow(url, options);
    }
    /**
     * Default navigation implementation invoked by the internal and external functions
     * @param url
     * @param options
     */ static defaultNavigateWindow(url, options) {
        if (options.noHistory) window.location.replace(url);
        else window.location.assign(url);
        return new Promise((resolve)=>{
            setTimeout(()=>{
                resolve(true);
            }, options.timeout);
        });
    }
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ /*! @azure/msal-common v14.16.1 2025-08-05 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Represents network related errors
 */ class $9ce5dcfe9606df55$export$bae979e68e4dc802 extends (0, $53b49d8334c1646a$export$145273558d58e0ac) {
    constructor(error, httpStatus, responseHeaders){
        super(error.errorCode, error.errorMessage, error.subError);
        Object.setPrototypeOf(this, $9ce5dcfe9606df55$export$bae979e68e4dc802.prototype);
        this.name = "NetworkError";
        this.error = error;
        this.httpStatus = httpStatus;
        this.responseHeaders = responseHeaders;
    }
}
/**
 * Creates NetworkError object for a failed network request
 * @param error - Error to be thrown back to the caller
 * @param httpStatus - Status code of the network request
 * @param responseHeaders - Response headers of the network request, when available
 * @returns NetworkError object
 */ function $9ce5dcfe9606df55$export$262c4a35fb53be19(error, httpStatus, responseHeaders) {
    return new $9ce5dcfe9606df55$export$bae979e68e4dc802(error, httpStatus, responseHeaders);
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 
/*! @azure/msal-browser v3.30.0 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $aa0e430adf0f9ba6$export$ee549107fa376fc1 = "pkce_not_created";
const $aa0e430adf0f9ba6$export$6319761d10f0cc4c = "crypto_nonexistent";
const $aa0e430adf0f9ba6$export$be9285c64f247822 = "empty_navigate_uri";
const $aa0e430adf0f9ba6$export$a29c42a1dd414317 = "hash_empty_error";
const $aa0e430adf0f9ba6$export$211c8e8843a8d278 = "no_state_in_hash";
const $aa0e430adf0f9ba6$export$5743873a5ba5d124 = "hash_does_not_contain_known_properties";
const $aa0e430adf0f9ba6$export$237bdd0b913cb30c = "unable_to_parse_state";
const $aa0e430adf0f9ba6$export$499b1b95c97a1c75 = "state_interaction_type_mismatch";
const $aa0e430adf0f9ba6$export$2700dc1c133d227e = "interaction_in_progress";
const $aa0e430adf0f9ba6$export$f1b7091ee48d0b3e = "popup_window_error";
const $aa0e430adf0f9ba6$export$5e827e513523a576 = "empty_window_error";
const $aa0e430adf0f9ba6$export$6bae303c5e922702 = "user_cancelled";
const $aa0e430adf0f9ba6$export$e2e3374c08b8ef2a = "monitor_popup_timeout";
const $aa0e430adf0f9ba6$export$c8b6efb19551013d = "monitor_window_timeout";
const $aa0e430adf0f9ba6$export$9cc12eb574ceee30 = "redirect_in_iframe";
const $aa0e430adf0f9ba6$export$71bafc2814e56c09 = "block_iframe_reload";
const $aa0e430adf0f9ba6$export$c4a80c97d7b48f72 = "block_nested_popups";
const $aa0e430adf0f9ba6$export$6a76760db525f402 = "iframe_closed_prematurely";
const $aa0e430adf0f9ba6$export$78523a40be105a03 = "silent_logout_unsupported";
const $aa0e430adf0f9ba6$export$87933d7d4116cb12 = "no_account_error";
const $aa0e430adf0f9ba6$export$24dae796d0958d3 = "silent_prompt_value_error";
const $aa0e430adf0f9ba6$export$8b51939fb2aab3d7 = "no_token_request_cache_error";
const $aa0e430adf0f9ba6$export$f3ae24cdfaab4488 = "unable_to_parse_token_request_cache_error";
const $aa0e430adf0f9ba6$export$3a2c83e7753553b = "no_cached_authority_error";
const $aa0e430adf0f9ba6$export$c47649cf6408c7b2 = "auth_request_not_set_error";
const $aa0e430adf0f9ba6$export$ff7164a2aeeff392 = "invalid_cache_type";
const $aa0e430adf0f9ba6$export$932e0f52d657f7fb = "non_browser_environment";
const $aa0e430adf0f9ba6$export$4752ced1a1a262f = "database_not_open";
const $aa0e430adf0f9ba6$export$31ae862f18c3b2b7 = "no_network_connectivity";
const $aa0e430adf0f9ba6$export$7a1e28a7b60ca602 = "post_request_failed";
const $aa0e430adf0f9ba6$export$45e7eaaecd19d31e = "get_request_failed";
const $aa0e430adf0f9ba6$export$96735047beea85a0 = "failed_to_parse_response";
const $aa0e430adf0f9ba6$export$6acf650331eb5f5f = "unable_to_load_token";
const $aa0e430adf0f9ba6$export$a416b0eceb5c15df = "crypto_key_not_found";
const $aa0e430adf0f9ba6$export$e502d98cd8d2da43 = "auth_code_required";
const $aa0e430adf0f9ba6$export$8bea68053103eaeb = "auth_code_or_nativeAccountId_required";
const $aa0e430adf0f9ba6$export$1efb009e9d75bbe4 = "spa_code_and_nativeAccountId_present";
const $aa0e430adf0f9ba6$export$c1110692d2978b8 = "database_unavailable";
const $aa0e430adf0f9ba6$export$b897bbe2c683def2 = "unable_to_acquire_token_from_native_platform";
const $aa0e430adf0f9ba6$export$4747c302ef0117fd = "native_handshake_timeout";
const $aa0e430adf0f9ba6$export$59080ea2398ee306 = "native_extension_not_installed";
const $aa0e430adf0f9ba6$export$7b7357e3538624aa = "native_connection_not_established";
const $aa0e430adf0f9ba6$export$436657cdcd7fe2be = "uninitialized_public_client_application";
const $aa0e430adf0f9ba6$export$62fdd8848aa75547 = "native_prompt_not_supported";
const $aa0e430adf0f9ba6$export$fcc6790b5d12da63 = "invalid_base64_string";
const $aa0e430adf0f9ba6$export$f6f43ae33ad04b91 = "invalid_pop_token_request";
const $aa0e430adf0f9ba6$export$df9e6aae71bd84f = "failed_to_build_headers";
const $aa0e430adf0f9ba6$export$487fe7232a90003c = "failed_to_parse_headers";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $59d58688ac49ebc0$var$ErrorLink = "For more visit: aka.ms/msaljs/browser-errors";
/**
 * BrowserAuthErrorMessage class containing string constants used by error codes and messages.
 */ const $59d58688ac49ebc0$export$16ffff3fb076c606 = {
    [(0, $aa0e430adf0f9ba6$export$ee549107fa376fc1)]: "The PKCE code challenge and verifier could not be generated.",
    [(0, $aa0e430adf0f9ba6$export$6319761d10f0cc4c)]: "The crypto object or function is not available.",
    [(0, $aa0e430adf0f9ba6$export$be9285c64f247822)]: "Navigation URI is empty. Please check stack trace for more info.",
    [(0, $aa0e430adf0f9ba6$export$a29c42a1dd414317)]: `Hash value cannot be processed because it is empty. Please verify that your redirectUri is not clearing the hash. ${$59d58688ac49ebc0$var$ErrorLink}`,
    [(0, $aa0e430adf0f9ba6$export$211c8e8843a8d278)]: "Hash does not contain state. Please verify that the request originated from msal.",
    [(0, $aa0e430adf0f9ba6$export$5743873a5ba5d124)]: `Hash does not contain known properites. Please verify that your redirectUri is not changing the hash.  ${$59d58688ac49ebc0$var$ErrorLink}`,
    [(0, $aa0e430adf0f9ba6$export$237bdd0b913cb30c)]: "Unable to parse state. Please verify that the request originated from msal.",
    [(0, $aa0e430adf0f9ba6$export$499b1b95c97a1c75)]: "Hash contains state but the interaction type does not match the caller.",
    [(0, $aa0e430adf0f9ba6$export$2700dc1c133d227e)]: `Interaction is currently in progress. Please ensure that this interaction has been completed before calling an interactive API.   ${$59d58688ac49ebc0$var$ErrorLink}`,
    [(0, $aa0e430adf0f9ba6$export$f1b7091ee48d0b3e)]: "Error opening popup window. This can happen if you are using IE or if popups are blocked in the browser.",
    [(0, $aa0e430adf0f9ba6$export$5e827e513523a576)]: "window.open returned null or undefined window object.",
    [(0, $aa0e430adf0f9ba6$export$6bae303c5e922702)]: "User cancelled the flow.",
    [(0, $aa0e430adf0f9ba6$export$e2e3374c08b8ef2a)]: `Token acquisition in popup failed due to timeout.  ${$59d58688ac49ebc0$var$ErrorLink}`,
    [(0, $aa0e430adf0f9ba6$export$c8b6efb19551013d)]: `Token acquisition in iframe failed due to timeout.  ${$59d58688ac49ebc0$var$ErrorLink}`,
    [(0, $aa0e430adf0f9ba6$export$9cc12eb574ceee30)]: "Redirects are not supported for iframed or brokered applications. Please ensure you are using MSAL.js in a top frame of the window if using the redirect APIs, or use the popup APIs.",
    [(0, $aa0e430adf0f9ba6$export$71bafc2814e56c09)]: `Request was blocked inside an iframe because MSAL detected an authentication response.  ${$59d58688ac49ebc0$var$ErrorLink}`,
    [(0, $aa0e430adf0f9ba6$export$c4a80c97d7b48f72)]: "Request was blocked inside a popup because MSAL detected it was running in a popup.",
    [(0, $aa0e430adf0f9ba6$export$6a76760db525f402)]: "The iframe being monitored was closed prematurely.",
    [(0, $aa0e430adf0f9ba6$export$78523a40be105a03)]: "Silent logout not supported. Please call logoutRedirect or logoutPopup instead.",
    [(0, $aa0e430adf0f9ba6$export$87933d7d4116cb12)]: "No account object provided to acquireTokenSilent and no active account has been set. Please call setActiveAccount or provide an account on the request.",
    [(0, $aa0e430adf0f9ba6$export$24dae796d0958d3)]: "The value given for the prompt value is not valid for silent requests - must be set to 'none' or 'no_session'.",
    [(0, $aa0e430adf0f9ba6$export$8b51939fb2aab3d7)]: "No token request found in cache.",
    [(0, $aa0e430adf0f9ba6$export$f3ae24cdfaab4488)]: "The cached token request could not be parsed.",
    [(0, $aa0e430adf0f9ba6$export$3a2c83e7753553b)]: "No cached authority found.",
    [(0, $aa0e430adf0f9ba6$export$c47649cf6408c7b2)]: "Auth Request not set. Please ensure initiateAuthRequest was called from the InteractionHandler",
    [(0, $aa0e430adf0f9ba6$export$ff7164a2aeeff392)]: "Invalid cache type",
    [(0, $aa0e430adf0f9ba6$export$932e0f52d657f7fb)]: "Login and token requests are not supported in non-browser environments.",
    [(0, $aa0e430adf0f9ba6$export$4752ced1a1a262f)]: "Database is not open!",
    [(0, $aa0e430adf0f9ba6$export$31ae862f18c3b2b7)]: "No network connectivity. Check your internet connection.",
    [(0, $aa0e430adf0f9ba6$export$7a1e28a7b60ca602)]: "Network request failed: If the browser threw a CORS error, check that the redirectUri is registered in the Azure App Portal as type 'SPA'",
    [(0, $aa0e430adf0f9ba6$export$45e7eaaecd19d31e)]: "Network request failed. Please check the network trace to determine root cause.",
    [(0, $aa0e430adf0f9ba6$export$96735047beea85a0)]: "Failed to parse network response. Check network trace.",
    [(0, $aa0e430adf0f9ba6$export$6acf650331eb5f5f)]: "Error loading token to cache.",
    [(0, $aa0e430adf0f9ba6$export$a416b0eceb5c15df)]: "Cryptographic Key or Keypair not found in browser storage.",
    [(0, $aa0e430adf0f9ba6$export$e502d98cd8d2da43)]: "An authorization code must be provided (as the `code` property on the request) to this flow.",
    [(0, $aa0e430adf0f9ba6$export$8bea68053103eaeb)]: "An authorization code or nativeAccountId must be provided to this flow.",
    [(0, $aa0e430adf0f9ba6$export$1efb009e9d75bbe4)]: "Request cannot contain both spa code and native account id.",
    [(0, $aa0e430adf0f9ba6$export$c1110692d2978b8)]: "IndexedDB, which is required for persistent cryptographic key storage, is unavailable. This may be caused by browser privacy features which block persistent storage in third-party contexts.",
    [(0, $aa0e430adf0f9ba6$export$b897bbe2c683def2)]: `Unable to acquire token from native platform.  ${$59d58688ac49ebc0$var$ErrorLink}`,
    [(0, $aa0e430adf0f9ba6$export$4747c302ef0117fd)]: "Timed out while attempting to establish connection to browser extension",
    [(0, $aa0e430adf0f9ba6$export$59080ea2398ee306)]: "Native extension is not installed. If you think this is a mistake call the initialize function.",
    [(0, $aa0e430adf0f9ba6$export$7b7357e3538624aa)]: `Connection to native platform has not been established. Please install a compatible browser extension and run initialize().  ${$59d58688ac49ebc0$var$ErrorLink}`,
    [(0, $aa0e430adf0f9ba6$export$436657cdcd7fe2be)]: `You must call and await the initialize function before attempting to call any other MSAL API.  ${$59d58688ac49ebc0$var$ErrorLink}`,
    [(0, $aa0e430adf0f9ba6$export$62fdd8848aa75547)]: "The provided prompt is not supported by the native platform. This request should be routed to the web based flow.",
    [(0, $aa0e430adf0f9ba6$export$fcc6790b5d12da63)]: "Invalid base64 encoded string.",
    [(0, $aa0e430adf0f9ba6$export$f6f43ae33ad04b91)]: "Invalid PoP token request. The request should not have both a popKid value and signPopToken set to true.",
    [(0, $aa0e430adf0f9ba6$export$df9e6aae71bd84f)]: "Failed to build request headers object.",
    [(0, $aa0e430adf0f9ba6$export$487fe7232a90003c)]: "Failed to parse response headers"
};
/**
 * BrowserAuthErrorMessage class containing string constants used by error codes and messages.
 * @deprecated Use exported BrowserAuthErrorCodes instead.
 * In your app you can do :
 * ```
 * import { BrowserAuthErrorCodes } from "@azure/msal-browser";
 * ```
 */ const $59d58688ac49ebc0$export$6deffaef56f0bd5a = {
    pkceNotGenerated: {
        code: (0, $aa0e430adf0f9ba6$export$ee549107fa376fc1),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$ee549107fa376fc1]
    },
    cryptoDoesNotExist: {
        code: (0, $aa0e430adf0f9ba6$export$6319761d10f0cc4c),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$6319761d10f0cc4c]
    },
    emptyNavigateUriError: {
        code: (0, $aa0e430adf0f9ba6$export$be9285c64f247822),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$be9285c64f247822]
    },
    hashEmptyError: {
        code: (0, $aa0e430adf0f9ba6$export$a29c42a1dd414317),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$a29c42a1dd414317]
    },
    hashDoesNotContainStateError: {
        code: (0, $aa0e430adf0f9ba6$export$211c8e8843a8d278),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$211c8e8843a8d278]
    },
    hashDoesNotContainKnownPropertiesError: {
        code: (0, $aa0e430adf0f9ba6$export$5743873a5ba5d124),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$5743873a5ba5d124]
    },
    unableToParseStateError: {
        code: (0, $aa0e430adf0f9ba6$export$237bdd0b913cb30c),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$237bdd0b913cb30c]
    },
    stateInteractionTypeMismatchError: {
        code: (0, $aa0e430adf0f9ba6$export$499b1b95c97a1c75),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$499b1b95c97a1c75]
    },
    interactionInProgress: {
        code: (0, $aa0e430adf0f9ba6$export$2700dc1c133d227e),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$2700dc1c133d227e]
    },
    popupWindowError: {
        code: (0, $aa0e430adf0f9ba6$export$f1b7091ee48d0b3e),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$f1b7091ee48d0b3e]
    },
    emptyWindowError: {
        code: (0, $aa0e430adf0f9ba6$export$5e827e513523a576),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$5e827e513523a576]
    },
    userCancelledError: {
        code: (0, $aa0e430adf0f9ba6$export$6bae303c5e922702),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$6bae303c5e922702]
    },
    monitorPopupTimeoutError: {
        code: (0, $aa0e430adf0f9ba6$export$e2e3374c08b8ef2a),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$e2e3374c08b8ef2a]
    },
    monitorIframeTimeoutError: {
        code: (0, $aa0e430adf0f9ba6$export$c8b6efb19551013d),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$c8b6efb19551013d]
    },
    redirectInIframeError: {
        code: (0, $aa0e430adf0f9ba6$export$9cc12eb574ceee30),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$9cc12eb574ceee30]
    },
    blockTokenRequestsInHiddenIframeError: {
        code: (0, $aa0e430adf0f9ba6$export$71bafc2814e56c09),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$71bafc2814e56c09]
    },
    blockAcquireTokenInPopupsError: {
        code: (0, $aa0e430adf0f9ba6$export$c4a80c97d7b48f72),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$c4a80c97d7b48f72]
    },
    iframeClosedPrematurelyError: {
        code: (0, $aa0e430adf0f9ba6$export$6a76760db525f402),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$6a76760db525f402]
    },
    silentLogoutUnsupportedError: {
        code: (0, $aa0e430adf0f9ba6$export$78523a40be105a03),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$78523a40be105a03]
    },
    noAccountError: {
        code: (0, $aa0e430adf0f9ba6$export$87933d7d4116cb12),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$87933d7d4116cb12]
    },
    silentPromptValueError: {
        code: (0, $aa0e430adf0f9ba6$export$24dae796d0958d3),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$24dae796d0958d3]
    },
    noTokenRequestCacheError: {
        code: (0, $aa0e430adf0f9ba6$export$8b51939fb2aab3d7),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$8b51939fb2aab3d7]
    },
    unableToParseTokenRequestCacheError: {
        code: (0, $aa0e430adf0f9ba6$export$f3ae24cdfaab4488),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$f3ae24cdfaab4488]
    },
    noCachedAuthorityError: {
        code: (0, $aa0e430adf0f9ba6$export$3a2c83e7753553b),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$3a2c83e7753553b]
    },
    authRequestNotSet: {
        code: (0, $aa0e430adf0f9ba6$export$c47649cf6408c7b2),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$c47649cf6408c7b2]
    },
    invalidCacheType: {
        code: (0, $aa0e430adf0f9ba6$export$ff7164a2aeeff392),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$ff7164a2aeeff392]
    },
    notInBrowserEnvironment: {
        code: (0, $aa0e430adf0f9ba6$export$932e0f52d657f7fb),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$932e0f52d657f7fb]
    },
    databaseNotOpen: {
        code: (0, $aa0e430adf0f9ba6$export$4752ced1a1a262f),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$4752ced1a1a262f]
    },
    noNetworkConnectivity: {
        code: (0, $aa0e430adf0f9ba6$export$31ae862f18c3b2b7),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$31ae862f18c3b2b7]
    },
    postRequestFailed: {
        code: (0, $aa0e430adf0f9ba6$export$7a1e28a7b60ca602),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$7a1e28a7b60ca602]
    },
    getRequestFailed: {
        code: (0, $aa0e430adf0f9ba6$export$45e7eaaecd19d31e),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$45e7eaaecd19d31e]
    },
    failedToParseNetworkResponse: {
        code: (0, $aa0e430adf0f9ba6$export$96735047beea85a0),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$96735047beea85a0]
    },
    unableToLoadTokenError: {
        code: (0, $aa0e430adf0f9ba6$export$6acf650331eb5f5f),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$6acf650331eb5f5f]
    },
    signingKeyNotFoundInStorage: {
        code: (0, $aa0e430adf0f9ba6$export$a416b0eceb5c15df),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$a416b0eceb5c15df]
    },
    authCodeRequired: {
        code: (0, $aa0e430adf0f9ba6$export$e502d98cd8d2da43),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$e502d98cd8d2da43]
    },
    authCodeOrNativeAccountRequired: {
        code: (0, $aa0e430adf0f9ba6$export$8bea68053103eaeb),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$8bea68053103eaeb]
    },
    spaCodeAndNativeAccountPresent: {
        code: (0, $aa0e430adf0f9ba6$export$1efb009e9d75bbe4),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$1efb009e9d75bbe4]
    },
    databaseUnavailable: {
        code: (0, $aa0e430adf0f9ba6$export$c1110692d2978b8),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$c1110692d2978b8]
    },
    unableToAcquireTokenFromNativePlatform: {
        code: (0, $aa0e430adf0f9ba6$export$b897bbe2c683def2),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$b897bbe2c683def2]
    },
    nativeHandshakeTimeout: {
        code: (0, $aa0e430adf0f9ba6$export$4747c302ef0117fd),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$4747c302ef0117fd]
    },
    nativeExtensionNotInstalled: {
        code: (0, $aa0e430adf0f9ba6$export$59080ea2398ee306),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$59080ea2398ee306]
    },
    nativeConnectionNotEstablished: {
        code: (0, $aa0e430adf0f9ba6$export$7b7357e3538624aa),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$7b7357e3538624aa]
    },
    uninitializedPublicClientApplication: {
        code: (0, $aa0e430adf0f9ba6$export$436657cdcd7fe2be),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$436657cdcd7fe2be]
    },
    nativePromptNotSupported: {
        code: (0, $aa0e430adf0f9ba6$export$62fdd8848aa75547),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$62fdd8848aa75547]
    },
    invalidBase64StringError: {
        code: (0, $aa0e430adf0f9ba6$export$fcc6790b5d12da63),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$fcc6790b5d12da63]
    },
    invalidPopTokenRequest: {
        code: (0, $aa0e430adf0f9ba6$export$f6f43ae33ad04b91),
        desc: $59d58688ac49ebc0$export$16ffff3fb076c606[0, $aa0e430adf0f9ba6$export$f6f43ae33ad04b91]
    }
};
/**
 * Browser library error class thrown by the MSAL.js library for SPAs
 */ class $59d58688ac49ebc0$export$f8eb6760ca13876a extends (0, $53b49d8334c1646a$export$145273558d58e0ac) {
    constructor(errorCode, subError){
        super(errorCode, $59d58688ac49ebc0$export$16ffff3fb076c606[errorCode], subError);
        Object.setPrototypeOf(this, $59d58688ac49ebc0$export$f8eb6760ca13876a.prototype);
        this.name = "BrowserAuthError";
    }
}
function $59d58688ac49ebc0$export$72f7b48f3bc1d4cb(errorCode, subError) {
    return new $59d58688ac49ebc0$export$f8eb6760ca13876a(errorCode, subError);
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class implements the Fetch API for GET and POST requests. See more here: https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API
 */ class $a9a81d90f5cc8475$export$4c206ef5be879972 {
    /**
     * Fetch Client for REST endpoints - Get request
     * @param url
     * @param headers
     * @param body
     */ async sendGetRequestAsync(url, options) {
        let response;
        let responseHeaders = {};
        let responseStatus = 0;
        const reqHeaders = $a9a81d90f5cc8475$var$getFetchHeaders(options);
        try {
            response = await fetch(url, {
                method: (0, $091acf4c2675819b$export$c774c31b4c31da8).GET,
                headers: reqHeaders
            });
        } catch (e) {
            throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)(window.navigator.onLine ? (0, $aa0e430adf0f9ba6$export$45e7eaaecd19d31e) : (0, $aa0e430adf0f9ba6$export$31ae862f18c3b2b7));
        }
        responseHeaders = $a9a81d90f5cc8475$var$getHeaderDict(response.headers);
        try {
            responseStatus = response.status;
            return {
                headers: responseHeaders,
                body: await response.json(),
                status: responseStatus
            };
        } catch (e) {
            throw (0, $9ce5dcfe9606df55$export$262c4a35fb53be19)((0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$96735047beea85a0)), responseStatus, responseHeaders);
        }
    }
    /**
     * Fetch Client for REST endpoints - Post request
     * @param url
     * @param headers
     * @param body
     */ async sendPostRequestAsync(url, options) {
        const reqBody = options && options.body || "";
        const reqHeaders = $a9a81d90f5cc8475$var$getFetchHeaders(options);
        let response;
        let responseStatus = 0;
        let responseHeaders = {};
        try {
            response = await fetch(url, {
                method: (0, $091acf4c2675819b$export$c774c31b4c31da8).POST,
                headers: reqHeaders,
                body: reqBody
            });
        } catch (e) {
            throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)(window.navigator.onLine ? (0, $aa0e430adf0f9ba6$export$7a1e28a7b60ca602) : (0, $aa0e430adf0f9ba6$export$31ae862f18c3b2b7));
        }
        responseHeaders = $a9a81d90f5cc8475$var$getHeaderDict(response.headers);
        try {
            responseStatus = response.status;
            return {
                headers: responseHeaders,
                body: await response.json(),
                status: responseStatus
            };
        } catch (e) {
            throw (0, $9ce5dcfe9606df55$export$262c4a35fb53be19)((0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$96735047beea85a0)), responseStatus, responseHeaders);
        }
    }
}
/**
 * Get Fetch API Headers object from string map
 * @param inputHeaders
 */ function $a9a81d90f5cc8475$var$getFetchHeaders(options) {
    try {
        const headers = new Headers();
        if (!(options && options.headers)) return headers;
        const optionsHeaders = options.headers;
        Object.entries(optionsHeaders).forEach(([key, value])=>{
            headers.append(key, value);
        });
        return headers;
    } catch (e) {
        throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$df9e6aae71bd84f));
    }
}
/**
 * Returns object representing response headers
 * @param headers
 * @returns
 */ function $a9a81d90f5cc8475$var$getHeaderDict(headers) {
    try {
        const headerDict = {};
        headers.forEach((value, key)=>{
            headerDict[key] = value;
        });
        return headerDict;
    } catch (e) {
        throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$487fe7232a90003c));
    }
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class which exposes APIs to encode plaintext to base64 encoded string. See here for implementation details:
 * https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64/Base64_encoding_and_decoding#Solution_2_%E2%80%93_JavaScript's_UTF-16_%3E_UTF-8_%3E_base64
 */ /**
 * Returns URL Safe b64 encoded string from a plaintext string.
 * @param input
 */ function $3665c4f98d09cc5b$export$9ef804feabbcbaf1(input) {
    return encodeURIComponent($3665c4f98d09cc5b$export$e510a73ee562749(input).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_"));
}
/**
 * Returns URL Safe b64 encoded string from an int8Array.
 * @param inputArr
 */ function $3665c4f98d09cc5b$export$84f5a428c7153a69(inputArr) {
    return $3665c4f98d09cc5b$var$base64EncArr(inputArr).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
}
/**
 * Returns b64 encoded string from plaintext string.
 * @param input
 */ function $3665c4f98d09cc5b$export$e510a73ee562749(input) {
    return $3665c4f98d09cc5b$var$base64EncArr(new TextEncoder().encode(input));
}
/**
 * Base64 encode byte array
 * @param aBytes
 */ function $3665c4f98d09cc5b$var$base64EncArr(aBytes) {
    const binString = Array.from(aBytes, (x)=>String.fromCodePoint(x)).join("");
    return btoa(binString);
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This file defines functions used by the browser library to perform cryptography operations such as
 * hashing and encoding. It also has helper functions to validate the availability of specific APIs.
 */ /**
 * See here for more info on RsaHashedKeyGenParams: https://developer.mozilla.org/en-US/docs/Web/API/RsaHashedKeyGenParams
 */ // RSA KeyGen Algorithm
const $b512579b1150f905$var$PKCS1_V15_KEYGEN_ALG = "RSASSA-PKCS1-v1_5";
// SHA-256 hashing algorithm
const $b512579b1150f905$var$S256_HASH_ALG = "SHA-256";
// MOD length for PoP tokens
const $b512579b1150f905$var$MODULUS_LENGTH = 2048;
// Public Exponent
const $b512579b1150f905$var$PUBLIC_EXPONENT = new Uint8Array([
    0x01,
    0x00,
    0x01
]);
// UUID hex digits
const $b512579b1150f905$var$UUID_CHARS = "0123456789abcdef";
// Array to store UINT32 random value
const $b512579b1150f905$var$UINT32_ARR = new Uint32Array(1);
const $b512579b1150f905$var$SUBTLE_SUBERROR = "crypto_subtle_undefined";
const $b512579b1150f905$var$keygenAlgorithmOptions = {
    name: $b512579b1150f905$var$PKCS1_V15_KEYGEN_ALG,
    hash: $b512579b1150f905$var$S256_HASH_ALG,
    modulusLength: $b512579b1150f905$var$MODULUS_LENGTH,
    publicExponent: $b512579b1150f905$var$PUBLIC_EXPONENT
};
/**
 * Check whether browser crypto is available.
 */ function $b512579b1150f905$export$1ddcc6bab2bf2314(skipValidateSubtleCrypto) {
    if (!window) throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$932e0f52d657f7fb));
    if (!window.crypto) throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$6319761d10f0cc4c));
    if (!skipValidateSubtleCrypto && !window.crypto.subtle) throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$6319761d10f0cc4c), $b512579b1150f905$var$SUBTLE_SUBERROR);
}
/**
 * Returns a sha-256 hash of the given dataString as an ArrayBuffer.
 * @param dataString {string} data string
 * @param performanceClient {?IPerformanceClient}
 * @param correlationId {?string} correlation id
 */ async function $b512579b1150f905$export$52caff7bddbaf316(dataString, performanceClient, correlationId) {
    performanceClient?.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).Sha256Digest, correlationId);
    const encoder = new TextEncoder();
    const data = encoder.encode(dataString);
    return window.crypto.subtle.digest($b512579b1150f905$var$S256_HASH_ALG, data);
}
/**
 * Populates buffer with cryptographically random values.
 * @param dataBuffer
 */ function $b512579b1150f905$export$960b9ff25e7d4257(dataBuffer) {
    return window.crypto.getRandomValues(dataBuffer);
}
/**
 * Returns random Uint32 value.
 * @returns {number}
 */ function $b512579b1150f905$var$getRandomUint32() {
    window.crypto.getRandomValues($b512579b1150f905$var$UINT32_ARR);
    return $b512579b1150f905$var$UINT32_ARR[0];
}
/**
 * Creates a UUID v7 from the current timestamp.
 * Implementation relies on the system clock to guarantee increasing order of generated identifiers.
 * @returns {number}
 */ function $b512579b1150f905$export$6ef0355fa80a5278() {
    const currentTimestamp = Date.now();
    const baseRand = $b512579b1150f905$var$getRandomUint32() * 0x400 + ($b512579b1150f905$var$getRandomUint32() & 0x3ff);
    // Result byte array
    const bytes = new Uint8Array(16);
    // A 12-bit `rand_a` field value
    const randA = Math.trunc(baseRand / 2 ** 30);
    // The higher 30 bits of 62-bit `rand_b` field value
    const randBHi = baseRand & 2 ** 30 - 1;
    // The lower 32 bits of 62-bit `rand_b` field value
    const randBLo = $b512579b1150f905$var$getRandomUint32();
    bytes[0] = currentTimestamp / 2 ** 40;
    bytes[1] = currentTimestamp / 2 ** 32;
    bytes[2] = currentTimestamp / 2 ** 24;
    bytes[3] = currentTimestamp / 2 ** 16;
    bytes[4] = currentTimestamp / 256;
    bytes[5] = currentTimestamp;
    bytes[6] = 0x70 | randA >>> 8;
    bytes[7] = randA;
    bytes[8] = 0x80 | randBHi >>> 24;
    bytes[9] = randBHi >>> 16;
    bytes[10] = randBHi >>> 8;
    bytes[11] = randBHi;
    bytes[12] = randBLo >>> 24;
    bytes[13] = randBLo >>> 16;
    bytes[14] = randBLo >>> 8;
    bytes[15] = randBLo;
    let text = "";
    for(let i = 0; i < bytes.length; i++){
        text += $b512579b1150f905$var$UUID_CHARS.charAt(bytes[i] >>> 4);
        text += $b512579b1150f905$var$UUID_CHARS.charAt(bytes[i] & 0xf);
        if (i === 3 || i === 5 || i === 7 || i === 9) text += "-";
    }
    return text;
}
/**
 * Generates a keypair based on current keygen algorithm config.
 * @param extractable
 * @param usages
 */ async function $b512579b1150f905$export$a949d36eab55b41f(extractable, usages) {
    return window.crypto.subtle.generateKey($b512579b1150f905$var$keygenAlgorithmOptions, extractable, usages);
}
/**
 * Export key as Json Web Key (JWK)
 * @param key
 */ async function $b512579b1150f905$export$88781b8595a7d2ff(key) {
    return window.crypto.subtle.exportKey((0, $091acf4c2675819b$export$1294c3e3f84694cd), key);
}
/**
 * Imports key as Json Web Key (JWK), can set extractable and usages.
 * @param key
 * @param extractable
 * @param usages
 */ async function $b512579b1150f905$export$8bdea4e2e3f593c9(key, extractable, usages) {
    return window.crypto.subtle.importKey((0, $091acf4c2675819b$export$1294c3e3f84694cd), key, $b512579b1150f905$var$keygenAlgorithmOptions, extractable, usages);
}
/**
 * Signs given data with given key
 * @param key
 * @param data
 */ async function $b512579b1150f905$export$c5552dfdbc7cec71(key, data) {
    return window.crypto.subtle.sign($b512579b1150f905$var$keygenAlgorithmOptions, key, data);
}
/**
 * Returns the SHA-256 hash of an input string
 * @param plainText
 */ async function $b512579b1150f905$export$9169be2e06c9c165(plainText) {
    const hashBuffer = await $b512579b1150f905$export$52caff7bddbaf316(plainText);
    const hashBytes = new Uint8Array(hashBuffer);
    return (0, $3665c4f98d09cc5b$export$84f5a428c7153a69)(hashBytes);
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 
/*! @azure/msal-browser v3.30.0 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $a9716436b0450272$export$41d7a3d4e14d6113 = "storage_not_supported";
const $a9716436b0450272$export$1377ea690fa0b6d8 = "stubbed_public_client_application_called";
const $a9716436b0450272$export$37486e3b6bed61c6 = "in_mem_redirect_unavailable";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $d1b404816c4f6b37$export$a14089932466e176 = {
    [(0, $a9716436b0450272$export$41d7a3d4e14d6113)]: "Given storage configuration option was not supported.",
    [(0, $a9716436b0450272$export$1377ea690fa0b6d8)]: "Stub instance of Public Client Application was called. If using msal-react, please ensure context is not used without a provider. For more visit: aka.ms/msaljs/browser-errors",
    [(0, $a9716436b0450272$export$37486e3b6bed61c6)]: "Redirect cannot be supported. In-memory storage was selected and storeAuthStateInCookie=false, which would cause the library to be unable to handle the incoming hash. If you would like to use the redirect API, please use session/localStorage or set storeAuthStateInCookie=true."
};
/**
 * BrowserAuthErrorMessage class containing string constants used by error codes and messages.
 * @deprecated Use BrowserAuthErrorCodes instead
 */ const $d1b404816c4f6b37$export$daccd9364f884077 = {
    storageNotSupportedError: {
        code: (0, $a9716436b0450272$export$41d7a3d4e14d6113),
        desc: $d1b404816c4f6b37$export$a14089932466e176[0, $a9716436b0450272$export$41d7a3d4e14d6113]
    },
    stubPcaInstanceCalled: {
        code: (0, $a9716436b0450272$export$1377ea690fa0b6d8),
        desc: $d1b404816c4f6b37$export$a14089932466e176[0, $a9716436b0450272$export$1377ea690fa0b6d8]
    },
    inMemRedirectUnavailable: {
        code: (0, $a9716436b0450272$export$37486e3b6bed61c6),
        desc: $d1b404816c4f6b37$export$a14089932466e176[0, $a9716436b0450272$export$37486e3b6bed61c6]
    }
};
/**
 * Browser library error class thrown by the MSAL.js library for SPAs
 */ class $d1b404816c4f6b37$export$2eb7a1dfdc4c5fba extends (0, $53b49d8334c1646a$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage){
        super(errorCode, errorMessage);
        this.name = "BrowserConfigurationAuthError";
        Object.setPrototypeOf(this, $d1b404816c4f6b37$export$2eb7a1dfdc4c5fba.prototype);
    }
}
function $d1b404816c4f6b37$export$176bd5050947ba0c(errorCode) {
    return new $d1b404816c4f6b37$export$2eb7a1dfdc4c5fba(errorCode, $d1b404816c4f6b37$export$a14089932466e176[errorCode]);
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Clears hash from window url.
 */ function $deacecf435b3f5ad$export$a20c3032ba81d6aa(contentWindow) {
    // Office.js sets history.replaceState to null
    contentWindow.location.hash = "";
    if (typeof contentWindow.history.replaceState === "function") // Full removes "#" from url
    contentWindow.history.replaceState(null, "", `${contentWindow.location.origin}${contentWindow.location.pathname}${contentWindow.location.search}`);
}
/**
 * Replaces current hash with hash from provided url
 */ function $deacecf435b3f5ad$export$9bf2691bda54425c(url) {
    const urlParts = url.split("#");
    urlParts.shift(); // Remove part before the hash
    window.location.hash = urlParts.length > 0 ? urlParts.join("#") : "";
}
/**
 * Returns boolean of whether the current window is in an iframe or not.
 */ function $deacecf435b3f5ad$export$9f140ed41af5108c() {
    return window.parent !== window;
}
/**
 * Returns boolean of whether or not the current window is a popup opened by msal
 */ function $deacecf435b3f5ad$export$722fdce8786cc28b() {
    return typeof window !== "undefined" && !!window.opener && window.opener !== window && typeof window.name === "string" && window.name.indexOf(`${(0, $091acf4c2675819b$export$a0a689e4294b9880).POPUP_NAME_PREFIX}.`) === 0;
}
// #endregion
/**
 * Returns current window URL as redirect uri
 */ function $deacecf435b3f5ad$export$1204531fbbf6ecde() {
    return typeof window !== "undefined" && window.location ? window.location.href.split("?")[0].split("#")[0] : "";
}
/**
 * Gets the homepage url for the current window location.
 */ function $deacecf435b3f5ad$export$60785768478b4ffc() {
    const currentUrl = new (0, $ff2860ddbc741970$export$3abcdca7229e54f2)(window.location.href);
    const urlComponents = currentUrl.getUrlComponents();
    return `${urlComponents.Protocol}//${urlComponents.HostNameAndPort}/`;
}
/**
 * Throws error if we have completed an auth and are
 * attempting another auth request inside an iframe.
 */ function $deacecf435b3f5ad$export$8fdba407d8e31f54() {
    const isResponseHash = (0, $ff2860ddbc741970$export$3abcdca7229e54f2).hashContainsKnownProperties(window.location.hash);
    // return an error if called from the hidden iframe created by the msal js silent calls
    if (isResponseHash && $deacecf435b3f5ad$export$9f140ed41af5108c()) throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$71bafc2814e56c09));
}
/**
 * Block redirect operations in iframes unless explicitly allowed
 * @param interactionType Interaction type for the request
 * @param allowRedirectInIframe Config value to allow redirects when app is inside an iframe
 */ function $deacecf435b3f5ad$export$5ae6b09f947c8a9e(allowRedirectInIframe) {
    if ($deacecf435b3f5ad$export$9f140ed41af5108c() && !allowRedirectInIframe) // If we are not in top frame, we shouldn't redirect. This is also handled by the service.
    throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$9cc12eb574ceee30));
}
/**
 * Block redirectUri loaded in popup from calling AcquireToken APIs
 */ function $deacecf435b3f5ad$export$dc99b653c8cd2cd7() {
    // Popups opened by msal popup APIs are given a name that starts with "msal."
    if ($deacecf435b3f5ad$export$722fdce8786cc28b()) throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$c4a80c97d7b48f72));
}
/**
 * Throws error if token requests are made in non-browser environment
 * @param isBrowserEnvironment Flag indicating if environment is a browser.
 */ function $deacecf435b3f5ad$export$c7939bfe92ae2787() {
    if (typeof window === "undefined") throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$932e0f52d657f7fb));
}
/**
 * Throws error if initialize hasn't been called
 * @param initialized
 */ function $deacecf435b3f5ad$export$630119c5db8b5529(initialized) {
    if (!initialized) throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$436657cdcd7fe2be));
}
/**
 * Helper to validate app environment before making an auth request
 * @param initialized
 */ function $deacecf435b3f5ad$export$4dd091cbdc98b52e(initialized) {
    // Block request if not in browser environment
    $deacecf435b3f5ad$export$c7939bfe92ae2787();
    // Block auth requests inside a hidden iframe
    $deacecf435b3f5ad$export$8fdba407d8e31f54();
    // Block redirectUri opened in a popup from calling MSAL APIs
    $deacecf435b3f5ad$export$dc99b653c8cd2cd7();
    // Block token acquisition before initialize has been called
    $deacecf435b3f5ad$export$630119c5db8b5529(initialized);
}
/**
 * Helper to validate app enviornment before making redirect request
 * @param initialized
 * @param config
 */ function $deacecf435b3f5ad$export$62c8f4fdca4df60f(initialized, config) {
    $deacecf435b3f5ad$export$4dd091cbdc98b52e(initialized);
    $deacecf435b3f5ad$export$5ae6b09f947c8a9e(config.system.allowRedirectInIframe);
    // Block redirects if memory storage is enabled but storeAuthStateInCookie is not
    if (config.cache.cacheLocation === (0, $091acf4c2675819b$export$573384e47a12d835).MemoryStorage && !config.cache.storeAuthStateInCookie) throw (0, $d1b404816c4f6b37$export$176bd5050947ba0c)((0, $a9716436b0450272$export$37486e3b6bed61c6));
}
/**
 * Adds a preconnect link element to the header which begins DNS resolution and SSL connection in anticipation of the /token request
 * @param loginDomain Authority domain, including https protocol e.g. https://login.microsoftonline.com
 * @returns
 */ function $deacecf435b3f5ad$export$a0816fa17a9e79be(authority) {
    const link = document.createElement("link");
    link.rel = "preconnect";
    link.href = new URL(authority).origin;
    link.crossOrigin = "anonymous";
    document.head.appendChild(link);
    // The browser will close connection if not used within a few seconds, remove element from the header after 10s
    window.setTimeout(()=>{
        try {
            document.head.removeChild(link);
        } catch  {}
    }, 10000); // 10s Timeout
}
/**
 * Wrapper function that creates a UUID v7 from the current timestamp.
 * @returns {string}
 */ function $deacecf435b3f5ad$export$7571c350ed9fec74() {
    return (0, $b512579b1150f905$export$6ef0355fa80a5278)();
}


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Default timeout for popup windows and iframes in milliseconds
const $06f12bd748d4f674$export$a5835ee54399d410 = 60000;
const $06f12bd748d4f674$export$f3ffe700be354b19 = 10000;
const $06f12bd748d4f674$export$293647e7865520c6 = 30000;
const $06f12bd748d4f674$export$73d1d87a8b7ddb57 = 2000;
/**
 * MSAL function that sets the default options when not explicitly configured from app developer
 *
 * @param auth
 * @param cache
 * @param system
 *
 * @returns Configuration object
 */ function $06f12bd748d4f674$export$f8352245bee68086({ auth: userInputAuth, cache: userInputCache, system: userInputSystem, telemetry: userInputTelemetry }, isBrowserEnvironment) {
    // Default auth options for browser
    const DEFAULT_AUTH_OPTIONS = {
        clientId: (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING,
        authority: `${(0, $08c107807d753255$export$a002182e51710d39).DEFAULT_AUTHORITY}`,
        knownAuthorities: [],
        cloudDiscoveryMetadata: (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING,
        authorityMetadata: (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING,
        redirectUri: typeof window !== "undefined" ? (0, $deacecf435b3f5ad$export$1204531fbbf6ecde)() : "",
        postLogoutRedirectUri: (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING,
        navigateToLoginRequestUrl: true,
        clientCapabilities: [],
        protocolMode: (0, $a47d2ec0503d310c$export$73a3e3dedd37150d).AAD,
        OIDCOptions: {
            serverResponseType: (0, $08c107807d753255$export$b34cb6fbea2adc44).FRAGMENT,
            defaultScopes: [
                (0, $08c107807d753255$export$a002182e51710d39).OPENID_SCOPE,
                (0, $08c107807d753255$export$a002182e51710d39).PROFILE_SCOPE,
                (0, $08c107807d753255$export$a002182e51710d39).OFFLINE_ACCESS_SCOPE
            ]
        },
        azureCloudOptions: {
            azureCloudInstance: (0, $7ae45af95b45dab9$export$4cda21933050d9ec).None,
            tenant: (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING
        },
        skipAuthorityMetadataCache: false,
        supportsNestedAppAuth: false,
        instanceAware: false
    };
    // Default cache options for browser
    const DEFAULT_CACHE_OPTIONS = {
        cacheLocation: (0, $091acf4c2675819b$export$573384e47a12d835).SessionStorage,
        temporaryCacheLocation: (0, $091acf4c2675819b$export$573384e47a12d835).SessionStorage,
        storeAuthStateInCookie: false,
        secureCookies: false,
        // Default cache migration to true if cache location is localStorage since entries are preserved across tabs/windows. Migration has little to no benefit in sessionStorage and memoryStorage
        cacheMigrationEnabled: userInputCache && userInputCache.cacheLocation === (0, $091acf4c2675819b$export$573384e47a12d835).LocalStorage ? true : false,
        claimsBasedCachingEnabled: false
    };
    // Default logger options for browser
    const DEFAULT_LOGGER_OPTIONS = {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        loggerCallback: ()=>{
        // allow users to not set logger call back
        },
        logLevel: (0, $4643cd557adfd6d5$export$243e62d78d3b544d).Info,
        piiLoggingEnabled: false
    };
    // Default system options for browser
    const DEFAULT_BROWSER_SYSTEM_OPTIONS = {
        ...(0, $44a243886d8c290a$export$f7a7dd6bfc156d75),
        loggerOptions: DEFAULT_LOGGER_OPTIONS,
        networkClient: isBrowserEnvironment ? new (0, $a9a81d90f5cc8475$export$4c206ef5be879972)() : (0, $3957fd5ca920db1c$export$6d95060a8ed7155a),
        navigationClient: new (0, $a838f8b4c4f03b05$export$d0d362a73d466c9b)(),
        loadFrameTimeout: 0,
        // If loadFrameTimeout is provided, use that as default.
        windowHashTimeout: userInputSystem?.loadFrameTimeout || $06f12bd748d4f674$export$a5835ee54399d410,
        iframeHashTimeout: userInputSystem?.loadFrameTimeout || $06f12bd748d4f674$export$f3ffe700be354b19,
        navigateFrameWait: 0,
        redirectNavigationTimeout: $06f12bd748d4f674$export$293647e7865520c6,
        asyncPopups: false,
        allowRedirectInIframe: false,
        allowNativeBroker: false,
        nativeBrokerHandshakeTimeout: userInputSystem?.nativeBrokerHandshakeTimeout || $06f12bd748d4f674$export$73d1d87a8b7ddb57,
        pollIntervalMilliseconds: (0, $091acf4c2675819b$export$a0a689e4294b9880).DEFAULT_POLL_INTERVAL_MS
    };
    const providedSystemOptions = {
        ...DEFAULT_BROWSER_SYSTEM_OPTIONS,
        ...userInputSystem,
        loggerOptions: userInputSystem?.loggerOptions || DEFAULT_LOGGER_OPTIONS
    };
    const DEFAULT_TELEMETRY_OPTIONS = {
        application: {
            appName: (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING,
            appVersion: (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING
        },
        client: new (0, $1b6245e94168f9ed$export$c70f2989a65fda3e)()
    };
    // Throw an error if user has set OIDCOptions without being in OIDC protocol mode
    if (userInputAuth?.protocolMode !== (0, $a47d2ec0503d310c$export$73a3e3dedd37150d).OIDC && userInputAuth?.OIDCOptions) {
        const logger = new (0, $4643cd557adfd6d5$export$efa9a398d6368992)(providedSystemOptions.loggerOptions);
        logger.warning(JSON.stringify((0, $a6f096219dc1b547$export$5d63d098f4f130a1)((0, $f66a3d6fc9f2eb73$exports).cannotSetOIDCOptions)));
    }
    // Throw an error if user has set allowNativeBroker to true without being in AAD protocol mode
    if (userInputAuth?.protocolMode && userInputAuth.protocolMode !== (0, $a47d2ec0503d310c$export$73a3e3dedd37150d).AAD && providedSystemOptions?.allowNativeBroker) throw (0, $a6f096219dc1b547$export$5d63d098f4f130a1)((0, $f66a3d6fc9f2eb73$exports).cannotAllowNativeBroker);
    const overlayedConfig = {
        auth: {
            ...DEFAULT_AUTH_OPTIONS,
            ...userInputAuth,
            OIDCOptions: {
                ...DEFAULT_AUTH_OPTIONS.OIDCOptions,
                ...userInputAuth?.OIDCOptions
            }
        },
        cache: {
            ...DEFAULT_CACHE_OPTIONS,
            ...userInputCache
        },
        system: providedSystemOptions,
        telemetry: {
            ...DEFAULT_TELEMETRY_OPTIONS,
            ...userInputTelemetry
        }
    };
    return overlayedConfig;
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 'use strict';
/* eslint-disable header/header */ const $f42d0d3ccc24f1b6$export$a8ff84c12d48cfa6 = "@azure/msal-browser";
const $f42d0d3ccc24f1b6$export$83d89fbfd8236492 = "3.30.0";



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Base class for operating context
 * Operating contexts are contexts in which MSAL.js is being run
 * More than one operating context may be available at a time
 * It's important from a logging and telemetry point of view for us to be able to identify the operating context.
 * For example: Some operating contexts will pre-cache tokens impacting performance telemetry
 */ class $c6385b2c6376fb77$export$3aea257f46651b2b {
    static loggerCallback(level, message) {
        switch(level){
            case (0, $4643cd557adfd6d5$export$243e62d78d3b544d).Error:
                // eslint-disable-next-line no-console
                console.error(message);
                return;
            case (0, $4643cd557adfd6d5$export$243e62d78d3b544d).Info:
                // eslint-disable-next-line no-console
                console.info(message);
                return;
            case (0, $4643cd557adfd6d5$export$243e62d78d3b544d).Verbose:
                // eslint-disable-next-line no-console
                console.debug(message);
                return;
            case (0, $4643cd557adfd6d5$export$243e62d78d3b544d).Warning:
                // eslint-disable-next-line no-console
                console.warn(message);
                return;
            default:
                // eslint-disable-next-line no-console
                console.log(message);
                return;
        }
    }
    constructor(config){
        /*
         * If loaded in an environment where window is not available,
         * set internal flag to false so that further requests fail.
         * This is to support server-side rendering environments.
         */ this.browserEnvironment = typeof window !== "undefined";
        this.config = (0, $06f12bd748d4f674$export$f8352245bee68086)(config, this.browserEnvironment);
        let sessionStorage;
        try {
            sessionStorage = window[(0, $091acf4c2675819b$export$573384e47a12d835).SessionStorage];
        // Mute errors if it's a non-browser environment or cookies are blocked.
        } catch (e) {}
        const logLevelKey = sessionStorage?.getItem((0, $091acf4c2675819b$export$b28668d53eb57e63));
        const piiLoggingKey = sessionStorage?.getItem((0, $091acf4c2675819b$export$d9bc1c202a3825f1))?.toLowerCase();
        const piiLoggingEnabled = piiLoggingKey === "true" ? true : piiLoggingKey === "false" ? false : undefined;
        const loggerOptions = {
            ...this.config.system.loggerOptions
        };
        const logLevel = logLevelKey && Object.keys((0, $4643cd557adfd6d5$export$243e62d78d3b544d)).includes(logLevelKey) ? (0, $4643cd557adfd6d5$export$243e62d78d3b544d)[logLevelKey] : undefined;
        if (logLevel) {
            loggerOptions.loggerCallback = $c6385b2c6376fb77$export$3aea257f46651b2b.loggerCallback;
            loggerOptions.logLevel = logLevel;
        }
        if (piiLoggingEnabled !== undefined) loggerOptions.piiLoggingEnabled = piiLoggingEnabled;
        this.logger = new (0, $4643cd557adfd6d5$export$efa9a398d6368992)(loggerOptions, (0, $f42d0d3ccc24f1b6$export$a8ff84c12d48cfa6), (0, $f42d0d3ccc24f1b6$export$83d89fbfd8236492));
        this.available = false;
    }
    /**
     * Return the MSAL config
     * @returns BrowserConfiguration
     */ getConfig() {
        return this.config;
    }
    /**
     * Returns the MSAL Logger
     * @returns Logger
     */ getLogger() {
        return this.logger;
    }
    isAvailable() {
        return this.available;
    }
    isBrowserEnvironment() {
        return this.browserEnvironment;
    }
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ /*! @azure/msal-browser v3.30.0 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $d78de803a4cae362$export$6d05f68c12a46a00 = {
    UserInteractionRequired: "USER_INTERACTION_REQUIRED",
    UserCancel: "USER_CANCEL",
    NoNetwork: "NO_NETWORK",
    TransientError: "TRANSIENT_ERROR",
    PersistentError: "PERSISTENT_ERROR",
    Disabled: "DISABLED",
    AccountUnavailable: "ACCOUNT_UNAVAILABLE",
    NestedAppAuthUnavailable: "NESTED_APP_AUTH_UNAVAILABLE"
};





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * BridgeProxy
 * Provides a proxy for accessing a bridge to a host app and/or
 * platform broker
 */ class $4346f4a9639c434a$export$d974b2d5dad1979e {
    /**
     * initializeNestedAppAuthBridge - Initializes the bridge to the host app
     * @returns a promise that resolves to an InitializeBridgeResponse or rejects with an Error
     * @remarks This method will be called by the create factory method
     * @remarks If the bridge is not available, this method will throw an error
     */ static async initializeNestedAppAuthBridge() {
        if (window === undefined) throw new Error("window is undefined");
        if (window.nestedAppAuthBridge === undefined) throw new Error("window.nestedAppAuthBridge is undefined");
        try {
            window.nestedAppAuthBridge.addEventListener("message", (response)=>{
                const responsePayload = typeof response === "string" ? response : response.data;
                const responseEnvelope = JSON.parse(responsePayload);
                const request = $4346f4a9639c434a$export$d974b2d5dad1979e.bridgeRequests.find((element)=>element.requestId === responseEnvelope.requestId);
                if (request !== undefined) {
                    $4346f4a9639c434a$export$d974b2d5dad1979e.bridgeRequests.splice($4346f4a9639c434a$export$d974b2d5dad1979e.bridgeRequests.indexOf(request), 1);
                    if (responseEnvelope.success) request.resolve(responseEnvelope);
                    else request.reject(responseEnvelope.error);
                }
            });
            const bridgeResponse = await new Promise((resolve, reject)=>{
                const message = $4346f4a9639c434a$export$d974b2d5dad1979e.buildRequest("GetInitContext");
                const request = {
                    requestId: message.requestId,
                    method: message.method,
                    resolve: resolve,
                    reject: reject
                };
                $4346f4a9639c434a$export$d974b2d5dad1979e.bridgeRequests.push(request);
                window.nestedAppAuthBridge.postMessage(JSON.stringify(message));
            });
            return $4346f4a9639c434a$export$d974b2d5dad1979e.validateBridgeResultOrThrow(bridgeResponse.initContext);
        } catch (error) {
            window.console.log(error);
            throw error;
        }
    }
    /**
     * getTokenInteractive - Attempts to get a token interactively from the bridge
     * @param request A token request
     * @returns a promise that resolves to an auth result or rejects with a BridgeError
     */ getTokenInteractive(request) {
        return this.getToken("GetTokenPopup", request);
    }
    /**
     * getTokenSilent Attempts to get a token silently from the bridge
     * @param request A token request
     * @returns a promise that resolves to an auth result or rejects with a BridgeError
     */ getTokenSilent(request) {
        return this.getToken("GetToken", request);
    }
    async getToken(requestType, request) {
        const result = await this.sendRequest(requestType, {
            tokenParams: request
        });
        return {
            token: $4346f4a9639c434a$export$d974b2d5dad1979e.validateBridgeResultOrThrow(result.token),
            account: $4346f4a9639c434a$export$d974b2d5dad1979e.validateBridgeResultOrThrow(result.account)
        };
    }
    getHostCapabilities() {
        return this.capabilities ?? null;
    }
    getAccountContext() {
        return this.accountContext ? this.accountContext : null;
    }
    static buildRequest(method, requestParams) {
        return {
            messageType: "NestedAppAuthRequest",
            method: method,
            requestId: (0, $b512579b1150f905$export$6ef0355fa80a5278)(),
            sendTime: Date.now(),
            clientLibrary: (0, $091acf4c2675819b$export$a0a689e4294b9880).MSAL_SKU,
            clientLibraryVersion: (0, $f42d0d3ccc24f1b6$export$83d89fbfd8236492),
            ...requestParams
        };
    }
    /**
     * A method used to send a request to the bridge
     * @param request A token request
     * @returns a promise that resolves to a response of provided type or rejects with a BridgeError
     */ sendRequest(method, requestParams) {
        const message = $4346f4a9639c434a$export$d974b2d5dad1979e.buildRequest(method, requestParams);
        const promise = new Promise((resolve, reject)=>{
            const request = {
                requestId: message.requestId,
                method: message.method,
                resolve: resolve,
                reject: reject
            };
            $4346f4a9639c434a$export$d974b2d5dad1979e.bridgeRequests.push(request);
            window.nestedAppAuthBridge.postMessage(JSON.stringify(message));
        });
        return promise;
    }
    static validateBridgeResultOrThrow(input) {
        if (input === undefined) {
            const bridgeError = {
                status: (0, $d78de803a4cae362$export$6d05f68c12a46a00).NestedAppAuthUnavailable
            };
            throw bridgeError;
        }
        return input;
    }
    /**
     * Private constructor for BridgeProxy
     * @param sdkName The name of the SDK being used to make requests on behalf of the app
     * @param sdkVersion The version of the SDK being used to make requests on behalf of the app
     * @param capabilities The capabilities of the bridge / SDK / platform broker
     */ constructor(sdkName, sdkVersion, accountContext, capabilities){
        this.sdkName = sdkName;
        this.sdkVersion = sdkVersion;
        this.accountContext = accountContext;
        this.capabilities = capabilities;
    }
    /**
     * Factory method for creating an implementation of IBridgeProxy
     * @returns A promise that resolves to a BridgeProxy implementation
     */ static async create() {
        const response = await $4346f4a9639c434a$export$d974b2d5dad1979e.initializeNestedAppAuthBridge();
        return new $4346f4a9639c434a$export$d974b2d5dad1979e(response.sdkName, response.sdkVersion, response.accountContext, response.capabilities);
    }
}
$4346f4a9639c434a$export$d974b2d5dad1979e.bridgeRequests = [];


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $a94b06492cd1639d$export$a2170d4e3f010950 extends (0, $c6385b2c6376fb77$export$3aea257f46651b2b) {
    constructor(){
        super(...arguments);
        this.bridgeProxy = undefined;
        this.accountContext = null;
    }
    /**
     * Return the module name.  Intended for use with import() to enable dynamic import
     * of the implementation associated with this operating context
     * @returns
     */ getModuleName() {
        return $a94b06492cd1639d$export$a2170d4e3f010950.MODULE_NAME;
    }
    /**
     * Returns the unique identifier for this operating context
     * @returns string
     */ getId() {
        return $a94b06492cd1639d$export$a2170d4e3f010950.ID;
    }
    /**
     * Returns the current BridgeProxy
     * @returns IBridgeProxy | undefined
     */ getBridgeProxy() {
        return this.bridgeProxy;
    }
    /**
     * Checks whether the operating context is available.
     * Confirms that the code is running a browser rather.  This is required.
     * @returns Promise<boolean> indicating whether this operating context is currently available.
     */ async initialize() {
        try {
            if (typeof window !== "undefined") {
                if (typeof window.__initializeNestedAppAuth === "function") await window.__initializeNestedAppAuth();
                const bridgeProxy = await (0, $4346f4a9639c434a$export$d974b2d5dad1979e).create();
                /*
                 * Because we want single sign on we expect the host app to provide the account context
                 * with a min set of params that can be used to identify the account
                 * this.account = nestedApp.getAccountByFilter(bridgeProxy.getAccountContext());
                 */ this.accountContext = bridgeProxy.getAccountContext();
                this.bridgeProxy = bridgeProxy;
                this.available = bridgeProxy !== undefined;
            }
        } catch (ex) {
            this.logger.infoPii(`Could not initialize Nested App Auth bridge (${ex})`);
        }
        this.logger.info(`Nested App Auth Bridge available: ${this.available}`);
        return this.available;
    }
}
/*
 * TODO: Once we have determine the bundling code return here to specify the name of the bundle
 * containing the implementation for this operating context
 */ $a94b06492cd1639d$export$a2170d4e3f010950.MODULE_NAME = "";
/**
 * Unique identifier for the operating context
 */ $a94b06492cd1639d$export$a2170d4e3f010950.ID = "NestedAppOperatingContext";


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $58111f41d057aaf0$export$f39c23bbfed89e6e extends (0, $c6385b2c6376fb77$export$3aea257f46651b2b) {
    /**
     * Return the module name.  Intended for use with import() to enable dynamic import
     * of the implementation associated with this operating context
     * @returns
     */ getModuleName() {
        return $58111f41d057aaf0$export$f39c23bbfed89e6e.MODULE_NAME;
    }
    /**
     * Returns the unique identifier for this operating context
     * @returns string
     */ getId() {
        return $58111f41d057aaf0$export$f39c23bbfed89e6e.ID;
    }
    /**
     * Checks whether the operating context is available.
     * Confirms that the code is running a browser rather.  This is required.
     * @returns Promise<boolean> indicating whether this operating context is currently available.
     */ async initialize() {
        this.available = typeof window !== "undefined";
        return this.available;
    /*
         * NOTE: The standard context is available as long as there is a window.  If/when we split out WAM from Browser
         * We can move the current contents of the initialize method to here and verify that the WAM extension is available
         */ }
}
/*
 * TODO: Once we have determine the bundling code return here to specify the name of the bundle
 * containing the implementation for this operating context
 */ $58111f41d057aaf0$export$f39c23bbfed89e6e.MODULE_NAME = "";
/**
 * Unique identifier for the operating context
 */ $58111f41d057aaf0$export$f39c23bbfed89e6e.ID = "StandardOperatingContext";


/*! @azure/msal-browser v3.30.0 2025-08-05 */ /*! @azure/msal-browser v3.30.0 2025-08-05 */ /*! @azure/msal-common v14.16.1 2025-08-05 */ /*! @azure/msal-common v14.16.1 2025-08-05 */ 
/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $b7eb3d7e7c4c096a$export$e2ac717a196f20ed = "missing_kid_error";
const $b7eb3d7e7c4c096a$export$de67390d0a514010 = "missing_alg_error";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $940a01af24cecfce$export$ce96a12d056376ad = {
    [(0, $b7eb3d7e7c4c096a$export$e2ac717a196f20ed)]: "The JOSE Header for the requested JWT, JWS or JWK object requires a keyId to be configured as the 'kid' header claim. No 'kid' value was provided.",
    [(0, $b7eb3d7e7c4c096a$export$de67390d0a514010)]: "The JOSE Header for the requested JWT, JWS or JWK object requires an algorithm to be specified as the 'alg' header claim. No 'alg' value was provided."
};
/**
 * Error thrown when there is an error in the client code running on the browser.
 */ class $940a01af24cecfce$export$980ad46b7a115fad extends (0, $53b49d8334c1646a$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage){
        super(errorCode, errorMessage);
        this.name = "JoseHeaderError";
        Object.setPrototypeOf(this, $940a01af24cecfce$export$980ad46b7a115fad.prototype);
    }
}
/** Returns JoseHeaderError object */ function $940a01af24cecfce$export$3ef463ea134172ed(code) {
    return new $940a01af24cecfce$export$980ad46b7a115fad(code, $940a01af24cecfce$export$ce96a12d056376ad[code]);
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /** @internal */ class $aad628ffe34c7973$export$91748d132e6cb9b3 {
    constructor(options){
        this.typ = options.typ;
        this.alg = options.alg;
        this.kid = options.kid;
    }
    /**
     * Builds SignedHttpRequest formatted JOSE Header from the
     * JOSE Header options provided or previously set on the object and returns
     * the stringified header object.
     * Throws if keyId or algorithm aren't provided since they are required for Access Token Binding.
     * @param shrHeaderOptions
     * @returns
     */ static getShrHeaderString(shrHeaderOptions) {
        // KeyID is required on the SHR header
        if (!shrHeaderOptions.kid) throw (0, $940a01af24cecfce$export$3ef463ea134172ed)((0, $b7eb3d7e7c4c096a$export$e2ac717a196f20ed));
        // Alg is required on the SHR header
        if (!shrHeaderOptions.alg) throw (0, $940a01af24cecfce$export$3ef463ea134172ed)((0, $b7eb3d7e7c4c096a$export$de67390d0a514010));
        const shrHeader = new $aad628ffe34c7973$export$91748d132e6cb9b3({
            // Access Token PoP headers must have type pop, but the type header can be overriden for special cases
            typ: shrHeaderOptions.typ || (0, $08c107807d753255$export$fe5c42ed17efe603).Pop,
            kid: shrHeaderOptions.kid,
            alg: shrHeaderOptions.alg
        });
        return JSON.stringify(shrHeader);
    }
}



/*! @azure/msal-browser v3.30.0 2025-08-05 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class which exposes APIs to decode base64 strings to plaintext. See here for implementation details:
 * https://developer.mozilla.org/en-US/docs/Glossary/Base64#the_unicode_problem
 */ /**
 * Returns a URL-safe plaintext decoded string from b64 encoded input.
 * @param input
 */ function $823c1cd3d50f09ac$export$c62426fdd000a97e(input) {
    return new TextDecoder().decode($823c1cd3d50f09ac$var$base64DecToArr(input));
}
/**
 * Decodes base64 into Uint8Array
 * @param base64String
 */ function $823c1cd3d50f09ac$var$base64DecToArr(base64String) {
    let encodedString = base64String.replace(/-/g, "+").replace(/_/g, "/");
    switch(encodedString.length % 4){
        case 0:
            break;
        case 2:
            encodedString += "==";
            break;
        case 3:
            encodedString += "=";
            break;
        default:
            throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$fcc6790b5d12da63));
    }
    const binString = atob(encodedString);
    return Uint8Array.from(binString, (m)=>m.codePointAt(0) || 0);
}




/*! @azure/msal-browser v3.30.0 2025-08-05 */ 
/*! @azure/msal-browser v3.30.0 2025-08-05 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Storage wrapper for IndexedDB storage in browsers: https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API
 */ class $eedf57f7320f9a85$export$286b0f3b569e5f16 {
    constructor(){
        this.dbName = (0, $091acf4c2675819b$export$3c22ff8b64b8f565);
        this.version = (0, $091acf4c2675819b$export$6a9022b4c5fcea02);
        this.tableName = (0, $091acf4c2675819b$export$9d785db034fb436f);
        this.dbOpen = false;
    }
    /**
     * Opens IndexedDB instance.
     */ async open() {
        return new Promise((resolve, reject)=>{
            const openDB = window.indexedDB.open(this.dbName, this.version);
            openDB.addEventListener("upgradeneeded", (e)=>{
                const event = e;
                event.target.result.createObjectStore(this.tableName);
            });
            openDB.addEventListener("success", (e)=>{
                const event = e;
                this.db = event.target.result;
                this.dbOpen = true;
                resolve();
            });
            openDB.addEventListener("error", ()=>reject((0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$c1110692d2978b8))));
        });
    }
    /**
     * Closes the connection to IndexedDB database when all pending transactions
     * complete.
     */ closeConnection() {
        const db = this.db;
        if (db && this.dbOpen) {
            db.close();
            this.dbOpen = false;
        }
    }
    /**
     * Opens database if it's not already open
     */ async validateDbIsOpen() {
        if (!this.dbOpen) return this.open();
    }
    /**
     * Retrieves item from IndexedDB instance.
     * @param key
     */ async getItem(key) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            // TODO: Add timeouts?
            if (!this.db) return reject((0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$4752ced1a1a262f)));
            const transaction = this.db.transaction([
                this.tableName
            ], "readonly");
            const objectStore = transaction.objectStore(this.tableName);
            const dbGet = objectStore.get(key);
            dbGet.addEventListener("success", (e)=>{
                const event = e;
                this.closeConnection();
                resolve(event.target.result);
            });
            dbGet.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Adds item to IndexedDB under given key
     * @param key
     * @param payload
     */ async setItem(key, payload) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            // TODO: Add timeouts?
            if (!this.db) return reject((0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$4752ced1a1a262f)));
            const transaction = this.db.transaction([
                this.tableName
            ], "readwrite");
            const objectStore = transaction.objectStore(this.tableName);
            const dbPut = objectStore.put(payload, key);
            dbPut.addEventListener("success", ()=>{
                this.closeConnection();
                resolve();
            });
            dbPut.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Removes item from IndexedDB under given key
     * @param key
     */ async removeItem(key) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            if (!this.db) return reject((0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$4752ced1a1a262f)));
            const transaction = this.db.transaction([
                this.tableName
            ], "readwrite");
            const objectStore = transaction.objectStore(this.tableName);
            const dbDelete = objectStore.delete(key);
            dbDelete.addEventListener("success", ()=>{
                this.closeConnection();
                resolve();
            });
            dbDelete.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Get all the keys from the storage object as an iterable array of strings.
     */ async getKeys() {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            if (!this.db) return reject((0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$4752ced1a1a262f)));
            const transaction = this.db.transaction([
                this.tableName
            ], "readonly");
            const objectStore = transaction.objectStore(this.tableName);
            const dbGetKeys = objectStore.getAllKeys();
            dbGetKeys.addEventListener("success", (e)=>{
                const event = e;
                this.closeConnection();
                resolve(event.target.result);
            });
            dbGetKeys.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     *
     * Checks whether there is an object under the search key in the object store
     */ async containsKey(key) {
        await this.validateDbIsOpen();
        return new Promise((resolve, reject)=>{
            if (!this.db) return reject((0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$4752ced1a1a262f)));
            const transaction = this.db.transaction([
                this.tableName
            ], "readonly");
            const objectStore = transaction.objectStore(this.tableName);
            const dbContainsKey = objectStore.count(key);
            dbContainsKey.addEventListener("success", (e)=>{
                const event = e;
                this.closeConnection();
                resolve(event.target.result === 1);
            });
            dbContainsKey.addEventListener("error", (e)=>{
                this.closeConnection();
                reject(e);
            });
        });
    }
    /**
     * Deletes the MSAL database. The database is deleted rather than cleared to make it possible
     * for client applications to downgrade to a previous MSAL version without worrying about forward compatibility issues
     * with IndexedDB database versions.
     */ async deleteDatabase() {
        // Check if database being deleted exists
        if (this.db && this.dbOpen) this.closeConnection();
        return new Promise((resolve, reject)=>{
            const deleteDbRequest = window.indexedDB.deleteDatabase((0, $091acf4c2675819b$export$3c22ff8b64b8f565));
            const id = setTimeout(()=>reject(false), 200); // Reject if events aren't raised within 200ms
            deleteDbRequest.addEventListener("success", ()=>{
                clearTimeout(id);
                return resolve(true);
            });
            deleteDbRequest.addEventListener("blocked", ()=>{
                clearTimeout(id);
                return resolve(true);
            });
            deleteDbRequest.addEventListener("error", ()=>{
                clearTimeout(id);
                return reject(false);
            });
        });
    }
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $b85fe2fa055a4f1c$export$d7392285c701ecf5 {
    constructor(){
        this.cache = new Map();
    }
    getItem(key) {
        return this.cache.get(key) || null;
    }
    setItem(key, value) {
        this.cache.set(key, value);
    }
    removeItem(key) {
        this.cache.delete(key);
    }
    getKeys() {
        const cacheKeys = [];
        this.cache.forEach((value, key)=>{
            cacheKeys.push(key);
        });
        return cacheKeys;
    }
    containsKey(key) {
        return this.cache.has(key);
    }
    clear() {
        this.cache.clear();
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class allows MSAL to store artifacts asynchronously using the DatabaseStorage IndexedDB wrapper,
 * backed up with the more volatile MemoryStorage object for cases in which IndexedDB may be unavailable.
 */ class $698c513aeebe6a97$export$b38f35aab37afcde {
    constructor(logger){
        this.inMemoryCache = new (0, $b85fe2fa055a4f1c$export$d7392285c701ecf5)();
        this.indexedDBCache = new (0, $eedf57f7320f9a85$export$286b0f3b569e5f16)();
        this.logger = logger;
    }
    handleDatabaseAccessError(error) {
        if (error instanceof (0, $59d58688ac49ebc0$export$f8eb6760ca13876a) && error.errorCode === (0, $aa0e430adf0f9ba6$export$c1110692d2978b8)) this.logger.error("Could not access persistent storage. This may be caused by browser privacy features which block persistent storage in third-party contexts.");
        else throw error;
    }
    /**
     * Get the item matching the given key. Tries in-memory cache first, then in the asynchronous
     * storage object if item isn't found in-memory.
     * @param key
     */ async getItem(key) {
        const item = this.inMemoryCache.getItem(key);
        if (!item) try {
            this.logger.verbose("Queried item not found in in-memory cache, now querying persistent storage.");
            return await this.indexedDBCache.getItem(key);
        } catch (e) {
            this.handleDatabaseAccessError(e);
        }
        return item;
    }
    /**
     * Sets the item in the in-memory cache and then tries to set it in the asynchronous
     * storage object with the given key.
     * @param key
     * @param value
     */ async setItem(key, value) {
        this.inMemoryCache.setItem(key, value);
        try {
            await this.indexedDBCache.setItem(key, value);
        } catch (e) {
            this.handleDatabaseAccessError(e);
        }
    }
    /**
     * Removes the item matching the key from the in-memory cache, then tries to remove it from the asynchronous storage object.
     * @param key
     */ async removeItem(key) {
        this.inMemoryCache.removeItem(key);
        try {
            await this.indexedDBCache.removeItem(key);
        } catch (e) {
            this.handleDatabaseAccessError(e);
        }
    }
    /**
     * Get all the keys from the in-memory cache as an iterable array of strings. If no keys are found, query the keys in the
     * asynchronous storage object.
     */ async getKeys() {
        const cacheKeys = this.inMemoryCache.getKeys();
        if (cacheKeys.length === 0) try {
            this.logger.verbose("In-memory cache is empty, now querying persistent storage.");
            return await this.indexedDBCache.getKeys();
        } catch (e) {
            this.handleDatabaseAccessError(e);
        }
        return cacheKeys;
    }
    /**
     * Returns true or false if the given key is present in the cache.
     * @param key
     */ async containsKey(key) {
        const containsKey = this.inMemoryCache.containsKey(key);
        if (!containsKey) try {
            this.logger.verbose("Key not found in in-memory cache, now querying persistent storage.");
            return await this.indexedDBCache.containsKey(key);
        } catch (e) {
            this.handleDatabaseAccessError(e);
        }
        return containsKey;
    }
    /**
     * Clears in-memory Map
     */ clearInMemory() {
        // InMemory cache is a Map instance, clear is straightforward
        this.logger.verbose(`Deleting in-memory keystore`);
        this.inMemoryCache.clear();
        this.logger.verbose(`In-memory keystore deleted`);
    }
    /**
     * Tries to delete the IndexedDB database
     * @returns
     */ async clearPersistent() {
        try {
            this.logger.verbose("Deleting persistent keystore");
            const dbDeleted = await this.indexedDBCache.deleteDatabase();
            if (dbDeleted) this.logger.verbose("Persistent keystore deleted");
            return dbDeleted;
        } catch (e) {
            this.handleDatabaseAccessError(e);
            return false;
        }
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class implements MSAL's crypto interface, which allows it to perform base64 encoding and decoding, generating cryptographically random GUIDs and
 * implementing Proof Key for Code Exchange specs for the OAuth Authorization Code Flow using PKCE (rfc here: https://tools.ietf.org/html/rfc7636).
 */ class $b97228d657d79796$export$c274a7f0ebd24b14 {
    constructor(logger, performanceClient, skipValidateSubtleCrypto){
        this.logger = logger;
        // Browser crypto needs to be validated first before any other classes can be set.
        (0, $b512579b1150f905$export$1ddcc6bab2bf2314)(skipValidateSubtleCrypto ?? false);
        this.cache = new (0, $698c513aeebe6a97$export$b38f35aab37afcde)(this.logger);
        this.performanceClient = performanceClient;
    }
    /**
     * Creates a new random GUID - used to populate state and nonce.
     * @returns string (GUID)
     */ createNewGuid() {
        return (0, $b512579b1150f905$export$6ef0355fa80a5278)();
    }
    /**
     * Encodes input string to base64.
     * @param input
     */ base64Encode(input) {
        return (0, $3665c4f98d09cc5b$export$e510a73ee562749)(input);
    }
    /**
     * Decodes input string from base64.
     * @param input
     */ base64Decode(input) {
        return (0, $823c1cd3d50f09ac$export$c62426fdd000a97e)(input);
    }
    /**
     * Encodes input string to base64 URL safe string.
     * @param input
     */ base64UrlEncode(input) {
        return (0, $3665c4f98d09cc5b$export$9ef804feabbcbaf1)(input);
    }
    /**
     * Stringifies and base64Url encodes input public key
     * @param inputKid
     * @returns Base64Url encoded public key
     */ encodeKid(inputKid) {
        return this.base64UrlEncode(JSON.stringify({
            kid: inputKid
        }));
    }
    /**
     * Generates a keypair, stores it and returns a thumbprint
     * @param request
     */ async getPublicKeyThumbprint(request) {
        const publicKeyThumbMeasurement = this.performanceClient?.startMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).CryptoOptsGetPublicKeyThumbprint, request.correlationId);
        // Generate Keypair
        const keyPair = await (0, $b512579b1150f905$export$a949d36eab55b41f)($b97228d657d79796$export$c274a7f0ebd24b14.EXTRACTABLE, $b97228d657d79796$export$c274a7f0ebd24b14.POP_KEY_USAGES);
        // Generate Thumbprint for Public Key
        const publicKeyJwk = await (0, $b512579b1150f905$export$88781b8595a7d2ff)(keyPair.publicKey);
        const pubKeyThumprintObj = {
            e: publicKeyJwk.e,
            kty: publicKeyJwk.kty,
            n: publicKeyJwk.n
        };
        const publicJwkString = $b97228d657d79796$var$getSortedObjectString(pubKeyThumprintObj);
        const publicJwkHash = await this.hashString(publicJwkString);
        // Generate Thumbprint for Private Key
        const privateKeyJwk = await (0, $b512579b1150f905$export$88781b8595a7d2ff)(keyPair.privateKey);
        // Re-import private key to make it unextractable
        const unextractablePrivateKey = await (0, $b512579b1150f905$export$8bdea4e2e3f593c9)(privateKeyJwk, false, [
            "sign"
        ]);
        // Store Keypair data in keystore
        await this.cache.setItem(publicJwkHash, {
            privateKey: unextractablePrivateKey,
            publicKey: keyPair.publicKey,
            requestMethod: request.resourceRequestMethod,
            requestUri: request.resourceRequestUri
        });
        if (publicKeyThumbMeasurement) publicKeyThumbMeasurement.end({
            success: true
        });
        return publicJwkHash;
    }
    /**
     * Removes cryptographic keypair from key store matching the keyId passed in
     * @param kid
     */ async removeTokenBindingKey(kid) {
        await this.cache.removeItem(kid);
        const keyFound = await this.cache.containsKey(kid);
        return !keyFound;
    }
    /**
     * Removes all cryptographic keys from IndexedDB storage
     */ async clearKeystore() {
        // Delete in-memory keystores
        this.cache.clearInMemory();
        /**
         * There is only one database, so calling clearPersistent on asymmetric keystore takes care of
         * every persistent keystore
         */ try {
            await this.cache.clearPersistent();
            return true;
        } catch (e) {
            if (e instanceof Error) this.logger.error(`Clearing keystore failed with error: ${e.message}`);
            else this.logger.error("Clearing keystore failed with unknown error");
            return false;
        }
    }
    /**
     * Signs the given object as a jwt payload with private key retrieved by given kid.
     * @param payload
     * @param kid
     */ async signJwt(payload, kid, shrOptions, correlationId) {
        const signJwtMeasurement = this.performanceClient?.startMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).CryptoOptsSignJwt, correlationId);
        const cachedKeyPair = await this.cache.getItem(kid);
        if (!cachedKeyPair) throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$a416b0eceb5c15df));
        // Get public key as JWK
        const publicKeyJwk = await (0, $b512579b1150f905$export$88781b8595a7d2ff)(cachedKeyPair.publicKey);
        const publicKeyJwkString = $b97228d657d79796$var$getSortedObjectString(publicKeyJwk);
        // Base64URL encode public key thumbprint with keyId only: BASE64URL({ kid: "FULL_PUBLIC_KEY_HASH" })
        const encodedKeyIdThumbprint = (0, $3665c4f98d09cc5b$export$9ef804feabbcbaf1)(JSON.stringify({
            kid: kid
        }));
        // Generate header
        const shrHeader = (0, $aad628ffe34c7973$export$91748d132e6cb9b3).getShrHeaderString({
            ...shrOptions?.header,
            alg: publicKeyJwk.alg,
            kid: encodedKeyIdThumbprint
        });
        const encodedShrHeader = (0, $3665c4f98d09cc5b$export$9ef804feabbcbaf1)(shrHeader);
        // Generate payload
        payload.cnf = {
            jwk: JSON.parse(publicKeyJwkString)
        };
        const encodedPayload = (0, $3665c4f98d09cc5b$export$9ef804feabbcbaf1)(JSON.stringify(payload));
        // Form token string
        const tokenString = `${encodedShrHeader}.${encodedPayload}`;
        // Sign token
        const encoder = new TextEncoder();
        const tokenBuffer = encoder.encode(tokenString);
        const signatureBuffer = await (0, $b512579b1150f905$export$c5552dfdbc7cec71)(cachedKeyPair.privateKey, tokenBuffer);
        const encodedSignature = (0, $3665c4f98d09cc5b$export$84f5a428c7153a69)(new Uint8Array(signatureBuffer));
        const signedJwt = `${tokenString}.${encodedSignature}`;
        if (signJwtMeasurement) signJwtMeasurement.end({
            success: true
        });
        return signedJwt;
    }
    /**
     * Returns the SHA-256 hash of an input string
     * @param plainText
     */ async hashString(plainText) {
        return (0, $b512579b1150f905$export$9169be2e06c9c165)(plainText);
    }
}
$b97228d657d79796$export$c274a7f0ebd24b14.POP_KEY_USAGES = [
    "sign",
    "verify"
];
$b97228d657d79796$export$c274a7f0ebd24b14.EXTRACTABLE = true;
function $b97228d657d79796$var$getSortedObjectString(obj) {
    return JSON.stringify(obj, Object.keys(obj).sort());
}


/*! @azure/msal-common v14.16.1 2025-08-05 */ 
/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $770c2a41e25cfdd1$export$aab44dc88900a3b(response) {
    return response.hasOwnProperty("authorization_endpoint") && response.hasOwnProperty("token_endpoint") && response.hasOwnProperty("issuer") && response.hasOwnProperty("jwks_uri");
}









/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $334bd7b20b2edf7e$export$b288ea4a1e969e42(response) {
    return response.hasOwnProperty("tenant_discovery_endpoint") && response.hasOwnProperty("metadata");
}


/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $b4fba2399f55fc14$export$6716273459d383f8(response) {
    return response.hasOwnProperty("error") && response.hasOwnProperty("error_description");
}


/*! @azure/msal-common v14.16.1 2025-08-05 */ 

/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Wraps a function with a performance measurement.
 * Usage: invoke(functionToCall, performanceClient, "EventName", "correlationId")(...argsToPassToFunction)
 * @param callback
 * @param eventName
 * @param logger
 * @param telemetryClient
 * @param correlationId
 * @returns
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4832f15bf602f56d$export$468cda29b159ee5d = (callback, eventName, logger, telemetryClient, correlationId)=>{
    return (...args)=>{
        logger.trace(`Executing function ${eventName}`);
        const inProgressEvent = telemetryClient?.startMeasurement(eventName, correlationId);
        if (correlationId) {
            // Track number of times this API is called in a single request
            const eventCount = eventName + "CallCount";
            telemetryClient?.incrementFields({
                [eventCount]: 1
            }, correlationId);
        }
        try {
            const result = callback(...args);
            inProgressEvent?.end({
                success: true
            });
            logger.trace(`Returning result from ${eventName}`);
            return result;
        } catch (e) {
            logger.trace(`Error occurred in ${eventName}`);
            try {
                logger.trace(JSON.stringify(e));
            } catch (e) {
                logger.trace("Unable to print error message.");
            }
            inProgressEvent?.end({
                success: false
            }, e);
            throw e;
        }
    };
};
/**
 * Wraps an async function with a performance measurement.
 * Usage: invokeAsync(functionToCall, performanceClient, "EventName", "correlationId")(...argsToPassToFunction)
 * @param callback
 * @param eventName
 * @param logger
 * @param telemetryClient
 * @param correlationId
 * @returns
 * @internal
 *
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4832f15bf602f56d$export$e4feded94d9adb18 = (callback, eventName, logger, telemetryClient, correlationId)=>{
    return (...args)=>{
        logger.trace(`Executing function ${eventName}`);
        const inProgressEvent = telemetryClient?.startMeasurement(eventName, correlationId);
        if (correlationId) {
            // Track number of times this API is called in a single request
            const eventCount = eventName + "CallCount";
            telemetryClient?.incrementFields({
                [eventCount]: 1
            }, correlationId);
        }
        telemetryClient?.setPreQueueTime(eventName, correlationId);
        return callback(...args).then((response)=>{
            logger.trace(`Returning result from ${eventName}`);
            inProgressEvent?.end({
                success: true
            });
            return response;
        }).catch((e)=>{
            logger.trace(`Error occurred in ${eventName}`);
            try {
                logger.trace(JSON.stringify(e));
            } catch (e) {
                logger.trace("Unable to print error message.");
            }
            inProgressEvent?.end({
                success: false
            }, e);
            throw e;
        });
    };
};


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $0408f7205b81c753$export$1afa9d0f261ebb47 {
    constructor(networkInterface, logger, performanceClient, correlationId){
        this.networkInterface = networkInterface;
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
    }
    /**
     * Detect the region from the application's environment.
     *
     * @returns Promise<string | null>
     */ async detectRegion(environmentRegion, regionDiscoveryMetadata) {
        this.performanceClient?.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).RegionDiscoveryDetectRegion, this.correlationId);
        // Initialize auto detected region with the region from the envrionment
        let autodetectedRegionName = environmentRegion;
        // Check if a region was detected from the environment, if not, attempt to get the region from IMDS
        if (!autodetectedRegionName) {
            const options = $0408f7205b81c753$export$1afa9d0f261ebb47.IMDS_OPTIONS;
            try {
                const localIMDSVersionResponse = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.getRegionFromIMDS.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).RegionDiscoveryGetRegionFromIMDS, this.logger, this.performanceClient, this.correlationId)((0, $08c107807d753255$export$a002182e51710d39).IMDS_VERSION, options);
                if (localIMDSVersionResponse.status === (0, $08c107807d753255$export$20ba0879771a17be).httpSuccess) {
                    autodetectedRegionName = localIMDSVersionResponse.body;
                    regionDiscoveryMetadata.region_source = (0, $08c107807d753255$export$3d4a3e11df589b40).IMDS;
                }
                // If the response using the local IMDS version failed, try to fetch the current version of IMDS and retry.
                if (localIMDSVersionResponse.status === (0, $08c107807d753255$export$20ba0879771a17be).httpBadRequest) {
                    const currentIMDSVersion = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.getCurrentVersion.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).RegionDiscoveryGetCurrentVersion, this.logger, this.performanceClient, this.correlationId)(options);
                    if (!currentIMDSVersion) {
                        regionDiscoveryMetadata.region_source = (0, $08c107807d753255$export$3d4a3e11df589b40).FAILED_AUTO_DETECTION;
                        return null;
                    }
                    const currentIMDSVersionResponse = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.getRegionFromIMDS.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).RegionDiscoveryGetRegionFromIMDS, this.logger, this.performanceClient, this.correlationId)(currentIMDSVersion, options);
                    if (currentIMDSVersionResponse.status === (0, $08c107807d753255$export$20ba0879771a17be).httpSuccess) {
                        autodetectedRegionName = currentIMDSVersionResponse.body;
                        regionDiscoveryMetadata.region_source = (0, $08c107807d753255$export$3d4a3e11df589b40).IMDS;
                    }
                }
            } catch (e) {
                regionDiscoveryMetadata.region_source = (0, $08c107807d753255$export$3d4a3e11df589b40).FAILED_AUTO_DETECTION;
                return null;
            }
        } else regionDiscoveryMetadata.region_source = (0, $08c107807d753255$export$3d4a3e11df589b40).ENVIRONMENT_VARIABLE;
        // If no region was auto detected from the environment or from the IMDS endpoint, mark the attempt as a FAILED_AUTO_DETECTION
        if (!autodetectedRegionName) regionDiscoveryMetadata.region_source = (0, $08c107807d753255$export$3d4a3e11df589b40).FAILED_AUTO_DETECTION;
        return autodetectedRegionName || null;
    }
    /**
     * Make the call to the IMDS endpoint
     *
     * @param imdsEndpointUrl
     * @returns Promise<NetworkResponse<string>>
     */ async getRegionFromIMDS(version, options) {
        this.performanceClient?.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).RegionDiscoveryGetRegionFromIMDS, this.correlationId);
        return this.networkInterface.sendGetRequestAsync(`${(0, $08c107807d753255$export$a002182e51710d39).IMDS_ENDPOINT}?api-version=${version}&format=text`, options, (0, $08c107807d753255$export$a002182e51710d39).IMDS_TIMEOUT);
    }
    /**
     * Get the most recent version of the IMDS endpoint available
     *
     * @returns Promise<string | null>
     */ async getCurrentVersion(options) {
        this.performanceClient?.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).RegionDiscoveryGetCurrentVersion, this.correlationId);
        try {
            const response = await this.networkInterface.sendGetRequestAsync(`${(0, $08c107807d753255$export$a002182e51710d39).IMDS_ENDPOINT}?format=json`, options);
            // When IMDS endpoint is called without the api version query param, bad request response comes back with latest version.
            if (response.status === (0, $08c107807d753255$export$20ba0879771a17be).httpBadRequest && response.body && response.body["newest-versions"] && response.body["newest-versions"].length > 0) return response.body["newest-versions"][0];
            return null;
        } catch (e) {
            return null;
        }
    }
}
// Options for the IMDS endpoint request
$0408f7205b81c753$export$1afa9d0f261ebb47.IMDS_OPTIONS = {
    headers: {
        Metadata: "true"
    }
};








'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The authority class validates the authority URIs used by the user, and retrieves the OpenID Configuration Data from the
 * endpoint. It will store the pertinent config data in this object for use during token calls.
 * @internal
 */ class $dda2270c89fd90c8$export$f1c6ec2e6d68c49c {
    constructor(authority, networkInterface, cacheManager, authorityOptions, logger, correlationId, performanceClient, managedIdentity){
        this.canonicalAuthority = authority;
        this._canonicalAuthority.validateAsUri();
        this.networkInterface = networkInterface;
        this.cacheManager = cacheManager;
        this.authorityOptions = authorityOptions;
        this.regionDiscoveryMetadata = {
            region_used: undefined,
            region_source: undefined,
            region_outcome: undefined
        };
        this.logger = logger;
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
        this.managedIdentity = managedIdentity || false;
        this.regionDiscovery = new (0, $0408f7205b81c753$export$1afa9d0f261ebb47)(networkInterface, this.logger, this.performanceClient, this.correlationId);
    }
    /**
     * Get {@link AuthorityType}
     * @param authorityUri {@link IUri}
     * @private
     */ getAuthorityType(authorityUri) {
        // CIAM auth url pattern is being standardized as: <tenant>.ciamlogin.com
        if (authorityUri.HostNameAndPort.endsWith((0, $08c107807d753255$export$a002182e51710d39).CIAM_AUTH_URL)) return (0, $177318b44e15a6f4$export$cd82032b224a3839).Ciam;
        const pathSegments = authorityUri.PathSegments;
        if (pathSegments.length) switch(pathSegments[0].toLowerCase()){
            case (0, $08c107807d753255$export$a002182e51710d39).ADFS:
                return (0, $177318b44e15a6f4$export$cd82032b224a3839).Adfs;
            case (0, $08c107807d753255$export$a002182e51710d39).DSTS:
                return (0, $177318b44e15a6f4$export$cd82032b224a3839).Dsts;
        }
        return (0, $177318b44e15a6f4$export$cd82032b224a3839).Default;
    }
    // See above for AuthorityType
    get authorityType() {
        return this.getAuthorityType(this.canonicalAuthorityUrlComponents);
    }
    /**
     * ProtocolMode enum representing the way endpoints are constructed.
     */ get protocolMode() {
        return this.authorityOptions.protocolMode;
    }
    /**
     * Returns authorityOptions which can be used to reinstantiate a new authority instance
     */ get options() {
        return this.authorityOptions;
    }
    /**
     * A URL that is the authority set by the developer
     */ get canonicalAuthority() {
        return this._canonicalAuthority.urlString;
    }
    /**
     * Sets canonical authority.
     */ set canonicalAuthority(url) {
        this._canonicalAuthority = new (0, $ff2860ddbc741970$export$3abcdca7229e54f2)(url);
        this._canonicalAuthority.validateAsUri();
        this._canonicalAuthorityUrlComponents = null;
    }
    /**
     * Get authority components.
     */ get canonicalAuthorityUrlComponents() {
        if (!this._canonicalAuthorityUrlComponents) this._canonicalAuthorityUrlComponents = this._canonicalAuthority.getUrlComponents();
        return this._canonicalAuthorityUrlComponents;
    }
    /**
     * Get hostname and port i.e. login.microsoftonline.com
     */ get hostnameAndPort() {
        return this.canonicalAuthorityUrlComponents.HostNameAndPort.toLowerCase();
    }
    /**
     * Get tenant for authority.
     */ get tenant() {
        return this.canonicalAuthorityUrlComponents.PathSegments[0];
    }
    /**
     * OAuth /authorize endpoint for requests
     */ get authorizationEndpoint() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.authorization_endpoint);
        else throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$c9fcc93738cc2bc3));
    }
    /**
     * OAuth /token endpoint for requests
     */ get tokenEndpoint() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.token_endpoint);
        else throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$c9fcc93738cc2bc3));
    }
    get deviceCodeEndpoint() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.token_endpoint.replace("/token", "/devicecode"));
        else throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$c9fcc93738cc2bc3));
    }
    /**
     * OAuth logout endpoint for requests
     */ get endSessionEndpoint() {
        if (this.discoveryComplete()) {
            // ROPC policies may not have end_session_endpoint set
            if (!this.metadata.end_session_endpoint) throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$c3bd741c16a889f3));
            return this.replacePath(this.metadata.end_session_endpoint);
        } else throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$c9fcc93738cc2bc3));
    }
    /**
     * OAuth issuer for requests
     */ get selfSignedJwtAudience() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.issuer);
        else throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$c9fcc93738cc2bc3));
    }
    /**
     * Jwks_uri for token signing keys
     */ get jwksUri() {
        if (this.discoveryComplete()) return this.replacePath(this.metadata.jwks_uri);
        else throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$c9fcc93738cc2bc3));
    }
    /**
     * Returns a flag indicating that tenant name can be replaced in authority {@link IUri}
     * @param authorityUri {@link IUri}
     * @private
     */ canReplaceTenant(authorityUri) {
        return authorityUri.PathSegments.length === 1 && !$dda2270c89fd90c8$export$f1c6ec2e6d68c49c.reservedTenantDomains.has(authorityUri.PathSegments[0]) && this.getAuthorityType(authorityUri) === (0, $177318b44e15a6f4$export$cd82032b224a3839).Default && this.protocolMode === (0, $a47d2ec0503d310c$export$73a3e3dedd37150d).AAD;
    }
    /**
     * Replaces tenant in url path with current tenant. Defaults to common.
     * @param urlString
     */ replaceTenant(urlString) {
        return urlString.replace(/{tenant}|{tenantid}/g, this.tenant);
    }
    /**
     * Replaces path such as tenant or policy with the current tenant or policy.
     * @param urlString
     */ replacePath(urlString) {
        let endpoint = urlString;
        const cachedAuthorityUrl = new (0, $ff2860ddbc741970$export$3abcdca7229e54f2)(this.metadata.canonical_authority);
        const cachedAuthorityUrlComponents = cachedAuthorityUrl.getUrlComponents();
        const cachedAuthorityParts = cachedAuthorityUrlComponents.PathSegments;
        const currentAuthorityParts = this.canonicalAuthorityUrlComponents.PathSegments;
        currentAuthorityParts.forEach((currentPart, index)=>{
            let cachedPart = cachedAuthorityParts[index];
            if (index === 0 && this.canReplaceTenant(cachedAuthorityUrlComponents)) {
                const tenantId = new (0, $ff2860ddbc741970$export$3abcdca7229e54f2)(this.metadata.authorization_endpoint).getUrlComponents().PathSegments[0];
                /**
                 * Check if AAD canonical authority contains tenant domain name, for example "testdomain.onmicrosoft.com",
                 * by comparing its first path segment to the corresponding authorization endpoint path segment, which is
                 * always resolved with tenant id by OIDC.
                 */ if (cachedPart !== tenantId) {
                    this.logger.verbose(`Replacing tenant domain name ${cachedPart} with id ${tenantId}`);
                    cachedPart = tenantId;
                }
            }
            if (currentPart !== cachedPart) endpoint = endpoint.replace(`/${cachedPart}/`, `/${currentPart}/`);
        });
        return this.replaceTenant(endpoint);
    }
    /**
     * The default open id configuration endpoint for any canonical authority.
     */ get defaultOpenIdConfigurationEndpoint() {
        const canonicalAuthorityHost = this.hostnameAndPort;
        if (this.canonicalAuthority.endsWith("v2.0/") || this.authorityType === (0, $177318b44e15a6f4$export$cd82032b224a3839).Adfs || this.protocolMode !== (0, $a47d2ec0503d310c$export$73a3e3dedd37150d).AAD && !this.isAliasOfKnownMicrosoftAuthority(canonicalAuthorityHost)) return `${this.canonicalAuthority}.well-known/openid-configuration`;
        return `${this.canonicalAuthority}v2.0/.well-known/openid-configuration`;
    }
    /**
     * Boolean that returns whether or not tenant discovery has been completed.
     */ discoveryComplete() {
        return !!this.metadata;
    }
    /**
     * Perform endpoint discovery to discover aliases, preferred_cache, preferred_network
     * and the /authorize, /token and logout endpoints.
     */ async resolveEndpointsAsync() {
        this.performanceClient?.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).AuthorityResolveEndpointsAsync, this.correlationId);
        const metadataEntity = this.getCurrentMetadataEntity();
        const cloudDiscoverySource = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.updateCloudDiscoveryMetadata.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).AuthorityUpdateCloudDiscoveryMetadata, this.logger, this.performanceClient, this.correlationId)(metadataEntity);
        this.canonicalAuthority = this.canonicalAuthority.replace(this.hostnameAndPort, metadataEntity.preferred_network);
        const endpointSource = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.updateEndpointMetadata.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).AuthorityUpdateEndpointMetadata, this.logger, this.performanceClient, this.correlationId)(metadataEntity);
        this.updateCachedMetadata(metadataEntity, cloudDiscoverySource, {
            source: endpointSource
        });
        this.performanceClient?.addFields({
            cloudDiscoverySource: cloudDiscoverySource,
            authorityEndpointSource: endpointSource
        }, this.correlationId);
    }
    /**
     * Returns metadata entity from cache if it exists, otherwiser returns a new metadata entity built
     * from the configured canonical authority
     * @returns
     */ getCurrentMetadataEntity() {
        let metadataEntity = this.cacheManager.getAuthorityMetadataByAlias(this.hostnameAndPort);
        if (!metadataEntity) metadataEntity = {
            aliases: [],
            preferred_cache: this.hostnameAndPort,
            preferred_network: this.hostnameAndPort,
            canonical_authority: this.canonicalAuthority,
            authorization_endpoint: "",
            token_endpoint: "",
            end_session_endpoint: "",
            issuer: "",
            aliasesFromNetwork: false,
            endpointsFromNetwork: false,
            expiresAt: (0, $bd840ab348a8e6dd$export$90f464c4238c27e5)(),
            jwks_uri: ""
        };
        return metadataEntity;
    }
    /**
     * Updates cached metadata based on metadata source and sets the instance's metadata
     * property to the same value
     * @param metadataEntity
     * @param cloudDiscoverySource
     * @param endpointMetadataResult
     */ updateCachedMetadata(metadataEntity, cloudDiscoverySource, endpointMetadataResult) {
        if (cloudDiscoverySource !== (0, $08c107807d753255$export$5d365d77acfcb55d).CACHE && endpointMetadataResult?.source !== (0, $08c107807d753255$export$5d365d77acfcb55d).CACHE) {
            // Reset the expiration time unless both values came from a successful cache lookup
            metadataEntity.expiresAt = (0, $bd840ab348a8e6dd$export$90f464c4238c27e5)();
            metadataEntity.canonical_authority = this.canonicalAuthority;
        }
        const cacheKey = this.cacheManager.generateAuthorityMetadataCacheKey(metadataEntity.preferred_cache);
        this.cacheManager.setAuthorityMetadata(cacheKey, metadataEntity);
        this.metadata = metadataEntity;
    }
    /**
     * Update AuthorityMetadataEntity with new endpoints and return where the information came from
     * @param metadataEntity
     */ async updateEndpointMetadata(metadataEntity) {
        this.performanceClient?.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).AuthorityUpdateEndpointMetadata, this.correlationId);
        const localMetadata = this.updateEndpointMetadataFromLocalSources(metadataEntity);
        // Further update may be required for hardcoded metadata if regional metadata is preferred
        if (localMetadata) {
            if (localMetadata.source === (0, $08c107807d753255$export$5d365d77acfcb55d).HARDCODED_VALUES) {
                // If the user prefers to use an azure region replace the global endpoints with regional information.
                if (this.authorityOptions.azureRegionConfiguration?.azureRegion) {
                    if (localMetadata.metadata) {
                        const hardcodedMetadata = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.updateMetadataWithRegionalInformation.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).AuthorityUpdateMetadataWithRegionalInformation, this.logger, this.performanceClient, this.correlationId)(localMetadata.metadata);
                        (0, $bd840ab348a8e6dd$export$ef87e8fbd8af5f96)(metadataEntity, hardcodedMetadata, false);
                        metadataEntity.canonical_authority = this.canonicalAuthority;
                    }
                }
            }
            return localMetadata.source;
        }
        // Get metadata from network if local sources aren't available
        let metadata = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.getEndpointMetadataFromNetwork.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).AuthorityGetEndpointMetadataFromNetwork, this.logger, this.performanceClient, this.correlationId)();
        if (metadata) {
            // If the user prefers to use an azure region replace the global endpoints with regional information.
            if (this.authorityOptions.azureRegionConfiguration?.azureRegion) metadata = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.updateMetadataWithRegionalInformation.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).AuthorityUpdateMetadataWithRegionalInformation, this.logger, this.performanceClient, this.correlationId)(metadata);
            (0, $bd840ab348a8e6dd$export$ef87e8fbd8af5f96)(metadataEntity, metadata, true);
            return (0, $08c107807d753255$export$5d365d77acfcb55d).NETWORK;
        } else // Metadata could not be obtained from the config, cache, network or hardcoded values
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$73566da29bc073eb), this.defaultOpenIdConfigurationEndpoint);
    }
    /**
     * Updates endpoint metadata from local sources and returns where the information was retrieved from and the metadata config
     * response if the source is hardcoded metadata
     * @param metadataEntity
     * @returns
     */ updateEndpointMetadataFromLocalSources(metadataEntity) {
        this.logger.verbose("Attempting to get endpoint metadata from authority configuration");
        const configMetadata = this.getEndpointMetadataFromConfig();
        if (configMetadata) {
            this.logger.verbose("Found endpoint metadata in authority configuration");
            (0, $bd840ab348a8e6dd$export$ef87e8fbd8af5f96)(metadataEntity, configMetadata, false);
            return {
                source: (0, $08c107807d753255$export$5d365d77acfcb55d).CONFIG
            };
        }
        this.logger.verbose("Did not find endpoint metadata in the config... Attempting to get endpoint metadata from the hardcoded values.");
        // skipAuthorityMetadataCache is used to bypass hardcoded authority metadata and force a network metadata cache lookup and network metadata request if no cached response is available.
        if (this.authorityOptions.skipAuthorityMetadataCache) this.logger.verbose("Skipping hardcoded metadata cache since skipAuthorityMetadataCache is set to true. Attempting to get endpoint metadata from the network metadata cache.");
        else {
            const hardcodedMetadata = this.getEndpointMetadataFromHardcodedValues();
            if (hardcodedMetadata) {
                (0, $bd840ab348a8e6dd$export$ef87e8fbd8af5f96)(metadataEntity, hardcodedMetadata, false);
                return {
                    source: (0, $08c107807d753255$export$5d365d77acfcb55d).HARDCODED_VALUES,
                    metadata: hardcodedMetadata
                };
            } else this.logger.verbose("Did not find endpoint metadata in hardcoded values... Attempting to get endpoint metadata from the network metadata cache.");
        }
        // Check cached metadata entity expiration status
        const metadataEntityExpired = (0, $bd840ab348a8e6dd$export$b96839cf63a15b0f)(metadataEntity);
        if (this.isAuthoritySameType(metadataEntity) && metadataEntity.endpointsFromNetwork && !metadataEntityExpired) {
            // No need to update
            this.logger.verbose("Found endpoint metadata in the cache.");
            return {
                source: (0, $08c107807d753255$export$5d365d77acfcb55d).CACHE
            };
        } else if (metadataEntityExpired) this.logger.verbose("The metadata entity is expired.");
        return null;
    }
    /**
     * Compares the number of url components after the domain to determine if the cached
     * authority metadata can be used for the requested authority. Protects against same domain different
     * authority such as login.microsoftonline.com/tenant and login.microsoftonline.com/tfp/tenant/policy
     * @param metadataEntity
     */ isAuthoritySameType(metadataEntity) {
        const cachedAuthorityUrl = new (0, $ff2860ddbc741970$export$3abcdca7229e54f2)(metadataEntity.canonical_authority);
        const cachedParts = cachedAuthorityUrl.getUrlComponents().PathSegments;
        return cachedParts.length === this.canonicalAuthorityUrlComponents.PathSegments.length;
    }
    /**
     * Parse authorityMetadata config option
     */ getEndpointMetadataFromConfig() {
        if (this.authorityOptions.authorityMetadata) try {
            return JSON.parse(this.authorityOptions.authorityMetadata);
        } catch (e) {
            throw (0, $a6f096219dc1b547$export$5d63d098f4f130a1)((0, $f66a3d6fc9f2eb73$export$edb4d5942bc8ccff));
        }
        return null;
    }
    /**
     * Gets OAuth endpoints from the given OpenID configuration endpoint.
     *
     * @param hasHardcodedMetadata boolean
     */ async getEndpointMetadataFromNetwork() {
        this.performanceClient?.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).AuthorityGetEndpointMetadataFromNetwork, this.correlationId);
        const options = {};
        /*
         * TODO: Add a timeout if the authority exists in our library's
         * hardcoded list of metadata
         */ const openIdConfigurationEndpoint = this.defaultOpenIdConfigurationEndpoint;
        this.logger.verbose(`Authority.getEndpointMetadataFromNetwork: attempting to retrieve OAuth endpoints from ${openIdConfigurationEndpoint}`);
        try {
            const response = await this.networkInterface.sendGetRequestAsync(openIdConfigurationEndpoint, options);
            const isValidResponse = (0, $770c2a41e25cfdd1$export$aab44dc88900a3b)(response.body);
            if (isValidResponse) return response.body;
            else {
                this.logger.verbose(`Authority.getEndpointMetadataFromNetwork: could not parse response as OpenID configuration`);
                return null;
            }
        } catch (e) {
            this.logger.verbose(`Authority.getEndpointMetadataFromNetwork: ${e}`);
            return null;
        }
    }
    /**
     * Get OAuth endpoints for common authorities.
     */ getEndpointMetadataFromHardcodedValues() {
        if (this.hostnameAndPort in (0, $1d18a42dbb0c24e8$export$f612854287391207)) return (0, $1d18a42dbb0c24e8$export$f612854287391207)[this.hostnameAndPort];
        return null;
    }
    /**
     * Update the retrieved metadata with regional information.
     * User selected Azure region will be used if configured.
     */ async updateMetadataWithRegionalInformation(metadata) {
        this.performanceClient?.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).AuthorityUpdateMetadataWithRegionalInformation, this.correlationId);
        const userConfiguredAzureRegion = this.authorityOptions.azureRegionConfiguration?.azureRegion;
        if (userConfiguredAzureRegion) {
            if (userConfiguredAzureRegion !== (0, $08c107807d753255$export$a002182e51710d39).AZURE_REGION_AUTO_DISCOVER_FLAG) {
                this.regionDiscoveryMetadata.region_outcome = (0, $08c107807d753255$export$92a685f9218422bd).CONFIGURED_NO_AUTO_DETECTION;
                this.regionDiscoveryMetadata.region_used = userConfiguredAzureRegion;
                return $dda2270c89fd90c8$export$f1c6ec2e6d68c49c.replaceWithRegionalInformation(metadata, userConfiguredAzureRegion);
            }
            const autodetectedRegionName = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.regionDiscovery.detectRegion.bind(this.regionDiscovery), (0, $32170abc11155933$export$2f2811a3e1b21823).RegionDiscoveryDetectRegion, this.logger, this.performanceClient, this.correlationId)(this.authorityOptions.azureRegionConfiguration?.environmentRegion, this.regionDiscoveryMetadata);
            if (autodetectedRegionName) {
                this.regionDiscoveryMetadata.region_outcome = (0, $08c107807d753255$export$92a685f9218422bd).AUTO_DETECTION_REQUESTED_SUCCESSFUL;
                this.regionDiscoveryMetadata.region_used = autodetectedRegionName;
                return $dda2270c89fd90c8$export$f1c6ec2e6d68c49c.replaceWithRegionalInformation(metadata, autodetectedRegionName);
            }
            this.regionDiscoveryMetadata.region_outcome = (0, $08c107807d753255$export$92a685f9218422bd).AUTO_DETECTION_REQUESTED_FAILED;
        }
        return metadata;
    }
    /**
     * Updates the AuthorityMetadataEntity with new aliases, preferred_network and preferred_cache
     * and returns where the information was retrieved from
     * @param metadataEntity
     * @returns AuthorityMetadataSource
     */ async updateCloudDiscoveryMetadata(metadataEntity) {
        this.performanceClient?.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).AuthorityUpdateCloudDiscoveryMetadata, this.correlationId);
        const localMetadataSource = this.updateCloudDiscoveryMetadataFromLocalSources(metadataEntity);
        if (localMetadataSource) return localMetadataSource;
        // Fallback to network as metadata source
        const metadata = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.getCloudDiscoveryMetadataFromNetwork.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).AuthorityGetCloudDiscoveryMetadataFromNetwork, this.logger, this.performanceClient, this.correlationId)();
        if (metadata) {
            (0, $bd840ab348a8e6dd$export$6d4972e1d88c8518)(metadataEntity, metadata, true);
            return (0, $08c107807d753255$export$5d365d77acfcb55d).NETWORK;
        }
        // Metadata could not be obtained from the config, cache, network or hardcoded values
        throw (0, $a6f096219dc1b547$export$5d63d098f4f130a1)((0, $f66a3d6fc9f2eb73$export$50c3162fda5f57));
    }
    updateCloudDiscoveryMetadataFromLocalSources(metadataEntity) {
        this.logger.verbose("Attempting to get cloud discovery metadata  from authority configuration");
        this.logger.verbosePii(`Known Authorities: ${this.authorityOptions.knownAuthorities || (0, $08c107807d753255$export$a002182e51710d39).NOT_APPLICABLE}`);
        this.logger.verbosePii(`Authority Metadata: ${this.authorityOptions.authorityMetadata || (0, $08c107807d753255$export$a002182e51710d39).NOT_APPLICABLE}`);
        this.logger.verbosePii(`Canonical Authority: ${metadataEntity.canonical_authority || (0, $08c107807d753255$export$a002182e51710d39).NOT_APPLICABLE}`);
        const metadata = this.getCloudDiscoveryMetadataFromConfig();
        if (metadata) {
            this.logger.verbose("Found cloud discovery metadata in authority configuration");
            (0, $bd840ab348a8e6dd$export$6d4972e1d88c8518)(metadataEntity, metadata, false);
            return (0, $08c107807d753255$export$5d365d77acfcb55d).CONFIG;
        }
        // If the cached metadata came from config but that config was not passed to this instance, we must go to hardcoded values
        this.logger.verbose("Did not find cloud discovery metadata in the config... Attempting to get cloud discovery metadata from the hardcoded values.");
        if (this.options.skipAuthorityMetadataCache) this.logger.verbose("Skipping hardcoded cloud discovery metadata cache since skipAuthorityMetadataCache is set to true. Attempting to get cloud discovery metadata from the network metadata cache.");
        else {
            const hardcodedMetadata = (0, $1d18a42dbb0c24e8$export$1b1433f93c9873f)(this.hostnameAndPort);
            if (hardcodedMetadata) {
                this.logger.verbose("Found cloud discovery metadata from hardcoded values.");
                (0, $bd840ab348a8e6dd$export$6d4972e1d88c8518)(metadataEntity, hardcodedMetadata, false);
                return (0, $08c107807d753255$export$5d365d77acfcb55d).HARDCODED_VALUES;
            }
            this.logger.verbose("Did not find cloud discovery metadata in hardcoded values... Attempting to get cloud discovery metadata from the network metadata cache.");
        }
        const metadataEntityExpired = (0, $bd840ab348a8e6dd$export$b96839cf63a15b0f)(metadataEntity);
        if (this.isAuthoritySameType(metadataEntity) && metadataEntity.aliasesFromNetwork && !metadataEntityExpired) {
            this.logger.verbose("Found cloud discovery metadata in the cache.");
            // No need to update
            return (0, $08c107807d753255$export$5d365d77acfcb55d).CACHE;
        } else if (metadataEntityExpired) this.logger.verbose("The metadata entity is expired.");
        return null;
    }
    /**
     * Parse cloudDiscoveryMetadata config or check knownAuthorities
     */ getCloudDiscoveryMetadataFromConfig() {
        // CIAM does not support cloud discovery metadata
        if (this.authorityType === (0, $177318b44e15a6f4$export$cd82032b224a3839).Ciam) {
            this.logger.verbose("CIAM authorities do not support cloud discovery metadata, generate the aliases from authority host.");
            return $dda2270c89fd90c8$export$f1c6ec2e6d68c49c.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        // Check if network response was provided in config
        if (this.authorityOptions.cloudDiscoveryMetadata) {
            this.logger.verbose("The cloud discovery metadata has been provided as a network response, in the config.");
            try {
                this.logger.verbose("Attempting to parse the cloud discovery metadata.");
                const parsedResponse = JSON.parse(this.authorityOptions.cloudDiscoveryMetadata);
                const metadata = (0, $1d18a42dbb0c24e8$export$6e21098ea6e60dc)(parsedResponse.metadata, this.hostnameAndPort);
                this.logger.verbose("Parsed the cloud discovery metadata.");
                if (metadata) {
                    this.logger.verbose("There is returnable metadata attached to the parsed cloud discovery metadata.");
                    return metadata;
                } else this.logger.verbose("There is no metadata attached to the parsed cloud discovery metadata.");
            } catch (e) {
                this.logger.verbose("Unable to parse the cloud discovery metadata. Throwing Invalid Cloud Discovery Metadata Error.");
                throw (0, $a6f096219dc1b547$export$5d63d098f4f130a1)((0, $f66a3d6fc9f2eb73$export$92a2985751150ca5));
            }
        }
        // If cloudDiscoveryMetadata is empty or does not contain the host, check knownAuthorities
        if (this.isInKnownAuthorities()) {
            this.logger.verbose("The host is included in knownAuthorities. Creating new cloud discovery metadata from the host.");
            return $dda2270c89fd90c8$export$f1c6ec2e6d68c49c.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        return null;
    }
    /**
     * Called to get metadata from network if CloudDiscoveryMetadata was not populated by config
     *
     * @param hasHardcodedMetadata boolean
     */ async getCloudDiscoveryMetadataFromNetwork() {
        this.performanceClient?.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).AuthorityGetCloudDiscoveryMetadataFromNetwork, this.correlationId);
        const instanceDiscoveryEndpoint = `${(0, $08c107807d753255$export$a002182e51710d39).AAD_INSTANCE_DISCOVERY_ENDPT}${this.canonicalAuthority}oauth2/v2.0/authorize`;
        const options = {};
        /*
         * TODO: Add a timeout if the authority exists in our library's
         * hardcoded list of metadata
         */ let match = null;
        try {
            const response = await this.networkInterface.sendGetRequestAsync(instanceDiscoveryEndpoint, options);
            let typedResponseBody;
            let metadata;
            if ((0, $334bd7b20b2edf7e$export$b288ea4a1e969e42)(response.body)) {
                typedResponseBody = response.body;
                metadata = typedResponseBody.metadata;
                this.logger.verbosePii(`tenant_discovery_endpoint is: ${typedResponseBody.tenant_discovery_endpoint}`);
            } else if ((0, $b4fba2399f55fc14$export$6716273459d383f8)(response.body)) {
                this.logger.warning(`A CloudInstanceDiscoveryErrorResponse was returned. The cloud instance discovery network request's status code is: ${response.status}`);
                typedResponseBody = response.body;
                if (typedResponseBody.error === (0, $08c107807d753255$export$a002182e51710d39).INVALID_INSTANCE) {
                    this.logger.error("The CloudInstanceDiscoveryErrorResponse error is invalid_instance.");
                    return null;
                }
                this.logger.warning(`The CloudInstanceDiscoveryErrorResponse error is ${typedResponseBody.error}`);
                this.logger.warning(`The CloudInstanceDiscoveryErrorResponse error description is ${typedResponseBody.error_description}`);
                this.logger.warning("Setting the value of the CloudInstanceDiscoveryMetadata (returned from the network) to []");
                metadata = [];
            } else {
                this.logger.error("AAD did not return a CloudInstanceDiscoveryResponse or CloudInstanceDiscoveryErrorResponse");
                return null;
            }
            this.logger.verbose("Attempting to find a match between the developer's authority and the CloudInstanceDiscoveryMetadata returned from the network request.");
            match = (0, $1d18a42dbb0c24e8$export$6e21098ea6e60dc)(metadata, this.hostnameAndPort);
        } catch (error) {
            if (error instanceof (0, $53b49d8334c1646a$export$145273558d58e0ac)) this.logger.error(`There was a network error while attempting to get the cloud discovery instance metadata.\nError: ${error.errorCode}\nError Description: ${error.errorMessage}`);
            else {
                const typedError = error;
                this.logger.error(`A non-MSALJS error was thrown while attempting to get the cloud instance discovery metadata.\nError: ${typedError.name}\nError Description: ${typedError.message}`);
            }
            return null;
        }
        // Custom Domain scenario, host is trusted because Instance Discovery call succeeded
        if (!match) {
            this.logger.warning("The developer's authority was not found within the CloudInstanceDiscoveryMetadata returned from the network request.");
            this.logger.verbose("Creating custom Authority for custom domain scenario.");
            match = $dda2270c89fd90c8$export$f1c6ec2e6d68c49c.createCloudDiscoveryMetadataFromHost(this.hostnameAndPort);
        }
        return match;
    }
    /**
     * Helper function to determine if this host is included in the knownAuthorities config option
     */ isInKnownAuthorities() {
        const matches = this.authorityOptions.knownAuthorities.filter((authority)=>{
            return authority && (0, $ff2860ddbc741970$export$3abcdca7229e54f2).getDomainFromUrl(authority).toLowerCase() === this.hostnameAndPort;
        });
        return matches.length > 0;
    }
    /**
     * helper function to populate the authority based on azureCloudOptions
     * @param authorityString
     * @param azureCloudOptions
     */ static generateAuthority(authorityString, azureCloudOptions) {
        let authorityAzureCloudInstance;
        if (azureCloudOptions && azureCloudOptions.azureCloudInstance !== (0, $7ae45af95b45dab9$export$4cda21933050d9ec).None) {
            const tenant = azureCloudOptions.tenant ? azureCloudOptions.tenant : (0, $08c107807d753255$export$a002182e51710d39).DEFAULT_COMMON_TENANT;
            authorityAzureCloudInstance = `${azureCloudOptions.azureCloudInstance}/${tenant}/`;
        }
        return authorityAzureCloudInstance ? authorityAzureCloudInstance : authorityString;
    }
    /**
     * Creates cloud discovery metadata object from a given host
     * @param host
     */ static createCloudDiscoveryMetadataFromHost(host) {
        return {
            preferred_network: host,
            preferred_cache: host,
            aliases: [
                host
            ]
        };
    }
    /**
     * helper function to generate environment from authority object
     */ getPreferredCache() {
        if (this.managedIdentity) return (0, $08c107807d753255$export$a002182e51710d39).DEFAULT_AUTHORITY_HOST;
        else if (this.discoveryComplete()) return this.metadata.preferred_cache;
        else throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$c9fcc93738cc2bc3));
    }
    /**
     * Returns whether or not the provided host is an alias of this authority instance
     * @param host
     */ isAlias(host) {
        return this.metadata.aliases.indexOf(host) > -1;
    }
    /**
     * Returns whether or not the provided host is an alias of a known Microsoft authority for purposes of endpoint discovery
     * @param host
     */ isAliasOfKnownMicrosoftAuthority(host) {
        return (0, $1d18a42dbb0c24e8$export$7d026f079148cd31).has(host);
    }
    /**
     * Checks whether the provided host is that of a public cloud authority
     *
     * @param authority string
     * @returns bool
     */ static isPublicCloudAuthority(host) {
        return (0, $08c107807d753255$export$a002182e51710d39).KNOWN_PUBLIC_CLOUDS.indexOf(host) >= 0;
    }
    /**
     * Rebuild the authority string with the region
     *
     * @param host string
     * @param region string
     */ static buildRegionalAuthorityString(host, region, queryString) {
        // Create and validate a Url string object with the initial authority string
        const authorityUrlInstance = new (0, $ff2860ddbc741970$export$3abcdca7229e54f2)(host);
        authorityUrlInstance.validateAsUri();
        const authorityUrlParts = authorityUrlInstance.getUrlComponents();
        let hostNameAndPort = `${region}.${authorityUrlParts.HostNameAndPort}`;
        if (this.isPublicCloudAuthority(authorityUrlParts.HostNameAndPort)) hostNameAndPort = `${region}.${(0, $08c107807d753255$export$a002182e51710d39).REGIONAL_AUTH_PUBLIC_CLOUD_SUFFIX}`;
        // Include the query string portion of the url
        const url = (0, $ff2860ddbc741970$export$3abcdca7229e54f2).constructAuthorityUriFromObject({
            ...authorityUrlInstance.getUrlComponents(),
            HostNameAndPort: hostNameAndPort
        }).urlString;
        // Add the query string if a query string was provided
        if (queryString) return `${url}?${queryString}`;
        return url;
    }
    /**
     * Replace the endpoints in the metadata object with their regional equivalents.
     *
     * @param metadata OpenIdConfigResponse
     * @param azureRegion string
     */ static replaceWithRegionalInformation(metadata, azureRegion) {
        const regionalMetadata = {
            ...metadata
        };
        regionalMetadata.authorization_endpoint = $dda2270c89fd90c8$export$f1c6ec2e6d68c49c.buildRegionalAuthorityString(regionalMetadata.authorization_endpoint, azureRegion);
        regionalMetadata.token_endpoint = $dda2270c89fd90c8$export$f1c6ec2e6d68c49c.buildRegionalAuthorityString(regionalMetadata.token_endpoint, azureRegion);
        if (regionalMetadata.end_session_endpoint) regionalMetadata.end_session_endpoint = $dda2270c89fd90c8$export$f1c6ec2e6d68c49c.buildRegionalAuthorityString(regionalMetadata.end_session_endpoint, azureRegion);
        return regionalMetadata;
    }
    /**
     * Transform CIAM_AUTHORIY as per the below rules:
     * If no path segments found and it is a CIAM authority (hostname ends with .ciamlogin.com), then transform it
     *
     * NOTE: The transformation path should go away once STS supports CIAM with the format: `tenantIdorDomain.ciamlogin.com`
     * `ciamlogin.com` can also change in the future and we should accommodate the same
     *
     * @param authority
     */ static transformCIAMAuthority(authority) {
        let ciamAuthority = authority;
        const authorityUrl = new (0, $ff2860ddbc741970$export$3abcdca7229e54f2)(authority);
        const authorityUrlComponents = authorityUrl.getUrlComponents();
        // check if transformation is needed
        if (authorityUrlComponents.PathSegments.length === 0 && authorityUrlComponents.HostNameAndPort.endsWith((0, $08c107807d753255$export$a002182e51710d39).CIAM_AUTH_URL)) {
            const tenantIdOrDomain = authorityUrlComponents.HostNameAndPort.split(".")[0];
            ciamAuthority = `${ciamAuthority}${tenantIdOrDomain}${(0, $08c107807d753255$export$a002182e51710d39).AAD_TENANT_DOMAIN_SUFFIX}`;
        }
        return ciamAuthority;
    }
}
// Reserved tenant domain names that will not be replaced with tenant id
$dda2270c89fd90c8$export$f1c6ec2e6d68c49c.reservedTenantDomains = new Set([
    "{tenant}",
    "{tenantid}",
    (0, $08c107807d753255$export$e18ac120172ed505).COMMON,
    (0, $08c107807d753255$export$e18ac120172ed505).CONSUMERS,
    (0, $08c107807d753255$export$e18ac120172ed505).ORGANIZATIONS
]);
/**
 * Extract tenantId from authority
 */ function $dda2270c89fd90c8$export$6ed5af33d279fbc7(authority) {
    const authorityUrl = new (0, $ff2860ddbc741970$export$3abcdca7229e54f2)(authority);
    const authorityUrlComponents = authorityUrl.getUrlComponents();
    /**
     * For credential matching purposes, tenantId is the last path segment of the authority URL:
     *  AAD Authority - domain/tenantId -> Credentials are cached with realm = tenantId
     *  B2C Authority - domain/{tenantId}?/.../policy -> Credentials are cached with realm = policy
     *  tenantId is downcased because B2C policies can have mixed case but tfp claim is downcased
     *
     * Note that we may not have any path segments in certain OIDC scenarios.
     */ const tenantId = authorityUrlComponents.PathSegments.slice(-1)[0]?.toLowerCase();
    switch(tenantId){
        case (0, $08c107807d753255$export$e18ac120172ed505).COMMON:
        case (0, $08c107807d753255$export$e18ac120172ed505).ORGANIZATIONS:
        case (0, $08c107807d753255$export$e18ac120172ed505).CONSUMERS:
            return undefined;
        default:
            return tenantId;
    }
}
function $dda2270c89fd90c8$export$4030f3538167cb9e(authorityUri) {
    return authorityUri.endsWith((0, $08c107807d753255$export$a002182e51710d39).FORWARD_SLASH) ? authorityUri : `${authorityUri}${(0, $08c107807d753255$export$a002182e51710d39).FORWARD_SLASH}`;
}
function $dda2270c89fd90c8$export$2b9ebf6f25078cc0(authOptions) {
    const rawCloudDiscoveryMetadata = authOptions.cloudDiscoveryMetadata;
    let cloudDiscoveryMetadata = undefined;
    if (rawCloudDiscoveryMetadata) try {
        cloudDiscoveryMetadata = JSON.parse(rawCloudDiscoveryMetadata);
    } catch (e) {
        throw (0, $a6f096219dc1b547$export$5d63d098f4f130a1)((0, $f66a3d6fc9f2eb73$export$92a2985751150ca5));
    }
    return {
        canonicalAuthority: authOptions.authority ? $dda2270c89fd90c8$export$4030f3538167cb9e(authOptions.authority) : undefined,
        knownAuthorities: authOptions.knownAuthorities,
        cloudDiscoveryMetadata: cloudDiscoveryMetadata
    };
}

/*! @azure/msal-common v14.16.1 2025-08-05 */ 

var $5663e5ea2c96c5cf$exports = {};

$parcel$export($5663e5ea2c96c5cf$exports, "noTokensFound", function () { return $5663e5ea2c96c5cf$export$e408b083cd212696; });
$parcel$export($5663e5ea2c96c5cf$exports, "nativeAccountUnavailable", function () { return $5663e5ea2c96c5cf$export$3bf2eb3358f5f570; });
$parcel$export($5663e5ea2c96c5cf$exports, "refreshTokenExpired", function () { return $5663e5ea2c96c5cf$export$a90e8b9c10991b49; });
$parcel$export($5663e5ea2c96c5cf$exports, "interactionRequired", function () { return $5663e5ea2c96c5cf$export$cdb77bf88e749c31; });
$parcel$export($5663e5ea2c96c5cf$exports, "consentRequired", function () { return $5663e5ea2c96c5cf$export$ca4e8d96d12fe4c5; });
$parcel$export($5663e5ea2c96c5cf$exports, "loginRequired", function () { return $5663e5ea2c96c5cf$export$402ebc0f96d7decb; });
$parcel$export($5663e5ea2c96c5cf$exports, "badToken", function () { return $5663e5ea2c96c5cf$export$2e3666c77d45a4da; });
/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Codes defined by MSAL
const $5663e5ea2c96c5cf$export$e408b083cd212696 = "no_tokens_found";
const $5663e5ea2c96c5cf$export$3bf2eb3358f5f570 = "native_account_unavailable";
const $5663e5ea2c96c5cf$export$a90e8b9c10991b49 = "refresh_token_expired";
// Codes potentially returned by server
const $5663e5ea2c96c5cf$export$cdb77bf88e749c31 = "interaction_required";
const $5663e5ea2c96c5cf$export$ca4e8d96d12fe4c5 = "consent_required";
const $5663e5ea2c96c5cf$export$402ebc0f96d7decb = "login_required";
const $5663e5ea2c96c5cf$export$2e3666c77d45a4da = "bad_token";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * InteractionRequiredServerErrorMessage contains string constants used by error codes and messages returned by the server indicating interaction is required
 */ const $0171ff24547bf7bf$export$e16d6a6c677acec5 = [
    (0, $5663e5ea2c96c5cf$export$cdb77bf88e749c31),
    (0, $5663e5ea2c96c5cf$export$ca4e8d96d12fe4c5),
    (0, $5663e5ea2c96c5cf$export$402ebc0f96d7decb),
    (0, $5663e5ea2c96c5cf$export$2e3666c77d45a4da)
];
const $0171ff24547bf7bf$export$9689959ec6716811 = [
    "message_only",
    "additional_action",
    "basic_action",
    "user_password_expired",
    "consent_required",
    "bad_token"
];
const $0171ff24547bf7bf$var$InteractionRequiredAuthErrorMessages = {
    [(0, $5663e5ea2c96c5cf$export$e408b083cd212696)]: "No refresh token found in the cache. Please sign-in.",
    [(0, $5663e5ea2c96c5cf$export$3bf2eb3358f5f570)]: "The requested account is not available in the native broker. It may have been deleted or logged out. Please sign-in again using an interactive API.",
    [(0, $5663e5ea2c96c5cf$export$a90e8b9c10991b49)]: "Refresh token has expired.",
    [(0, $5663e5ea2c96c5cf$export$2e3666c77d45a4da)]: "Identity provider returned bad_token due to an expired or invalid refresh token. Please invoke an interactive API to resolve."
};
/**
 * Interaction required errors defined by the SDK
 * @deprecated Use InteractionRequiredAuthErrorCodes instead
 */ const $0171ff24547bf7bf$export$d44d3b7b7a580eb6 = {
    noTokensFoundError: {
        code: (0, $5663e5ea2c96c5cf$export$e408b083cd212696),
        desc: $0171ff24547bf7bf$var$InteractionRequiredAuthErrorMessages[0, $5663e5ea2c96c5cf$export$e408b083cd212696]
    },
    native_account_unavailable: {
        code: (0, $5663e5ea2c96c5cf$export$3bf2eb3358f5f570),
        desc: $0171ff24547bf7bf$var$InteractionRequiredAuthErrorMessages[0, $5663e5ea2c96c5cf$export$3bf2eb3358f5f570]
    },
    bad_token: {
        code: (0, $5663e5ea2c96c5cf$export$2e3666c77d45a4da),
        desc: $0171ff24547bf7bf$var$InteractionRequiredAuthErrorMessages[0, $5663e5ea2c96c5cf$export$2e3666c77d45a4da]
    }
};
/**
 * Error thrown when user interaction is required.
 */ class $0171ff24547bf7bf$export$6ba3e818c6bc76ba extends (0, $53b49d8334c1646a$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage, subError, timestamp, traceId, correlationId, claims, errorNo){
        super(errorCode, errorMessage, subError);
        Object.setPrototypeOf(this, $0171ff24547bf7bf$export$6ba3e818c6bc76ba.prototype);
        this.timestamp = timestamp || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING;
        this.traceId = traceId || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING;
        this.correlationId = correlationId || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING;
        this.claims = claims || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING;
        this.name = "InteractionRequiredAuthError";
        this.errorNo = errorNo;
    }
}
/**
 * Helper function used to determine if an error thrown by the server requires interaction to resolve
 * @param errorCode
 * @param errorString
 * @param subError
 */ function $0171ff24547bf7bf$export$376c3c4c19cb933a(errorCode, errorString, subError) {
    const isInteractionRequiredErrorCode = !!errorCode && $0171ff24547bf7bf$export$e16d6a6c677acec5.indexOf(errorCode) > -1;
    const isInteractionRequiredSubError = !!subError && $0171ff24547bf7bf$export$9689959ec6716811.indexOf(subError) > -1;
    const isInteractionRequiredErrorDesc = !!errorString && $0171ff24547bf7bf$export$e16d6a6c677acec5.some((irErrorCode)=>{
        return errorString.indexOf(irErrorCode) > -1;
    });
    return isInteractionRequiredErrorCode || isInteractionRequiredErrorDesc || isInteractionRequiredSubError;
}
/**
 * Creates an InteractionRequiredAuthError
 */ function $0171ff24547bf7bf$export$8f7a741750c16535(errorCode) {
    return new $0171ff24547bf7bf$export$6ba3e818c6bc76ba(errorCode, $0171ff24547bf7bf$var$InteractionRequiredAuthErrorMessages[errorCode]);
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ /*! @azure/msal-common v14.16.1 2025-08-05 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Class which provides helpers for OAuth 2.0 protocol specific values
 */ class $1cc651d5e90b7480$export$871e33217042c65e {
    /**
     * Appends user state with random guid, or returns random guid.
     * @param userState
     * @param randomGuid
     */ static setRequestState(cryptoObj, userState, meta) {
        const libraryState = $1cc651d5e90b7480$export$871e33217042c65e.generateLibraryState(cryptoObj, meta);
        return userState ? `${libraryState}${(0, $08c107807d753255$export$a002182e51710d39).RESOURCE_DELIM}${userState}` : libraryState;
    }
    /**
     * Generates the state value used by the common library.
     * @param randomGuid
     * @param cryptoObj
     */ static generateLibraryState(cryptoObj, meta) {
        if (!cryptoObj) throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$c39e501a22cba395));
        // Create a state object containing a unique id and the timestamp of the request creation
        const stateObj = {
            id: cryptoObj.createNewGuid()
        };
        if (meta) stateObj.meta = meta;
        const stateString = JSON.stringify(stateObj);
        return cryptoObj.base64Encode(stateString);
    }
    /**
     * Parses the state into the RequestStateObject, which contains the LibraryState info and the state passed by the user.
     * @param state
     * @param cryptoObj
     */ static parseRequestState(cryptoObj, state) {
        if (!cryptoObj) throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$c39e501a22cba395));
        if (!state) throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$72a77317632c052b));
        try {
            // Split the state between library state and user passed state and decode them separately
            const splitState = state.split((0, $08c107807d753255$export$a002182e51710d39).RESOURCE_DELIM);
            const libraryState = splitState[0];
            const userState = splitState.length > 1 ? splitState.slice(1).join((0, $08c107807d753255$export$a002182e51710d39).RESOURCE_DELIM) : (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING;
            const libraryStateString = cryptoObj.base64Decode(libraryState);
            const libraryStateObj = JSON.parse(libraryStateString);
            return {
                userRequestState: userState || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING,
                libraryState: libraryStateObj
            };
        } catch (e) {
            throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$72a77317632c052b));
        }
    }
}

/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $36f32d37ad76b0c5$export$17b7b3ac1abef49f = {
    HOME_ACCOUNT_ID: "home_account_id",
    UPN: "UPN"
};




/*! @azure/msal-browser v3.30.0 2025-08-05 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $61cf1426cc39c4a8$export$19fffca37ef3e106 {
    constructor(){
        if (!window.localStorage) throw (0, $d1b404816c4f6b37$export$176bd5050947ba0c)((0, $a9716436b0450272$export$41d7a3d4e14d6113));
    }
    getItem(key) {
        return window.localStorage.getItem(key);
    }
    setItem(key, value) {
        window.localStorage.setItem(key, value);
    }
    removeItem(key) {
        window.localStorage.removeItem(key);
    }
    getKeys() {
        return Object.keys(window.localStorage);
    }
    containsKey(key) {
        return window.localStorage.hasOwnProperty(key);
    }
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $684017062d6af0b8$export$2c4b17e1c2e0931 {
    constructor(){
        if (!window.sessionStorage) throw (0, $d1b404816c4f6b37$export$176bd5050947ba0c)((0, $a9716436b0450272$export$41d7a3d4e14d6113));
    }
    getItem(key) {
        return window.sessionStorage.getItem(key);
    }
    setItem(key, value) {
        window.sessionStorage.setItem(key, value);
    }
    removeItem(key) {
        window.sessionStorage.removeItem(key);
    }
    getKeys() {
        return Object.keys(window.sessionStorage);
    }
    containsKey(key) {
        return window.sessionStorage.hasOwnProperty(key);
    }
}



/*! @azure/msal-browser v3.30.0 2025-08-05 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Extracts the BrowserStateObject from the state string.
 * @param browserCrypto
 * @param state
 */ function $e5678e89c6203472$export$68ec87f530f5f536(browserCrypto, state) {
    if (!state) return null;
    try {
        const requestStateObj = (0, $1cc651d5e90b7480$export$871e33217042c65e).parseRequestState(browserCrypto, state);
        return requestStateObj.libraryState.meta;
    } catch (e) {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$exports).invalidState);
    }
}




/*! @azure/msal-browser v3.30.0 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Cookie life calculation (hours * minutes * seconds * ms)
const $1962b548efca9ec7$var$COOKIE_LIFE_MULTIPLIER = 86400000;
class $1962b548efca9ec7$export$dae7d845015939d5 {
    getItem(key) {
        const name = `${encodeURIComponent(key)}`;
        const cookieList = document.cookie.split(";");
        for(let i = 0; i < cookieList.length; i++){
            const cookie = cookieList[i];
            const [key, ...rest] = decodeURIComponent(cookie).trim().split("=");
            const value = rest.join("=");
            if (key === name) return value;
        }
        return "";
    }
    setItem(key, value, cookieLifeDays, secure = true) {
        let cookieStr = `${encodeURIComponent(key)}=${encodeURIComponent(value)};path=/;SameSite=Lax;`;
        if (cookieLifeDays) {
            const expireTime = $1962b548efca9ec7$export$b720d871a37fa65(cookieLifeDays);
            cookieStr += `expires=${expireTime};`;
        }
        if (secure) cookieStr += "Secure;";
        document.cookie = cookieStr;
    }
    removeItem(key) {
        // Setting expiration to -1 removes it
        this.setItem(key, "", -1);
    }
    getKeys() {
        const cookieList = document.cookie.split(";");
        const keys = [];
        cookieList.forEach((cookie)=>{
            const cookieParts = decodeURIComponent(cookie).trim().split("=");
            keys.push(cookieParts[0]);
        });
        return keys;
    }
    containsKey(key) {
        return this.getKeys().includes(key);
    }
}
/**
 * Get cookie expiration time
 * @param cookieLifeDays
 */ function $1962b548efca9ec7$export$b720d871a37fa65(cookieLifeDays) {
    const today = new Date();
    const expr = new Date(today.getTime() + cookieLifeDays * $1962b548efca9ec7$var$COOKIE_LIFE_MULTIPLIER);
    return expr.toUTCString();
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class implements the cache storage interface for MSAL through browser local or session storage.
 * Cookies are only used if storeAuthStateInCookie is true, and are only used for
 * parameters such as state and nonce, generally.
 */ class $acde3ca448a630dc$export$44d7291b5c8cc149 extends (0, $4ffcb9b8559edbe4$export$996e3ea69314b5c6) {
    constructor(clientId, cacheConfig, cryptoImpl, logger, staticAuthorityOptions, performanceClient){
        super(clientId, cryptoImpl, logger, staticAuthorityOptions);
        this.cacheConfig = cacheConfig;
        this.logger = logger;
        this.internalStorage = new (0, $b85fe2fa055a4f1c$export$d7392285c701ecf5)();
        this.browserStorage = this.setupBrowserStorage(this.cacheConfig.cacheLocation);
        this.temporaryCacheStorage = this.setupBrowserStorage(this.cacheConfig.temporaryCacheLocation);
        this.cookieStorage = new (0, $1962b548efca9ec7$export$dae7d845015939d5)();
        // Migrate cache entries from older versions of MSAL.
        if (cacheConfig.cacheMigrationEnabled) {
            this.migrateCacheEntries();
            this.createKeyMaps();
        }
        this.performanceClient = performanceClient;
    }
    /**
     * Returns a window storage class implementing the IWindowStorage interface that corresponds to the configured cacheLocation.
     * @param cacheLocation
     */ setupBrowserStorage(cacheLocation) {
        try {
            switch(cacheLocation){
                case (0, $091acf4c2675819b$export$573384e47a12d835).LocalStorage:
                    return new (0, $61cf1426cc39c4a8$export$19fffca37ef3e106)();
                case (0, $091acf4c2675819b$export$573384e47a12d835).SessionStorage:
                    return new (0, $684017062d6af0b8$export$2c4b17e1c2e0931)();
                case (0, $091acf4c2675819b$export$573384e47a12d835).MemoryStorage:
                default:
                    break;
            }
        } catch (e) {
            this.logger.error(e);
        }
        this.cacheConfig.cacheLocation = (0, $091acf4c2675819b$export$573384e47a12d835).MemoryStorage;
        return new (0, $b85fe2fa055a4f1c$export$d7392285c701ecf5)();
    }
    /**
     * Migrate all old cache entries to new schema. No rollback supported.
     * @param storeAuthStateInCookie
     */ migrateCacheEntries() {
        const previousVersion = this.browserStorage.getItem((0, $091acf4c2675819b$export$f6ce23cce692699f).VERSION);
        if (previousVersion) this.logger.info(`MSAL.js was last initialized with version ${previousVersion}`);
        if (previousVersion !== (0, $f42d0d3ccc24f1b6$export$83d89fbfd8236492)) this.browserStorage.setItem((0, $091acf4c2675819b$export$f6ce23cce692699f).VERSION, (0, $f42d0d3ccc24f1b6$export$83d89fbfd8236492));
        const idTokenKey = `${(0, $08c107807d753255$export$a002182e51710d39).CACHE_PREFIX}.${(0, $08c107807d753255$export$81ab9ba9bd28255c).ID_TOKEN}`;
        const clientInfoKey = `${(0, $08c107807d753255$export$a002182e51710d39).CACHE_PREFIX}.${(0, $08c107807d753255$export$81ab9ba9bd28255c).CLIENT_INFO}`;
        const errorKey = `${(0, $08c107807d753255$export$a002182e51710d39).CACHE_PREFIX}.${(0, $08c107807d753255$export$81ab9ba9bd28255c).ERROR}`;
        const errorDescKey = `${(0, $08c107807d753255$export$a002182e51710d39).CACHE_PREFIX}.${(0, $08c107807d753255$export$81ab9ba9bd28255c).ERROR_DESC}`;
        const idTokenValue = this.browserStorage.getItem(idTokenKey);
        const clientInfoValue = this.browserStorage.getItem(clientInfoKey);
        const errorValue = this.browserStorage.getItem(errorKey);
        const errorDescValue = this.browserStorage.getItem(errorDescKey);
        const values = [
            idTokenValue,
            clientInfoValue,
            errorValue,
            errorDescValue
        ];
        const keysToMigrate = [
            (0, $08c107807d753255$export$81ab9ba9bd28255c).ID_TOKEN,
            (0, $08c107807d753255$export$81ab9ba9bd28255c).CLIENT_INFO,
            (0, $08c107807d753255$export$81ab9ba9bd28255c).ERROR,
            (0, $08c107807d753255$export$81ab9ba9bd28255c).ERROR_DESC
        ];
        keysToMigrate.forEach((cacheKey, index)=>{
            const value = values[index];
            if (value) this.setTemporaryCache(cacheKey, value, true);
        });
    }
    /**
     * Searches all cache entries for MSAL accounts and creates the account key map
     * This is used to migrate users from older versions of MSAL which did not create the map.
     * @returns
     */ createKeyMaps() {
        this.logger.trace("BrowserCacheManager - createKeyMaps called.");
        const correlationId = this.cryptoImpl.createNewGuid();
        const accountKeys = this.getItem((0, $091acf4c2675819b$export$f6ce23cce692699f).ACCOUNT_KEYS);
        const tokenKeys = this.getItem(`${(0, $091acf4c2675819b$export$f6ce23cce692699f).TOKEN_KEYS}.${this.clientId}`);
        if (accountKeys && tokenKeys) {
            this.logger.verbose("BrowserCacheManager:createKeyMaps - account and token key maps already exist, skipping migration.");
            // Key maps already exist, no need to iterate through cache
            return;
        }
        const allKeys = this.browserStorage.getKeys();
        allKeys.forEach((key)=>{
            if (this.isCredentialKey(key)) {
                // Get item, parse, validate and write key to map
                const value = this.getItem(key);
                if (value) {
                    const credObj = this.validateAndParseJson(value);
                    if (credObj && credObj.hasOwnProperty("credentialType")) switch(credObj["credentialType"]){
                        case (0, $08c107807d753255$export$eca2dc7e6e608a68).ID_TOKEN:
                            if ((0, $bd840ab348a8e6dd$exports).isIdTokenEntity(credObj)) {
                                this.logger.trace("BrowserCacheManager:createKeyMaps - idToken found, saving key to token key map");
                                this.logger.tracePii(`BrowserCacheManager:createKeyMaps - idToken with key: ${key} found, saving key to token key map`);
                                const idTokenEntity = credObj;
                                const newKey = this.updateCredentialCacheKey(key, idTokenEntity, correlationId);
                                this.addTokenKey(newKey, (0, $08c107807d753255$export$eca2dc7e6e608a68).ID_TOKEN, correlationId);
                                return;
                            } else {
                                this.logger.trace("BrowserCacheManager:createKeyMaps - key found matching idToken schema with value containing idToken credentialType field but value failed IdTokenEntity validation, skipping.");
                                this.logger.tracePii(`BrowserCacheManager:createKeyMaps - failed idToken validation on key: ${key}`);
                            }
                            break;
                        case (0, $08c107807d753255$export$eca2dc7e6e608a68).ACCESS_TOKEN:
                        case (0, $08c107807d753255$export$eca2dc7e6e608a68).ACCESS_TOKEN_WITH_AUTH_SCHEME:
                            if ((0, $bd840ab348a8e6dd$exports).isAccessTokenEntity(credObj)) {
                                this.logger.trace("BrowserCacheManager:createKeyMaps - accessToken found, saving key to token key map");
                                this.logger.tracePii(`BrowserCacheManager:createKeyMaps - accessToken with key: ${key} found, saving key to token key map`);
                                const accessTokenEntity = credObj;
                                const newKey = this.updateCredentialCacheKey(key, accessTokenEntity, correlationId);
                                this.addTokenKey(newKey, (0, $08c107807d753255$export$eca2dc7e6e608a68).ACCESS_TOKEN, correlationId);
                                return;
                            } else {
                                this.logger.trace("BrowserCacheManager:createKeyMaps - key found matching accessToken schema with value containing accessToken credentialType field but value failed AccessTokenEntity validation, skipping.");
                                this.logger.tracePii(`BrowserCacheManager:createKeyMaps - failed accessToken validation on key: ${key}`);
                            }
                            break;
                        case (0, $08c107807d753255$export$eca2dc7e6e608a68).REFRESH_TOKEN:
                            if ((0, $bd840ab348a8e6dd$exports).isRefreshTokenEntity(credObj)) {
                                this.logger.trace("BrowserCacheManager:createKeyMaps - refreshToken found, saving key to token key map");
                                this.logger.tracePii(`BrowserCacheManager:createKeyMaps - refreshToken with key: ${key} found, saving key to token key map`);
                                const refreshTokenEntity = credObj;
                                const newKey = this.updateCredentialCacheKey(key, refreshTokenEntity, correlationId);
                                this.addTokenKey(newKey, (0, $08c107807d753255$export$eca2dc7e6e608a68).REFRESH_TOKEN, correlationId);
                                return;
                            } else {
                                this.logger.trace("BrowserCacheManager:createKeyMaps - key found matching refreshToken schema with value containing refreshToken credentialType field but value failed RefreshTokenEntity validation, skipping.");
                                this.logger.tracePii(`BrowserCacheManager:createKeyMaps - failed refreshToken validation on key: ${key}`);
                            }
                            break;
                    }
                }
            }
            if (this.isAccountKey(key)) {
                const value = this.getItem(key);
                if (value) {
                    const accountObj = this.validateAndParseJson(value);
                    if (accountObj && (0, $35a4414ce05ac30e$export$680160523e6bfa6a).isAccountEntity(accountObj)) {
                        this.logger.trace("BrowserCacheManager:createKeyMaps - account found, saving key to account key map");
                        this.logger.tracePii(`BrowserCacheManager:createKeyMaps - account with key: ${key} found, saving key to account key map`);
                        this.addAccountKeyToMap(key, correlationId);
                    }
                }
            }
        });
    }
    /**
     * Parses passed value as JSON object, JSON.parse() will throw an error.
     * @param input
     */ validateAndParseJson(jsonValue) {
        try {
            const parsedJson = JSON.parse(jsonValue);
            /**
             * There are edge cases in which JSON.parse will successfully parse a non-valid JSON object
             * (e.g. JSON.parse will parse an escaped string into an unescaped string), so adding a type check
             * of the parsed value is necessary in order to be certain that the string represents a valid JSON object.
             *
             */ return parsedJson && typeof parsedJson === "object" ? parsedJson : null;
        } catch (error) {
            return null;
        }
    }
    /**
     * fetches the entry from the browser storage based off the key
     * @param key
     */ getItem(key) {
        return this.browserStorage.getItem(key);
    }
    /**
     * sets the entry in the browser storage
     * @param key
     * @param value
     */ setItem(key, value, correlationId) {
        let accessTokenKeys = [];
        const maxRetries = 20;
        for(let i = 0; i <= maxRetries; i++)try {
            this.browserStorage.setItem(key, value);
            if (i > 0) // Finally update the token keys array with the tokens removed
            this.removeAccessTokenKeys(accessTokenKeys.slice(0, i), correlationId);
            break; // If setItem succeeds, exit the loop
        } catch (e) {
            const cacheError = (0, $812f0ad9daef6a7a$export$2056718aee1b1d88)(e);
            if (cacheError.errorCode === (0, $20d5d8804295d8ea$exports).cacheQuotaExceeded && i < maxRetries) {
                if (!accessTokenKeys.length) {
                    if (key === `${(0, $091acf4c2675819b$export$f6ce23cce692699f).TOKEN_KEYS}.${this.clientId}`) // If we are currently trying to set the token keys, use the value we're trying to set
                    accessTokenKeys = JSON.parse(value).accessToken;
                    else // If token keys have not been initialized, get them
                    accessTokenKeys = this.getTokenKeys().accessToken;
                }
                if (accessTokenKeys.length <= i) // Nothing to remove, rethrow the error
                throw cacheError;
                // When cache quota is exceeded, start removing access tokens until we can successfully set the item
                this.removeAccessToken(accessTokenKeys[i], correlationId, false // Don't save token keys yet, do it at the end
                );
            } else // If the error is not a quota exceeded error, rethrow it
            throw cacheError;
        }
    }
    /**
     * fetch the account entity from the platform cache
     * @param accountKey
     */ getAccount(accountKey, correlationId, logger) {
        this.logger.trace("BrowserCacheManager.getAccount called");
        const accountEntity = this.getCachedAccountEntity(accountKey, correlationId);
        return this.updateOutdatedCachedAccount(accountKey, accountEntity, correlationId, logger);
    }
    /**
     * Reads account from cache, deserializes it into an account entity and returns it.
     * If account is not found from the key, returns null and removes key from map.
     * @param accountKey
     * @returns
     */ getCachedAccountEntity(accountKey, correlationId) {
        const serializedAccount = this.getItem(accountKey);
        if (!serializedAccount) {
            this.removeAccountKeyFromMap(accountKey, correlationId);
            return null;
        }
        const parsedAccount = this.validateAndParseJson(serializedAccount);
        if (!parsedAccount || !(0, $35a4414ce05ac30e$export$680160523e6bfa6a).isAccountEntity(parsedAccount)) return null;
        return (0, $4ffcb9b8559edbe4$export$996e3ea69314b5c6).toObject(new (0, $35a4414ce05ac30e$export$680160523e6bfa6a)(), parsedAccount);
    }
    /**
     * set account entity in the platform cache
     * @param account
     */ setAccount(account, correlationId) {
        this.logger.trace("BrowserCacheManager.setAccount called");
        const key = account.generateAccountKey();
        account.lastUpdatedAt = Date.now().toString();
        this.setItem(key, JSON.stringify(account), correlationId);
        this.addAccountKeyToMap(key, correlationId);
    }
    /**
     * Returns the array of account keys currently cached
     * @returns
     */ getAccountKeys() {
        this.logger.trace("BrowserCacheManager.getAccountKeys called");
        const accountKeys = this.getItem((0, $091acf4c2675819b$export$f6ce23cce692699f).ACCOUNT_KEYS);
        if (accountKeys) return JSON.parse(accountKeys);
        this.logger.verbose("BrowserCacheManager.getAccountKeys - No account keys found");
        return [];
    }
    /**
     * Add a new account to the key map
     * @param key
     */ addAccountKeyToMap(key, correlationId) {
        this.logger.trace("BrowserCacheManager.addAccountKeyToMap called");
        this.logger.tracePii(`BrowserCacheManager.addAccountKeyToMap called with key: ${key}`);
        const accountKeys = this.getAccountKeys();
        if (accountKeys.indexOf(key) === -1) {
            // Only add key if it does not already exist in the map
            accountKeys.push(key);
            this.setItem((0, $091acf4c2675819b$export$f6ce23cce692699f).ACCOUNT_KEYS, JSON.stringify(accountKeys), correlationId);
            this.logger.verbose("BrowserCacheManager.addAccountKeyToMap account key added");
        } else this.logger.verbose("BrowserCacheManager.addAccountKeyToMap account key already exists in map");
    }
    /**
     * Remove an account from the key map
     * @param key
     */ removeAccountKeyFromMap(key, correlationId) {
        this.logger.trace("BrowserCacheManager.removeAccountKeyFromMap called");
        this.logger.tracePii(`BrowserCacheManager.removeAccountKeyFromMap called with key: ${key}`);
        const accountKeys = this.getAccountKeys();
        const removalIndex = accountKeys.indexOf(key);
        if (removalIndex > -1) {
            accountKeys.splice(removalIndex, 1);
            if (accountKeys.length === 0) {
                // If no keys left, remove the map
                this.removeItem((0, $091acf4c2675819b$export$f6ce23cce692699f).ACCOUNT_KEYS);
                return;
            } else this.setItem((0, $091acf4c2675819b$export$f6ce23cce692699f).ACCOUNT_KEYS, JSON.stringify(accountKeys), correlationId);
            this.logger.trace("BrowserCacheManager.removeAccountKeyFromMap account key removed");
        } else this.logger.trace("BrowserCacheManager.removeAccountKeyFromMap key not found in existing map");
    }
    /**
     * Extends inherited removeAccount function to include removal of the account key from the map
     * @param key
     */ async removeAccount(key, correlationId) {
        super.removeAccount(key, correlationId);
        this.removeAccountKeyFromMap(key, correlationId);
    }
    /**
     * Remove account entity from the platform cache if it's outdated
     * @param accountKey
     */ removeOutdatedAccount(accountKey, correlationId) {
        this.removeItem(accountKey);
        this.removeAccountKeyFromMap(accountKey, correlationId);
    }
    /**
     * Removes given idToken from the cache and from the key map
     * @param key
     */ removeIdToken(key, correlationId) {
        super.removeIdToken(key, correlationId);
        this.removeTokenKey(key, (0, $08c107807d753255$export$eca2dc7e6e608a68).ID_TOKEN, correlationId);
    }
    /**
     * Removes given accessToken from the cache and from the key map
     * @param key
     */ removeAccessToken(key, correlationId, updateTokenKeys = true) {
        super.removeAccessToken(key, correlationId);
        this.performanceClient?.incrementFields({
            accessTokensRemoved: 1
        }, correlationId);
        updateTokenKeys && this.removeTokenKey(key, (0, $08c107807d753255$export$eca2dc7e6e608a68).ACCESS_TOKEN, correlationId);
    }
    removeAccessTokenKeys(keys, correlationId) {
        this.logger.trace("removeAccessTokenKey called");
        const tokenKeys = this.getTokenKeys();
        let keysRemoved = 0;
        keys.forEach((key)=>{
            const accessRemoval = tokenKeys.accessToken.indexOf(key);
            if (accessRemoval > -1) {
                tokenKeys.accessToken.splice(accessRemoval, 1);
                keysRemoved++;
            }
        });
        if (keysRemoved > 0) {
            this.logger.info(`removed ${keysRemoved} accessToken keys from tokenKeys map`);
            this.setTokenKeys(tokenKeys, correlationId);
            return;
        }
    }
    /**
     * Removes given refreshToken from the cache and from the key map
     * @param key
     */ removeRefreshToken(key, correlationId) {
        super.removeRefreshToken(key, correlationId);
        this.removeTokenKey(key, (0, $08c107807d753255$export$eca2dc7e6e608a68).REFRESH_TOKEN, correlationId);
    }
    /**
     * Gets the keys for the cached tokens associated with this clientId
     * @returns
     */ getTokenKeys() {
        this.logger.trace("BrowserCacheManager.getTokenKeys called");
        const item = this.getItem(`${(0, $091acf4c2675819b$export$f6ce23cce692699f).TOKEN_KEYS}.${this.clientId}`);
        if (item) {
            const tokenKeys = this.validateAndParseJson(item);
            if (tokenKeys && tokenKeys.hasOwnProperty("idToken") && tokenKeys.hasOwnProperty("accessToken") && tokenKeys.hasOwnProperty("refreshToken")) return tokenKeys;
            else this.logger.error("BrowserCacheManager.getTokenKeys - Token keys found but in an unknown format. Returning empty key map.");
        } else this.logger.verbose("BrowserCacheManager.getTokenKeys - No token keys found");
        return {
            idToken: [],
            accessToken: [],
            refreshToken: []
        };
    }
    /**
     * Stores the token keys in the cache
     * @param tokenKeys
     * @param correlationId
     * @returns
     */ setTokenKeys(tokenKeys, correlationId) {
        if (tokenKeys.idToken.length === 0 && tokenKeys.accessToken.length === 0 && tokenKeys.refreshToken.length === 0) {
            // If no keys left, remove the map
            this.removeItem(`${(0, $091acf4c2675819b$export$f6ce23cce692699f).TOKEN_KEYS}.${this.clientId}`);
            return;
        } else this.setItem(`${(0, $091acf4c2675819b$export$f6ce23cce692699f).TOKEN_KEYS}.${this.clientId}`, JSON.stringify(tokenKeys), correlationId);
    }
    /**
     * Adds the given key to the token key map
     * @param key
     * @param type
     */ addTokenKey(key, type, correlationId) {
        this.logger.trace("BrowserCacheManager addTokenKey called");
        const tokenKeys = this.getTokenKeys();
        switch(type){
            case (0, $08c107807d753255$export$eca2dc7e6e608a68).ID_TOKEN:
                if (tokenKeys.idToken.indexOf(key) === -1) {
                    this.logger.info("BrowserCacheManager: addTokenKey - idToken added to map");
                    tokenKeys.idToken.push(key);
                }
                break;
            case (0, $08c107807d753255$export$eca2dc7e6e608a68).ACCESS_TOKEN:
                const index = tokenKeys.accessToken.indexOf(key);
                if (index !== -1) tokenKeys.accessToken.splice(index, 1); // Remove existing key before pushing to the end
                this.logger.trace(`access token ${index === -1 ? "added to" : "updated in"} map`);
                tokenKeys.accessToken.push(key);
                break;
            case (0, $08c107807d753255$export$eca2dc7e6e608a68).REFRESH_TOKEN:
                if (tokenKeys.refreshToken.indexOf(key) === -1) {
                    this.logger.info("BrowserCacheManager: addTokenKey - refreshToken added to map");
                    tokenKeys.refreshToken.push(key);
                }
                break;
            default:
                this.logger.error(`BrowserCacheManager:addTokenKey - CredentialType provided invalid. CredentialType: ${type}`);
                throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$exports).unexpectedCredentialType);
        }
        this.setTokenKeys(tokenKeys, correlationId);
    }
    /**
     * Removes the given key from the token key map
     * @param key
     * @param type
     */ removeTokenKey(key, type, correlationId, tokenKeys = this.getTokenKeys()) {
        this.logger.trace("BrowserCacheManager removeTokenKey called");
        switch(type){
            case (0, $08c107807d753255$export$eca2dc7e6e608a68).ID_TOKEN:
                this.logger.infoPii(`BrowserCacheManager: removeTokenKey - attempting to remove idToken with key: ${key} from map`);
                const idRemoval = tokenKeys.idToken.indexOf(key);
                if (idRemoval > -1) {
                    this.logger.info("BrowserCacheManager: removeTokenKey - idToken removed from map");
                    tokenKeys.idToken.splice(idRemoval, 1);
                } else this.logger.info("BrowserCacheManager: removeTokenKey - idToken does not exist in map. Either it was previously removed or it was never added.");
                break;
            case (0, $08c107807d753255$export$eca2dc7e6e608a68).ACCESS_TOKEN:
                this.logger.infoPii(`BrowserCacheManager: removeTokenKey - attempting to remove accessToken with key: ${key} from map`);
                const accessRemoval = tokenKeys.accessToken.indexOf(key);
                if (accessRemoval > -1) {
                    this.logger.info("BrowserCacheManager: removeTokenKey - accessToken removed from map");
                    tokenKeys.accessToken.splice(accessRemoval, 1);
                } else this.logger.info("BrowserCacheManager: removeTokenKey - accessToken does not exist in map. Either it was previously removed or it was never added.");
                break;
            case (0, $08c107807d753255$export$eca2dc7e6e608a68).REFRESH_TOKEN:
                this.logger.infoPii(`BrowserCacheManager: removeTokenKey - attempting to remove refreshToken with key: ${key} from map`);
                const refreshRemoval = tokenKeys.refreshToken.indexOf(key);
                if (refreshRemoval > -1) {
                    this.logger.info("BrowserCacheManager: removeTokenKey - refreshToken removed from map");
                    tokenKeys.refreshToken.splice(refreshRemoval, 1);
                } else this.logger.info("BrowserCacheManager: removeTokenKey - refreshToken does not exist in map. Either it was previously removed or it was never added.");
                break;
            default:
                this.logger.error(`BrowserCacheManager:removeTokenKey - CredentialType provided invalid. CredentialType: ${type}`);
                throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$exports).unexpectedCredentialType);
        }
        this.setTokenKeys(tokenKeys, correlationId);
    }
    /**
     * generates idToken entity from a string
     * @param idTokenKey
     */ getIdTokenCredential(idTokenKey, correlationId) {
        const value = this.getItem(idTokenKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getIdTokenCredential: called, no cache hit");
            this.removeIdToken(idTokenKey, correlationId);
            return null;
        }
        const parsedIdToken = this.validateAndParseJson(value);
        if (!parsedIdToken || !(0, $bd840ab348a8e6dd$exports).isIdTokenEntity(parsedIdToken)) {
            this.logger.trace("BrowserCacheManager.getIdTokenCredential: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getIdTokenCredential: cache hit");
        return parsedIdToken;
    }
    /**
     * set IdToken credential to the platform cache
     * @param idToken
     */ setIdTokenCredential(idToken, correlationId) {
        this.logger.trace("BrowserCacheManager.setIdTokenCredential called");
        const idTokenKey = (0, $bd840ab348a8e6dd$exports).generateCredentialKey(idToken);
        idToken.lastUpdatedAt = Date.now().toString();
        this.setItem(idTokenKey, JSON.stringify(idToken), correlationId);
        this.addTokenKey(idTokenKey, (0, $08c107807d753255$export$eca2dc7e6e608a68).ID_TOKEN, correlationId);
    }
    /**
     * generates accessToken entity from a string
     * @param key
     */ getAccessTokenCredential(accessTokenKey, correlationId) {
        const value = this.getItem(accessTokenKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getAccessTokenCredential: called, no cache hit");
            this.removeTokenKey(accessTokenKey, (0, $08c107807d753255$export$eca2dc7e6e608a68).ACCESS_TOKEN, correlationId);
            return null;
        }
        const parsedAccessToken = this.validateAndParseJson(value);
        if (!parsedAccessToken || !(0, $bd840ab348a8e6dd$exports).isAccessTokenEntity(parsedAccessToken)) {
            this.logger.trace("BrowserCacheManager.getAccessTokenCredential: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getAccessTokenCredential: cache hit");
        return parsedAccessToken;
    }
    /**
     * set accessToken credential to the platform cache
     * @param accessToken
     */ setAccessTokenCredential(accessToken, correlationId) {
        this.logger.trace("BrowserCacheManager.setAccessTokenCredential called");
        const accessTokenKey = (0, $bd840ab348a8e6dd$exports).generateCredentialKey(accessToken);
        accessToken.lastUpdatedAt = Date.now().toString();
        this.setItem(accessTokenKey, JSON.stringify(accessToken), correlationId);
        this.addTokenKey(accessTokenKey, (0, $08c107807d753255$export$eca2dc7e6e608a68).ACCESS_TOKEN, correlationId);
    }
    /**
     * generates refreshToken entity from a string
     * @param refreshTokenKey
     */ getRefreshTokenCredential(refreshTokenKey, correlationId) {
        const value = this.getItem(refreshTokenKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: called, no cache hit");
            this.removeTokenKey(refreshTokenKey, (0, $08c107807d753255$export$eca2dc7e6e608a68).REFRESH_TOKEN, correlationId);
            return null;
        }
        const parsedRefreshToken = this.validateAndParseJson(value);
        if (!parsedRefreshToken || !(0, $bd840ab348a8e6dd$exports).isRefreshTokenEntity(parsedRefreshToken)) {
            this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getRefreshTokenCredential: cache hit");
        return parsedRefreshToken;
    }
    /**
     * set refreshToken credential to the platform cache
     * @param refreshToken
     */ setRefreshTokenCredential(refreshToken, correlationId) {
        this.logger.trace("BrowserCacheManager.setRefreshTokenCredential called");
        const refreshTokenKey = (0, $bd840ab348a8e6dd$exports).generateCredentialKey(refreshToken);
        refreshToken.lastUpdatedAt = Date.now().toString();
        this.setItem(refreshTokenKey, JSON.stringify(refreshToken), correlationId);
        this.addTokenKey(refreshTokenKey, (0, $08c107807d753255$export$eca2dc7e6e608a68).REFRESH_TOKEN, correlationId);
    }
    /**
     * fetch appMetadata entity from the platform cache
     * @param appMetadataKey
     */ getAppMetadata(appMetadataKey) {
        const value = this.getItem(appMetadataKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getAppMetadata: called, no cache hit");
            return null;
        }
        const parsedMetadata = this.validateAndParseJson(value);
        if (!parsedMetadata || !(0, $bd840ab348a8e6dd$exports).isAppMetadataEntity(appMetadataKey, parsedMetadata)) {
            this.logger.trace("BrowserCacheManager.getAppMetadata: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getAppMetadata: cache hit");
        return parsedMetadata;
    }
    /**
     * set appMetadata entity to the platform cache
     * @param appMetadata
     */ setAppMetadata(appMetadata, correlationId) {
        this.logger.trace("BrowserCacheManager.setAppMetadata called");
        const appMetadataKey = (0, $bd840ab348a8e6dd$exports).generateAppMetadataKey(appMetadata);
        this.setItem(appMetadataKey, JSON.stringify(appMetadata), correlationId);
    }
    /**
     * fetch server telemetry entity from the platform cache
     * @param serverTelemetryKey
     */ getServerTelemetry(serverTelemetryKey) {
        const value = this.getItem(serverTelemetryKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getServerTelemetry: called, no cache hit");
            return null;
        }
        const parsedEntity = this.validateAndParseJson(value);
        if (!parsedEntity || !(0, $bd840ab348a8e6dd$exports).isServerTelemetryEntity(serverTelemetryKey, parsedEntity)) {
            this.logger.trace("BrowserCacheManager.getServerTelemetry: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getServerTelemetry: cache hit");
        return parsedEntity;
    }
    /**
     * set server telemetry entity to the platform cache
     * @param serverTelemetryKey
     * @param serverTelemetry
     */ setServerTelemetry(serverTelemetryKey, serverTelemetry, correlationId) {
        this.logger.trace("BrowserCacheManager.setServerTelemetry called");
        this.setItem(serverTelemetryKey, JSON.stringify(serverTelemetry), correlationId);
    }
    /**
     *
     */ getAuthorityMetadata(key) {
        const value = this.internalStorage.getItem(key);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getAuthorityMetadata: called, no cache hit");
            return null;
        }
        const parsedMetadata = this.validateAndParseJson(value);
        if (parsedMetadata && (0, $bd840ab348a8e6dd$exports).isAuthorityMetadataEntity(key, parsedMetadata)) {
            this.logger.trace("BrowserCacheManager.getAuthorityMetadata: cache hit");
            return parsedMetadata;
        }
        return null;
    }
    /**
     *
     */ getAuthorityMetadataKeys() {
        const allKeys = this.internalStorage.getKeys();
        return allKeys.filter((key)=>{
            return this.isAuthorityMetadata(key);
        });
    }
    /**
     * Sets wrapper metadata in memory
     * @param wrapperSKU
     * @param wrapperVersion
     */ setWrapperMetadata(wrapperSKU, wrapperVersion) {
        this.internalStorage.setItem((0, $091acf4c2675819b$export$8f546f90896bcfa9).WRAPPER_SKU, wrapperSKU);
        this.internalStorage.setItem((0, $091acf4c2675819b$export$8f546f90896bcfa9).WRAPPER_VER, wrapperVersion);
    }
    /**
     * Returns wrapper metadata from in-memory storage
     */ getWrapperMetadata() {
        const sku = this.internalStorage.getItem((0, $091acf4c2675819b$export$8f546f90896bcfa9).WRAPPER_SKU) || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING;
        const version = this.internalStorage.getItem((0, $091acf4c2675819b$export$8f546f90896bcfa9).WRAPPER_VER) || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING;
        return [
            sku,
            version
        ];
    }
    /**
     *
     * @param entity
     */ setAuthorityMetadata(key, entity) {
        this.logger.trace("BrowserCacheManager.setAuthorityMetadata called");
        this.internalStorage.setItem(key, JSON.stringify(entity));
    }
    /**
     * Gets the active account
     */ getActiveAccount(correlationId) {
        const activeAccountKeyFilters = this.generateCacheKey((0, $08c107807d753255$export$81ab9ba9bd28255c).ACTIVE_ACCOUNT_FILTERS);
        const activeAccountValueFilters = this.getItem(activeAccountKeyFilters);
        if (!activeAccountValueFilters) {
            // if new active account cache type isn't found, it's an old version, so look for that instead
            this.logger.trace("BrowserCacheManager.getActiveAccount: No active account filters cache schema found, looking for legacy schema");
            const activeAccountKeyLocal = this.generateCacheKey((0, $08c107807d753255$export$81ab9ba9bd28255c).ACTIVE_ACCOUNT);
            const activeAccountValueLocal = this.getItem(activeAccountKeyLocal);
            if (!activeAccountValueLocal) {
                this.logger.trace("BrowserCacheManager.getActiveAccount: No active account found");
                return null;
            }
            const activeAccount = this.getAccountInfoFilteredBy({
                localAccountId: activeAccountValueLocal
            }, correlationId);
            if (activeAccount) {
                this.logger.trace("BrowserCacheManager.getActiveAccount: Legacy active account cache schema found");
                this.logger.trace("BrowserCacheManager.getActiveAccount: Adding active account filters cache schema");
                this.setActiveAccount(activeAccount, correlationId);
                return activeAccount;
            }
            return null;
        }
        const activeAccountValueObj = this.validateAndParseJson(activeAccountValueFilters);
        if (activeAccountValueObj) {
            this.logger.trace("BrowserCacheManager.getActiveAccount: Active account filters schema found");
            return this.getAccountInfoFilteredBy({
                homeAccountId: activeAccountValueObj.homeAccountId,
                localAccountId: activeAccountValueObj.localAccountId,
                tenantId: activeAccountValueObj.tenantId
            }, correlationId);
        }
        this.logger.trace("BrowserCacheManager.getActiveAccount: No active account found");
        return null;
    }
    /**
     * Sets the active account's localAccountId in cache
     * @param account
     */ setActiveAccount(account, correlationId) {
        const activeAccountKey = this.generateCacheKey((0, $08c107807d753255$export$81ab9ba9bd28255c).ACTIVE_ACCOUNT_FILTERS);
        const activeAccountKeyLocal = this.generateCacheKey((0, $08c107807d753255$export$81ab9ba9bd28255c).ACTIVE_ACCOUNT);
        if (account) {
            this.logger.verbose("setActiveAccount: Active account set");
            const activeAccountValue = {
                homeAccountId: account.homeAccountId,
                localAccountId: account.localAccountId,
                tenantId: account.tenantId,
                lastUpdatedAt: Date.now().toString()
            };
            this.setItem(activeAccountKey, JSON.stringify(activeAccountValue), correlationId);
            this.setItem(activeAccountKeyLocal, account.localAccountId, correlationId);
        } else {
            this.logger.verbose("setActiveAccount: No account passed, active account not set");
            this.browserStorage.removeItem(activeAccountKey);
            this.browserStorage.removeItem(activeAccountKeyLocal);
        }
    }
    /**
     * fetch throttling entity from the platform cache
     * @param throttlingCacheKey
     */ getThrottlingCache(throttlingCacheKey) {
        const value = this.getItem(throttlingCacheKey);
        if (!value) {
            this.logger.trace("BrowserCacheManager.getThrottlingCache: called, no cache hit");
            return null;
        }
        const parsedThrottlingCache = this.validateAndParseJson(value);
        if (!parsedThrottlingCache || !(0, $bd840ab348a8e6dd$exports).isThrottlingEntity(throttlingCacheKey, parsedThrottlingCache)) {
            this.logger.trace("BrowserCacheManager.getThrottlingCache: called, no cache hit");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getThrottlingCache: cache hit");
        return parsedThrottlingCache;
    }
    /**
     * set throttling entity to the platform cache
     * @param throttlingCacheKey
     * @param throttlingCache
     */ setThrottlingCache(throttlingCacheKey, throttlingCache, correlationId) {
        this.logger.trace("BrowserCacheManager.setThrottlingCache called");
        this.setItem(throttlingCacheKey, JSON.stringify(throttlingCache), correlationId);
    }
    /**
     * Gets cache item with given key.
     * Will retrieve from cookies if storeAuthStateInCookie is set to true.
     * @param key
     */ getTemporaryCache(cacheKey, generateKey) {
        const key = generateKey ? this.generateCacheKey(cacheKey) : cacheKey;
        if (this.cacheConfig.storeAuthStateInCookie) {
            const itemCookie = this.cookieStorage.getItem(key);
            if (itemCookie) {
                this.logger.trace("BrowserCacheManager.getTemporaryCache: storeAuthStateInCookies set to true, retrieving from cookies");
                return itemCookie;
            }
        }
        const value = this.temporaryCacheStorage.getItem(key);
        if (!value) {
            // If temp cache item not found in session/memory, check local storage for items set by old versions
            if (this.cacheConfig.cacheLocation === (0, $091acf4c2675819b$export$573384e47a12d835).LocalStorage) {
                const item = this.browserStorage.getItem(key);
                if (item) {
                    this.logger.trace("BrowserCacheManager.getTemporaryCache: Temporary cache item found in local storage");
                    return item;
                }
            }
            this.logger.trace("BrowserCacheManager.getTemporaryCache: No cache item found in local storage");
            return null;
        }
        this.logger.trace("BrowserCacheManager.getTemporaryCache: Temporary cache item returned");
        return value;
    }
    /**
     * Sets the cache item with the key and value given.
     * Stores in cookie if storeAuthStateInCookie is set to true.
     * This can cause cookie overflow if used incorrectly.
     * @param key
     * @param value
     */ setTemporaryCache(cacheKey, value, generateKey) {
        const key = generateKey ? this.generateCacheKey(cacheKey) : cacheKey;
        this.temporaryCacheStorage.setItem(key, value);
        if (this.cacheConfig.storeAuthStateInCookie) {
            this.logger.trace("BrowserCacheManager.setTemporaryCache: storeAuthStateInCookie set to true, setting item cookie");
            this.cookieStorage.setItem(key, value, undefined, this.cacheConfig.secureCookies);
        }
    }
    /**
     * Removes the cache item with the given key.
     * @param key
     */ removeItem(key) {
        this.browserStorage.removeItem(key);
    }
    /**
     * Removes the temporary cache item with the given key.
     * Will also clear the cookie item if storeAuthStateInCookie is set to true.
     * @param key
     */ removeTemporaryItem(key) {
        this.temporaryCacheStorage.removeItem(key);
        if (this.cacheConfig.storeAuthStateInCookie) {
            this.logger.trace("BrowserCacheManager.removeItem: storeAuthStateInCookie is true, clearing item cookie");
            this.cookieStorage.removeItem(key);
        }
    }
    /**
     * Gets all keys in window.
     */ getKeys() {
        return this.browserStorage.getKeys();
    }
    /**
     * Clears all cache entries created by MSAL.
     */ async clear(correlationId) {
        // Removes all accounts and their credentials
        await this.removeAllAccounts(correlationId);
        this.removeAppMetadata(correlationId);
        // Remove temp storage first to make sure any cookies are cleared
        this.temporaryCacheStorage.getKeys().forEach((cacheKey)=>{
            if (cacheKey.indexOf((0, $08c107807d753255$export$a002182e51710d39).CACHE_PREFIX) !== -1 || cacheKey.indexOf(this.clientId) !== -1) this.removeTemporaryItem(cacheKey);
        });
        // Removes all remaining MSAL cache items
        this.browserStorage.getKeys().forEach((cacheKey)=>{
            if (cacheKey.indexOf((0, $08c107807d753255$export$a002182e51710d39).CACHE_PREFIX) !== -1 || cacheKey.indexOf(this.clientId) !== -1) this.browserStorage.removeItem(cacheKey);
        });
        this.internalStorage.clear();
    }
    /**
     * Clears all access tokes that have claims prior to saving the current one
     * @param performanceClient {IPerformanceClient}
     * @param correlationId {string} correlation id
     * @returns
     */ async clearTokensAndKeysWithClaims(performanceClient, correlationId) {
        performanceClient.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).ClearTokensAndKeysWithClaims, correlationId);
        const tokenKeys = this.getTokenKeys();
        let removedAccessTokens = 0;
        tokenKeys.accessToken.forEach((key)=>{
            // if the access token has claims in its key, remove the token key and the token
            const credential = this.getAccessTokenCredential(key, correlationId);
            if (credential?.requestedClaimsHash && key.includes(credential.requestedClaimsHash.toLowerCase())) {
                this.removeAccessToken(key, correlationId);
                removedAccessTokens++;
            }
        });
        // warn if any access tokens are removed
        if (removedAccessTokens > 0) this.logger.warning(`${removedAccessTokens} access tokens with claims in the cache keys have been removed from the cache.`);
    }
    /**
     * Prepend msal.<client-id> to each key; Skip for any JSON object as Key (defined schemas do not need the key appended: AccessToken Keys or the upcoming schema)
     * @param key
     * @param addInstanceId
     */ generateCacheKey(key) {
        const generatedKey = this.validateAndParseJson(key);
        if (!generatedKey) {
            if ((0, $5d9dc3fc4be02ef2$export$ecc754f99843e759).startsWith(key, (0, $08c107807d753255$export$a002182e51710d39).CACHE_PREFIX) || (0, $5d9dc3fc4be02ef2$export$ecc754f99843e759).startsWith(key, (0, $08c107807d753255$export$81ab9ba9bd28255c).ADAL_ID_TOKEN)) return key;
            return `${(0, $08c107807d753255$export$a002182e51710d39).CACHE_PREFIX}.${this.clientId}.${key}`;
        }
        return JSON.stringify(key);
    }
    /**
     * Create authorityKey to cache authority
     * @param state
     */ generateAuthorityKey(stateString) {
        const { libraryState: { id: stateId } } = (0, $1cc651d5e90b7480$export$871e33217042c65e).parseRequestState(this.cryptoImpl, stateString);
        return this.generateCacheKey(`${(0, $091acf4c2675819b$export$21d55bedf0d269fb).AUTHORITY}.${stateId}`);
    }
    /**
     * Create Nonce key to cache nonce
     * @param state
     */ generateNonceKey(stateString) {
        const { libraryState: { id: stateId } } = (0, $1cc651d5e90b7480$export$871e33217042c65e).parseRequestState(this.cryptoImpl, stateString);
        return this.generateCacheKey(`${(0, $091acf4c2675819b$export$21d55bedf0d269fb).NONCE_IDTOKEN}.${stateId}`);
    }
    /**
     * Creates full cache key for the request state
     * @param stateString State string for the request
     */ generateStateKey(stateString) {
        // Use the library state id to key temp storage for uniqueness for multiple concurrent requests
        const { libraryState: { id: stateId } } = (0, $1cc651d5e90b7480$export$871e33217042c65e).parseRequestState(this.cryptoImpl, stateString);
        return this.generateCacheKey(`${(0, $091acf4c2675819b$export$21d55bedf0d269fb).REQUEST_STATE}.${stateId}`);
    }
    /**
     * Gets the cached authority based on the cached state. Returns empty if no cached state found.
     */ getCachedAuthority(cachedState) {
        const stateCacheKey = this.generateStateKey(cachedState);
        const state = this.getTemporaryCache(stateCacheKey);
        if (!state) return null;
        const authorityCacheKey = this.generateAuthorityKey(state);
        return this.getTemporaryCache(authorityCacheKey);
    }
    /**
     * Updates account, authority, and state in cache
     * @param serverAuthenticationRequest
     * @param account
     */ updateCacheEntries(state, nonce, authorityInstance, loginHint, account) {
        this.logger.trace("BrowserCacheManager.updateCacheEntries called");
        // Cache the request state
        const stateCacheKey = this.generateStateKey(state);
        this.setTemporaryCache(stateCacheKey, state, false);
        // Cache the nonce
        const nonceCacheKey = this.generateNonceKey(state);
        this.setTemporaryCache(nonceCacheKey, nonce, false);
        // Cache authorityKey
        const authorityCacheKey = this.generateAuthorityKey(state);
        this.setTemporaryCache(authorityCacheKey, authorityInstance, false);
        if (account) {
            const ccsCredential = {
                credential: account.homeAccountId,
                type: (0, $36f32d37ad76b0c5$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
            };
            this.setTemporaryCache((0, $091acf4c2675819b$export$21d55bedf0d269fb).CCS_CREDENTIAL, JSON.stringify(ccsCredential), true);
        } else if (loginHint) {
            const ccsCredential = {
                credential: loginHint,
                type: (0, $36f32d37ad76b0c5$export$17b7b3ac1abef49f).UPN
            };
            this.setTemporaryCache((0, $091acf4c2675819b$export$21d55bedf0d269fb).CCS_CREDENTIAL, JSON.stringify(ccsCredential), true);
        }
    }
    /**
     * Reset all temporary cache items
     * @param state
     */ resetRequestCache(state) {
        this.logger.trace("BrowserCacheManager.resetRequestCache called");
        // check state and remove associated cache items
        if (state) {
            this.temporaryCacheStorage.getKeys().forEach((key)=>{
                if (key.indexOf(state) !== -1) this.removeTemporaryItem(key);
            });
            // delete generic interactive request parameters
            this.removeTemporaryItem(this.generateStateKey(state));
            this.removeTemporaryItem(this.generateNonceKey(state));
            this.removeTemporaryItem(this.generateAuthorityKey(state));
        }
        this.removeTemporaryItem(this.generateCacheKey((0, $091acf4c2675819b$export$21d55bedf0d269fb).REQUEST_PARAMS));
        this.removeTemporaryItem(this.generateCacheKey((0, $091acf4c2675819b$export$21d55bedf0d269fb).ORIGIN_URI));
        this.removeTemporaryItem(this.generateCacheKey((0, $091acf4c2675819b$export$21d55bedf0d269fb).URL_HASH));
        this.removeTemporaryItem(this.generateCacheKey((0, $091acf4c2675819b$export$21d55bedf0d269fb).CORRELATION_ID));
        this.removeTemporaryItem(this.generateCacheKey((0, $091acf4c2675819b$export$21d55bedf0d269fb).CCS_CREDENTIAL));
        this.removeTemporaryItem(this.generateCacheKey((0, $091acf4c2675819b$export$21d55bedf0d269fb).NATIVE_REQUEST));
        this.setInteractionInProgress(false);
    }
    /**
     * Removes temporary cache for the provided state
     * @param stateString
     */ cleanRequestByState(stateString) {
        this.logger.trace("BrowserCacheManager.cleanRequestByState called");
        // Interaction is completed - remove interaction status.
        if (stateString) {
            const stateKey = this.generateStateKey(stateString);
            const cachedState = this.temporaryCacheStorage.getItem(stateKey);
            this.logger.infoPii(`BrowserCacheManager.cleanRequestByState: Removing temporary cache items for state: ${cachedState}`);
            this.resetRequestCache(cachedState || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING);
        }
    }
    /**
     * Looks in temporary cache for any state values with the provided interactionType and removes all temporary cache items for that state
     * Used in scenarios where temp cache needs to be cleaned but state is not known, such as clicking browser back button.
     * @param interactionType
     */ cleanRequestByInteractionType(interactionType) {
        this.logger.trace("BrowserCacheManager.cleanRequestByInteractionType called");
        // Loop through all keys to find state key
        this.temporaryCacheStorage.getKeys().forEach((key)=>{
            // If this key is not the state key, move on
            if (key.indexOf((0, $091acf4c2675819b$export$21d55bedf0d269fb).REQUEST_STATE) === -1) return;
            // Retrieve state value, return if not a valid value
            const stateValue = this.temporaryCacheStorage.getItem(key);
            if (!stateValue) return;
            // Extract state and ensure it matches given InteractionType, then clean request cache
            const parsedState = (0, $e5678e89c6203472$export$68ec87f530f5f536)(this.cryptoImpl, stateValue);
            if (parsedState && parsedState.interactionType === interactionType) {
                this.logger.infoPii(`BrowserCacheManager.cleanRequestByInteractionType: Removing temporary cache items for state: ${stateValue}`);
                this.resetRequestCache(stateValue);
            }
        });
        this.setInteractionInProgress(false);
    }
    cacheCodeRequest(authCodeRequest) {
        this.logger.trace("BrowserCacheManager.cacheCodeRequest called");
        const encodedValue = (0, $3665c4f98d09cc5b$export$e510a73ee562749)(JSON.stringify(authCodeRequest));
        this.setTemporaryCache((0, $091acf4c2675819b$export$21d55bedf0d269fb).REQUEST_PARAMS, encodedValue, true);
    }
    /**
     * Gets the token exchange parameters from the cache. Throws an error if nothing is found.
     */ getCachedRequest(state) {
        this.logger.trace("BrowserCacheManager.getCachedRequest called");
        // Get token request from cache and parse as TokenExchangeParameters.
        const encodedTokenRequest = this.getTemporaryCache((0, $091acf4c2675819b$export$21d55bedf0d269fb).REQUEST_PARAMS, true);
        if (!encodedTokenRequest) throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$8b51939fb2aab3d7));
        let parsedRequest;
        try {
            parsedRequest = JSON.parse((0, $823c1cd3d50f09ac$export$c62426fdd000a97e)(encodedTokenRequest));
        } catch (e) {
            this.logger.errorPii(`Attempted to parse: ${encodedTokenRequest}`);
            this.logger.error(`Parsing cached token request threw with error: ${e}`);
            throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$f3ae24cdfaab4488));
        }
        this.removeTemporaryItem(this.generateCacheKey((0, $091acf4c2675819b$export$21d55bedf0d269fb).REQUEST_PARAMS));
        // Get cached authority and use if no authority is cached with request.
        if (!parsedRequest.authority) {
            const authorityCacheKey = this.generateAuthorityKey(state);
            const cachedAuthority = this.getTemporaryCache(authorityCacheKey);
            if (!cachedAuthority) throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$3a2c83e7753553b));
            parsedRequest.authority = cachedAuthority;
        }
        return parsedRequest;
    }
    /**
     * Gets cached native request for redirect flows
     */ getCachedNativeRequest() {
        this.logger.trace("BrowserCacheManager.getCachedNativeRequest called");
        const cachedRequest = this.getTemporaryCache((0, $091acf4c2675819b$export$21d55bedf0d269fb).NATIVE_REQUEST, true);
        if (!cachedRequest) {
            this.logger.trace("BrowserCacheManager.getCachedNativeRequest: No cached native request found");
            return null;
        }
        const parsedRequest = this.validateAndParseJson(cachedRequest);
        if (!parsedRequest) {
            this.logger.error("BrowserCacheManager.getCachedNativeRequest: Unable to parse native request");
            return null;
        }
        return parsedRequest;
    }
    isInteractionInProgress(matchClientId) {
        const clientId = this.getInteractionInProgress();
        if (matchClientId) return clientId === this.clientId;
        else return !!clientId;
    }
    getInteractionInProgress() {
        const key = `${(0, $08c107807d753255$export$a002182e51710d39).CACHE_PREFIX}.${(0, $091acf4c2675819b$export$21d55bedf0d269fb).INTERACTION_STATUS_KEY}`;
        return this.getTemporaryCache(key, false);
    }
    setInteractionInProgress(inProgress) {
        // Ensure we don't overwrite interaction in progress for a different clientId
        const key = `${(0, $08c107807d753255$export$a002182e51710d39).CACHE_PREFIX}.${(0, $091acf4c2675819b$export$21d55bedf0d269fb).INTERACTION_STATUS_KEY}`;
        if (inProgress) {
            if (this.getInteractionInProgress()) throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$2700dc1c133d227e));
            else // No interaction is in progress
            this.setTemporaryCache(key, this.clientId, false);
        } else if (!inProgress && this.getInteractionInProgress() === this.clientId) this.removeTemporaryItem(key);
    }
    /**
     * Returns username retrieved from ADAL or MSAL v1 idToken
     * @deprecated
     */ getLegacyLoginHint() {
        // Only check for adal/msal token if no SSO params are being used
        const adalIdTokenString = this.getTemporaryCache((0, $08c107807d753255$export$81ab9ba9bd28255c).ADAL_ID_TOKEN);
        if (adalIdTokenString) {
            this.browserStorage.removeItem((0, $08c107807d753255$export$81ab9ba9bd28255c).ADAL_ID_TOKEN);
            this.logger.verbose("Cached ADAL id token retrieved.");
        }
        // Check for cached MSAL v1 id token
        const msalIdTokenString = this.getTemporaryCache((0, $08c107807d753255$export$81ab9ba9bd28255c).ID_TOKEN, true);
        if (msalIdTokenString) {
            this.browserStorage.removeItem(this.generateCacheKey((0, $08c107807d753255$export$81ab9ba9bd28255c).ID_TOKEN));
            this.logger.verbose("Cached MSAL.js v1 id token retrieved");
        }
        const cachedIdTokenString = msalIdTokenString || adalIdTokenString;
        if (cachedIdTokenString) {
            const idTokenClaims = (0, $dfbf8cbb9a592daa$exports).extractTokenClaims(cachedIdTokenString, (0, $823c1cd3d50f09ac$export$c62426fdd000a97e));
            if (idTokenClaims.preferred_username) {
                this.logger.verbose("No SSO params used and ADAL/MSAL v1 token retrieved, setting ADAL/MSAL v1 preferred_username as loginHint");
                return idTokenClaims.preferred_username;
            } else if (idTokenClaims.upn) {
                this.logger.verbose("No SSO params used and ADAL/MSAL v1 token retrieved, setting ADAL/MSAL v1 upn as loginHint");
                return idTokenClaims.upn;
            } else this.logger.verbose("No SSO params used and ADAL/MSAL v1 token retrieved, however, no account hint claim found. Enable preferred_username or upn id token claim to get SSO.");
        }
        return null;
    }
    /**
     * Updates a credential's cache key if the current cache key is outdated
     */ updateCredentialCacheKey(currentCacheKey, credential, correlationId) {
        const updatedCacheKey = (0, $bd840ab348a8e6dd$exports).generateCredentialKey(credential);
        if (currentCacheKey !== updatedCacheKey) {
            const cacheItem = this.getItem(currentCacheKey);
            if (cacheItem) {
                this.browserStorage.removeItem(currentCacheKey);
                this.setItem(updatedCacheKey, cacheItem, correlationId);
                this.logger.verbose(`Updated an outdated ${credential.credentialType} cache key`);
                return updatedCacheKey;
            } else this.logger.error(`Attempted to update an outdated ${credential.credentialType} cache key but no item matching the outdated key was found in storage`);
        }
        return currentCacheKey;
    }
    /**
     * Builds credential entities from AuthenticationResult object and saves the resulting credentials to the cache
     * @param result
     * @param request
     */ async hydrateCache(result, request) {
        const idTokenEntity = (0, $bd840ab348a8e6dd$exports).createIdTokenEntity(result.account?.homeAccountId, result.account?.environment, result.idToken, this.clientId, result.tenantId);
        let claimsHash;
        if (request.claims) claimsHash = await this.cryptoImpl.hashString(request.claims);
        /**
         * meta data for cache stores time in seconds from epoch
         * AuthenticationResult returns expiresOn and extExpiresOn in milliseconds (as a Date object which is in ms)
         * We need to map these for the cache when building tokens from AuthenticationResult
         *
         * The next MSAL VFuture should map these both to same value if possible
         */ const accessTokenEntity = (0, $bd840ab348a8e6dd$exports).createAccessTokenEntity(result.account?.homeAccountId, result.account.environment, result.accessToken, this.clientId, result.tenantId, result.scopes.join(" "), result.expiresOn ? result.expiresOn.getTime() / 1000 : 0, result.extExpiresOn ? result.extExpiresOn.getTime() / 1000 : 0, (0, $823c1cd3d50f09ac$export$c62426fdd000a97e), undefined, result.tokenType, undefined, request.sshKid, request.claims, claimsHash);
        const cacheRecord = {
            idToken: idTokenEntity,
            accessToken: accessTokenEntity
        };
        return this.saveCacheRecord(cacheRecord, result.correlationId);
    }
    /**
     * saves a cache record
     * @param cacheRecord {CacheRecord}
     * @param storeInCache {?StoreInCache}
     * @param correlationId {?string} correlation id
     */ async saveCacheRecord(cacheRecord, correlationId, storeInCache) {
        try {
            await super.saveCacheRecord(cacheRecord, correlationId, storeInCache);
        } catch (e) {
            if (e instanceof (0, $812f0ad9daef6a7a$export$78ff06e91c3de382) && this.performanceClient && correlationId) try {
                const tokenKeys = this.getTokenKeys();
                this.performanceClient.addFields({
                    cacheRtCount: tokenKeys.refreshToken.length,
                    cacheIdCount: tokenKeys.idToken.length,
                    cacheAtCount: tokenKeys.accessToken.length
                }, correlationId);
            } catch (e) {}
            throw e;
        }
    }
}
const $acde3ca448a630dc$export$8e2d54002f8f6e5d = (clientId, logger)=>{
    const cacheOptions = {
        cacheLocation: (0, $091acf4c2675819b$export$573384e47a12d835).MemoryStorage,
        temporaryCacheLocation: (0, $091acf4c2675819b$export$573384e47a12d835).MemoryStorage,
        storeAuthStateInCookie: false,
        secureCookies: false,
        cacheMigrationEnabled: false,
        claimsBasedCachingEnabled: false
    };
    return new $acde3ca448a630dc$export$44d7291b5c8cc149(clientId, cacheOptions, (0, $f03a022fda639465$export$865f57d401606752), logger);
};


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
 * @param accountFilter - (Optional) filter to narrow down the accounts returned
 * @returns Array of AccountInfo objects in cache
 */ function $ba0fbd2fa27ffd1a$export$a4fc43c2a99143cd(logger, browserStorage, isInBrowser, correlationId, accountFilter) {
    logger.verbose("getAllAccounts called");
    return isInBrowser ? browserStorage.getAllAccounts(correlationId, accountFilter) : [];
}
/**
 * Returns the first account found in the cache that matches the account filter passed in.
 * @param accountFilter
 * @returns The first account found in the cache matching the provided filter or null if no account could be found.
 */ function $ba0fbd2fa27ffd1a$export$4f9234baf34abd0(accountFilter, logger, browserStorage, correlationId) {
    logger.trace("getAccount called");
    if (Object.keys(accountFilter).length === 0) {
        logger.warning("getAccount: No accountFilter provided");
        return null;
    }
    const account = browserStorage.getAccountInfoFilteredBy(accountFilter, correlationId);
    if (account) {
        logger.verbose("getAccount: Account matching provided filter found, returning");
        return account;
    } else {
        logger.verbose("getAccount: No matching account found, returning null");
        return null;
    }
}
/**
 * Returns the signed in account matching username.
 * (the account object is created at the time of successful login)
 * or null when no matching account is found.
 * This API is provided for convenience but getAccountById should be used for best reliability
 * @param username
 * @returns The account object stored in MSAL
 */ function $ba0fbd2fa27ffd1a$export$d915baf55d86927d(username, logger, browserStorage, correlationId) {
    logger.trace("getAccountByUsername called");
    if (!username) {
        logger.warning("getAccountByUsername: No username provided");
        return null;
    }
    const account = browserStorage.getAccountInfoFilteredBy({
        username: username
    }, correlationId);
    if (account) {
        logger.verbose("getAccountByUsername: Account matching username found, returning");
        logger.verbosePii(`getAccountByUsername: Returning signed-in accounts matching username: ${username}`);
        return account;
    } else {
        logger.verbose("getAccountByUsername: No matching account found, returning null");
        return null;
    }
}
/**
 * Returns the signed in account matching homeAccountId.
 * (the account object is created at the time of successful login)
 * or null when no matching account is found
 * @param homeAccountId
 * @returns The account object stored in MSAL
 */ function $ba0fbd2fa27ffd1a$export$d6fa7d1e8099998e(homeAccountId, logger, browserStorage, correlationId) {
    logger.trace("getAccountByHomeId called");
    if (!homeAccountId) {
        logger.warning("getAccountByHomeId: No homeAccountId provided");
        return null;
    }
    const account = browserStorage.getAccountInfoFilteredBy({
        homeAccountId: homeAccountId
    }, correlationId);
    if (account) {
        logger.verbose("getAccountByHomeId: Account matching homeAccountId found, returning");
        logger.verbosePii(`getAccountByHomeId: Returning signed-in accounts matching homeAccountId: ${homeAccountId}`);
        return account;
    } else {
        logger.verbose("getAccountByHomeId: No matching account found, returning null");
        return null;
    }
}
/**
 * Returns the signed in account matching localAccountId.
 * (the account object is created at the time of successful login)
 * or null when no matching account is found
 * @param localAccountId
 * @returns The account object stored in MSAL
 */ function $ba0fbd2fa27ffd1a$export$7ac8aa09fdf78340(localAccountId, logger, browserStorage, correlationId) {
    logger.trace("getAccountByLocalId called");
    if (!localAccountId) {
        logger.warning("getAccountByLocalId: No localAccountId provided");
        return null;
    }
    const account = browserStorage.getAccountInfoFilteredBy({
        localAccountId: localAccountId
    }, correlationId);
    if (account) {
        logger.verbose("getAccountByLocalId: Account matching localAccountId found, returning");
        logger.verbosePii(`getAccountByLocalId: Returning signed-in accounts matching localAccountId: ${localAccountId}`);
        return account;
    } else {
        logger.verbose("getAccountByLocalId: No matching account found, returning null");
        return null;
    }
}
/**
 * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
 * @param account
 */ function $ba0fbd2fa27ffd1a$export$c55c3d25cf1bcd99(account, browserStorage, correlationId) {
    browserStorage.setActiveAccount(account, correlationId);
}
/**
 * Gets the currently active account
 */ function $ba0fbd2fa27ffd1a$export$13dd2e33a23839ad(browserStorage, correlationId) {
    return browserStorage.getActiveAccount(correlationId);
}




/*! @azure/msal-browser v3.30.0 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $15f33001bc68716c$export$3d7865934588d77e = {
    INITIALIZE_START: "msal:initializeStart",
    INITIALIZE_END: "msal:initializeEnd",
    ACCOUNT_ADDED: "msal:accountAdded",
    ACCOUNT_REMOVED: "msal:accountRemoved",
    ACTIVE_ACCOUNT_CHANGED: "msal:activeAccountChanged",
    LOGIN_START: "msal:loginStart",
    LOGIN_SUCCESS: "msal:loginSuccess",
    LOGIN_FAILURE: "msal:loginFailure",
    ACQUIRE_TOKEN_START: "msal:acquireTokenStart",
    ACQUIRE_TOKEN_SUCCESS: "msal:acquireTokenSuccess",
    ACQUIRE_TOKEN_FAILURE: "msal:acquireTokenFailure",
    ACQUIRE_TOKEN_NETWORK_START: "msal:acquireTokenFromNetworkStart",
    SSO_SILENT_START: "msal:ssoSilentStart",
    SSO_SILENT_SUCCESS: "msal:ssoSilentSuccess",
    SSO_SILENT_FAILURE: "msal:ssoSilentFailure",
    ACQUIRE_TOKEN_BY_CODE_START: "msal:acquireTokenByCodeStart",
    ACQUIRE_TOKEN_BY_CODE_SUCCESS: "msal:acquireTokenByCodeSuccess",
    ACQUIRE_TOKEN_BY_CODE_FAILURE: "msal:acquireTokenByCodeFailure",
    HANDLE_REDIRECT_START: "msal:handleRedirectStart",
    HANDLE_REDIRECT_END: "msal:handleRedirectEnd",
    POPUP_OPENED: "msal:popupOpened",
    LOGOUT_START: "msal:logoutStart",
    LOGOUT_SUCCESS: "msal:logoutSuccess",
    LOGOUT_FAILURE: "msal:logoutFailure",
    LOGOUT_END: "msal:logoutEnd",
    RESTORE_FROM_BFCACHE: "msal:restoreFromBFCache"
};


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $73896da9aeaab286$export$ce0ba2422a1c7815 {
    constructor(logger){
        this.eventCallbacks = new Map();
        this.logger = logger || new (0, $4643cd557adfd6d5$export$efa9a398d6368992)({});
    }
    /**
     * Adds event callbacks to array
     * @param callback - callback to be invoked when an event is raised
     * @param eventTypes - list of events that this callback will be invoked for, if not provided callback will be invoked for all events
     * @param callbackId - Identifier for the callback, used to locate and remove the callback when no longer required
     */ addEventCallback(callback, eventTypes, callbackId) {
        if (typeof window !== "undefined") {
            const id = callbackId || (0, $deacecf435b3f5ad$export$7571c350ed9fec74)();
            if (this.eventCallbacks.has(id)) {
                this.logger.error(`Event callback with id: ${id} is already registered. Please provide a unique id or remove the existing callback and try again.`);
                return null;
            }
            this.eventCallbacks.set(id, [
                callback,
                eventTypes || []
            ]);
            this.logger.verbose(`Event callback registered with id: ${id}`);
            return id;
        }
        return null;
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        this.eventCallbacks.delete(callbackId);
        this.logger.verbose(`Event callback ${callbackId} removed.`);
    }
    /**
     * Emits events by calling callback with event message
     * @param eventType
     * @param interactionType
     * @param payload
     * @param error
     */ emitEvent(eventType, interactionType, payload, error) {
        if (typeof window !== "undefined") {
            const message = {
                eventType: eventType,
                interactionType: interactionType || null,
                payload: payload || null,
                error: error || null,
                timestamp: Date.now()
            };
            this.eventCallbacks.forEach(([callback, eventTypes], callbackId)=>{
                if (eventTypes.length === 0 || eventTypes.includes(eventType)) {
                    this.logger.verbose(`Emitting event to callback ${callbackId}: ${eventType}`);
                    callback.apply(null, [
                        message
                    ]);
                }
            });
        }
    }
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ /*! @azure/msal-common v14.16.1 2025-08-05 */ 
/*! @azure/msal-common v14.16.1 2025-08-05 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Error thrown when there is an error with the server code, for example, unavailability.
 */ class $85fc58951e10e394$export$ea52035eac03daf0 extends (0, $53b49d8334c1646a$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage, subError, errorNo, status){
        super(errorCode, errorMessage, subError);
        this.name = "ServerError";
        this.errorNo = errorNo;
        this.status = status;
        Object.setPrototypeOf(this, $85fc58951e10e394$export$ea52035eac03daf0.prototype);
    }
}


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /** @internal */ class $a5c865990da19377$export$c060a619741dd765 {
    /**
     * Prepares a RequestThumbprint to be stored as a key.
     * @param thumbprint
     */ static generateThrottlingStorageKey(thumbprint) {
        return `${(0, $08c107807d753255$export$a2330d6808e6d893).THROTTLING_PREFIX}.${JSON.stringify(thumbprint)}`;
    }
    /**
     * Performs necessary throttling checks before a network request.
     * @param cacheManager
     * @param thumbprint
     */ static preProcess(cacheManager, thumbprint, correlationId) {
        const key = $a5c865990da19377$export$c060a619741dd765.generateThrottlingStorageKey(thumbprint);
        const value = cacheManager.getThrottlingCache(key);
        if (value) {
            if (value.throttleTime < Date.now()) {
                cacheManager.removeItem(key, correlationId);
                return;
            }
            throw new (0, $85fc58951e10e394$export$ea52035eac03daf0)(value.errorCodes?.join(" ") || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING, value.errorMessage, value.subError);
        }
    }
    /**
     * Performs necessary throttling checks after a network request.
     * @param cacheManager
     * @param thumbprint
     * @param response
     */ static postProcess(cacheManager, thumbprint, response, correlationId) {
        if ($a5c865990da19377$export$c060a619741dd765.checkResponseStatus(response) || $a5c865990da19377$export$c060a619741dd765.checkResponseForRetryAfter(response)) {
            const thumbprintValue = {
                throttleTime: $a5c865990da19377$export$c060a619741dd765.calculateThrottleTime(parseInt(response.headers[(0, $08c107807d753255$export$28d77f87efed1d88).RETRY_AFTER])),
                error: response.body.error,
                errorCodes: response.body.error_codes,
                errorMessage: response.body.error_description,
                subError: response.body.suberror
            };
            cacheManager.setThrottlingCache($a5c865990da19377$export$c060a619741dd765.generateThrottlingStorageKey(thumbprint), thumbprintValue, correlationId);
        }
    }
    /**
     * Checks a NetworkResponse object's status codes against 429 or 5xx
     * @param response
     */ static checkResponseStatus(response) {
        return response.status === 429 || response.status >= 500 && response.status < 600;
    }
    /**
     * Checks a NetworkResponse object's RetryAfter header
     * @param response
     */ static checkResponseForRetryAfter(response) {
        if (response.headers) return response.headers.hasOwnProperty((0, $08c107807d753255$export$28d77f87efed1d88).RETRY_AFTER) && (response.status < 200 || response.status >= 300);
        return false;
    }
    /**
     * Calculates the Unix-time value for a throttle to expire given throttleTime in seconds.
     * @param throttleTime
     */ static calculateThrottleTime(throttleTime) {
        const time = throttleTime <= 0 ? 0 : throttleTime;
        const currentSeconds = Date.now() / 1000;
        return Math.floor(Math.min(currentSeconds + (time || (0, $08c107807d753255$export$a2330d6808e6d893).DEFAULT_THROTTLE_TIME_SECONDS), currentSeconds + (0, $08c107807d753255$export$a2330d6808e6d893).DEFAULT_MAX_THROTTLE_TIME_SECONDS) * 1000);
    }
    static removeThrottle(cacheManager, clientId, request, homeAccountIdentifier) {
        const thumbprint = {
            clientId: clientId,
            authority: request.authority,
            scopes: request.scopes,
            homeAccountIdentifier: homeAccountIdentifier,
            claims: request.claims,
            authenticationScheme: request.authenticationScheme,
            resourceRequestMethod: request.resourceRequestMethod,
            resourceRequestUri: request.resourceRequestUri,
            shrClaims: request.shrClaims,
            sshKid: request.sshKid
        };
        const key = this.generateThrottlingStorageKey(thumbprint);
        cacheManager.removeItem(key, request.correlationId);
    }
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ /*! @azure/msal-common v14.16.1 2025-08-05 */ /*! @azure/msal-common v14.16.1 2025-08-05 */ 





/*! @azure/msal-common v14.16.1 2025-08-05 */ 
var $fd2f81929f856dad$exports = {};

$parcel$export($fd2f81929f856dad$exports, "CLIENT_ID", function () { return $fd2f81929f856dad$export$c7b1b63f5b60f8e; });
$parcel$export($fd2f81929f856dad$exports, "REDIRECT_URI", function () { return $fd2f81929f856dad$export$89711068e98820c5; });
$parcel$export($fd2f81929f856dad$exports, "RESPONSE_TYPE", function () { return $fd2f81929f856dad$export$af70b7209f1c7f6e; });
$parcel$export($fd2f81929f856dad$exports, "RESPONSE_MODE", function () { return $fd2f81929f856dad$export$2ae8b352eb8edff7; });
$parcel$export($fd2f81929f856dad$exports, "GRANT_TYPE", function () { return $fd2f81929f856dad$export$47f09697d0642170; });
$parcel$export($fd2f81929f856dad$exports, "CLAIMS", function () { return $fd2f81929f856dad$export$c9b29cc9615296dd; });
$parcel$export($fd2f81929f856dad$exports, "SCOPE", function () { return $fd2f81929f856dad$export$1c5a554c78c0cd12; });
$parcel$export($fd2f81929f856dad$exports, "ERROR", function () { return $fd2f81929f856dad$export$103bedf43ba882db; });
$parcel$export($fd2f81929f856dad$exports, "ERROR_DESCRIPTION", function () { return $fd2f81929f856dad$export$a9d2d02ea6b73527; });
$parcel$export($fd2f81929f856dad$exports, "ACCESS_TOKEN", function () { return $fd2f81929f856dad$export$cdbdf26448f9da5b; });
$parcel$export($fd2f81929f856dad$exports, "ID_TOKEN", function () { return $fd2f81929f856dad$export$9e690c458f1b1eda; });
$parcel$export($fd2f81929f856dad$exports, "REFRESH_TOKEN", function () { return $fd2f81929f856dad$export$2a2261c5a58ac0; });
$parcel$export($fd2f81929f856dad$exports, "EXPIRES_IN", function () { return $fd2f81929f856dad$export$a9f2539254087dfb; });
$parcel$export($fd2f81929f856dad$exports, "REFRESH_TOKEN_EXPIRES_IN", function () { return $fd2f81929f856dad$export$97e3ac17371277; });
$parcel$export($fd2f81929f856dad$exports, "STATE", function () { return $fd2f81929f856dad$export$63b4527a2777036f; });
$parcel$export($fd2f81929f856dad$exports, "NONCE", function () { return $fd2f81929f856dad$export$8646168ae3eb91e1; });
$parcel$export($fd2f81929f856dad$exports, "PROMPT", function () { return $fd2f81929f856dad$export$19855bb42e55939d; });
$parcel$export($fd2f81929f856dad$exports, "SESSION_STATE", function () { return $fd2f81929f856dad$export$3edd0f3d0bfcddba; });
$parcel$export($fd2f81929f856dad$exports, "CLIENT_INFO", function () { return $fd2f81929f856dad$export$476989d62bcb4c85; });
$parcel$export($fd2f81929f856dad$exports, "CODE", function () { return $fd2f81929f856dad$export$ec5856072852bd7f; });
$parcel$export($fd2f81929f856dad$exports, "CODE_CHALLENGE", function () { return $fd2f81929f856dad$export$58d2be3216991fee; });
$parcel$export($fd2f81929f856dad$exports, "CODE_CHALLENGE_METHOD", function () { return $fd2f81929f856dad$export$129e6f0601e36303; });
$parcel$export($fd2f81929f856dad$exports, "CODE_VERIFIER", function () { return $fd2f81929f856dad$export$a5a34ec10c757281; });
$parcel$export($fd2f81929f856dad$exports, "CLIENT_REQUEST_ID", function () { return $fd2f81929f856dad$export$633c8d7cd18ad9a9; });
$parcel$export($fd2f81929f856dad$exports, "X_CLIENT_SKU", function () { return $fd2f81929f856dad$export$fe2f04d04881f19d; });
$parcel$export($fd2f81929f856dad$exports, "X_CLIENT_VER", function () { return $fd2f81929f856dad$export$d0d0201281a553c0; });
$parcel$export($fd2f81929f856dad$exports, "X_CLIENT_OS", function () { return $fd2f81929f856dad$export$35497983a44f9406; });
$parcel$export($fd2f81929f856dad$exports, "X_CLIENT_CPU", function () { return $fd2f81929f856dad$export$d14a6ca469cd1d2b; });
$parcel$export($fd2f81929f856dad$exports, "X_CLIENT_CURR_TELEM", function () { return $fd2f81929f856dad$export$770dc090fda61e98; });
$parcel$export($fd2f81929f856dad$exports, "X_CLIENT_LAST_TELEM", function () { return $fd2f81929f856dad$export$99d6087ff3bfb0d3; });
$parcel$export($fd2f81929f856dad$exports, "X_MS_LIB_CAPABILITY", function () { return $fd2f81929f856dad$export$c5cd103a582a276; });
$parcel$export($fd2f81929f856dad$exports, "X_APP_NAME", function () { return $fd2f81929f856dad$export$6101af169595a2ae; });
$parcel$export($fd2f81929f856dad$exports, "X_APP_VER", function () { return $fd2f81929f856dad$export$a8707209cc4254a; });
$parcel$export($fd2f81929f856dad$exports, "POST_LOGOUT_URI", function () { return $fd2f81929f856dad$export$965624bb436bcb2; });
$parcel$export($fd2f81929f856dad$exports, "ID_TOKEN_HINT", function () { return $fd2f81929f856dad$export$8d6737236a319b56; });
$parcel$export($fd2f81929f856dad$exports, "DEVICE_CODE", function () { return $fd2f81929f856dad$export$a575303545717aec; });
$parcel$export($fd2f81929f856dad$exports, "CLIENT_SECRET", function () { return $fd2f81929f856dad$export$69f7aececf3ea5d7; });
$parcel$export($fd2f81929f856dad$exports, "CLIENT_ASSERTION", function () { return $fd2f81929f856dad$export$cddd1d85c78cca51; });
$parcel$export($fd2f81929f856dad$exports, "CLIENT_ASSERTION_TYPE", function () { return $fd2f81929f856dad$export$21aecb34d0e7d9c0; });
$parcel$export($fd2f81929f856dad$exports, "TOKEN_TYPE", function () { return $fd2f81929f856dad$export$5706a68daf4f000a; });
$parcel$export($fd2f81929f856dad$exports, "REQ_CNF", function () { return $fd2f81929f856dad$export$427afb3f9eefe31e; });
$parcel$export($fd2f81929f856dad$exports, "OBO_ASSERTION", function () { return $fd2f81929f856dad$export$3529b31b0ae94ae0; });
$parcel$export($fd2f81929f856dad$exports, "REQUESTED_TOKEN_USE", function () { return $fd2f81929f856dad$export$97bc1bf63f077c4a; });
$parcel$export($fd2f81929f856dad$exports, "ON_BEHALF_OF", function () { return $fd2f81929f856dad$export$4aca5741d44e318e; });
$parcel$export($fd2f81929f856dad$exports, "FOCI", function () { return $fd2f81929f856dad$export$a03331b9d99609d6; });
$parcel$export($fd2f81929f856dad$exports, "CCS_HEADER", function () { return $fd2f81929f856dad$export$773357fabf610b1f; });
$parcel$export($fd2f81929f856dad$exports, "RETURN_SPA_CODE", function () { return $fd2f81929f856dad$export$f58b98a40c1faa68; });
$parcel$export($fd2f81929f856dad$exports, "NATIVE_BROKER", function () { return $fd2f81929f856dad$export$830ff7e6cf071f86; });
$parcel$export($fd2f81929f856dad$exports, "LOGOUT_HINT", function () { return $fd2f81929f856dad$export$a96ff88ff08babe2; });
$parcel$export($fd2f81929f856dad$exports, "SID", function () { return $fd2f81929f856dad$export$e9405f9e95799b52; });
$parcel$export($fd2f81929f856dad$exports, "LOGIN_HINT", function () { return $fd2f81929f856dad$export$defd6be6e02aaeb3; });
$parcel$export($fd2f81929f856dad$exports, "DOMAIN_HINT", function () { return $fd2f81929f856dad$export$41459bac1e74ba19; });
$parcel$export($fd2f81929f856dad$exports, "X_CLIENT_EXTRA_SKU", function () { return $fd2f81929f856dad$export$493429868d5ba9bc; });
$parcel$export($fd2f81929f856dad$exports, "BROKER_CLIENT_ID", function () { return $fd2f81929f856dad$export$3f910906fd5fe047; });
$parcel$export($fd2f81929f856dad$exports, "BROKER_REDIRECT_URI", function () { return $fd2f81929f856dad$export$c3ecf58e7e228261; });
/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $fd2f81929f856dad$export$c7b1b63f5b60f8e = "client_id";
const $fd2f81929f856dad$export$89711068e98820c5 = "redirect_uri";
const $fd2f81929f856dad$export$af70b7209f1c7f6e = "response_type";
const $fd2f81929f856dad$export$2ae8b352eb8edff7 = "response_mode";
const $fd2f81929f856dad$export$47f09697d0642170 = "grant_type";
const $fd2f81929f856dad$export$c9b29cc9615296dd = "claims";
const $fd2f81929f856dad$export$1c5a554c78c0cd12 = "scope";
const $fd2f81929f856dad$export$103bedf43ba882db = "error";
const $fd2f81929f856dad$export$a9d2d02ea6b73527 = "error_description";
const $fd2f81929f856dad$export$cdbdf26448f9da5b = "access_token";
const $fd2f81929f856dad$export$9e690c458f1b1eda = "id_token";
const $fd2f81929f856dad$export$2a2261c5a58ac0 = "refresh_token";
const $fd2f81929f856dad$export$a9f2539254087dfb = "expires_in";
const $fd2f81929f856dad$export$97e3ac17371277 = "refresh_token_expires_in";
const $fd2f81929f856dad$export$63b4527a2777036f = "state";
const $fd2f81929f856dad$export$8646168ae3eb91e1 = "nonce";
const $fd2f81929f856dad$export$19855bb42e55939d = "prompt";
const $fd2f81929f856dad$export$3edd0f3d0bfcddba = "session_state";
const $fd2f81929f856dad$export$476989d62bcb4c85 = "client_info";
const $fd2f81929f856dad$export$ec5856072852bd7f = "code";
const $fd2f81929f856dad$export$58d2be3216991fee = "code_challenge";
const $fd2f81929f856dad$export$129e6f0601e36303 = "code_challenge_method";
const $fd2f81929f856dad$export$a5a34ec10c757281 = "code_verifier";
const $fd2f81929f856dad$export$633c8d7cd18ad9a9 = "client-request-id";
const $fd2f81929f856dad$export$fe2f04d04881f19d = "x-client-SKU";
const $fd2f81929f856dad$export$d0d0201281a553c0 = "x-client-VER";
const $fd2f81929f856dad$export$35497983a44f9406 = "x-client-OS";
const $fd2f81929f856dad$export$d14a6ca469cd1d2b = "x-client-CPU";
const $fd2f81929f856dad$export$770dc090fda61e98 = "x-client-current-telemetry";
const $fd2f81929f856dad$export$99d6087ff3bfb0d3 = "x-client-last-telemetry";
const $fd2f81929f856dad$export$c5cd103a582a276 = "x-ms-lib-capability";
const $fd2f81929f856dad$export$6101af169595a2ae = "x-app-name";
const $fd2f81929f856dad$export$a8707209cc4254a = "x-app-ver";
const $fd2f81929f856dad$export$965624bb436bcb2 = "post_logout_redirect_uri";
const $fd2f81929f856dad$export$8d6737236a319b56 = "id_token_hint";
const $fd2f81929f856dad$export$a575303545717aec = "device_code";
const $fd2f81929f856dad$export$69f7aececf3ea5d7 = "client_secret";
const $fd2f81929f856dad$export$cddd1d85c78cca51 = "client_assertion";
const $fd2f81929f856dad$export$21aecb34d0e7d9c0 = "client_assertion_type";
const $fd2f81929f856dad$export$5706a68daf4f000a = "token_type";
const $fd2f81929f856dad$export$427afb3f9eefe31e = "req_cnf";
const $fd2f81929f856dad$export$3529b31b0ae94ae0 = "assertion";
const $fd2f81929f856dad$export$97bc1bf63f077c4a = "requested_token_use";
const $fd2f81929f856dad$export$4aca5741d44e318e = "on_behalf_of";
const $fd2f81929f856dad$export$a03331b9d99609d6 = "foci";
const $fd2f81929f856dad$export$773357fabf610b1f = "X-AnchorMailbox";
const $fd2f81929f856dad$export$f58b98a40c1faa68 = "return_spa_code";
const $fd2f81929f856dad$export$830ff7e6cf071f86 = "nativebroker";
const $fd2f81929f856dad$export$a96ff88ff08babe2 = "logout_hint";
const $fd2f81929f856dad$export$e9405f9e95799b52 = "sid";
const $fd2f81929f856dad$export$defd6be6e02aaeb3 = "login_hint";
const $fd2f81929f856dad$export$41459bac1e74ba19 = "domain_hint";
const $fd2f81929f856dad$export$493429868d5ba9bc = "x-client-xtra-sku";
const $fd2f81929f856dad$export$3f910906fd5fe047 = "brk_client_id";
const $fd2f81929f856dad$export$c3ecf58e7e228261 = "brk_redirect_uri";




/*! @azure/msal-common v14.16.1 2025-08-05 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Validates server consumable params from the "request" objects
 */ class $ebac5c31cde45bb3$export$9800b929b6984365 {
    /**
     * Utility to check if the `redirectUri` in the request is a non-null value
     * @param redirectUri
     */ static validateRedirectUri(redirectUri) {
        if (!redirectUri) throw (0, $a6f096219dc1b547$export$5d63d098f4f130a1)((0, $f66a3d6fc9f2eb73$export$7a02f9bdce79dd4e));
    }
    /**
     * Utility to validate prompt sent by the user in the request
     * @param prompt
     */ static validatePrompt(prompt) {
        const promptValues = [];
        for(const value in 0, $08c107807d753255$export$49a06cbda5acaa5)promptValues.push((0, $08c107807d753255$export$49a06cbda5acaa5)[value]);
        if (promptValues.indexOf(prompt) < 0) throw (0, $a6f096219dc1b547$export$5d63d098f4f130a1)((0, $f66a3d6fc9f2eb73$export$ccbe5d2d7c960c35));
    }
    static validateClaims(claims) {
        try {
            JSON.parse(claims);
        } catch (e) {
            throw (0, $a6f096219dc1b547$export$5d63d098f4f130a1)((0, $f66a3d6fc9f2eb73$export$96e755c70e0d0e34));
        }
    }
    /**
     * Utility to validate code_challenge and code_challenge_method
     * @param codeChallenge
     * @param codeChallengeMethod
     */ static validateCodeChallengeParams(codeChallenge, codeChallengeMethod) {
        if (!codeChallenge || !codeChallengeMethod) throw (0, $a6f096219dc1b547$export$5d63d098f4f130a1)((0, $f66a3d6fc9f2eb73$export$2da3866b327f1753));
        else this.validateCodeChallengeMethod(codeChallengeMethod);
    }
    /**
     * Utility to validate code_challenge_method
     * @param codeChallengeMethod
     */ static validateCodeChallengeMethod(codeChallengeMethod) {
        if ([
            (0, $08c107807d753255$export$a1fe36237c1cc863).PLAIN,
            (0, $08c107807d753255$export$a1fe36237c1cc863).S256
        ].indexOf(codeChallengeMethod) < 0) throw (0, $a6f096219dc1b547$export$5d63d098f4f130a1)((0, $f66a3d6fc9f2eb73$export$b8d8b332f17376dc));
    }
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $b2fdab17beec58b6$var$instrumentBrokerParams(parameters, correlationId, performanceClient) {
    if (!correlationId) return;
    const clientId = parameters.get((0, $fd2f81929f856dad$export$c7b1b63f5b60f8e));
    if (clientId && parameters.has((0, $fd2f81929f856dad$export$3f910906fd5fe047))) performanceClient?.addFields({
        embeddedClientId: clientId,
        embeddedRedirectUri: parameters.get((0, $fd2f81929f856dad$export$89711068e98820c5))
    }, correlationId);
}
/** @internal */ class $b2fdab17beec58b6$export$882078dd8a9e0bfa {
    constructor(correlationId, performanceClient){
        this.parameters = new Map();
        this.performanceClient = performanceClient;
        this.correlationId = correlationId;
    }
    /**
     * add response_type = code
     */ addResponseTypeCode() {
        this.parameters.set((0, $fd2f81929f856dad$export$af70b7209f1c7f6e), encodeURIComponent((0, $08c107807d753255$export$a002182e51710d39).CODE_RESPONSE_TYPE));
    }
    /**
     * add response_type = token id_token
     */ addResponseTypeForTokenAndIdToken() {
        this.parameters.set((0, $fd2f81929f856dad$export$af70b7209f1c7f6e), encodeURIComponent(`${(0, $08c107807d753255$export$a002182e51710d39).TOKEN_RESPONSE_TYPE} ${(0, $08c107807d753255$export$a002182e51710d39).ID_TOKEN_RESPONSE_TYPE}`));
    }
    /**
     * add response_mode. defaults to query.
     * @param responseMode
     */ addResponseMode(responseMode) {
        this.parameters.set((0, $fd2f81929f856dad$export$2ae8b352eb8edff7), encodeURIComponent(responseMode ? responseMode : (0, $08c107807d753255$export$f990a5bae1260b8c).QUERY));
    }
    /**
     * Add flag to indicate STS should attempt to use WAM if available
     */ addNativeBroker() {
        this.parameters.set((0, $fd2f81929f856dad$export$830ff7e6cf071f86), encodeURIComponent("1"));
    }
    /**
     * add scopes. set addOidcScopes to false to prevent default scopes in non-user scenarios
     * @param scopeSet
     * @param addOidcScopes
     */ addScopes(scopes, addOidcScopes = true, defaultScopes = (0, $08c107807d753255$export$893b1b5b686d84ef)) {
        // Always add openid to the scopes when adding OIDC scopes
        if (addOidcScopes && !defaultScopes.includes("openid") && !scopes.includes("openid")) defaultScopes.push("openid");
        const requestScopes = addOidcScopes ? [
            ...scopes || [],
            ...defaultScopes
        ] : scopes || [];
        const scopeSet = new (0, $d671ba25592fe375$export$b9b82b0f94ae1f99)(requestScopes);
        this.parameters.set((0, $fd2f81929f856dad$export$1c5a554c78c0cd12), encodeURIComponent(scopeSet.printScopes()));
    }
    /**
     * add clientId
     * @param clientId
     */ addClientId(clientId) {
        this.parameters.set((0, $fd2f81929f856dad$export$c7b1b63f5b60f8e), encodeURIComponent(clientId));
    }
    /**
     * add redirect_uri
     * @param redirectUri
     */ addRedirectUri(redirectUri) {
        (0, $ebac5c31cde45bb3$export$9800b929b6984365).validateRedirectUri(redirectUri);
        this.parameters.set((0, $fd2f81929f856dad$export$89711068e98820c5), encodeURIComponent(redirectUri));
    }
    /**
     * add post logout redirectUri
     * @param redirectUri
     */ addPostLogoutRedirectUri(redirectUri) {
        (0, $ebac5c31cde45bb3$export$9800b929b6984365).validateRedirectUri(redirectUri);
        this.parameters.set((0, $fd2f81929f856dad$export$965624bb436bcb2), encodeURIComponent(redirectUri));
    }
    /**
     * add id_token_hint to logout request
     * @param idTokenHint
     */ addIdTokenHint(idTokenHint) {
        this.parameters.set((0, $fd2f81929f856dad$export$8d6737236a319b56), encodeURIComponent(idTokenHint));
    }
    /**
     * add domain_hint
     * @param domainHint
     */ addDomainHint(domainHint) {
        this.parameters.set((0, $fd2f81929f856dad$export$41459bac1e74ba19), encodeURIComponent(domainHint));
    }
    /**
     * add login_hint
     * @param loginHint
     */ addLoginHint(loginHint) {
        this.parameters.set((0, $fd2f81929f856dad$export$defd6be6e02aaeb3), encodeURIComponent(loginHint));
    }
    /**
     * Adds the CCS (Cache Credential Service) query parameter for login_hint
     * @param loginHint
     */ addCcsUpn(loginHint) {
        this.parameters.set((0, $08c107807d753255$export$28d77f87efed1d88).CCS_HEADER, encodeURIComponent(`UPN:${loginHint}`));
    }
    /**
     * Adds the CCS (Cache Credential Service) query parameter for account object
     * @param loginHint
     */ addCcsOid(clientInfo) {
        this.parameters.set((0, $08c107807d753255$export$28d77f87efed1d88).CCS_HEADER, encodeURIComponent(`Oid:${clientInfo.uid}@${clientInfo.utid}`));
    }
    /**
     * add sid
     * @param sid
     */ addSid(sid) {
        this.parameters.set((0, $fd2f81929f856dad$export$e9405f9e95799b52), encodeURIComponent(sid));
    }
    /**
     * add claims
     * @param claims
     */ addClaims(claims, clientCapabilities) {
        const mergedClaims = this.addClientCapabilitiesToClaims(claims, clientCapabilities);
        (0, $ebac5c31cde45bb3$export$9800b929b6984365).validateClaims(mergedClaims);
        this.parameters.set((0, $fd2f81929f856dad$export$c9b29cc9615296dd), encodeURIComponent(mergedClaims));
    }
    /**
     * add correlationId
     * @param correlationId
     */ addCorrelationId(correlationId) {
        this.parameters.set((0, $fd2f81929f856dad$export$633c8d7cd18ad9a9), encodeURIComponent(correlationId));
    }
    /**
     * add library info query params
     * @param libraryInfo
     */ addLibraryInfo(libraryInfo) {
        // Telemetry Info
        this.parameters.set((0, $fd2f81929f856dad$export$fe2f04d04881f19d), libraryInfo.sku);
        this.parameters.set((0, $fd2f81929f856dad$export$d0d0201281a553c0), libraryInfo.version);
        if (libraryInfo.os) this.parameters.set((0, $fd2f81929f856dad$export$35497983a44f9406), libraryInfo.os);
        if (libraryInfo.cpu) this.parameters.set((0, $fd2f81929f856dad$export$d14a6ca469cd1d2b), libraryInfo.cpu);
    }
    /**
     * Add client telemetry parameters
     * @param appTelemetry
     */ addApplicationTelemetry(appTelemetry) {
        if (appTelemetry?.appName) this.parameters.set((0, $fd2f81929f856dad$export$6101af169595a2ae), appTelemetry.appName);
        if (appTelemetry?.appVersion) this.parameters.set((0, $fd2f81929f856dad$export$a8707209cc4254a), appTelemetry.appVersion);
    }
    /**
     * add prompt
     * @param prompt
     */ addPrompt(prompt) {
        (0, $ebac5c31cde45bb3$export$9800b929b6984365).validatePrompt(prompt);
        this.parameters.set(`${(0, $fd2f81929f856dad$export$19855bb42e55939d)}`, encodeURIComponent(prompt));
    }
    /**
     * add state
     * @param state
     */ addState(state) {
        if (state) this.parameters.set((0, $fd2f81929f856dad$export$63b4527a2777036f), encodeURIComponent(state));
    }
    /**
     * add nonce
     * @param nonce
     */ addNonce(nonce) {
        this.parameters.set((0, $fd2f81929f856dad$export$8646168ae3eb91e1), encodeURIComponent(nonce));
    }
    /**
     * add code_challenge and code_challenge_method
     * - throw if either of them are not passed
     * @param codeChallenge
     * @param codeChallengeMethod
     */ addCodeChallengeParams(codeChallenge, codeChallengeMethod) {
        (0, $ebac5c31cde45bb3$export$9800b929b6984365).validateCodeChallengeParams(codeChallenge, codeChallengeMethod);
        if (codeChallenge && codeChallengeMethod) {
            this.parameters.set((0, $fd2f81929f856dad$export$58d2be3216991fee), encodeURIComponent(codeChallenge));
            this.parameters.set((0, $fd2f81929f856dad$export$129e6f0601e36303), encodeURIComponent(codeChallengeMethod));
        } else throw (0, $a6f096219dc1b547$export$5d63d098f4f130a1)((0, $f66a3d6fc9f2eb73$export$2da3866b327f1753));
    }
    /**
     * add the `authorization_code` passed by the user to exchange for a token
     * @param code
     */ addAuthorizationCode(code) {
        this.parameters.set((0, $fd2f81929f856dad$export$ec5856072852bd7f), encodeURIComponent(code));
    }
    /**
     * add the `authorization_code` passed by the user to exchange for a token
     * @param code
     */ addDeviceCode(code) {
        this.parameters.set((0, $fd2f81929f856dad$export$a575303545717aec), encodeURIComponent(code));
    }
    /**
     * add the `refreshToken` passed by the user
     * @param refreshToken
     */ addRefreshToken(refreshToken) {
        this.parameters.set((0, $fd2f81929f856dad$export$2a2261c5a58ac0), encodeURIComponent(refreshToken));
    }
    /**
     * add the `code_verifier` passed by the user to exchange for a token
     * @param codeVerifier
     */ addCodeVerifier(codeVerifier) {
        this.parameters.set((0, $fd2f81929f856dad$export$a5a34ec10c757281), encodeURIComponent(codeVerifier));
    }
    /**
     * add client_secret
     * @param clientSecret
     */ addClientSecret(clientSecret) {
        this.parameters.set((0, $fd2f81929f856dad$export$69f7aececf3ea5d7), encodeURIComponent(clientSecret));
    }
    /**
     * add clientAssertion for confidential client flows
     * @param clientAssertion
     */ addClientAssertion(clientAssertion) {
        if (clientAssertion) this.parameters.set((0, $fd2f81929f856dad$export$cddd1d85c78cca51), encodeURIComponent(clientAssertion));
    }
    /**
     * add clientAssertionType for confidential client flows
     * @param clientAssertionType
     */ addClientAssertionType(clientAssertionType) {
        if (clientAssertionType) this.parameters.set((0, $fd2f81929f856dad$export$21aecb34d0e7d9c0), encodeURIComponent(clientAssertionType));
    }
    /**
     * add OBO assertion for confidential client flows
     * @param clientAssertion
     */ addOboAssertion(oboAssertion) {
        this.parameters.set((0, $fd2f81929f856dad$export$3529b31b0ae94ae0), encodeURIComponent(oboAssertion));
    }
    /**
     * add grant type
     * @param grantType
     */ addRequestTokenUse(tokenUse) {
        this.parameters.set((0, $fd2f81929f856dad$export$97bc1bf63f077c4a), encodeURIComponent(tokenUse));
    }
    /**
     * add grant type
     * @param grantType
     */ addGrantType(grantType) {
        this.parameters.set((0, $fd2f81929f856dad$export$47f09697d0642170), encodeURIComponent(grantType));
    }
    /**
     * add client info
     *
     */ addClientInfo() {
        this.parameters.set((0, $08c107807d753255$export$476989d62bcb4c85), "1");
    }
    /**
     * add extraQueryParams
     * @param eQParams
     */ addExtraQueryParameters(eQParams) {
        Object.entries(eQParams).forEach(([key, value])=>{
            if (!this.parameters.has(key) && value) this.parameters.set(key, value);
        });
    }
    addClientCapabilitiesToClaims(claims, clientCapabilities) {
        let mergedClaims;
        // Parse provided claims into JSON object or initialize empty object
        if (!claims) mergedClaims = {};
        else try {
            mergedClaims = JSON.parse(claims);
        } catch (e) {
            throw (0, $a6f096219dc1b547$export$5d63d098f4f130a1)((0, $f66a3d6fc9f2eb73$export$96e755c70e0d0e34));
        }
        if (clientCapabilities && clientCapabilities.length > 0) {
            if (!mergedClaims.hasOwnProperty((0, $08c107807d753255$export$c125cda26c71ef54).ACCESS_TOKEN)) // Add access_token key to claims object
            mergedClaims[(0, $08c107807d753255$export$c125cda26c71ef54).ACCESS_TOKEN] = {};
            // Add xms_cc claim with provided clientCapabilities to access_token key
            mergedClaims[(0, $08c107807d753255$export$c125cda26c71ef54).ACCESS_TOKEN][(0, $08c107807d753255$export$c125cda26c71ef54).XMS_CC] = {
                values: clientCapabilities
            };
        }
        return JSON.stringify(mergedClaims);
    }
    /**
     * adds `username` for Password Grant flow
     * @param username
     */ addUsername(username) {
        this.parameters.set((0, $08c107807d753255$export$fa8b29062cab1da).username, encodeURIComponent(username));
    }
    /**
     * adds `password` for Password Grant flow
     * @param password
     */ addPassword(password) {
        this.parameters.set((0, $08c107807d753255$export$fa8b29062cab1da).password, encodeURIComponent(password));
    }
    /**
     * add pop_jwk to query params
     * @param cnfString
     */ addPopToken(cnfString) {
        if (cnfString) {
            this.parameters.set((0, $fd2f81929f856dad$export$5706a68daf4f000a), (0, $08c107807d753255$export$901491a717da2ba5).POP);
            this.parameters.set((0, $fd2f81929f856dad$export$427afb3f9eefe31e), encodeURIComponent(cnfString));
        }
    }
    /**
     * add SSH JWK and key ID to query params
     */ addSshJwk(sshJwkString) {
        if (sshJwkString) {
            this.parameters.set((0, $fd2f81929f856dad$export$5706a68daf4f000a), (0, $08c107807d753255$export$901491a717da2ba5).SSH);
            this.parameters.set((0, $fd2f81929f856dad$export$427afb3f9eefe31e), encodeURIComponent(sshJwkString));
        }
    }
    /**
     * add server telemetry fields
     * @param serverTelemetryManager
     */ addServerTelemetry(serverTelemetryManager) {
        this.parameters.set((0, $fd2f81929f856dad$export$770dc090fda61e98), serverTelemetryManager.generateCurrentRequestHeaderValue());
        this.parameters.set((0, $fd2f81929f856dad$export$99d6087ff3bfb0d3), serverTelemetryManager.generateLastRequestHeaderValue());
    }
    /**
     * Adds parameter that indicates to the server that throttling is supported
     */ addThrottling() {
        this.parameters.set((0, $fd2f81929f856dad$export$c5cd103a582a276), (0, $08c107807d753255$export$a2330d6808e6d893).X_MS_LIB_CAPABILITY_VALUE);
    }
    /**
     * Adds logout_hint parameter for "silent" logout which prevent server account picker
     */ addLogoutHint(logoutHint) {
        this.parameters.set((0, $fd2f81929f856dad$export$a96ff88ff08babe2), encodeURIComponent(logoutHint));
    }
    addBrokerParameters(params) {
        const brokerParams = {};
        brokerParams[0, $fd2f81929f856dad$export$3f910906fd5fe047] = params.brokerClientId;
        brokerParams[0, $fd2f81929f856dad$export$c3ecf58e7e228261] = params.brokerRedirectUri;
        this.addExtraQueryParameters(brokerParams);
    }
    /**
     * Utility to create a URL from the params map
     */ createQueryString() {
        const queryParameterArray = new Array();
        this.parameters.forEach((value, key)=>{
            queryParameterArray.push(`${key}=${value}`);
        });
        $b2fdab17beec58b6$var$instrumentBrokerParams(this.parameters, this.correlationId, this.performanceClient);
        return queryParameterArray.join("&");
    }
}


var $386db2f829938631$exports = {};

$parcel$export($386db2f829938631$exports, "createDiscoveredInstance", function () { return $386db2f829938631$export$ab9db5e7e572e7da; });
/*! @azure/msal-common v14.16.1 2025-08-05 */ 




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Create an authority object of the correct type based on the url
 * Performs basic authority validation - checks to see if the authority is of a valid type (i.e. aad, b2c, adfs)
 *
 * Also performs endpoint discovery.
 *
 * @param authorityUri
 * @param networkClient
 * @param protocolMode
 * @internal
 */ async function $386db2f829938631$export$ab9db5e7e572e7da(authorityUri, networkClient, cacheManager, authorityOptions, logger, correlationId, performanceClient) {
    performanceClient?.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).AuthorityFactoryCreateDiscoveredInstance, correlationId);
    const authorityUriFinal = (0, $dda2270c89fd90c8$export$f1c6ec2e6d68c49c).transformCIAMAuthority((0, $dda2270c89fd90c8$export$4030f3538167cb9e)(authorityUri));
    // Initialize authority and perform discovery endpoint check.
    const acquireTokenAuthority = new (0, $dda2270c89fd90c8$export$f1c6ec2e6d68c49c)(authorityUriFinal, networkClient, cacheManager, authorityOptions, logger, correlationId, performanceClient);
    try {
        await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(acquireTokenAuthority.resolveEndpointsAsync.bind(acquireTokenAuthority), (0, $32170abc11155933$export$2f2811a3e1b21823).AuthorityResolveEndpointsAsync, logger, performanceClient, correlationId)();
        return acquireTokenAuthority;
    } catch (e) {
        throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$c9fcc93738cc2bc3));
    }
}









'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Base application class which will construct requests to send to and handle responses from the Microsoft STS using the authorization code flow.
 * @internal
 */ class $ed3742a5fca7e3cb$export$4f22f74eddb7716a {
    constructor(configuration, performanceClient){
        // Set the configuration
        this.config = (0, $44a243886d8c290a$export$57a091701dcdabb2)(configuration);
        // Initialize the logger
        this.logger = new (0, $4643cd557adfd6d5$export$efa9a398d6368992)(this.config.loggerOptions, (0, $a15c066c8ddfab99$export$a8ff84c12d48cfa6), (0, $a15c066c8ddfab99$export$83d89fbfd8236492));
        // Initialize crypto
        this.cryptoUtils = this.config.cryptoInterface;
        // Initialize storage interface
        this.cacheManager = this.config.storageInterface;
        // Set the network interface
        this.networkClient = this.config.networkInterface;
        // Set TelemetryManager
        this.serverTelemetryManager = this.config.serverTelemetryManager;
        // set Authority
        this.authority = this.config.authOptions.authority;
        // set performance telemetry client
        this.performanceClient = performanceClient;
    }
    /**
     * Creates default headers for requests to token endpoint
     */ createTokenRequestHeaders(ccsCred) {
        const headers = {};
        headers[(0, $08c107807d753255$export$28d77f87efed1d88).CONTENT_TYPE] = (0, $08c107807d753255$export$a002182e51710d39).URL_FORM_CONTENT_TYPE;
        if (!this.config.systemOptions.preventCorsPreflight && ccsCred) switch(ccsCred.type){
            case (0, $36f32d37ad76b0c5$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID:
                try {
                    const clientInfo = (0, $8647f63f1ec6244a$export$63508a6d6b7dbe07)(ccsCred.credential);
                    headers[(0, $08c107807d753255$export$28d77f87efed1d88).CCS_HEADER] = `Oid:${clientInfo.uid}@${clientInfo.utid}`;
                } catch (e) {
                    this.logger.verbose("Could not parse home account ID for CCS Header: " + e);
                }
                break;
            case (0, $36f32d37ad76b0c5$export$17b7b3ac1abef49f).UPN:
                headers[(0, $08c107807d753255$export$28d77f87efed1d88).CCS_HEADER] = `UPN: ${ccsCred.credential}`;
                break;
        }
        return headers;
    }
    /**
     * Http post to token endpoint
     * @param tokenEndpoint
     * @param queryString
     * @param headers
     * @param thumbprint
     */ async executePostToTokenEndpoint(tokenEndpoint, queryString, headers, thumbprint, correlationId, queuedEvent) {
        if (queuedEvent) this.performanceClient?.addQueueMeasurement(queuedEvent, correlationId);
        const response = await this.sendPostRequest(thumbprint, tokenEndpoint, {
            body: queryString,
            headers: headers
        }, correlationId);
        if (this.config.serverTelemetryManager && response.status < 500 && response.status !== 429) // Telemetry data successfully logged by server, clear Telemetry cache
        this.config.serverTelemetryManager.clearTelemetryCache();
        return response;
    }
    /**
     * Wraps sendPostRequestAsync with necessary preflight and postflight logic
     * @param thumbprint - Request thumbprint for throttling
     * @param tokenEndpoint - Endpoint to make the POST to
     * @param options - Body and Headers to include on the POST request
     * @param correlationId - CorrelationId for telemetry
     */ async sendPostRequest(thumbprint, tokenEndpoint, options, correlationId) {
        (0, $a5c865990da19377$export$c060a619741dd765).preProcess(this.cacheManager, thumbprint, correlationId);
        let response;
        try {
            response = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.networkClient.sendPostRequestAsync.bind(this.networkClient), (0, $32170abc11155933$export$2f2811a3e1b21823).NetworkClientSendPostRequestAsync, this.logger, this.performanceClient, correlationId)(tokenEndpoint, options);
            const responseHeaders = response.headers || {};
            this.performanceClient?.addFields({
                refreshTokenSize: response.body.refresh_token?.length || 0,
                httpVerToken: responseHeaders[(0, $08c107807d753255$export$28d77f87efed1d88).X_MS_HTTP_VERSION] || "",
                requestId: responseHeaders[(0, $08c107807d753255$export$28d77f87efed1d88).X_MS_REQUEST_ID] || ""
            }, correlationId);
        } catch (e) {
            if (e instanceof (0, $9ce5dcfe9606df55$export$bae979e68e4dc802)) {
                const responseHeaders = e.responseHeaders;
                if (responseHeaders) this.performanceClient?.addFields({
                    httpVerToken: responseHeaders[(0, $08c107807d753255$export$28d77f87efed1d88).X_MS_HTTP_VERSION] || "",
                    requestId: responseHeaders[(0, $08c107807d753255$export$28d77f87efed1d88).X_MS_REQUEST_ID] || "",
                    contentTypeHeader: responseHeaders[(0, $08c107807d753255$export$28d77f87efed1d88).CONTENT_TYPE] || undefined,
                    contentLengthHeader: responseHeaders[(0, $08c107807d753255$export$28d77f87efed1d88).CONTENT_LENGTH] || undefined,
                    httpStatus: e.httpStatus
                }, correlationId);
                throw e.error;
            }
            if (e instanceof (0, $53b49d8334c1646a$export$145273558d58e0ac)) throw e;
            else throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$4358cbadf08aa73));
        }
        (0, $a5c865990da19377$export$c060a619741dd765).postProcess(this.cacheManager, thumbprint, response, correlationId);
        return response;
    }
    /**
     * Updates the authority object of the client. Endpoint discovery must be completed.
     * @param updatedAuthority
     */ async updateAuthority(cloudInstanceHostname, correlationId) {
        this.performanceClient?.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).UpdateTokenEndpointAuthority, correlationId);
        const cloudInstanceAuthorityUri = `https://${cloudInstanceHostname}/${this.authority.tenant}/`;
        const cloudInstanceAuthority = await (0, $386db2f829938631$export$ab9db5e7e572e7da)(cloudInstanceAuthorityUri, this.networkClient, this.cacheManager, this.authority.options, this.logger, correlationId, this.performanceClient);
        this.authority = cloudInstanceAuthority;
    }
    /**
     * Creates query string for the /token request
     * @param request
     */ createTokenQueryParameters(request) {
        const parameterBuilder = new (0, $b2fdab17beec58b6$export$882078dd8a9e0bfa)(request.correlationId, this.performanceClient);
        if (request.embeddedClientId) parameterBuilder.addBrokerParameters({
            brokerClientId: this.config.authOptions.clientId,
            brokerRedirectUri: this.config.authOptions.redirectUri
        });
        if (request.tokenQueryParameters) parameterBuilder.addExtraQueryParameters(request.tokenQueryParameters);
        parameterBuilder.addCorrelationId(request.correlationId);
        return parameterBuilder.createQueryString();
    }
}






/*! @azure/msal-common v14.16.1 2025-08-05 */ 






/*! @azure/msal-common v14.16.1 2025-08-05 */ 



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $a427aceea5cc6ef6$var$KeyLocation = {
    SW: "sw",
    UHW: "uhw"
};
/** @internal */ class $a427aceea5cc6ef6$export$3dd8467151c83e3e {
    constructor(cryptoUtils, performanceClient){
        this.cryptoUtils = cryptoUtils;
        this.performanceClient = performanceClient;
    }
    /**
     * Generates the req_cnf validated at the RP in the POP protocol for SHR parameters
     * and returns an object containing the keyid, the full req_cnf string and the req_cnf string hash
     * @param request
     * @returns
     */ async generateCnf(request, logger) {
        this.performanceClient?.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).PopTokenGenerateCnf, request.correlationId);
        const reqCnf = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.generateKid.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).PopTokenGenerateCnf, logger, this.performanceClient, request.correlationId)(request);
        const reqCnfString = this.cryptoUtils.base64UrlEncode(JSON.stringify(reqCnf));
        return {
            kid: reqCnf.kid,
            reqCnfString: reqCnfString
        };
    }
    /**
     * Generates key_id for a SHR token request
     * @param request
     * @returns
     */ async generateKid(request) {
        this.performanceClient?.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).PopTokenGenerateKid, request.correlationId);
        const kidThumbprint = await this.cryptoUtils.getPublicKeyThumbprint(request);
        return {
            kid: kidThumbprint,
            xms_ksl: $a427aceea5cc6ef6$var$KeyLocation.SW
        };
    }
    /**
     * Signs the POP access_token with the local generated key-pair
     * @param accessToken
     * @param request
     * @returns
     */ async signPopToken(accessToken, keyId, request) {
        return this.signPayload(accessToken, keyId, request);
    }
    /**
     * Utility function to generate the signed JWT for an access_token
     * @param payload
     * @param kid
     * @param request
     * @param claims
     * @returns
     */ async signPayload(payload, keyId, request, claims) {
        // Deconstruct request to extract SHR parameters
        const { resourceRequestMethod: resourceRequestMethod, resourceRequestUri: resourceRequestUri, shrClaims: shrClaims, shrNonce: shrNonce, shrOptions: shrOptions } = request;
        const resourceUrlString = resourceRequestUri ? new (0, $ff2860ddbc741970$export$3abcdca7229e54f2)(resourceRequestUri) : undefined;
        const resourceUrlComponents = resourceUrlString?.getUrlComponents();
        return this.cryptoUtils.signJwt({
            at: payload,
            ts: (0, $7dce75f27affa532$export$ae62599a119ac50a)(),
            m: resourceRequestMethod?.toUpperCase(),
            u: resourceUrlComponents?.HostNameAndPort,
            nonce: shrNonce || this.cryptoUtils.createNewGuid(),
            p: resourceUrlComponents?.AbsolutePath,
            q: resourceUrlComponents?.QueryString ? [
                [],
                resourceUrlComponents.QueryString
            ] : undefined,
            client_claims: shrClaims || undefined,
            ...claims
        }, keyId, shrOptions, request.correlationId);
    }
}


/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * This class instance helps track the memory changes facilitating
 * decisions to read from and write to the persistent cache
 */ class $121887a1e0b63ac2$export$500ab620f6bcc747 {
    constructor(tokenCache, hasChanged){
        this.cache = tokenCache;
        this.hasChanged = hasChanged;
    }
    /**
     * boolean which indicates the changes in cache
     */ get cacheHasChanged() {
        return this.hasChanged;
    }
    /**
     * function to retrieve the token cache
     */ get tokenCache() {
        return this.cache;
    }
}








'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $85344044ef39ab89$var$parseServerErrorNo(serverResponse) {
    const errorCodePrefix = "code=";
    const errorCodePrefixIndex = serverResponse.error_uri?.lastIndexOf(errorCodePrefix);
    return errorCodePrefixIndex && errorCodePrefixIndex >= 0 ? serverResponse.error_uri?.substring(errorCodePrefixIndex + errorCodePrefix.length) : undefined;
}
/**
 * Class that handles response parsing.
 * @internal
 */ class $85344044ef39ab89$export$f456c9835cc63582 {
    constructor(clientId, cacheStorage, cryptoObj, logger, serializableCache, persistencePlugin, performanceClient){
        this.clientId = clientId;
        this.cacheStorage = cacheStorage;
        this.cryptoObj = cryptoObj;
        this.logger = logger;
        this.serializableCache = serializableCache;
        this.persistencePlugin = persistencePlugin;
        this.performanceClient = performanceClient;
    }
    /**
     * Function which validates server authorization code response.
     * @param serverResponseHash
     * @param requestState
     * @param cryptoObj
     */ validateServerAuthorizationCodeResponse(serverResponse, requestState) {
        if (!serverResponse.state || !requestState) throw serverResponse.state ? (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$ef9214cfa5960fc), "Cached State") : (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$ef9214cfa5960fc), "Server State");
        let decodedServerResponseState;
        let decodedRequestState;
        try {
            decodedServerResponseState = decodeURIComponent(serverResponse.state);
        } catch (e) {
            throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$72a77317632c052b), serverResponse.state);
        }
        try {
            decodedRequestState = decodeURIComponent(requestState);
        } catch (e) {
            throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$72a77317632c052b), serverResponse.state);
        }
        if (decodedServerResponseState !== decodedRequestState) throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$6a56d8f882843cd8));
        // Check for error
        if (serverResponse.error || serverResponse.error_description || serverResponse.suberror) {
            const serverErrorNo = $85344044ef39ab89$var$parseServerErrorNo(serverResponse);
            if ((0, $0171ff24547bf7bf$export$376c3c4c19cb933a)(serverResponse.error, serverResponse.error_description, serverResponse.suberror)) throw new (0, $0171ff24547bf7bf$export$6ba3e818c6bc76ba)(serverResponse.error || "", serverResponse.error_description, serverResponse.suberror, serverResponse.timestamp || "", serverResponse.trace_id || "", serverResponse.correlation_id || "", serverResponse.claims || "", serverErrorNo);
            throw new (0, $85fc58951e10e394$export$ea52035eac03daf0)(serverResponse.error || "", serverResponse.error_description, serverResponse.suberror, serverErrorNo);
        }
    }
    /**
     * Function which validates server authorization token response.
     * @param serverResponse
     * @param refreshAccessToken
     */ validateTokenResponse(serverResponse, refreshAccessToken) {
        // Check for error
        if (serverResponse.error || serverResponse.error_description || serverResponse.suberror) {
            const errString = `Error(s): ${serverResponse.error_codes || (0, $08c107807d753255$export$a002182e51710d39).NOT_AVAILABLE} - Timestamp: ${serverResponse.timestamp || (0, $08c107807d753255$export$a002182e51710d39).NOT_AVAILABLE} - Description: ${serverResponse.error_description || (0, $08c107807d753255$export$a002182e51710d39).NOT_AVAILABLE} - Correlation ID: ${serverResponse.correlation_id || (0, $08c107807d753255$export$a002182e51710d39).NOT_AVAILABLE} - Trace ID: ${serverResponse.trace_id || (0, $08c107807d753255$export$a002182e51710d39).NOT_AVAILABLE}`;
            const serverErrorNo = serverResponse.error_codes?.length ? serverResponse.error_codes[0] : undefined;
            const serverError = new (0, $85fc58951e10e394$export$ea52035eac03daf0)(serverResponse.error, errString, serverResponse.suberror, serverErrorNo, serverResponse.status);
            // check if 500 error
            if (refreshAccessToken && serverResponse.status && serverResponse.status >= (0, $08c107807d753255$export$2b71909294c66558).SERVER_ERROR_RANGE_START && serverResponse.status <= (0, $08c107807d753255$export$2b71909294c66558).SERVER_ERROR_RANGE_END) {
                this.logger.warning(`executeTokenRequest:validateTokenResponse - AAD is currently unavailable and the access token is unable to be refreshed.\n${serverError}`);
                // don't throw an exception, but alert the user via a log that the token was unable to be refreshed
                return;
            // check if 400 error
            } else if (refreshAccessToken && serverResponse.status && serverResponse.status >= (0, $08c107807d753255$export$2b71909294c66558).CLIENT_ERROR_RANGE_START && serverResponse.status <= (0, $08c107807d753255$export$2b71909294c66558).CLIENT_ERROR_RANGE_END) {
                this.logger.warning(`executeTokenRequest:validateTokenResponse - AAD is currently available but is unable to refresh the access token.\n${serverError}`);
                // don't throw an exception, but alert the user via a log that the token was unable to be refreshed
                return;
            }
            if ((0, $0171ff24547bf7bf$export$376c3c4c19cb933a)(serverResponse.error, serverResponse.error_description, serverResponse.suberror)) throw new (0, $0171ff24547bf7bf$export$6ba3e818c6bc76ba)(serverResponse.error, serverResponse.error_description, serverResponse.suberror, serverResponse.timestamp || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING, serverResponse.trace_id || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING, serverResponse.correlation_id || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING, serverResponse.claims || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING, serverErrorNo);
            throw serverError;
        }
    }
    /**
     * Returns a constructed token response based on given string. Also manages the cache updates and cleanups.
     * @param serverTokenResponse
     * @param authority
     */ async handleServerTokenResponse(serverTokenResponse, authority, reqTimestamp, request, authCodePayload, userAssertionHash, handlingRefreshTokenResponse, forceCacheRefreshTokenResponse, serverRequestId) {
        this.performanceClient?.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).HandleServerTokenResponse, serverTokenResponse.correlation_id);
        // create an idToken object (not entity)
        let idTokenClaims;
        if (serverTokenResponse.id_token) {
            idTokenClaims = (0, $dfbf8cbb9a592daa$export$8a59e6f35fb00518)(serverTokenResponse.id_token || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING, this.cryptoObj.base64Decode);
            // token nonce check (TODO: Add a warning if no nonce is given?)
            if (authCodePayload && authCodePayload.nonce) {
                if (idTokenClaims.nonce !== authCodePayload.nonce) throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$edd0491c2c280be7));
            }
            // token max_age check
            if (request.maxAge || request.maxAge === 0) {
                const authTime = idTokenClaims.auth_time;
                if (!authTime) throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$43356944266c945e));
                (0, $dfbf8cbb9a592daa$export$ee7a34ea7880144c)(authTime, request.maxAge);
            }
        }
        // generate homeAccountId
        this.homeAccountIdentifier = (0, $35a4414ce05ac30e$export$680160523e6bfa6a).generateHomeAccountId(serverTokenResponse.client_info || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING, authority.authorityType, this.logger, this.cryptoObj, idTokenClaims);
        // save the response tokens
        let requestStateObj;
        if (!!authCodePayload && !!authCodePayload.state) requestStateObj = (0, $1cc651d5e90b7480$export$871e33217042c65e).parseRequestState(this.cryptoObj, authCodePayload.state);
        // Add keyId from request to serverTokenResponse if defined
        serverTokenResponse.key_id = serverTokenResponse.key_id || request.sshKid || undefined;
        const cacheRecord = this.generateCacheRecord(serverTokenResponse, authority, reqTimestamp, request, idTokenClaims, userAssertionHash, authCodePayload);
        let cacheContext;
        try {
            if (this.persistencePlugin && this.serializableCache) {
                this.logger.verbose("Persistence enabled, calling beforeCacheAccess");
                cacheContext = new (0, $121887a1e0b63ac2$export$500ab620f6bcc747)(this.serializableCache, true);
                await this.persistencePlugin.beforeCacheAccess(cacheContext);
            }
            /*
             * When saving a refreshed tokens to the cache, it is expected that the account that was used is present in the cache.
             * If not present, we should return null, as it's the case that another application called removeAccount in between
             * the calls to getAllAccounts and acquireTokenSilent. We should not overwrite that removal, unless explicitly flagged by
             * the developer, as in the case of refresh token flow used in ADAL Node to MSAL Node migration.
             */ if (handlingRefreshTokenResponse && !forceCacheRefreshTokenResponse && cacheRecord.account) {
                const key = cacheRecord.account.generateAccountKey();
                const account = this.cacheStorage.getAccount(key, request.correlationId, this.logger);
                if (!account) {
                    this.logger.warning("Account used to refresh tokens not in persistence, refreshed tokens will not be stored in the cache");
                    return await $85344044ef39ab89$export$f456c9835cc63582.generateAuthenticationResult(this.cryptoObj, authority, cacheRecord, false, request, idTokenClaims, requestStateObj, undefined, serverRequestId);
                }
            }
            await this.cacheStorage.saveCacheRecord(cacheRecord, request.correlationId, request.storeInCache);
        } finally{
            if (this.persistencePlugin && this.serializableCache && cacheContext) {
                this.logger.verbose("Persistence enabled, calling afterCacheAccess");
                await this.persistencePlugin.afterCacheAccess(cacheContext);
            }
        }
        return $85344044ef39ab89$export$f456c9835cc63582.generateAuthenticationResult(this.cryptoObj, authority, cacheRecord, false, request, idTokenClaims, requestStateObj, serverTokenResponse, serverRequestId);
    }
    /**
     * Generates CacheRecord
     * @param serverTokenResponse
     * @param idTokenObj
     * @param authority
     */ generateCacheRecord(serverTokenResponse, authority, reqTimestamp, request, idTokenClaims, userAssertionHash, authCodePayload) {
        const env = authority.getPreferredCache();
        if (!env) throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$dedc648643245fa1));
        const claimsTenantId = (0, $72bd70d616a36606$export$8e1decb9a5e2932)(idTokenClaims);
        // IdToken: non AAD scenarios can have empty realm
        let cachedIdToken;
        let cachedAccount;
        if (serverTokenResponse.id_token && !!idTokenClaims) {
            cachedIdToken = (0, $bd840ab348a8e6dd$export$d8a173a23f325769)(this.homeAccountIdentifier, env, serverTokenResponse.id_token, this.clientId, claimsTenantId || "");
            cachedAccount = $85344044ef39ab89$export$73b84062d58a1307(this.cacheStorage, authority, this.homeAccountIdentifier, this.cryptoObj.base64Decode, request.correlationId, idTokenClaims, serverTokenResponse.client_info, env, claimsTenantId, authCodePayload, undefined, this.logger);
        }
        // AccessToken
        let cachedAccessToken = null;
        if (serverTokenResponse.access_token) {
            // If scopes not returned in server response, use request scopes
            const responseScopes = serverTokenResponse.scope ? (0, $d671ba25592fe375$export$b9b82b0f94ae1f99).fromString(serverTokenResponse.scope) : new (0, $d671ba25592fe375$export$b9b82b0f94ae1f99)(request.scopes || []);
            /*
             * Use timestamp calculated before request
             * Server may return timestamps as strings, parse to numbers if so.
             */ const expiresIn = (typeof serverTokenResponse.expires_in === "string" ? parseInt(serverTokenResponse.expires_in, 10) : serverTokenResponse.expires_in) || 0;
            const extExpiresIn = (typeof serverTokenResponse.ext_expires_in === "string" ? parseInt(serverTokenResponse.ext_expires_in, 10) : serverTokenResponse.ext_expires_in) || 0;
            const refreshIn = (typeof serverTokenResponse.refresh_in === "string" ? parseInt(serverTokenResponse.refresh_in, 10) : serverTokenResponse.refresh_in) || undefined;
            const tokenExpirationSeconds = reqTimestamp + expiresIn;
            const extendedTokenExpirationSeconds = tokenExpirationSeconds + extExpiresIn;
            const refreshOnSeconds = refreshIn && refreshIn > 0 ? reqTimestamp + refreshIn : undefined;
            // non AAD scenarios can have empty realm
            cachedAccessToken = (0, $bd840ab348a8e6dd$export$fa005e75d915b6db)(this.homeAccountIdentifier, env, serverTokenResponse.access_token, this.clientId, claimsTenantId || authority.tenant || "", responseScopes.printScopes(), tokenExpirationSeconds, extendedTokenExpirationSeconds, this.cryptoObj.base64Decode, refreshOnSeconds, serverTokenResponse.token_type, userAssertionHash, serverTokenResponse.key_id, request.claims, request.requestedClaimsHash);
        }
        // refreshToken
        let cachedRefreshToken = null;
        if (serverTokenResponse.refresh_token) {
            let rtExpiresOn;
            if (serverTokenResponse.refresh_token_expires_in) {
                const rtExpiresIn = typeof serverTokenResponse.refresh_token_expires_in === "string" ? parseInt(serverTokenResponse.refresh_token_expires_in, 10) : serverTokenResponse.refresh_token_expires_in;
                rtExpiresOn = reqTimestamp + rtExpiresIn;
            }
            cachedRefreshToken = (0, $bd840ab348a8e6dd$export$9095b5885dfa55cc)(this.homeAccountIdentifier, env, serverTokenResponse.refresh_token, this.clientId, serverTokenResponse.foci, userAssertionHash, rtExpiresOn);
        }
        // appMetadata
        let cachedAppMetadata = null;
        if (serverTokenResponse.foci) cachedAppMetadata = {
            clientId: this.clientId,
            environment: env,
            familyId: serverTokenResponse.foci
        };
        return {
            account: cachedAccount,
            idToken: cachedIdToken,
            accessToken: cachedAccessToken,
            refreshToken: cachedRefreshToken,
            appMetadata: cachedAppMetadata
        };
    }
    /**
     * Creates an @AuthenticationResult from @CacheRecord , @IdToken , and a boolean that states whether or not the result is from cache.
     *
     * Optionally takes a state string that is set as-is in the response.
     *
     * @param cacheRecord
     * @param idTokenObj
     * @param fromTokenCache
     * @param stateString
     */ static async generateAuthenticationResult(cryptoObj, authority, cacheRecord, fromTokenCache, request, idTokenClaims, requestState, serverTokenResponse, requestId) {
        let accessToken = (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING;
        let responseScopes = [];
        let expiresOn = null;
        let extExpiresOn;
        let refreshOn;
        let familyId = (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING;
        if (cacheRecord.accessToken) {
            /*
             * if the request object has `popKid` property, `signPopToken` will be set to false and
             * the token will be returned unsigned
             */ if (cacheRecord.accessToken.tokenType === (0, $08c107807d753255$export$901491a717da2ba5).POP && !request.popKid) {
                const popTokenGenerator = new (0, $a427aceea5cc6ef6$export$3dd8467151c83e3e)(cryptoObj);
                const { secret: secret, keyId: keyId } = cacheRecord.accessToken;
                if (!keyId) throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$3c9338a50e294d1));
                accessToken = await popTokenGenerator.signPopToken(secret, keyId, request);
            } else accessToken = cacheRecord.accessToken.secret;
            responseScopes = (0, $d671ba25592fe375$export$b9b82b0f94ae1f99).fromString(cacheRecord.accessToken.target).asArray();
            expiresOn = new Date(Number(cacheRecord.accessToken.expiresOn) * 1000);
            extExpiresOn = new Date(Number(cacheRecord.accessToken.extendedExpiresOn) * 1000);
            if (cacheRecord.accessToken.refreshOn) refreshOn = new Date(Number(cacheRecord.accessToken.refreshOn) * 1000);
        }
        if (cacheRecord.appMetadata) familyId = cacheRecord.appMetadata.familyId === (0, $08c107807d753255$export$978fe7ab5e74b539) ? (0, $08c107807d753255$export$978fe7ab5e74b539) : "";
        const uid = idTokenClaims?.oid || idTokenClaims?.sub || "";
        const tid = idTokenClaims?.tid || "";
        // for hybrid + native bridge enablement, send back the native account Id
        if (serverTokenResponse?.spa_accountid && !!cacheRecord.account) cacheRecord.account.nativeAccountId = serverTokenResponse?.spa_accountid;
        const accountInfo = cacheRecord.account ? (0, $2b6041b9fe3f70e1$export$452a054c78b83dad)(cacheRecord.account.getAccountInfo(), undefined, idTokenClaims, cacheRecord.idToken?.secret) : null;
        return {
            authority: authority.canonicalAuthority,
            uniqueId: uid,
            tenantId: tid,
            scopes: responseScopes,
            account: accountInfo,
            idToken: cacheRecord?.idToken?.secret || "",
            idTokenClaims: idTokenClaims || {},
            accessToken: accessToken,
            fromCache: fromTokenCache,
            expiresOn: expiresOn,
            extExpiresOn: extExpiresOn,
            refreshOn: refreshOn,
            correlationId: request.correlationId,
            requestId: requestId || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING,
            familyId: familyId,
            tokenType: cacheRecord.accessToken?.tokenType || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING,
            state: requestState ? requestState.userRequestState : (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING,
            cloudGraphHostName: cacheRecord.account?.cloudGraphHostName || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING,
            msGraphHost: cacheRecord.account?.msGraphHost || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING,
            code: serverTokenResponse?.spa_code,
            fromNativeBroker: false
        };
    }
}
function $85344044ef39ab89$export$73b84062d58a1307(cacheStorage, authority, homeAccountId, base64Decode, correlationId, idTokenClaims, clientInfo, environment, claimsTenantId, authCodePayload, nativeAccountId, logger) {
    logger?.verbose("setCachedAccount called");
    // Check if base account is already cached
    const accountKeys = cacheStorage.getAccountKeys();
    const baseAccountKey = accountKeys.find((accountKey)=>{
        return accountKey.startsWith(homeAccountId);
    });
    let cachedAccount = null;
    if (baseAccountKey) cachedAccount = cacheStorage.getAccount(baseAccountKey, correlationId, logger);
    const baseAccount = cachedAccount || (0, $35a4414ce05ac30e$export$680160523e6bfa6a).createAccount({
        homeAccountId: homeAccountId,
        idTokenClaims: idTokenClaims,
        clientInfo: clientInfo,
        environment: environment,
        cloudGraphHostName: authCodePayload?.cloud_graph_host_name,
        msGraphHost: authCodePayload?.msgraph_host,
        nativeAccountId: nativeAccountId
    }, authority, base64Decode);
    const tenantProfiles = baseAccount.tenantProfiles || [];
    const tenantId = claimsTenantId || baseAccount.realm;
    if (tenantId && !tenantProfiles.find((tenantProfile)=>{
        return tenantProfile.tenantId === tenantId;
    })) {
        const newTenantProfile = (0, $2b6041b9fe3f70e1$export$924857724cb21ba4)(homeAccountId, baseAccount.localAccountId, tenantId, idTokenClaims);
        tenantProfiles.push(newTenantProfile);
    }
    baseAccount.tenantProfiles = tenantProfiles;
    return baseAccount;
}













/*! @azure/msal-common v14.16.1 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ async function $5bf8ef87a233da43$export$620d3a93bf8b59fb(clientAssertion, clientId, tokenEndpoint) {
    if (typeof clientAssertion === "string") return clientAssertion;
    else {
        const config = {
            clientId: clientId,
            tokenEndpoint: tokenEndpoint
        };
        return clientAssertion(config);
    }
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Oauth2.0 Authorization Code client
 * @internal
 */ class $402bc6236039ff02$export$8538731fd397fb90 extends (0, $ed3742a5fca7e3cb$export$4f22f74eddb7716a) {
    constructor(configuration, performanceClient){
        super(configuration, performanceClient);
        // Flag to indicate if client is for hybrid spa auth code redemption
        this.includeRedirectUri = true;
        this.oidcDefaultScopes = this.config.authOptions.authority.options.OIDCOptions?.defaultScopes;
    }
    /**
     * Creates the URL of the authorization request letting the user input credentials and consent to the
     * application. The URL target the /authorize endpoint of the authority configured in the
     * application object.
     *
     * Once the user inputs their credentials and consents, the authority will send a response to the redirect URI
     * sent in the request and should contain an authorization code, which can then be used to acquire tokens via
     * acquireToken(AuthorizationCodeRequest)
     * @param request
     */ async getAuthCodeUrl(request) {
        this.performanceClient?.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).GetAuthCodeUrl, request.correlationId);
        const queryString = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.createAuthCodeUrlQueryString.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).AuthClientCreateQueryString, this.logger, this.performanceClient, request.correlationId)(request);
        return (0, $ff2860ddbc741970$export$3abcdca7229e54f2).appendQueryString(this.authority.authorizationEndpoint, queryString);
    }
    /**
     * API to acquire a token in exchange of 'authorization_code` acquired by the user in the first leg of the
     * authorization_code_grant
     * @param request
     */ async acquireToken(request, authCodePayload) {
        this.performanceClient?.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).AuthClientAcquireToken, request.correlationId);
        if (!request.code) throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$4ac9fb1f531eded7));
        const reqTimestamp = (0, $7dce75f27affa532$export$ae62599a119ac50a)();
        const response = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.executeTokenRequest.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).AuthClientExecuteTokenRequest, this.logger, this.performanceClient, request.correlationId)(this.authority, request);
        // Retrieve requestId from response headers
        const requestId = response.headers?.[(0, $08c107807d753255$export$28d77f87efed1d88).X_MS_REQUEST_ID];
        const responseHandler = new (0, $85344044ef39ab89$export$f456c9835cc63582)(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.config.serializableCache, this.config.persistencePlugin, this.performanceClient);
        // Validate response. This function throws a server error if an error is returned by the server.
        responseHandler.validateTokenResponse(response.body);
        return (0, $4832f15bf602f56d$export$e4feded94d9adb18)(responseHandler.handleServerTokenResponse.bind(responseHandler), (0, $32170abc11155933$export$2f2811a3e1b21823).HandleServerTokenResponse, this.logger, this.performanceClient, request.correlationId)(response.body, this.authority, reqTimestamp, request, authCodePayload, undefined, undefined, undefined, requestId);
    }
    /**
     * Handles the hash fragment response from public client code request. Returns a code response used by
     * the client to exchange for a token in acquireToken.
     * @param hashFragment
     */ handleFragmentResponse(serverParams, cachedState) {
        // Handle responses.
        const responseHandler = new (0, $85344044ef39ab89$export$f456c9835cc63582)(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, null, null);
        // Get code response
        responseHandler.validateServerAuthorizationCodeResponse(serverParams, cachedState);
        // throw when there is no auth code in the response
        if (!serverParams.code) throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$93625fc864d26bba));
        return serverParams;
    }
    /**
     * Used to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param authorityUri
     */ getLogoutUri(logoutRequest) {
        // Throw error if logoutRequest is null/undefined
        if (!logoutRequest) throw (0, $a6f096219dc1b547$export$5d63d098f4f130a1)((0, $f66a3d6fc9f2eb73$export$9eb2eeb401492d88));
        const queryString = this.createLogoutUrlQueryString(logoutRequest);
        // Construct logout URI
        return (0, $ff2860ddbc741970$export$3abcdca7229e54f2).appendQueryString(this.authority.endSessionEndpoint, queryString);
    }
    /**
     * Executes POST request to token endpoint
     * @param authority
     * @param request
     */ async executeTokenRequest(authority, request) {
        this.performanceClient?.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).AuthClientExecuteTokenRequest, request.correlationId);
        const queryParametersString = this.createTokenQueryParameters(request);
        const endpoint = (0, $ff2860ddbc741970$export$3abcdca7229e54f2).appendQueryString(authority.tokenEndpoint, queryParametersString);
        const requestBody = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.createTokenRequestBody.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).AuthClientCreateTokenRequestBody, this.logger, this.performanceClient, request.correlationId)(request);
        let ccsCredential = undefined;
        if (request.clientInfo) try {
            const clientInfo = (0, $8647f63f1ec6244a$export$575e1419cfbab7f8)(request.clientInfo, this.cryptoUtils.base64Decode);
            ccsCredential = {
                credential: `${clientInfo.uid}${(0, $08c107807d753255$export$520854da2ba5d734).CLIENT_INFO_SEPARATOR}${clientInfo.utid}`,
                type: (0, $36f32d37ad76b0c5$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
            };
        } catch (e) {
            this.logger.verbose("Could not parse client info for CCS Header: " + e);
        }
        const headers = this.createTokenRequestHeaders(ccsCredential || request.ccsCredential);
        const thumbprint = {
            clientId: request.tokenBodyParameters?.clientId || this.config.authOptions.clientId,
            authority: authority.canonicalAuthority,
            scopes: request.scopes,
            claims: request.claims,
            authenticationScheme: request.authenticationScheme,
            resourceRequestMethod: request.resourceRequestMethod,
            resourceRequestUri: request.resourceRequestUri,
            shrClaims: request.shrClaims,
            sshKid: request.sshKid
        };
        return (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.executePostToTokenEndpoint.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).AuthorizationCodeClientExecutePostToTokenEndpoint, this.logger, this.performanceClient, request.correlationId)(endpoint, requestBody, headers, thumbprint, request.correlationId, (0, $32170abc11155933$export$2f2811a3e1b21823).AuthorizationCodeClientExecutePostToTokenEndpoint);
    }
    /**
     * Generates a map for all the params to be sent to the service
     * @param request
     */ async createTokenRequestBody(request) {
        this.performanceClient?.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).AuthClientCreateTokenRequestBody, request.correlationId);
        const parameterBuilder = new (0, $b2fdab17beec58b6$export$882078dd8a9e0bfa)(request.correlationId, this.performanceClient);
        parameterBuilder.addClientId(request.embeddedClientId || request.tokenBodyParameters?.[0, $fd2f81929f856dad$export$c7b1b63f5b60f8e] || this.config.authOptions.clientId);
        /*
         * For hybrid spa flow, there will be a code but no verifier
         * In this scenario, don't include redirect uri as auth code will not be bound to redirect URI
         */ if (!this.includeRedirectUri) // Just validate
        (0, $ebac5c31cde45bb3$export$9800b929b6984365).validateRedirectUri(request.redirectUri);
        else // Validate and include redirect uri
        parameterBuilder.addRedirectUri(request.redirectUri);
        // Add scope array, parameter builder will add default scopes and dedupe
        parameterBuilder.addScopes(request.scopes, true, this.oidcDefaultScopes);
        // add code: user set, not validated
        parameterBuilder.addAuthorizationCode(request.code);
        // Add library metadata
        parameterBuilder.addLibraryInfo(this.config.libraryInfo);
        parameterBuilder.addApplicationTelemetry(this.config.telemetry.application);
        parameterBuilder.addThrottling();
        if (this.serverTelemetryManager && !(0, $44a243886d8c290a$export$25afa7198c2ed9b9)(this.config)) parameterBuilder.addServerTelemetry(this.serverTelemetryManager);
        // add code_verifier if passed
        if (request.codeVerifier) parameterBuilder.addCodeVerifier(request.codeVerifier);
        if (this.config.clientCredentials.clientSecret) parameterBuilder.addClientSecret(this.config.clientCredentials.clientSecret);
        if (this.config.clientCredentials.clientAssertion) {
            const clientAssertion = this.config.clientCredentials.clientAssertion;
            parameterBuilder.addClientAssertion(await (0, $5bf8ef87a233da43$export$620d3a93bf8b59fb)(clientAssertion.assertion, this.config.authOptions.clientId, request.resourceRequestUri));
            parameterBuilder.addClientAssertionType(clientAssertion.assertionType);
        }
        parameterBuilder.addGrantType((0, $08c107807d753255$export$ce68f19b50b39c0b).AUTHORIZATION_CODE_GRANT);
        parameterBuilder.addClientInfo();
        if (request.authenticationScheme === (0, $08c107807d753255$export$901491a717da2ba5).POP) {
            const popTokenGenerator = new (0, $a427aceea5cc6ef6$export$3dd8467151c83e3e)(this.cryptoUtils, this.performanceClient);
            let reqCnfData;
            if (!request.popKid) {
                const generatedReqCnfData = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(popTokenGenerator.generateCnf.bind(popTokenGenerator), (0, $32170abc11155933$export$2f2811a3e1b21823).PopTokenGenerateCnf, this.logger, this.performanceClient, request.correlationId)(request, this.logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
            } else reqCnfData = this.cryptoUtils.encodeKid(request.popKid);
            // SPA PoP requires full Base64Url encoded req_cnf string (unhashed)
            parameterBuilder.addPopToken(reqCnfData);
        } else if (request.authenticationScheme === (0, $08c107807d753255$export$901491a717da2ba5).SSH) {
            if (request.sshJwk) parameterBuilder.addSshJwk(request.sshJwk);
            else throw (0, $a6f096219dc1b547$export$5d63d098f4f130a1)((0, $f66a3d6fc9f2eb73$export$8fbed44b22d9136f));
        }
        if (!(0, $5d9dc3fc4be02ef2$export$ecc754f99843e759).isEmptyObj(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) parameterBuilder.addClaims(request.claims, this.config.authOptions.clientCapabilities);
        let ccsCred = undefined;
        if (request.clientInfo) try {
            const clientInfo = (0, $8647f63f1ec6244a$export$575e1419cfbab7f8)(request.clientInfo, this.cryptoUtils.base64Decode);
            ccsCred = {
                credential: `${clientInfo.uid}${(0, $08c107807d753255$export$520854da2ba5d734).CLIENT_INFO_SEPARATOR}${clientInfo.utid}`,
                type: (0, $36f32d37ad76b0c5$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
            };
        } catch (e) {
            this.logger.verbose("Could not parse client info for CCS Header: " + e);
        }
        else ccsCred = request.ccsCredential;
        // Adds these as parameters in the request instead of headers to prevent CORS preflight request
        if (this.config.systemOptions.preventCorsPreflight && ccsCred) switch(ccsCred.type){
            case (0, $36f32d37ad76b0c5$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID:
                try {
                    const clientInfo = (0, $8647f63f1ec6244a$export$63508a6d6b7dbe07)(ccsCred.credential);
                    parameterBuilder.addCcsOid(clientInfo);
                } catch (e) {
                    this.logger.verbose("Could not parse home account ID for CCS Header: " + e);
                }
                break;
            case (0, $36f32d37ad76b0c5$export$17b7b3ac1abef49f).UPN:
                parameterBuilder.addCcsUpn(ccsCred.credential);
                break;
        }
        if (request.embeddedClientId) parameterBuilder.addBrokerParameters({
            brokerClientId: this.config.authOptions.clientId,
            brokerRedirectUri: this.config.authOptions.redirectUri
        });
        if (request.tokenBodyParameters) parameterBuilder.addExtraQueryParameters(request.tokenBodyParameters);
        // Add hybrid spa parameters if not already provided
        if (request.enableSpaAuthorizationCode && (!request.tokenBodyParameters || !request.tokenBodyParameters[0, $fd2f81929f856dad$export$f58b98a40c1faa68])) parameterBuilder.addExtraQueryParameters({
            [(0, $fd2f81929f856dad$export$f58b98a40c1faa68)]: "1"
        });
        return parameterBuilder.createQueryString();
    }
    /**
     * This API validates the `AuthorizationCodeUrlRequest` and creates a URL
     * @param request
     */ async createAuthCodeUrlQueryString(request) {
        // generate the correlationId if not set by the user and add
        const correlationId = request.correlationId || this.config.cryptoInterface.createNewGuid();
        this.performanceClient?.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).AuthClientCreateQueryString, correlationId);
        const parameterBuilder = new (0, $b2fdab17beec58b6$export$882078dd8a9e0bfa)(correlationId, this.performanceClient);
        parameterBuilder.addClientId(request.embeddedClientId || request.extraQueryParameters?.[0, $fd2f81929f856dad$export$c7b1b63f5b60f8e] || this.config.authOptions.clientId);
        const requestScopes = [
            ...request.scopes || [],
            ...request.extraScopesToConsent || []
        ];
        parameterBuilder.addScopes(requestScopes, true, this.oidcDefaultScopes);
        // validate the redirectUri (to be a non null value)
        parameterBuilder.addRedirectUri(request.redirectUri);
        parameterBuilder.addCorrelationId(correlationId);
        // add response_mode. If not passed in it defaults to query.
        parameterBuilder.addResponseMode(request.responseMode);
        // add response_type = code
        parameterBuilder.addResponseTypeCode();
        // add library info parameters
        parameterBuilder.addLibraryInfo(this.config.libraryInfo);
        if (!(0, $44a243886d8c290a$export$25afa7198c2ed9b9)(this.config)) parameterBuilder.addApplicationTelemetry(this.config.telemetry.application);
        // add client_info=1
        parameterBuilder.addClientInfo();
        if (request.codeChallenge && request.codeChallengeMethod) parameterBuilder.addCodeChallengeParams(request.codeChallenge, request.codeChallengeMethod);
        if (request.prompt) parameterBuilder.addPrompt(request.prompt);
        if (request.domainHint) parameterBuilder.addDomainHint(request.domainHint);
        // Add sid or loginHint with preference for login_hint claim (in request) -> sid -> loginHint (upn/email) -> username of AccountInfo object
        if (request.prompt !== (0, $08c107807d753255$export$49a06cbda5acaa5).SELECT_ACCOUNT) {
            // AAD will throw if prompt=select_account is passed with an account hint
            if (request.sid && request.prompt === (0, $08c107807d753255$export$49a06cbda5acaa5).NONE) {
                // SessionID is only used in silent calls
                this.logger.verbose("createAuthCodeUrlQueryString: Prompt is none, adding sid from request");
                parameterBuilder.addSid(request.sid);
            } else if (request.account) {
                const accountSid = this.extractAccountSid(request.account);
                let accountLoginHintClaim = this.extractLoginHint(request.account);
                if (accountLoginHintClaim && request.domainHint) {
                    this.logger.warning(`AuthorizationCodeClient.createAuthCodeUrlQueryString: "domainHint" param is set, skipping opaque "login_hint" claim. Please consider not passing domainHint`);
                    accountLoginHintClaim = null;
                }
                // If login_hint claim is present, use it over sid/username
                if (accountLoginHintClaim) {
                    this.logger.verbose("createAuthCodeUrlQueryString: login_hint claim present on account");
                    parameterBuilder.addLoginHint(accountLoginHintClaim);
                    try {
                        const clientInfo = (0, $8647f63f1ec6244a$export$63508a6d6b7dbe07)(request.account.homeAccountId);
                        parameterBuilder.addCcsOid(clientInfo);
                    } catch (e) {
                        this.logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header");
                    }
                } else if (accountSid && request.prompt === (0, $08c107807d753255$export$49a06cbda5acaa5).NONE) {
                    /*
                     * If account and loginHint are provided, we will check account first for sid before adding loginHint
                     * SessionId is only used in silent calls
                     */ this.logger.verbose("createAuthCodeUrlQueryString: Prompt is none, adding sid from account");
                    parameterBuilder.addSid(accountSid);
                    try {
                        const clientInfo = (0, $8647f63f1ec6244a$export$63508a6d6b7dbe07)(request.account.homeAccountId);
                        parameterBuilder.addCcsOid(clientInfo);
                    } catch (e) {
                        this.logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header");
                    }
                } else if (request.loginHint) {
                    this.logger.verbose("createAuthCodeUrlQueryString: Adding login_hint from request");
                    parameterBuilder.addLoginHint(request.loginHint);
                    parameterBuilder.addCcsUpn(request.loginHint);
                } else if (request.account.username) {
                    // Fallback to account username if provided
                    this.logger.verbose("createAuthCodeUrlQueryString: Adding login_hint from account");
                    parameterBuilder.addLoginHint(request.account.username);
                    try {
                        const clientInfo = (0, $8647f63f1ec6244a$export$63508a6d6b7dbe07)(request.account.homeAccountId);
                        parameterBuilder.addCcsOid(clientInfo);
                    } catch (e) {
                        this.logger.verbose("createAuthCodeUrlQueryString: Could not parse home account ID for CCS Header");
                    }
                }
            } else if (request.loginHint) {
                this.logger.verbose("createAuthCodeUrlQueryString: No account, adding login_hint from request");
                parameterBuilder.addLoginHint(request.loginHint);
                parameterBuilder.addCcsUpn(request.loginHint);
            }
        } else this.logger.verbose("createAuthCodeUrlQueryString: Prompt is select_account, ignoring account hints");
        if (request.nonce) parameterBuilder.addNonce(request.nonce);
        if (request.state) parameterBuilder.addState(request.state);
        if (request.claims || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) parameterBuilder.addClaims(request.claims, this.config.authOptions.clientCapabilities);
        if (request.embeddedClientId) parameterBuilder.addBrokerParameters({
            brokerClientId: this.config.authOptions.clientId,
            brokerRedirectUri: this.config.authOptions.redirectUri
        });
        this.addExtraQueryParams(request, parameterBuilder);
        if (request.nativeBroker) {
            // signal ests that this is a WAM call
            parameterBuilder.addNativeBroker();
            // pass the req_cnf for POP
            if (request.authenticationScheme === (0, $08c107807d753255$export$901491a717da2ba5).POP) {
                const popTokenGenerator = new (0, $a427aceea5cc6ef6$export$3dd8467151c83e3e)(this.cryptoUtils);
                // req_cnf is always sent as a string for SPAs
                let reqCnfData;
                if (!request.popKid) {
                    const generatedReqCnfData = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(popTokenGenerator.generateCnf.bind(popTokenGenerator), (0, $32170abc11155933$export$2f2811a3e1b21823).PopTokenGenerateCnf, this.logger, this.performanceClient, request.correlationId)(request, this.logger);
                    reqCnfData = generatedReqCnfData.reqCnfString;
                } else reqCnfData = this.cryptoUtils.encodeKid(request.popKid);
                parameterBuilder.addPopToken(reqCnfData);
            }
        }
        return parameterBuilder.createQueryString();
    }
    /**
     * This API validates the `EndSessionRequest` and creates a URL
     * @param request
     */ createLogoutUrlQueryString(request) {
        const parameterBuilder = new (0, $b2fdab17beec58b6$export$882078dd8a9e0bfa)(request.correlationId, this.performanceClient);
        if (request.postLogoutRedirectUri) parameterBuilder.addPostLogoutRedirectUri(request.postLogoutRedirectUri);
        if (request.correlationId) parameterBuilder.addCorrelationId(request.correlationId);
        if (request.idTokenHint) parameterBuilder.addIdTokenHint(request.idTokenHint);
        if (request.state) parameterBuilder.addState(request.state);
        if (request.logoutHint) parameterBuilder.addLogoutHint(request.logoutHint);
        this.addExtraQueryParams(request, parameterBuilder);
        return parameterBuilder.createQueryString();
    }
    addExtraQueryParams(request, parameterBuilder) {
        const hasRequestInstanceAware = request.extraQueryParameters && request.extraQueryParameters.hasOwnProperty("instance_aware");
        // Set instance_aware flag if config auth param is set
        if (!hasRequestInstanceAware && this.config.authOptions.instanceAware) {
            request.extraQueryParameters = request.extraQueryParameters || {};
            request.extraQueryParameters["instance_aware"] = "true";
        }
        if (request.extraQueryParameters) parameterBuilder.addExtraQueryParameters(request.extraQueryParameters);
    }
    /**
     * Helper to get sid from account. Returns null if idTokenClaims are not present or sid is not present.
     * @param account
     */ extractAccountSid(account) {
        return account.idTokenClaims?.sid || null;
    }
    extractLoginHint(account) {
        return account.idTokenClaims?.login_hint || null;
    }
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ /*! @azure/msal-common v14.16.1 2025-08-05 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $2dbd37583ce105ee$var$skuGroupSeparator = ",";
const $2dbd37583ce105ee$var$skuValueSeparator = "|";
function $2dbd37583ce105ee$var$makeExtraSkuString(params) {
    const { skus: skus, libraryName: libraryName, libraryVersion: libraryVersion, extensionName: extensionName, extensionVersion: extensionVersion } = params;
    const skuMap = new Map([
        [
            0,
            [
                libraryName,
                libraryVersion
            ]
        ],
        [
            2,
            [
                extensionName,
                extensionVersion
            ]
        ]
    ]);
    let skuArr = [];
    if (skus?.length) {
        skuArr = skus.split($2dbd37583ce105ee$var$skuGroupSeparator);
        // Ignore invalid input sku param
        if (skuArr.length < 4) return skus;
    } else skuArr = Array.from({
        length: 4
    }, ()=>$2dbd37583ce105ee$var$skuValueSeparator);
    skuMap.forEach((value, key)=>{
        if (value.length === 2 && value[0]?.length && value[1]?.length) $2dbd37583ce105ee$var$setSku({
            skuArr: skuArr,
            index: key,
            skuName: value[0],
            skuVersion: value[1]
        });
    });
    return skuArr.join($2dbd37583ce105ee$var$skuGroupSeparator);
}
function $2dbd37583ce105ee$var$setSku(params) {
    const { skuArr: skuArr, index: index, skuName: skuName, skuVersion: skuVersion } = params;
    if (index >= skuArr.length) return;
    skuArr[index] = [
        skuName,
        skuVersion
    ].join($2dbd37583ce105ee$var$skuValueSeparator);
}
/** @internal */ class $2dbd37583ce105ee$export$bddbbc43a3ca9c53 {
    constructor(telemetryRequest, cacheManager){
        this.cacheOutcome = (0, $08c107807d753255$export$aa4af185ea049f6b).NOT_APPLICABLE;
        this.cacheManager = cacheManager;
        this.apiId = telemetryRequest.apiId;
        this.correlationId = telemetryRequest.correlationId;
        this.wrapperSKU = telemetryRequest.wrapperSKU || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING;
        this.wrapperVer = telemetryRequest.wrapperVer || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING;
        this.telemetryCacheKey = (0, $08c107807d753255$export$30fa4ad28fb9feeb).CACHE_KEY + (0, $08c107807d753255$export$520854da2ba5d734).CACHE_KEY_SEPARATOR + telemetryRequest.clientId;
    }
    /**
     * API to add MSER Telemetry to request
     */ generateCurrentRequestHeaderValue() {
        const request = `${this.apiId}${(0, $08c107807d753255$export$30fa4ad28fb9feeb).VALUE_SEPARATOR}${this.cacheOutcome}`;
        const platformFieldsArr = [
            this.wrapperSKU,
            this.wrapperVer
        ];
        const nativeBrokerErrorCode = this.getNativeBrokerErrorCode();
        if (nativeBrokerErrorCode?.length) platformFieldsArr.push(`broker_error=${nativeBrokerErrorCode}`);
        const platformFields = platformFieldsArr.join((0, $08c107807d753255$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        const regionDiscoveryFields = this.getRegionDiscoveryFields();
        const requestWithRegionDiscoveryFields = [
            request,
            regionDiscoveryFields
        ].join((0, $08c107807d753255$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        return [
            (0, $08c107807d753255$export$30fa4ad28fb9feeb).SCHEMA_VERSION,
            requestWithRegionDiscoveryFields,
            platformFields
        ].join((0, $08c107807d753255$export$30fa4ad28fb9feeb).CATEGORY_SEPARATOR);
    }
    /**
     * API to add MSER Telemetry for the last failed request
     */ generateLastRequestHeaderValue() {
        const lastRequests = this.getLastRequests();
        const maxErrors = $2dbd37583ce105ee$export$bddbbc43a3ca9c53.maxErrorsToSend(lastRequests);
        const failedRequests = lastRequests.failedRequests.slice(0, 2 * maxErrors).join((0, $08c107807d753255$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        const errors = lastRequests.errors.slice(0, maxErrors).join((0, $08c107807d753255$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        const errorCount = lastRequests.errors.length;
        // Indicate whether this header contains all data or partial data
        const overflow = maxErrors < errorCount ? (0, $08c107807d753255$export$30fa4ad28fb9feeb).OVERFLOW_TRUE : (0, $08c107807d753255$export$30fa4ad28fb9feeb).OVERFLOW_FALSE;
        const platformFields = [
            errorCount,
            overflow
        ].join((0, $08c107807d753255$export$30fa4ad28fb9feeb).VALUE_SEPARATOR);
        return [
            (0, $08c107807d753255$export$30fa4ad28fb9feeb).SCHEMA_VERSION,
            lastRequests.cacheHits,
            failedRequests,
            errors,
            platformFields
        ].join((0, $08c107807d753255$export$30fa4ad28fb9feeb).CATEGORY_SEPARATOR);
    }
    /**
     * API to cache token failures for MSER data capture
     * @param error
     */ cacheFailedRequest(error) {
        const lastRequests = this.getLastRequests();
        if (lastRequests.errors.length >= (0, $08c107807d753255$export$30fa4ad28fb9feeb).MAX_CACHED_ERRORS) {
            // Remove a cached error to make room, first in first out
            lastRequests.failedRequests.shift(); // apiId
            lastRequests.failedRequests.shift(); // correlationId
            lastRequests.errors.shift();
        }
        lastRequests.failedRequests.push(this.apiId, this.correlationId);
        if (error instanceof Error && !!error && error.toString()) {
            if (error instanceof (0, $53b49d8334c1646a$export$145273558d58e0ac)) {
                if (error.subError) lastRequests.errors.push(error.subError);
                else if (error.errorCode) lastRequests.errors.push(error.errorCode);
                else lastRequests.errors.push(error.toString());
            } else lastRequests.errors.push(error.toString());
        } else lastRequests.errors.push((0, $08c107807d753255$export$30fa4ad28fb9feeb).UNKNOWN_ERROR);
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests, this.correlationId);
        return;
    }
    /**
     * Update server telemetry cache entry by incrementing cache hit counter
     */ incrementCacheHits() {
        const lastRequests = this.getLastRequests();
        lastRequests.cacheHits += 1;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests, this.correlationId);
        return lastRequests.cacheHits;
    }
    /**
     * Get the server telemetry entity from cache or initialize a new one
     */ getLastRequests() {
        const initialValue = {
            failedRequests: [],
            errors: [],
            cacheHits: 0
        };
        const lastRequests = this.cacheManager.getServerTelemetry(this.telemetryCacheKey);
        return lastRequests || initialValue;
    }
    /**
     * Remove server telemetry cache entry
     */ clearTelemetryCache() {
        const lastRequests = this.getLastRequests();
        const numErrorsFlushed = $2dbd37583ce105ee$export$bddbbc43a3ca9c53.maxErrorsToSend(lastRequests);
        const errorCount = lastRequests.errors.length;
        if (numErrorsFlushed === errorCount) // All errors were sent on last request, clear Telemetry cache
        this.cacheManager.removeItem(this.telemetryCacheKey, this.correlationId);
        else {
            // Partial data was flushed to server, construct a new telemetry cache item with errors that were not flushed
            const serverTelemEntity = {
                failedRequests: lastRequests.failedRequests.slice(numErrorsFlushed * 2),
                errors: lastRequests.errors.slice(numErrorsFlushed),
                cacheHits: 0
            };
            this.cacheManager.setServerTelemetry(this.telemetryCacheKey, serverTelemEntity, this.correlationId);
        }
    }
    /**
     * Returns the maximum number of errors that can be flushed to the server in the next network request
     * @param serverTelemetryEntity
     */ static maxErrorsToSend(serverTelemetryEntity) {
        let i;
        let maxErrors = 0;
        let dataSize = 0;
        const errorCount = serverTelemetryEntity.errors.length;
        for(i = 0; i < errorCount; i++){
            // failedRequests parameter contains pairs of apiId and correlationId, multiply index by 2 to preserve pairs
            const apiId = serverTelemetryEntity.failedRequests[2 * i] || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING;
            const correlationId = serverTelemetryEntity.failedRequests[2 * i + 1] || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING;
            const errorCode = serverTelemetryEntity.errors[i] || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING;
            // Count number of characters that would be added to header, each character is 1 byte. Add 3 at the end to account for separators
            dataSize += apiId.toString().length + correlationId.toString().length + errorCode.length + 3;
            if (dataSize < (0, $08c107807d753255$export$30fa4ad28fb9feeb).MAX_LAST_HEADER_BYTES) // Adding this entry to the header would still keep header size below the limit
            maxErrors += 1;
            else break;
        }
        return maxErrors;
    }
    /**
     * Get the region discovery fields
     *
     * @returns string
     */ getRegionDiscoveryFields() {
        const regionDiscoveryFields = [];
        regionDiscoveryFields.push(this.regionUsed || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING);
        regionDiscoveryFields.push(this.regionSource || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING);
        regionDiscoveryFields.push(this.regionOutcome || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING);
        return regionDiscoveryFields.join(",");
    }
    /**
     * Update the region discovery metadata
     *
     * @param regionDiscoveryMetadata
     * @returns void
     */ updateRegionDiscoveryMetadata(regionDiscoveryMetadata) {
        this.regionUsed = regionDiscoveryMetadata.region_used;
        this.regionSource = regionDiscoveryMetadata.region_source;
        this.regionOutcome = regionDiscoveryMetadata.region_outcome;
    }
    /**
     * Set cache outcome
     */ setCacheOutcome(cacheOutcome) {
        this.cacheOutcome = cacheOutcome;
    }
    setNativeBrokerErrorCode(errorCode) {
        const lastRequests = this.getLastRequests();
        lastRequests.nativeBrokerErrorCode = errorCode;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests, this.correlationId);
    }
    getNativeBrokerErrorCode() {
        return this.getLastRequests().nativeBrokerErrorCode;
    }
    clearNativeBrokerErrorCode() {
        const lastRequests = this.getLastRequests();
        delete lastRequests.nativeBrokerErrorCode;
        this.cacheManager.setServerTelemetry(this.telemetryCacheKey, lastRequests, this.correlationId);
    }
    static makeExtraSkuString(params) {
        return $2dbd37583ce105ee$var$makeExtraSkuString(params);
    }
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $e667915c70089a10$export$d858565f81c03f1f {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeMessageHandler, correlationId){
        this.config = config;
        this.browserStorage = storageImpl;
        this.browserCrypto = browserCrypto;
        this.networkClient = this.config.system.networkClient;
        this.eventHandler = eventHandler;
        this.navigationClient = navigationClient;
        this.nativeMessageHandler = nativeMessageHandler;
        this.correlationId = correlationId || (0, $b512579b1150f905$export$6ef0355fa80a5278)();
        this.logger = logger.clone((0, $091acf4c2675819b$export$a0a689e4294b9880).MSAL_SKU, (0, $f42d0d3ccc24f1b6$export$83d89fbfd8236492), this.correlationId);
        this.performanceClient = performanceClient;
    }
    async clearCacheOnLogout(account) {
        if (account) {
            if ((0, $35a4414ce05ac30e$export$680160523e6bfa6a).accountInfoIsEqual(account, this.browserStorage.getActiveAccount(this.correlationId), false)) {
                this.logger.verbose("Setting active account to null");
                this.browserStorage.setActiveAccount(null, this.correlationId);
            }
            // Clear given account.
            try {
                await this.browserStorage.removeAccount((0, $35a4414ce05ac30e$export$680160523e6bfa6a).generateAccountCacheKey(account), this.correlationId);
                this.logger.verbose("Cleared cache items belonging to the account provided in the logout request.");
            } catch (error) {
                this.logger.error("Account provided in logout request was not found. Local cache unchanged.");
            }
        } else try {
            this.logger.verbose("No account provided in logout request, clearing all cache items.", this.correlationId);
            // Clear all accounts and tokens
            await this.browserStorage.clear(this.correlationId);
            // Clear any stray keys from IndexedDB
            await this.browserCrypto.clearKeystore();
        } catch (e) {
            this.logger.error("Attempted to clear all MSAL cache items and failed. Local cache unchanged.");
        }
    }
    /**
     *
     * Use to get the redirect uri configured in MSAL or null.
     * @param requestRedirectUri
     * @returns Redirect URL
     *
     */ getRedirectUri(requestRedirectUri) {
        this.logger.verbose("getRedirectUri called");
        const redirectUri = requestRedirectUri || this.config.auth.redirectUri;
        return (0, $ff2860ddbc741970$export$3abcdca7229e54f2).getAbsoluteUrl(redirectUri, (0, $deacecf435b3f5ad$export$1204531fbbf6ecde)());
    }
    /**
     *
     * @param apiId
     * @param correlationId
     * @param forceRefresh
     */ initializeServerTelemetryManager(apiId, forceRefresh) {
        this.logger.verbose("initializeServerTelemetryManager called");
        const telemetryPayload = {
            clientId: this.config.auth.clientId,
            correlationId: this.correlationId,
            apiId: apiId,
            forceRefresh: forceRefresh || false,
            wrapperSKU: this.browserStorage.getWrapperMetadata()[0],
            wrapperVer: this.browserStorage.getWrapperMetadata()[1]
        };
        return new (0, $2dbd37583ce105ee$export$bddbbc43a3ca9c53)(telemetryPayload, this.browserStorage);
    }
    /**
     * Used to get a discovered version of the default authority.
     * @param params {
     *         requestAuthority?: string;
     *         requestAzureCloudOptions?: AzureCloudOptions;
     *         requestExtraQueryParameters?: StringDict;
     *         account?: AccountInfo;
     *        }
     */ async getDiscoveredAuthority(params) {
        const { account: account } = params;
        const instanceAwareEQ = params.requestExtraQueryParameters && params.requestExtraQueryParameters.hasOwnProperty("instance_aware") ? params.requestExtraQueryParameters["instance_aware"] : undefined;
        this.performanceClient.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.correlationId);
        const authorityOptions = {
            protocolMode: this.config.auth.protocolMode,
            OIDCOptions: this.config.auth.OIDCOptions,
            knownAuthorities: this.config.auth.knownAuthorities,
            cloudDiscoveryMetadata: this.config.auth.cloudDiscoveryMetadata,
            authorityMetadata: this.config.auth.authorityMetadata,
            skipAuthorityMetadataCache: this.config.auth.skipAuthorityMetadataCache
        };
        // build authority string based on auth params, precedence - azureCloudInstance + tenant >> authority
        const resolvedAuthority = params.requestAuthority || this.config.auth.authority;
        const resolvedInstanceAware = instanceAwareEQ?.length ? instanceAwareEQ === "true" : this.config.auth.instanceAware;
        const userAuthority = account && resolvedInstanceAware ? this.config.auth.authority.replace((0, $ff2860ddbc741970$export$3abcdca7229e54f2).getDomainFromUrl(resolvedAuthority), account.environment) : resolvedAuthority;
        // fall back to the authority from config
        const builtAuthority = (0, $dda2270c89fd90c8$export$f1c6ec2e6d68c49c).generateAuthority(userAuthority, params.requestAzureCloudOptions || this.config.auth.azureCloudOptions);
        const discoveredAuthority = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)((0, $386db2f829938631$exports).createDiscoveredInstance, (0, $32170abc11155933$export$2f2811a3e1b21823).AuthorityFactoryCreateDiscoveredInstance, this.logger, this.performanceClient, this.correlationId)(builtAuthority, this.config.system.networkClient, this.browserStorage, authorityOptions, this.logger, this.correlationId, this.performanceClient);
        if (account && !discoveredAuthority.isAlias(account.environment)) throw (0, $a6f096219dc1b547$export$5d63d098f4f130a1)((0, $f66a3d6fc9f2eb73$exports).authorityMismatch);
        return discoveredAuthority;
    }
}





/*! @azure/msal-browser v3.30.0 2025-08-05 */ 




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Constant byte array length
const $176e0b9269dc2056$var$RANDOM_BYTE_ARR_LENGTH = 32;
/**
 * This file defines APIs to generate PKCE codes and code verifiers.
 */ /**
 * Generates PKCE Codes. See the RFC for more information: https://tools.ietf.org/html/rfc7636
 */ async function $176e0b9269dc2056$export$91d5e5a023803853(performanceClient, logger, correlationId) {
    performanceClient.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).GeneratePkceCodes, correlationId);
    const codeVerifier = (0, $4832f15bf602f56d$export$468cda29b159ee5d)($176e0b9269dc2056$var$generateCodeVerifier, (0, $32170abc11155933$export$2f2811a3e1b21823).GenerateCodeVerifier, logger, performanceClient, correlationId)(performanceClient, logger, correlationId);
    const codeChallenge = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)($176e0b9269dc2056$var$generateCodeChallengeFromVerifier, (0, $32170abc11155933$export$2f2811a3e1b21823).GenerateCodeChallengeFromVerifier, logger, performanceClient, correlationId)(codeVerifier, performanceClient, logger, correlationId);
    return {
        verifier: codeVerifier,
        challenge: codeChallenge
    };
}
/**
 * Generates a random 32 byte buffer and returns the base64
 * encoded string to be used as a PKCE Code Verifier
 */ function $176e0b9269dc2056$var$generateCodeVerifier(performanceClient, logger, correlationId) {
    try {
        // Generate random values as utf-8
        const buffer = new Uint8Array($176e0b9269dc2056$var$RANDOM_BYTE_ARR_LENGTH);
        (0, $4832f15bf602f56d$export$468cda29b159ee5d)((0, $b512579b1150f905$export$960b9ff25e7d4257), (0, $32170abc11155933$export$2f2811a3e1b21823).GetRandomValues, logger, performanceClient, correlationId)(buffer);
        // encode verifier as base64
        const pkceCodeVerifierB64 = (0, $3665c4f98d09cc5b$export$84f5a428c7153a69)(buffer);
        return pkceCodeVerifierB64;
    } catch (e) {
        throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$ee549107fa376fc1));
    }
}
/**
 * Creates a base64 encoded PKCE Code Challenge string from the
 * hash created from the PKCE Code Verifier supplied
 */ async function $176e0b9269dc2056$var$generateCodeChallengeFromVerifier(pkceCodeVerifier, performanceClient, logger, correlationId) {
    performanceClient.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).GenerateCodeChallengeFromVerifier, correlationId);
    try {
        // hashed verifier
        const pkceHashedCodeVerifier = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)((0, $b512579b1150f905$export$52caff7bddbaf316), (0, $32170abc11155933$export$2f2811a3e1b21823).Sha256Digest, logger, performanceClient, correlationId)(pkceCodeVerifier, performanceClient, correlationId);
        // encode hash as base64
        return (0, $3665c4f98d09cc5b$export$84f5a428c7153a69)(new Uint8Array(pkceHashedCodeVerifier));
    } catch (e) {
        throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$ee549107fa376fc1));
    }
}



/*! @azure/msal-browser v3.30.0 2025-08-05 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Initializer function for all request APIs
 * @param request
 */ async function $4b44e4e159274463$export$8e461fcf1fd6910b(request, config, performanceClient, logger) {
    performanceClient.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).InitializeBaseRequest, request.correlationId);
    const authority = request.authority || config.auth.authority;
    const scopes = [
        ...request && request.scopes || []
    ];
    const validatedRequest = {
        ...request,
        correlationId: request.correlationId,
        authority: authority,
        scopes: scopes
    };
    // Set authenticationScheme to BEARER if not explicitly set in the request
    if (!validatedRequest.authenticationScheme) {
        validatedRequest.authenticationScheme = (0, $08c107807d753255$export$901491a717da2ba5).BEARER;
        logger.verbose('Authentication Scheme wasn\'t explicitly set in request, defaulting to "Bearer" request');
    } else {
        if (validatedRequest.authenticationScheme === (0, $08c107807d753255$export$901491a717da2ba5).SSH) {
            if (!request.sshJwk) throw (0, $a6f096219dc1b547$export$5d63d098f4f130a1)((0, $f66a3d6fc9f2eb73$exports).missingSshJwk);
            if (!request.sshKid) throw (0, $a6f096219dc1b547$export$5d63d098f4f130a1)((0, $f66a3d6fc9f2eb73$exports).missingSshKid);
        }
        logger.verbose(`Authentication Scheme set to "${validatedRequest.authenticationScheme}" as configured in Auth request`);
    }
    // Set requested claims hash if claims-based caching is enabled and claims were requested
    if (config.cache.claimsBasedCachingEnabled && request.claims && // Checks for empty stringified object "{}" which doesn't qualify as requested claims
    !(0, $5d9dc3fc4be02ef2$export$ecc754f99843e759).isEmptyObj(request.claims)) validatedRequest.requestedClaimsHash = await (0, $b512579b1150f905$export$9169be2e06c9c165)(request.claims);
    return validatedRequest;
}
async function $4b44e4e159274463$export$4c8aa78c426811d4(request, account, config, performanceClient, logger) {
    performanceClient.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).InitializeSilentRequest, request.correlationId);
    const baseRequest = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)($4b44e4e159274463$export$8e461fcf1fd6910b, (0, $32170abc11155933$export$2f2811a3e1b21823).InitializeBaseRequest, logger, performanceClient, request.correlationId)(request, config, performanceClient, logger);
    return {
        ...request,
        ...baseRequest,
        account: account,
        forceRefresh: request.forceRefresh || false
    };
}


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Defines the class structure and helper functions used by the "standard", non-brokered auth flows (popup, redirect, silent (RT), silent (iframe))
 */ class $e3650a1232c7da00$export$fa9179cade3eb05a extends (0, $e667915c70089a10$export$d858565f81c03f1f) {
    /**
     * Generates an auth code request tied to the url request.
     * @param request
     */ async initializeAuthorizationCodeRequest(request) {
        this.performanceClient.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationCodeRequest, this.correlationId);
        const generatedPkceParams = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)((0, $176e0b9269dc2056$export$91d5e5a023803853), (0, $32170abc11155933$export$2f2811a3e1b21823).GeneratePkceCodes, this.logger, this.performanceClient, this.correlationId)(this.performanceClient, this.logger, this.correlationId);
        const authCodeRequest = {
            ...request,
            redirectUri: request.redirectUri,
            code: (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING,
            codeVerifier: generatedPkceParams.verifier
        };
        request.codeChallenge = generatedPkceParams.challenge;
        request.codeChallengeMethod = (0, $08c107807d753255$export$a002182e51710d39).S256_CODE_CHALLENGE_METHOD;
        return authCodeRequest;
    }
    /**
     * Initializer for the logout request.
     * @param logoutRequest
     */ initializeLogoutRequest(logoutRequest) {
        this.logger.verbose("initializeLogoutRequest called", logoutRequest?.correlationId);
        const validLogoutRequest = {
            correlationId: this.correlationId || (0, $b512579b1150f905$export$6ef0355fa80a5278)(),
            ...logoutRequest
        };
        /**
         * Set logout_hint to be login_hint from ID Token Claims if present
         * and logoutHint attribute wasn't manually set in logout request
         */ if (logoutRequest) {
            // If logoutHint isn't set and an account was passed in, try to extract logoutHint from ID Token Claims
            if (!logoutRequest.logoutHint) {
                if (logoutRequest.account) {
                    const logoutHint = this.getLogoutHintFromIdTokenClaims(logoutRequest.account);
                    if (logoutHint) {
                        this.logger.verbose("Setting logoutHint to login_hint ID Token Claim value for the account provided");
                        validLogoutRequest.logoutHint = logoutHint;
                    }
                } else this.logger.verbose("logoutHint was not set and account was not passed into logout request, logoutHint will not be set");
            } else this.logger.verbose("logoutHint has already been set in logoutRequest");
        } else this.logger.verbose("logoutHint will not be set since no logout request was configured");
        /*
         * Only set redirect uri if logout request isn't provided or the set uri isn't null.
         * Otherwise, use passed uri, config, or current page.
         */ if (!logoutRequest || logoutRequest.postLogoutRedirectUri !== null) {
            if (logoutRequest && logoutRequest.postLogoutRedirectUri) {
                this.logger.verbose("Setting postLogoutRedirectUri to uri set on logout request", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = (0, $ff2860ddbc741970$export$3abcdca7229e54f2).getAbsoluteUrl(logoutRequest.postLogoutRedirectUri, (0, $deacecf435b3f5ad$export$1204531fbbf6ecde)());
            } else if (this.config.auth.postLogoutRedirectUri === null) this.logger.verbose("postLogoutRedirectUri configured as null and no uri set on request, not passing post logout redirect", validLogoutRequest.correlationId);
            else if (this.config.auth.postLogoutRedirectUri) {
                this.logger.verbose("Setting postLogoutRedirectUri to configured uri", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = (0, $ff2860ddbc741970$export$3abcdca7229e54f2).getAbsoluteUrl(this.config.auth.postLogoutRedirectUri, (0, $deacecf435b3f5ad$export$1204531fbbf6ecde)());
            } else {
                this.logger.verbose("Setting postLogoutRedirectUri to current page", validLogoutRequest.correlationId);
                validLogoutRequest.postLogoutRedirectUri = (0, $ff2860ddbc741970$export$3abcdca7229e54f2).getAbsoluteUrl((0, $deacecf435b3f5ad$export$1204531fbbf6ecde)(), (0, $deacecf435b3f5ad$export$1204531fbbf6ecde)());
            }
        } else this.logger.verbose("postLogoutRedirectUri passed as null, not setting post logout redirect uri", validLogoutRequest.correlationId);
        return validLogoutRequest;
    }
    /**
     * Parses login_hint ID Token Claim out of AccountInfo object to be used as
     * logout_hint in end session request.
     * @param account
     */ getLogoutHintFromIdTokenClaims(account) {
        const idTokenClaims = account.idTokenClaims;
        if (idTokenClaims) {
            if (idTokenClaims.login_hint) return idTokenClaims.login_hint;
            else this.logger.verbose("The ID Token Claims tied to the provided account do not contain a login_hint claim, logoutHint will not be added to logout request");
        } else this.logger.verbose("The provided account does not contain ID Token Claims, logoutHint will not be added to logout request");
        return null;
    }
    /**
     * Creates an Authorization Code Client with the given authority, or the default authority.
     * @param params {
     *         serverTelemetryManager: ServerTelemetryManager;
     *         authorityUrl?: string;
     *         requestAzureCloudOptions?: AzureCloudOptions;
     *         requestExtraQueryParameters?: StringDict;
     *         account?: AccountInfo;
     *        }
     */ async createAuthCodeClient(params) {
        this.performanceClient.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.correlationId);
        // Create auth module.
        const clientConfig = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.getClientConfiguration.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.logger, this.performanceClient, this.correlationId)(params);
        return new (0, $402bc6236039ff02$export$8538731fd397fb90)(clientConfig, this.performanceClient);
    }
    /**
     * Creates a Client Configuration object with the given request authority, or the default authority.
     * @param params {
     *         serverTelemetryManager: ServerTelemetryManager;
     *         requestAuthority?: string;
     *         requestAzureCloudOptions?: AzureCloudOptions;
     *         requestExtraQueryParameters?: boolean;
     *         account?: AccountInfo;
     *        }
     */ async getClientConfiguration(params) {
        const { serverTelemetryManager: serverTelemetryManager, requestAuthority: requestAuthority, requestAzureCloudOptions: requestAzureCloudOptions, requestExtraQueryParameters: requestExtraQueryParameters, account: account } = params;
        this.performanceClient.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.correlationId);
        const discoveredAuthority = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.getDiscoveredAuthority.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).StandardInteractionClientGetDiscoveredAuthority, this.logger, this.performanceClient, this.correlationId)({
            requestAuthority: requestAuthority,
            requestAzureCloudOptions: requestAzureCloudOptions,
            requestExtraQueryParameters: requestExtraQueryParameters,
            account: account
        });
        const logger = this.config.system.loggerOptions;
        return {
            authOptions: {
                clientId: this.config.auth.clientId,
                authority: discoveredAuthority,
                clientCapabilities: this.config.auth.clientCapabilities,
                redirectUri: this.config.auth.redirectUri
            },
            systemOptions: {
                tokenRenewalOffsetSeconds: this.config.system.tokenRenewalOffsetSeconds,
                preventCorsPreflight: true
            },
            loggerOptions: {
                loggerCallback: logger.loggerCallback,
                piiLoggingEnabled: logger.piiLoggingEnabled,
                logLevel: logger.logLevel,
                correlationId: this.correlationId
            },
            cacheOptions: {
                claimsBasedCachingEnabled: this.config.cache.claimsBasedCachingEnabled
            },
            cryptoInterface: this.browserCrypto,
            networkInterface: this.networkClient,
            storageInterface: this.browserStorage,
            serverTelemetryManager: serverTelemetryManager,
            libraryInfo: {
                sku: (0, $091acf4c2675819b$export$a0a689e4294b9880).MSAL_SKU,
                version: (0, $f42d0d3ccc24f1b6$export$83d89fbfd8236492),
                cpu: (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING,
                os: (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING
            },
            telemetry: this.config.telemetry
        };
    }
    /**
     * Helper to initialize required request parameters for interactive APIs and ssoSilent()
     * @param request
     * @param interactionType
     */ async initializeAuthorizationRequest(request, interactionType) {
        this.performanceClient.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.correlationId);
        const redirectUri = this.getRedirectUri(request.redirectUri);
        const browserState = {
            interactionType: interactionType
        };
        const state = (0, $1cc651d5e90b7480$export$871e33217042c65e).setRequestState(this.browserCrypto, request && request.state || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING, browserState);
        const baseRequest = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)((0, $4b44e4e159274463$export$8e461fcf1fd6910b), (0, $32170abc11155933$export$2f2811a3e1b21823).InitializeBaseRequest, this.logger, this.performanceClient, this.correlationId)({
            ...request,
            correlationId: this.correlationId
        }, this.config, this.performanceClient, this.logger);
        const validatedRequest = {
            ...baseRequest,
            redirectUri: redirectUri,
            state: state,
            nonce: request.nonce || (0, $b512579b1150f905$export$6ef0355fa80a5278)(),
            responseMode: this.config.auth.OIDCOptions.serverResponseType
        };
        // Skip active account lookup if either login hint or session id is set
        if (request.loginHint || request.sid) return validatedRequest;
        const account = request.account || this.browserStorage.getActiveAccount(this.correlationId);
        if (account) {
            this.logger.verbose("Setting validated request account", this.correlationId);
            this.logger.verbosePii(`Setting validated request account: ${account.homeAccountId}`, this.correlationId);
            validatedRequest.account = account;
        }
        // Check for ADAL/MSAL v1 SSO
        if (!validatedRequest.loginHint && !account) {
            const legacyLoginHint = this.browserStorage.getLegacyLoginHint();
            if (legacyLoginHint) validatedRequest.loginHint = legacyLoginHint;
        }
        return validatedRequest;
    }
}





/*! @azure/msal-browser v3.30.0 2025-08-05 */ 


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 

/*! @azure/msal-browser v3.30.0 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $28353e90d0055d2e$export$fbe5ac8608048ea9 = "ContentError";
const $28353e90d0055d2e$export$966ec8558e4d7922 = "user_switch";


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ // Status Codes that can be thrown by WAM
const $059d2a8d7bb9e086$export$e0aac30e542b316c = "USER_INTERACTION_REQUIRED";
const $059d2a8d7bb9e086$export$bec5e49cc27c5c10 = "USER_CANCEL";
const $059d2a8d7bb9e086$export$3c68b4973c91ba = "NO_NETWORK";
const $059d2a8d7bb9e086$export$b17f0b3cc10a2593 = "PERSISTENT_ERROR";
const $059d2a8d7bb9e086$export$8cd212c10b4124d2 = "DISABLED";
const $059d2a8d7bb9e086$export$f4c2bddc98c93ffc = "ACCOUNT_UNAVAILABLE";



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $8cbaa4db29abc94e$var$INVALID_METHOD_ERROR = -2147186943;
const $8cbaa4db29abc94e$export$9a1233b0d52ed7cd = {
    [(0, $28353e90d0055d2e$export$966ec8558e4d7922)]: "User attempted to switch accounts in the native broker, which is not allowed. All new accounts must sign-in through the standard web flow first, please try again."
};
class $8cbaa4db29abc94e$export$4b8a4f6256e840ab extends (0, $53b49d8334c1646a$export$145273558d58e0ac) {
    constructor(errorCode, description, ext){
        super(errorCode, description);
        Object.setPrototypeOf(this, $8cbaa4db29abc94e$export$4b8a4f6256e840ab.prototype);
        this.name = "NativeAuthError";
        this.ext = ext;
    }
}
/**
 * These errors should result in a fallback to the 'standard' browser based auth flow.
 */ function $8cbaa4db29abc94e$export$f21e42e365baeb50(error) {
    if (error.ext && error.ext.status && (error.ext.status === (0, $059d2a8d7bb9e086$export$b17f0b3cc10a2593) || error.ext.status === (0, $059d2a8d7bb9e086$export$8cd212c10b4124d2))) return true;
    if (error.ext && error.ext.error && error.ext.error === $8cbaa4db29abc94e$var$INVALID_METHOD_ERROR) return true;
    switch(error.errorCode){
        case 0, $28353e90d0055d2e$export$fbe5ac8608048ea9:
            return true;
        default:
            return false;
    }
}
/**
 * Create the appropriate error object based on the WAM status code.
 * @param code
 * @param description
 * @param ext
 * @returns
 */ function $8cbaa4db29abc94e$export$9154414ec87d187b(code, description, ext) {
    if (ext && ext.status) switch(ext.status){
        case 0, $059d2a8d7bb9e086$export$f4c2bddc98c93ffc:
            return (0, $0171ff24547bf7bf$export$8f7a741750c16535)((0, $5663e5ea2c96c5cf$exports).nativeAccountUnavailable);
        case 0, $059d2a8d7bb9e086$export$e0aac30e542b316c:
            return new (0, $0171ff24547bf7bf$export$6ba3e818c6bc76ba)(code, description);
        case 0, $059d2a8d7bb9e086$export$bec5e49cc27c5c10:
            return (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$6bae303c5e922702));
        case 0, $059d2a8d7bb9e086$export$3c68b4973c91ba:
            return (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$31ae862f18c3b2b7));
    }
    return new $8cbaa4db29abc94e$export$4b8a4f6256e840ab(code, $8cbaa4db29abc94e$export$9a1233b0d52ed7cd[code] || description, ext);
}



/*! @azure/msal-browser v3.30.0 2025-08-05 */ 
/*! @azure/msal-common v14.16.1 2025-08-05 */ 

/*! @azure/msal-common v14.16.1 2025-08-05 */ 






















'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $2c8fb1fd5a5f37d1$var$DEFAULT_REFRESH_TOKEN_EXPIRATION_OFFSET_SECONDS = 300; // 5 Minutes
/**
 * OAuth2.0 refresh token client
 * @internal
 */ class $2c8fb1fd5a5f37d1$export$9cb096b89b92d8a8 extends (0, $ed3742a5fca7e3cb$export$4f22f74eddb7716a) {
    constructor(configuration, performanceClient){
        super(configuration, performanceClient);
    }
    async acquireToken(request) {
        this.performanceClient?.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).RefreshTokenClientAcquireToken, request.correlationId);
        const reqTimestamp = (0, $7dce75f27affa532$export$ae62599a119ac50a)();
        const response = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.executeTokenRequest.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).RefreshTokenClientExecuteTokenRequest, this.logger, this.performanceClient, request.correlationId)(request, this.authority);
        // Retrieve requestId from response headers
        const requestId = response.headers?.[(0, $08c107807d753255$export$28d77f87efed1d88).X_MS_REQUEST_ID];
        const responseHandler = new (0, $85344044ef39ab89$export$f456c9835cc63582)(this.config.authOptions.clientId, this.cacheManager, this.cryptoUtils, this.logger, this.config.serializableCache, this.config.persistencePlugin);
        responseHandler.validateTokenResponse(response.body);
        return (0, $4832f15bf602f56d$export$e4feded94d9adb18)(responseHandler.handleServerTokenResponse.bind(responseHandler), (0, $32170abc11155933$export$2f2811a3e1b21823).HandleServerTokenResponse, this.logger, this.performanceClient, request.correlationId)(response.body, this.authority, reqTimestamp, request, undefined, undefined, true, request.forceCache, requestId);
    }
    /**
     * Gets cached refresh token and attaches to request, then calls acquireToken API
     * @param request
     */ async acquireTokenByRefreshToken(request) {
        // Cannot renew token if no request object is given.
        if (!request) throw (0, $a6f096219dc1b547$export$5d63d098f4f130a1)((0, $f66a3d6fc9f2eb73$export$eca67ff7a91fed9d));
        this.performanceClient?.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenByRefreshToken, request.correlationId);
        // We currently do not support silent flow for account === null use cases; This will be revisited for confidential flow usecases
        if (!request.account) throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$5a3c7d1c90ac9220));
        // try checking if FOCI is enabled for the given application
        const isFOCI = this.cacheManager.isAppMetadataFOCI(request.account.environment);
        // if the app is part of the family, retrive a Family refresh token if present and make a refreshTokenRequest
        if (isFOCI) try {
            return await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.acquireTokenWithCachedRefreshToken.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, this.logger, this.performanceClient, request.correlationId)(request, true);
        } catch (e) {
            const noFamilyRTInCache = e instanceof (0, $0171ff24547bf7bf$export$6ba3e818c6bc76ba) && e.errorCode === (0, $5663e5ea2c96c5cf$export$e408b083cd212696);
            const clientMismatchErrorWithFamilyRT = e instanceof (0, $85fc58951e10e394$export$ea52035eac03daf0) && e.errorCode === (0, $08c107807d753255$export$b8e9cd941e8016ac).INVALID_GRANT_ERROR && e.subError === (0, $08c107807d753255$export$b8e9cd941e8016ac).CLIENT_MISMATCH_ERROR;
            // if family Refresh Token (FRT) cache acquisition fails or if client_mismatch error is seen with FRT, reattempt with application Refresh Token (ART)
            if (noFamilyRTInCache || clientMismatchErrorWithFamilyRT) return (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.acquireTokenWithCachedRefreshToken.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, this.logger, this.performanceClient, request.correlationId)(request, false);
            else throw e;
        }
        // fall back to application refresh token acquisition
        return (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.acquireTokenWithCachedRefreshToken.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, this.logger, this.performanceClient, request.correlationId)(request, false);
    }
    /**
     * makes a network call to acquire tokens by exchanging RefreshToken available in userCache; throws if refresh token is not cached
     * @param request
     */ async acquireTokenWithCachedRefreshToken(request, foci) {
        this.performanceClient?.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenWithCachedRefreshToken, request.correlationId);
        // fetches family RT or application RT based on FOCI value
        const refreshToken = (0, $4832f15bf602f56d$export$468cda29b159ee5d)(this.cacheManager.getRefreshToken.bind(this.cacheManager), (0, $32170abc11155933$export$2f2811a3e1b21823).CacheManagerGetRefreshToken, this.logger, this.performanceClient, request.correlationId)(request.account, foci, request.correlationId, undefined, this.performanceClient);
        if (!refreshToken) throw (0, $0171ff24547bf7bf$export$8f7a741750c16535)((0, $5663e5ea2c96c5cf$export$e408b083cd212696));
        if (refreshToken.expiresOn && (0, $7dce75f27affa532$export$b007d77a962aa175)(refreshToken.expiresOn, request.refreshTokenExpirationOffsetSeconds || $2c8fb1fd5a5f37d1$var$DEFAULT_REFRESH_TOKEN_EXPIRATION_OFFSET_SECONDS)) throw (0, $0171ff24547bf7bf$export$8f7a741750c16535)((0, $5663e5ea2c96c5cf$export$a90e8b9c10991b49));
        // attach cached RT size to the current measurement
        const refreshTokenRequest = {
            ...request,
            refreshToken: refreshToken.secret,
            authenticationScheme: request.authenticationScheme || (0, $08c107807d753255$export$901491a717da2ba5).BEARER,
            ccsCredential: {
                credential: request.account.homeAccountId,
                type: (0, $36f32d37ad76b0c5$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
            }
        };
        try {
            return await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.acquireToken.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).RefreshTokenClientAcquireToken, this.logger, this.performanceClient, request.correlationId)(refreshTokenRequest);
        } catch (e) {
            if (e instanceof (0, $0171ff24547bf7bf$export$6ba3e818c6bc76ba) && e.subError === (0, $5663e5ea2c96c5cf$export$2e3666c77d45a4da)) {
                // Remove bad refresh token from cache
                this.logger.verbose("acquireTokenWithRefreshToken: bad refresh token, removing from cache");
                const badRefreshTokenKey = (0, $bd840ab348a8e6dd$export$1aaa1362083ec7a3)(refreshToken);
                this.cacheManager.removeRefreshToken(badRefreshTokenKey, request.correlationId);
            }
            throw e;
        }
    }
    /**
     * Constructs the network message and makes a NW call to the underlying secure token service
     * @param request
     * @param authority
     */ async executeTokenRequest(request, authority) {
        this.performanceClient?.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).RefreshTokenClientExecuteTokenRequest, request.correlationId);
        const queryParametersString = this.createTokenQueryParameters(request);
        const endpoint = (0, $ff2860ddbc741970$export$3abcdca7229e54f2).appendQueryString(authority.tokenEndpoint, queryParametersString);
        const requestBody = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.createTokenRequestBody.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).RefreshTokenClientCreateTokenRequestBody, this.logger, this.performanceClient, request.correlationId)(request);
        const headers = this.createTokenRequestHeaders(request.ccsCredential);
        const thumbprint = {
            clientId: request.tokenBodyParameters?.clientId || this.config.authOptions.clientId,
            authority: authority.canonicalAuthority,
            scopes: request.scopes,
            claims: request.claims,
            authenticationScheme: request.authenticationScheme,
            resourceRequestMethod: request.resourceRequestMethod,
            resourceRequestUri: request.resourceRequestUri,
            shrClaims: request.shrClaims,
            sshKid: request.sshKid
        };
        return (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.executePostToTokenEndpoint.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).RefreshTokenClientExecutePostToTokenEndpoint, this.logger, this.performanceClient, request.correlationId)(endpoint, requestBody, headers, thumbprint, request.correlationId, (0, $32170abc11155933$export$2f2811a3e1b21823).RefreshTokenClientExecutePostToTokenEndpoint);
    }
    /**
     * Helper function to create the token request body
     * @param request
     */ async createTokenRequestBody(request) {
        this.performanceClient?.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).RefreshTokenClientCreateTokenRequestBody, request.correlationId);
        const correlationId = request.correlationId;
        const parameterBuilder = new (0, $b2fdab17beec58b6$export$882078dd8a9e0bfa)(correlationId, this.performanceClient);
        parameterBuilder.addClientId(request.embeddedClientId || request.tokenBodyParameters?.[0, $fd2f81929f856dad$export$c7b1b63f5b60f8e] || this.config.authOptions.clientId);
        if (request.redirectUri) parameterBuilder.addRedirectUri(request.redirectUri);
        parameterBuilder.addScopes(request.scopes, true, this.config.authOptions.authority.options.OIDCOptions?.defaultScopes);
        parameterBuilder.addGrantType((0, $08c107807d753255$export$ce68f19b50b39c0b).REFRESH_TOKEN_GRANT);
        parameterBuilder.addClientInfo();
        parameterBuilder.addLibraryInfo(this.config.libraryInfo);
        parameterBuilder.addApplicationTelemetry(this.config.telemetry.application);
        parameterBuilder.addThrottling();
        if (this.serverTelemetryManager && !(0, $44a243886d8c290a$export$25afa7198c2ed9b9)(this.config)) parameterBuilder.addServerTelemetry(this.serverTelemetryManager);
        parameterBuilder.addRefreshToken(request.refreshToken);
        if (this.config.clientCredentials.clientSecret) parameterBuilder.addClientSecret(this.config.clientCredentials.clientSecret);
        if (this.config.clientCredentials.clientAssertion) {
            const clientAssertion = this.config.clientCredentials.clientAssertion;
            parameterBuilder.addClientAssertion(await (0, $5bf8ef87a233da43$export$620d3a93bf8b59fb)(clientAssertion.assertion, this.config.authOptions.clientId, request.resourceRequestUri));
            parameterBuilder.addClientAssertionType(clientAssertion.assertionType);
        }
        if (request.authenticationScheme === (0, $08c107807d753255$export$901491a717da2ba5).POP) {
            const popTokenGenerator = new (0, $a427aceea5cc6ef6$export$3dd8467151c83e3e)(this.cryptoUtils, this.performanceClient);
            let reqCnfData;
            if (!request.popKid) {
                const generatedReqCnfData = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(popTokenGenerator.generateCnf.bind(popTokenGenerator), (0, $32170abc11155933$export$2f2811a3e1b21823).PopTokenGenerateCnf, this.logger, this.performanceClient, request.correlationId)(request, this.logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
            } else reqCnfData = this.cryptoUtils.encodeKid(request.popKid);
            // SPA PoP requires full Base64Url encoded req_cnf string (unhashed)
            parameterBuilder.addPopToken(reqCnfData);
        } else if (request.authenticationScheme === (0, $08c107807d753255$export$901491a717da2ba5).SSH) {
            if (request.sshJwk) parameterBuilder.addSshJwk(request.sshJwk);
            else throw (0, $a6f096219dc1b547$export$5d63d098f4f130a1)((0, $f66a3d6fc9f2eb73$export$8fbed44b22d9136f));
        }
        if (!(0, $5d9dc3fc4be02ef2$export$ecc754f99843e759).isEmptyObj(request.claims) || this.config.authOptions.clientCapabilities && this.config.authOptions.clientCapabilities.length > 0) parameterBuilder.addClaims(request.claims, this.config.authOptions.clientCapabilities);
        if (this.config.systemOptions.preventCorsPreflight && request.ccsCredential) switch(request.ccsCredential.type){
            case (0, $36f32d37ad76b0c5$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID:
                try {
                    const clientInfo = (0, $8647f63f1ec6244a$export$63508a6d6b7dbe07)(request.ccsCredential.credential);
                    parameterBuilder.addCcsOid(clientInfo);
                } catch (e) {
                    this.logger.verbose("Could not parse home account ID for CCS Header: " + e);
                }
                break;
            case (0, $36f32d37ad76b0c5$export$17b7b3ac1abef49f).UPN:
                parameterBuilder.addCcsUpn(request.ccsCredential.credential);
                break;
        }
        if (request.embeddedClientId) parameterBuilder.addBrokerParameters({
            brokerClientId: this.config.authOptions.clientId,
            brokerRedirectUri: this.config.authOptions.redirectUri
        });
        if (request.tokenBodyParameters) parameterBuilder.addExtraQueryParameters(request.tokenBodyParameters);
        return parameterBuilder.createQueryString();
    }
}











'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /** @internal */ class $5a07a79e2d7c2c49$export$e344f5b12c464597 extends (0, $ed3742a5fca7e3cb$export$4f22f74eddb7716a) {
    constructor(configuration, performanceClient){
        super(configuration, performanceClient);
    }
    /**
     * Retrieves a token from cache if it is still valid, or uses the cached refresh token to renew
     * the given token and returns the renewed token
     * @param request
     */ async acquireToken(request) {
        try {
            const [authResponse, cacheOutcome] = await this.acquireCachedToken({
                ...request,
                scopes: request.scopes?.length ? request.scopes : [
                    ...(0, $08c107807d753255$export$893b1b5b686d84ef)
                ]
            });
            // if the token is not expired but must be refreshed; get a new one in the background
            if (cacheOutcome === (0, $08c107807d753255$export$aa4af185ea049f6b).PROACTIVELY_REFRESHED) {
                this.logger.info("SilentFlowClient:acquireCachedToken - Cached access token's refreshOn property has been exceeded'. It's not expired, but must be refreshed.");
                // refresh the access token in the background
                const refreshTokenClient = new (0, $2c8fb1fd5a5f37d1$export$9cb096b89b92d8a8)(this.config, this.performanceClient);
                refreshTokenClient.acquireTokenByRefreshToken(request).catch(()=>{
                // do nothing, this is running in the background and no action is to be taken upon success or failure
                });
            }
            // return the cached token
            return authResponse;
        } catch (e) {
            if (e instanceof (0, $8382ef0ce9eb98e6$export$a839ff85a7957561) && e.errorCode === (0, $9f4ee6b47026c448$export$e23b692cce0c7779)) {
                const refreshTokenClient = new (0, $2c8fb1fd5a5f37d1$export$9cb096b89b92d8a8)(this.config, this.performanceClient);
                return refreshTokenClient.acquireTokenByRefreshToken(request);
            } else throw e;
        }
    }
    /**
     * Retrieves token from cache or throws an error if it must be refreshed.
     * @param request
     */ async acquireCachedToken(request) {
        this.performanceClient?.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).SilentFlowClientAcquireCachedToken, request.correlationId);
        let lastCacheOutcome = (0, $08c107807d753255$export$aa4af185ea049f6b).NOT_APPLICABLE;
        if (request.forceRefresh || !this.config.cacheOptions.claimsBasedCachingEnabled && !(0, $5d9dc3fc4be02ef2$export$ecc754f99843e759).isEmptyObj(request.claims)) {
            // Must refresh due to present force_refresh flag.
            this.setCacheOutcome((0, $08c107807d753255$export$aa4af185ea049f6b).FORCE_REFRESH_OR_CLAIMS, request.correlationId);
            throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$e23b692cce0c7779));
        }
        // We currently do not support silent flow for account === null use cases; This will be revisited for confidential flow usecases
        if (!request.account) throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$5a3c7d1c90ac9220));
        const requestTenantId = request.account.tenantId || (0, $dda2270c89fd90c8$export$6ed5af33d279fbc7)(request.authority);
        const tokenKeys = this.cacheManager.getTokenKeys();
        const cachedAccessToken = this.cacheManager.getAccessToken(request.account, request, tokenKeys, requestTenantId, this.performanceClient);
        if (!cachedAccessToken) {
            // must refresh due to non-existent access_token
            this.setCacheOutcome((0, $08c107807d753255$export$aa4af185ea049f6b).NO_CACHED_ACCESS_TOKEN, request.correlationId);
            throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$e23b692cce0c7779));
        } else if ((0, $7dce75f27affa532$export$8961be72dcbc368e)(cachedAccessToken.cachedAt) || (0, $7dce75f27affa532$export$b007d77a962aa175)(cachedAccessToken.expiresOn, this.config.systemOptions.tokenRenewalOffsetSeconds)) {
            // must refresh due to the expires_in value
            this.setCacheOutcome((0, $08c107807d753255$export$aa4af185ea049f6b).CACHED_ACCESS_TOKEN_EXPIRED, request.correlationId);
            throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$e23b692cce0c7779));
        } else if (cachedAccessToken.refreshOn && (0, $7dce75f27affa532$export$b007d77a962aa175)(cachedAccessToken.refreshOn, 0)) // must refresh (in the background) due to the refresh_in value
        lastCacheOutcome = (0, $08c107807d753255$export$aa4af185ea049f6b).PROACTIVELY_REFRESHED;
        const environment = request.authority || this.authority.getPreferredCache();
        const cacheRecord = {
            account: this.cacheManager.readAccountFromCache(request.account, request.correlationId),
            accessToken: cachedAccessToken,
            idToken: this.cacheManager.getIdToken(request.account, request.correlationId, tokenKeys, requestTenantId, this.performanceClient),
            refreshToken: null,
            appMetadata: this.cacheManager.readAppMetadataFromCache(environment)
        };
        this.setCacheOutcome(lastCacheOutcome, request.correlationId);
        if (this.config.serverTelemetryManager) this.config.serverTelemetryManager.incrementCacheHits();
        return [
            await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.generateResultFromCacheRecord.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).SilentFlowClientGenerateResultFromCacheRecord, this.logger, this.performanceClient, request.correlationId)(cacheRecord, request),
            lastCacheOutcome
        ];
    }
    setCacheOutcome(cacheOutcome, correlationId) {
        this.serverTelemetryManager?.setCacheOutcome(cacheOutcome);
        this.performanceClient?.addFields({
            cacheOutcome: cacheOutcome
        }, correlationId);
        if (cacheOutcome !== (0, $08c107807d753255$export$aa4af185ea049f6b).NOT_APPLICABLE) this.logger.info(`Token refresh is required due to cache outcome: ${cacheOutcome}`);
    }
    /**
     * Helper function to build response object from the CacheRecord
     * @param cacheRecord
     */ async generateResultFromCacheRecord(cacheRecord, request) {
        this.performanceClient?.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).SilentFlowClientGenerateResultFromCacheRecord, request.correlationId);
        let idTokenClaims;
        if (cacheRecord.idToken) idTokenClaims = (0, $dfbf8cbb9a592daa$export$8a59e6f35fb00518)(cacheRecord.idToken.secret, this.config.cryptoInterface.base64Decode);
        // token max_age check
        if (request.maxAge || request.maxAge === 0) {
            const authTime = idTokenClaims?.auth_time;
            if (!authTime) throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$export$43356944266c945e));
            (0, $dfbf8cbb9a592daa$export$ee7a34ea7880144c)(authTime, request.maxAge);
        }
        return (0, $85344044ef39ab89$export$f456c9835cc63582).generateAuthenticationResult(this.cryptoUtils, this.authority, cacheRecord, true, request, idTokenClaims);
    }
}





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $065ef8adac8fed74$export$59d4f873ee62d01e extends (0, $e3650a1232c7da00$export$fa9179cade3eb05a) {
    /**
     * Returns unexpired tokens from the cache, if available
     * @param silentRequest
     */ async acquireToken(silentRequest) {
        this.performanceClient.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).SilentCacheClientAcquireToken, silentRequest.correlationId);
        // Telemetry manager only used to increment cacheHits here
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $091acf4c2675819b$export$192d74ad69b40705).acquireTokenSilent_silentFlow);
        const clientConfig = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.getClientConfiguration.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: serverTelemetryManager,
            requestAuthority: silentRequest.authority,
            requestAzureCloudOptions: silentRequest.azureCloudOptions,
            account: silentRequest.account
        });
        const silentAuthClient = new (0, $5a07a79e2d7c2c49$export$e344f5b12c464597)(clientConfig, this.performanceClient);
        this.logger.verbose("Silent auth client created");
        try {
            const response = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(silentAuthClient.acquireCachedToken.bind(silentAuthClient), (0, $32170abc11155933$export$2f2811a3e1b21823).SilentFlowClientAcquireCachedToken, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest);
            const authResponse = response[0];
            this.performanceClient.addFields({
                fromCache: true
            }, silentRequest.correlationId);
            return authResponse;
        } catch (error) {
            if (error instanceof (0, $59d58688ac49ebc0$export$f8eb6760ca13876a) && error.errorCode === (0, $aa0e430adf0f9ba6$export$a416b0eceb5c15df)) this.logger.verbose("Signing keypair for bound access token not found. Refreshing bound access token and generating a new crypto keypair.");
            throw error;
        }
    }
    /**
     * API to silenty clear the browser cache.
     * @param logoutRequest
     */ logout(logoutRequest) {
        this.logger.verbose("logoutRedirect called");
        const validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
        return this.clearCacheOnLogout(validLogoutRequest?.account);
    }
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $b593e4d2c5327969$export$38af86d4cb90fd61 extends (0, $e667915c70089a10$export$d858565f81c03f1f) {
    constructor(config, browserStorage, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, provider, accountId, nativeStorageImpl, correlationId){
        super(config, browserStorage, browserCrypto, logger, eventHandler, navigationClient, performanceClient, provider, correlationId);
        this.apiId = apiId;
        this.accountId = accountId;
        this.nativeMessageHandler = provider;
        this.nativeStorageManager = nativeStorageImpl;
        this.silentCacheClient = new (0, $065ef8adac8fed74$export$59d4f873ee62d01e)(config, this.nativeStorageManager, browserCrypto, logger, eventHandler, navigationClient, performanceClient, provider, correlationId);
        this.serverTelemetryManager = this.initializeServerTelemetryManager(this.apiId);
        const extensionName = this.nativeMessageHandler.getExtensionId() === (0, $091acf4c2675819b$export$fec113838800867f).PREFERRED_EXTENSION_ID ? "chrome" : this.nativeMessageHandler.getExtensionId()?.length ? "unknown" : undefined;
        this.skus = (0, $2dbd37583ce105ee$export$bddbbc43a3ca9c53).makeExtraSkuString({
            libraryName: (0, $091acf4c2675819b$export$a0a689e4294b9880).MSAL_SKU,
            libraryVersion: (0, $f42d0d3ccc24f1b6$export$83d89fbfd8236492),
            extensionName: extensionName,
            extensionVersion: this.nativeMessageHandler.getExtensionVersion()
        });
    }
    /**
     * Adds SKUs to request extra query parameters
     * @param request {NativeTokenRequest}
     * @private
     */ addRequestSKUs(request) {
        request.extraParameters = {
            ...request.extraParameters,
            [(0, $fd2f81929f856dad$exports).X_CLIENT_EXTRA_SKU]: this.skus
        };
    }
    /**
     * Acquire token from native platform via browser extension
     * @param request
     */ async acquireToken(request) {
        this.performanceClient.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).NativeInteractionClientAcquireToken, request.correlationId);
        this.logger.trace("NativeInteractionClient - acquireToken called.");
        // start the perf measurement
        const nativeATMeasurement = this.performanceClient.startMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).NativeInteractionClientAcquireToken, request.correlationId);
        const reqTimestamp = (0, $7dce75f27affa532$exports).nowSeconds();
        try {
            // initialize native request
            const nativeRequest = await this.initializeNativeRequest(request);
            // check if the tokens can be retrieved from internal cache
            try {
                const result = await this.acquireTokensFromCache(this.accountId, nativeRequest);
                nativeATMeasurement.end({
                    success: true,
                    isNativeBroker: false,
                    fromCache: true
                });
                return result;
            } catch (e) {
                // continue with a native call for any and all errors
                this.logger.info("MSAL internal Cache does not contain tokens, proceed to make a native call");
            }
            const { ...nativeTokenRequest } = nativeRequest;
            // fall back to native calls
            const messageBody = {
                method: (0, $091acf4c2675819b$export$3536098be6c7dadb).GetToken,
                request: nativeTokenRequest
            };
            const response = await this.nativeMessageHandler.sendMessage(messageBody);
            const validatedResponse = this.validateNativeResponse(response);
            return await this.handleNativeResponse(validatedResponse, nativeRequest, reqTimestamp).then((result)=>{
                nativeATMeasurement.end({
                    success: true,
                    isNativeBroker: true,
                    requestId: result.requestId
                });
                this.serverTelemetryManager.clearNativeBrokerErrorCode();
                return result;
            }).catch((error)=>{
                nativeATMeasurement.end({
                    success: false,
                    errorCode: error.errorCode,
                    subErrorCode: error.subError,
                    isNativeBroker: true
                });
                throw error;
            });
        } catch (e) {
            if (e instanceof (0, $8cbaa4db29abc94e$export$4b8a4f6256e840ab)) this.serverTelemetryManager.setNativeBrokerErrorCode(e.errorCode);
            throw e;
        }
    }
    /**
     * Creates silent flow request
     * @param request
     * @param cachedAccount
     * @returns CommonSilentFlowRequest
     */ createSilentCacheRequest(request, cachedAccount) {
        return {
            authority: request.authority,
            correlationId: this.correlationId,
            scopes: (0, $d671ba25592fe375$export$b9b82b0f94ae1f99).fromString(request.scope).asArray(),
            account: cachedAccount,
            forceRefresh: false
        };
    }
    /**
     * Fetches the tokens from the cache if un-expired
     * @param nativeAccountId
     * @param request
     * @returns authenticationResult
     */ async acquireTokensFromCache(nativeAccountId, request) {
        if (!nativeAccountId) {
            this.logger.warning("NativeInteractionClient:acquireTokensFromCache - No nativeAccountId provided");
            throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$exports).noAccountFound);
        }
        // fetch the account from browser cache
        const account = this.browserStorage.getBaseAccountInfo({
            nativeAccountId: nativeAccountId
        }, request.correlationId);
        if (!account) throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$exports).noAccountFound);
        // leverage silent flow for cached tokens retrieval
        try {
            const silentRequest = this.createSilentCacheRequest(request, account);
            const result = await this.silentCacheClient.acquireToken(silentRequest);
            const fullAccount = {
                ...account,
                idTokenClaims: result?.idTokenClaims,
                idToken: result?.idToken
            };
            return {
                ...result,
                account: fullAccount
            };
        } catch (e) {
            throw e;
        }
    }
    /**
     * Acquires a token from native platform then redirects to the redirectUri instead of returning the response
     * @param {RedirectRequest} request
     * @param {InProgressPerformanceEvent} rootMeasurement
     */ async acquireTokenRedirect(request, rootMeasurement) {
        this.logger.trace("NativeInteractionClient - acquireTokenRedirect called.");
        const { ...remainingParameters } = request;
        delete remainingParameters.onRedirectNavigate;
        const nativeRequest = await this.initializeNativeRequest(remainingParameters);
        const messageBody = {
            method: (0, $091acf4c2675819b$export$3536098be6c7dadb).GetToken,
            request: nativeRequest
        };
        try {
            const response = await this.nativeMessageHandler.sendMessage(messageBody);
            this.validateNativeResponse(response);
        } catch (e) {
            // Only throw fatal errors here to allow application to fallback to regular redirect. Otherwise proceed and the error will be thrown in handleRedirectPromise
            if (e instanceof (0, $8cbaa4db29abc94e$export$4b8a4f6256e840ab)) {
                this.serverTelemetryManager.setNativeBrokerErrorCode(e.errorCode);
                if ((0, $8cbaa4db29abc94e$export$f21e42e365baeb50)(e)) throw e;
            }
        }
        this.browserStorage.setTemporaryCache((0, $091acf4c2675819b$export$21d55bedf0d269fb).NATIVE_REQUEST, JSON.stringify(nativeRequest), true);
        const navigationOptions = {
            apiId: (0, $091acf4c2675819b$export$192d74ad69b40705).acquireTokenRedirect,
            timeout: this.config.system.redirectNavigationTimeout,
            noHistory: false
        };
        const redirectUri = this.config.auth.navigateToLoginRequestUrl ? window.location.href : this.getRedirectUri(request.redirectUri);
        rootMeasurement.end({
            success: true
        });
        await this.navigationClient.navigateExternal(redirectUri, navigationOptions); // Need to treat this as external to ensure handleRedirectPromise is run again
    }
    /**
     * If the previous page called native platform for a token using redirect APIs, send the same request again and return the response
     * @param performanceClient {IPerformanceClient?}
     * @param correlationId {string?} correlation identifier
     */ async handleRedirectPromise(performanceClient, correlationId) {
        this.logger.trace("NativeInteractionClient - handleRedirectPromise called.");
        if (!this.browserStorage.isInteractionInProgress(true)) {
            this.logger.info("handleRedirectPromise called but there is no interaction in progress, returning null.");
            return null;
        }
        // remove prompt from the request to prevent WAM from prompting twice
        const cachedRequest = this.browserStorage.getCachedNativeRequest();
        if (!cachedRequest) {
            this.logger.verbose("NativeInteractionClient - handleRedirectPromise called but there is no cached request, returning null.");
            if (performanceClient && correlationId) performanceClient?.addFields({
                errorCode: "no_cached_request"
            }, correlationId);
            return null;
        }
        const { prompt: prompt, ...request } = cachedRequest;
        if (prompt) this.logger.verbose("NativeInteractionClient - handleRedirectPromise called and prompt was included in the original request, removing prompt from cached request to prevent second interaction with native broker window.");
        this.browserStorage.removeItem(this.browserStorage.generateCacheKey((0, $091acf4c2675819b$export$21d55bedf0d269fb).NATIVE_REQUEST));
        const messageBody = {
            method: (0, $091acf4c2675819b$export$3536098be6c7dadb).GetToken,
            request: request
        };
        const reqTimestamp = (0, $7dce75f27affa532$exports).nowSeconds();
        try {
            this.logger.verbose("NativeInteractionClient - handleRedirectPromise sending message to native broker.");
            const response = await this.nativeMessageHandler.sendMessage(messageBody);
            this.validateNativeResponse(response);
            const result = this.handleNativeResponse(response, request, reqTimestamp);
            this.browserStorage.setInteractionInProgress(false);
            const res = await result;
            this.serverTelemetryManager.clearNativeBrokerErrorCode();
            return res;
        } catch (e) {
            this.browserStorage.setInteractionInProgress(false);
            throw e;
        }
    }
    /**
     * Logout from native platform via browser extension
     * @param request
     */ logout() {
        this.logger.trace("NativeInteractionClient - logout called.");
        return Promise.reject("Logout not implemented yet");
    }
    /**
     * Transform response from native platform into AuthenticationResult object which will be returned to the end user
     * @param response
     * @param request
     * @param reqTimestamp
     */ async handleNativeResponse(response, request, reqTimestamp) {
        this.logger.trace("NativeInteractionClient - handleNativeResponse called.");
        // generate identifiers
        const idTokenClaims = (0, $dfbf8cbb9a592daa$exports).extractTokenClaims(response.id_token, (0, $823c1cd3d50f09ac$export$c62426fdd000a97e));
        const homeAccountIdentifier = this.createHomeAccountIdentifier(response, idTokenClaims);
        const cachedhomeAccountId = this.browserStorage.getAccountInfoFilteredBy({
            nativeAccountId: request.accountId
        }, this.correlationId)?.homeAccountId;
        if (homeAccountIdentifier !== cachedhomeAccountId && response.account.id !== request.accountId) // User switch in native broker prompt is not supported. All users must first sign in through web flow to ensure server state is in sync
        throw (0, $8cbaa4db29abc94e$export$9154414ec87d187b)((0, $28353e90d0055d2e$export$966ec8558e4d7922));
        // Get the preferred_cache domain for the given authority
        const authority = await this.getDiscoveredAuthority({
            requestAuthority: request.authority
        });
        const baseAccount = (0, $85344044ef39ab89$export$73b84062d58a1307)(this.browserStorage, authority, homeAccountIdentifier, (0, $823c1cd3d50f09ac$export$c62426fdd000a97e), this.correlationId, idTokenClaims, response.client_info, undefined, idTokenClaims.tid, undefined, response.account.id, this.logger);
        // generate authenticationResult
        const result = await this.generateAuthenticationResult(response, request, idTokenClaims, baseAccount, authority.canonicalAuthority, reqTimestamp);
        // cache accounts and tokens in the appropriate storage
        this.cacheAccount(baseAccount);
        this.cacheNativeTokens(response, request, homeAccountIdentifier, idTokenClaims, response.access_token, result.tenantId, reqTimestamp);
        return result;
    }
    /**
     * creates an homeAccountIdentifier for the account
     * @param response
     * @param idTokenObj
     * @returns
     */ createHomeAccountIdentifier(response, idTokenClaims) {
        // Save account in browser storage
        const homeAccountIdentifier = (0, $35a4414ce05ac30e$export$680160523e6bfa6a).generateHomeAccountId(response.client_info || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING, (0, $177318b44e15a6f4$export$cd82032b224a3839).Default, this.logger, this.browserCrypto, idTokenClaims);
        return homeAccountIdentifier;
    }
    /**
     * Helper to generate scopes
     * @param response
     * @param request
     * @returns
     */ generateScopes(response, request) {
        return response.scope ? (0, $d671ba25592fe375$export$b9b82b0f94ae1f99).fromString(response.scope) : (0, $d671ba25592fe375$export$b9b82b0f94ae1f99).fromString(request.scope);
    }
    /**
     * If PoP token is requesred, records the PoP token if returned from the WAM, else generates one in the browser
     * @param request
     * @param response
     */ async generatePopAccessToken(response, request) {
        if (request.tokenType === (0, $08c107807d753255$export$901491a717da2ba5).POP && request.signPopToken) {
            /**
             * This code prioritizes SHR returned from the native layer. In case of error/SHR not calculated from WAM and the AT
             * is still received, SHR is calculated locally
             */ // Check if native layer returned an SHR token
            if (response.shr) {
                this.logger.trace("handleNativeServerResponse: SHR is enabled in native layer");
                return response.shr;
            }
            // Generate SHR in msal js if WAM does not compute it when POP is enabled
            const popTokenGenerator = new (0, $a427aceea5cc6ef6$export$3dd8467151c83e3e)(this.browserCrypto);
            const shrParameters = {
                resourceRequestMethod: request.resourceRequestMethod,
                resourceRequestUri: request.resourceRequestUri,
                shrClaims: request.shrClaims,
                shrNonce: request.shrNonce
            };
            /**
             * KeyID must be present in the native request from when the PoP key was generated in order for
             * PopTokenGenerator to query the full key for signing
             */ if (!request.keyId) throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$exports).keyIdMissing);
            return popTokenGenerator.signPopToken(response.access_token, request.keyId, shrParameters);
        } else return response.access_token;
    }
    /**
     * Generates authentication result
     * @param response
     * @param request
     * @param idTokenObj
     * @param accountEntity
     * @param authority
     * @param reqTimestamp
     * @returns
     */ async generateAuthenticationResult(response, request, idTokenClaims, accountEntity, authority, reqTimestamp) {
        // Add Native Broker fields to Telemetry
        const mats = this.addTelemetryFromNativeResponse(response);
        // If scopes not returned in server response, use request scopes
        const responseScopes = response.scope ? (0, $d671ba25592fe375$export$b9b82b0f94ae1f99).fromString(response.scope) : (0, $d671ba25592fe375$export$b9b82b0f94ae1f99).fromString(request.scope);
        const accountProperties = response.account.properties || {};
        const uid = accountProperties["UID"] || idTokenClaims.oid || idTokenClaims.sub || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING;
        const tid = accountProperties["TenantId"] || idTokenClaims.tid || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING;
        const accountInfo = (0, $2b6041b9fe3f70e1$export$452a054c78b83dad)(accountEntity.getAccountInfo(), undefined, idTokenClaims, response.id_token);
        /**
         * In pairwise broker flows, this check prevents the broker's native account id
         * from being returned over the embedded app's account id.
         */ if (accountInfo.nativeAccountId !== response.account.id) accountInfo.nativeAccountId = response.account.id;
        // generate PoP token as needed
        const responseAccessToken = await this.generatePopAccessToken(response, request);
        const tokenType = request.tokenType === (0, $08c107807d753255$export$901491a717da2ba5).POP ? (0, $08c107807d753255$export$901491a717da2ba5).POP : (0, $08c107807d753255$export$901491a717da2ba5).BEARER;
        const result = {
            authority: authority,
            uniqueId: uid,
            tenantId: tid,
            scopes: responseScopes.asArray(),
            account: accountInfo,
            idToken: response.id_token,
            idTokenClaims: idTokenClaims,
            accessToken: responseAccessToken,
            fromCache: mats ? this.isResponseFromCache(mats) : false,
            expiresOn: new Date(Number(reqTimestamp + response.expires_in) * 1000),
            tokenType: tokenType,
            correlationId: this.correlationId,
            state: response.state,
            fromNativeBroker: true
        };
        return result;
    }
    /**
     * cache the account entity in browser storage
     * @param accountEntity
     */ cacheAccount(accountEntity) {
        // Store the account info and hence `nativeAccountId` in browser cache
        this.browserStorage.setAccount(accountEntity, this.correlationId);
        // Remove any existing cached tokens for this account in browser storage
        this.browserStorage.removeAccountContext(accountEntity, this.correlationId).catch((e)=>{
            this.logger.error(`Error occurred while removing account context from browser storage. ${e}`);
        });
    }
    /**
     * Stores the access_token and id_token in inmemory storage
     * @param response
     * @param request
     * @param homeAccountIdentifier
     * @param idTokenObj
     * @param responseAccessToken
     * @param tenantId
     * @param reqTimestamp
     */ cacheNativeTokens(response, request, homeAccountIdentifier, idTokenClaims, responseAccessToken, tenantId, reqTimestamp) {
        const cachedIdToken = (0, $bd840ab348a8e6dd$exports).createIdTokenEntity(homeAccountIdentifier, request.authority, response.id_token || "", request.clientId, idTokenClaims.tid || "");
        // cache accessToken in inmemory storage
        const expiresIn = request.tokenType === (0, $08c107807d753255$export$901491a717da2ba5).POP ? (0, $08c107807d753255$export$a002182e51710d39).SHR_NONCE_VALIDITY : (typeof response.expires_in === "string" ? parseInt(response.expires_in, 10) : response.expires_in) || 0;
        const tokenExpirationSeconds = reqTimestamp + expiresIn;
        const responseScopes = this.generateScopes(response, request);
        const cachedAccessToken = (0, $bd840ab348a8e6dd$exports).createAccessTokenEntity(homeAccountIdentifier, request.authority, responseAccessToken, request.clientId, idTokenClaims.tid || tenantId, responseScopes.printScopes(), tokenExpirationSeconds, 0, (0, $823c1cd3d50f09ac$export$c62426fdd000a97e), undefined, request.tokenType, undefined, request.keyId);
        const nativeCacheRecord = {
            idToken: cachedIdToken,
            accessToken: cachedAccessToken
        };
        this.nativeStorageManager.saveCacheRecord(nativeCacheRecord, request.correlationId, request.storeInCache);
    }
    addTelemetryFromNativeResponse(response) {
        const mats = this.getMATSFromResponse(response);
        if (!mats) return null;
        this.performanceClient.addFields({
            extensionId: this.nativeMessageHandler.getExtensionId(),
            extensionVersion: this.nativeMessageHandler.getExtensionVersion(),
            matsBrokerVersion: mats.broker_version,
            matsAccountJoinOnStart: mats.account_join_on_start,
            matsAccountJoinOnEnd: mats.account_join_on_end,
            matsDeviceJoin: mats.device_join,
            matsPromptBehavior: mats.prompt_behavior,
            matsApiErrorCode: mats.api_error_code,
            matsUiVisible: mats.ui_visible,
            matsSilentCode: mats.silent_code,
            matsSilentBiSubCode: mats.silent_bi_sub_code,
            matsSilentMessage: mats.silent_message,
            matsSilentStatus: mats.silent_status,
            matsHttpStatus: mats.http_status,
            matsHttpEventCount: mats.http_event_count
        }, this.correlationId);
        return mats;
    }
    /**
     * Validates native platform response before processing
     * @param response
     */ validateNativeResponse(response) {
        if (response.hasOwnProperty("access_token") && response.hasOwnProperty("id_token") && response.hasOwnProperty("client_info") && response.hasOwnProperty("account") && response.hasOwnProperty("scope") && response.hasOwnProperty("expires_in")) return response;
        else throw (0, $53b49d8334c1646a$export$eb157f7636c79bd2)((0, $c741bd9c870ee400$exports).unexpectedError, "Response missing expected properties.");
    }
    /**
     * Gets MATS telemetry from native response
     * @param response
     * @returns
     */ getMATSFromResponse(response) {
        if (response.properties.MATS) try {
            return JSON.parse(response.properties.MATS);
        } catch (e) {
            this.logger.error("NativeInteractionClient - Error parsing MATS telemetry, returning null instead");
        }
        return null;
    }
    /**
     * Returns whether or not response came from native cache
     * @param response
     * @returns
     */ isResponseFromCache(mats) {
        if (typeof mats.is_cached === "undefined") {
            this.logger.verbose("NativeInteractionClient - MATS telemetry does not contain field indicating if response was served from cache. Returning false.");
            return false;
        }
        return !!mats.is_cached;
    }
    /**
     * Translates developer provided request object into NativeRequest object
     * @param request
     */ async initializeNativeRequest(request) {
        this.logger.trace("NativeInteractionClient - initializeNativeRequest called");
        const requestAuthority = request.authority || this.config.auth.authority;
        if (request.account) // validate authority
        await this.getDiscoveredAuthority({
            requestAuthority: requestAuthority,
            requestAzureCloudOptions: request.azureCloudOptions,
            account: request.account
        });
        const canonicalAuthority = new (0, $ff2860ddbc741970$export$3abcdca7229e54f2)(requestAuthority);
        canonicalAuthority.validateAsUri();
        // scopes are expected to be received by the native broker as "scope" and will be added to the request below. Other properties that should be dropped from the request to the native broker can be included in the object destructuring here.
        const { scopes: scopes, ...remainingProperties } = request;
        const scopeSet = new (0, $d671ba25592fe375$export$b9b82b0f94ae1f99)(scopes || []);
        scopeSet.appendScopes((0, $08c107807d753255$export$893b1b5b686d84ef));
        const getPrompt = ()=>{
            // If request is silent, prompt is always none
            switch(this.apiId){
                case (0, $091acf4c2675819b$export$192d74ad69b40705).ssoSilent:
                case (0, $091acf4c2675819b$export$192d74ad69b40705).acquireTokenSilent_silentFlow:
                    this.logger.trace("initializeNativeRequest: silent request sets prompt to none");
                    return (0, $08c107807d753255$export$49a06cbda5acaa5).NONE;
            }
            // Prompt not provided, request may proceed and native broker decides if it needs to prompt
            if (!request.prompt) {
                this.logger.trace("initializeNativeRequest: prompt was not provided");
                return undefined;
            }
            // If request is interactive, check if prompt provided is allowed to go directly to native broker
            switch(request.prompt){
                case (0, $08c107807d753255$export$49a06cbda5acaa5).NONE:
                case (0, $08c107807d753255$export$49a06cbda5acaa5).CONSENT:
                case (0, $08c107807d753255$export$49a06cbda5acaa5).LOGIN:
                    this.logger.trace("initializeNativeRequest: prompt is compatible with native flow");
                    return request.prompt;
                default:
                    this.logger.trace(`initializeNativeRequest: prompt = ${request.prompt} is not compatible with native flow`);
                    throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$62fdd8848aa75547));
            }
        };
        const validatedRequest = {
            ...remainingProperties,
            accountId: this.accountId,
            clientId: this.config.auth.clientId,
            authority: canonicalAuthority.urlString,
            scope: scopeSet.printScopes(),
            redirectUri: this.getRedirectUri(request.redirectUri),
            prompt: getPrompt(),
            correlationId: this.correlationId,
            tokenType: request.authenticationScheme,
            windowTitleSubstring: document.title,
            extraParameters: {
                ...request.extraQueryParameters,
                ...request.tokenQueryParameters
            },
            extendedExpiryToken: false,
            keyId: request.popKid
        };
        // Check for PoP token requests: signPopToken should only be set to true if popKid is not set
        if (validatedRequest.signPopToken && !!request.popKid) throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$f6f43ae33ad04b91));
        this.handleExtraBrokerParams(validatedRequest);
        validatedRequest.extraParameters = validatedRequest.extraParameters || {};
        validatedRequest.extraParameters.telemetry = (0, $091acf4c2675819b$export$fec113838800867f).MATS_TELEMETRY;
        if (request.authenticationScheme === (0, $08c107807d753255$export$901491a717da2ba5).POP) {
            // add POP request type
            const shrParameters = {
                resourceRequestUri: request.resourceRequestUri,
                resourceRequestMethod: request.resourceRequestMethod,
                shrClaims: request.shrClaims,
                shrNonce: request.shrNonce
            };
            const popTokenGenerator = new (0, $a427aceea5cc6ef6$export$3dd8467151c83e3e)(this.browserCrypto);
            // generate reqCnf if not provided in the request
            let reqCnfData;
            if (!validatedRequest.keyId) {
                const generatedReqCnfData = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(popTokenGenerator.generateCnf.bind(popTokenGenerator), (0, $32170abc11155933$export$2f2811a3e1b21823).PopTokenGenerateCnf, this.logger, this.performanceClient, request.correlationId)(shrParameters, this.logger);
                reqCnfData = generatedReqCnfData.reqCnfString;
                validatedRequest.keyId = generatedReqCnfData.kid;
                validatedRequest.signPopToken = true;
            } else {
                reqCnfData = this.browserCrypto.base64UrlEncode(JSON.stringify({
                    kid: validatedRequest.keyId
                }));
                validatedRequest.signPopToken = false;
            }
            // SPAs require whole string to be passed to broker
            validatedRequest.reqCnf = reqCnfData;
        }
        this.addRequestSKUs(validatedRequest);
        return validatedRequest;
    }
    /**
     * Handles extra broker request parameters
     * @param request {NativeTokenRequest}
     * @private
     */ handleExtraBrokerParams(request) {
        const hasExtraBrokerParams = request.extraParameters && request.extraParameters.hasOwnProperty((0, $fd2f81929f856dad$exports).BROKER_CLIENT_ID) && request.extraParameters.hasOwnProperty((0, $fd2f81929f856dad$exports).BROKER_REDIRECT_URI) && request.extraParameters.hasOwnProperty((0, $fd2f81929f856dad$exports).CLIENT_ID);
        if (!request.embeddedClientId && !hasExtraBrokerParams) return;
        let child_client_id = "";
        const child_redirect_uri = request.redirectUri;
        if (request.embeddedClientId) {
            request.redirectUri = this.config.auth.redirectUri;
            child_client_id = request.embeddedClientId;
        } else if (request.extraParameters) {
            request.redirectUri = request.extraParameters[(0, $fd2f81929f856dad$exports).BROKER_REDIRECT_URI];
            child_client_id = request.extraParameters[(0, $fd2f81929f856dad$exports).CLIENT_ID];
        }
        request.extraParameters = {
            child_client_id: child_client_id,
            child_redirect_uri: child_redirect_uri
        };
        this.performanceClient?.addFields({
            embeddedClientId: child_client_id,
            embeddedRedirectUri: child_redirect_uri
        }, request.correlationId);
    }
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $6031f29937eca509$export$c98888b8059e2702 {
    constructor(logger, handshakeTimeoutMs, performanceClient, extensionId){
        this.logger = logger;
        this.handshakeTimeoutMs = handshakeTimeoutMs;
        this.extensionId = extensionId;
        this.resolvers = new Map(); // Used for non-handshake messages
        this.handshakeResolvers = new Map(); // Used for handshake messages
        this.messageChannel = new MessageChannel();
        this.windowListener = this.onWindowMessage.bind(this); // Window event callback doesn't have access to 'this' unless it's bound
        this.performanceClient = performanceClient;
        this.handshakeEvent = performanceClient.startMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).NativeMessageHandlerHandshake);
    }
    /**
     * Sends a given message to the extension and resolves with the extension response
     * @param body
     */ async sendMessage(body) {
        this.logger.trace("NativeMessageHandler - sendMessage called.");
        const req = {
            channel: (0, $091acf4c2675819b$export$fec113838800867f).CHANNEL_ID,
            extensionId: this.extensionId,
            responseId: (0, $b512579b1150f905$export$6ef0355fa80a5278)(),
            body: body
        };
        this.logger.trace("NativeMessageHandler - Sending request to browser extension");
        this.logger.tracePii(`NativeMessageHandler - Sending request to browser extension: ${JSON.stringify(req)}`);
        this.messageChannel.port1.postMessage(req);
        return new Promise((resolve, reject)=>{
            this.resolvers.set(req.responseId, {
                resolve: resolve,
                reject: reject
            });
        });
    }
    /**
     * Returns an instance of the MessageHandler that has successfully established a connection with an extension
     * @param {Logger} logger
     * @param {number} handshakeTimeoutMs
     * @param {IPerformanceClient} performanceClient
     * @param {ICrypto} crypto
     */ static async createProvider(logger, handshakeTimeoutMs, performanceClient) {
        logger.trace("NativeMessageHandler - createProvider called.");
        try {
            const preferredProvider = new $6031f29937eca509$export$c98888b8059e2702(logger, handshakeTimeoutMs, performanceClient, (0, $091acf4c2675819b$export$fec113838800867f).PREFERRED_EXTENSION_ID);
            await preferredProvider.sendHandshakeRequest();
            return preferredProvider;
        } catch (e) {
            // If preferred extension fails for whatever reason, fallback to using any installed extension
            const backupProvider = new $6031f29937eca509$export$c98888b8059e2702(logger, handshakeTimeoutMs, performanceClient);
            await backupProvider.sendHandshakeRequest();
            return backupProvider;
        }
    }
    /**
     * Send handshake request helper.
     */ async sendHandshakeRequest() {
        this.logger.trace("NativeMessageHandler - sendHandshakeRequest called.");
        // Register this event listener before sending handshake
        window.addEventListener("message", this.windowListener, false); // false is important, because content script message processing should work first
        const req = {
            channel: (0, $091acf4c2675819b$export$fec113838800867f).CHANNEL_ID,
            extensionId: this.extensionId,
            responseId: (0, $b512579b1150f905$export$6ef0355fa80a5278)(),
            body: {
                method: (0, $091acf4c2675819b$export$3536098be6c7dadb).HandshakeRequest
            }
        };
        this.handshakeEvent.add({
            extensionId: this.extensionId,
            extensionHandshakeTimeoutMs: this.handshakeTimeoutMs
        });
        this.messageChannel.port1.onmessage = (event)=>{
            this.onChannelMessage(event);
        };
        window.postMessage(req, window.origin, [
            this.messageChannel.port2
        ]);
        return new Promise((resolve, reject)=>{
            this.handshakeResolvers.set(req.responseId, {
                resolve: resolve,
                reject: reject
            });
            this.timeoutId = window.setTimeout(()=>{
                /*
                 * Throw an error if neither HandshakeResponse nor original Handshake request are received in a reasonable timeframe.
                 * This typically suggests an event handler stopped propagation of the Handshake request but did not respond to it on the MessageChannel port
                 */ window.removeEventListener("message", this.windowListener, false);
                this.messageChannel.port1.close();
                this.messageChannel.port2.close();
                this.handshakeEvent.end({
                    extensionHandshakeTimedOut: true,
                    success: false
                });
                reject((0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$4747c302ef0117fd)));
                this.handshakeResolvers.delete(req.responseId);
            }, this.handshakeTimeoutMs); // Use a reasonable timeout in milliseconds here
        });
    }
    /**
     * Invoked when a message is posted to the window. If a handshake request is received it means the extension is not installed.
     * @param event
     */ onWindowMessage(event) {
        this.logger.trace("NativeMessageHandler - onWindowMessage called");
        // We only accept messages from ourselves
        if (event.source !== window) return;
        const request = event.data;
        if (!request.channel || request.channel !== (0, $091acf4c2675819b$export$fec113838800867f).CHANNEL_ID) return;
        if (request.extensionId && request.extensionId !== this.extensionId) return;
        if (request.body.method === (0, $091acf4c2675819b$export$3536098be6c7dadb).HandshakeRequest) {
            const handshakeResolver = this.handshakeResolvers.get(request.responseId);
            /*
             * Filter out responses with no matched resolvers sooner to keep channel ports open while waiting for
             * the proper response.
             */ if (!handshakeResolver) {
                this.logger.trace(`NativeMessageHandler.onWindowMessage - resolver can't be found for request ${request.responseId}`);
                return;
            }
            // If we receive this message back it means no extension intercepted the request, meaning no extension supporting handshake protocol is installed
            this.logger.verbose(request.extensionId ? `Extension with id: ${request.extensionId} not installed` : "No extension installed");
            clearTimeout(this.timeoutId);
            this.messageChannel.port1.close();
            this.messageChannel.port2.close();
            window.removeEventListener("message", this.windowListener, false);
            this.handshakeEvent.end({
                success: false,
                extensionInstalled: false
            });
            handshakeResolver.reject((0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$59080ea2398ee306)));
        }
    }
    /**
     * Invoked when a message is received from the extension on the MessageChannel port
     * @param event
     */ onChannelMessage(event) {
        this.logger.trace("NativeMessageHandler - onChannelMessage called.");
        const request = event.data;
        const resolver = this.resolvers.get(request.responseId);
        const handshakeResolver = this.handshakeResolvers.get(request.responseId);
        try {
            const method = request.body.method;
            if (method === (0, $091acf4c2675819b$export$3536098be6c7dadb).Response) {
                if (!resolver) return;
                const response = request.body.response;
                this.logger.trace("NativeMessageHandler - Received response from browser extension");
                this.logger.tracePii(`NativeMessageHandler - Received response from browser extension: ${JSON.stringify(response)}`);
                if (response.status !== "Success") resolver.reject((0, $8cbaa4db29abc94e$export$9154414ec87d187b)(response.code, response.description, response.ext));
                else if (response.result) {
                    if (response.result["code"] && response.result["description"]) resolver.reject((0, $8cbaa4db29abc94e$export$9154414ec87d187b)(response.result["code"], response.result["description"], response.result["ext"]));
                    else resolver.resolve(response.result);
                } else throw (0, $53b49d8334c1646a$export$eb157f7636c79bd2)((0, $c741bd9c870ee400$exports).unexpectedError, "Event does not contain result.");
                this.resolvers.delete(request.responseId);
            } else if (method === (0, $091acf4c2675819b$export$3536098be6c7dadb).HandshakeResponse) {
                if (!handshakeResolver) {
                    this.logger.trace(`NativeMessageHandler.onChannelMessage - resolver can't be found for request ${request.responseId}`);
                    return;
                }
                clearTimeout(this.timeoutId); // Clear setTimeout
                window.removeEventListener("message", this.windowListener, false); // Remove 'No extension' listener
                this.extensionId = request.extensionId;
                this.extensionVersion = request.body.version;
                this.logger.verbose(`NativeMessageHandler - Received HandshakeResponse from extension: ${this.extensionId}`);
                this.handshakeEvent.end({
                    extensionInstalled: true,
                    success: true
                });
                handshakeResolver.resolve();
                this.handshakeResolvers.delete(request.responseId);
            }
        // Do nothing if method is not Response or HandshakeResponse
        } catch (err) {
            this.logger.error("Error parsing response from WAM Extension");
            this.logger.errorPii(`Error parsing response from WAM Extension: ${err}`);
            this.logger.errorPii(`Unable to parse ${event}`);
            if (resolver) resolver.reject(err);
            else if (handshakeResolver) handshakeResolver.reject(err);
        }
    }
    /**
     * Returns the Id for the browser extension this handler is communicating with
     * @returns
     */ getExtensionId() {
        return this.extensionId;
    }
    /**
     * Returns the version for the browser extension this handler is communicating with
     * @returns
     */ getExtensionVersion() {
        return this.extensionVersion;
    }
    /**
     * Returns boolean indicating whether or not the request should attempt to use native broker
     * @param logger
     * @param config
     * @param nativeExtensionProvider
     * @param authenticationScheme
     */ static isNativeAvailable(config, logger, nativeExtensionProvider, authenticationScheme) {
        logger.trace("isNativeAvailable called");
        if (!config.system.allowNativeBroker) {
            logger.trace("isNativeAvailable: allowNativeBroker is not enabled, returning false");
            // Developer disabled WAM
            return false;
        }
        if (!nativeExtensionProvider) {
            logger.trace("isNativeAvailable: WAM extension provider is not initialized, returning false");
            // Extension is not available
            return false;
        }
        if (authenticationScheme) switch(authenticationScheme){
            case (0, $08c107807d753255$export$901491a717da2ba5).BEARER:
            case (0, $08c107807d753255$export$901491a717da2ba5).POP:
                logger.trace("isNativeAvailable: authenticationScheme is supported, returning true");
                return true;
            default:
                logger.trace("isNativeAvailable: authenticationScheme is not supported, returning false");
                return false;
        }
        return true;
    }
}



/*! @azure/msal-browser v3.30.0 2025-08-05 */ 


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Abstract class which defines operations for a browser interaction handling class.
 */ class $36b133ef1760b48e$export$a30cd982b4e89bdb {
    constructor(authCodeModule, storageImpl, authCodeRequest, logger, performanceClient){
        this.authModule = authCodeModule;
        this.browserStorage = storageImpl;
        this.authCodeRequest = authCodeRequest;
        this.logger = logger;
        this.performanceClient = performanceClient;
    }
    /**
     * Function to handle response parameters from hash.
     * @param locationHash
     */ async handleCodeResponse(response, request) {
        this.performanceClient.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).HandleCodeResponse, request.correlationId);
        let authCodeResponse;
        try {
            authCodeResponse = this.authModule.handleFragmentResponse(response, request.state);
        } catch (e) {
            if (e instanceof (0, $85fc58951e10e394$export$ea52035eac03daf0) && e.subError === (0, $aa0e430adf0f9ba6$export$6bae303c5e922702)) // Translate server error caused by user closing native prompt to corresponding first class MSAL error
            throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$6bae303c5e922702));
            else throw e;
        }
        return (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.handleCodeResponseFromServer.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).HandleCodeResponseFromServer, this.logger, this.performanceClient, request.correlationId)(authCodeResponse, request);
    }
    /**
     * Process auth code response from AAD
     * @param authCodeResponse
     * @param state
     * @param authority
     * @param networkModule
     * @returns
     */ async handleCodeResponseFromServer(authCodeResponse, request, validateNonce = true) {
        this.performanceClient.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).HandleCodeResponseFromServer, request.correlationId);
        this.logger.trace("InteractionHandler.handleCodeResponseFromServer called");
        // Assign code to request
        this.authCodeRequest.code = authCodeResponse.code;
        // Check for new cloud instance
        if (authCodeResponse.cloud_instance_host_name) await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.authModule.updateAuthority.bind(this.authModule), (0, $32170abc11155933$export$2f2811a3e1b21823).UpdateTokenEndpointAuthority, this.logger, this.performanceClient, request.correlationId)(authCodeResponse.cloud_instance_host_name, request.correlationId);
        // Nonce validation not needed when redirect not involved (e.g. hybrid spa, renewing token via rt)
        if (validateNonce) // TODO: Assigning "response nonce" to "request nonce" is confusing. Refactor the function doing validation to accept request nonce directly
        authCodeResponse.nonce = request.nonce || undefined;
        authCodeResponse.state = request.state;
        // Add CCS parameters if available
        if (authCodeResponse.client_info) this.authCodeRequest.clientInfo = authCodeResponse.client_info;
        else {
            const ccsCred = this.createCcsCredentials(request);
            if (ccsCred) this.authCodeRequest.ccsCredential = ccsCred;
        }
        // Acquire token with retrieved code.
        const tokenResponse = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.authModule.acquireToken.bind(this.authModule), (0, $32170abc11155933$export$2f2811a3e1b21823).AuthClientAcquireToken, this.logger, this.performanceClient, request.correlationId)(this.authCodeRequest, authCodeResponse);
        return tokenResponse;
    }
    /**
     * Build ccs creds if available
     */ createCcsCredentials(request) {
        if (request.account) return {
            credential: request.account.homeAccountId,
            type: (0, $36f32d37ad76b0c5$export$17b7b3ac1abef49f).HOME_ACCOUNT_ID
        };
        else if (request.loginHint) return {
            credential: request.loginHint,
            type: (0, $36f32d37ad76b0c5$export$17b7b3ac1abef49f).UPN
        };
        return null;
    }
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $689c4e1b04283aef$export$e64c1808ed72a7c(responseString, responseLocation, logger) {
    // Deserialize hash fragment response parameters.
    const serverParams = (0, $cdc672602db089f1$exports).getDeserializedResponse(responseString);
    if (!serverParams) {
        if (!(0, $cdc672602db089f1$exports).stripLeadingHashOrQuery(responseString)) {
            // Hash or Query string is empty
            logger.error(`The request has returned to the redirectUri but a ${responseLocation} is not present. It's likely that the ${responseLocation} has been removed or the page has been redirected by code running on the redirectUri page.`);
            throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$a29c42a1dd414317));
        } else {
            logger.error(`A ${responseLocation} is present in the iframe but it does not contain known properties. It's likely that the ${responseLocation} has been replaced by code running on the redirectUri page.`);
            logger.errorPii(`The ${responseLocation} detected is: ${responseString}`);
            throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$5743873a5ba5d124));
        }
    }
    return serverParams;
}
/**
 * Returns the interaction type that the response object belongs to
 */ function $689c4e1b04283aef$export$af0c72d18284aa0(response, browserCrypto, interactionType) {
    if (!response.state) throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$211c8e8843a8d278));
    const platformStateObj = (0, $e5678e89c6203472$export$68ec87f530f5f536)(browserCrypto, response.state);
    if (!platformStateObj) throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$237bdd0b913cb30c));
    if (platformStateObj.interactionType !== interactionType) throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$499b1b95c97a1c75));
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $ec7c843d99a2cf46$export$43b0fce132d066f4 extends (0, $e3650a1232c7da00$export$fa9179cade3eb05a) {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeStorageImpl, nativeMessageHandler, correlationId){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeMessageHandler, correlationId);
        // Properly sets this reference for the unload event.
        this.unloadWindow = this.unloadWindow.bind(this);
        this.nativeStorage = nativeStorageImpl;
    }
    /**
     * Acquires tokens by opening a popup window to the /authorize endpoint of the authority
     * @param request
     */ acquireToken(request) {
        try {
            const popupName = this.generatePopupName(request.scopes || (0, $08c107807d753255$export$893b1b5b686d84ef), request.authority || this.config.auth.authority);
            const popupParams = {
                popupName: popupName,
                popupWindowAttributes: request.popupWindowAttributes || {},
                popupWindowParent: request.popupWindowParent ?? window
            };
            // asyncPopups flag is true. Acquires token without first opening popup. Popup will be opened later asynchronously.
            if (this.config.system.asyncPopups) {
                this.logger.verbose("asyncPopups set to true, acquiring token");
                // Passes on popup position and dimensions if in request
                return this.acquireTokenPopupAsync(request, popupParams);
            } else {
                // asyncPopups flag is set to false. Opens popup before acquiring token.
                this.logger.verbose("asyncPopup set to false, opening popup before acquiring token");
                popupParams.popup = this.openSizedPopup("about:blank", popupParams);
                return this.acquireTokenPopupAsync(request, popupParams);
            }
        } catch (e) {
            return Promise.reject(e);
        }
    }
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ logout(logoutRequest) {
        try {
            this.logger.verbose("logoutPopup called");
            const validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
            const popupParams = {
                popupName: this.generateLogoutPopupName(validLogoutRequest),
                popupWindowAttributes: logoutRequest?.popupWindowAttributes || {},
                popupWindowParent: logoutRequest?.popupWindowParent ?? window
            };
            const authority = logoutRequest && logoutRequest.authority;
            const mainWindowRedirectUri = logoutRequest && logoutRequest.mainWindowRedirectUri;
            // asyncPopups flag is true. Acquires token without first opening popup. Popup will be opened later asynchronously.
            if (this.config.system.asyncPopups) {
                this.logger.verbose("asyncPopups set to true");
                // Passes on popup position and dimensions if in request
                return this.logoutPopupAsync(validLogoutRequest, popupParams, authority, mainWindowRedirectUri);
            } else {
                // asyncPopups flag is set to false. Opens popup before logging out.
                this.logger.verbose("asyncPopup set to false, opening popup");
                popupParams.popup = this.openSizedPopup("about:blank", popupParams);
                return this.logoutPopupAsync(validLogoutRequest, popupParams, authority, mainWindowRedirectUri);
            }
        } catch (e) {
            // Since this function is synchronous we need to reject
            return Promise.reject(e);
        }
    }
    /**
     * Helper which obtains an access_token for your API via opening a popup window in the user's browser
     * @param validRequest
     * @param popupName
     * @param popup
     * @param popupWindowAttributes
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async acquireTokenPopupAsync(request, popupParams) {
        this.logger.verbose("acquireTokenPopupAsync called");
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $091acf4c2675819b$export$192d74ad69b40705).acquireTokenPopup);
        const validRequest = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.initializeAuthorizationRequest.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, this.correlationId)(request, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Popup);
        (0, $deacecf435b3f5ad$export$a0816fa17a9e79be)(validRequest.authority);
        try {
            // Create auth code request and generate PKCE params
            const authCodeRequest = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.initializeAuthorizationCodeRequest.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationCodeRequest, this.logger, this.performanceClient, this.correlationId)(validRequest);
            // Initialize the client
            const authClient = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: validRequest.authority,
                requestAzureCloudOptions: validRequest.azureCloudOptions,
                requestExtraQueryParameters: validRequest.extraQueryParameters,
                account: validRequest.account
            });
            const isNativeBroker = (0, $6031f29937eca509$export$c98888b8059e2702).isNativeAvailable(this.config, this.logger, this.nativeMessageHandler, request.authenticationScheme);
            // Start measurement for server calls with native brokering enabled
            let fetchNativeAccountIdMeasurement;
            if (isNativeBroker) fetchNativeAccountIdMeasurement = this.performanceClient.startMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).FetchAccountIdWithNativeBroker, request.correlationId);
            // Create acquire token url.
            const navigateUrl = await authClient.getAuthCodeUrl({
                ...validRequest,
                nativeBroker: isNativeBroker
            });
            // Create popup interaction handler.
            const interactionHandler = new (0, $36b133ef1760b48e$export$a30cd982b4e89bdb)(authClient, this.browserStorage, authCodeRequest, this.logger, this.performanceClient);
            // Show the UI once the url has been created. Get the window handle for the popup.
            const popupWindow = this.initiateAuthRequest(navigateUrl, popupParams);
            this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).POPUP_OPENED, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Popup, {
                popupWindow: popupWindow
            }, null);
            // Monitor the window for the hash. Return the string value and close the popup when the hash is received. Default timeout is 60 seconds.
            const responseString = await this.monitorPopupForHash(popupWindow, popupParams.popupWindowParent);
            const serverParams = (0, $4832f15bf602f56d$export$468cda29b159ee5d)((0, $689c4e1b04283aef$export$e64c1808ed72a7c), (0, $32170abc11155933$export$2f2811a3e1b21823).DeserializeResponse, this.logger, this.performanceClient, this.correlationId)(responseString, this.config.auth.OIDCOptions.serverResponseType, this.logger);
            // Remove throttle if it exists
            (0, $a5c865990da19377$export$c060a619741dd765).removeThrottle(this.browserStorage, this.config.auth.clientId, authCodeRequest);
            if (serverParams.accountId) {
                this.logger.verbose("Account id found in hash, calling WAM for token");
                // end measurement for server call with native brokering enabled
                if (fetchNativeAccountIdMeasurement) fetchNativeAccountIdMeasurement.end({
                    success: true,
                    isNativeBroker: true
                });
                if (!this.nativeMessageHandler) throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$7b7357e3538624aa));
                const nativeInteractionClient = new (0, $b593e4d2c5327969$export$38af86d4cb90fd61)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $091acf4c2675819b$export$192d74ad69b40705).acquireTokenPopup, this.performanceClient, this.nativeMessageHandler, serverParams.accountId, this.nativeStorage, validRequest.correlationId);
                const { userRequestState: userRequestState } = (0, $1cc651d5e90b7480$export$871e33217042c65e).parseRequestState(this.browserCrypto, validRequest.state);
                return await nativeInteractionClient.acquireToken({
                    ...validRequest,
                    state: userRequestState,
                    prompt: undefined
                });
            }
            // Handle response from hash string.
            const result = await interactionHandler.handleCodeResponse(serverParams, validRequest);
            return result;
        } catch (e) {
            // Close the synchronous popup if an error is thrown before the window unload event is registered
            popupParams.popup?.close();
            if (e instanceof (0, $53b49d8334c1646a$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        }
    }
    /**
     *
     * @param validRequest
     * @param popupName
     * @param requestAuthority
     * @param popup
     * @param mainWindowRedirectUri
     * @param popupWindowAttributes
     */ async logoutPopupAsync(validRequest, popupParams, requestAuthority, mainWindowRedirectUri) {
        this.logger.verbose("logoutPopupAsync called");
        this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).LOGOUT_START, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Popup, validRequest);
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $091acf4c2675819b$export$192d74ad69b40705).logoutPopup);
        try {
            // Clear cache on logout
            await this.clearCacheOnLogout(validRequest.account);
            // Initialize the client
            const authClient = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: requestAuthority,
                account: validRequest.account || undefined
            });
            try {
                authClient.authority.endSessionEndpoint;
            } catch  {
                if (validRequest.account?.homeAccountId && validRequest.postLogoutRedirectUri && authClient.authority.protocolMode === (0, $a47d2ec0503d310c$export$73a3e3dedd37150d).OIDC) {
                    this.browserStorage.removeAccount(validRequest.account?.homeAccountId, this.correlationId);
                    this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).LOGOUT_SUCCESS, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Popup, validRequest);
                    if (mainWindowRedirectUri) {
                        const navigationOptions = {
                            apiId: (0, $091acf4c2675819b$export$192d74ad69b40705).logoutPopup,
                            timeout: this.config.system.redirectNavigationTimeout,
                            noHistory: false
                        };
                        const absoluteUrl = (0, $ff2860ddbc741970$export$3abcdca7229e54f2).getAbsoluteUrl(mainWindowRedirectUri, (0, $deacecf435b3f5ad$export$1204531fbbf6ecde)());
                        await this.navigationClient.navigateInternal(absoluteUrl, navigationOptions);
                    }
                    popupParams.popup?.close();
                    return;
                }
            }
            // Create logout string and navigate user window to logout.
            const logoutUri = authClient.getLogoutUri(validRequest);
            this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).LOGOUT_SUCCESS, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Popup, validRequest);
            // Open the popup window to requestUrl.
            const popupWindow = this.openPopup(logoutUri, popupParams);
            this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).POPUP_OPENED, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Popup, {
                popupWindow: popupWindow
            }, null);
            await this.monitorPopupForHash(popupWindow, popupParams.popupWindowParent).catch(()=>{
            // Swallow any errors related to monitoring the window. Server logout is best effort
            });
            if (mainWindowRedirectUri) {
                const navigationOptions = {
                    apiId: (0, $091acf4c2675819b$export$192d74ad69b40705).logoutPopup,
                    timeout: this.config.system.redirectNavigationTimeout,
                    noHistory: false
                };
                const absoluteUrl = (0, $ff2860ddbc741970$export$3abcdca7229e54f2).getAbsoluteUrl(mainWindowRedirectUri, (0, $deacecf435b3f5ad$export$1204531fbbf6ecde)());
                this.logger.verbose("Redirecting main window to url specified in the request");
                this.logger.verbosePii(`Redirecting main window to: ${absoluteUrl}`);
                await this.navigationClient.navigateInternal(absoluteUrl, navigationOptions);
            } else this.logger.verbose("No main window navigation requested");
        } catch (e) {
            // Close the synchronous popup if an error is thrown before the window unload event is registered
            popupParams.popup?.close();
            if (e instanceof (0, $53b49d8334c1646a$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            this.browserStorage.setInteractionInProgress(false);
            this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).LOGOUT_FAILURE, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Popup, null, e);
            this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).LOGOUT_END, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Popup);
            throw e;
        }
        this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).LOGOUT_END, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Popup);
    }
    /**
     * Opens a popup window with given request Url.
     * @param requestUrl
     */ initiateAuthRequest(requestUrl, params) {
        // Check that request url is not empty.
        if (requestUrl) {
            this.logger.infoPii(`Navigate to: ${requestUrl}`);
            // Open the popup window to requestUrl.
            return this.openPopup(requestUrl, params);
        } else {
            // Throw error if request URL is empty.
            this.logger.error("Navigate url is empty");
            throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$be9285c64f247822));
        }
    }
    /**
     * Monitors a window until it loads a url with the same origin.
     * @param popupWindow - window that is being monitored
     * @param timeout - timeout for processing hash once popup is redirected back to application
     */ monitorPopupForHash(popupWindow, popupWindowParent) {
        return new Promise((resolve, reject)=>{
            this.logger.verbose("PopupHandler.monitorPopupForHash - polling started");
            const intervalId = setInterval(()=>{
                // Window is closed
                if (popupWindow.closed) {
                    this.logger.error("PopupHandler.monitorPopupForHash - window closed");
                    clearInterval(intervalId);
                    reject((0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$6bae303c5e922702)));
                    return;
                }
                let href = "";
                try {
                    /*
                     * Will throw if cross origin,
                     * which should be caught and ignored
                     * since we need the interval to keep running while on STS UI.
                     */ href = popupWindow.location.href;
                } catch (e) {}
                // Don't process blank pages or cross domain
                if (!href || href === "about:blank") return;
                clearInterval(intervalId);
                let responseString = "";
                const responseType = this.config.auth.OIDCOptions.serverResponseType;
                if (popupWindow) {
                    if (responseType === (0, $08c107807d753255$export$b34cb6fbea2adc44).QUERY) responseString = popupWindow.location.search;
                    else responseString = popupWindow.location.hash;
                }
                this.logger.verbose("PopupHandler.monitorPopupForHash - popup window is on same origin as caller");
                resolve(responseString);
            }, this.config.system.pollIntervalMilliseconds);
        }).finally(()=>{
            this.cleanPopup(popupWindow, popupWindowParent);
        });
    }
    /**
     * @hidden
     *
     * Configures popup window for login.
     *
     * @param urlNavigate
     * @param title
     * @param popUpWidth
     * @param popUpHeight
     * @param popupWindowAttributes
     * @ignore
     * @hidden
     */ openPopup(urlNavigate, popupParams) {
        try {
            let popupWindow;
            // Popup window passed in, setting url to navigate to
            if (popupParams.popup) {
                popupWindow = popupParams.popup;
                this.logger.verbosePii(`Navigating popup window to: ${urlNavigate}`);
                popupWindow.location.assign(urlNavigate);
            } else if (typeof popupParams.popup === "undefined") {
                // Popup will be undefined if it was not passed in
                this.logger.verbosePii(`Opening popup window to: ${urlNavigate}`);
                popupWindow = this.openSizedPopup(urlNavigate, popupParams);
            }
            // Popup will be null if popups are blocked
            if (!popupWindow) throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$5e827e513523a576));
            if (popupWindow.focus) popupWindow.focus();
            this.currentWindow = popupWindow;
            popupParams.popupWindowParent.addEventListener("beforeunload", this.unloadWindow);
            return popupWindow;
        } catch (e) {
            this.logger.error("error opening popup " + e.message);
            this.browserStorage.setInteractionInProgress(false);
            throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$f1b7091ee48d0b3e));
        }
    }
    /**
     * Helper function to set popup window dimensions and position
     * @param urlNavigate
     * @param popupName
     * @param popupWindowAttributes
     * @returns
     */ openSizedPopup(urlNavigate, { popupName: popupName, popupWindowAttributes: popupWindowAttributes, popupWindowParent: popupWindowParent }) {
        /**
         * adding winLeft and winTop to account for dual monitor
         * using screenLeft and screenTop for IE8 and earlier
         */ const winLeft = popupWindowParent.screenLeft ? popupWindowParent.screenLeft : popupWindowParent.screenX;
        const winTop = popupWindowParent.screenTop ? popupWindowParent.screenTop : popupWindowParent.screenY;
        /**
         * window.innerWidth displays browser window"s height and width excluding toolbars
         * using document.documentElement.clientWidth for IE8 and earlier
         */ const winWidth = popupWindowParent.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const winHeight = popupWindowParent.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        let width = popupWindowAttributes.popupSize?.width;
        let height = popupWindowAttributes.popupSize?.height;
        let top = popupWindowAttributes.popupPosition?.top;
        let left = popupWindowAttributes.popupPosition?.left;
        if (!width || width < 0 || width > winWidth) {
            this.logger.verbose("Default popup window width used. Window width not configured or invalid.");
            width = (0, $091acf4c2675819b$export$a0a689e4294b9880).POPUP_WIDTH;
        }
        if (!height || height < 0 || height > winHeight) {
            this.logger.verbose("Default popup window height used. Window height not configured or invalid.");
            height = (0, $091acf4c2675819b$export$a0a689e4294b9880).POPUP_HEIGHT;
        }
        if (!top || top < 0 || top > winHeight) {
            this.logger.verbose("Default popup window top position used. Window top not configured or invalid.");
            top = Math.max(0, winHeight / 2 - (0, $091acf4c2675819b$export$a0a689e4294b9880).POPUP_HEIGHT / 2 + winTop);
        }
        if (!left || left < 0 || left > winWidth) {
            this.logger.verbose("Default popup window left position used. Window left not configured or invalid.");
            left = Math.max(0, winWidth / 2 - (0, $091acf4c2675819b$export$a0a689e4294b9880).POPUP_WIDTH / 2 + winLeft);
        }
        return popupWindowParent.open(urlNavigate, popupName, `width=${width}, height=${height}, top=${top}, left=${left}, scrollbars=yes`);
    }
    /**
     * Event callback to unload main window.
     */ unloadWindow(e) {
        this.browserStorage.cleanRequestByInteractionType((0, $091acf4c2675819b$export$4ec29255e7e7f68f).Popup);
        if (this.currentWindow) this.currentWindow.close();
        // Guarantees browser unload will happen, so no other errors will be thrown.
        e.preventDefault();
    }
    /**
     * Closes popup, removes any state vars created during popup calls.
     * @param popupWindow
     */ cleanPopup(popupWindow, popupWindowParent) {
        // Close window.
        popupWindow.close();
        // Remove window unload function
        popupWindowParent.removeEventListener("beforeunload", this.unloadWindow);
        // Interaction is completed - remove interaction status.
        this.browserStorage.setInteractionInProgress(false);
    }
    /**
     * Generates the name for the popup based on the client id and request
     * @param clientId
     * @param request
     */ generatePopupName(scopes, authority) {
        return `${(0, $091acf4c2675819b$export$a0a689e4294b9880).POPUP_NAME_PREFIX}.${this.config.auth.clientId}.${scopes.join("-")}.${authority}.${this.correlationId}`;
    }
    /**
     * Generates the name for the popup based on the client id and request for logouts
     * @param clientId
     * @param request
     */ generateLogoutPopupName(request) {
        const homeAccountId = request.account && request.account.homeAccountId;
        return `${(0, $091acf4c2675819b$export$a0a689e4294b9880).POPUP_NAME_PREFIX}.${this.config.auth.clientId}.${homeAccountId}.${this.correlationId}`;
    }
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $53cbe5765e8787bf$export$9af91951fcedc08c {
    constructor(authCodeModule, storageImpl, authCodeRequest, logger, performanceClient){
        this.authModule = authCodeModule;
        this.browserStorage = storageImpl;
        this.authCodeRequest = authCodeRequest;
        this.logger = logger;
        this.performanceClient = performanceClient;
    }
    /**
     * Redirects window to given URL.
     * @param urlNavigate
     */ async initiateAuthRequest(requestUrl, params) {
        this.logger.verbose("RedirectHandler.initiateAuthRequest called");
        // Navigate if valid URL
        if (requestUrl) {
            // Cache start page, returns to this page after redirectUri if navigateToLoginRequestUrl is true
            if (params.redirectStartPage) {
                this.logger.verbose("RedirectHandler.initiateAuthRequest: redirectStartPage set, caching start page");
                this.browserStorage.setTemporaryCache((0, $091acf4c2675819b$export$21d55bedf0d269fb).ORIGIN_URI, params.redirectStartPage, true);
            }
            // Set interaction status in the library.
            this.browserStorage.setTemporaryCache((0, $091acf4c2675819b$export$21d55bedf0d269fb).CORRELATION_ID, this.authCodeRequest.correlationId, true);
            this.browserStorage.cacheCodeRequest(this.authCodeRequest);
            this.logger.infoPii(`RedirectHandler.initiateAuthRequest: Navigate to: ${requestUrl}`);
            const navigationOptions = {
                apiId: (0, $091acf4c2675819b$export$192d74ad69b40705).acquireTokenRedirect,
                timeout: params.redirectTimeout,
                noHistory: false
            };
            // If onRedirectNavigate is implemented, invoke it and provide requestUrl
            if (typeof params.onRedirectNavigate === "function") {
                this.logger.verbose("RedirectHandler.initiateAuthRequest: Invoking onRedirectNavigate callback");
                const navigate = params.onRedirectNavigate(requestUrl);
                // Returning false from onRedirectNavigate will stop navigation
                if (navigate !== false) {
                    this.logger.verbose("RedirectHandler.initiateAuthRequest: onRedirectNavigate did not return false, navigating");
                    await params.navigationClient.navigateExternal(requestUrl, navigationOptions);
                    return;
                } else {
                    this.logger.verbose("RedirectHandler.initiateAuthRequest: onRedirectNavigate returned false, stopping navigation");
                    return;
                }
            } else {
                // Navigate window to request URL
                this.logger.verbose("RedirectHandler.initiateAuthRequest: Navigating window to navigate url");
                await params.navigationClient.navigateExternal(requestUrl, navigationOptions);
                return;
            }
        } else {
            // Throw error if request URL is empty.
            this.logger.info("RedirectHandler.initiateAuthRequest: Navigate url is empty");
            throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$be9285c64f247822));
        }
    }
    /**
     * Handle authorization code response in the window.
     * @param hash
     */ async handleCodeResponse(response, state) {
        this.logger.verbose("RedirectHandler.handleCodeResponse called");
        // Interaction is completed - remove interaction status.
        this.browserStorage.setInteractionInProgress(false);
        // Handle code response.
        const stateKey = this.browserStorage.generateStateKey(state);
        const requestState = this.browserStorage.getTemporaryCache(stateKey);
        if (!requestState) throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$exports).stateNotFound, "Cached State");
        let authCodeResponse;
        try {
            authCodeResponse = this.authModule.handleFragmentResponse(response, requestState);
        } catch (e) {
            if (e instanceof (0, $85fc58951e10e394$export$ea52035eac03daf0) && e.subError === (0, $aa0e430adf0f9ba6$export$6bae303c5e922702)) // Translate server error caused by user closing native prompt to corresponding first class MSAL error
            throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$6bae303c5e922702));
            else throw e;
        }
        // Get cached items
        const nonceKey = this.browserStorage.generateNonceKey(requestState);
        const cachedNonce = this.browserStorage.getTemporaryCache(nonceKey);
        // Assign code to request
        this.authCodeRequest.code = authCodeResponse.code;
        // Check for new cloud instance
        if (authCodeResponse.cloud_instance_host_name) await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.authModule.updateAuthority.bind(this.authModule), (0, $32170abc11155933$export$2f2811a3e1b21823).UpdateTokenEndpointAuthority, this.logger, this.performanceClient, this.authCodeRequest.correlationId)(authCodeResponse.cloud_instance_host_name, this.authCodeRequest.correlationId);
        authCodeResponse.nonce = cachedNonce || undefined;
        authCodeResponse.state = requestState;
        // Add CCS parameters if available
        if (authCodeResponse.client_info) this.authCodeRequest.clientInfo = authCodeResponse.client_info;
        else {
            const cachedCcsCred = this.checkCcsCredentials();
            if (cachedCcsCred) this.authCodeRequest.ccsCredential = cachedCcsCred;
        }
        // Acquire token with retrieved code.
        const tokenResponse = await this.authModule.acquireToken(this.authCodeRequest, authCodeResponse);
        this.browserStorage.cleanRequestByState(state);
        return tokenResponse;
    }
    /**
     * Looks up ccs creds in the cache
     */ checkCcsCredentials() {
        // Look up ccs credential in temp cache
        const cachedCcsCred = this.browserStorage.getTemporaryCache((0, $091acf4c2675819b$export$21d55bedf0d269fb).CCS_CREDENTIAL, true);
        if (cachedCcsCred) try {
            return JSON.parse(cachedCcsCred);
        } catch (e) {
            this.authModule.logger.error("Cache credential could not be parsed");
            this.authModule.logger.errorPii(`Cache credential could not be parsed: ${cachedCcsCred}`);
        }
        return null;
    }
}









'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $75323b305c7c385a$var$getNavigationType() {
    if (typeof window === "undefined" || typeof window.performance === "undefined" || typeof window.performance.getEntriesByType !== "function") return undefined;
    const navigationEntries = window.performance.getEntriesByType("navigation");
    const navigation = navigationEntries.length ? navigationEntries[0] : undefined;
    return navigation?.type;
}
class $75323b305c7c385a$export$a368977effbc1ed6 extends (0, $e3650a1232c7da00$export$fa9179cade3eb05a) {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeStorageImpl, nativeMessageHandler, correlationId){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeMessageHandler, correlationId);
        this.nativeStorage = nativeStorageImpl;
    }
    /**
     * Redirects the page to the /authorize endpoint of the IDP
     * @param request
     */ async acquireToken(request) {
        const validRequest = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.initializeAuthorizationRequest.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, this.correlationId)(request, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Redirect);
        this.browserStorage.updateCacheEntries(validRequest.state, validRequest.nonce, validRequest.authority, validRequest.loginHint || "", validRequest.account || null);
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $091acf4c2675819b$export$192d74ad69b40705).acquireTokenRedirect);
        const handleBackButton = (event)=>{
            // Clear temporary cache if the back button is clicked during the redirect flow.
            if (event.persisted) {
                this.logger.verbose("Page was restored from back/forward cache. Clearing temporary cache.");
                this.browserStorage.cleanRequestByState(validRequest.state);
                this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).RESTORE_FROM_BFCACHE, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Redirect);
            }
        };
        try {
            // Create auth code request and generate PKCE params
            const authCodeRequest = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.initializeAuthorizationCodeRequest.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationCodeRequest, this.logger, this.performanceClient, this.correlationId)(validRequest);
            // Initialize the client
            const authClient = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: validRequest.authority,
                requestAzureCloudOptions: validRequest.azureCloudOptions,
                requestExtraQueryParameters: validRequest.extraQueryParameters,
                account: validRequest.account
            });
            // Create redirect interaction handler.
            const interactionHandler = new (0, $53cbe5765e8787bf$export$9af91951fcedc08c)(authClient, this.browserStorage, authCodeRequest, this.logger, this.performanceClient);
            // Create acquire token url.
            const navigateUrl = await authClient.getAuthCodeUrl({
                ...validRequest,
                nativeBroker: (0, $6031f29937eca509$export$c98888b8059e2702).isNativeAvailable(this.config, this.logger, this.nativeMessageHandler, request.authenticationScheme)
            });
            const redirectStartPage = this.getRedirectStartPage(request.redirectStartPage);
            this.logger.verbosePii(`Redirect start page: ${redirectStartPage}`);
            // Clear temporary cache if the back button is clicked during the redirect flow.
            window.addEventListener("pageshow", handleBackButton);
            // Show the UI once the url has been created. Response will come back in the hash, which will be handled in the handleRedirectCallback function.
            return await interactionHandler.initiateAuthRequest(navigateUrl, {
                navigationClient: this.navigationClient,
                redirectTimeout: this.config.system.redirectNavigationTimeout,
                redirectStartPage: redirectStartPage,
                onRedirectNavigate: request.onRedirectNavigate || this.config.auth.onRedirectNavigate
            });
        } catch (e) {
            if (e instanceof (0, $53b49d8334c1646a$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            window.removeEventListener("pageshow", handleBackButton);
            this.browserStorage.cleanRequestByState(validRequest.state);
            throw e;
        }
    }
    /**
     * Checks if navigateToLoginRequestUrl is set, and:
     * - if true, performs logic to cache and navigate
     * - if false, handles hash string and parses response
     * @param hash {string} url hash
     * @param parentMeasurement {InProgressPerformanceEvent} parent measurement
     */ async handleRedirectPromise(hash = "", parentMeasurement) {
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $091acf4c2675819b$export$192d74ad69b40705).handleRedirectPromise);
        try {
            if (!this.browserStorage.isInteractionInProgress(true)) {
                this.logger.info("handleRedirectPromise called but there is no interaction in progress, returning null.");
                return null;
            }
            const [serverParams, responseString] = this.getRedirectResponse(hash || "");
            if (!serverParams) {
                // Not a recognized server response hash or hash not associated with a redirect request
                this.logger.info("handleRedirectPromise did not detect a response as a result of a redirect. Cleaning temporary cache.");
                this.browserStorage.cleanRequestByInteractionType((0, $091acf4c2675819b$export$4ec29255e7e7f68f).Redirect);
                // Do not instrument "no_server_response" if user clicked back button
                if ($75323b305c7c385a$var$getNavigationType() !== "back_forward") parentMeasurement.event.errorCode = "no_server_response";
                else this.logger.verbose("Back navigation event detected. Muting no_server_response error");
                return null;
            }
            // If navigateToLoginRequestUrl is true, get the url where the redirect request was initiated
            const loginRequestUrl = this.browserStorage.getTemporaryCache((0, $091acf4c2675819b$export$21d55bedf0d269fb).ORIGIN_URI, true) || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING;
            const loginRequestUrlNormalized = (0, $ff2860ddbc741970$export$3abcdca7229e54f2).removeHashFromUrl(loginRequestUrl);
            const currentUrlNormalized = (0, $ff2860ddbc741970$export$3abcdca7229e54f2).removeHashFromUrl(window.location.href);
            if (loginRequestUrlNormalized === currentUrlNormalized && this.config.auth.navigateToLoginRequestUrl) {
                // We are on the page we need to navigate to - handle hash
                this.logger.verbose("Current page is loginRequestUrl, handling response");
                if (loginRequestUrl.indexOf("#") > -1) // Replace current hash with non-msal hash, if present
                (0, $deacecf435b3f5ad$export$9bf2691bda54425c)(loginRequestUrl);
                const handleHashResult = await this.handleResponse(serverParams, serverTelemetryManager);
                return handleHashResult;
            } else if (!this.config.auth.navigateToLoginRequestUrl) {
                this.logger.verbose("NavigateToLoginRequestUrl set to false, handling response");
                return await this.handleResponse(serverParams, serverTelemetryManager);
            } else if (!(0, $deacecf435b3f5ad$export$9f140ed41af5108c)() || this.config.system.allowRedirectInIframe) {
                /*
                 * Returned from authority using redirect - need to perform navigation before processing response
                 * Cache the hash to be retrieved after the next redirect
                 */ this.browserStorage.setTemporaryCache((0, $091acf4c2675819b$export$21d55bedf0d269fb).URL_HASH, responseString, true);
                const navigationOptions = {
                    apiId: (0, $091acf4c2675819b$export$192d74ad69b40705).handleRedirectPromise,
                    timeout: this.config.system.redirectNavigationTimeout,
                    noHistory: true
                };
                /**
                 * Default behavior is to redirect to the start page and not process the hash now.
                 * The start page is expected to also call handleRedirectPromise which will process the hash in one of the checks above.
                 */ let processHashOnRedirect = true;
                if (!loginRequestUrl || loginRequestUrl === "null") {
                    // Redirect to home page if login request url is null (real null or the string null)
                    const homepage = (0, $deacecf435b3f5ad$export$60785768478b4ffc)();
                    // Cache the homepage under ORIGIN_URI to ensure cached hash is processed on homepage
                    this.browserStorage.setTemporaryCache((0, $091acf4c2675819b$export$21d55bedf0d269fb).ORIGIN_URI, homepage, true);
                    this.logger.warning("Unable to get valid login request url from cache, redirecting to home page");
                    processHashOnRedirect = await this.navigationClient.navigateInternal(homepage, navigationOptions);
                } else {
                    // Navigate to page that initiated the redirect request
                    this.logger.verbose(`Navigating to loginRequestUrl: ${loginRequestUrl}`);
                    processHashOnRedirect = await this.navigationClient.navigateInternal(loginRequestUrl, navigationOptions);
                }
                // If navigateInternal implementation returns false, handle the hash now
                if (!processHashOnRedirect) return await this.handleResponse(serverParams, serverTelemetryManager);
            }
            return null;
        } catch (e) {
            if (e instanceof (0, $53b49d8334c1646a$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            this.browserStorage.cleanRequestByInteractionType((0, $091acf4c2675819b$export$4ec29255e7e7f68f).Redirect);
            throw e;
        }
    }
    /**
     * Gets the response hash for a redirect request
     * Returns null if interactionType in the state value is not "redirect" or the hash does not contain known properties
     * @param hash
     */ getRedirectResponse(userProvidedResponse) {
        this.logger.verbose("getRedirectResponseHash called");
        // Get current location hash from window or cache.
        let responseString = userProvidedResponse;
        if (!responseString) {
            if (this.config.auth.OIDCOptions.serverResponseType === (0, $08c107807d753255$export$b34cb6fbea2adc44).QUERY) responseString = window.location.search;
            else responseString = window.location.hash;
        }
        let response = (0, $cdc672602db089f1$exports).getDeserializedResponse(responseString);
        if (response) {
            try {
                (0, $689c4e1b04283aef$export$af0c72d18284aa0)(response, this.browserCrypto, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Redirect);
            } catch (e) {
                if (e instanceof (0, $53b49d8334c1646a$export$145273558d58e0ac)) this.logger.error(`Interaction type validation failed due to ${e.errorCode}: ${e.errorMessage}`);
                return [
                    null,
                    ""
                ];
            }
            (0, $deacecf435b3f5ad$export$a20c3032ba81d6aa)(window);
            this.logger.verbose("Hash contains known properties, returning response hash");
            return [
                response,
                responseString
            ];
        }
        const cachedHash = this.browserStorage.getTemporaryCache((0, $091acf4c2675819b$export$21d55bedf0d269fb).URL_HASH, true);
        this.browserStorage.removeItem(this.browserStorage.generateCacheKey((0, $091acf4c2675819b$export$21d55bedf0d269fb).URL_HASH));
        if (cachedHash) {
            response = (0, $cdc672602db089f1$exports).getDeserializedResponse(cachedHash);
            if (response) {
                this.logger.verbose("Hash does not contain known properties, returning cached hash");
                return [
                    response,
                    cachedHash
                ];
            }
        }
        return [
            null,
            ""
        ];
    }
    /**
     * Checks if hash exists and handles in window.
     * @param hash
     * @param state
     */ async handleResponse(serverParams, serverTelemetryManager) {
        const state = serverParams.state;
        if (!state) throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$211c8e8843a8d278));
        const cachedRequest = this.browserStorage.getCachedRequest(state);
        this.logger.verbose("handleResponse called, retrieved cached request");
        if (serverParams.accountId) {
            this.logger.verbose("Account id found in hash, calling WAM for token");
            if (!this.nativeMessageHandler) throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$7b7357e3538624aa));
            const nativeInteractionClient = new (0, $b593e4d2c5327969$export$38af86d4cb90fd61)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $091acf4c2675819b$export$192d74ad69b40705).acquireTokenPopup, this.performanceClient, this.nativeMessageHandler, serverParams.accountId, this.nativeStorage, cachedRequest.correlationId);
            const { userRequestState: userRequestState } = (0, $1cc651d5e90b7480$export$871e33217042c65e).parseRequestState(this.browserCrypto, state);
            return nativeInteractionClient.acquireToken({
                ...cachedRequest,
                state: userRequestState,
                prompt: undefined
            }).finally(()=>{
                this.browserStorage.cleanRequestByState(state);
            });
        }
        // Hash contains known properties - handle and return in callback
        const currentAuthority = this.browserStorage.getCachedAuthority(state);
        if (!currentAuthority) throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$3a2c83e7753553b));
        const authClient = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: serverTelemetryManager,
            requestAuthority: currentAuthority
        });
        (0, $a5c865990da19377$export$c060a619741dd765).removeThrottle(this.browserStorage, this.config.auth.clientId, cachedRequest);
        const interactionHandler = new (0, $53cbe5765e8787bf$export$9af91951fcedc08c)(authClient, this.browserStorage, cachedRequest, this.logger, this.performanceClient);
        return interactionHandler.handleCodeResponse(serverParams, state);
    }
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ async logout(logoutRequest) {
        this.logger.verbose("logoutRedirect called");
        const validLogoutRequest = this.initializeLogoutRequest(logoutRequest);
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $091acf4c2675819b$export$192d74ad69b40705).logout);
        try {
            this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).LOGOUT_START, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Redirect, logoutRequest);
            // Clear cache on logout
            await this.clearCacheOnLogout(validLogoutRequest.account);
            const navigationOptions = {
                apiId: (0, $091acf4c2675819b$export$192d74ad69b40705).logout,
                timeout: this.config.system.redirectNavigationTimeout,
                noHistory: false
            };
            const authClient = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, this.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: logoutRequest && logoutRequest.authority,
                requestExtraQueryParameters: logoutRequest?.extraQueryParameters,
                account: logoutRequest && logoutRequest.account || undefined
            });
            if (authClient.authority.protocolMode === (0, $a47d2ec0503d310c$export$73a3e3dedd37150d).OIDC) try {
                authClient.authority.endSessionEndpoint;
            } catch  {
                if (validLogoutRequest.account?.homeAccountId) {
                    this.browserStorage.removeAccount(validLogoutRequest.account?.homeAccountId, this.correlationId);
                    this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).LOGOUT_SUCCESS, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Redirect, validLogoutRequest);
                    return;
                }
            }
            // Create logout string and navigate user window to logout.
            const logoutUri = authClient.getLogoutUri(validLogoutRequest);
            this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).LOGOUT_SUCCESS, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Redirect, validLogoutRequest);
            // Check if onRedirectNavigate is implemented, and invoke it if so
            if (logoutRequest && typeof logoutRequest.onRedirectNavigate === "function") {
                const navigate = logoutRequest.onRedirectNavigate(logoutUri);
                if (navigate !== false) {
                    this.logger.verbose("Logout onRedirectNavigate did not return false, navigating");
                    // Ensure interaction is in progress
                    if (!this.browserStorage.getInteractionInProgress()) this.browserStorage.setInteractionInProgress(true);
                    await this.navigationClient.navigateExternal(logoutUri, navigationOptions);
                    return;
                } else {
                    // Ensure interaction is not in progress
                    this.browserStorage.setInteractionInProgress(false);
                    this.logger.verbose("Logout onRedirectNavigate returned false, stopping navigation");
                }
            } else {
                // Ensure interaction is in progress
                if (!this.browserStorage.getInteractionInProgress()) this.browserStorage.setInteractionInProgress(true);
                await this.navigationClient.navigateExternal(logoutUri, navigationOptions);
                return;
            }
        } catch (e) {
            if (e instanceof (0, $53b49d8334c1646a$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).LOGOUT_FAILURE, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Redirect, null, e);
            this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).LOGOUT_END, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Redirect);
            throw e;
        }
        this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).LOGOUT_END, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Redirect);
    }
    /**
     * Use to get the redirectStartPage either from request or use current window
     * @param requestStartPage
     */ getRedirectStartPage(requestStartPage) {
        const redirectStartPage = requestStartPage || window.location.href;
        return (0, $ff2860ddbc741970$export$3abcdca7229e54f2).getAbsoluteUrl(redirectStartPage, (0, $deacecf435b3f5ad$export$1204531fbbf6ecde)());
    }
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 



/*! @azure/msal-browser v3.30.0 2025-08-05 */ 



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Creates a hidden iframe to given URL using user-requested scopes as an id.
 * @param urlNavigate
 * @param userRequestScopes
 */ async function $d3b6538fb609b4d8$export$57f8a7967bf66c8e(requestUrl, performanceClient, logger, correlationId, navigateFrameWait) {
    performanceClient.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).SilentHandlerInitiateAuthRequest, correlationId);
    if (!requestUrl) {
        // Throw error if request URL is empty.
        logger.info("Navigate url is empty");
        throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$be9285c64f247822));
    }
    if (navigateFrameWait) return (0, $4832f15bf602f56d$export$e4feded94d9adb18)($d3b6538fb609b4d8$var$loadFrame, (0, $32170abc11155933$export$2f2811a3e1b21823).SilentHandlerLoadFrame, logger, performanceClient, correlationId)(requestUrl, navigateFrameWait, performanceClient, correlationId);
    return (0, $4832f15bf602f56d$export$468cda29b159ee5d)($d3b6538fb609b4d8$var$loadFrameSync, (0, $32170abc11155933$export$2f2811a3e1b21823).SilentHandlerLoadFrameSync, logger, performanceClient, correlationId)(requestUrl);
}
/**
 * Monitors an iframe content window until it loads a url with a known hash, or hits a specified timeout.
 * @param iframe
 * @param timeout
 */ async function $d3b6538fb609b4d8$export$9ee275d2f26db8a7(iframe, timeout, pollIntervalMilliseconds, performanceClient, logger, correlationId, responseType) {
    performanceClient.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).SilentHandlerMonitorIframeForHash, correlationId);
    return new Promise((resolve, reject)=>{
        if (timeout < (0, $06f12bd748d4f674$export$f3ffe700be354b19)) logger.warning(`system.loadFrameTimeout or system.iframeHashTimeout set to lower (${timeout}ms) than the default (${(0, $06f12bd748d4f674$export$f3ffe700be354b19)}ms). This may result in timeouts.`);
        /*
         * Polling for iframes can be purely timing based,
         * since we don't need to account for interaction.
         */ const timeoutId = window.setTimeout(()=>{
            window.clearInterval(intervalId);
            reject((0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$c8b6efb19551013d)));
        }, timeout);
        const intervalId = window.setInterval(()=>{
            let href = "";
            const contentWindow = iframe.contentWindow;
            try {
                /*
                 * Will throw if cross origin,
                 * which should be caught and ignored
                 * since we need the interval to keep running while on STS UI.
                 */ href = contentWindow ? contentWindow.location.href : "";
            } catch (e) {}
            if (!href || href === "about:blank") return;
            let responseString = "";
            if (contentWindow) {
                if (responseType === (0, $08c107807d753255$export$b34cb6fbea2adc44).QUERY) responseString = contentWindow.location.search;
                else responseString = contentWindow.location.hash;
            }
            window.clearTimeout(timeoutId);
            window.clearInterval(intervalId);
            resolve(responseString);
        }, pollIntervalMilliseconds);
    }).finally(()=>{
        (0, $4832f15bf602f56d$export$468cda29b159ee5d)($d3b6538fb609b4d8$var$removeHiddenIframe, (0, $32170abc11155933$export$2f2811a3e1b21823).RemoveHiddenIframe, logger, performanceClient, correlationId)(iframe);
    });
}
/**
 * @hidden
 * Loads iframe with authorization endpoint URL
 * @ignore
 * @deprecated
 */ function $d3b6538fb609b4d8$var$loadFrame(urlNavigate, navigateFrameWait, performanceClient, correlationId) {
    performanceClient.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).SilentHandlerLoadFrame, correlationId);
    /*
     * This trick overcomes iframe navigation in IE
     * IE does not load the page consistently in iframe
     */ return new Promise((resolve, reject)=>{
        const frameHandle = $d3b6538fb609b4d8$var$createHiddenIframe();
        window.setTimeout(()=>{
            if (!frameHandle) {
                reject("Unable to load iframe");
                return;
            }
            frameHandle.src = urlNavigate;
            resolve(frameHandle);
        }, navigateFrameWait);
    });
}
/**
 * @hidden
 * Loads the iframe synchronously when the navigateTimeFrame is set to `0`
 * @param urlNavigate
 * @param frameName
 * @param logger
 */ function $d3b6538fb609b4d8$var$loadFrameSync(urlNavigate) {
    const frameHandle = $d3b6538fb609b4d8$var$createHiddenIframe();
    frameHandle.src = urlNavigate;
    return frameHandle;
}
/**
 * @hidden
 * Creates a new hidden iframe or gets an existing one for silent token renewal.
 * @ignore
 */ function $d3b6538fb609b4d8$var$createHiddenIframe() {
    const authFrame = document.createElement("iframe");
    authFrame.className = "msalSilentIframe";
    authFrame.style.visibility = "hidden";
    authFrame.style.position = "absolute";
    authFrame.style.width = authFrame.style.height = "0";
    authFrame.style.border = "0";
    authFrame.setAttribute("sandbox", "allow-scripts allow-same-origin allow-forms");
    document.body.appendChild(authFrame);
    return authFrame;
}
/**
 * @hidden
 * Removes a hidden iframe from the page.
 * @ignore
 */ function $d3b6538fb609b4d8$var$removeHiddenIframe(iframe) {
    if (document.body === iframe.parentNode) document.body.removeChild(iframe);
}








'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $15e51d94ebb188a3$export$e81c7938bccef977 extends (0, $e3650a1232c7da00$export$fa9179cade3eb05a) {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, nativeStorageImpl, nativeMessageHandler, correlationId){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeMessageHandler, correlationId);
        this.apiId = apiId;
        this.nativeStorage = nativeStorageImpl;
    }
    /**
     * Acquires a token silently by opening a hidden iframe to the /authorize endpoint with prompt=none or prompt=no_session
     * @param request
     */ async acquireToken(request) {
        this.performanceClient.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).SilentIframeClientAcquireToken, request.correlationId);
        // Check that we have some SSO data
        if (!request.loginHint && !request.sid && (!request.account || !request.account.username)) this.logger.warning("No user hint provided. The authorization server may need more information to complete this request.");
        // Check the prompt value
        const inputRequest = {
            ...request
        };
        if (inputRequest.prompt) {
            if (inputRequest.prompt !== (0, $08c107807d753255$export$49a06cbda5acaa5).NONE && inputRequest.prompt !== (0, $08c107807d753255$export$49a06cbda5acaa5).NO_SESSION) {
                this.logger.warning(`SilentIframeClient. Replacing invalid prompt ${inputRequest.prompt} with ${(0, $08c107807d753255$export$49a06cbda5acaa5).NONE}`);
                inputRequest.prompt = (0, $08c107807d753255$export$49a06cbda5acaa5).NONE;
            }
        } else inputRequest.prompt = (0, $08c107807d753255$export$49a06cbda5acaa5).NONE;
        // Create silent request
        const silentRequest = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.initializeAuthorizationRequest.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, request.correlationId)(inputRequest, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Silent);
        (0, $deacecf435b3f5ad$export$a0816fa17a9e79be)(silentRequest.authority);
        const serverTelemetryManager = this.initializeServerTelemetryManager(this.apiId);
        let authClient;
        try {
            // Initialize the client
            authClient = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.createAuthCodeClient.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).StandardInteractionClientCreateAuthCodeClient, this.logger, this.performanceClient, request.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: silentRequest.authority,
                requestAzureCloudOptions: silentRequest.azureCloudOptions,
                requestExtraQueryParameters: silentRequest.extraQueryParameters,
                account: silentRequest.account
            });
            return await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.silentTokenHelper.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).SilentIframeClientTokenHelper, this.logger, this.performanceClient, request.correlationId)(authClient, silentRequest);
        } catch (e) {
            if (e instanceof (0, $53b49d8334c1646a$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            if (!authClient || !(e instanceof (0, $53b49d8334c1646a$export$145273558d58e0ac)) || e.errorCode !== (0, $091acf4c2675819b$export$a0a689e4294b9880).INVALID_GRANT_ERROR) throw e;
            this.performanceClient.addFields({
                retryError: e.errorCode
            }, this.correlationId);
            const retrySilentRequest = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.initializeAuthorizationRequest.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, request.correlationId)(inputRequest, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Silent);
            return await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.silentTokenHelper.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).SilentIframeClientTokenHelper, this.logger, this.performanceClient, this.correlationId)(authClient, retrySilentRequest);
        }
    }
    /**
     * Currently Unsupported
     */ logout() {
        // Synchronous so we must reject
        return Promise.reject((0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$78523a40be105a03)));
    }
    /**
     * Helper which acquires an authorization code silently using a hidden iframe from given url
     * using the scopes requested as part of the id, and exchanges the code for a set of OAuth tokens.
     * @param navigateUrl
     * @param userRequestScopes
     */ async silentTokenHelper(authClient, silentRequest) {
        const correlationId = silentRequest.correlationId;
        this.performanceClient.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).SilentIframeClientTokenHelper, correlationId);
        // Create auth code request and generate PKCE params
        const authCodeRequest = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.initializeAuthorizationCodeRequest.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationCodeRequest, this.logger, this.performanceClient, correlationId)(silentRequest);
        // Create authorize request url
        const navigateUrl = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(authClient.getAuthCodeUrl.bind(authClient), (0, $32170abc11155933$export$2f2811a3e1b21823).GetAuthCodeUrl, this.logger, this.performanceClient, correlationId)({
            ...silentRequest,
            nativeBroker: (0, $6031f29937eca509$export$c98888b8059e2702).isNativeAvailable(this.config, this.logger, this.nativeMessageHandler, silentRequest.authenticationScheme)
        });
        // Create silent handler
        const interactionHandler = new (0, $36b133ef1760b48e$export$a30cd982b4e89bdb)(authClient, this.browserStorage, authCodeRequest, this.logger, this.performanceClient);
        // Get the frame handle for the silent request
        const msalFrame = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)((0, $d3b6538fb609b4d8$export$57f8a7967bf66c8e), (0, $32170abc11155933$export$2f2811a3e1b21823).SilentHandlerInitiateAuthRequest, this.logger, this.performanceClient, correlationId)(navigateUrl, this.performanceClient, this.logger, correlationId, this.config.system.navigateFrameWait);
        const responseType = this.config.auth.OIDCOptions.serverResponseType;
        // Monitor the window for the hash. Return the string value and close the popup when the hash is received. Default timeout is 60 seconds.
        const responseString = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)((0, $d3b6538fb609b4d8$export$9ee275d2f26db8a7), (0, $32170abc11155933$export$2f2811a3e1b21823).SilentHandlerMonitorIframeForHash, this.logger, this.performanceClient, correlationId)(msalFrame, this.config.system.iframeHashTimeout, this.config.system.pollIntervalMilliseconds, this.performanceClient, this.logger, correlationId, responseType);
        const serverParams = (0, $4832f15bf602f56d$export$468cda29b159ee5d)((0, $689c4e1b04283aef$export$e64c1808ed72a7c), (0, $32170abc11155933$export$2f2811a3e1b21823).DeserializeResponse, this.logger, this.performanceClient, this.correlationId)(responseString, responseType, this.logger);
        if (serverParams.accountId) {
            this.logger.verbose("Account id found in hash, calling WAM for token");
            if (!this.nativeMessageHandler) throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$7b7357e3538624aa));
            const nativeInteractionClient = new (0, $b593e4d2c5327969$export$38af86d4cb90fd61)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.apiId, this.performanceClient, this.nativeMessageHandler, serverParams.accountId, this.browserStorage, correlationId);
            const { userRequestState: userRequestState } = (0, $1cc651d5e90b7480$export$871e33217042c65e).parseRequestState(this.browserCrypto, silentRequest.state);
            return (0, $4832f15bf602f56d$export$e4feded94d9adb18)(nativeInteractionClient.acquireToken.bind(nativeInteractionClient), (0, $32170abc11155933$export$2f2811a3e1b21823).NativeInteractionClientAcquireToken, this.logger, this.performanceClient, correlationId)({
                ...silentRequest,
                state: userRequestState,
                prompt: silentRequest.prompt || (0, $08c107807d753255$export$49a06cbda5acaa5).NONE
            });
        }
        // Handle response from hash string
        return (0, $4832f15bf602f56d$export$e4feded94d9adb18)(interactionHandler.handleCodeResponse.bind(interactionHandler), (0, $32170abc11155933$export$2f2811a3e1b21823).HandleCodeResponse, this.logger, this.performanceClient, correlationId)(serverParams, silentRequest);
    }
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 





'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $fc15c9be3b8e87fe$export$b4a36596822a5d2 extends (0, $e3650a1232c7da00$export$fa9179cade3eb05a) {
    /**
     * Exchanges the refresh token for new tokens
     * @param request
     */ async acquireToken(request) {
        this.performanceClient.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).SilentRefreshClientAcquireToken, request.correlationId);
        const baseRequest = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)((0, $4b44e4e159274463$export$8e461fcf1fd6910b), (0, $32170abc11155933$export$2f2811a3e1b21823).InitializeBaseRequest, this.logger, this.performanceClient, request.correlationId)(request, this.config, this.performanceClient, this.logger);
        const silentRequest = {
            ...request,
            ...baseRequest
        };
        if (request.redirectUri) // Make sure any passed redirectUri is converted to an absolute URL - redirectUri is not a required parameter for refresh token redemption so only include if explicitly provided
        silentRequest.redirectUri = this.getRedirectUri(request.redirectUri);
        const serverTelemetryManager = this.initializeServerTelemetryManager((0, $091acf4c2675819b$export$192d74ad69b40705).acquireTokenSilent_silentFlow);
        const refreshTokenClient = await this.createRefreshTokenClient({
            serverTelemetryManager: serverTelemetryManager,
            authorityUrl: silentRequest.authority,
            azureCloudOptions: silentRequest.azureCloudOptions,
            account: silentRequest.account
        });
        // Send request to renew token. Auth module will throw errors if token cannot be renewed.
        return (0, $4832f15bf602f56d$export$e4feded94d9adb18)(refreshTokenClient.acquireTokenByRefreshToken.bind(refreshTokenClient), (0, $32170abc11155933$export$2f2811a3e1b21823).RefreshTokenClientAcquireTokenByRefreshToken, this.logger, this.performanceClient, request.correlationId)(silentRequest).catch((e)=>{
            e.setCorrelationId(this.correlationId);
            serverTelemetryManager.cacheFailedRequest(e);
            throw e;
        });
    }
    /**
     * Currently Unsupported
     */ logout() {
        // Synchronous so we must reject
        return Promise.reject((0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$78523a40be105a03)));
    }
    /**
     * Creates a Refresh Client with the given authority, or the default authority.
     * @param params {
     *         serverTelemetryManager: ServerTelemetryManager;
     *         authorityUrl?: string;
     *         azureCloudOptions?: AzureCloudOptions;
     *         extraQueryParams?: StringDict;
     *         account?: AccountInfo;
     *        }
     */ async createRefreshTokenClient(params) {
        // Create auth module.
        const clientConfig = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.getClientConfiguration.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.logger, this.performanceClient, this.correlationId)({
            serverTelemetryManager: params.serverTelemetryManager,
            requestAuthority: params.authorityUrl,
            requestAzureCloudOptions: params.azureCloudOptions,
            requestExtraQueryParameters: params.extraQueryParameters,
            account: params.account
        });
        return new (0, $2c8fb1fd5a5f37d1$export$9cb096b89b92d8a8)(clientConfig, this.performanceClient);
    }
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Token cache manager
 */ class $89f7a63eb8a30ef6$export$ed5d1a18907a1001 {
    constructor(configuration, storage, logger, cryptoObj){
        this.isBrowserEnvironment = typeof window !== "undefined";
        this.config = configuration;
        this.storage = storage;
        this.logger = logger;
        this.cryptoObj = cryptoObj;
    }
    // Move getAllAccounts here and cache utility APIs
    /**
     * API to load tokens to msal-browser cache.
     * @param request
     * @param response
     * @param options
     * @returns `AuthenticationResult` for the response that was loaded.
     */ loadExternalTokens(request, response, options) {
        if (!this.isBrowserEnvironment) throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$932e0f52d657f7fb));
        const correlationId = request.correlationId || (0, $b512579b1150f905$export$6ef0355fa80a5278)();
        const idTokenClaims = response.id_token ? (0, $dfbf8cbb9a592daa$exports).extractTokenClaims(response.id_token, (0, $823c1cd3d50f09ac$export$c62426fdd000a97e)) : undefined;
        const authorityOptions = {
            protocolMode: this.config.auth.protocolMode,
            knownAuthorities: this.config.auth.knownAuthorities,
            cloudDiscoveryMetadata: this.config.auth.cloudDiscoveryMetadata,
            authorityMetadata: this.config.auth.authorityMetadata,
            skipAuthorityMetadataCache: this.config.auth.skipAuthorityMetadataCache
        };
        const authority = request.authority ? new (0, $dda2270c89fd90c8$export$f1c6ec2e6d68c49c)((0, $dda2270c89fd90c8$export$f1c6ec2e6d68c49c).generateAuthority(request.authority, request.azureCloudOptions), this.config.system.networkClient, this.storage, authorityOptions, this.logger, request.correlationId || (0, $b512579b1150f905$export$6ef0355fa80a5278)()) : undefined;
        const cacheRecordAccount = this.loadAccount(request, options.clientInfo || response.client_info || "", correlationId, idTokenClaims, authority);
        const idToken = this.loadIdToken(response, cacheRecordAccount.homeAccountId, cacheRecordAccount.environment, cacheRecordAccount.realm, correlationId);
        const accessToken = this.loadAccessToken(request, response, cacheRecordAccount.homeAccountId, cacheRecordAccount.environment, cacheRecordAccount.realm, options, correlationId);
        const refreshToken = this.loadRefreshToken(response, cacheRecordAccount.homeAccountId, cacheRecordAccount.environment, correlationId);
        return this.generateAuthenticationResult(request, {
            account: cacheRecordAccount,
            idToken: idToken,
            accessToken: accessToken,
            refreshToken: refreshToken
        }, idTokenClaims, authority);
    }
    /**
     * Helper function to load account to msal-browser cache
     * @param idToken
     * @param environment
     * @param clientInfo
     * @param authorityType
     * @param requestHomeAccountId
     * @returns `AccountEntity`
     */ loadAccount(request, clientInfo, correlationId, idTokenClaims, authority) {
        this.logger.verbose("TokenCache - loading account");
        if (request.account) {
            const accountEntity = (0, $35a4414ce05ac30e$export$680160523e6bfa6a).createFromAccountInfo(request.account);
            this.storage.setAccount(accountEntity, correlationId);
            return accountEntity;
        } else if (!authority || !clientInfo && !idTokenClaims) {
            this.logger.error("TokenCache - if an account is not provided on the request, authority and either clientInfo or idToken must be provided instead.");
            throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$6acf650331eb5f5f));
        }
        const homeAccountId = (0, $35a4414ce05ac30e$export$680160523e6bfa6a).generateHomeAccountId(clientInfo, authority.authorityType, this.logger, this.cryptoObj, idTokenClaims);
        const claimsTenantId = idTokenClaims?.tid;
        const cachedAccount = (0, $85344044ef39ab89$export$73b84062d58a1307)(this.storage, authority, homeAccountId, (0, $823c1cd3d50f09ac$export$c62426fdd000a97e), correlationId, idTokenClaims, clientInfo, authority.hostnameAndPort, claimsTenantId, undefined, undefined, this.logger);
        this.storage.setAccount(cachedAccount, correlationId);
        return cachedAccount;
    }
    /**
     * Helper function to load id tokens to msal-browser cache
     * @param idToken
     * @param homeAccountId
     * @param environment
     * @param tenantId
     * @returns `IdTokenEntity`
     */ loadIdToken(response, homeAccountId, environment, tenantId, correlationId) {
        if (!response.id_token) {
            this.logger.verbose("TokenCache - no id token found in response");
            return null;
        }
        this.logger.verbose("TokenCache - loading id token");
        const idTokenEntity = (0, $bd840ab348a8e6dd$exports).createIdTokenEntity(homeAccountId, environment, response.id_token, this.config.auth.clientId, tenantId);
        this.storage.setIdTokenCredential(idTokenEntity, correlationId);
        return idTokenEntity;
    }
    /**
     * Helper function to load access tokens to msal-browser cache
     * @param request
     * @param response
     * @param homeAccountId
     * @param environment
     * @param tenantId
     * @returns `AccessTokenEntity`
     */ loadAccessToken(request, response, homeAccountId, environment, tenantId, options, correlationId) {
        if (!response.access_token) {
            this.logger.verbose("TokenCache - no access token found in response");
            return null;
        } else if (!response.expires_in) {
            this.logger.error("TokenCache - no expiration set on the access token. Cannot add it to the cache.");
            return null;
        } else if (!response.scope && (!request.scopes || !request.scopes.length)) {
            this.logger.error("TokenCache - scopes not specified in the request or response. Cannot add token to the cache.");
            return null;
        }
        this.logger.verbose("TokenCache - loading access token");
        const scopes = response.scope ? (0, $d671ba25592fe375$export$b9b82b0f94ae1f99).fromString(response.scope) : new (0, $d671ba25592fe375$export$b9b82b0f94ae1f99)(request.scopes);
        const expiresOn = options.expiresOn || response.expires_in + new Date().getTime() / 1000;
        const extendedExpiresOn = options.extendedExpiresOn || (response.ext_expires_in || response.expires_in) + new Date().getTime() / 1000;
        const accessTokenEntity = (0, $bd840ab348a8e6dd$exports).createAccessTokenEntity(homeAccountId, environment, response.access_token, this.config.auth.clientId, tenantId, scopes.printScopes(), expiresOn, extendedExpiresOn, (0, $823c1cd3d50f09ac$export$c62426fdd000a97e));
        this.storage.setAccessTokenCredential(accessTokenEntity, correlationId);
        return accessTokenEntity;
    }
    /**
     * Helper function to load refresh tokens to msal-browser cache
     * @param request
     * @param response
     * @param homeAccountId
     * @param environment
     * @returns `RefreshTokenEntity`
     */ loadRefreshToken(response, homeAccountId, environment, correlationId) {
        if (!response.refresh_token) {
            this.logger.verbose("TokenCache - no refresh token found in response");
            return null;
        }
        this.logger.verbose("TokenCache - loading refresh token");
        const refreshTokenEntity = (0, $bd840ab348a8e6dd$exports).createRefreshTokenEntity(homeAccountId, environment, response.refresh_token, this.config.auth.clientId, response.foci, undefined, response.refresh_token_expires_in);
        this.storage.setRefreshTokenCredential(refreshTokenEntity, correlationId);
        return refreshTokenEntity;
    }
    /**
     * Helper function to generate an `AuthenticationResult` for the result.
     * @param request
     * @param idTokenObj
     * @param cacheRecord
     * @param authority
     * @returns `AuthenticationResult`
     */ generateAuthenticationResult(request, cacheRecord, idTokenClaims, authority) {
        let accessToken = "";
        let responseScopes = [];
        let expiresOn = null;
        let extExpiresOn;
        if (cacheRecord?.accessToken) {
            accessToken = cacheRecord.accessToken.secret;
            responseScopes = (0, $d671ba25592fe375$export$b9b82b0f94ae1f99).fromString(cacheRecord.accessToken.target).asArray();
            expiresOn = new Date(Number(cacheRecord.accessToken.expiresOn) * 1000);
            extExpiresOn = new Date(Number(cacheRecord.accessToken.extendedExpiresOn) * 1000);
        }
        const accountEntity = cacheRecord.account;
        return {
            authority: authority ? authority.canonicalAuthority : "",
            uniqueId: cacheRecord.account.localAccountId,
            tenantId: cacheRecord.account.realm,
            scopes: responseScopes,
            account: accountEntity.getAccountInfo(),
            idToken: cacheRecord.idToken?.secret || "",
            idTokenClaims: idTokenClaims || {},
            accessToken: accessToken,
            fromCache: true,
            expiresOn: expiresOn,
            correlationId: request.correlationId || "",
            requestId: "",
            extExpiresOn: extExpiresOn,
            familyId: cacheRecord.refreshToken?.familyId || "",
            tokenType: cacheRecord?.accessToken?.tokenType || "",
            state: request.state || "",
            cloudGraphHostName: accountEntity.cloudGraphHostName || "",
            msGraphHost: accountEntity.msGraphHost || "",
            fromNativeBroker: false
        };
    }
}






/*! @azure/msal-browser v3.30.0 2025-08-05 */ 



/*! @azure/msal-browser v3.30.0 2025-08-05 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $78dda38a63fcf82b$export$a2dbbd28e9bce542 extends (0, $402bc6236039ff02$export$8538731fd397fb90) {
    constructor(config){
        super(config);
        this.includeRedirectUri = false;
    }
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $a2c52b90bfd3ac63$export$d7f5ef311b3e9fca extends (0, $e3650a1232c7da00$export$fa9179cade3eb05a) {
    constructor(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, apiId, performanceClient, nativeMessageHandler, correlationId){
        super(config, storageImpl, browserCrypto, logger, eventHandler, navigationClient, performanceClient, nativeMessageHandler, correlationId);
        this.apiId = apiId;
    }
    /**
     * Acquires a token silently by redeeming an authorization code against the /token endpoint
     * @param request
     */ async acquireToken(request) {
        // Auth code payload is required
        if (!request.code) throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$e502d98cd8d2da43));
        // Create silent request
        const silentRequest = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.initializeAuthorizationRequest.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).StandardInteractionClientInitializeAuthorizationRequest, this.logger, this.performanceClient, request.correlationId)(request, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Silent);
        const serverTelemetryManager = this.initializeServerTelemetryManager(this.apiId);
        try {
            // Create auth code request (PKCE not needed)
            const authCodeRequest = {
                ...silentRequest,
                code: request.code
            };
            // Initialize the client
            const clientConfig = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.getClientConfiguration.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).StandardInteractionClientGetClientConfiguration, this.logger, this.performanceClient, request.correlationId)({
                serverTelemetryManager: serverTelemetryManager,
                requestAuthority: silentRequest.authority,
                requestAzureCloudOptions: silentRequest.azureCloudOptions,
                requestExtraQueryParameters: silentRequest.extraQueryParameters,
                account: silentRequest.account
            });
            const authClient = new (0, $78dda38a63fcf82b$export$a2dbbd28e9bce542)(clientConfig);
            this.logger.verbose("Auth code client created");
            // Create silent handler
            const interactionHandler = new (0, $36b133ef1760b48e$export$a30cd982b4e89bdb)(authClient, this.browserStorage, authCodeRequest, this.logger, this.performanceClient);
            // Handle auth code parameters from request
            return await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(interactionHandler.handleCodeResponseFromServer.bind(interactionHandler), (0, $32170abc11155933$export$2f2811a3e1b21823).HandleCodeResponseFromServer, this.logger, this.performanceClient, request.correlationId)({
                code: request.code,
                msgraph_host: request.msGraphHost,
                cloud_graph_host_name: request.cloudGraphHostName,
                cloud_instance_host_name: request.cloudInstanceHostName
            }, silentRequest, false);
        } catch (e) {
            if (e instanceof (0, $53b49d8334c1646a$export$145273558d58e0ac)) {
                e.setCorrelationId(this.correlationId);
                serverTelemetryManager.cacheFailedRequest(e);
            }
            throw e;
        }
    }
    /**
     * Currently Unsupported
     */ logout() {
        // Synchronous so we must reject
        return Promise.reject((0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$78523a40be105a03)));
    }
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $07a809f266e440d6$var$getAccountType(account) {
    const idTokenClaims = account?.idTokenClaims;
    if (idTokenClaims?.tfp || idTokenClaims?.acr) return "B2C";
    if (!idTokenClaims?.tid) return undefined;
    else if (idTokenClaims?.tid === "9188040d-6c67-4c5b-b112-36a304b66dad") return "MSA";
    return "AAD";
}
function $07a809f266e440d6$var$preflightCheck(initialized, performanceEvent) {
    try {
        (0, $deacecf435b3f5ad$export$4dd091cbdc98b52e)(initialized);
    } catch (e) {
        performanceEvent.end({
            success: false
        }, e);
        throw e;
    }
}
class $07a809f266e440d6$export$e9d1ef1cb8705404 {
    /**
     * @constructor
     * Constructor for the PublicClientApplication used to instantiate the PublicClientApplication object
     *
     * Important attributes in the Configuration object for auth are:
     * - clientID: the application ID of your application. You can obtain one by registering your application with our Application registration portal : https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/RegisteredAppsPreview
     * - authority: the authority URL for your application.
     * - redirect_uri: the uri of your application registered in the portal.
     *
     * In Azure AD, authority is a URL indicating the Azure active directory that MSAL uses to obtain tokens.
     * It is of the form https://login.microsoftonline.com/{Enter_the_Tenant_Info_Here}
     * If your application supports Accounts in one organizational directory, replace "Enter_the_Tenant_Info_Here" value with the Tenant Id or Tenant name (for example, contoso.microsoft.com).
     * If your application supports Accounts in any organizational directory, replace "Enter_the_Tenant_Info_Here" value with organizations.
     * If your application supports Accounts in any organizational directory and personal Microsoft accounts, replace "Enter_the_Tenant_Info_Here" value with common.
     * To restrict support to Personal Microsoft accounts only, replace "Enter_the_Tenant_Info_Here" value with consumers.
     *
     * In Azure B2C, authority is of the form https://{instance}/tfp/{tenant}/{policyName}/
     * Full B2C functionality will be available in this library in future versions.
     *
     * @param configuration Object for the MSAL PublicClientApplication instance
     */ constructor(operatingContext){
        this.operatingContext = operatingContext;
        this.isBrowserEnvironment = this.operatingContext.isBrowserEnvironment();
        // Set the configuration.
        this.config = operatingContext.getConfig();
        this.initialized = false;
        // Initialize logger
        this.logger = this.operatingContext.getLogger();
        // Initialize the network module class.
        this.networkClient = this.config.system.networkClient;
        // Initialize the navigation client class.
        this.navigationClient = this.config.system.navigationClient;
        // Initialize redirectResponse Map
        this.redirectResponse = new Map();
        // Initial hybrid spa map
        this.hybridAuthCodeResponses = new Map();
        // Initialize performance client
        this.performanceClient = this.config.telemetry.client;
        // Initialize the crypto class.
        this.browserCrypto = this.isBrowserEnvironment ? new (0, $b97228d657d79796$export$c274a7f0ebd24b14)(this.logger, this.performanceClient) : (0, $f03a022fda639465$export$865f57d401606752);
        this.eventHandler = new (0, $73896da9aeaab286$export$ce0ba2422a1c7815)(this.logger);
        // Initialize the browser storage class.
        this.browserStorage = this.isBrowserEnvironment ? new (0, $acde3ca448a630dc$export$44d7291b5c8cc149)(this.config.auth.clientId, this.config.cache, this.browserCrypto, this.logger, (0, $dda2270c89fd90c8$export$2b9ebf6f25078cc0)(this.config.auth), this.performanceClient) : (0, $acde3ca448a630dc$export$8e2d54002f8f6e5d)(this.config.auth.clientId, this.logger);
        // initialize in memory storage for native flows
        const nativeCacheOptions = {
            cacheLocation: (0, $091acf4c2675819b$export$573384e47a12d835).MemoryStorage,
            temporaryCacheLocation: (0, $091acf4c2675819b$export$573384e47a12d835).MemoryStorage,
            storeAuthStateInCookie: false,
            secureCookies: false,
            cacheMigrationEnabled: false,
            claimsBasedCachingEnabled: false
        };
        this.nativeInternalStorage = new (0, $acde3ca448a630dc$export$44d7291b5c8cc149)(this.config.auth.clientId, nativeCacheOptions, this.browserCrypto, this.logger, undefined, this.performanceClient);
        // Initialize the token cache
        this.tokenCache = new (0, $89f7a63eb8a30ef6$export$ed5d1a18907a1001)(this.config, this.browserStorage, this.logger, this.browserCrypto);
        this.activeSilentTokenRequests = new Map();
        // Register listener functions
        this.trackPageVisibility = this.trackPageVisibility.bind(this);
        // Register listener functions
        this.trackPageVisibilityWithMeasurement = this.trackPageVisibilityWithMeasurement.bind(this);
        // account storage events
        this.listeningToStorageEvents = false;
        this.handleAccountCacheChange = this.handleAccountCacheChange.bind(this);
    }
    static async createController(operatingContext, request) {
        const controller = new $07a809f266e440d6$export$e9d1ef1cb8705404(operatingContext);
        await controller.initialize(request);
        return controller;
    }
    trackPageVisibility(correlationId) {
        if (!correlationId) return;
        this.logger.info("Perf: Visibility change detected");
        this.performanceClient.incrementFields({
            visibilityChangeCount: 1
        }, correlationId);
    }
    /**
     * Initializer function to perform async startup tasks such as connecting to WAM extension
     * @param request {?InitializeApplicationRequest} correlation id
     */ async initialize(request) {
        this.logger.trace("initialize called");
        if (this.initialized) {
            this.logger.info("initialize has already been called, exiting early.");
            return;
        }
        if (!this.isBrowserEnvironment) {
            this.logger.info("in non-browser environment, exiting early.");
            this.initialized = true;
            this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).INITIALIZE_END);
            return;
        }
        const initCorrelationId = request?.correlationId || this.getRequestCorrelationId();
        const allowNativeBroker = this.config.system.allowNativeBroker;
        const initMeasurement = this.performanceClient.startMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).InitializeClientApplication, initCorrelationId);
        this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).INITIALIZE_START);
        if (allowNativeBroker) try {
            this.nativeExtensionProvider = await (0, $6031f29937eca509$export$c98888b8059e2702).createProvider(this.logger, this.config.system.nativeBrokerHandshakeTimeout, this.performanceClient);
        } catch (e) {
            this.logger.verbose(e);
        }
        if (!this.config.cache.claimsBasedCachingEnabled) {
            this.logger.verbose("Claims-based caching is disabled. Clearing the previous cache with claims");
            await (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.browserStorage.clearTokensAndKeysWithClaims.bind(this.browserStorage), (0, $32170abc11155933$export$2f2811a3e1b21823).ClearTokensAndKeysWithClaims, this.logger, this.performanceClient, initCorrelationId)(this.performanceClient, initCorrelationId);
        }
        this.initialized = true;
        this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).INITIALIZE_END);
        initMeasurement.end({
            allowNativeBroker: allowNativeBroker,
            success: true
        });
    }
    // #region Redirect Flow
    /**
     * Event handler function which allows users to fire events after the PublicClientApplication object
     * has loaded during redirect flows. This should be invoked on all page loads involved in redirect
     * auth flows.
     * @param hash Hash to process. Defaults to the current value of window.location.hash. Only needs to be provided explicitly if the response to be handled is not contained in the current value.
     * @returns Token response or null. If the return value is null, then no auth redirect was detected.
     */ async handleRedirectPromise(hash) {
        this.logger.verbose("handleRedirectPromise called");
        // Block token acquisition before initialize has been called
        (0, $deacecf435b3f5ad$export$630119c5db8b5529)(this.initialized);
        if (this.isBrowserEnvironment) {
            /**
             * Store the promise on the PublicClientApplication instance if this is the first invocation of handleRedirectPromise,
             * otherwise return the promise from the first invocation. Prevents race conditions when handleRedirectPromise is called
             * several times concurrently.
             */ const redirectResponseKey = hash || "";
            let response = this.redirectResponse.get(redirectResponseKey);
            if (typeof response === "undefined") {
                response = this.handleRedirectPromiseInternal(hash);
                this.redirectResponse.set(redirectResponseKey, response);
                this.logger.verbose("handleRedirectPromise has been called for the first time, storing the promise");
            } else this.logger.verbose("handleRedirectPromise has been called previously, returning the result from the first call");
            return response;
        }
        this.logger.verbose("handleRedirectPromise returns null, not browser environment");
        return null;
    }
    /**
     * The internal details of handleRedirectPromise. This is separated out to a helper to allow handleRedirectPromise to memoize requests
     * @param hash
     * @returns
     */ async handleRedirectPromiseInternal(hash) {
        const loggedInAccounts = this.getAllAccounts();
        const request = this.browserStorage.getCachedNativeRequest();
        const useNative = request && (0, $6031f29937eca509$export$c98888b8059e2702).isNativeAvailable(this.config, this.logger, this.nativeExtensionProvider) && this.nativeExtensionProvider && !hash;
        const correlationId = useNative ? request?.correlationId : this.browserStorage.getTemporaryCache((0, $091acf4c2675819b$export$21d55bedf0d269fb).CORRELATION_ID, true) || "";
        const rootMeasurement = this.performanceClient.startMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).AcquireTokenRedirect, correlationId);
        this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).HANDLE_REDIRECT_START, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Redirect);
        let redirectResponse;
        if (useNative && this.nativeExtensionProvider) {
            this.logger.trace("handleRedirectPromise - acquiring token from native platform");
            const nativeClient = new (0, $b593e4d2c5327969$export$38af86d4cb90fd61)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $091acf4c2675819b$export$192d74ad69b40705).handleRedirectPromise, this.performanceClient, this.nativeExtensionProvider, request.accountId, this.nativeInternalStorage, request.correlationId);
            redirectResponse = (0, $4832f15bf602f56d$export$e4feded94d9adb18)(nativeClient.handleRedirectPromise.bind(nativeClient), (0, $32170abc11155933$export$2f2811a3e1b21823).HandleNativeRedirectPromiseMeasurement, this.logger, this.performanceClient, rootMeasurement.event.correlationId)(this.performanceClient, rootMeasurement.event.correlationId);
        } else {
            this.logger.trace("handleRedirectPromise - acquiring token from web flow");
            const redirectClient = this.createRedirectClient(correlationId);
            redirectResponse = (0, $4832f15bf602f56d$export$e4feded94d9adb18)(redirectClient.handleRedirectPromise.bind(redirectClient), (0, $32170abc11155933$export$2f2811a3e1b21823).HandleRedirectPromiseMeasurement, this.logger, this.performanceClient, rootMeasurement.event.correlationId)(hash, rootMeasurement);
        }
        return redirectResponse.then((result)=>{
            if (result) {
                // Emit login event if number of accounts change
                const isLoggingIn = loggedInAccounts.length < this.getAllAccounts().length;
                if (isLoggingIn) {
                    this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).LOGIN_SUCCESS, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Redirect, result);
                    this.logger.verbose("handleRedirectResponse returned result, login success");
                } else {
                    this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Redirect, result);
                    this.logger.verbose("handleRedirectResponse returned result, acquire token success");
                }
                rootMeasurement.end({
                    success: true,
                    accountType: $07a809f266e440d6$var$getAccountType(result.account)
                });
            } else /*
                 * Instrument an event only if an error code is set. Otherwise, discard it when the redirect response
                 * is empty and the error code is missing.
                 */ if (rootMeasurement.event.errorCode) rootMeasurement.end({
                success: false
            });
            else rootMeasurement.discard();
            this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).HANDLE_REDIRECT_END, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Redirect);
            return result;
        }).catch((e)=>{
            const eventError = e;
            // Emit login event if there is an account
            if (loggedInAccounts.length > 0) this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Redirect, null, eventError);
            else this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).LOGIN_FAILURE, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Redirect, null, eventError);
            this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).HANDLE_REDIRECT_END, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Redirect);
            rootMeasurement.end({
                success: false
            }, eventError);
            throw e;
        });
    }
    /**
     * Use when you want to obtain an access_token for your API by redirecting the user's browser window to the authorization endpoint. This function redirects
     * the page, so any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ async acquireTokenRedirect(request) {
        // Preflight request
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("acquireTokenRedirect called", correlationId);
        const atrMeasurement = this.performanceClient.startMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).AcquireTokenPreRedirect, correlationId);
        atrMeasurement.add({
            accountType: $07a809f266e440d6$var$getAccountType(request.account),
            scenarioId: request.scenarioId
        });
        // Override on request only if set, as onRedirectNavigate field is deprecated
        const onRedirectNavigateCb = request.onRedirectNavigate;
        if (onRedirectNavigateCb) request.onRedirectNavigate = (url)=>{
            const navigate = typeof onRedirectNavigateCb === "function" ? onRedirectNavigateCb(url) : undefined;
            if (navigate !== false) atrMeasurement.end({
                success: true
            });
            else atrMeasurement.discard();
            return navigate;
        };
        else {
            const configOnRedirectNavigateCb = this.config.auth.onRedirectNavigate;
            this.config.auth.onRedirectNavigate = (url)=>{
                const navigate = typeof configOnRedirectNavigateCb === "function" ? configOnRedirectNavigateCb(url) : undefined;
                if (navigate !== false) atrMeasurement.end({
                    success: true
                });
                else atrMeasurement.discard();
                return navigate;
            };
        }
        // If logged in, emit acquire token events
        const isLoggedIn = this.getAllAccounts().length > 0;
        try {
            (0, $deacecf435b3f5ad$export$62c8f4fdca4df60f)(this.initialized, this.config);
            this.browserStorage.setInteractionInProgress(true);
            if (isLoggedIn) this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Redirect, request);
            else this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).LOGIN_START, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Redirect, request);
            let result;
            if (this.nativeExtensionProvider && this.canUseNative(request)) {
                const nativeClient = new (0, $b593e4d2c5327969$export$38af86d4cb90fd61)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $091acf4c2675819b$export$192d74ad69b40705).acquireTokenRedirect, this.performanceClient, this.nativeExtensionProvider, this.getNativeAccountId(request), this.nativeInternalStorage, correlationId);
                result = nativeClient.acquireTokenRedirect(request, atrMeasurement).catch((e)=>{
                    if (e instanceof (0, $8cbaa4db29abc94e$export$4b8a4f6256e840ab) && (0, $8cbaa4db29abc94e$export$f21e42e365baeb50)(e)) {
                        this.nativeExtensionProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                        const redirectClient = this.createRedirectClient(correlationId);
                        return redirectClient.acquireToken(request);
                    } else if (e instanceof (0, $0171ff24547bf7bf$export$6ba3e818c6bc76ba)) {
                        this.logger.verbose("acquireTokenRedirect - Resolving interaction required error thrown by native broker by falling back to web flow");
                        const redirectClient = this.createRedirectClient(correlationId);
                        return redirectClient.acquireToken(request);
                    }
                    this.browserStorage.setInteractionInProgress(false);
                    throw e;
                });
            } else {
                const redirectClient = this.createRedirectClient(correlationId);
                result = redirectClient.acquireToken(request);
            }
            return await result;
        } catch (e) {
            atrMeasurement.end({
                success: false
            }, e);
            if (isLoggedIn) this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Redirect, null, e);
            else this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).LOGIN_FAILURE, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Redirect, null, e);
            throw e;
        }
    }
    // #endregion
    // #region Popup Flow
    /**
     * Use when you want to obtain an access_token for your API via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ acquireTokenPopup(request) {
        const correlationId = this.getRequestCorrelationId(request);
        const atPopupMeasurement = this.performanceClient.startMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).AcquireTokenPopup, correlationId);
        atPopupMeasurement.add({
            scenarioId: request.scenarioId,
            accountType: $07a809f266e440d6$var$getAccountType(request.account)
        });
        try {
            this.logger.verbose("acquireTokenPopup called", correlationId);
            $07a809f266e440d6$var$preflightCheck(this.initialized, atPopupMeasurement);
            this.browserStorage.setInteractionInProgress(true);
        } catch (e) {
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }
        // If logged in, emit acquire token events
        const loggedInAccounts = this.getAllAccounts();
        if (loggedInAccounts.length > 0) this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Popup, request);
        else this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).LOGIN_START, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Popup, request);
        let result;
        if (this.canUseNative(request)) result = this.acquireTokenNative({
            ...request,
            correlationId: correlationId
        }, (0, $091acf4c2675819b$export$192d74ad69b40705).acquireTokenPopup).then((response)=>{
            this.browserStorage.setInteractionInProgress(false);
            atPopupMeasurement.end({
                success: true,
                isNativeBroker: true,
                accountType: $07a809f266e440d6$var$getAccountType(response.account)
            });
            return response;
        }).catch((e)=>{
            if (e instanceof (0, $8cbaa4db29abc94e$export$4b8a4f6256e840ab) && (0, $8cbaa4db29abc94e$export$f21e42e365baeb50)(e)) {
                this.nativeExtensionProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                const popupClient = this.createPopupClient(correlationId);
                return popupClient.acquireToken(request);
            } else if (e instanceof (0, $0171ff24547bf7bf$export$6ba3e818c6bc76ba)) {
                this.logger.verbose("acquireTokenPopup - Resolving interaction required error thrown by native broker by falling back to web flow");
                const popupClient = this.createPopupClient(correlationId);
                return popupClient.acquireToken(request);
            }
            this.browserStorage.setInteractionInProgress(false);
            throw e;
        });
        else {
            const popupClient = this.createPopupClient(correlationId);
            result = popupClient.acquireToken(request);
        }
        return result.then((result)=>{
            /*
             *  If logged in, emit acquire token events
             */ const isLoggingIn = loggedInAccounts.length < this.getAllAccounts().length;
            if (isLoggingIn) this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).LOGIN_SUCCESS, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Popup, result);
            else this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Popup, result);
            atPopupMeasurement.end({
                success: true,
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length,
                accountType: $07a809f266e440d6$var$getAccountType(result.account)
            });
            return result;
        }).catch((e)=>{
            if (loggedInAccounts.length > 0) this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Popup, null, e);
            else this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).LOGIN_FAILURE, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Popup, null, e);
            atPopupMeasurement.end({
                success: false
            }, e);
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        });
    }
    trackPageVisibilityWithMeasurement() {
        const measurement = this.ssoSilentMeasurement || this.acquireTokenByCodeAsyncMeasurement;
        if (!measurement) return;
        this.logger.info("Perf: Visibility change detected in ", measurement.event.name);
        measurement.increment({
            visibilityChangeCount: 1
        });
    }
    // #endregion
    // #region Silent Flow
    /**
     * This function uses a hidden iframe to fetch an authorization code from the eSTS. There are cases where this may not work:
     * - Any browser using a form of Intelligent Tracking Prevention
     * - If there is not an established session with the service
     *
     * In these cases, the request must be done inside a popup or full frame redirect.
     *
     * For the cases where interaction is required, you cannot send a request with prompt=none.
     *
     * If your refresh token has expired, you can use this function to fetch a new set of tokens silently as long as
     * you session on the server still exists.
     * @param request {@link SsoSilentRequest}
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async ssoSilent(request) {
        const correlationId = this.getRequestCorrelationId(request);
        const validRequest = {
            ...request,
            // will be PromptValue.NONE or PromptValue.NO_SESSION
            prompt: request.prompt,
            correlationId: correlationId
        };
        this.ssoSilentMeasurement = this.performanceClient.startMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).SsoSilent, correlationId);
        this.ssoSilentMeasurement?.add({
            scenarioId: request.scenarioId,
            accountType: $07a809f266e440d6$var$getAccountType(request.account)
        });
        $07a809f266e440d6$var$preflightCheck(this.initialized, this.ssoSilentMeasurement);
        this.ssoSilentMeasurement?.increment({
            visibilityChangeCount: 0
        });
        document.addEventListener("visibilitychange", this.trackPageVisibilityWithMeasurement);
        this.logger.verbose("ssoSilent called", correlationId);
        this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).SSO_SILENT_START, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Silent, validRequest);
        let result;
        if (this.canUseNative(validRequest)) result = this.acquireTokenNative(validRequest, (0, $091acf4c2675819b$export$192d74ad69b40705).ssoSilent).catch((e)=>{
            // If native token acquisition fails for availability reasons fallback to standard flow
            if (e instanceof (0, $8cbaa4db29abc94e$export$4b8a4f6256e840ab) && (0, $8cbaa4db29abc94e$export$f21e42e365baeb50)(e)) {
                this.nativeExtensionProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                const silentIframeClient = this.createSilentIframeClient(validRequest.correlationId);
                return silentIframeClient.acquireToken(validRequest);
            }
            throw e;
        });
        else {
            const silentIframeClient = this.createSilentIframeClient(validRequest.correlationId);
            result = silentIframeClient.acquireToken(validRequest);
        }
        return result.then((response)=>{
            this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).SSO_SILENT_SUCCESS, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Silent, response);
            this.ssoSilentMeasurement?.end({
                success: true,
                isNativeBroker: response.fromNativeBroker,
                accessTokenSize: response.accessToken.length,
                idTokenSize: response.idToken.length,
                accountType: $07a809f266e440d6$var$getAccountType(response.account)
            });
            return response;
        }).catch((e)=>{
            this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).SSO_SILENT_FAILURE, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Silent, null, e);
            this.ssoSilentMeasurement?.end({
                success: false
            }, e);
            throw e;
        }).finally(()=>{
            document.removeEventListener("visibilitychange", this.trackPageVisibilityWithMeasurement);
        });
    }
    /**
     * This function redeems an authorization code (passed as code) from the eSTS token endpoint.
     * This authorization code should be acquired server-side using a confidential client to acquire a spa_code.
     * This API is not indended for normal authorization code acquisition and redemption.
     *
     * Redemption of this authorization code will not require PKCE, as it was acquired by a confidential client.
     *
     * @param request {@link AuthorizationCodeRequest}
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async acquireTokenByCode(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.trace("acquireTokenByCode called", correlationId);
        const atbcMeasurement = this.performanceClient.startMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).AcquireTokenByCode, correlationId);
        $07a809f266e440d6$var$preflightCheck(this.initialized, atbcMeasurement);
        this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).ACQUIRE_TOKEN_BY_CODE_START, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Silent, request);
        atbcMeasurement.add({
            scenarioId: request.scenarioId
        });
        try {
            if (request.code && request.nativeAccountId) // Throw error in case server returns both spa_code and spa_accountid in exchange for auth code.
            throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$1efb009e9d75bbe4));
            else if (request.code) {
                const hybridAuthCode = request.code;
                let response = this.hybridAuthCodeResponses.get(hybridAuthCode);
                if (!response) {
                    this.logger.verbose("Initiating new acquireTokenByCode request", correlationId);
                    response = this.acquireTokenByCodeAsync({
                        ...request,
                        correlationId: correlationId
                    }).then((result)=>{
                        this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).ACQUIRE_TOKEN_BY_CODE_SUCCESS, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Silent, result);
                        this.hybridAuthCodeResponses.delete(hybridAuthCode);
                        atbcMeasurement.end({
                            success: true,
                            isNativeBroker: result.fromNativeBroker,
                            accessTokenSize: result.accessToken.length,
                            idTokenSize: result.idToken.length,
                            accountType: $07a809f266e440d6$var$getAccountType(result.account)
                        });
                        return result;
                    }).catch((error)=>{
                        this.hybridAuthCodeResponses.delete(hybridAuthCode);
                        this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).ACQUIRE_TOKEN_BY_CODE_FAILURE, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Silent, null, error);
                        atbcMeasurement.end({
                            success: false
                        }, error);
                        throw error;
                    });
                    this.hybridAuthCodeResponses.set(hybridAuthCode, response);
                } else {
                    this.logger.verbose("Existing acquireTokenByCode request found", correlationId);
                    atbcMeasurement.discard();
                }
                return await response;
            } else if (request.nativeAccountId) {
                if (this.canUseNative(request, request.nativeAccountId)) {
                    const result = await this.acquireTokenNative({
                        ...request,
                        correlationId: correlationId
                    }, (0, $091acf4c2675819b$export$192d74ad69b40705).acquireTokenByCode, request.nativeAccountId).catch((e)=>{
                        // If native token acquisition fails for availability reasons fallback to standard flow
                        if (e instanceof (0, $8cbaa4db29abc94e$export$4b8a4f6256e840ab) && (0, $8cbaa4db29abc94e$export$f21e42e365baeb50)(e)) this.nativeExtensionProvider = undefined; // If extension gets uninstalled during session prevent future requests from continuing to attempt
                        throw e;
                    });
                    atbcMeasurement.end({
                        accountType: $07a809f266e440d6$var$getAccountType(result.account),
                        success: true
                    });
                    return result;
                } else throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$b897bbe2c683def2));
            } else throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$8bea68053103eaeb));
        } catch (e) {
            this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).ACQUIRE_TOKEN_BY_CODE_FAILURE, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Silent, null, e);
            atbcMeasurement.end({
                success: false
            }, e);
            throw e;
        }
    }
    /**
     * Creates a SilentAuthCodeClient to redeem an authorization code.
     * @param request
     * @returns Result of the operation to redeem the authorization code
     */ async acquireTokenByCodeAsync(request) {
        this.logger.trace("acquireTokenByCodeAsync called", request.correlationId);
        this.acquireTokenByCodeAsyncMeasurement = this.performanceClient.startMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).AcquireTokenByCodeAsync, request.correlationId);
        this.acquireTokenByCodeAsyncMeasurement?.increment({
            visibilityChangeCount: 0
        });
        document.addEventListener("visibilitychange", this.trackPageVisibilityWithMeasurement);
        const silentAuthCodeClient = this.createSilentAuthCodeClient(request.correlationId);
        const silentTokenResult = await silentAuthCodeClient.acquireToken(request).then((response)=>{
            this.acquireTokenByCodeAsyncMeasurement?.end({
                success: true,
                fromCache: response.fromCache,
                isNativeBroker: response.fromNativeBroker
            });
            return response;
        }).catch((tokenRenewalError)=>{
            this.acquireTokenByCodeAsyncMeasurement?.end({
                success: false
            }, tokenRenewalError);
            throw tokenRenewalError;
        }).finally(()=>{
            document.removeEventListener("visibilitychange", this.trackPageVisibilityWithMeasurement);
        });
        return silentTokenResult;
    }
    /**
     * Attempt to acquire an access token from the cache
     * @param silentCacheClient SilentCacheClient
     * @param commonRequest CommonSilentFlowRequest
     * @param silentRequest SilentRequest
     * @returns A promise that, when resolved, returns the access token
     */ async acquireTokenFromCache(commonRequest, cacheLookupPolicy) {
        this.performanceClient.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).AcquireTokenFromCache, commonRequest.correlationId);
        switch(cacheLookupPolicy){
            case (0, $091acf4c2675819b$export$4394baa7e922d42d).Default:
            case (0, $091acf4c2675819b$export$4394baa7e922d42d).AccessToken:
            case (0, $091acf4c2675819b$export$4394baa7e922d42d).AccessTokenAndRefreshToken:
                const silentCacheClient = this.createSilentCacheClient(commonRequest.correlationId);
                return (0, $4832f15bf602f56d$export$e4feded94d9adb18)(silentCacheClient.acquireToken.bind(silentCacheClient), (0, $32170abc11155933$export$2f2811a3e1b21823).SilentCacheClientAcquireToken, this.logger, this.performanceClient, commonRequest.correlationId)(commonRequest);
            default:
                throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$exports).tokenRefreshRequired);
        }
    }
    /**
     * Attempt to acquire an access token via a refresh token
     * @param commonRequest CommonSilentFlowRequest
     * @param cacheLookupPolicy CacheLookupPolicy
     * @returns A promise that, when resolved, returns the access token
     */ async acquireTokenByRefreshToken(commonRequest, cacheLookupPolicy) {
        this.performanceClient.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).AcquireTokenByRefreshToken, commonRequest.correlationId);
        switch(cacheLookupPolicy){
            case (0, $091acf4c2675819b$export$4394baa7e922d42d).Default:
            case (0, $091acf4c2675819b$export$4394baa7e922d42d).AccessTokenAndRefreshToken:
            case (0, $091acf4c2675819b$export$4394baa7e922d42d).RefreshToken:
            case (0, $091acf4c2675819b$export$4394baa7e922d42d).RefreshTokenAndNetwork:
                const silentRefreshClient = this.createSilentRefreshClient(commonRequest.correlationId);
                return (0, $4832f15bf602f56d$export$e4feded94d9adb18)(silentRefreshClient.acquireToken.bind(silentRefreshClient), (0, $32170abc11155933$export$2f2811a3e1b21823).SilentRefreshClientAcquireToken, this.logger, this.performanceClient, commonRequest.correlationId)(commonRequest);
            default:
                throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$exports).tokenRefreshRequired);
        }
    }
    /**
     * Attempt to acquire an access token via an iframe
     * @param request CommonSilentFlowRequest
     * @returns A promise that, when resolved, returns the access token
     */ async acquireTokenBySilentIframe(request) {
        this.performanceClient.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).AcquireTokenBySilentIframe, request.correlationId);
        const silentIframeClient = this.createSilentIframeClient(request.correlationId);
        return (0, $4832f15bf602f56d$export$e4feded94d9adb18)(silentIframeClient.acquireToken.bind(silentIframeClient), (0, $32170abc11155933$export$2f2811a3e1b21823).SilentIframeClientAcquireToken, this.logger, this.performanceClient, request.correlationId)(request);
    }
    // #endregion
    // #region Logout
    /**
     * Deprecated logout function. Use logoutRedirect or logoutPopup instead
     * @param logoutRequest
     * @deprecated
     */ async logout(logoutRequest) {
        const correlationId = this.getRequestCorrelationId(logoutRequest);
        this.logger.warning("logout API is deprecated and will be removed in msal-browser v3.0.0. Use logoutRedirect instead.", correlationId);
        return this.logoutRedirect({
            correlationId: correlationId,
            ...logoutRequest
        });
    }
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ async logoutRedirect(logoutRequest) {
        const correlationId = this.getRequestCorrelationId(logoutRequest);
        (0, $deacecf435b3f5ad$export$62c8f4fdca4df60f)(this.initialized, this.config);
        this.browserStorage.setInteractionInProgress(true);
        const redirectClient = this.createRedirectClient(correlationId);
        return redirectClient.logout(logoutRequest);
    }
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ logoutPopup(logoutRequest) {
        try {
            const correlationId = this.getRequestCorrelationId(logoutRequest);
            (0, $deacecf435b3f5ad$export$4dd091cbdc98b52e)(this.initialized);
            this.browserStorage.setInteractionInProgress(true);
            const popupClient = this.createPopupClient(correlationId);
            return popupClient.logout(logoutRequest);
        } catch (e) {
            // Since this function is syncronous we need to reject
            return Promise.reject(e);
        }
    }
    /**
     * Creates a cache interaction client to clear broswer cache.
     * @param logoutRequest
     */ async clearCache(logoutRequest) {
        if (!this.isBrowserEnvironment) {
            this.logger.info("in non-browser environment, returning early.");
            return;
        }
        const correlationId = this.getRequestCorrelationId(logoutRequest);
        const cacheClient = this.createSilentCacheClient(correlationId);
        return cacheClient.logout(logoutRequest);
    }
    // #endregion
    // #region Account APIs
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter) {
        const correlationId = this.getRequestCorrelationId();
        return (0, $ba0fbd2fa27ffd1a$export$a4fc43c2a99143cd)(this.logger, this.browserStorage, this.isBrowserEnvironment, correlationId, accountFilter);
    }
    /**
     * Returns the first account found in the cache that matches the account filter passed in.
     * @param accountFilter
     * @returns The first account found in the cache matching the provided filter or null if no account could be found.
     */ getAccount(accountFilter) {
        const correlationId = this.getRequestCorrelationId();
        return (0, $ba0fbd2fa27ffd1a$export$4f9234baf34abd0)(accountFilter, this.logger, this.browserStorage, correlationId);
    }
    /**
     * Returns the signed in account matching username.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found.
     * This API is provided for convenience but getAccountById should be used for best reliability
     * @param username
     * @returns The account object stored in MSAL
     */ getAccountByUsername(username) {
        const correlationId = this.getRequestCorrelationId();
        return (0, $ba0fbd2fa27ffd1a$export$d915baf55d86927d)(username, this.logger, this.browserStorage, correlationId);
    }
    /**
     * Returns the signed in account matching homeAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param homeAccountId
     * @returns The account object stored in MSAL
     */ getAccountByHomeId(homeAccountId) {
        const correlationId = this.getRequestCorrelationId();
        return (0, $ba0fbd2fa27ffd1a$export$d6fa7d1e8099998e)(homeAccountId, this.logger, this.browserStorage, correlationId);
    }
    /**
     * Returns the signed in account matching localAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param localAccountId
     * @returns The account object stored in MSAL
     */ getAccountByLocalId(localAccountId) {
        const correlationId = this.getRequestCorrelationId();
        return (0, $ba0fbd2fa27ffd1a$export$7ac8aa09fdf78340)(localAccountId, this.logger, this.browserStorage, correlationId);
    }
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */ setActiveAccount(account) {
        const correlationId = this.getRequestCorrelationId();
        (0, $ba0fbd2fa27ffd1a$export$c55c3d25cf1bcd99)(account, this.browserStorage, correlationId);
    }
    /**
     * Gets the currently active account
     */ getActiveAccount() {
        const correlationId = this.getRequestCorrelationId();
        return (0, $ba0fbd2fa27ffd1a$export$13dd2e33a23839ad)(this.browserStorage, correlationId);
    }
    // #endregion
    /**
     * Hydrates the cache with the tokens from an AuthenticationResult
     * @param result
     * @param request
     * @returns
     */ async hydrateCache(result, request) {
        this.logger.verbose("hydrateCache called");
        // Account gets saved to browser storage regardless of native or not
        const accountEntity = (0, $35a4414ce05ac30e$export$680160523e6bfa6a).createFromAccountInfo(result.account, result.cloudGraphHostName, result.msGraphHost);
        this.browserStorage.setAccount(accountEntity, result.correlationId);
        if (result.fromNativeBroker) {
            this.logger.verbose("Response was from native broker, storing in-memory");
            // Tokens from native broker are stored in-memory
            return this.nativeInternalStorage.hydrateCache(result, request);
        } else return this.browserStorage.hydrateCache(result, request);
    }
    // #region Helpers
    /**
     * Acquire a token from native device (e.g. WAM)
     * @param request
     */ async acquireTokenNative(request, apiId, accountId) {
        this.logger.trace("acquireTokenNative called");
        if (!this.nativeExtensionProvider) throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$7b7357e3538624aa));
        const nativeClient = new (0, $b593e4d2c5327969$export$38af86d4cb90fd61)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, apiId, this.performanceClient, this.nativeExtensionProvider, accountId || this.getNativeAccountId(request), this.nativeInternalStorage, request.correlationId);
        return nativeClient.acquireToken(request);
    }
    /**
     * Returns boolean indicating if this request can use the native broker
     * @param request
     */ canUseNative(request, accountId) {
        this.logger.trace("canUseNative called");
        if (!(0, $6031f29937eca509$export$c98888b8059e2702).isNativeAvailable(this.config, this.logger, this.nativeExtensionProvider, request.authenticationScheme)) {
            this.logger.trace("canUseNative: isNativeAvailable returned false, returning false");
            return false;
        }
        if (request.prompt) switch(request.prompt){
            case (0, $08c107807d753255$export$49a06cbda5acaa5).NONE:
            case (0, $08c107807d753255$export$49a06cbda5acaa5).CONSENT:
            case (0, $08c107807d753255$export$49a06cbda5acaa5).LOGIN:
                this.logger.trace("canUseNative: prompt is compatible with native flow");
                break;
            default:
                this.logger.trace(`canUseNative: prompt = ${request.prompt} is not compatible with native flow, returning false`);
                return false;
        }
        if (!accountId && !this.getNativeAccountId(request)) {
            this.logger.trace("canUseNative: nativeAccountId is not available, returning false");
            return false;
        }
        return true;
    }
    /**
     * Get the native accountId from the account
     * @param request
     * @returns
     */ getNativeAccountId(request) {
        const account = request.account || this.getAccount({
            loginHint: request.loginHint,
            sid: request.sid
        }) || this.getActiveAccount();
        return account && account.nativeAccountId || "";
    }
    /**
     * Returns new instance of the Popup Interaction Client
     * @param correlationId
     */ createPopupClient(correlationId) {
        return new (0, $ec7c843d99a2cf46$export$43b0fce132d066f4)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeInternalStorage, this.nativeExtensionProvider, correlationId);
    }
    /**
     * Returns new instance of the Redirect Interaction Client
     * @param correlationId
     */ createRedirectClient(correlationId) {
        return new (0, $75323b305c7c385a$export$a368977effbc1ed6)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeInternalStorage, this.nativeExtensionProvider, correlationId);
    }
    /**
     * Returns new instance of the Silent Iframe Interaction Client
     * @param correlationId
     */ createSilentIframeClient(correlationId) {
        return new (0, $15e51d94ebb188a3$export$e81c7938bccef977)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $091acf4c2675819b$export$192d74ad69b40705).ssoSilent, this.performanceClient, this.nativeInternalStorage, this.nativeExtensionProvider, correlationId);
    }
    /**
     * Returns new instance of the Silent Cache Interaction Client
     */ createSilentCacheClient(correlationId) {
        return new (0, $065ef8adac8fed74$export$59d4f873ee62d01e)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeExtensionProvider, correlationId);
    }
    /**
     * Returns new instance of the Silent Refresh Interaction Client
     */ createSilentRefreshClient(correlationId) {
        return new (0, $fc15c9be3b8e87fe$export$b4a36596822a5d2)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, this.performanceClient, this.nativeExtensionProvider, correlationId);
    }
    /**
     * Returns new instance of the Silent AuthCode Interaction Client
     */ createSilentAuthCodeClient(correlationId) {
        return new (0, $a2c52b90bfd3ac63$export$d7f5ef311b3e9fca)(this.config, this.browserStorage, this.browserCrypto, this.logger, this.eventHandler, this.navigationClient, (0, $091acf4c2675819b$export$192d74ad69b40705).acquireTokenByCode, this.performanceClient, this.nativeExtensionProvider, correlationId);
    }
    /**
     * Adds event callbacks to array
     * @param callback
     */ addEventCallback(callback, eventTypes) {
        return this.eventHandler.addEventCallback(callback, eventTypes);
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        this.eventHandler.removeEventCallback(callbackId);
    }
    /**
     * Registers a callback to receive performance events.
     *
     * @param {PerformanceCallbackFunction} callback
     * @returns {string}
     */ addPerformanceCallback(callback) {
        (0, $deacecf435b3f5ad$export$c7939bfe92ae2787)();
        return this.performanceClient.addPerformanceCallback(callback);
    }
    /**
     * Removes a callback registered with addPerformanceCallback.
     *
     * @param {string} callbackId
     * @returns {boolean}
     */ removePerformanceCallback(callbackId) {
        return this.performanceClient.removePerformanceCallback(callbackId);
    }
    /**
     * Adds event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     */ enableAccountStorageEvents() {
        if (typeof window === "undefined") return;
        if (!this.listeningToStorageEvents) {
            this.logger.verbose("Adding account storage listener.");
            this.listeningToStorageEvents = true;
            window.addEventListener("storage", this.handleAccountCacheChange);
        } else this.logger.verbose("Account storage listener already registered.");
    }
    /**
     * Removes event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     */ disableAccountStorageEvents() {
        if (typeof window === "undefined") return;
        if (this.listeningToStorageEvents) {
            this.logger.verbose("Removing account storage listener.");
            window.removeEventListener("storage", this.handleAccountCacheChange);
            this.listeningToStorageEvents = false;
        } else this.logger.verbose("No account storage listener registered.");
    }
    /**
     * Emit account added/removed events when cached accounts are changed in a different tab or frame
     */ handleAccountCacheChange(e) {
        try {
            // Handle active account filter change
            if (e.key?.includes((0, $08c107807d753255$export$81ab9ba9bd28255c).ACTIVE_ACCOUNT_FILTERS)) // This event has no payload, it only signals cross-tab app instances that the results of calling getActiveAccount() will have changed
            this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).ACTIVE_ACCOUNT_CHANGED);
            // Handle account object change
            const cacheValue = e.newValue || e.oldValue;
            if (!cacheValue) return;
            const parsedValue = JSON.parse(cacheValue);
            if (typeof parsedValue !== "object" || !(0, $35a4414ce05ac30e$export$680160523e6bfa6a).isAccountEntity(parsedValue)) return;
            const accountEntity = (0, $4ffcb9b8559edbe4$export$996e3ea69314b5c6).toObject(new (0, $35a4414ce05ac30e$export$680160523e6bfa6a)(), parsedValue);
            const accountInfo = accountEntity.getAccountInfo();
            if (!e.oldValue && e.newValue) {
                this.logger.info("Account was added to cache in a different window");
                this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).ACCOUNT_ADDED, undefined, accountInfo);
            } else if (!e.newValue && e.oldValue) {
                this.logger.info("Account was removed from cache in a different window");
                this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).ACCOUNT_REMOVED, undefined, accountInfo);
            }
        } catch (e) {
            return;
        }
    }
    /**
     * Gets the token cache for the application.
     */ getTokenCache() {
        return this.tokenCache;
    }
    /**
     * Returns the logger instance
     */ getLogger() {
        return this.logger;
    }
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */ setLogger(logger) {
        this.logger = logger;
    }
    /**
     * Called by wrapper libraries (Angular & React) to set SKU and Version passed down to telemetry, logger, etc.
     * @param sku
     * @param version
     */ initializeWrapperLibrary(sku, version) {
        // Validate the SKU passed in is one we expect
        this.browserStorage.setWrapperMetadata(sku, version);
    }
    /**
     * Sets navigation client
     * @param navigationClient
     */ setNavigationClient(navigationClient) {
        this.navigationClient = navigationClient;
    }
    /**
     * Returns the configuration object
     */ getConfiguration() {
        return this.config;
    }
    /**
     * Returns the performance client
     */ getPerformanceClient() {
        return this.performanceClient;
    }
    /**
     * Returns the browser env indicator
     */ isBrowserEnv() {
        return this.isBrowserEnvironment;
    }
    /**
     * Generates a correlation id for a request if none is provided.
     *
     * @protected
     * @param {?Partial<BaseAuthRequest>} [request]
     * @returns {string}
     */ getRequestCorrelationId(request) {
        if (request?.correlationId) return request.correlationId;
        if (this.isBrowserEnvironment) return (0, $b512579b1150f905$export$6ef0355fa80a5278)();
        /*
         * Included for fallback for non-browser environments,
         * and to ensure this method always returns a string.
         */ return (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING;
    }
    // #endregion
    /**
     * Use when initiating the login process by redirecting the user's browser to the authorization endpoint. This function redirects the page, so
     * any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ async loginRedirect(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("loginRedirect called", correlationId);
        return this.acquireTokenRedirect({
            correlationId: correlationId,
            ...request || (0, $091acf4c2675819b$export$7e12949cd6884193)
        });
    }
    /**
     * Use when initiating the login process via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ loginPopup(request) {
        const correlationId = this.getRequestCorrelationId(request);
        this.logger.verbose("loginPopup called", correlationId);
        return this.acquireTokenPopup({
            correlationId: correlationId,
            ...request || (0, $091acf4c2675819b$export$7e12949cd6884193)
        });
    }
    /**
     * Silently acquire an access token for a given set of scopes. Returns currently processing promise if parallel requests are made.
     *
     * @param {@link (SilentRequest:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthResponse} object
     */ async acquireTokenSilent(request) {
        const correlationId = this.getRequestCorrelationId(request);
        const atsMeasurement = this.performanceClient.startMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).AcquireTokenSilent, correlationId);
        atsMeasurement.add({
            cacheLookupPolicy: request.cacheLookupPolicy,
            scenarioId: request.scenarioId
        });
        $07a809f266e440d6$var$preflightCheck(this.initialized, atsMeasurement);
        this.logger.verbose("acquireTokenSilent called", correlationId);
        const account = request.account || this.getActiveAccount();
        if (!account) throw (0, $59d58688ac49ebc0$export$72f7b48f3bc1d4cb)((0, $aa0e430adf0f9ba6$export$87933d7d4116cb12));
        atsMeasurement.add({
            accountType: $07a809f266e440d6$var$getAccountType(account)
        });
        const thumbprint = {
            clientId: this.config.auth.clientId,
            authority: request.authority || (0, $08c107807d753255$export$a002182e51710d39).EMPTY_STRING,
            scopes: request.scopes,
            homeAccountIdentifier: account.homeAccountId,
            claims: request.claims,
            authenticationScheme: request.authenticationScheme,
            resourceRequestMethod: request.resourceRequestMethod,
            resourceRequestUri: request.resourceRequestUri,
            shrClaims: request.shrClaims,
            sshKid: request.sshKid,
            shrOptions: request.shrOptions
        };
        const silentRequestKey = JSON.stringify(thumbprint);
        const cachedResponse = this.activeSilentTokenRequests.get(silentRequestKey);
        if (typeof cachedResponse === "undefined") {
            this.logger.verbose("acquireTokenSilent called for the first time, storing active request", correlationId);
            const response = (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.acquireTokenSilentAsync.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).AcquireTokenSilentAsync, this.logger, this.performanceClient, correlationId)({
                ...request,
                correlationId: correlationId
            }, account).then((result)=>{
                this.activeSilentTokenRequests.delete(silentRequestKey);
                atsMeasurement.end({
                    success: true,
                    fromCache: result.fromCache,
                    isNativeBroker: result.fromNativeBroker,
                    cacheLookupPolicy: request.cacheLookupPolicy,
                    accessTokenSize: result.accessToken.length,
                    idTokenSize: result.idToken.length
                });
                return result;
            }).catch((error)=>{
                this.activeSilentTokenRequests.delete(silentRequestKey);
                atsMeasurement.end({
                    success: false
                }, error);
                throw error;
            });
            this.activeSilentTokenRequests.set(silentRequestKey, response);
            return {
                ...await response,
                state: request.state
            };
        } else {
            this.logger.verbose("acquireTokenSilent has been called previously, returning the result from the first call", correlationId);
            // Discard measurements for memoized calls, as they are usually only a couple of ms and will artificially deflate metrics
            atsMeasurement.discard();
            return {
                ...await cachedResponse,
                state: request.state
            };
        }
    }
    /**
     * Silently acquire an access token for a given set of scopes. Will use cached token if available, otherwise will attempt to acquire a new token from the network via refresh token.
     * @param {@link (SilentRequest:type)}
     * @param {@link (AccountInfo:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthResponse}
     */ async acquireTokenSilentAsync(request, account) {
        const trackPageVisibility = ()=>this.trackPageVisibility(request.correlationId);
        this.performanceClient.addQueueMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).AcquireTokenSilentAsync, request.correlationId);
        this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Silent, request);
        if (request.correlationId) this.performanceClient.incrementFields({
            visibilityChangeCount: 0
        }, request.correlationId);
        document.addEventListener("visibilitychange", trackPageVisibility);
        const silentRequest = await (0, $4832f15bf602f56d$export$e4feded94d9adb18)((0, $4b44e4e159274463$export$4c8aa78c426811d4), (0, $32170abc11155933$export$2f2811a3e1b21823).InitializeSilentRequest, this.logger, this.performanceClient, request.correlationId)(request, account, this.config, this.performanceClient, this.logger);
        const cacheLookupPolicy = request.cacheLookupPolicy || (0, $091acf4c2675819b$export$4394baa7e922d42d).Default;
        const result = this.acquireTokenSilentNoIframe(silentRequest, cacheLookupPolicy).catch(async (refreshTokenError)=>{
            const shouldTryToResolveSilently = $07a809f266e440d6$var$checkIfRefreshTokenErrorCanBeResolvedSilently(refreshTokenError, cacheLookupPolicy);
            if (shouldTryToResolveSilently) {
                if (!this.activeIframeRequest) {
                    let _resolve;
                    // Always set the active request tracker immediately after checking it to prevent races
                    this.activeIframeRequest = [
                        new Promise((resolve)=>{
                            _resolve = resolve;
                        }),
                        silentRequest.correlationId
                    ];
                    this.logger.verbose("Refresh token expired/invalid or CacheLookupPolicy is set to Skip, attempting acquire token by iframe.", silentRequest.correlationId);
                    return (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.acquireTokenBySilentIframe.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).AcquireTokenBySilentIframe, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest).then((iframeResult)=>{
                        _resolve(true);
                        return iframeResult;
                    }).catch((e)=>{
                        _resolve(false);
                        throw e;
                    }).finally(()=>{
                        this.activeIframeRequest = undefined;
                    });
                } else if (cacheLookupPolicy !== (0, $091acf4c2675819b$export$4394baa7e922d42d).Skip) {
                    const [activePromise, activeCorrelationId] = this.activeIframeRequest;
                    this.logger.verbose(`Iframe request is already in progress, awaiting resolution for request with correlationId: ${activeCorrelationId}`, silentRequest.correlationId);
                    const awaitConcurrentIframeMeasure = this.performanceClient.startMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).AwaitConcurrentIframe, silentRequest.correlationId);
                    awaitConcurrentIframeMeasure.add({
                        awaitIframeCorrelationId: activeCorrelationId
                    });
                    const activePromiseResult = await activePromise;
                    awaitConcurrentIframeMeasure.end({
                        success: activePromiseResult
                    });
                    if (activePromiseResult) {
                        this.logger.verbose(`Parallel iframe request with correlationId: ${activeCorrelationId} succeeded. Retrying cache and/or RT redemption`, silentRequest.correlationId);
                        // Retry cache lookup and/or RT exchange after iframe completes
                        return this.acquireTokenSilentNoIframe(silentRequest, cacheLookupPolicy);
                    } else {
                        this.logger.info(`Iframe request with correlationId: ${activeCorrelationId} failed. Interaction is required.`);
                        // If previous iframe request failed, it's unlikely to succeed this time. Throw original error.
                        throw refreshTokenError;
                    }
                } else {
                    // Cache policy set to skip and another iframe request is already in progress
                    this.logger.warning("Another iframe request is currently in progress and CacheLookupPolicy is set to Skip. This may result in degraded performance and/or reliability for both calls. Please consider changing the CacheLookupPolicy to take advantage of request queuing and token cache.", silentRequest.correlationId);
                    return (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.acquireTokenBySilentIframe.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).AcquireTokenBySilentIframe, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest);
                }
            } else // Error cannot be silently resolved or iframe renewal is not allowed, interaction required
            throw refreshTokenError;
        });
        return result.then((response)=>{
            this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Silent, response);
            if (request.correlationId) this.performanceClient.addFields({
                fromCache: response.fromCache,
                isNativeBroker: response.fromNativeBroker
            }, request.correlationId);
            return response;
        }).catch((tokenRenewalError)=>{
            this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Silent, null, tokenRenewalError);
            throw tokenRenewalError;
        }).finally(()=>{
            document.removeEventListener("visibilitychange", trackPageVisibility);
        });
    }
    /**
     * AcquireTokenSilent without the iframe fallback. This is used to enable the correct fallbacks in cases where there's a potential for multiple silent requests to be made in parallel and prevent those requests from making concurrent iframe requests.
     * @param silentRequest
     * @param cacheLookupPolicy
     * @returns
     */ async acquireTokenSilentNoIframe(silentRequest, cacheLookupPolicy) {
        if ((0, $6031f29937eca509$export$c98888b8059e2702).isNativeAvailable(this.config, this.logger, this.nativeExtensionProvider, silentRequest.authenticationScheme) && silentRequest.account.nativeAccountId) {
            this.logger.verbose("acquireTokenSilent - attempting to acquire token from native platform");
            return this.acquireTokenNative(silentRequest, (0, $091acf4c2675819b$export$192d74ad69b40705).acquireTokenSilent_silentFlow).catch(async (e)=>{
                // If native token acquisition fails for availability reasons fallback to web flow
                if (e instanceof (0, $8cbaa4db29abc94e$export$4b8a4f6256e840ab) && (0, $8cbaa4db29abc94e$export$f21e42e365baeb50)(e)) {
                    this.logger.verbose("acquireTokenSilent - native platform unavailable, falling back to web flow");
                    this.nativeExtensionProvider = undefined; // Prevent future requests from continuing to attempt
                    // Cache will not contain tokens, given that previous WAM requests succeeded. Skip cache and RT renewal and go straight to iframe renewal
                    throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$exports).tokenRefreshRequired);
                }
                throw e;
            });
        } else {
            this.logger.verbose("acquireTokenSilent - attempting to acquire token from web flow");
            return (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.acquireTokenFromCache.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).AcquireTokenFromCache, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest, cacheLookupPolicy).catch((cacheError)=>{
                if (cacheLookupPolicy === (0, $091acf4c2675819b$export$4394baa7e922d42d).AccessToken) throw cacheError;
                this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).ACQUIRE_TOKEN_NETWORK_START, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Silent, silentRequest);
                return (0, $4832f15bf602f56d$export$e4feded94d9adb18)(this.acquireTokenByRefreshToken.bind(this), (0, $32170abc11155933$export$2f2811a3e1b21823).AcquireTokenByRefreshToken, this.logger, this.performanceClient, silentRequest.correlationId)(silentRequest, cacheLookupPolicy);
            });
        }
    }
}
/**
 * Determines whether an error thrown by the refresh token endpoint can be resolved without interaction
 * @param refreshTokenError
 * @param silentRequest
 * @param cacheLookupPolicy
 * @returns
 */ function $07a809f266e440d6$var$checkIfRefreshTokenErrorCanBeResolvedSilently(refreshTokenError, cacheLookupPolicy) {
    const noInteractionRequired = !(refreshTokenError instanceof (0, $0171ff24547bf7bf$export$6ba3e818c6bc76ba) && // For refresh token errors, bad_token does not always require interaction (silently resolvable)
    refreshTokenError.subError !== (0, $5663e5ea2c96c5cf$exports).badToken);
    // Errors that result when the refresh token needs to be replaced
    const refreshTokenRefreshRequired = refreshTokenError.errorCode === (0, $091acf4c2675819b$export$a0a689e4294b9880).INVALID_GRANT_ERROR || refreshTokenError.errorCode === (0, $9f4ee6b47026c448$exports).tokenRefreshRequired;
    // Errors that may be resolved before falling back to interaction (through iframe renewal)
    const isSilentlyResolvable = noInteractionRequired && refreshTokenRefreshRequired || refreshTokenError.errorCode === (0, $5663e5ea2c96c5cf$exports).noTokensFound || refreshTokenError.errorCode === (0, $5663e5ea2c96c5cf$exports).refreshTokenExpired;
    // Only these policies allow for an iframe renewal attempt
    const tryIframeRenewal = (0, $091acf4c2675819b$export$736180706fb122ee).includes(cacheLookupPolicy);
    return isSilentlyResolvable && tryIframeRenewal;
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 
/*! @azure/msal-browser v3.30.0 2025-08-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $1202fcc685d1cff5$export$caa3bc10e51dd7ee(error) {
    return error.status !== undefined;
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $99dae2e01a0cdcb4$export$cee94b20506f02aa {
    constructor(clientId, clientCapabilities, crypto, logger){
        this.clientId = clientId;
        this.clientCapabilities = clientCapabilities;
        this.crypto = crypto;
        this.logger = logger;
    }
    toNaaTokenRequest(request) {
        let extraParams;
        if (request.extraQueryParameters === undefined) extraParams = new Map();
        else extraParams = new Map(Object.entries(request.extraQueryParameters));
        const correlationId = request.correlationId || this.crypto.createNewGuid();
        const requestBuilder = new (0, $b2fdab17beec58b6$export$882078dd8a9e0bfa)(correlationId);
        const claims = requestBuilder.addClientCapabilitiesToClaims(request.claims, this.clientCapabilities);
        const scopes = request.scopes || (0, $08c107807d753255$export$893b1b5b686d84ef);
        const tokenRequest = {
            platformBrokerId: request.account?.homeAccountId,
            clientId: this.clientId,
            authority: request.authority,
            scope: scopes.join(" "),
            correlationId: correlationId,
            claims: !(0, $5d9dc3fc4be02ef2$export$ecc754f99843e759).isEmptyObj(claims) ? claims : undefined,
            state: request.state,
            authenticationScheme: request.authenticationScheme || (0, $08c107807d753255$export$901491a717da2ba5).BEARER,
            extraParameters: extraParams
        };
        return tokenRequest;
    }
    fromNaaTokenResponse(request, response, reqTimestamp) {
        if (!response.token.id_token || !response.token.access_token) throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$exports).nullOrEmptyToken);
        const expiresOn = new Date((reqTimestamp + (response.token.expires_in || 0)) * 1000);
        const idTokenClaims = (0, $dfbf8cbb9a592daa$exports).extractTokenClaims(response.token.id_token, this.crypto.base64Decode);
        const account = this.fromNaaAccountInfo(response.account, response.token.id_token, idTokenClaims);
        const scopes = response.token.scope || request.scope;
        const authenticationResult = {
            authority: response.token.authority || account.environment,
            uniqueId: account.localAccountId,
            tenantId: account.tenantId,
            scopes: scopes.split(" "),
            account: account,
            idToken: response.token.id_token,
            idTokenClaims: idTokenClaims,
            accessToken: response.token.access_token,
            fromCache: false,
            expiresOn: expiresOn,
            tokenType: request.authenticationScheme || (0, $08c107807d753255$export$901491a717da2ba5).BEARER,
            correlationId: request.correlationId,
            extExpiresOn: expiresOn,
            state: request.state
        };
        return authenticationResult;
    }
    /*
     *  export type AccountInfo = {
     *     homeAccountId: string;
     *     environment: string;
     *     tenantId: string;
     *     username: string;
     *     localAccountId: string;
     *     name?: string;
     *     idToken?: string;
     *     idTokenClaims?: TokenClaims & {
     *         [key: string]:
     *             | string
     *             | number
     *             | string[]
     *             | object
     *             | undefined
     *             | unknown;
     *     };
     *     nativeAccountId?: string;
     *     authorityType?: string;
     * };
     */ fromNaaAccountInfo(fromAccount, idToken, idTokenClaims) {
        const effectiveIdTokenClaims = idTokenClaims || fromAccount.idTokenClaims;
        const localAccountId = fromAccount.localAccountId || effectiveIdTokenClaims?.oid || effectiveIdTokenClaims?.sub || "";
        const tenantId = fromAccount.tenantId || effectiveIdTokenClaims?.tid || "";
        const homeAccountId = fromAccount.homeAccountId || `${localAccountId}.${tenantId}`;
        const username = fromAccount.username || effectiveIdTokenClaims?.preferred_username || "";
        const name = fromAccount.name || effectiveIdTokenClaims?.name;
        const tenantProfiles = new Map();
        const tenantProfile = (0, $2b6041b9fe3f70e1$export$924857724cb21ba4)(homeAccountId, localAccountId, tenantId, effectiveIdTokenClaims);
        tenantProfiles.set(tenantId, tenantProfile);
        const account = {
            homeAccountId: homeAccountId,
            environment: fromAccount.environment,
            tenantId: tenantId,
            username: username,
            localAccountId: localAccountId,
            name: name,
            idToken: idToken,
            idTokenClaims: effectiveIdTokenClaims,
            tenantProfiles: tenantProfiles
        };
        return account;
    }
    /**
     *
     * @param error BridgeError
     * @returns AuthError, ClientAuthError, ClientConfigurationError, ServerError, InteractionRequiredError
     */ fromBridgeError(error) {
        if ((0, $1202fcc685d1cff5$export$caa3bc10e51dd7ee)(error)) switch(error.status){
            case (0, $d78de803a4cae362$export$6d05f68c12a46a00).UserCancel:
                return new (0, $8382ef0ce9eb98e6$export$a839ff85a7957561)((0, $9f4ee6b47026c448$exports).userCanceled);
            case (0, $d78de803a4cae362$export$6d05f68c12a46a00).NoNetwork:
                return new (0, $8382ef0ce9eb98e6$export$a839ff85a7957561)((0, $9f4ee6b47026c448$exports).noNetworkConnectivity);
            case (0, $d78de803a4cae362$export$6d05f68c12a46a00).AccountUnavailable:
                return new (0, $8382ef0ce9eb98e6$export$a839ff85a7957561)((0, $9f4ee6b47026c448$exports).noAccountFound);
            case (0, $d78de803a4cae362$export$6d05f68c12a46a00).Disabled:
                return new (0, $8382ef0ce9eb98e6$export$a839ff85a7957561)((0, $9f4ee6b47026c448$exports).nestedAppAuthBridgeDisabled);
            case (0, $d78de803a4cae362$export$6d05f68c12a46a00).NestedAppAuthUnavailable:
                return new (0, $8382ef0ce9eb98e6$export$a839ff85a7957561)(error.code || (0, $9f4ee6b47026c448$exports).nestedAppAuthBridgeDisabled, error.description);
            case (0, $d78de803a4cae362$export$6d05f68c12a46a00).TransientError:
            case (0, $d78de803a4cae362$export$6d05f68c12a46a00).PersistentError:
                return new (0, $85fc58951e10e394$export$ea52035eac03daf0)(error.code, error.description);
            case (0, $d78de803a4cae362$export$6d05f68c12a46a00).UserInteractionRequired:
                return new (0, $0171ff24547bf7bf$export$6ba3e818c6bc76ba)(error.code, error.description);
            default:
                return new (0, $53b49d8334c1646a$export$145273558d58e0ac)(error.code, error.description);
        }
        else return new (0, $53b49d8334c1646a$export$145273558d58e0ac)("unknown_error", "An unknown error occurred");
    }
    /**
     * Returns an AuthenticationResult from the given cache items
     *
     * @param account
     * @param idToken
     * @param accessToken
     * @param reqTimestamp
     * @returns
     */ toAuthenticationResultFromCache(account, idToken, accessToken, request, correlationId) {
        if (!idToken || !accessToken) throw (0, $8382ef0ce9eb98e6$export$ea892ce48f5bb4f3)((0, $9f4ee6b47026c448$exports).nullOrEmptyToken);
        const idTokenClaims = (0, $dfbf8cbb9a592daa$exports).extractTokenClaims(idToken.secret, this.crypto.base64Decode);
        const scopes = accessToken.target || request.scopes.join(" ");
        const authenticationResult = {
            authority: accessToken.environment || account.environment,
            uniqueId: account.localAccountId,
            tenantId: account.tenantId,
            scopes: scopes.split(" "),
            account: account,
            idToken: idToken.secret,
            idTokenClaims: idTokenClaims || {},
            accessToken: accessToken.secret,
            fromCache: true,
            expiresOn: new Date(Number(accessToken.expiresOn) * 1000),
            tokenType: request.authenticationScheme || (0, $08c107807d753255$export$901491a717da2ba5).BEARER,
            correlationId: correlationId,
            extExpiresOn: new Date(Number(accessToken.extendedExpiresOn) * 1000),
            state: request.state
        };
        return authenticationResult;
    }
}


/*! @azure/msal-browser v3.30.0 2025-08-05 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * NestedAppAuthErrorMessage class containing string constants used by error codes and messages.
 */ const $00282f204b26dd19$export$81a70490e660273a = {
    unsupportedMethod: {
        code: "unsupported_method",
        desc: "This method is not supported in nested app environment."
    }
};
class $00282f204b26dd19$export$7c79ceb488783308 extends (0, $53b49d8334c1646a$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage){
        super(errorCode, errorMessage);
        Object.setPrototypeOf(this, $00282f204b26dd19$export$7c79ceb488783308.prototype);
        this.name = "NestedAppAuthError";
    }
    static createUnsupportedError() {
        return new $00282f204b26dd19$export$7c79ceb488783308($00282f204b26dd19$export$81a70490e660273a.unsupportedMethod.code, $00282f204b26dd19$export$81a70490e660273a.unsupportedMethod.desc);
    }
}







'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $c6c20faab9333e1b$export$2319deb182e38ab3 {
    constructor(operatingContext){
        this.operatingContext = operatingContext;
        const proxy = this.operatingContext.getBridgeProxy();
        if (proxy !== undefined) this.bridgeProxy = proxy;
        else throw new Error("unexpected: bridgeProxy is undefined");
        // Set the configuration.
        this.config = operatingContext.getConfig();
        // Initialize logger
        this.logger = this.operatingContext.getLogger();
        // Initialize performance client
        this.performanceClient = this.config.telemetry.client;
        // Initialize the crypto class.
        this.browserCrypto = operatingContext.isBrowserEnvironment() ? new (0, $b97228d657d79796$export$c274a7f0ebd24b14)(this.logger, this.performanceClient, true) : (0, $f03a022fda639465$export$865f57d401606752);
        // Initialize the browser storage class.
        this.browserStorage = this.operatingContext.isBrowserEnvironment() ? new (0, $acde3ca448a630dc$export$44d7291b5c8cc149)(this.config.auth.clientId, this.config.cache, this.browserCrypto, this.logger, (0, $dda2270c89fd90c8$export$2b9ebf6f25078cc0)(this.config.auth)) : (0, $acde3ca448a630dc$export$8e2d54002f8f6e5d)(this.config.auth.clientId, this.logger);
        this.eventHandler = new (0, $73896da9aeaab286$export$ce0ba2422a1c7815)(this.logger);
        this.nestedAppAuthAdapter = new (0, $99dae2e01a0cdcb4$export$cee94b20506f02aa)(this.config.auth.clientId, this.config.auth.clientCapabilities, this.browserCrypto, this.logger);
        // Set the active account if available
        const accountContext = this.bridgeProxy.getAccountContext();
        if (accountContext) {
            const correlationId = (0, $b512579b1150f905$export$6ef0355fa80a5278)();
            const cachedAccount = (0, $ba0fbd2fa27ffd1a$export$4f9234baf34abd0)(accountContext, this.logger, this.browserStorage, correlationId);
            (0, $ba0fbd2fa27ffd1a$export$c55c3d25cf1bcd99)(cachedAccount, this.browserStorage, correlationId);
        }
    }
    /**
     * Factory function to create a new instance of NestedAppAuthController
     * @param operatingContext
     * @returns Promise<IController>
     */ static async createController(operatingContext) {
        const controller = new $c6c20faab9333e1b$export$2319deb182e38ab3(operatingContext);
        return Promise.resolve(controller);
    }
    /**
     * Specific implementation of initialize function for NestedAppAuthController
     * @returns
     */ initialize() {
        // do nothing not required by this controller
        return Promise.resolve();
    }
    /**
     * Validate the incoming request and add correlationId if not present
     * @param request
     * @returns
     */ ensureValidRequest(request) {
        if (request?.correlationId) return request;
        return {
            ...request,
            correlationId: this.browserCrypto.createNewGuid()
        };
    }
    /**
     * Internal implementation of acquireTokenInteractive flow
     * @param request
     * @returns
     */ async acquireTokenInteractive(request) {
        const validRequest = this.ensureValidRequest(request);
        this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Popup, validRequest);
        const atPopupMeasurement = this.performanceClient.startMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).AcquireTokenPopup, validRequest.correlationId);
        atPopupMeasurement?.add({
            nestedAppAuthRequest: true
        });
        try {
            const naaRequest = this.nestedAppAuthAdapter.toNaaTokenRequest(validRequest);
            const reqTimestamp = (0, $7dce75f27affa532$exports).nowSeconds();
            const response = await this.bridgeProxy.getTokenInteractive(naaRequest);
            const result = {
                ...this.nestedAppAuthAdapter.fromNaaTokenResponse(naaRequest, response, reqTimestamp)
            };
            // cache the tokens in the response
            await this.hydrateCache(result, request);
            this.browserStorage.setActiveAccount(result.account, result.correlationId);
            this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Popup, result);
            atPopupMeasurement.add({
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            });
            atPopupMeasurement.end({
                success: true,
                requestId: result.requestId
            });
            return result;
        } catch (e) {
            const error = this.nestedAppAuthAdapter.fromBridgeError(e);
            this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Popup, null, e);
            atPopupMeasurement.end({
                success: false
            }, e);
            throw error;
        }
    }
    /**
     * Internal implementation of acquireTokenSilent flow
     * @param request
     * @returns
     */ async acquireTokenSilentInternal(request) {
        const validRequest = this.ensureValidRequest(request);
        this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).ACQUIRE_TOKEN_START, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Silent, validRequest);
        // Look for tokens in the cache first
        const result = await this.acquireTokenFromCache(validRequest);
        if (result) {
            this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Silent, result);
            return result;
        }
        // proceed with acquiring tokens via the host
        const ssoSilentMeasurement = this.performanceClient.startMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).SsoSilent, validRequest.correlationId);
        ssoSilentMeasurement?.increment({
            visibilityChangeCount: 0
        });
        ssoSilentMeasurement?.add({
            nestedAppAuthRequest: true
        });
        try {
            const naaRequest = this.nestedAppAuthAdapter.toNaaTokenRequest(validRequest);
            const reqTimestamp = (0, $7dce75f27affa532$exports).nowSeconds();
            const response = await this.bridgeProxy.getTokenSilent(naaRequest);
            const result = this.nestedAppAuthAdapter.fromNaaTokenResponse(naaRequest, response, reqTimestamp);
            // cache the tokens in the response
            await this.hydrateCache(result, request);
            this.browserStorage.setActiveAccount(result.account, result.correlationId);
            this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Silent, result);
            ssoSilentMeasurement?.add({
                accessTokenSize: result.accessToken.length,
                idTokenSize: result.idToken.length
            });
            ssoSilentMeasurement?.end({
                success: true,
                requestId: result.requestId
            });
            return result;
        } catch (e) {
            const error = this.nestedAppAuthAdapter.fromBridgeError(e);
            this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Silent, null, e);
            ssoSilentMeasurement?.end({
                success: false
            }, e);
            throw error;
        }
    }
    /**
     * acquires tokens from cache
     * @param request
     * @returns
     */ async acquireTokenFromCache(request) {
        const atsMeasurement = this.performanceClient.startMeasurement((0, $32170abc11155933$export$2f2811a3e1b21823).AcquireTokenSilent, request.correlationId);
        atsMeasurement?.add({
            nestedAppAuthRequest: true
        });
        // if the request has claims, we cannot look up in the cache
        if (request.claims) {
            this.logger.verbose("Claims are present in the request, skipping cache lookup");
            return null;
        }
        // respect cache lookup policy
        let result = null;
        switch(request.cacheLookupPolicy){
            case (0, $091acf4c2675819b$export$4394baa7e922d42d).Default:
            case (0, $091acf4c2675819b$export$4394baa7e922d42d).AccessToken:
            case (0, $091acf4c2675819b$export$4394baa7e922d42d).AccessTokenAndRefreshToken:
                result = await this.acquireTokenFromCacheInternal(request);
                break;
            default:
                return null;
        }
        if (result) {
            this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Silent, result);
            atsMeasurement?.add({
                accessTokenSize: result?.accessToken.length,
                idTokenSize: result?.idToken.length
            });
            atsMeasurement?.end({
                success: true
            });
            return result;
        }
        this.logger.error("Cached tokens are not found for the account, proceeding with silent token request.");
        this.eventHandler.emitEvent((0, $15f33001bc68716c$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE, (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Silent, null);
        atsMeasurement?.end({
            success: false
        });
        return null;
    }
    /**
     *
     * @param request
     * @returns
     */ async acquireTokenFromCacheInternal(request) {
        const correlationId = request.correlationId || (0, $b512579b1150f905$export$6ef0355fa80a5278)();
        const accountContext = this.bridgeProxy.getAccountContext();
        let currentAccount = null;
        if (accountContext) {
            const hubAccount = (0, $ba0fbd2fa27ffd1a$export$4f9234baf34abd0)(accountContext, this.logger, this.browserStorage, correlationId);
            // always prioritize for hub account context, the reqirement of `request.account` will be removed soon
            currentAccount = hubAccount || request.account;
        }
        // fall back to brokering if no cached account is found
        if (!currentAccount) {
            this.logger.verbose("No active account found, falling back to the host");
            return Promise.resolve(null);
        }
        this.logger.verbose("active account found, attempting to acquire token silently");
        const authRequest = {
            ...request,
            correlationId: correlationId,
            authority: request.authority || currentAccount.environment,
            scopes: request.scopes?.length ? request.scopes : [
                ...(0, $08c107807d753255$export$893b1b5b686d84ef)
            ]
        };
        // fetch access token and check for expiry
        const tokenKeys = this.browserStorage.getTokenKeys();
        const cachedAccessToken = this.browserStorage.getAccessToken(currentAccount, authRequest, tokenKeys, currentAccount.tenantId, this.performanceClient);
        // If there is no access token, log it and return null
        if (!cachedAccessToken) {
            this.logger.verbose("No cached access token found");
            return Promise.resolve(null);
        } else if ((0, $7dce75f27affa532$exports).wasClockTurnedBack(cachedAccessToken.cachedAt) || (0, $7dce75f27affa532$exports).isTokenExpired(cachedAccessToken.expiresOn, this.config.system.tokenRenewalOffsetSeconds)) {
            this.logger.verbose("Cached access token has expired");
            return Promise.resolve(null);
        }
        const cachedIdToken = this.browserStorage.getIdToken(currentAccount, authRequest.correlationId, tokenKeys, currentAccount.tenantId, this.performanceClient);
        if (!cachedIdToken) {
            this.logger.verbose("No cached id token found");
            return Promise.resolve(null);
        }
        return this.nestedAppAuthAdapter.toAuthenticationResultFromCache(currentAccount, cachedIdToken, cachedAccessToken, authRequest, authRequest.correlationId);
    }
    /**
     * acquireTokenPopup flow implementation
     * @param request
     * @returns
     */ async acquireTokenPopup(request) {
        return this.acquireTokenInteractive(request);
    }
    /**
     * acquireTokenRedirect flow is not supported in nested app auth
     * @param request
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    acquireTokenRedirect(request) {
        throw (0, $00282f204b26dd19$export$7c79ceb488783308).createUnsupportedError();
    }
    /**
     * acquireTokenSilent flow implementation
     * @param silentRequest
     * @returns
     */ async acquireTokenSilent(silentRequest) {
        return this.acquireTokenSilentInternal(silentRequest);
    }
    /**
     * Hybrid flow is not currently supported in nested app auth
     * @param request
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    acquireTokenByCode(request // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        throw (0, $00282f204b26dd19$export$7c79ceb488783308).createUnsupportedError();
    }
    /**
     * acquireTokenNative flow is not currently supported in nested app auth
     * @param request
     * @param apiId
     * @param accountId
     */ acquireTokenNative(request, apiId, accountId // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        throw (0, $00282f204b26dd19$export$7c79ceb488783308).createUnsupportedError();
    }
    /**
     * acquireTokenByRefreshToken flow is not currently supported in nested app auth
     * @param commonRequest
     * @param silentRequest
     */ acquireTokenByRefreshToken(commonRequest, silentRequest // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        throw (0, $00282f204b26dd19$export$7c79ceb488783308).createUnsupportedError();
    }
    /**
     * Adds event callbacks to array
     * @param callback
     * @param eventTypes
     */ addEventCallback(callback, eventTypes) {
        return this.eventHandler.addEventCallback(callback, eventTypes);
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        this.eventHandler.removeEventCallback(callbackId);
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    addPerformanceCallback(callback) {
        throw (0, $00282f204b26dd19$export$7c79ceb488783308).createUnsupportedError();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    removePerformanceCallback(callbackId) {
        throw (0, $00282f204b26dd19$export$7c79ceb488783308).createUnsupportedError();
    }
    enableAccountStorageEvents() {
        throw (0, $00282f204b26dd19$export$7c79ceb488783308).createUnsupportedError();
    }
    disableAccountStorageEvents() {
        throw (0, $00282f204b26dd19$export$7c79ceb488783308).createUnsupportedError();
    }
    // #region Account APIs
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter) {
        const correlationId = (0, $b512579b1150f905$export$6ef0355fa80a5278)();
        return (0, $ba0fbd2fa27ffd1a$export$a4fc43c2a99143cd)(this.logger, this.browserStorage, this.isBrowserEnv(), correlationId, accountFilter);
    }
    /**
     * Returns the first account found in the cache that matches the account filter passed in.
     * @param accountFilter
     * @returns The first account found in the cache matching the provided filter or null if no account could be found.
     */ getAccount(accountFilter) {
        const correlationId = (0, $b512579b1150f905$export$6ef0355fa80a5278)();
        return (0, $ba0fbd2fa27ffd1a$export$4f9234baf34abd0)(accountFilter, this.logger, this.browserStorage, correlationId);
    }
    /**
     * Returns the signed in account matching username.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found.
     * This API is provided for convenience but getAccountById should be used for best reliability
     * @param username
     * @returns The account object stored in MSAL
     */ getAccountByUsername(username) {
        const correlationId = (0, $b512579b1150f905$export$6ef0355fa80a5278)();
        return (0, $ba0fbd2fa27ffd1a$export$d915baf55d86927d)(username, this.logger, this.browserStorage, correlationId);
    }
    /**
     * Returns the signed in account matching homeAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param homeAccountId
     * @returns The account object stored in MSAL
     */ getAccountByHomeId(homeAccountId) {
        const correlationId = (0, $b512579b1150f905$export$6ef0355fa80a5278)();
        return (0, $ba0fbd2fa27ffd1a$export$d6fa7d1e8099998e)(homeAccountId, this.logger, this.browserStorage, correlationId);
    }
    /**
     * Returns the signed in account matching localAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param localAccountId
     * @returns The account object stored in MSAL
     */ getAccountByLocalId(localAccountId) {
        const correlationId = (0, $b512579b1150f905$export$6ef0355fa80a5278)();
        return (0, $ba0fbd2fa27ffd1a$export$7ac8aa09fdf78340)(localAccountId, this.logger, this.browserStorage, correlationId);
    }
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */ setActiveAccount(account) {
        /*
         * StandardController uses this to allow the developer to set the active account
         * in the nested app auth scenario the active account is controlled by the app hosting the nested app
         */ const correlationId = (0, $b512579b1150f905$export$6ef0355fa80a5278)();
        return (0, $ba0fbd2fa27ffd1a$export$c55c3d25cf1bcd99)(account, this.browserStorage, correlationId);
    }
    /**
     * Gets the currently active account
     */ getActiveAccount() {
        const correlationId = (0, $b512579b1150f905$export$6ef0355fa80a5278)();
        return (0, $ba0fbd2fa27ffd1a$export$13dd2e33a23839ad)(this.browserStorage, correlationId);
    }
    // #endregion
    handleRedirectPromise(hash // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        return Promise.resolve(null);
    }
    loginPopup(request // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        return this.acquireTokenInteractive(request || (0, $091acf4c2675819b$export$7e12949cd6884193));
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    loginRedirect(request) {
        throw (0, $00282f204b26dd19$export$7c79ceb488783308).createUnsupportedError();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    logout(logoutRequest) {
        throw (0, $00282f204b26dd19$export$7c79ceb488783308).createUnsupportedError();
    }
    logoutRedirect(logoutRequest // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        throw (0, $00282f204b26dd19$export$7c79ceb488783308).createUnsupportedError();
    }
    logoutPopup(logoutRequest // eslint-disable-line @typescript-eslint/no-unused-vars
    ) {
        throw (0, $00282f204b26dd19$export$7c79ceb488783308).createUnsupportedError();
    }
    ssoSilent(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    request) {
        return this.acquireTokenSilentInternal(request);
    }
    getTokenCache() {
        throw (0, $00282f204b26dd19$export$7c79ceb488783308).createUnsupportedError();
    }
    /**
     * Returns the logger instance
     */ getLogger() {
        return this.logger;
    }
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */ setLogger(logger) {
        this.logger = logger;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    initializeWrapperLibrary(sku, version) {
        /*
         * Standard controller uses this to set the sku and version of the wrapper library in the storage
         * we do nothing here
         */ return;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setNavigationClient(navigationClient) {
        this.logger.warning("setNavigationClient is not supported in nested app auth");
    }
    getConfiguration() {
        return this.config;
    }
    isBrowserEnv() {
        return this.operatingContext.isBrowserEnvironment();
    }
    getBrowserCrypto() {
        return this.browserCrypto;
    }
    getPerformanceClient() {
        throw (0, $00282f204b26dd19$export$7c79ceb488783308).createUnsupportedError();
    }
    getRedirectResponse() {
        throw (0, $00282f204b26dd19$export$7c79ceb488783308).createUnsupportedError();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    async clearCache(logoutRequest) {
        throw (0, $00282f204b26dd19$export$7c79ceb488783308).createUnsupportedError();
    }
    async hydrateCache(result, request) {
        this.logger.verbose("hydrateCache called");
        const accountEntity = (0, $35a4414ce05ac30e$export$680160523e6bfa6a).createFromAccountInfo(result.account, result.cloudGraphHostName, result.msGraphHost);
        this.browserStorage.setAccount(accountEntity, result.correlationId);
        return this.browserStorage.hydrateCache(result, request);
    }
}


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ async function $70a3229a10343334$export$414d5e42be8c56db(config, request) {
    const standard = new (0, $58111f41d057aaf0$export$f39c23bbfed89e6e)(config);
    await standard.initialize();
    return (0, $07a809f266e440d6$export$e9d1ef1cb8705404).createController(standard, request);
}
async function $70a3229a10343334$export$6a1d744b364856f2(config) {
    const standard = new (0, $58111f41d057aaf0$export$f39c23bbfed89e6e)(config);
    const nestedApp = new (0, $a94b06492cd1639d$export$a2170d4e3f010950)(config);
    const operatingContexts = [
        standard.initialize(),
        nestedApp.initialize()
    ];
    await Promise.all(operatingContexts);
    if (nestedApp.isAvailable() && config.auth.supportsNestedAppAuth) return (0, $c6c20faab9333e1b$export$2319deb182e38ab3).createController(nestedApp);
    else if (standard.isAvailable()) return (0, $07a809f266e440d6$export$e9d1ef1cb8705404).createController(standard);
    else // Since neither of the actual operating contexts are available keep the UnknownOperatingContextController
    return null;
}






'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * The PublicClientApplication class is the object exposed by the library to perform authentication and authorization functions in Single Page Applications
 * to obtain JWT tokens as described in the OAuth 2.0 Authorization Code Flow with PKCE specification.
 */ class $c99e07903adb4e65$export$89f4855ef88b7920 {
    /**
     * Creates StandardController and passes it to the PublicClientApplication
     *
     * @param configuration {Configuration}
     */ static async createPublicClientApplication(configuration) {
        const controller = await (0, $70a3229a10343334$export$414d5e42be8c56db)(configuration);
        const pca = new $c99e07903adb4e65$export$89f4855ef88b7920(configuration, controller);
        return pca;
    }
    /**
     * @constructor
     * Constructor for the PublicClientApplication used to instantiate the PublicClientApplication object
     *
     * Important attributes in the Configuration object for auth are:
     * - clientID: the application ID of your application. You can obtain one by registering your application with our Application registration portal : https://portal.azure.com/#blade/Microsoft_AAD_IAM/ActiveDirectoryMenuBlade/RegisteredAppsPreview
     * - authority: the authority URL for your application.
     * - redirect_uri: the uri of your application registered in the portal.
     *
     * In Azure AD, authority is a URL indicating the Azure active directory that MSAL uses to obtain tokens.
     * It is of the form https://login.microsoftonline.com/{Enter_the_Tenant_Info_Here}
     * If your application supports Accounts in one organizational directory, replace "Enter_the_Tenant_Info_Here" value with the Tenant Id or Tenant name (for example, contoso.microsoft.com).
     * If your application supports Accounts in any organizational directory, replace "Enter_the_Tenant_Info_Here" value with organizations.
     * If your application supports Accounts in any organizational directory and personal Microsoft accounts, replace "Enter_the_Tenant_Info_Here" value with common.
     * To restrict support to Personal Microsoft accounts only, replace "Enter_the_Tenant_Info_Here" value with consumers.
     *
     * In Azure B2C, authority is of the form https://{instance}/tfp/{tenant}/{policyName}/
     * Full B2C functionality will be available in this library in future versions.
     *
     * @param configuration Object for the MSAL PublicClientApplication instance
     * @param IController Optional parameter to explictly set the controller. (Will be removed when we remove public constructor)
     */ constructor(configuration, controller){
        this.controller = controller || new (0, $07a809f266e440d6$export$e9d1ef1cb8705404)(new (0, $58111f41d057aaf0$export$f39c23bbfed89e6e)(configuration));
    }
    /**
     * Initializer function to perform async startup tasks such as connecting to WAM extension
     * @param request {?InitializeApplicationRequest}
     */ async initialize(request) {
        return this.controller.initialize(request);
    }
    /**
     * Use when you want to obtain an access_token for your API via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ async acquireTokenPopup(request) {
        return this.controller.acquireTokenPopup(request);
    }
    /**
     * Use when you want to obtain an access_token for your API by redirecting the user's browser window to the authorization endpoint. This function redirects
     * the page, so any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ acquireTokenRedirect(request) {
        return this.controller.acquireTokenRedirect(request);
    }
    /**
     * Silently acquire an access token for a given set of scopes. Returns currently processing promise if parallel requests are made.
     *
     * @param {@link (SilentRequest:type)}
     * @returns {Promise.<AuthenticationResult>} - a promise that is fulfilled when this function has completed, or rejected if an error was raised. Returns the {@link AuthenticationResult} object
     */ acquireTokenSilent(silentRequest) {
        return this.controller.acquireTokenSilent(silentRequest);
    }
    /**
     * This function redeems an authorization code (passed as code) from the eSTS token endpoint.
     * This authorization code should be acquired server-side using a confidential client to acquire a spa_code.
     * This API is not indended for normal authorization code acquisition and redemption.
     *
     * Redemption of this authorization code will not require PKCE, as it was acquired by a confidential client.
     *
     * @param request {@link AuthorizationCodeRequest}
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ acquireTokenByCode(request) {
        return this.controller.acquireTokenByCode(request);
    }
    /**
     * Adds event callbacks to array
     * @param callback
     * @param eventTypes
     */ addEventCallback(callback, eventTypes) {
        return this.controller.addEventCallback(callback, eventTypes);
    }
    /**
     * Removes callback with provided id from callback array
     * @param callbackId
     */ removeEventCallback(callbackId) {
        return this.controller.removeEventCallback(callbackId);
    }
    /**
     * Registers a callback to receive performance events.
     *
     * @param {PerformanceCallbackFunction} callback
     * @returns {string}
     */ addPerformanceCallback(callback) {
        return this.controller.addPerformanceCallback(callback);
    }
    /**
     * Removes a callback registered with addPerformanceCallback.
     *
     * @param {string} callbackId
     * @returns {boolean}
     */ removePerformanceCallback(callbackId) {
        return this.controller.removePerformanceCallback(callbackId);
    }
    /**
     * Adds event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     */ enableAccountStorageEvents() {
        this.controller.enableAccountStorageEvents();
    }
    /**
     * Removes event listener that emits an event when a user account is added or removed from localstorage in a different browser tab or window
     */ disableAccountStorageEvents() {
        this.controller.disableAccountStorageEvents();
    }
    /**
     * Returns the first account found in the cache that matches the account filter passed in.
     * @param accountFilter
     * @returns The first account found in the cache matching the provided filter or null if no account could be found.
     */ getAccount(accountFilter) {
        return this.controller.getAccount(accountFilter);
    }
    /**
     * Returns the signed in account matching homeAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param homeAccountId
     * @returns The account object stored in MSAL
     * @deprecated - Use getAccount instead
     */ getAccountByHomeId(homeAccountId) {
        return this.controller.getAccountByHomeId(homeAccountId);
    }
    /**
     * Returns the signed in account matching localAccountId.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found
     * @param localAccountId
     * @returns The account object stored in MSAL
     * @deprecated - Use getAccount instead
     */ getAccountByLocalId(localId) {
        return this.controller.getAccountByLocalId(localId);
    }
    /**
     * Returns the signed in account matching username.
     * (the account object is created at the time of successful login)
     * or null when no matching account is found.
     * This API is provided for convenience but getAccountById should be used for best reliability
     * @param userName
     * @returns The account object stored in MSAL
     * @deprecated - Use getAccount instead
     */ getAccountByUsername(userName) {
        return this.controller.getAccountByUsername(userName);
    }
    /**
     * Returns all the accounts in the cache that match the optional filter. If no filter is provided, all accounts are returned.
     * @param accountFilter - (Optional) filter to narrow down the accounts returned
     * @returns Array of AccountInfo objects in cache
     */ getAllAccounts(accountFilter) {
        return this.controller.getAllAccounts(accountFilter);
    }
    /**
     * Event handler function which allows users to fire events after the PublicClientApplication object
     * has loaded during redirect flows. This should be invoked on all page loads involved in redirect
     * auth flows.
     * @param hash Hash to process. Defaults to the current value of window.location.hash. Only needs to be provided explicitly if the response to be handled is not contained in the current value.
     * @returns Token response or null. If the return value is null, then no auth redirect was detected.
     */ handleRedirectPromise(hash) {
        return this.controller.handleRedirectPromise(hash);
    }
    /**
     * Use when initiating the login process via opening a popup window in the user's browser
     *
     * @param request
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ loginPopup(request) {
        return this.controller.loginPopup(request);
    }
    /**
     * Use when initiating the login process by redirecting the user's browser to the authorization endpoint. This function redirects the page, so
     * any code that follows this function will not execute.
     *
     * IMPORTANT: It is NOT recommended to have code that is dependent on the resolution of the Promise. This function will navigate away from the current
     * browser window. It currently returns a Promise in order to reflect the asynchronous nature of the code running in this function.
     *
     * @param request
     */ loginRedirect(request) {
        return this.controller.loginRedirect(request);
    }
    /**
     * Deprecated logout function. Use logoutRedirect or logoutPopup instead
     * @param logoutRequest
     * @deprecated
     */ logout(logoutRequest) {
        return this.controller.logout(logoutRequest);
    }
    /**
     * Use to log out the current user, and redirect the user to the postLogoutRedirectUri.
     * Default behaviour is to redirect the user to `window.location.href`.
     * @param logoutRequest
     */ logoutRedirect(logoutRequest) {
        return this.controller.logoutRedirect(logoutRequest);
    }
    /**
     * Clears local cache for the current user then opens a popup window prompting the user to sign-out of the server
     * @param logoutRequest
     */ logoutPopup(logoutRequest) {
        return this.controller.logoutPopup(logoutRequest);
    }
    /**
     * This function uses a hidden iframe to fetch an authorization code from the eSTS. There are cases where this may not work:
     * - Any browser using a form of Intelligent Tracking Prevention
     * - If there is not an established session with the service
     *
     * In these cases, the request must be done inside a popup or full frame redirect.
     *
     * For the cases where interaction is required, you cannot send a request with prompt=none.
     *
     * If your refresh token has expired, you can use this function to fetch a new set of tokens silently as long as
     * you session on the server still exists.
     * @param request {@link SsoSilentRequest}
     *
     * @returns A promise that is fulfilled when this function has completed, or rejected if an error was raised.
     */ ssoSilent(request) {
        return this.controller.ssoSilent(request);
    }
    /**
     * Gets the token cache for the application.
     */ getTokenCache() {
        return this.controller.getTokenCache();
    }
    /**
     * Returns the logger instance
     */ getLogger() {
        return this.controller.getLogger();
    }
    /**
     * Replaces the default logger set in configurations with new Logger with new configurations
     * @param logger Logger instance
     */ setLogger(logger) {
        this.controller.setLogger(logger);
    }
    /**
     * Sets the account to use as the active account. If no account is passed to the acquireToken APIs, then MSAL will use this active account.
     * @param account
     */ setActiveAccount(account) {
        this.controller.setActiveAccount(account);
    }
    /**
     * Gets the currently active account
     */ getActiveAccount() {
        return this.controller.getActiveAccount();
    }
    /**
     * Called by wrapper libraries (Angular & React) to set SKU and Version passed down to telemetry, logger, etc.
     * @param sku
     * @param version
     */ initializeWrapperLibrary(sku, version) {
        return this.controller.initializeWrapperLibrary(sku, version);
    }
    /**
     * Sets navigation client
     * @param navigationClient
     */ setNavigationClient(navigationClient) {
        this.controller.setNavigationClient(navigationClient);
    }
    /**
     * Returns the configuration object
     * @internal
     */ getConfiguration() {
        return this.controller.getConfiguration();
    }
    /**
     * Hydrates cache with the tokens and account in the AuthenticationResult object
     * @param result
     * @param request - The request object that was used to obtain the AuthenticationResult
     * @returns
     */ async hydrateCache(result, request) {
        return this.controller.hydrateCache(result, request);
    }
    /**
     * Clears tokens and account from the browser cache.
     * @param logoutRequest
     */ clearCache(logoutRequest) {
        return this.controller.clearCache(logoutRequest);
    }
}
/**
 * creates NestedAppAuthController and passes it to the PublicClientApplication,
 * falls back to StandardController if NestedAppAuthController is not available
 *
 * @param configuration
 * @returns IPublicClientApplication
 *
 */ async function $c99e07903adb4e65$export$210078d2745a65ac(configuration) {
    const nestedAppAuth = new (0, $a94b06492cd1639d$export$a2170d4e3f010950)(configuration);
    await nestedAppAuth.initialize();
    if (nestedAppAuth.isAvailable()) {
        const controller = new (0, $c6c20faab9333e1b$export$2319deb182e38ab3)(nestedAppAuth);
        return new $c99e07903adb4e65$export$89f4855ef88b7920(configuration, controller);
    }
    return $c99e07903adb4e65$export$f28b97cfb2f3098(configuration);
}
/**
 * creates PublicClientApplication using StandardController
 *
 * @param configuration
 * @returns IPublicClientApplication
 *
 */ async function $c99e07903adb4e65$export$f28b97cfb2f3098(configuration) {
    const pca = new $c99e07903adb4e65$export$89f4855ef88b7920(configuration);
    await pca.initialize();
    return pca;
}


/*! @azure/msal-react v2.2.0 2024-11-05 */ /*! @azure/msal-react v2.2.0 2024-11-05 */ 
var $7fPBF = parcelRequire("7fPBF");
/*! @azure/msal-browser v3.30.0 2025-08-05 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $dde6acd356adb1b5$export$29650b96fd06034a = {
    initialize: ()=>{
        return Promise.reject((0, $d1b404816c4f6b37$export$176bd5050947ba0c)((0, $a9716436b0450272$export$1377ea690fa0b6d8)));
    },
    acquireTokenPopup: ()=>{
        return Promise.reject((0, $d1b404816c4f6b37$export$176bd5050947ba0c)((0, $a9716436b0450272$export$1377ea690fa0b6d8)));
    },
    acquireTokenRedirect: ()=>{
        return Promise.reject((0, $d1b404816c4f6b37$export$176bd5050947ba0c)((0, $a9716436b0450272$export$1377ea690fa0b6d8)));
    },
    acquireTokenSilent: ()=>{
        return Promise.reject((0, $d1b404816c4f6b37$export$176bd5050947ba0c)((0, $a9716436b0450272$export$1377ea690fa0b6d8)));
    },
    acquireTokenByCode: ()=>{
        return Promise.reject((0, $d1b404816c4f6b37$export$176bd5050947ba0c)((0, $a9716436b0450272$export$1377ea690fa0b6d8)));
    },
    getAllAccounts: ()=>{
        return [];
    },
    getAccount: ()=>{
        return null;
    },
    getAccountByHomeId: ()=>{
        return null;
    },
    getAccountByUsername: ()=>{
        return null;
    },
    getAccountByLocalId: ()=>{
        return null;
    },
    handleRedirectPromise: ()=>{
        return Promise.reject((0, $d1b404816c4f6b37$export$176bd5050947ba0c)((0, $a9716436b0450272$export$1377ea690fa0b6d8)));
    },
    loginPopup: ()=>{
        return Promise.reject((0, $d1b404816c4f6b37$export$176bd5050947ba0c)((0, $a9716436b0450272$export$1377ea690fa0b6d8)));
    },
    loginRedirect: ()=>{
        return Promise.reject((0, $d1b404816c4f6b37$export$176bd5050947ba0c)((0, $a9716436b0450272$export$1377ea690fa0b6d8)));
    },
    logout: ()=>{
        return Promise.reject((0, $d1b404816c4f6b37$export$176bd5050947ba0c)((0, $a9716436b0450272$export$1377ea690fa0b6d8)));
    },
    logoutRedirect: ()=>{
        return Promise.reject((0, $d1b404816c4f6b37$export$176bd5050947ba0c)((0, $a9716436b0450272$export$1377ea690fa0b6d8)));
    },
    logoutPopup: ()=>{
        return Promise.reject((0, $d1b404816c4f6b37$export$176bd5050947ba0c)((0, $a9716436b0450272$export$1377ea690fa0b6d8)));
    },
    ssoSilent: ()=>{
        return Promise.reject((0, $d1b404816c4f6b37$export$176bd5050947ba0c)((0, $a9716436b0450272$export$1377ea690fa0b6d8)));
    },
    addEventCallback: ()=>{
        return null;
    },
    removeEventCallback: ()=>{
        return;
    },
    addPerformanceCallback: ()=>{
        return "";
    },
    removePerformanceCallback: ()=>{
        return false;
    },
    enableAccountStorageEvents: ()=>{
        return;
    },
    disableAccountStorageEvents: ()=>{
        return;
    },
    getTokenCache: ()=>{
        throw (0, $d1b404816c4f6b37$export$176bd5050947ba0c)((0, $a9716436b0450272$export$1377ea690fa0b6d8));
    },
    getLogger: ()=>{
        throw (0, $d1b404816c4f6b37$export$176bd5050947ba0c)((0, $a9716436b0450272$export$1377ea690fa0b6d8));
    },
    setLogger: ()=>{
        return;
    },
    setActiveAccount: ()=>{
        return;
    },
    getActiveAccount: ()=>{
        return null;
    },
    initializeWrapperLibrary: ()=>{
        return;
    },
    setNavigationClient: ()=>{
        return;
    },
    getConfiguration: ()=>{
        throw (0, $d1b404816c4f6b37$export$176bd5050947ba0c)((0, $a9716436b0450272$export$1377ea690fa0b6d8));
    },
    hydrateCache: ()=>{
        return Promise.reject((0, $d1b404816c4f6b37$export$176bd5050947ba0c)((0, $a9716436b0450272$export$1377ea690fa0b6d8)));
    },
    clearCache: ()=>{
        return Promise.reject((0, $d1b404816c4f6b37$export$176bd5050947ba0c)((0, $a9716436b0450272$export$1377ea690fa0b6d8)));
    }
};


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /*
 * Stubbed context implementation
 * Only used when there is no provider, which is an unsupported scenario
 */ const $f4c3218338dabc5f$var$defaultMsalContext = {
    instance: (0, $dde6acd356adb1b5$export$29650b96fd06034a),
    inProgress: (0, $091acf4c2675819b$export$bec20eda0179362b).None,
    accounts: [],
    logger: new (0, $4643cd557adfd6d5$export$efa9a398d6368992)({})
};
const $f4c3218338dabc5f$export$66324aeea97dd1e5 = $7fPBF.createContext($f4c3218338dabc5f$var$defaultMsalContext);
const $f4c3218338dabc5f$export$b74154d0810e24c1 = $f4c3218338dabc5f$export$66324aeea97dd1e5.Consumer;


/*! @azure/msal-react v2.2.0 2024-11-05 */ 
var $7fPBF = parcelRequire("7fPBF");
/*! @azure/msal-browser v3.30.0 2025-08-05 */ 

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ class $8ac7d15fc10e332c$export$ba9166e03da6599c {
    /**
     * Gets interaction status from event message
     * @param message
     * @param currentStatus
     */ static getInteractionStatusFromEvent(message, currentStatus) {
        switch(message.eventType){
            case (0, $15f33001bc68716c$export$3d7865934588d77e).LOGIN_START:
                return (0, $091acf4c2675819b$export$bec20eda0179362b).Login;
            case (0, $15f33001bc68716c$export$3d7865934588d77e).SSO_SILENT_START:
                return (0, $091acf4c2675819b$export$bec20eda0179362b).SsoSilent;
            case (0, $15f33001bc68716c$export$3d7865934588d77e).ACQUIRE_TOKEN_START:
                if (message.interactionType === (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Redirect || message.interactionType === (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Popup) return (0, $091acf4c2675819b$export$bec20eda0179362b).AcquireToken;
                break;
            case (0, $15f33001bc68716c$export$3d7865934588d77e).HANDLE_REDIRECT_START:
                return (0, $091acf4c2675819b$export$bec20eda0179362b).HandleRedirect;
            case (0, $15f33001bc68716c$export$3d7865934588d77e).LOGOUT_START:
                return (0, $091acf4c2675819b$export$bec20eda0179362b).Logout;
            case (0, $15f33001bc68716c$export$3d7865934588d77e).SSO_SILENT_SUCCESS:
            case (0, $15f33001bc68716c$export$3d7865934588d77e).SSO_SILENT_FAILURE:
                if (currentStatus && currentStatus !== (0, $091acf4c2675819b$export$bec20eda0179362b).SsoSilent) break;
                return (0, $091acf4c2675819b$export$bec20eda0179362b).None;
            case (0, $15f33001bc68716c$export$3d7865934588d77e).LOGOUT_END:
                if (currentStatus && currentStatus !== (0, $091acf4c2675819b$export$bec20eda0179362b).Logout) break;
                return (0, $091acf4c2675819b$export$bec20eda0179362b).None;
            case (0, $15f33001bc68716c$export$3d7865934588d77e).HANDLE_REDIRECT_END:
                if (currentStatus && currentStatus !== (0, $091acf4c2675819b$export$bec20eda0179362b).HandleRedirect) break;
                return (0, $091acf4c2675819b$export$bec20eda0179362b).None;
            case (0, $15f33001bc68716c$export$3d7865934588d77e).LOGIN_SUCCESS:
            case (0, $15f33001bc68716c$export$3d7865934588d77e).LOGIN_FAILURE:
            case (0, $15f33001bc68716c$export$3d7865934588d77e).ACQUIRE_TOKEN_SUCCESS:
            case (0, $15f33001bc68716c$export$3d7865934588d77e).ACQUIRE_TOKEN_FAILURE:
            case (0, $15f33001bc68716c$export$3d7865934588d77e).RESTORE_FROM_BFCACHE:
                if (message.interactionType === (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Redirect || message.interactionType === (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Popup) {
                    if (currentStatus && currentStatus !== (0, $091acf4c2675819b$export$bec20eda0179362b).Login && currentStatus !== (0, $091acf4c2675819b$export$bec20eda0179362b).AcquireToken) break;
                    return (0, $091acf4c2675819b$export$bec20eda0179362b).None;
                }
                break;
        }
        return null;
    }
}



/*! @azure/msal-react v2.2.0 2024-11-05 */ 'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $7f8ae2d45d6f70c2$export$7a39d5906c5d6010(children, args) {
    if (typeof children === "function") return children(args);
    return children;
}
/**
 * Helper function to determine whether 2 arrays are equal
 * Used to avoid unnecessary state updates
 * @param arrayA
 * @param arrayB
 */ function $7f8ae2d45d6f70c2$export$601fd69958c01c8c(arrayA, arrayB) {
    if (arrayA.length !== arrayB.length) return false;
    const comparisonArray = [
        ...arrayB
    ];
    return arrayA.every((elementA)=>{
        const elementB = comparisonArray.shift();
        if (!elementA || !elementB) return false;
        return elementA.homeAccountId === elementB.homeAccountId && elementA.localAccountId === elementB.localAccountId && elementA.username === elementB.username;
    });
}
function $7f8ae2d45d6f70c2$export$fa581286d49c51db(allAccounts, accountIdentifiers) {
    if (allAccounts.length > 0 && (accountIdentifiers.homeAccountId || accountIdentifiers.localAccountId || accountIdentifiers.username)) {
        const matchedAccounts = allAccounts.filter((accountObj)=>{
            if (accountIdentifiers.username && accountIdentifiers.username.toLowerCase() !== accountObj.username.toLowerCase()) return false;
            if (accountIdentifiers.homeAccountId && accountIdentifiers.homeAccountId.toLowerCase() !== accountObj.homeAccountId.toLowerCase()) return false;
            if (accountIdentifiers.localAccountId && accountIdentifiers.localAccountId.toLowerCase() !== accountObj.localAccountId.toLowerCase()) return false;
            return true;
        });
        return matchedAccounts[0] || null;
    } else return null;
}


/*! @azure/msal-react v2.2.0 2024-11-05 */ 'use strict';
/* eslint-disable header/header */ const $5b1d1fdd3bd75eef$export$a8ff84c12d48cfa6 = "@azure/msal-react";
const $5b1d1fdd3bd75eef$export$83d89fbfd8236492 = "2.2.0";


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $3e5b0bdd73df37c9$var$MsalProviderActionType = {
    UNBLOCK_INPROGRESS: "UNBLOCK_INPROGRESS",
    EVENT: "EVENT"
};
/**
 * Returns the next inProgress and accounts state based on event message
 * @param previousState
 * @param action
 */ const $3e5b0bdd73df37c9$var$reducer = (previousState, action)=>{
    const { type: type, payload: payload } = action;
    let newInProgress = previousState.inProgress;
    switch(type){
        case $3e5b0bdd73df37c9$var$MsalProviderActionType.UNBLOCK_INPROGRESS:
            if (previousState.inProgress === (0, $091acf4c2675819b$export$bec20eda0179362b).Startup) {
                newInProgress = (0, $091acf4c2675819b$export$bec20eda0179362b).None;
                payload.logger.info("MsalProvider - handleRedirectPromise resolved, setting inProgress to 'none'");
            }
            break;
        case $3e5b0bdd73df37c9$var$MsalProviderActionType.EVENT:
            const message = payload.message;
            const status = (0, $8ac7d15fc10e332c$export$ba9166e03da6599c).getInteractionStatusFromEvent(message, previousState.inProgress);
            if (status) {
                payload.logger.info(`MsalProvider - ${message.eventType} results in setting inProgress from ${previousState.inProgress} to ${status}`);
                newInProgress = status;
            }
            break;
        default:
            throw new Error(`Unknown action type: ${type}`);
    }
    const currentAccounts = payload.instance.getAllAccounts();
    if (newInProgress !== previousState.inProgress && !(0, $7f8ae2d45d6f70c2$export$601fd69958c01c8c)(currentAccounts, previousState.accounts)) // Both inProgress and accounts changed
    return {
        ...previousState,
        inProgress: newInProgress,
        accounts: currentAccounts
    };
    else if (newInProgress !== previousState.inProgress) // Only only inProgress changed
    return {
        ...previousState,
        inProgress: newInProgress
    };
    else if (!(0, $7f8ae2d45d6f70c2$export$601fd69958c01c8c)(currentAccounts, previousState.accounts)) // Only accounts changed
    return {
        ...previousState,
        accounts: currentAccounts
    };
    else // Nothing changed
    return previousState;
};
/**
 * MSAL context provider component. This must be rendered above any other components that use MSAL.
 */ function $3e5b0bdd73df37c9$export$25bac41dc3d78d47({ instance: instance, children: children }) {
    (0, $7fPBF.useEffect)(()=>{
        instance.initializeWrapperLibrary((0, $091acf4c2675819b$export$8abb9de997bb4e44).React, (0, $5b1d1fdd3bd75eef$export$83d89fbfd8236492));
    }, [
        instance
    ]);
    // Create a logger instance for msal-react with the same options as PublicClientApplication
    const logger = (0, $7fPBF.useMemo)(()=>{
        return instance.getLogger().clone((0, $5b1d1fdd3bd75eef$export$a8ff84c12d48cfa6), (0, $5b1d1fdd3bd75eef$export$83d89fbfd8236492));
    }, [
        instance
    ]);
    const [state, updateState] = (0, $7fPBF.useReducer)($3e5b0bdd73df37c9$var$reducer, undefined, ()=>{
        // Lazy initialization of the initial state
        return {
            inProgress: (0, $091acf4c2675819b$export$bec20eda0179362b).Startup,
            accounts: instance.getAllAccounts()
        };
    });
    (0, $7fPBF.useEffect)(()=>{
        const callbackId = instance.addEventCallback((message)=>{
            updateState({
                payload: {
                    instance: instance,
                    logger: logger,
                    message: message
                },
                type: $3e5b0bdd73df37c9$var$MsalProviderActionType.EVENT
            });
        });
        logger.verbose(`MsalProvider - Registered event callback with id: ${callbackId}`);
        instance.initialize().then(()=>{
            instance.handleRedirectPromise().catch(()=>{
                // Errors should be handled by listening to the LOGIN_FAILURE event
                return;
            }).finally(()=>{
                /*
                 * If handleRedirectPromise returns a cached promise the necessary events may not be fired
                 * This is a fallback to prevent inProgress from getting stuck in 'startup'
                 */ updateState({
                    payload: {
                        instance: instance,
                        logger: logger
                    },
                    type: $3e5b0bdd73df37c9$var$MsalProviderActionType.UNBLOCK_INPROGRESS
                });
            });
        }).catch(()=>{
            // Errors should be handled by listening to the LOGIN_FAILURE event
            return;
        });
        return ()=>{
            // Remove callback when component unmounts or accounts change
            if (callbackId) {
                logger.verbose(`MsalProvider - Removing event callback ${callbackId}`);
                instance.removeEventCallback(callbackId);
            }
        };
    }, [
        instance,
        logger
    ]);
    const contextValue = {
        instance: instance,
        inProgress: state.inProgress,
        accounts: state.accounts,
        logger: logger
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $f4c3218338dabc5f$export$66324aeea97dd1e5).Provider, {
        value: contextValue
    }, children);
}


/*! @azure/msal-react v2.2.0 2024-11-05 */ 
var $7fPBF = parcelRequire("7fPBF");

/*! @azure/msal-react v2.2.0 2024-11-05 */ 
var $7fPBF = parcelRequire("7fPBF");

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Returns Msal Context values
 */ const $f8cae32216c5cd58$export$f41558044a1dd55 = ()=>(0, $7fPBF.useContext)((0, $f4c3218338dabc5f$export$66324aeea97dd1e5));


/*! @azure/msal-react v2.2.0 2024-11-05 */ 
var $7fPBF = parcelRequire("7fPBF");



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $f9d2523957423cdc$var$isAuthenticated(allAccounts, matchAccount) {
    if (matchAccount && (matchAccount.username || matchAccount.homeAccountId || matchAccount.localAccountId)) return !!(0, $7f8ae2d45d6f70c2$export$fa581286d49c51db)(allAccounts, matchAccount);
    return allAccounts.length > 0;
}
/**
 * Returns whether or not a user is currently signed-in. Optionally provide 1 or more accountIdentifiers to determine if a specific user is signed-in
 * @param matchAccount
 */ function $f9d2523957423cdc$export$7e9c60d6d1836c84(matchAccount) {
    const { accounts: allAccounts, inProgress: inProgress } = (0, $f8cae32216c5cd58$export$f41558044a1dd55)();
    const isUserAuthenticated = (0, $7fPBF.useMemo)(()=>{
        if (inProgress === (0, $091acf4c2675819b$export$bec20eda0179362b).Startup) return false;
        return $f9d2523957423cdc$var$isAuthenticated(allAccounts, matchAccount);
    }, [
        allAccounts,
        inProgress,
        matchAccount
    ]);
    return isUserAuthenticated;
}



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Renders child components if user is authenticated
 * @param props
 */ function $8bf74becfd97247d$export$3f7734c901feade6({ username: username, homeAccountId: homeAccountId, localAccountId: localAccountId, children: children }) {
    const context = (0, $f8cae32216c5cd58$export$f41558044a1dd55)();
    const accountIdentifier = (0, $7fPBF.useMemo)(()=>{
        return {
            username: username,
            homeAccountId: homeAccountId,
            localAccountId: localAccountId
        };
    }, [
        username,
        homeAccountId,
        localAccountId
    ]);
    const isAuthenticated = (0, $f9d2523957423cdc$export$7e9c60d6d1836c84)(accountIdentifier);
    if (isAuthenticated && context.inProgress !== (0, $091acf4c2675819b$export$bec20eda0179362b).Startup) return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, (0, $7f8ae2d45d6f70c2$export$7a39d5906c5d6010)(children, context));
    return null;
}


/*! @azure/msal-react v2.2.0 2024-11-05 */ 
var $7fPBF = parcelRequire("7fPBF");




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Renders child components if user is unauthenticated
 * @param props
 */ function $d41cd79556f3e484$export$8285a35799c5812b({ username: username, homeAccountId: homeAccountId, localAccountId: localAccountId, children: children }) {
    const context = (0, $f8cae32216c5cd58$export$f41558044a1dd55)();
    const accountIdentifier = (0, $7fPBF.useMemo)(()=>{
        return {
            username: username,
            homeAccountId: homeAccountId,
            localAccountId: localAccountId
        };
    }, [
        username,
        homeAccountId,
        localAccountId
    ]);
    const isAuthenticated = (0, $f9d2523957423cdc$export$7e9c60d6d1836c84)(accountIdentifier);
    if (!isAuthenticated && context.inProgress !== (0, $091acf4c2675819b$export$bec20eda0179362b).Startup && context.inProgress !== (0, $091acf4c2675819b$export$bec20eda0179362b).HandleRedirect) return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, (0, $7f8ae2d45d6f70c2$export$7a39d5906c5d6010)(children, context));
    return null;
}


/*! @azure/msal-react v2.2.0 2024-11-05 */ 
var $7fPBF = parcelRequire("7fPBF");


/*! @azure/msal-react v2.2.0 2024-11-05 */ 
var $7fPBF = parcelRequire("7fPBF");



/*! @azure/msal-react v2.2.0 2024-11-05 */ 
var $7fPBF = parcelRequire("7fPBF");



'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ function $3ce1473fd8c294d9$var$getAccount(instance, accountIdentifiers) {
    if (!accountIdentifiers || !accountIdentifiers.homeAccountId && !accountIdentifiers.localAccountId && !accountIdentifiers.username) // If no account identifiers are provided, return active account
    return instance.getActiveAccount();
    return (0, $7f8ae2d45d6f70c2$export$fa581286d49c51db)(instance.getAllAccounts(), accountIdentifiers);
}
/**
 * Given 1 or more accountIdentifiers, returns the Account object if the user is signed-in
 * @param accountIdentifiers
 */ function $3ce1473fd8c294d9$export$83a8e409853da004(accountIdentifiers) {
    const { instance: instance, inProgress: inProgress, logger: logger } = (0, $f8cae32216c5cd58$export$f41558044a1dd55)();
    const [account, setAccount] = (0, $7fPBF.useState)(()=>$3ce1473fd8c294d9$var$getAccount(instance, accountIdentifiers));
    (0, $7fPBF.useEffect)(()=>{
        setAccount((currentAccount)=>{
            const nextAccount = $3ce1473fd8c294d9$var$getAccount(instance, accountIdentifiers);
            if (!(0, $35a4414ce05ac30e$export$680160523e6bfa6a).accountInfoIsEqual(currentAccount, nextAccount, true)) {
                logger.info("useAccount - Updating account");
                return nextAccount;
            }
            return currentAccount;
        });
    }, [
        inProgress,
        accountIdentifiers,
        instance,
        logger
    ]);
    return account;
}


/*! @azure/msal-react v2.2.0 2024-11-05 */ 
'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ const $711dfc8bbd35925c$export$a77ea62d722c2a73 = {
    invalidInteractionType: {
        code: "invalid_interaction_type",
        desc: "The provided interaction type is invalid."
    },
    unableToFallbackToInteraction: {
        code: "unable_to_fallback_to_interaction",
        desc: "Interaction is required but another interaction is already in progress. Please try again when the current interaction is complete."
    }
};
class $711dfc8bbd35925c$export$2aa0f0a55de712e6 extends (0, $53b49d8334c1646a$export$145273558d58e0ac) {
    constructor(errorCode, errorMessage){
        super(errorCode, errorMessage);
        Object.setPrototypeOf(this, $711dfc8bbd35925c$export$2aa0f0a55de712e6.prototype);
        this.name = "ReactAuthError";
    }
    static createInvalidInteractionTypeError() {
        return new $711dfc8bbd35925c$export$2aa0f0a55de712e6($711dfc8bbd35925c$export$a77ea62d722c2a73.invalidInteractionType.code, $711dfc8bbd35925c$export$a77ea62d722c2a73.invalidInteractionType.desc);
    }
    static createUnableToFallbackToInteractionError() {
        return new $711dfc8bbd35925c$export$2aa0f0a55de712e6($711dfc8bbd35925c$export$a77ea62d722c2a73.unableToFallbackToInteraction.code, $711dfc8bbd35925c$export$a77ea62d722c2a73.unableToFallbackToInteraction.desc);
    }
}


'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * If a user is not currently signed in this hook invokes a login. Failed logins can be retried using the login callback returned.
 * If a user is currently signed in this hook attempts to acquire a token. Subsequent token requests can use the acquireToken callback returned.
 * Optionally provide a request object to be used in the login/acquireToken call.
 * Optionally provide a specific user that should be logged in.
 * @param interactionType
 * @param authenticationRequest
 * @param accountIdentifiers
 */ function $a9243ad9d1cee1da$export$d130d543558e611f(interactionType, authenticationRequest, accountIdentifiers) {
    const { instance: instance, inProgress: inProgress, logger: logger } = (0, $f8cae32216c5cd58$export$f41558044a1dd55)();
    const isAuthenticated = (0, $f9d2523957423cdc$export$7e9c60d6d1836c84)(accountIdentifiers);
    const account = (0, $3ce1473fd8c294d9$export$83a8e409853da004)(accountIdentifiers);
    const [[result, error], setResponse] = (0, $7fPBF.useState)([
        null,
        null
    ]);
    // Used to prevent state updates after unmount
    const mounted = (0, $7fPBF.useRef)(true);
    (0, $7fPBF.useEffect)(()=>{
        return ()=>{
            mounted.current = false;
        };
    }, []);
    // Boolean used to check if interaction is in progress in acquireTokenSilent fallback. Use Ref instead of state to prevent acquireToken function from being regenerated on each change to interactionInProgress value
    const interactionInProgress = (0, $7fPBF.useRef)(inProgress !== (0, $091acf4c2675819b$export$bec20eda0179362b).None);
    (0, $7fPBF.useEffect)(()=>{
        interactionInProgress.current = inProgress !== (0, $091acf4c2675819b$export$bec20eda0179362b).None;
    }, [
        inProgress
    ]);
    // Flag used to control when the hook calls login/acquireToken
    const shouldAcquireToken = (0, $7fPBF.useRef)(true);
    (0, $7fPBF.useEffect)(()=>{
        if (!!error) {
            // Errors should be handled by consuming component
            shouldAcquireToken.current = false;
            return;
        }
        if (!!result) {
            // Token has already been acquired, consuming component/application is responsible for renewing
            shouldAcquireToken.current = false;
            return;
        }
    }, [
        error,
        result
    ]);
    const login = (0, $7fPBF.useCallback)(async (callbackInteractionType, callbackRequest)=>{
        const loginType = callbackInteractionType || interactionType;
        const loginRequest = callbackRequest || authenticationRequest;
        switch(loginType){
            case (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Popup:
                logger.verbose("useMsalAuthentication - Calling loginPopup");
                return instance.loginPopup(loginRequest);
            case (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Redirect:
                // This promise is not expected to resolve due to full frame redirect
                logger.verbose("useMsalAuthentication - Calling loginRedirect");
                return instance.loginRedirect(loginRequest).then(null);
            case (0, $091acf4c2675819b$export$4ec29255e7e7f68f).Silent:
                logger.verbose("useMsalAuthentication - Calling ssoSilent");
                return instance.ssoSilent(loginRequest);
            default:
                throw (0, $711dfc8bbd35925c$export$2aa0f0a55de712e6).createInvalidInteractionTypeError();
        }
    }, [
        instance,
        interactionType,
        authenticationRequest,
        logger
    ]);
    const acquireToken = (0, $7fPBF.useCallback)(async (callbackInteractionType, callbackRequest)=>{
        const fallbackInteractionType = callbackInteractionType || interactionType;
        let tokenRequest;
        if (callbackRequest) {
            logger.trace("useMsalAuthentication - acquireToken - Using request provided in the callback");
            tokenRequest = {
                ...callbackRequest
            };
        } else if (authenticationRequest) {
            logger.trace("useMsalAuthentication - acquireToken - Using request provided in the hook");
            tokenRequest = {
                ...authenticationRequest,
                scopes: authenticationRequest.scopes || (0, $08c107807d753255$export$893b1b5b686d84ef)
            };
        } else {
            logger.trace("useMsalAuthentication - acquireToken - No request object provided, using default request.");
            tokenRequest = {
                scopes: (0, $08c107807d753255$export$893b1b5b686d84ef)
            };
        }
        if (!tokenRequest.account && account) {
            logger.trace("useMsalAuthentication - acquireToken - Attaching account to request");
            tokenRequest.account = account;
        }
        const getToken = async ()=>{
            logger.verbose("useMsalAuthentication - Calling acquireTokenSilent");
            return instance.acquireTokenSilent(tokenRequest).catch(async (e)=>{
                if (e instanceof (0, $0171ff24547bf7bf$export$6ba3e818c6bc76ba)) {
                    if (!interactionInProgress.current) {
                        logger.error("useMsalAuthentication - Interaction required, falling back to interaction");
                        return login(fallbackInteractionType, tokenRequest);
                    } else {
                        logger.error("useMsalAuthentication - Interaction required but is already in progress. Please try again, if needed, after interaction completes.");
                        throw (0, $711dfc8bbd35925c$export$2aa0f0a55de712e6).createUnableToFallbackToInteractionError();
                    }
                }
                throw e;
            });
        };
        return getToken().then((response)=>{
            if (mounted.current) setResponse([
                response,
                null
            ]);
            return response;
        }).catch((e)=>{
            if (mounted.current) setResponse([
                null,
                e
            ]);
            throw e;
        });
    }, [
        instance,
        interactionType,
        authenticationRequest,
        logger,
        account,
        login
    ]);
    (0, $7fPBF.useEffect)(()=>{
        const callbackId = instance.addEventCallback((message)=>{
            switch(message.eventType){
                case (0, $15f33001bc68716c$export$3d7865934588d77e).LOGIN_SUCCESS:
                case (0, $15f33001bc68716c$export$3d7865934588d77e).SSO_SILENT_SUCCESS:
                    if (message.payload) setResponse([
                        message.payload,
                        null
                    ]);
                    break;
                case (0, $15f33001bc68716c$export$3d7865934588d77e).LOGIN_FAILURE:
                case (0, $15f33001bc68716c$export$3d7865934588d77e).SSO_SILENT_FAILURE:
                    if (message.error) setResponse([
                        null,
                        message.error
                    ]);
                    break;
            }
        });
        logger.verbose(`useMsalAuthentication - Registered event callback with id: ${callbackId}`);
        return ()=>{
            if (callbackId) {
                logger.verbose(`useMsalAuthentication - Removing event callback ${callbackId}`);
                instance.removeEventCallback(callbackId);
            }
        };
    }, [
        instance,
        logger
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (shouldAcquireToken.current && inProgress === (0, $091acf4c2675819b$export$bec20eda0179362b).None) {
            shouldAcquireToken.current = false;
            if (!isAuthenticated) {
                logger.info("useMsalAuthentication - No user is authenticated, attempting to login");
                login().catch(()=>{
                    // Errors are saved in state above
                    return;
                });
            } else if (account) {
                logger.info("useMsalAuthentication - User is authenticated, attempting to acquire token");
                acquireToken().catch(()=>{
                    // Errors are saved in state above
                    return;
                });
            }
        }
    }, [
        isAuthenticated,
        account,
        inProgress,
        login,
        acquireToken,
        logger
    ]);
    return {
        login: login,
        acquireToken: acquireToken,
        result: result,
        error: error
    };
}




'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Attempts to authenticate user if not already authenticated, then renders child components
 * @param props
 */ function $069656b183204464$export$c9cd7a02d4bd7707({ interactionType: interactionType, username: username, homeAccountId: homeAccountId, localAccountId: localAccountId, authenticationRequest: authenticationRequest, loadingComponent: LoadingComponent, errorComponent: ErrorComponent, children: children }) {
    const accountIdentifier = (0, $7fPBF.useMemo)(()=>{
        return {
            username: username,
            homeAccountId: homeAccountId,
            localAccountId: localAccountId
        };
    }, [
        username,
        homeAccountId,
        localAccountId
    ]);
    const context = (0, $f8cae32216c5cd58$export$f41558044a1dd55)();
    const msalAuthResult = (0, $a9243ad9d1cee1da$export$d130d543558e611f)(interactionType, authenticationRequest, accountIdentifier);
    const isAuthenticated = (0, $f9d2523957423cdc$export$7e9c60d6d1836c84)(accountIdentifier);
    if (msalAuthResult.error && context.inProgress === (0, $091acf4c2675819b$export$bec20eda0179362b).None) {
        if (!!ErrorComponent) return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(ErrorComponent, {
            ...msalAuthResult
        });
        throw msalAuthResult.error;
    }
    if (isAuthenticated) return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, (0, $7f8ae2d45d6f70c2$export$7a39d5906c5d6010)(children, msalAuthResult));
    if (!!LoadingComponent && context.inProgress !== (0, $091acf4c2675819b$export$bec20eda0179362b).None) return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(LoadingComponent, {
        ...context
    });
    return null;
}


/*! @azure/msal-react v2.2.0 2024-11-05 */ 
var $7fPBF = parcelRequire("7fPBF");

'use strict';
/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */ /**
 * Higher order component wraps provided component with msal by injecting msal context values into the component's props
 * @param Component
 */ const $c7173ecc56227a28$export$8dea26c30ebc61cd = (Component)=>{
    const ComponentWithMsal = (props)=>{
        const msal = (0, $f8cae32216c5cd58$export$f41558044a1dd55)();
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Component, {
            ...props,
            msalContext: msal
        });
    };
    const componentName = Component.displayName || Component.name || "Component";
    ComponentWithMsal.displayName = `withMsal(${componentName})`;
    return ComponentWithMsal;
};







'use strict';



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

/**
 * API Service for connecting to the Margin Risk Management backend
 */ const $2b61471e8e825f6c$var$API_BASE_URL = '';
class $2b61471e8e825f6c$var$ApiService {
    async fetchWithTimeout(url, options = {}, timeout = 10000) {
        const controller = new AbortController();
        const timeoutId = setTimeout(()=>controller.abort(), timeout);
        try {
            const response = await fetch(url, {
                ...options,
                signal: controller.signal,
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    ...options.headers
                }
            });
            clearTimeout(timeoutId);
            // Handle 401 Unauthorized - attempt token refresh
            if (response.status === 401 && !url.includes('/auth/login') && !url.includes('/auth/refresh') && !url.includes('/auth/sso')) {
                const shouldRetry = await this.handleUnauthorized();
                if (shouldRetry) // Retry the original request after token refresh
                return this.fetchWithTimeout(url, options, timeout);
            }
            return response;
        } catch (error) {
            clearTimeout(timeoutId);
            // Provide better error message for aborted requests
            if (error instanceof Error && error.name === 'AbortError') {
                const timeoutSeconds = timeout / 1000;
                throw new Error(`Request timed out after ${timeoutSeconds} seconds. Please try again.`);
            }
            throw error;
        }
    }
    async handleUnauthorized() {
        if (this.isRefreshing) // Wait for the current refresh to complete
        return new Promise((resolve)=>{
            this.refreshSubscribers.push(()=>resolve(true));
        });
        this.isRefreshing = true;
        try {
            const refreshResponse = await fetch(`${$2b61471e8e825f6c$var$API_BASE_URL}/auth/refresh`, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (refreshResponse.ok) {
                // Token refreshed successfully
                this.isRefreshing = false;
                this.refreshSubscribers.forEach((callback)=>callback());
                this.refreshSubscribers = [];
                return true;
            } else {
                // Refresh failed - don't redirect here, let React Router handle it
                this.isRefreshing = false;
                this.refreshSubscribers = [];
                return false;
            }
        } catch (error) {
            this.isRefreshing = false;
            this.refreshSubscribers = [];
            return false;
        }
    }
    async handleResponse(response) {
        if (!response.ok) {
            let errorMessage = `Request failed: ${response.statusText}`;
            try {
                const errorData = await response.json();
                errorMessage = errorData.detail || errorMessage;
            } catch  {
            // If JSON parsing fails, use the default error message
            }
            const error = new Error(errorMessage);
            error.status = response.status;
            throw error;
        }
        return response.json();
    }
    // ============================================================================
    // Authentication Methods
    // ============================================================================
    async login(email, password) {
        // Use longer timeout for login (30 seconds) due to bcrypt verification and audit logging
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/auth/login`, {
            method: 'POST',
            body: JSON.stringify({
                email: email,
                password: password
            })
        }, 30000 // 30 second timeout for login
        );
        const data = await this.handleResponse(response);
        return data.user;
    }
    async loginWithSSO(idToken) {
        // Use longer timeout for SSO login (30 seconds) due to token validation
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/auth/sso`, {
            method: 'POST',
            body: JSON.stringify({
                id_token: idToken
            })
        }, 30000 // 30 second timeout for SSO login
        );
        const data = await this.handleResponse(response);
        return data.user;
    }
    async logout() {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/auth/logout`, {
            method: 'POST'
        });
        if (!response.ok) throw new Error('Logout failed');
    }
    async getCurrentUser() {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/auth/me`);
        return this.handleResponse(response);
    }
    async changePassword(newPassword) {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/auth/change-password`, {
            method: 'POST',
            body: JSON.stringify({
                new_password: newPassword
            })
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.detail || 'Password change failed');
        }
    }
    async refreshToken() {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/auth/refresh`, {
            method: 'POST'
        });
        if (!response.ok) throw new Error('Token refresh failed');
    }
    // ============================================================================
    // Health Check
    // ============================================================================
    async checkHealth() {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/health`);
        return this.handleResponse(response);
    }
    // ============================================================================
    // Portfolio Methods
    // ============================================================================
    async getPortfolios() {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/api/portfolios`);
        return this.handleResponse(response);
    }
    async getPortfolioDetail(portfolioId) {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/api/portfolios/${portfolioId}`);
        return this.handleResponse(response);
    }
    async getPortfolioCount() {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/api/portfolios/count`);
        return this.handleResponse(response);
    }
    async getAllPortfolioDetails() {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/api/portfolios/all-positions`, {}, 60000);
        return this.handleResponse(response);
    }
    // ============================================================================
    // Alert Methods
    // ============================================================================
    async getAlerts() {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/api/alerts`);
        return this.handleResponse(response);
    }
    async getAlertByPortfolio(portfolioId) {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/api/alerts/${portfolioId}`);
        return this.handleResponse(response);
    }
    async getAlertsCountSummary() {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/api/alerts/count/summary`);
        return this.handleResponse(response);
    }
    async acknowledgeAlert(portfolioId) {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/api/alerts/${portfolioId}/acknowledge`, {
            method: 'POST'
        });
        return this.handleResponse(response);
    }
    // ============================================================================
    // Comment Methods
    // ============================================================================
    async getCommentCount(portfolioId) {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/api/portfolios/${portfolioId}/comments/count`);
        return this.handleResponse(response);
    }
    async getCommentCountsBatch(portfolioIds) {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/api/portfolios/comments/counts/batch`, {
            method: 'POST',
            body: JSON.stringify(portfolioIds)
        });
        return this.handleResponse(response);
    }
    async getPortfolioComments(portfolioId) {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/api/portfolios/${portfolioId}/comments`);
        return this.handleResponse(response);
    }
    async createComment(portfolioId, data) {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/api/portfolios/${portfolioId}/comments`, {
            method: 'POST',
            body: JSON.stringify(data)
        });
        return this.handleResponse(response);
    }
    async createReply(portfolioId, commentId, data) {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/api/portfolios/${portfolioId}/comments/${commentId}/reply`, {
            method: 'POST',
            body: JSON.stringify(data)
        });
        return this.handleResponse(response);
    }
    async updateComment(portfolioId, commentId, data) {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/api/portfolios/${portfolioId}/comments/${commentId}`, {
            method: 'PUT',
            body: JSON.stringify(data)
        });
        return this.handleResponse(response);
    }
    async deleteComment(portfolioId, commentId) {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/api/portfolios/${portfolioId}/comments/${commentId}`, {
            method: 'DELETE'
        });
        return this.handleResponse(response);
    }
    async getAllComments(filters) {
        const params = new URLSearchParams();
        if (filters?.rmUserId) params.append('rm_user_id', filters.rmUserId);
        if (filters?.category) params.append('category', filters.category);
        if (filters?.isMarginTrading !== undefined) params.append('is_margin_trading', filters.isMarginTrading.toString());
        if (filters?.startDate) params.append('start_date', filters.startDate);
        if (filters?.endDate) params.append('end_date', filters.endDate);
        const queryString = params.toString();
        const url = queryString ? `${$2b61471e8e825f6c$var$API_BASE_URL}/api/portfolios/all?${queryString}` : `${$2b61471e8e825f6c$var$API_BASE_URL}/api/portfolios/all`;
        const response = await this.fetchWithTimeout(url);
        return this.handleResponse(response);
    }
    async getRMsList() {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/api/portfolios/rms`);
        return this.handleResponse(response);
    }
    // ============================================================================
    // Admin User Management Methods
    // ============================================================================
    async getUsers(params) {
        const queryParams = new URLSearchParams();
        if (params) {
            if (params.page) queryParams.append('page', params.page.toString());
            if (params.page_size) queryParams.append('page_size', params.page_size.toString());
            if (params.search) queryParams.append('search', params.search);
            if (params.role) queryParams.append('role', params.role);
            if (params.user_type) queryParams.append('user_type', params.user_type);
            if (params.is_active !== undefined) queryParams.append('is_active', params.is_active.toString());
        }
        const url = `${$2b61471e8e825f6c$var$API_BASE_URL}/admin/users${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
        const response = await this.fetchWithTimeout(url);
        return this.handleResponse(response);
    }
    async createUser(data) {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/admin/users`, {
            method: 'POST',
            body: JSON.stringify(data)
        });
        return this.handleResponse(response);
    }
    async updateUser(userId, data) {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/admin/users/${userId}`, {
            method: 'PUT',
            body: JSON.stringify(data)
        });
        return this.handleResponse(response);
    }
    async deactivateUser(userId) {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/admin/users/${userId}`, {
            method: 'DELETE'
        });
        return this.handleResponse(response);
    }
    async activateUser(userId) {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/admin/users/${userId}/activate`, {
            method: 'POST'
        });
        return this.handleResponse(response);
    }
    async resetUserPassword(userId) {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/admin/users/${userId}/reset-password`, {
            method: 'POST'
        });
        return this.handleResponse(response);
    }
    // ============================================================================
    // ARM Assignment Methods
    // ============================================================================
    async getARMAssignments(params) {
        const queryParams = new URLSearchParams();
        if (params) {
            if (params.page) queryParams.append('page', params.page.toString());
            if (params.page_size) queryParams.append('page_size', params.page_size.toString());
            if (params.search) queryParams.append('search', params.search);
            if (params.arm_user_id) queryParams.append('arm_user_id', params.arm_user_id.toString());
            if (params.rm_user_id) queryParams.append('rm_user_id', params.rm_user_id.toString());
            if (params.is_active !== undefined) queryParams.append('is_active', params.is_active.toString());
        }
        const url = `${$2b61471e8e825f6c$var$API_BASE_URL}/admin/arm-assignments${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
        const response = await this.fetchWithTimeout(url);
        return this.handleResponse(response);
    }
    async createARMAssignment(data) {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/admin/arm-assignments`, {
            method: 'POST',
            body: JSON.stringify(data)
        });
        return this.handleResponse(response);
    }
    async deactivateARMAssignment(assignmentId) {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/admin/arm-assignments/${assignmentId}`, {
            method: 'DELETE'
        });
        return this.handleResponse(response);
    }
    async activateARMAssignment(assignmentId) {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/admin/arm-assignments/${assignmentId}/activate`, {
            method: 'POST'
        });
        return this.handleResponse(response);
    }
    async getARMUsers() {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/admin/users/arms`);
        return this.handleResponse(response);
    }
    async getRMUsers() {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/admin/users/rms`);
        return this.handleResponse(response);
    }
    // ============================================================================
    // IC Override Methods
    // ============================================================================
    async getICOverrides(params) {
        const queryParams = new URLSearchParams();
        if (params) {
            if (params.page) queryParams.append('page', params.page.toString());
            if (params.page_size) queryParams.append('page_size', params.page_size.toString());
            if (params.search) queryParams.append('search', params.search);
            if (params.is_active !== undefined) queryParams.append('is_active', params.is_active.toString());
            if (params.portfolio_id) queryParams.append('portfolio_id', params.portfolio_id);
        }
        const url = `${$2b61471e8e825f6c$var$API_BASE_URL}/admin/ic-overrides${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
        const response = await this.fetchWithTimeout(url);
        return this.handleResponse(response);
    }
    async createICOverride(data) {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/admin/ic-overrides`, {
            method: 'POST',
            body: JSON.stringify(data)
        });
        return this.handleResponse(response);
    }
    async updateICOverride(overrideId, data) {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/admin/ic-overrides/${overrideId}`, {
            method: 'PUT',
            body: JSON.stringify(data)
        });
        return this.handleResponse(response);
    }
    async deactivateICOverride(overrideId) {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/admin/ic-overrides/${overrideId}`, {
            method: 'DELETE'
        });
        return this.handleResponse(response);
    }
    async activateICOverride(overrideId) {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/admin/ic-overrides/${overrideId}/activate`, {
            method: 'POST'
        });
        return this.handleResponse(response);
    }
    async getICUsers() {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/admin/users/ics`);
        return this.handleResponse(response);
    }
    async getAdminPortfolios(search) {
        const queryParams = new URLSearchParams();
        if (search) queryParams.append('search', search);
        const url = `${$2b61471e8e825f6c$var$API_BASE_URL}/admin/portfolios${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
        const response = await this.fetchWithTimeout(url);
        return this.handleResponse(response);
    }
    // ============================================================================
    // Margin Trading Override Methods
    // ============================================================================
    async getMarginTradingOverrides() {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/api/admin/margin-trading-overrides`);
        return this.handleResponse(response);
    }
    async setMarginTradingOverride(data) {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/api/admin/margin-trading-overrides`, {
            method: 'POST',
            body: JSON.stringify(data)
        });
        return this.handleResponse(response);
    }
    async deleteMarginTradingOverride(portfolioId) {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/api/admin/margin-trading-overrides/${portfolioId}`, {
            method: 'DELETE'
        });
        return this.handleResponse(response);
    }
    // ============================================================================
    // Email Template Methods
    // ============================================================================
    async getEmailTemplates() {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/api/admin/email-templates`);
        return this.handleResponse(response);
    }
    async getEmailTemplate(templateId) {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/api/admin/email-templates/${templateId}`);
        return this.handleResponse(response);
    }
    async updateEmailTemplate(templateId, data) {
        const response = await this.fetchWithTimeout(`${$2b61471e8e825f6c$var$API_BASE_URL}/api/admin/email-templates/${templateId}`, {
            method: 'PUT',
            body: JSON.stringify(data)
        });
        return this.handleResponse(response);
    }
    constructor(){
        this.isRefreshing = false;
        this.refreshSubscribers = [];
    }
}
const $2b61471e8e825f6c$export$d0204b1ddc8ee140 = new $2b61471e8e825f6c$var$ApiService();
const $2b61471e8e825f6c$export$c421df4b0a387416 = {
    getAll: ()=>$2b61471e8e825f6c$export$d0204b1ddc8ee140.getEmailTemplates(),
    get: (id)=>$2b61471e8e825f6c$export$d0204b1ddc8ee140.getEmailTemplate(id),
    update: (id, data)=>$2b61471e8e825f6c$export$d0204b1ddc8ee140.updateEmailTemplate(id, data)
};
var $2b61471e8e825f6c$export$2e2bcd8739ae039 = $2b61471e8e825f6c$export$d0204b1ddc8ee140;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
/**
 * Authentication Context
 * Provides global authentication state and methods throughout the app
 */ 
var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");



/**
 * MSAL (Microsoft Authentication Library) Configuration
 * Configure Azure AD authentication settings
 */ // Get Azure AD configuration from environment variables
const $7752dec9fa956b3a$var$clientId = "66b387a7-0731-4dd1-9992-d6d15033dac9";
const $7752dec9fa956b3a$var$tenantId = "c24167bc-ce54-479c-b126-59e68ab033ea";
const $7752dec9fa956b3a$var$redirectUri = `${window.location.origin}/auth/callback`;
// Validate required configuration
if (!$7752dec9fa956b3a$var$clientId || !$7752dec9fa956b3a$var$tenantId) console.error("Azure AD configuration is missing. Please set the following environment variables:\n  REACT_APP_AZURE_CLIENT_ID\n  REACT_APP_AZURE_TENANT_ID\n  REACT_APP_AZURE_REDIRECT_URI (optional, defaults to current origin)\n\nCreate a .env file in the frontend directory with these variables.\nSee sso/ENVIRONMENT_VARIABLES.md for setup instructions.");
const $7752dec9fa956b3a$export$f6d610d2730cbf1a = {
    auth: {
        clientId: $7752dec9fa956b3a$var$clientId,
        authority: $7752dec9fa956b3a$var$tenantId ? `https://login.microsoftonline.com/${$7752dec9fa956b3a$var$tenantId}` : 'https://login.microsoftonline.com/common',
        redirectUri: $7752dec9fa956b3a$var$redirectUri,
        // /auth/callback owns handleRedirectPromise() and the final app navigation.
        // Prevent MSAL from navigating away before that callback can exchange the ID token.
        navigateToLoginRequestUrl: false
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false
    }
};
const $7752dec9fa956b3a$export$642df60507c564d3 = ()=>{
    return !!($7752dec9fa956b3a$var$clientId && $7752dec9fa956b3a$var$tenantId);
};
const $7752dec9fa956b3a$export$be6c432b2463c5eb = {
    scopes: [
        'User.Read'
    ]
};
const $7752dec9fa956b3a$export$4965d3e40bbf5ccb = {
    graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me'
};


const $46326ed28bec5654$export$3550b9708c8ebb1f = "margin-risk:auto-sso-attempted";
function $46326ed28bec5654$export$f13d2d9003dd992f(storage) {
    if (storage.getItem($46326ed28bec5654$export$3550b9708c8ebb1f) === "1") return false;
    storage.setItem($46326ed28bec5654$export$3550b9708c8ebb1f, "1");
    return true;
}
function $46326ed28bec5654$export$bc20412576db7c56(storage) {
    storage.removeItem($46326ed28bec5654$export$3550b9708c8ebb1f);
}


const $d0020511b775fb45$var$AuthContext = /*#__PURE__*/ (0, $7fPBF.createContext)(undefined);
const $d0020511b775fb45$export$87091915187a1a85 = ({ children: children })=>{
    const [user, setUser] = (0, $7fPBF.useState)(null);
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(true);
    const { instance: instance, inProgress: inProgress } = (0, $f8cae32216c5cd58$export$f41558044a1dd55)();
    // On mount, check if user is already authenticated. The callback route owns
    // redirect processing and must not compete with a second MSAL interaction.
    (0, $7fPBF.useEffect)(()=>{
        const path = window.location.pathname;
        if (path === '/login' || path === '/auth/callback') {
            setIsLoading(false);
            return;
        }
        if (inProgress !== (0, $091acf4c2675819b$export$bec20eda0179362b).None) return;
        refreshAuth();
    }, [
        inProgress
    ]);
    const refreshAuth = async ()=>{
        try {
            setIsLoading(true);
            const currentUser = await (0, $2b61471e8e825f6c$export$d0204b1ddc8ee140).getCurrentUser();
            (0, $46326ed28bec5654$export$bc20412576db7c56)(sessionStorage);
            setUser(currentUser);
        } catch  {
            // No app session — try cached MSAL state first, then make one guarded
            // top-level redirect so Entra can reuse its browser session reliably.
            if ((0, $7752dec9fa956b3a$export$642df60507c564d3)()) {
                const account = instance.getActiveAccount() ?? instance.getAllAccounts()[0];
                let result;
                try {
                    result = account ? await instance.acquireTokenSilent({
                        ...(0, $7752dec9fa956b3a$export$be6c432b2463c5eb),
                        account: account
                    }) : await instance.ssoSilent((0, $7752dec9fa956b3a$export$be6c432b2463c5eb));
                } catch  {
                // Continue to the reliable top-level redirect below.
                }
                if (result?.idToken) try {
                    const loggedInUser = await (0, $2b61471e8e825f6c$export$d0204b1ddc8ee140).loginWithSSO(result.idToken);
                    (0, $46326ed28bec5654$export$bc20412576db7c56)(sessionStorage);
                    setUser(loggedInUser);
                    return;
                } catch  {
                    setUser(null);
                    return;
                }
                if ((0, $46326ed28bec5654$export$f13d2d9003dd992f)(sessionStorage)) try {
                    await instance.loginRedirect({
                        ...(0, $7752dec9fa956b3a$export$be6c432b2463c5eb),
                        ...account?.username ? {
                            loginHint: account.username
                        } : {}
                    });
                    return;
                } catch  {
                // The login page remains the manual fallback.
                }
            }
            setUser(null);
        } finally{
            setIsLoading(false);
        }
    };
    const login = async (email, password)=>{
        try {
            const user = await (0, $2b61471e8e825f6c$export$d0204b1ddc8ee140).login(email, password);
            (0, $46326ed28bec5654$export$bc20412576db7c56)(sessionStorage);
            setUser(user);
        } catch (error) {
            // Re-throw error to be handled by the login component
            throw error;
        }
    };
    const loginWithSSO = async (idToken)=>{
        try {
            const user = await (0, $2b61471e8e825f6c$export$d0204b1ddc8ee140).loginWithSSO(idToken);
            (0, $46326ed28bec5654$export$bc20412576db7c56)(sessionStorage);
            setUser(user);
        } catch (error) {
            // Re-throw error to be handled by the login component
            throw error;
        }
    };
    const logout = async ()=>{
        try {
            await (0, $2b61471e8e825f6c$export$d0204b1ddc8ee140).logout();
        } catch (error) {
            console.error('Logout error:', error);
        } finally{
            setUser(null);
        }
    };
    const changePassword = async (newPassword)=>{
        try {
            await (0, $2b61471e8e825f6c$export$d0204b1ddc8ee140).changePassword(newPassword);
        } catch (error) {
            // Re-throw error to be handled by the password change component
            throw error;
        }
    };
    const value = {
        user: user,
        isAuthenticated: !!user,
        isLoading: isLoading,
        login: login,
        loginWithSSO: loginWithSSO,
        logout: logout,
        refreshAuth: refreshAuth,
        changePassword: changePassword
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)($d0020511b775fb45$var$AuthContext.Provider, {
        value: value,
        children: children
    });
};
const $d0020511b775fb45$export$1d39dc5b47e56ff0 = ()=>{
    const context = (0, $7fPBF.useContext)($d0020511b775fb45$var$AuthContext);
    if (!context) throw new Error('useAuth must be used within an AuthProvider');
    return context;
};



const $2f198502e2232dfa$var$CommentsContext = /*#__PURE__*/ (0, $7fPBF.createContext)(undefined);
// Helper function to convert API comment to frontend Comment type
const $2f198502e2232dfa$var$convertApiComment = (apiComment)=>{
    return {
        id: apiComment.comment_id,
        portfolioId: apiComment.portfolio_id_lig,
        userId: apiComment.user_id,
        userName: apiComment.user_name,
        userRole: apiComment.user_role,
        content: apiComment.content,
        category: apiComment.category,
        tags: apiComment.tags || undefined,
        timestamp: new Date(apiComment.created_at),
        parentId: apiComment.parent_id || undefined,
        replies: []
    };
};
const $2f198502e2232dfa$export$5579c65002f1fbcb = ({ children: children })=>{
    const { user: user } = (0, $d0020511b775fb45$export$1d39dc5b47e56ff0)();
    const [comments, setComments] = (0, $7fPBF.useState)({});
    const [commentCounts, setCommentCounts] = (0, $7fPBF.useState)({}); // Separate count storage
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)({});
    // Fetch just the comment count (lightweight)
    const fetchCommentCount = (0, $7fPBF.useCallback)(async (portfolioId)=>{
        if (!user) return;
        try {
            const response = await (0, $2b61471e8e825f6c$export$d0204b1ddc8ee140).getCommentCount(portfolioId);
            setCommentCounts((prev)=>({
                    ...prev,
                    [portfolioId]: response.count
                }));
        } catch (error) {
            console.error('Error fetching comment count:', error);
            // Set 0 on error
            setCommentCounts((prev)=>({
                    ...prev,
                    [portfolioId]: 0
                }));
        }
    }, [
        user
    ]);
    // Batch fetch comment counts for multiple portfolios (much more efficient)
    const fetchCommentCountsBatch = (0, $7fPBF.useCallback)(async (portfolioIds)=>{
        if (!user || portfolioIds.length === 0) return;
        try {
            const response = await (0, $2b61471e8e825f6c$export$d0204b1ddc8ee140).getCommentCountsBatch(portfolioIds);
            // Update all counts at once
            const newCounts = {};
            response.forEach((item)=>{
                newCounts[item.portfolio_id] = item.count;
            });
            // Also set 0 for any portfolios not in the response (no comments)
            portfolioIds.forEach((pid)=>{
                if (newCounts[pid] === undefined) newCounts[pid] = 0;
            });
            setCommentCounts((prev)=>({
                    ...prev,
                    ...newCounts
                }));
        } catch (error) {
            console.error('Error fetching comment counts batch:', error);
            // Set 0 for all on error
            const zeroCounts = {};
            portfolioIds.forEach((pid)=>{
                zeroCounts[pid] = 0;
            });
            setCommentCounts((prev)=>({
                    ...prev,
                    ...zeroCounts
                }));
        }
    }, [
        user
    ]);
    // Fetch comments from API
    const fetchComments = (0, $7fPBF.useCallback)(async (portfolioId)=>{
        if (!user) return;
        setIsLoading((prev)=>({
                ...prev,
                [portfolioId]: true
            }));
        try {
            const response = await (0, $2b61471e8e825f6c$export$d0204b1ddc8ee140).getPortfolioComments(portfolioId);
            // Convert API comments to frontend Comment type
            const allComments = [];
            response.comments.forEach((topLevelComment)=>{
                // Add top-level comment
                const comment = $2f198502e2232dfa$var$convertApiComment(topLevelComment);
                allComments.push(comment);
                // Add replies
                topLevelComment.replies.forEach((reply)=>{
                    const replyComment = $2f198502e2232dfa$var$convertApiComment(reply);
                    allComments.push(replyComment);
                });
            });
            setComments((prev)=>({
                    ...prev,
                    [portfolioId]: allComments
                }));
            // Also update the count
            setCommentCounts((prev)=>({
                    ...prev,
                    [portfolioId]: allComments.length
                }));
        } catch (error) {
            console.error('Error fetching comments:', error);
            // Set empty array on error
            setComments((prev)=>({
                    ...prev,
                    [portfolioId]: []
                }));
            setCommentCounts((prev)=>({
                    ...prev,
                    [portfolioId]: 0
                }));
        } finally{
            setIsLoading((prev)=>({
                    ...prev,
                    [portfolioId]: false
                }));
        }
    }, [
        user
    ]);
    // Add a new top-level comment
    const addComment = (0, $7fPBF.useCallback)(async (portfolioId, content, category, tags)=>{
        if (!user) throw new Error('User must be authenticated to add comments');
        try {
            await (0, $2b61471e8e825f6c$export$d0204b1ddc8ee140).createComment(portfolioId, {
                content: content,
                category: category,
                tags: tags
            });
            // Refresh comments after creating
            await fetchComments(portfolioId);
        } catch (error) {
            console.error('Error creating comment:', error);
            throw error;
        }
    }, [
        user,
        fetchComments
    ]);
    // Add a reply to a comment
    const addReply = (0, $7fPBF.useCallback)(async (portfolioId, parentId, content, tags)=>{
        if (!user) throw new Error('User must be authenticated to add replies');
        try {
            await (0, $2b61471e8e825f6c$export$d0204b1ddc8ee140).createReply(portfolioId, parentId, {
                content: content,
                tags: tags
            });
            // Refresh comments after creating reply
            await fetchComments(portfolioId);
        } catch (error) {
            console.error('Error creating reply:', error);
            throw error;
        }
    }, [
        user,
        fetchComments
    ]);
    // Get comments for a specific portfolio
    const getCommentsForPortfolio = (0, $7fPBF.useCallback)((portfolioId)=>{
        return comments[portfolioId] || [];
    }, [
        comments
    ]);
    // Get comment count for a specific portfolio
    // Returns from count cache if available, otherwise from full comments
    const getCommentCount = (0, $7fPBF.useCallback)((portfolioId)=>{
        // Prefer the count cache (more up-to-date if fetched separately)
        if (commentCounts[portfolioId] !== undefined) return commentCounts[portfolioId];
        // Fall back to counting full comments if available
        return (comments[portfolioId] || []).length;
    }, [
        comments,
        commentCounts
    ]);
    const value = {
        comments: comments,
        isLoading: isLoading,
        fetchComments: fetchComments,
        fetchCommentCount: fetchCommentCount,
        fetchCommentCountsBatch: fetchCommentCountsBatch,
        addComment: addComment,
        addReply: addReply,
        getCommentsForPortfolio: getCommentsForPortfolio,
        getCommentCount: getCommentCount
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)($2f198502e2232dfa$var$CommentsContext.Provider, {
        value: value,
        children: children
    });
};
const $2f198502e2232dfa$export$80ad823ea511ef0f = ()=>{
    const context = (0, $7fPBF.useContext)($2f198502e2232dfa$var$CommentsContext);
    if (!context) throw new Error('useComments must be used within a CommentsProvider');
    return context;
};



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
// Core data types for the Margin Monitoring System
const $f213e983270415ba$export$b9f0c4cf5e81d842 = [
    'Margin Alerts',
    'Client Instructions',
    'Rebalance Notes',
    'Other'
];





var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
var $7fPBF = parcelRequire("7fPBF");
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $637d6991ff22e9ee$export$3d46f4579dba46e5 = (...classes)=>classes.filter((className, index, array)=>{
        return Boolean(className) && className.trim() !== "" && array.indexOf(className) === index;
    }).join(" ").trim();


/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $9e8f1097be3a2ed0$export$73bda83cddbc7187 = (string)=>string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();


/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ /**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $7ff3d079887c45b2$export$86f54f62aa7a7514 = (string)=>string.replace(/^([A-Z])|[\s-_]+(\w)/g, (match, p1, p2)=>p2 ? p2.toUpperCase() : p1.toLowerCase());


const $bcce55806b52783d$export$6fb43ff9addf7357 = (string)=>{
    const camelCase = (0, $7ff3d079887c45b2$export$86f54f62aa7a7514)(string);
    return camelCase.charAt(0).toUpperCase() + camelCase.slice(1);
};



var $7fPBF = parcelRequire("7fPBF");
/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ var $248cdc1a6cea9878$export$2e2bcd8739ae039 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
};


/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ const $18572c8b35a8a975$export$ab365959aa6deed0 = (props)=>{
    for(const prop in props){
        if (prop.startsWith("aria-") || prop === "role" || prop === "title") return true;
    }
    return false;
};




var $7fPBF = parcelRequire("7fPBF");
"use strict";
"use client";
const $0e72968ea832fc5c$var$LucideContext = (0, $7fPBF.createContext)({});
function $0e72968ea832fc5c$export$f4a5ae9d8b2d8a16({ children: children, size: size, color: color, strokeWidth: strokeWidth, absoluteStrokeWidth: absoluteStrokeWidth, className: className }) {
    const value = (0, $7fPBF.useMemo)(()=>({
            size: size,
            color: color,
            strokeWidth: strokeWidth,
            absoluteStrokeWidth: absoluteStrokeWidth,
            className: className
        }), [
        size,
        color,
        strokeWidth,
        absoluteStrokeWidth,
        className
    ]);
    return (0, $7fPBF.createElement)($0e72968ea832fc5c$var$LucideContext.Provider, {
        value: value
    }, children);
}
const $0e72968ea832fc5c$export$52ee7576b6cde767 = ()=>(0, $7fPBF.useContext)($0e72968ea832fc5c$var$LucideContext);


"use strict";
"use client";
const $4a66ddce4b4550b0$export$2e2bcd8739ae039 = (0, $7fPBF.forwardRef)(({ color: color, size: size, strokeWidth: strokeWidth, absoluteStrokeWidth: absoluteStrokeWidth, className: className = "", children: children, iconNode: iconNode, ...rest }, ref)=>{
    const { size: contextSize = 24, strokeWidth: contextStrokeWidth = 2, absoluteStrokeWidth: contextAbsoluteStrokeWidth = false, color: contextColor = "currentColor", className: contextClass = "" } = (0, $0e72968ea832fc5c$export$52ee7576b6cde767)() ?? {};
    const calculatedStrokeWidth = absoluteStrokeWidth ?? contextAbsoluteStrokeWidth ? Number(strokeWidth ?? contextStrokeWidth) * 24 / Number(size ?? contextSize) : strokeWidth ?? contextStrokeWidth;
    return (0, $7fPBF.createElement)("svg", {
        ref: ref,
        ...(0, $248cdc1a6cea9878$export$2e2bcd8739ae039),
        width: size ?? contextSize ?? (0, $248cdc1a6cea9878$export$2e2bcd8739ae039).width,
        height: size ?? contextSize ?? (0, $248cdc1a6cea9878$export$2e2bcd8739ae039).height,
        stroke: color ?? contextColor,
        strokeWidth: calculatedStrokeWidth,
        className: (0, $637d6991ff22e9ee$export$3d46f4579dba46e5)("lucide", contextClass, className),
        ...!children && !(0, $18572c8b35a8a975$export$ab365959aa6deed0)(rest) && {
            "aria-hidden": "true"
        },
        ...rest
    }, [
        ...iconNode.map(([tag, attrs])=>(0, $7fPBF.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [
            children
        ]
    ]);
});


const $573db7058e59e0a7$export$2e2bcd8739ae039 = (iconName, iconNode)=>{
    const Component = (0, $7fPBF.forwardRef)(({ className: className, ...props }, ref)=>(0, $7fPBF.createElement)((0, $4a66ddce4b4550b0$export$2e2bcd8739ae039), {
            ref: ref,
            iconNode: iconNode,
            className: (0, $637d6991ff22e9ee$export$3d46f4579dba46e5)(`lucide-${(0, $9e8f1097be3a2ed0$export$73bda83cddbc7187)((0, $bcce55806b52783d$export$6fb43ff9addf7357)(iconName))}`, `lucide-${iconName}`, className),
            ...props
        }));
    Component.displayName = (0, $bcce55806b52783d$export$6fb43ff9addf7357)(iconName);
    return Component;
};


const $66aec767d42fd513$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            width: "7",
            height: "9",
            x: "3",
            y: "3",
            rx: "1",
            key: "10lvy0"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "5",
            x: "14",
            y: "3",
            rx: "1",
            key: "16une8"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "9",
            x: "14",
            y: "12",
            rx: "1",
            key: "1hutg5"
        }
    ],
    [
        "rect",
        {
            width: "7",
            height: "5",
            x: "3",
            y: "16",
            rx: "1",
            key: "ldoo1y"
        }
    ]
];
const $66aec767d42fd513$export$2e2bcd8739ae039 = (0, $573db7058e59e0a7$export$2e2bcd8739ae039)("layout-dashboard", $66aec767d42fd513$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $197dfabd8b586015$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10.268 21a2 2 0 0 0 3.464 0",
            key: "vwvbt9"
        }
    ],
    [
        "path",
        {
            d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326",
            key: "11g9vi"
        }
    ]
];
const $197dfabd8b586015$export$2e2bcd8739ae039 = (0, $573db7058e59e0a7$export$2e2bcd8739ae039)("bell", $197dfabd8b586015$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $a333b396c1d3b782$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M22 17a2 2 0 0 1-2 2H6.828a2 2 0 0 0-1.414.586l-2.202 2.202A.71.71 0 0 1 2 21.286V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2z",
            key: "18887p"
        }
    ]
];
const $a333b396c1d3b782$export$2e2bcd8739ae039 = (0, $573db7058e59e0a7$export$2e2bcd8739ae039)("message-square", $a333b396c1d3b782$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e546ef3ca9a09b20$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M5 21v-6",
            key: "1hz6c0"
        }
    ],
    [
        "path",
        {
            d: "M12 21V3",
            key: "1lcnhd"
        }
    ],
    [
        "path",
        {
            d: "M19 21V9",
            key: "unv183"
        }
    ]
];
const $e546ef3ca9a09b20$export$2e2bcd8739ae039 = (0, $573db7058e59e0a7$export$2e2bcd8739ae039)("chart-no-axes-column", $e546ef3ca9a09b20$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d80e7deac00f5835$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M9.671 4.136a2.34 2.34 0 0 1 4.659 0 2.34 2.34 0 0 0 3.319 1.915 2.34 2.34 0 0 1 2.33 4.033 2.34 2.34 0 0 0 0 3.831 2.34 2.34 0 0 1-2.33 4.033 2.34 2.34 0 0 0-3.319 1.915 2.34 2.34 0 0 1-4.659 0 2.34 2.34 0 0 0-3.32-1.915 2.34 2.34 0 0 1-2.33-4.033 2.34 2.34 0 0 0 0-3.831A2.34 2.34 0 0 1 6.35 6.051a2.34 2.34 0 0 0 3.319-1.915",
            key: "1i5ecw"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
];
const $d80e7deac00f5835$export$2e2bcd8739ae039 = (0, $573db7058e59e0a7$export$2e2bcd8739ae039)("settings", $d80e7deac00f5835$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $50aa1309e6bfe67d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
            key: "1nclc0"
        }
    ],
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "3",
            key: "1v7zrd"
        }
    ]
];
const $50aa1309e6bfe67d$export$2e2bcd8739ae039 = (0, $573db7058e59e0a7$export$2e2bcd8739ae039)("eye", $50aa1309e6bfe67d$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $136792a2ec61cb3d$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7",
            key: "132q7q"
        }
    ],
    [
        "rect",
        {
            x: "2",
            y: "4",
            width: "20",
            height: "16",
            rx: "2",
            key: "izxlao"
        }
    ]
];
const $136792a2ec61cb3d$export$2e2bcd8739ae039 = (0, $573db7058e59e0a7$export$2e2bcd8739ae039)("mail", $136792a2ec61cb3d$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $950d2dc0950caddb$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m16 17 5-5-5-5",
            key: "1bji2h"
        }
    ],
    [
        "path",
        {
            d: "M21 12H9",
            key: "dn1m92"
        }
    ],
    [
        "path",
        {
            d: "M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4",
            key: "1uf3rs"
        }
    ]
];
const $950d2dc0950caddb$export$2e2bcd8739ae039 = (0, $573db7058e59e0a7$export$2e2bcd8739ae039)("log-out", $950d2dc0950caddb$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $86a9ea2d4cc6f619$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m21 21-4.34-4.34",
            key: "14j7rj"
        }
    ],
    [
        "circle",
        {
            cx: "11",
            cy: "11",
            r: "8",
            key: "4ej97u"
        }
    ]
];
const $86a9ea2d4cc6f619$export$2e2bcd8739ae039 = (0, $573db7058e59e0a7$export$2e2bcd8739ae039)("search", $86a9ea2d4cc6f619$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $6f65f1e42653b804$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m6 9 6 6 6-6",
            key: "qrunsl"
        }
    ]
];
const $6f65f1e42653b804$export$2e2bcd8739ae039 = (0, $573db7058e59e0a7$export$2e2bcd8739ae039)("chevron-down", $6f65f1e42653b804$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5a41cf212b4dadac$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8",
            key: "v9h5vc"
        }
    ],
    [
        "path",
        {
            d: "M21 3v5h-5",
            key: "1q7to0"
        }
    ],
    [
        "path",
        {
            d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16",
            key: "3uifl3"
        }
    ],
    [
        "path",
        {
            d: "M8 16H3v5",
            key: "1cv678"
        }
    ]
];
const $5a41cf212b4dadac$export$2e2bcd8739ae039 = (0, $573db7058e59e0a7$export$2e2bcd8739ae039)("refresh-cw", $5a41cf212b4dadac$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $f1c835c66028bb29$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "path",
        {
            d: "M12 6v6l4 2",
            key: "mmk7yg"
        }
    ]
];
const $f1c835c66028bb29$export$2e2bcd8739ae039 = (0, $573db7058e59e0a7$export$2e2bcd8739ae039)("clock", $f1c835c66028bb29$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $93bc410cbbe7c665$export$3efd853dbb351e94 = [
    [
        "rect",
        {
            x: "14",
            y: "3",
            width: "5",
            height: "18",
            rx: "1",
            key: "kaeet6"
        }
    ],
    [
        "rect",
        {
            x: "5",
            y: "3",
            width: "5",
            height: "18",
            rx: "1",
            key: "1wsw3u"
        }
    ]
];
const $93bc410cbbe7c665$export$2e2bcd8739ae039 = (0, $573db7058e59e0a7$export$2e2bcd8739ae039)("pause", $93bc410cbbe7c665$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c5af0e7c890a0112$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z",
            key: "10ikf1"
        }
    ]
];
const $c5af0e7c890a0112$export$2e2bcd8739ae039 = (0, $573db7058e59e0a7$export$2e2bcd8739ae039)("play", $c5af0e7c890a0112$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $e21fcbb4100dbb6f$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "m12 5 7 7-7 7",
            key: "xquz4c"
        }
    ]
];
const $e21fcbb4100dbb6f$export$2e2bcd8739ae039 = (0, $573db7058e59e0a7$export$2e2bcd8739ae039)("arrow-right", $e21fcbb4100dbb6f$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5ccabc7cfbfb4128$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m12 19-7-7 7-7",
            key: "1l729n"
        }
    ],
    [
        "path",
        {
            d: "M19 12H5",
            key: "x3x0zl"
        }
    ]
];
const $5ccabc7cfbfb4128$export$2e2bcd8739ae039 = (0, $573db7058e59e0a7$export$2e2bcd8739ae039)("arrow-left", $5ccabc7cfbfb4128$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $a1bb46db14cf1940$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M18 6 6 18",
            key: "1bl5f8"
        }
    ],
    [
        "path",
        {
            d: "m6 6 12 12",
            key: "d8bk6v"
        }
    ]
];
const $a1bb46db14cf1940$export$2e2bcd8739ae039 = (0, $573db7058e59e0a7$export$2e2bcd8739ae039)("x", $a1bb46db14cf1940$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $c8f72d08a026d232$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M5 12h14",
            key: "1ays0h"
        }
    ],
    [
        "path",
        {
            d: "M12 5v14",
            key: "s699le"
        }
    ]
];
const $c8f72d08a026d232$export$2e2bcd8739ae039 = (0, $573db7058e59e0a7$export$2e2bcd8739ae039)("plus", $c8f72d08a026d232$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $be3df7e130927463$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M20 6 9 17l-5-5",
            key: "1gmf2c"
        }
    ]
];
const $be3df7e130927463$export$2e2bcd8739ae039 = (0, $573db7058e59e0a7$export$2e2bcd8739ae039)("check", $be3df7e130927463$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $841a2e76ca4abe99$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
            key: "wmoenq"
        }
    ],
    [
        "path",
        {
            d: "M12 9v4",
            key: "juzpu7"
        }
    ],
    [
        "path",
        {
            d: "M12 17h.01",
            key: "p32p05"
        }
    ]
];
const $841a2e76ca4abe99$export$2e2bcd8739ae039 = (0, $573db7058e59e0a7$export$2e2bcd8739ae039)("triangle-alert", $841a2e76ca4abe99$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $0d80d575546715e7$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M8 2v4",
            key: "1cmpym"
        }
    ],
    [
        "path",
        {
            d: "M16 2v4",
            key: "4m81vk"
        }
    ],
    [
        "rect",
        {
            width: "18",
            height: "18",
            x: "3",
            y: "4",
            rx: "2",
            key: "1hopcy"
        }
    ],
    [
        "path",
        {
            d: "M3 10h18",
            key: "8toen8"
        }
    ]
];
const $0d80d575546715e7$export$2e2bcd8739ae039 = (0, $573db7058e59e0a7$export$2e2bcd8739ae039)("calendar", $0d80d575546715e7$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $5b3a6868d59f6a63$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "m15.5 7.5 2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4L19 4",
            key: "g0fldk"
        }
    ],
    [
        "path",
        {
            d: "m21 2-9.6 9.6",
            key: "1j0ho8"
        }
    ],
    [
        "circle",
        {
            cx: "7.5",
            cy: "15.5",
            r: "5.5",
            key: "yqb3hr"
        }
    ]
];
const $5b3a6868d59f6a63$export$2e2bcd8739ae039 = (0, $573db7058e59e0a7$export$2e2bcd8739ae039)("key", $5b3a6868d59f6a63$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $779f56f9bad980c3$export$3efd853dbb351e94 = [
    [
        "circle",
        {
            cx: "12",
            cy: "12",
            r: "10",
            key: "1mglay"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12",
            y1: "8",
            y2: "12",
            key: "1pkeuh"
        }
    ],
    [
        "line",
        {
            x1: "12",
            x2: "12.01",
            y1: "16",
            y2: "16",
            key: "4dfq90"
        }
    ]
];
const $779f56f9bad980c3$export$2e2bcd8739ae039 = (0, $573db7058e59e0a7$export$2e2bcd8739ae039)("circle-alert", $779f56f9bad980c3$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $64919d4075208dca$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
            key: "1a8usu"
        }
    ],
    [
        "path",
        {
            d: "m15 5 4 4",
            key: "1mk7zo"
        }
    ]
];
const $64919d4075208dca$export$2e2bcd8739ae039 = (0, $573db7058e59e0a7$export$2e2bcd8739ae039)("pencil", $64919d4075208dca$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $d5814cd6634c549c$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10 11v6",
            key: "nco0om"
        }
    ],
    [
        "path",
        {
            d: "M14 11v6",
            key: "outv1u"
        }
    ],
    [
        "path",
        {
            d: "M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6",
            key: "miytrc"
        }
    ],
    [
        "path",
        {
            d: "M3 6h18",
            key: "d0wm0j"
        }
    ],
    [
        "path",
        {
            d: "M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2",
            key: "e791ji"
        }
    ]
];
const $d5814cd6634c549c$export$2e2bcd8739ae039 = (0, $573db7058e59e0a7$export$2e2bcd8739ae039)("trash-2", $d5814cd6634c549c$export$3efd853dbb351e94);

/**
 * @license lucide-react v1.14.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */ 
const $568a29006da49d51$export$3efd853dbb351e94 = [
    [
        "path",
        {
            d: "M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49",
            key: "ct8e1f"
        }
    ],
    [
        "path",
        {
            d: "M14.084 14.158a3 3 0 0 1-4.242-4.242",
            key: "151rxh"
        }
    ],
    [
        "path",
        {
            d: "M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143",
            key: "13bj9a"
        }
    ],
    [
        "path",
        {
            d: "m2 2 20 20",
            key: "1ooewy"
        }
    ]
];
const $568a29006da49d51$export$2e2bcd8739ae039 = (0, $573db7058e59e0a7$export$2e2bcd8739ae039)("eye-off", $568a29006da49d51$export$3efd853dbb351e94);


const $8598e7256be7fb3c$var$ICON_MAP = {
    dashboard: (0, $66aec767d42fd513$export$2e2bcd8739ae039),
    alerts: (0, $197dfabd8b586015$export$2e2bcd8739ae039),
    comments: (0, $a333b396c1d3b782$export$2e2bcd8739ae039),
    exposure: (0, $e546ef3ca9a09b20$export$2e2bcd8739ae039),
    admin: (0, $d80e7deac00f5835$export$2e2bcd8739ae039),
    eye: (0, $50aa1309e6bfe67d$export$2e2bcd8739ae039),
    mail: (0, $136792a2ec61cb3d$export$2e2bcd8739ae039),
    logout: (0, $950d2dc0950caddb$export$2e2bcd8739ae039),
    search: (0, $86a9ea2d4cc6f619$export$2e2bcd8739ae039),
    chevron: (0, $6f65f1e42653b804$export$2e2bcd8739ae039),
    refresh: (0, $5a41cf212b4dadac$export$2e2bcd8739ae039),
    timer: (0, $f1c835c66028bb29$export$2e2bcd8739ae039),
    pause: (0, $93bc410cbbe7c665$export$2e2bcd8739ae039),
    play: (0, $c5af0e7c890a0112$export$2e2bcd8739ae039),
    arrow: (0, $e21fcbb4100dbb6f$export$2e2bcd8739ae039),
    back: (0, $5ccabc7cfbfb4128$export$2e2bcd8739ae039),
    close: (0, $a1bb46db14cf1940$export$2e2bcd8739ae039),
    plus: (0, $c8f72d08a026d232$export$2e2bcd8739ae039),
    check: (0, $be3df7e130927463$export$2e2bcd8739ae039),
    warn: (0, $841a2e76ca4abe99$export$2e2bcd8739ae039),
    calendar: (0, $0d80d575546715e7$export$2e2bcd8739ae039),
    key: (0, $5b3a6868d59f6a63$export$2e2bcd8739ae039),
    error: (0, $779f56f9bad980c3$export$2e2bcd8739ae039),
    edit: (0, $64919d4075208dca$export$2e2bcd8739ae039),
    trash: (0, $d5814cd6634c549c$export$2e2bcd8739ae039),
    'eye-off': (0, $568a29006da49d51$export$2e2bcd8739ae039)
};
const $8598e7256be7fb3c$var$LCIcon = ({ name: name, size: size = 18, className: className = '', style: style })=>{
    const Icon = $8598e7256be7fb3c$var$ICON_MAP[name];
    if (!Icon) return null;
    return /*#__PURE__*/ (0, $bbzbN.jsx)(Icon, {
        size: size,
        className: className,
        style: style,
        strokeWidth: 1.5
    });
};
var $8598e7256be7fb3c$export$2e2bcd8739ae039 = $8598e7256be7fb3c$var$LCIcon;



var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");

const $e4bf7e7a647cb901$export$217e472da3f6c211 = (v)=>{
    if (v == null || isNaN(v)) return "\u2014";
    const abs = Math.abs(v);
    if (abs >= 1e9) return `$${(v / 1e9).toFixed(2)}B`;
    if (abs >= 1e6) return `$${(v / 1e6).toFixed(2)}M`;
    if (abs >= 1e3) return `$${(v / 1e3).toFixed(0)}K`;
    return `$${Math.round(v).toLocaleString()}`;
};
const $e4bf7e7a647cb901$export$850409532323fff = (v, digits = 1)=>v == null || isNaN(v) ? "\u2014" : `${(v * 100).toFixed(digits)}%`;
const $e4bf7e7a647cb901$export$718bb85e5a505294 = (v, digits = 1)=>v == null || isNaN(v) ? "\u2014" : `${v.toFixed(digits)}%`;
const $e4bf7e7a647cb901$export$79b4d5b1a469ce61 = (v)=>v == null ? "\u2014" : Math.round(v).toLocaleString();
const $e4bf7e7a647cb901$export$50c3903b2324c92f = (v)=>v == null ? "\u2014" : v.toFixed(2);
const $e4bf7e7a647cb901$export$a1176940376eb77f = {
    GREEN: 'Green',
    AMBER_ALERT: 'Amber Alert',
    RED_ALERT: 'Red Alert',
    CRITICAL: 'Critical',
    HOUSE_CALL: 'House Call'
};
const $e4bf7e7a647cb901$export$70f8d8d5d8881b35 = {
    GREEN: '#1f8a4a',
    AMBER_ALERT: '#ffbf00',
    RED_ALERT: '#E50025',
    CRITICAL: '#B80020',
    HOUSE_CALL: '#000000'
};
const $e4bf7e7a647cb901$var$STATUS_CHIP_CLS = {
    GREEN: 'text-[#1f8a4a] bg-[rgba(31,138,74,0.10)]',
    AMBER_ALERT: 'text-[#b6770b] bg-[rgba(255,191,0,0.16)]',
    RED_ALERT: 'text-[#E50025] bg-[rgba(229,0,37,0.10)]',
    CRITICAL: 'text-white bg-[#B80020]',
    HOUSE_CALL: 'text-white bg-black'
};
const $e4bf7e7a647cb901$export$de72cd06bd8617fb = {
    GREEN: 'chip--green',
    AMBER_ALERT: 'chip--amber',
    RED_ALERT: 'chip--red',
    CRITICAL: 'chip--critical',
    HOUSE_CALL: 'chip--house'
};
function $e4bf7e7a647cb901$var$normalizeStatus(status) {
    if (!status) return '';
    return status.toUpperCase().replace(/ /g, '_');
}
const $e4bf7e7a647cb901$export$7139adf9d3bace41 = {
    // Chip base
    chip: 'inline-flex items-center gap-[5px] text-[9.5px] font-bold tracking-[0.08em] uppercase px-2 py-[3px] whitespace-nowrap',
    chipDot: 'w-1.5 h-1.5 rounded-full bg-current',
    chipOutline: 'bg-transparent border border-black/[0.18] text-[#333]',
    chipSuccess: 'text-[#1f8a4a] border-[rgba(31,138,74,0.32)]',
    chipSolidWarn: 'text-white bg-[#b6770b]',
    chipNeutral: 'text-[#333] bg-black/[0.06]',
    // Button base
    btn: 'font-sans font-bold tracking-[0.1em] uppercase border-0 cursor-pointer inline-flex items-center gap-2 whitespace-nowrap transition-colors disabled:opacity-45 disabled:cursor-not-allowed',
    btnSm: 'text-[10px] px-[11px] py-[7px] tracking-[0.09em]',
    btnMd: 'text-[11px] px-4 py-[10px]',
    btnPrimary: 'bg-[#E50025] text-white hover:bg-[#B80020]',
    btnOutline: 'bg-transparent text-black border border-black/[0.32] hover:bg-black hover:text-white hover:border-black',
    btnGhost: 'bg-transparent text-[#333] hover:text-[#E50025]',
    btnSecondary: 'bg-black text-white hover:bg-[#222]',
    // Table
    tableWrap: 'bg-white border border-black/[0.06] overflow-x-auto',
    table: 'w-full border-collapse text-[12.5px] [font-feature-settings:\'tnum\']',
    th: 'text-left text-[9.5px] font-bold tracking-[0.12em] uppercase text-[#7A7A76] px-3.5 py-3 border-b border-black/10 whitespace-nowrap select-none bg-[#FAF9F8]',
    thSortable: 'cursor-pointer hover:text-black',
    thSorted: 'text-black',
    td: 'px-3.5 py-3 border-b border-black/[0.05] align-middle',
    tdNum: 'text-right [font-feature-settings:\'tnum\']',
    tdMono: 'font-mono text-[11px] tracking-[0.02em] text-[#333]',
    tdClient: 'font-medium text-black',
    // Input
    field: 'flex flex-col gap-1.5',
    fieldLabel: 'text-[10px] tracking-[0.16em] uppercase font-bold text-[#333]',
    input: 'font-[inherit] text-[13.5px] font-light px-3 py-[10px] border border-black/[0.16] bg-white text-black transition-colors h-full w-full rounded-none focus:outline-none focus:border-[#E50025]',
    inputWrap: 'relative',
    inputIco: 'absolute left-3.5 top-1/2 -translate-y-1/2 text-[#7A7A76] pointer-events-none',
    // Page
    page: 'px-9 pt-7 pb-[60px] w-full max-lg:px-5 max-lg:pt-4 max-lg:pb-12 max-[768px]:px-3.5 max-[768px]:pt-3 max-[768px]:pb-10',
    pageHead: 'flex justify-between items-end gap-6 mb-[22px] max-[768px]:flex-col max-[768px]:items-start max-[768px]:gap-2.5 max-[768px]:mb-3.5',
    pageH1: 'font-serif font-normal text-[32px] leading-tight tracking-[-0.015em] text-black m-0 max-lg:text-[26px] max-[480px]:text-[22px]',
    pageSub: 'text-[13px] text-[#7A7A76] mt-1.5 font-normal',
    metaRow: 'flex gap-[18px] flex-wrap justify-end',
    meta: 'inline-flex items-center gap-1.5 text-[11.5px] text-[#7A7A76]',
    // Eyebrow
    eyebrow: 'text-[10px] font-bold tracking-[0.16em] uppercase text-[#7A7A76] m-0 mb-1.5',
    // Surface
    surface: 'bg-white border border-black/[0.06]',
    surfacePad: 'px-6 py-[22px]',
    // Section title
    sectionTitle: 'flex items-center gap-3.5 my-[22px] mb-3',
    sectionH2: 'font-serif text-[22px] font-normal tracking-[-0.005em] m-0',
    sectionCount: 'text-[11px] text-[#7A7A76] tracking-[0.04em]',
    sectionRule: 'flex-1 border-t border-black/[0.08] ml-1',
    // Misc
    muted: 'text-[#7A7A76]',
    hr: 'border-0 border-t border-black/[0.08] my-[18px]',
    iconBtn: 'bg-transparent border-0 p-1.5 cursor-pointer text-[#333] inline-grid place-items-center hover:text-[#E50025] hover:bg-[#FAF9F8] transition-colors',
    badgeNum: 'inline-grid place-items-center min-w-[16px] h-4 px-1 text-[9.5px] font-bold bg-[#E50025] text-white rounded-full ml-1'
};
const $e4bf7e7a647cb901$export$9a6eab314e3821cc = ({ variant: variant = 'primary', size: size = 'md', className: className = '', children: children, ...rest })=>{
    const variantCls = {
        primary: $e4bf7e7a647cb901$export$7139adf9d3bace41.btnPrimary,
        outline: $e4bf7e7a647cb901$export$7139adf9d3bace41.btnOutline,
        ghost: $e4bf7e7a647cb901$export$7139adf9d3bace41.btnGhost,
        secondary: $e4bf7e7a647cb901$export$7139adf9d3bace41.btnSecondary
    }[variant];
    const sizeCls = size === 'sm' ? $e4bf7e7a647cb901$export$7139adf9d3bace41.btnSm : $e4bf7e7a647cb901$export$7139adf9d3bace41.btnMd;
    return /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
        className: `${$e4bf7e7a647cb901$export$7139adf9d3bace41.btn} ${variantCls} ${sizeCls} ${className}`,
        ...rest,
        children: children
    });
};
const $e4bf7e7a647cb901$export$de784d3a9b38c570 = ({ status: status, label: label, className: className = '', variant: variant })=>{
    const norm = $e4bf7e7a647cb901$var$normalizeStatus(status);
    let colorCls = $e4bf7e7a647cb901$export$7139adf9d3bace41.chipNeutral;
    if (variant === 'outline') colorCls = $e4bf7e7a647cb901$export$7139adf9d3bace41.chipOutline;
    else if (variant === 'solid-warn') colorCls = $e4bf7e7a647cb901$export$7139adf9d3bace41.chipSolidWarn;
    else if (variant === 'success') colorCls = `${$e4bf7e7a647cb901$export$7139adf9d3bace41.chipOutline} ${$e4bf7e7a647cb901$export$7139adf9d3bace41.chipSuccess}`;
    else if (norm && $e4bf7e7a647cb901$var$STATUS_CHIP_CLS[norm]) colorCls = $e4bf7e7a647cb901$var$STATUS_CHIP_CLS[norm];
    const text = label ?? (norm ? $e4bf7e7a647cb901$export$a1176940376eb77f[norm] || status : "\u2014");
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
        className: `${$e4bf7e7a647cb901$export$7139adf9d3bace41.chip} ${colorCls} ${className}`,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                className: $e4bf7e7a647cb901$export$7139adf9d3bace41.chipDot
            }),
            text
        ]
    });
};
const $e4bf7e7a647cb901$export$a2aeb90e6df6bf5a = ({ value: value, status: status, big: big })=>{
    if (value == null) return /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
        className: $e4bf7e7a647cb901$export$7139adf9d3bace41.muted,
        children: "\u2014"
    });
    const pct = Math.max(0, Math.min(100, value * 100));
    const norm = $e4bf7e7a647cb901$var$normalizeStatus(status);
    const fill = norm && $e4bf7e7a647cb901$export$70f8d8d5d8881b35[norm] ? $e4bf7e7a647cb901$export$70f8d8d5d8881b35[norm] : '#1f8a4a';
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
        className: "flex items-center gap-2.5",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                className: `relative overflow-hidden bg-black/[0.07] ${big ? 'w-[220px] h-[10px]' : 'w-[100px] h-[6px]'}`,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                    className: "absolute left-0 top-0 bottom-0 transition-[width] duration-[220ms]",
                    style: {
                        width: `${pct}%`,
                        background: fill
                    }
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                className: `font-semibold ${big ? 'text-[18px] min-w-[56px]' : 'text-[11.5px] min-w-[38px]'}`,
                children: [
                    (value * 100).toFixed(1),
                    "%"
                ]
            })
        ]
    });
};
const $e4bf7e7a647cb901$export$f8f69345c94a0646 = ({ label: label, field: field, active: active, dir: dir, onClick: onClick, className: className = '' })=>/*#__PURE__*/ (0, $bbzbN.jsxs)("th", {
        className: `${$e4bf7e7a647cb901$export$7139adf9d3bace41.th} ${$e4bf7e7a647cb901$export$7139adf9d3bace41.thSortable} ${active ? $e4bf7e7a647cb901$export$7139adf9d3bace41.thSorted : ''} ${className}`,
        onClick: ()=>onClick(field),
        children: [
            label,
            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                className: `inline-block ml-[5px] text-[9px] ${active ? 'opacity-100 text-[#E50025]' : 'opacity-40'}`,
                children: active ? dir === 'asc' ? "\u25B2" : "\u25BC" : "\u25B2"
            })
        ]
    });


function $d0fd084ff87c43f3$var$timeAgo(ts) {
    const m = Math.floor((Date.now() - new Date(ts).getTime()) / 60000);
    if (m < 1) return 'just now';
    if (m < 60) return `${m}m ago`;
    const h = Math.floor(m / 60);
    if (h < 24) return `${h}h ago`;
    return `${Math.floor(h / 24)}d ago`;
}
const $d0fd084ff87c43f3$var$CommentsSidebar = ({ portfolio: portfolio, onClose: onClose })=>{
    const { user: user } = (0, $d0020511b775fb45$export$1d39dc5b47e56ff0)();
    const { getCommentsForPortfolio: getCommentsForPortfolio, addComment: addComment, addReply: addReply, fetchComments: fetchComments, isLoading: isLoading } = (0, $2f198502e2232dfa$export$80ad823ea511ef0f)();
    const [draft, setDraft] = (0, $7fPBF.useState)('');
    const [category, setCategory] = (0, $7fPBF.useState)('Other');
    const [replyingTo, setReplyingTo] = (0, $7fPBF.useState)(null);
    const [replyText, setReplyText] = (0, $7fPBF.useState)('');
    const [submitting, setSubmitting] = (0, $7fPBF.useState)(false);
    const pid = portfolio.portfolio_id_lig;
    (0, $7fPBF.useEffect)(()=>{
        fetchComments(pid);
    }, [
        pid,
        fetchComments
    ]);
    const allComments = getCommentsForPortfolio(pid);
    const loading = isLoading[pid] || false;
    const organized = allComments.filter((c)=>!c.parentId).map((c)=>({
            ...c,
            replies: allComments.filter((r)=>r.parentId === c.id)
        })).sort((a, b)=>new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
    const handleSubmit = async ()=>{
        if (!draft.trim() || submitting) return;
        setSubmitting(true);
        try {
            await addComment(pid, draft.trim(), category);
            setDraft('');
        } finally{
            setSubmitting(false);
        }
    };
    const handleReply = async (parentId)=>{
        if (!replyText.trim() || submitting) return;
        setSubmitting(true);
        try {
            await addReply(pid, parentId, replyText.trim());
            setReplyText('');
            setReplyingTo(null);
        } finally{
            setSubmitting(false);
        }
    };
    const currentUserName = user?.first_name && user?.last_name ? `${user.first_name} ${user.last_name}` : user?.email?.split('@')[0] || 'You';
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: "fixed inset-0 bg-black/[0.36] flex justify-end z-[50] animate-fadein",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
            className: "w-[460px] max-w-full bg-white h-full flex flex-col animate-slidein",
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    className: "px-[22px] py-[18px] border-b border-black/[0.08] flex items-start justify-between gap-3",
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                    className: "text-[10px] font-bold tracking-[0.16em] uppercase text-[#E50025] mb-1.5",
                                    children: "Portfolio Comments"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("h3", {
                                    className: "font-serif text-[22px] font-normal my-1 tracking-[-0.005em]",
                                    children: portfolio.client_name
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                    className: "text-[12px] text-[#7A7A76] font-mono",
                                    children: [
                                        pid,
                                        " \xb7 ",
                                        organized.length,
                                        " comment",
                                        organized.length !== 1 ? 's' : ''
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).iconBtn,
                            onClick: onClose,
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                name: "close",
                                size: 16
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    className: "flex-1 overflow-y-auto px-[22px] py-4 flex flex-col gap-3.5",
                    children: [
                        loading && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).muted} text-center py-7`,
                            children: "Loading comments\u2026"
                        }),
                        !loading && organized.length === 0 && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).muted} text-center py-7`,
                            children: "No comments yet. Be the first to leave one."
                        }),
                        organized.map((c)=>/*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                        className: `border-l-2 px-3 py-2 pb-2.5 bg-[#FAF9F8] ${c.userName === currentUserName ? 'border-l-black' : 'border-l-[#E50025]'}`,
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                                className: "flex justify-between gap-2 text-[10.5px] text-[#7A7A76] tracking-[0.04em] uppercase",
                                                children: [
                                                    /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                                                        className: "font-bold text-[#333] tracking-[0.06em]",
                                                        children: [
                                                            c.userName,
                                                            " \xb7 ",
                                                            c.userRole
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                        children: $d0fd084ff87c43f3$var$timeAgo(c.timestamp)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                className: "mt-1.5 text-[13px] leading-[1.5] text-black",
                                                children: c.content
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                className: "mt-2",
                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                                                    variant: "ghost",
                                                    size: "sm",
                                                    style: {
                                                        fontSize: 10,
                                                        padding: '4px 8px'
                                                    },
                                                    onClick: ()=>setReplyingTo(replyingTo === c.id ? null : c.id),
                                                    children: "Reply"
                                                })
                                            })
                                        ]
                                    }),
                                    c.replies.map((r)=>/*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                            className: `border-l-2 px-3 py-2 pb-2.5 bg-[#FAF9F8] ml-4 mt-1 ${r.userName === currentUserName ? 'border-l-black' : 'border-l-[#E50025]'}`,
                                            children: [
                                                /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                                    className: "flex justify-between gap-2 text-[10.5px] text-[#7A7A76] tracking-[0.04em] uppercase",
                                                    children: [
                                                        /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                                                            className: "font-bold text-[#333] tracking-[0.06em]",
                                                            children: [
                                                                r.userName,
                                                                " \xb7 ",
                                                                r.userRole
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                            children: $d0fd084ff87c43f3$var$timeAgo(r.timestamp)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                    className: "mt-1.5 text-[13px] leading-[1.5] text-black",
                                                    children: r.content
                                                })
                                            ]
                                        }, r.id)),
                                    replyingTo === c.id && /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                        className: "ml-4 mt-1.5 flex flex-col gap-1.5",
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("textarea", {
                                                placeholder: "Write a reply\u2026",
                                                value: replyText,
                                                onChange: (e)=>setReplyText(e.target.value),
                                                className: "w-full min-h-[60px] px-2.5 py-2 border border-black/[0.16] text-[13px] resize-y focus:outline-none focus:border-[#E50025] font-[inherit]"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                                className: "flex gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                                                        variant: "primary",
                                                        size: "sm",
                                                        onClick: ()=>handleReply(c.id),
                                                        disabled: submitting,
                                                        children: "Post Reply"
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                                                        variant: "ghost",
                                                        size: "sm",
                                                        onClick: ()=>setReplyingTo(null),
                                                        children: "Cancel"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, c.id))
                    ]
                }),
                /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    className: "border-t border-black/[0.08] px-[22px] py-3.5 flex flex-col gap-2.5",
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: "flex gap-2 mb-1.5",
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)("select", {
                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input,
                                style: {
                                    width: 160,
                                    padding: '6px 10px',
                                    fontSize: 12
                                },
                                value: category,
                                onChange: (e)=>setCategory(e.target.value),
                                children: (0, $f213e983270415ba$export$b9f0c4cf5e81d842).map((c)=>/*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                        children: c
                                    }, c))
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("textarea", {
                            className: "resize-y min-h-[78px] px-3 py-2.5 border border-black/[0.16] font-[inherit] text-[13px] focus:outline-none focus:border-[#E50025]",
                            placeholder: `Leave a comment as ${currentUserName}\u{2026}`,
                            value: draft,
                            onChange: (e)=>setDraft(e.target.value)
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                            className: "flex justify-between items-center",
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                    className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).muted} text-[11px]`,
                                    children: "Visible to all RMs and ICs."
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                                    variant: "primary",
                                    size: "sm",
                                    onClick: handleSubmit,
                                    disabled: submitting || !draft.trim(),
                                    children: [
                                        "Post Comment ",
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                            name: "arrow",
                                            size: 12
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var $d0fd084ff87c43f3$export$2e2bcd8739ae039 = $d0fd084ff87c43f3$var$CommentsSidebar;




function $4d3334a83e1f9fa9$var$normalizeStatus(s) {
    if (!s) return '';
    return s.toUpperCase().replace(/ /g, '_');
}
const $4d3334a83e1f9fa9$var$Dashboard = ()=>{
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const { getCommentCount: getCommentCount, fetchCommentCountsBatch: fetchCommentCountsBatch } = (0, $2f198502e2232dfa$export$80ad823ea511ef0f)();
    const [searchTerm, setSearchTerm] = (0, $7fPBF.useState)('');
    const [statusFilter, setStatusFilter] = (0, $7fPBF.useState)('');
    const [rmFilter, setRmFilter] = (0, $7fPBF.useState)('');
    const [refDate, setRefDate] = (0, $7fPBF.useState)(new Date().toLocaleDateString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
    }));
    const [sortField, setSortField] = (0, $7fPBF.useState)('surplus_cushion_with_cash');
    const [sortDir, setSortDir] = (0, $7fPBF.useState)('asc');
    const [cashSortField, setCashSortField] = (0, $7fPBF.useState)('total_aum');
    const [cashSortDir, setCashSortDir] = (0, $7fPBF.useState)('desc');
    const [portfoliosData, setPortfoliosData] = (0, $7fPBF.useState)([]);
    const [portfolioCount, setPortfolioCount] = (0, $7fPBF.useState)(null);
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const [timeUntilRefresh, setTimeUntilRefresh] = (0, $7fPBF.useState)(300);
    const [autoRefresh, setAutoRefresh] = (0, $7fPBF.useState)(true);
    const [lastUpdated, setLastUpdated] = (0, $7fPBF.useState)(null);
    const [commentsSidebarOpen, setCommentsSidebarOpen] = (0, $7fPBF.useState)(false);
    const [selectedPortfolio, setSelectedPortfolio] = (0, $7fPBF.useState)(null);
    const fetchPortfolios = (0, $7fPBF.useCallback)(async ()=>{
        try {
            setLoading(true);
            setError(null);
            const [portfolios, counts] = await Promise.all([
                (0, $2b61471e8e825f6c$export$2e2bcd8739ae039).getPortfolios(),
                (0, $2b61471e8e825f6c$export$2e2bcd8739ae039).getPortfolioCount()
            ]);
            setPortfoliosData(portfolios);
            setPortfolioCount(counts);
            const ts = portfolios.find((p)=>p.last_updated)?.last_updated;
            if (ts) setLastUpdated(new Date(ts).toLocaleString('en-US', {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false,
                timeZone: 'America/New_York'
            }) + ' EST');
            fetchCommentCountsBatch(portfolios.map((p)=>p.portfolio_id_lig));
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Failed to fetch portfolio data');
        } finally{
            setLoading(false);
        }
    }, [
        fetchCommentCountsBatch
    ]);
    const handleRefresh = (0, $7fPBF.useCallback)(async ()=>{
        await fetchPortfolios();
        setTimeUntilRefresh(300);
    }, [
        fetchPortfolios
    ]);
    (0, $7fPBF.useEffect)(()=>{
        fetchPortfolios();
        const interval = setInterval(()=>{
            if (autoRefresh) {
                fetchPortfolios();
                setTimeUntilRefresh(300);
            }
        }, 300000);
        return ()=>clearInterval(interval);
    }, [
        fetchPortfolios,
        autoRefresh
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!autoRefresh) return;
        const t = setInterval(()=>setTimeUntilRefresh((p)=>p <= 1 ? 300 : p - 1), 1000);
        return ()=>clearInterval(t);
    }, [
        autoRefresh
    ]);
    const onSort = (f)=>{
        const field = f;
        if (sortField === field) setSortDir((d)=>d === 'asc' ? 'desc' : 'asc');
        else {
            setSortField(field);
            setSortDir('asc');
        }
    };
    const onCashSort = (f)=>{
        const field = f;
        if (cashSortField === field) setCashSortDir((d)=>d === 'asc' ? 'desc' : 'asc');
        else {
            setCashSortField(field);
            setCashSortDir('asc');
        }
    };
    const rmOptions = (0, $7fPBF.useMemo)(()=>Array.from(new Set(portfoliosData.map((p)=>p.rm_name).filter(Boolean))).sort(), [
        portfoliosData
    ]);
    const { marginAccounts: marginAccounts, cashAccounts: cashAccounts } = (0, $7fPBF.useMemo)(()=>{
        const q = searchTerm.toLowerCase();
        const match = (p)=>{
            if (q && !`${p.client_name} ${p.portfolio_id_lig} ${p.rm_name}`.toLowerCase().includes(q)) return false;
            if (rmFilter && p.rm_name !== rmFilter) return false;
            return true;
        };
        const marginSF = statusFilter;
        let margin = portfoliosData.filter((p)=>p.has_margin_account && match(p) && (!marginSF || $4d3334a83e1f9fa9$var$normalizeStatus(p.status) === marginSF));
        margin.sort((a, b)=>{
            const aM = a.is_margin_trading ? 1 : 0, bM = b.is_margin_trading ? 1 : 0;
            if (aM !== bM) return bM - aM;
            const av = a[sortField] ?? 0, bv = b[sortField] ?? 0;
            if (av < bv) return sortDir === 'asc' ? -1 : 1;
            if (av > bv) return sortDir === 'asc' ? 1 : -1;
            return 0;
        });
        let cash = portfoliosData.filter((p)=>!p.has_margin_account && match(p));
        cash.sort((a, b)=>{
            const av = a[cashSortField] ?? 0, bv = b[cashSortField] ?? 0;
            if (av < bv) return cashSortDir === 'asc' ? -1 : 1;
            if (av > bv) return cashSortDir === 'asc' ? 1 : -1;
            return 0;
        });
        return {
            marginAccounts: margin,
            cashAccounts: cash
        };
    }, [
        portfoliosData,
        searchTerm,
        statusFilter,
        rmFilter,
        sortField,
        sortDir,
        cashSortField,
        cashSortDir
    ]);
    const stats = (0, $7fPBF.useMemo)(()=>{
        const valid = portfoliosData.filter((p)=>p.has_margin_account && p.total_aum != null);
        const totalAum = valid.reduce((s, p)=>s + (p.total_aum || 0), 0);
        const totalMarginUsed = valid.reduce((s, p)=>s + (p.lc_margin_requirement || 0), 0);
        const cushionPort = valid.filter((p)=>p.surplus_cushion != null && (p.pershing_requirement || 0) >= 10);
        const wsum = cushionPort.reduce((s, p)=>s + p.surplus_cushion * (p.total_aum || 0), 0);
        const tsum = cushionPort.reduce((s, p)=>s + (p.total_aum || 0), 0);
        const avgCushion = tsum > 0 ? wsum / tsum : 0;
        const counts = valid.reduce((acc, p)=>{
            const s = $4d3334a83e1f9fa9$var$normalizeStatus(p.status) || 'Unknown';
            acc[s] = (acc[s] || 0) + 1;
            return acc;
        }, {});
        const totalPortfolios = portfoliosData.filter((p)=>p.total_aum != null).length;
        return {
            totalAum: totalAum,
            totalMarginUsed: totalMarginUsed,
            avgCushion: avgCushion,
            counts: counts,
            totalPortfolios: totalPortfolios,
            marginPortfolios: valid.length
        };
    }, [
        portfoliosData,
        portfolioCount
    ]);
    if (loading && !portfoliosData.length) return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).page} flex items-center justify-center min-h-[400px] flex-col gap-4`,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                name: "refresh",
                size: 32,
                style: {
                    opacity: 0.4,
                    animation: 'spin 1s linear infinite'
                }
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).muted,
                style: {
                    fontSize: 14
                },
                children: "Loading portfolio data\u2026"
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("style", {
                children: `@keyframes spin { from { transform: rotate(0deg) } to { transform: rotate(360deg) } }`
            })
        ]
    });
    if (error) return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).page,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "bg-[rgba(229,0,37,0.06)] border border-[#E50025] px-[22px] py-[18px] mb-4",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "font-bold text-[#E50025] text-[12px] tracking-[0.12em] uppercase mb-1.5",
                        children: "Error Loading Data"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        style: {
                            fontSize: 13
                        },
                        children: error
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                variant: "primary",
                size: "sm",
                onClick: handleRefresh,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                        name: "refresh",
                        size: 12
                    }),
                    " Retry"
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).page,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).pageHead,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "flex flex-col justify-between",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("h1", {
                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).pageH1,
                                children: "Portfolio Dashboard"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).pageSub,
                                children: [
                                    "Real-time margin monitoring across ",
                                    stats.totalPortfolios,
                                    " portfolios \u2014 held at Pershing, monitored for LC house add-on requirements."
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).metaRow,
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).meta,
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                        name: "timer",
                                        size: 14
                                    }),
                                    autoRefresh ? /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                                        children: [
                                            "Next refresh in ",
                                            /*#__PURE__*/ (0, $bbzbN.jsxs)("strong", {
                                                className: "text-black ml-1",
                                                children: [
                                                    timeUntilRefresh,
                                                    "s"
                                                ]
                                            })
                                        ]
                                    }) : 'Auto-refresh paused'
                                ]
                            }),
                            lastUpdated && /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).meta} max-[768px]:w-full max-[768px]:justify-end`,
                                children: [
                                    "Last updated: ",
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("strong", {
                                        className: "text-black ml-1",
                                        children: lastUpdated
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                className: "flex gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                                        variant: "outline",
                                        size: "sm",
                                        onClick: ()=>setAutoRefresh((v)=>!v),
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                                name: autoRefresh ? 'pause' : 'play',
                                                size: 12
                                            }),
                                            autoRefresh ? 'Pause' : 'Resume'
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                                        variant: "primary",
                                        size: "sm",
                                        onClick: handleRefresh,
                                        disabled: loading,
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                                name: "refresh",
                                                size: 12
                                            }),
                                            " Refresh"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "grid grid-cols-3 gap-[18px] max-[768px]:gap-2 mb-[18px]",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "bg-white border border-black/[0.06] border-t-2 border-t-[#E50025] p-[12px_14px] flex flex-col relative min-w-0",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "text-[9.5px] font-bold tracking-[0.14em] uppercase text-[#7A7A76]",
                                children: "Total AUM"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "font-serif font-normal text-[22px] leading-tight mt-1.5 tracking-[-0.01em] text-black [font-feature-settings:'tnum']",
                                children: (0, $e4bf7e7a647cb901$export$217e472da3f6c211)(stats.totalAum)
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "mt-1.5 text-[10.5px] text-[#7A7A76]",
                                children: "margin accounts"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "bg-white border border-black/[0.06] p-[12px_14px] flex flex-col relative min-w-0",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "text-[9.5px] font-bold tracking-[0.14em] uppercase text-[#7A7A76]",
                                children: "Total Margin Used"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "font-serif font-normal text-[22px] leading-tight mt-1.5 tracking-[-0.01em] text-black [font-feature-settings:'tnum']",
                                children: (0, $e4bf7e7a647cb901$export$217e472da3f6c211)(stats.totalMarginUsed)
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                className: "mt-1.5 text-[10.5px] text-[#7A7A76]",
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("strong", {
                                        className: "text-black font-semibold",
                                        children: (0, $e4bf7e7a647cb901$export$850409532323fff)(stats.totalAum > 0 ? stats.totalMarginUsed / stats.totalAum : 0, 1)
                                    }),
                                    " of AUM"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "bg-white border border-black/[0.06] p-[12px_14px] flex flex-col relative min-w-0",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "text-[9.5px] font-bold tracking-[0.14em] uppercase text-[#7A7A76]",
                                children: "Avg. Surplus Cushion"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "font-serif font-normal text-[22px] leading-tight mt-1.5 tracking-[-0.01em] text-black [font-feature-settings:'tnum']",
                                children: (0, $e4bf7e7a647cb901$export$850409532323fff)(stats.avgCushion, 1)
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "mt-1.5 text-[10.5px] text-[#7A7A76]",
                                children: "weighted by AUM"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "bg-white border border-black/[0.06] p-[12px_14px] flex flex-col relative min-w-0",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "text-[9.5px] font-bold tracking-[0.14em] uppercase text-[#7A7A76]",
                                children: "Risk Status Distribution"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "flex gap-0.5 mt-3.5 h-2",
                                children: [
                                    'GREEN',
                                    'AMBER_ALERT',
                                    'RED_ALERT',
                                    'CRITICAL',
                                    'HOUSE_CALL'
                                ].map((s)=>{
                                    const c = stats.counts[s] || 0;
                                    const total = Object.values(stats.counts).reduce((a, b)=>a + b, 0);
                                    const w = total ? c / total * 100 : 0;
                                    if (!c) return null;
                                    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                        title: `${c} ${(0, $e4bf7e7a647cb901$export$a1176940376eb77f)[s]}`,
                                        style: {
                                            flex: w,
                                            background: (0, $e4bf7e7a647cb901$export$70f8d8d5d8881b35)[s]
                                        }
                                    }, s);
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "flex flex-wrap gap-1 mt-3",
                                children: Object.entries(stats.counts).filter(([, n])=>n > 0).map(([s, n])=>/*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                                        className: "inline-flex items-center gap-[5px] text-[9.5px] font-bold tracking-[0.06em] uppercase px-[7px] py-[3px] text-white",
                                        style: {
                                            background: (0, $e4bf7e7a647cb901$export$70f8d8d5d8881b35)[s]
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                className: "w-[5px] h-[5px] rounded-full bg-white/85"
                                            }),
                                            n,
                                            " ",
                                            (0, $e4bf7e7a647cb901$export$a1176940376eb77f)[s]
                                        ]
                                    }, s))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "bg-white border border-black/[0.06] p-[12px_14px] flex flex-col relative min-w-0",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "text-[9.5px] font-bold tracking-[0.14em] uppercase text-[#7A7A76]",
                                children: "Total Portfolios"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "font-serif font-normal text-[22px] leading-tight mt-1.5 tracking-[-0.01em] text-black [font-feature-settings:'tnum']",
                                children: stats.totalPortfolios
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                className: "mt-1.5 text-[10.5px] text-[#7A7A76]",
                                children: [
                                    stats.marginPortfolios,
                                    " with margin \xb7 ",
                                    stats.totalPortfolios - stats.marginPortfolios,
                                    " cash-only"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "bg-white border border-black/[0.06] p-[12px_14px] flex flex-col relative min-w-0",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "text-[9.5px] font-bold tracking-[0.14em] uppercase text-[#7A7A76]",
                                children: "LC House Calls"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "font-serif font-normal text-[22px] leading-tight mt-1.5 tracking-[-0.01em] text-black [font-feature-settings:'tnum']",
                                children: stats.counts.HOUSE_CALL || 0
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "mt-1.5 text-[10.5px] text-[#7A7A76]",
                                children: "require RM action by EOD"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "grid [grid-template-columns:minmax(0,1.6fr)_repeat(3,minmax(0,1fr))] gap-3 items-stretch bg-white border border-black/[0.06] p-[14px_16px] mb-[18px] max-lg:[grid-template-columns:1fr_1fr] max-[768px]:grid-cols-1",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).field,
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("label", {
                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).fieldLabel,
                                children: "Search"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).inputWrap,
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                        name: "search",
                                        size: 14,
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).inputIco
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input} pl-[38px]`,
                                        placeholder: "Search by client name, portfolio ID, or RM\u2026",
                                        value: searchTerm,
                                        onChange: (e)=>setSearchTerm(e.target.value)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).field,
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("label", {
                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).fieldLabel,
                                children: "Margin Status"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("select", {
                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input,
                                value: statusFilter,
                                onChange: (e)=>setStatusFilter(e.target.value),
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                        value: "",
                                        children: "All statuses"
                                    }),
                                    Object.entries((0, $e4bf7e7a647cb901$export$a1176940376eb77f)).map(([k, v])=>/*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                            value: k,
                                            children: v
                                        }, k))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).field,
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("label", {
                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).fieldLabel,
                                children: "Relationship Manager"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("select", {
                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input,
                                value: rmFilter,
                                onChange: (e)=>setRmFilter(e.target.value),
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                        value: "",
                                        children: "All managers"
                                    }),
                                    rmOptions.map((rm)=>/*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                            value: rm,
                                            children: rm
                                        }, rm))
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).field,
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("label", {
                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).fieldLabel,
                                children: "Reference Date"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).inputWrap,
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                        name: "calendar",
                                        size: 14,
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).inputIco
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input} pl-[38px]`,
                                        value: refDate,
                                        onChange: (e)=>setRefDate(e.target.value)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).sectionTitle,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("h2", {
                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).sectionH2,
                        children: "Portfolios with Margin Account"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).sectionCount,
                        children: [
                            marginAccounts.length,
                            " portfolios"
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).sectionRule
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tableWrap,
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)("table", {
                    className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).table,
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                        style: {
                                            width: '11%'
                                        },
                                        children: "Portfolio ID"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$f8f69345c94a0646), {
                                        label: "Client Name",
                                        field: "client_name",
                                        active: sortField === 'client_name',
                                        dir: sortDir,
                                        onClick: onSort
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                        children: "Status"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$f8f69345c94a0646), {
                                        label: "Surplus Cushion",
                                        field: "surplus_cushion",
                                        active: sortField === 'surplus_cushion',
                                        dir: sortDir,
                                        onClick: onSort
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$f8f69345c94a0646), {
                                        label: "With Cash",
                                        field: "surplus_cushion_with_cash",
                                        active: sortField === 'surplus_cushion_with_cash',
                                        dir: sortDir,
                                        onClick: onSort
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                        children: "Margin Trading"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$f8f69345c94a0646), {
                                        label: "Total AUM",
                                        field: "total_aum",
                                        active: sortField === 'total_aum',
                                        dir: sortDir,
                                        onClick: onSort,
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$f8f69345c94a0646), {
                                        label: "Margin Equity",
                                        field: "margin_account_equity",
                                        active: sortField === 'margin_account_equity',
                                        dir: sortDir,
                                        onClick: onSort,
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$f8f69345c94a0646), {
                                        label: "Pershing Req.",
                                        field: "pershing_requirement",
                                        active: sortField === 'pershing_requirement',
                                        dir: sortDir,
                                        onClick: onSort,
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$f8f69345c94a0646), {
                                        label: "LC Margin Req.",
                                        field: "lc_margin_requirement",
                                        active: sortField === 'lc_margin_requirement',
                                        dir: sortDir,
                                        onClick: onSort,
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                        children: "RM"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                        style: {
                                            textAlign: 'center'
                                        },
                                        children: "Comments"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                        style: {
                                            width: 40
                                        }
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)("tbody", {
                            children: [
                                marginAccounts.map((p)=>/*#__PURE__*/ (0, $bbzbN.jsxs)("tr", {
                                        className: "group cursor-pointer transition-colors hover:bg-[rgba(229,0,37,0.04)]",
                                        onClick: ()=>navigate(`/portfolio/${p.portfolio_id_lig}`),
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdMono}`,
                                                children: p.portfolio_id_lig
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdClient}`,
                                                children: p.client_name || "\u2014"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$de784d3a9b38c570), {
                                                    status: p.status
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$a2aeb90e6df6bf5a), {
                                                    value: p.surplus_cushion
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$a2aeb90e6df6bf5a), {
                                                    value: p.surplus_cushion_with_cash,
                                                    status: p.status
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$de784d3a9b38c570), {
                                                    variant: p.is_margin_trading ? 'solid-warn' : 'neutral',
                                                    label: p.is_margin_trading ? 'Yes' : 'No'
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                                children: (0, $e4bf7e7a647cb901$export$217e472da3f6c211)(p.total_aum)
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                                children: (0, $e4bf7e7a647cb901$export$217e472da3f6c211)(p.margin_account_equity)
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                                children: (0, $e4bf7e7a647cb901$export$217e472da3f6c211)(p.pershing_requirement)
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                                children: (0, $e4bf7e7a647cb901$export$217e472da3f6c211)(p.lc_margin_requirement)
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                children: p.rm_name || "\u2014"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                style: {
                                                    textAlign: 'center'
                                                },
                                                onClick: (e)=>e.stopPropagation(),
                                                children: /*#__PURE__*/ (0, $bbzbN.jsxs)("button", {
                                                    className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).iconBtn,
                                                    onClick: ()=>{
                                                        setSelectedPortfolio(p);
                                                        setCommentsSidebarOpen(true);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                                            name: "comments",
                                                            size: 16
                                                        }),
                                                        getCommentCount(p.portfolio_id_lig) > 0 && /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).badgeNum,
                                                            children: getCommentCount(p.portfolio_id_lig)
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                style: {
                                                    textAlign: 'right'
                                                },
                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                                    name: "arrow",
                                                    size: 14,
                                                    className: "text-[#7A7A76] transition-all group-hover:text-[#E50025] group-hover:translate-x-0.5"
                                                })
                                            })
                                        ]
                                    }, p.portfolio_id_lig)),
                                marginAccounts.length === 0 && /*#__PURE__*/ (0, $bbzbN.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                        colSpan: 13,
                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).muted}`,
                                        style: {
                                            padding: 30,
                                            textAlign: 'center'
                                        },
                                        children: "No margin accounts found."
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).sectionTitle,
                style: {
                    marginTop: 32
                },
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("h2", {
                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).sectionH2,
                        children: "Portfolios with Cash Account Only"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).sectionCount,
                        children: [
                            cashAccounts.length,
                            " portfolios"
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).sectionRule
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tableWrap,
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)("table", {
                    className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).table,
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                        style: {
                                            width: '11%'
                                        },
                                        children: "Portfolio ID"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$f8f69345c94a0646), {
                                        label: "Client Name",
                                        field: "client_name",
                                        active: cashSortField === 'client_name',
                                        dir: cashSortDir,
                                        onClick: onCashSort
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$f8f69345c94a0646), {
                                        label: "Total AUM",
                                        field: "total_aum",
                                        active: cashSortField === 'total_aum',
                                        dir: cashSortDir,
                                        onClick: onCashSort,
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$f8f69345c94a0646), {
                                        label: "Cash Equity",
                                        field: "cash_account_equity",
                                        active: cashSortField === 'cash_account_equity',
                                        dir: cashSortDir,
                                        onClick: onCashSort,
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                        children: "Cash & Equiv."
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                        children: "RM"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                        style: {
                                            textAlign: 'center'
                                        },
                                        children: "Comments"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                        style: {
                                            width: 40
                                        }
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)("tbody", {
                            children: [
                                cashAccounts.map((p)=>/*#__PURE__*/ (0, $bbzbN.jsxs)("tr", {
                                        className: "group cursor-pointer transition-colors hover:bg-[rgba(229,0,37,0.04)]",
                                        onClick: ()=>navigate(`/portfolio/${p.portfolio_id_lig}`),
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdMono}`,
                                                children: p.portfolio_id_lig
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdClient}`,
                                                children: p.client_name || "\u2014"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                                children: (0, $e4bf7e7a647cb901$export$217e472da3f6c211)(p.total_aum)
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                                children: (0, $e4bf7e7a647cb901$export$217e472da3f6c211)(p.cash_account_equity)
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                                children: (0, $e4bf7e7a647cb901$export$217e472da3f6c211)(p.cash_and_cash_equivalent)
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                children: p.rm_name || "\u2014"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                style: {
                                                    textAlign: 'center'
                                                },
                                                onClick: (e)=>e.stopPropagation(),
                                                children: /*#__PURE__*/ (0, $bbzbN.jsxs)("button", {
                                                    className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).iconBtn,
                                                    onClick: ()=>{
                                                        setSelectedPortfolio(p);
                                                        setCommentsSidebarOpen(true);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                                            name: "comments",
                                                            size: 16
                                                        }),
                                                        getCommentCount(p.portfolio_id_lig) > 0 && /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).badgeNum,
                                                            children: getCommentCount(p.portfolio_id_lig)
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                style: {
                                                    textAlign: 'right'
                                                },
                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                                    name: "arrow",
                                                    size: 14,
                                                    className: "text-[#7A7A76] transition-all group-hover:text-[#E50025] group-hover:translate-x-0.5"
                                                })
                                            })
                                        ]
                                    }, p.portfolio_id_lig)),
                                cashAccounts.length === 0 && /*#__PURE__*/ (0, $bbzbN.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                        colSpan: 8,
                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).muted}`,
                                        style: {
                                            padding: 30,
                                            textAlign: 'center'
                                        },
                                        children: "No cash-only accounts found."
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            commentsSidebarOpen && selectedPortfolio && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d0fd084ff87c43f3$export$2e2bcd8739ae039), {
                portfolio: selectedPortfolio,
                onClose: ()=>{
                    setCommentsSidebarOpen(false);
                    setSelectedPortfolio(null);
                }
            })
        ]
    });
};
var $4d3334a83e1f9fa9$export$2e2bcd8739ae039 = $4d3334a83e1f9fa9$var$Dashboard;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");




const $27e49bc84ecf2fec$var$PortfolioDetail = ()=>{
    const { portfolioId: portfolioId } = (0, $d9fd026bfea79ab9$export$99eaa27ddbbb95ef)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const [search, setSearch] = (0, $7fPBF.useState)('');
    const [secType, setSecType] = (0, $7fPBF.useState)('ALL');
    const [sortField, setSortField] = (0, $7fPBF.useState)('weight');
    const [sortDir, setSortDir] = (0, $7fPBF.useState)('desc');
    const [portfolio, setPortfolio] = (0, $7fPBF.useState)(null);
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const fetch = (0, $7fPBF.useCallback)(async ()=>{
        if (!portfolioId) return;
        setLoading(true);
        setError(null);
        try {
            const p = await (0, $2b61471e8e825f6c$export$2e2bcd8739ae039).getPortfolioDetail(portfolioId);
            setPortfolio(p);
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Failed to fetch portfolio');
        } finally{
            setLoading(false);
        }
    }, [
        portfolioId
    ]);
    (0, $7fPBF.useEffect)(()=>{
        fetch();
    }, [
        fetch
    ]);
    const onSort = (f)=>{
        const field = f;
        if (sortField === field) setSortDir((d)=>d === 'asc' ? 'desc' : 'asc');
        else {
            setSortField(field);
            setSortDir('desc');
        }
    };
    const positions = (0, $7fPBF.useMemo)(()=>{
        if (!portfolio) return [];
        let arr = portfolio.positions.filter((x)=>{
            if (secType !== 'ALL' && x.security_type !== secType) return false;
            if (search) {
                const q = search.toLowerCase();
                return [
                    x.security_name,
                    x.cusip,
                    x.security_type,
                    x.ticker
                ].some((s)=>(s || '').toLowerCase().includes(q));
            }
            return true;
        });
        arr.sort((a, b)=>{
            const av = a[sortField] ?? 0, bv = b[sortField] ?? 0;
            if (av < bv) return sortDir === 'asc' ? -1 : 1;
            if (av > bv) return sortDir === 'asc' ? 1 : -1;
            return 0;
        });
        return arr;
    }, [
        portfolio?.positions,
        search,
        secType,
        sortField,
        sortDir
    ]);
    const breakdown = (0, $7fPBF.useMemo)(()=>{
        if (!portfolio) return [];
        const map = {};
        portfolio.positions.forEach((pos)=>{
            const k = pos.security_type || 'OTHER';
            if (!map[k]) map[k] = {
                type: k,
                mv: 0,
                count: 0
            };
            map[k].mv += pos.market_value || 0;
            map[k].count++;
        });
        const total = Object.values(map).reduce((s, v)=>s + v.mv, 0);
        return Object.values(map).map((v)=>({
                ...v,
                weight: total > 0 ? v.mv / total : 0
            })).sort((a, b)=>b.mv - a.mv);
    }, [
        portfolio?.positions
    ]);
    const secTypes = (0, $7fPBF.useMemo)(()=>Array.from(new Set(portfolio?.positions.map((x)=>x.security_type).filter(Boolean))), [
        portfolio?.positions
    ]);
    if (loading) return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).page} flex items-center justify-center min-h-[400px] flex-col gap-4`,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).muted,
            children: "Loading portfolio\u2026"
        })
    });
    if (error || !portfolio) return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).page,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "bg-[rgba(229,0,37,0.06)] border border-[#E50025] px-[22px] py-[18px] mb-4",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "font-bold text-[#E50025] text-[12px] tracking-[0.12em] uppercase mb-1.5",
                        children: "Error"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        style: {
                            fontSize: 13
                        },
                        children: error || 'Portfolio not found'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                variant: "primary",
                size: "sm",
                onClick: fetch,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                        name: "refresh",
                        size: 12
                    }),
                    " Retry"
                ]
            })
        ]
    });
    const p = portfolio;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).page,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "flex items-end justify-between gap-6 mb-[22px] max-[768px]:flex-col max-[768px]:items-start max-[768px]:gap-3",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                className: "text-[10px] tracking-[0.16em] uppercase text-[#7A7A76] mb-1.5",
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("a", {
                                        href: "#",
                                        className: "text-inherit hover:text-[#E50025] hover:no-underline",
                                        onClick: (e)=>{
                                            e.preventDefault();
                                            navigate('/');
                                        },
                                        children: "Dashboard"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                        className: "mx-1.5",
                                        children: "\u203A"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                        children: "Portfolio Detail"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("h1", {
                                className: "font-serif text-[36px] font-normal tracking-[-0.015em] leading-tight m-0 max-[480px]:text-[24px]",
                                children: p.client_name
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                className: "text-[#7A7A76] mt-1.5 text-[12.5px]",
                                children: [
                                    "Portfolio ID: ",
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                        className: "",
                                        children: p.portfolio_id_lig
                                    }),
                                    p.rm_name && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                                        children: [
                                            "\xa0\xb7\xa0 RM: ",
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                className: "",
                                                children: p.rm_name
                                            })
                                        ]
                                    }),
                                    p.ic_name && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                                        children: [
                                            "\xa0\xb7\xa0 IC: ",
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                className: "",
                                                children: p.ic_name
                                            })
                                        ]
                                    }),
                                    p.platform && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                                        children: [
                                            "\xa0\xb7\xa0 ",
                                            p.platform
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "flex gap-2.5 max-[768px]:self-end",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                                variant: "outline",
                                size: "sm",
                                onClick: ()=>navigate('/'),
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                        name: "back",
                                        size: 12
                                    }),
                                    " Back"
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                                variant: "primary",
                                size: "sm",
                                onClick: fetch,
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                        name: "refresh",
                                        size: 12
                                    }),
                                    " Refresh"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "grid grid-cols-2 gap-4 mb-4 max-[768px]:grid-cols-1",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).surface} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).surfacePad}`,
                        children: p.has_margin_account ? /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                    className: "flex items-center gap-3 mb-4",
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$de784d3a9b38c570), {
                                            status: p.status,
                                            label: `Margin Status \u{2014} ${(0, $e4bf7e7a647cb901$export$a1176940376eb77f)[p.status?.toUpperCase().replace(/ /g, '_') || ''] || p.status || "\u2014"}`
                                        }),
                                        p.is_margin_trading && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$de784d3a9b38c570), {
                                            variant: "solid-warn",
                                            label: "Active Margin Trading"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                    className: "mb-3.5",
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).eyebrow,
                                            children: "Surplus Cushion"
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                            className: "mt-2",
                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$a2aeb90e6df6bf5a), {
                                                value: p.surplus_cushion,
                                                status: p.status,
                                                big: true
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                    className: "mb-[18px]",
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).eyebrow,
                                            children: "With Cash & Equivalents"
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                            className: "mt-2",
                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$a2aeb90e6df6bf5a), {
                                                value: p.surplus_cushion_with_cash,
                                                status: p.status,
                                                big: true
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                    className: "grid grid-cols-2 gap-[18px_28px]",
                                    children: [
                                        [
                                            'Total AUM',
                                            (0, $e4bf7e7a647cb901$export$217e472da3f6c211)(p.total_aum)
                                        ],
                                        [
                                            'Margin Equity',
                                            (0, $e4bf7e7a647cb901$export$217e472da3f6c211)(p.margin_account_equity)
                                        ],
                                        [
                                            'Pershing Req.',
                                            (0, $e4bf7e7a647cb901$export$217e472da3f6c211)(p.pershing_requirement)
                                        ],
                                        [
                                            'LC Margin Req.',
                                            (0, $e4bf7e7a647cb901$export$217e472da3f6c211)(p.lc_margin_requirement)
                                        ],
                                        [
                                            'Available Margin',
                                            (0, $e4bf7e7a647cb901$export$217e472da3f6c211)((p.total_aum || 0) - (p.lc_margin_requirement || 0))
                                        ],
                                        [
                                            'Cash & Equiv.',
                                            (0, $e4bf7e7a647cb901$export$217e472da3f6c211)(p.cash_and_cash_equivalent)
                                        ]
                                    ].map(([lbl, val])=>/*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                    className: "text-[10px] font-bold tracking-[0.14em] uppercase text-[#7A7A76]",
                                                    children: lbl
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                    className: "font-serif text-[22px] font-normal mt-1 tracking-[-0.005em]",
                                                    children: val
                                                })
                                            ]
                                        }, lbl))
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$de784d3a9b38c570), {
                                    variant: "success",
                                    label: "Cash-Only Account"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                    className: "grid grid-cols-2 gap-[18px_28px] mt-[18px]",
                                    children: [
                                        [
                                            'Total AUM',
                                            (0, $e4bf7e7a647cb901$export$217e472da3f6c211)(p.total_aum)
                                        ],
                                        [
                                            'Cash Equity',
                                            (0, $e4bf7e7a647cb901$export$217e472da3f6c211)(p.cash_account_equity)
                                        ],
                                        [
                                            'Cash & Equiv.',
                                            (0, $e4bf7e7a647cb901$export$217e472da3f6c211)(p.cash_and_cash_equivalent)
                                        ],
                                        [
                                            'Positions',
                                            String(p.positions.length)
                                        ]
                                    ].map(([lbl, val])=>/*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                    className: "text-[10px] font-bold tracking-[0.14em] uppercase text-[#7A7A76]",
                                                    children: lbl
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                    className: "font-serif text-[22px] font-normal mt-1 tracking-[-0.005em]",
                                                    children: val
                                                })
                                            ]
                                        }, lbl))
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).surface} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).surfacePad}`,
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).eyebrow} text-[#E50025]`,
                                children: "Team & Account"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "grid grid-cols-2 gap-[18px_28px] mt-2",
                                children: [
                                    [
                                        'Relationship Manager',
                                        p.rm_name || "\u2014"
                                    ],
                                    [
                                        'Investment Counselor',
                                        p.ic_name || "\u2014"
                                    ],
                                    [
                                        'Platform',
                                        p.platform || "\u2014"
                                    ],
                                    [
                                        'Risk Score',
                                        p.risk_score ? p.risk_score.charAt(0).toUpperCase() + p.risk_score.slice(1).toLowerCase() : "\u2014"
                                    ],
                                    [
                                        'Positions',
                                        String(p.positions.length)
                                    ],
                                    [
                                        'Last Updated',
                                        p.last_updated ? new Date(p.last_updated).toLocaleString() : "\u2014"
                                    ]
                                ].map(([lbl, val])=>/*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                className: "text-[10px] font-bold tracking-[0.14em] uppercase text-[#7A7A76]",
                                                children: lbl
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                className: "text-[22px] font-serif font-normal mt-1 tracking-[-0.005em]",
                                                children: val
                                            })
                                        ]
                                    }, lbl))
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("hr", {
                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).hr
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).eyebrow,
                                children: "Breakdown by Asset Class"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "mt-2.5",
                                children: breakdown.map((b)=>/*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                        className: "grid items-center py-2 border-b border-black/[0.05]",
                                        style: {
                                            gridTemplateColumns: '120px 1fr 80px 100px'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                className: "text-[11px] font-bold tracking-[0.06em] uppercase",
                                                children: b.type
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                className: "h-1.5 bg-black/[0.06] relative",
                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                    className: "absolute inset-0 bg-[#E50025]",
                                                    style: {
                                                        width: `${b.weight * 100}%`
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                                                className: "text-right text-[12px] text-[#7A7A76]",
                                                children: [
                                                    (b.weight * 100).toFixed(1),
                                                    "%"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                className: "text-right text-[12px] font-semibold",
                                                children: (0, $e4bf7e7a647cb901$export$217e472da3f6c211)(b.mv)
                                            })
                                        ]
                                    }, b.type))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).sectionTitle,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("h2", {
                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).sectionH2,
                        children: "Portfolio Positions"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).sectionCount,
                        children: [
                            positions.length,
                            " of ",
                            p.positions.length
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).sectionRule
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).surface} p-[14px_16px] mb-3.5 grid [grid-template-columns:2fr_1fr] gap-3`,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).field,
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("label", {
                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).fieldLabel,
                                children: "Search"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).inputWrap,
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                        name: "search",
                                        size: 14,
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).inputIco
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input} pl-[38px]`,
                                        placeholder: "Security name, CUSIP, ticker\u2026",
                                        value: search,
                                        onChange: (e)=>setSearch(e.target.value)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).field,
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("label", {
                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).fieldLabel,
                                children: "Security Type"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("select", {
                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input,
                                value: secType,
                                onChange: (e)=>setSecType(e.target.value),
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                        value: "ALL",
                                        children: "All types"
                                    }),
                                    secTypes.map((t)=>/*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                            children: t
                                        }, t))
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tableWrap,
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)("table", {
                    className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).table,
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                        style: {
                                            width: 110
                                        },
                                        children: "CUSIP"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$f8f69345c94a0646), {
                                        label: "Security",
                                        field: "security_name",
                                        active: sortField === 'security_name',
                                        dir: sortDir,
                                        onClick: onSort
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                        children: "Type"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$f8f69345c94a0646), {
                                        label: "Account",
                                        field: "account_type",
                                        active: sortField === 'account_type',
                                        dir: sortDir,
                                        onClick: onSort
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                        children: "Quantity"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                        children: "Price"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$f8f69345c94a0646), {
                                        label: "Market Value",
                                        field: "market_value",
                                        active: sortField === 'market_value',
                                        dir: sortDir,
                                        onClick: onSort,
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$f8f69345c94a0646), {
                                        label: "Weight",
                                        field: "weight",
                                        active: sortField === 'weight',
                                        dir: sortDir,
                                        onClick: onSort,
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$f8f69345c94a0646), {
                                        label: "Pershing Req.",
                                        field: "pershing_requirement",
                                        active: sortField === 'pershing_requirement',
                                        dir: sortDir,
                                        onClick: onSort,
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                        children: "LC Add-on"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$f8f69345c94a0646), {
                                        label: "LC Req.",
                                        field: "position_lc_margin_requirement",
                                        active: sortField === 'position_lc_margin_requirement',
                                        dir: sortDir,
                                        onClick: onSort,
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)("tbody", {
                            children: [
                                positions.map((x, i)=>/*#__PURE__*/ (0, $bbzbN.jsxs)("tr", {
                                        className: "transition-colors hover:bg-[#FAF9F8]",
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdMono}`,
                                                children: x.cusip || "\u2014"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsxs)("td", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                children: [
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                        className: "font-medium",
                                                        children: x.security_name || "\u2014"
                                                    }),
                                                    x.ticker && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdMono} text-[10px] ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).muted}`,
                                                        children: x.ticker
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$de784d3a9b38c570), {
                                                    variant: "outline",
                                                    label: x.security_type || "\u2014"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                children: x.account_type || "\u2014"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                                children: (0, $e4bf7e7a647cb901$export$79b4d5b1a469ce61)(x.quantity)
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                                children: (0, $e4bf7e7a647cb901$export$50c3903b2324c92f)(x.market_price)
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                                children: (0, $e4bf7e7a647cb901$export$217e472da3f6c211)(x.market_value)
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                                children: x.weight != null ? `${(x.weight * 100).toFixed(2)}%` : "\u2014"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                                children: (0, $e4bf7e7a647cb901$export$217e472da3f6c211)(x.pershing_requirement)
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum} text-[#E50025]`,
                                                children: x.lc_addon != null ? `${(x.lc_addon * 100).toFixed(1)}%` : "\u2014"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum} font-semibold text-[#E50025]`,
                                                children: (0, $e4bf7e7a647cb901$export$217e472da3f6c211)(x.position_lc_margin_requirement)
                                            })
                                        ]
                                    }, (x.cusip || '') + i)),
                                positions.length === 0 && /*#__PURE__*/ (0, $bbzbN.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                        colSpan: 11,
                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).muted}`,
                                        style: {
                                            padding: 30,
                                            textAlign: 'center'
                                        },
                                        children: "No positions match."
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $27e49bc84ecf2fec$export$2e2bcd8739ae039 = $27e49bc84ecf2fec$var$PortfolioDetail;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");
// Admin configuration types for margin thresholds and rules
const $0cb5891b02835d37$export$b555d33f86028caa = {
    assetTypeAddOns: {
        largeCap: 5,
        midCap: 10,
        smallCap: 15,
        volatile: 20,
        pennyStocks: 100,
        etfs: 5,
        bonds: 5,
        mutualFunds: 5,
        options: 5,
        other: 5 // +5% add-on for other marginable securities
    },
    marketCapDefinitions: {
        largeCap: 10000000000,
        midCap: 2000000000,
        smallCap: 2000000000 // Below $2B is small cap
    },
    volatilityThresholds: {
        volatileStock: 40,
        pennyStock: 5 // $5 price threshold
    },
    concentrationAddOns: {
        singlePosition30Percent: 10,
        singlePosition50Percent: 20,
        top3Positions70Percent: 10 // +10% for top 3 positions >70% (applied to concentrated positions >20%)
    },
    warningThresholds: {
        greenZone: 30,
        amberAlertZone: 20,
        redAlertZone: 10,
        criticalZone: 10 // ≤10% surplus cushion
    },
    lastUpdated: new Date(),
    updatedBy: 'system'
};





var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");


const $52a3fcb397c31455$export$2b77a92f1a5ad772 = ({ open: open, onClose: onClose, title: title, children: children, footer: footer, size: size = 'md' })=>{
    if (!open) return null;
    const w = size === 'sm' ? 'max-w-[480px]' : size === 'lg' ? 'max-w-[720px]' : 'max-w-[560px]';
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: "fixed inset-0 bg-black/[0.36] z-[300] flex items-center justify-center p-4",
        onClick: onClose,
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
            className: `bg-white w-full ${w} max-h-[90vh] flex flex-col shadow-xl`,
            onClick: (e)=>e.stopPropagation(),
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    className: "flex items-center justify-between px-5 py-4 border-b border-black/[0.08] shrink-0",
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)("h3", {
                            className: "font-semibold text-[15px] m-0 leading-snug",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).iconBtn,
                            onClick: onClose,
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                name: "close",
                                size: 14
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    className: "flex-1 overflow-y-auto px-5 py-4",
                    children: children
                }),
                footer && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                    className: "border-t border-black/[0.08] px-5 py-3.5 flex justify-end gap-2 shrink-0",
                    children: footer
                })
            ]
        })
    });
};
const $52a3fcb397c31455$var$BANNER_STYLE = {
    error: {
        bg: 'rgba(229,0,37,0.06)',
        border: 'rgba(229,0,37,0.30)',
        color: '#E50025',
        icon: 'error'
    },
    success: {
        bg: 'rgba(31,138,74,0.08)',
        border: 'rgba(31,138,74,0.28)',
        color: '#1f8a4a',
        icon: 'check'
    },
    info: {
        bg: 'rgba(100,100,230,0.06)',
        border: 'rgba(100,100,230,0.22)',
        color: '#4444b0',
        icon: 'error'
    },
    warn: {
        bg: 'rgba(255,191,0,0.10)',
        border: 'rgba(182,119,11,0.28)',
        color: '#b6770b',
        icon: 'warn'
    }
};
const $52a3fcb397c31455$export$3b4e64e77073e307 = ({ variant: variant, children: children, onClose: onClose, className: className = 'mb-3' })=>{
    const s = $52a3fcb397c31455$var$BANNER_STYLE[variant];
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: `flex items-start gap-2.5 px-4 py-3 text-[12.5px] leading-relaxed ${className}`,
        style: {
            background: s.bg,
            border: `1px solid ${s.border}`,
            color: s.color
        },
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                name: s.icon,
                size: 14,
                className: "shrink-0 mt-0.5"
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "flex-1",
                children: children
            }),
            onClose && /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                className: "bg-transparent border-0 cursor-pointer p-0 text-inherit ml-1 shrink-0 opacity-60 hover:opacity-100",
                onClick: onClose,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                    name: "close",
                    size: 12
                })
            })
        ]
    });
};
const $52a3fcb397c31455$export$5720c1871db44880 = ({ active: active, activeLabel: activeLabel = 'Active', inactiveLabel: inactiveLabel = 'Inactive' })=>/*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
        className: `inline-flex items-center gap-1.5 px-[7px] py-[2px] text-[9.5px] font-bold tracking-[0.06em] uppercase whitespace-nowrap ${active ? 'text-[#1f8a4a] bg-[rgba(31,138,74,0.10)]' : 'text-[#7A7A76] bg-black/[0.06]'}`,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                className: "w-1.5 h-1.5 rounded-full bg-current"
            }),
            active ? activeLabel : inactiveLabel
        ]
    });
const $52a3fcb397c31455$export$b061d3bc5141c982 = ({ role: role })=>{
    const color = role === 'admin' ? '#E50025' : role === 'super' ? '#b6770b' : '#6464E6';
    const bg = role === 'admin' ? 'rgba(229,0,37,0.08)' : role === 'super' ? 'rgba(255,191,0,0.12)' : 'rgba(100,100,230,0.08)';
    return /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
        style: {
            color: color,
            background: bg,
            border: `1px solid ${color}33`
        },
        className: "inline-flex items-center px-[7px] py-[2px] text-[9.5px] font-bold tracking-[0.08em] uppercase rounded-full whitespace-nowrap",
        children: role
    });
};
const $52a3fcb397c31455$export$56e87bf42978147a = ({ label: label, required: required, error: error, hint: hint, children: children })=>/*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "flex flex-col gap-1",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("label", {
                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).fieldLabel,
                children: [
                    label,
                    required && /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        className: "text-[#E50025] ml-0.5",
                        children: "*"
                    })
                ]
            }),
            children,
            error && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "text-[11px] text-[#E50025] mt-0.5",
                children: error
            }),
            !error && hint && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "text-[11px] text-[#7A7A76] mt-0.5",
                children: hint
            })
        ]
    });
const $52a3fcb397c31455$export$68f5e1453c188a82 = ({ page: page, pageSize: pageSize, total: total, onChange: onChange })=>{
    const totalPages = Math.max(1, Math.ceil(total / pageSize));
    const from = total === 0 ? 0 : page * pageSize + 1;
    const to = Math.min((page + 1) * pageSize, total);
    const btnCls = 'px-3 py-1.5 text-[11.5px] font-semibold border border-black/[0.16] bg-white text-[#333] cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed hover:bg-[#FAF9F8] transition-colors';
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "flex items-center justify-between px-4 py-2.5 border-t border-black/[0.06] bg-white",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "flex items-center gap-2 text-[12px] text-[#7A7A76]",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        children: "Rows per page:"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("select", {
                        className: "text-[12px] border border-black/[0.16] bg-white px-2 py-1 text-[#333] focus:outline-none focus:border-[#E50025]",
                        value: pageSize,
                        onChange: (e)=>onChange(0, Number(e.target.value)),
                        children: [
                            10,
                            25,
                            50,
                            100
                        ].map((s)=>/*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                value: s,
                                children: s
                            }, s))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "flex items-center gap-3 text-[12px] text-[#7A7A76]",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                        children: [
                            from,
                            "\u2013",
                            to,
                            " of ",
                            total
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "flex gap-1",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                                className: btnCls,
                                disabled: page === 0,
                                onClick: ()=>onChange(page - 1, pageSize),
                                children: "\u2039 Prev"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                                className: btnCls,
                                disabled: page >= totalPages - 1,
                                onClick: ()=>onChange(page + 1, pageSize),
                                children: "Next \u203A"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const $52a3fcb397c31455$export$4c260019440d418f = ({ children: children })=>/*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: "flex flex-wrap items-center gap-2 mb-4",
        children: children
    });
const $52a3fcb397c31455$export$ca183fc7c8e0e04a = ({ value: value, onChange: onChange, placeholder: placeholder = "Search\u2026" })=>/*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "relative w-[280px]",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                name: "search",
                size: 14,
                className: "absolute left-3.5 top-1/2 -translate-y-1/2 text-[#7A7A76] pointer-events-none"
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                className: "font-[inherit] text-[13px] font-light pl-[38px] pr-3 py-[7px] border border-black/[0.16] bg-white text-black transition-colors w-full rounded-none focus:outline-none focus:border-[#E50025]",
                placeholder: placeholder,
                value: value,
                onChange: (e)=>onChange(e.target.value)
            })
        ]
    });
const $52a3fcb397c31455$export$12d9e482a4de9a59 = ({ value: value, onChange: onChange, options: options, placeholder: placeholder })=>/*#__PURE__*/ (0, $bbzbN.jsxs)("select", {
        className: "font-[inherit] text-[13px] font-light px-3 py-[7px] border border-black/[0.16] bg-white text-black transition-colors rounded-none focus:outline-none focus:border-[#E50025] min-w-[140px]",
        value: value,
        onChange: (e)=>onChange(e.target.value),
        children: [
            placeholder && /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                value: "",
                children: placeholder
            }),
            options.map((o)=>/*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                    value: o.value,
                    children: o.label
                }, o.value))
        ]
    });
const $52a3fcb397c31455$export$d5de21f9becf2375 = ()=>/*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: "flex-1"
    });






var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");



const $8d00e4fd6941735d$var$ROLE_HINTS = {
    admin: 'Full access to all operations',
    super: 'Can view all data but cannot modify',
    normal: 'Standard user access'
};
const $8d00e4fd6941735d$var$EMPTY = {
    email: '',
    first_name: '',
    last_name: '',
    role: 'normal',
    user_type: 'RM',
    password: '',
    source_user_id: ''
};
const $8d00e4fd6941735d$var$UserCreateDialog = ({ open: open, onClose: onClose, onSuccess: onSuccess })=>{
    const [formData, setFormData] = (0, $7fPBF.useState)($8d00e4fd6941735d$var$EMPTY);
    const [errors, setErrors] = (0, $7fPBF.useState)({});
    const [showPassword, setShowPassword] = (0, $7fPBF.useState)(false);
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [apiError, setApiError] = (0, $7fPBF.useState)(null);
    const validateEmail = (v)=>{
        if (!v) return 'Email is required';
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) return 'Invalid email format';
    };
    const validatePassword = (v)=>{
        if (!v) return 'Password is required';
        if (v.length < 8) return 'Password must be at least 8 characters';
        if (!/[A-Z]/.test(v)) return 'Password must contain at least one uppercase letter';
        if (!/[a-z]/.test(v)) return 'Password must contain at least one lowercase letter';
        if (!/[0-9]/.test(v)) return 'Password must contain at least one digit';
    };
    const validate = ()=>{
        const e = {};
        const emailErr = validateEmail(formData.email);
        if (emailErr) e.email = emailErr;
        if (!formData.first_name.trim()) e.first_name = 'First name is required';
        if (!formData.last_name.trim()) e.last_name = 'Last name is required';
        const pwErr = validatePassword(formData.password);
        if (pwErr) e.password = pwErr;
        setErrors(e);
        return !Object.keys(e).length;
    };
    const reset = ()=>{
        setFormData($8d00e4fd6941735d$var$EMPTY);
        setErrors({});
        setApiError(null);
    };
    const handleSubmit = async ()=>{
        if (!validate()) return;
        setLoading(true);
        setApiError(null);
        try {
            const payload = {
                email: formData.email.trim(),
                first_name: formData.first_name.trim(),
                last_name: formData.last_name.trim(),
                role: formData.role,
                user_type: formData.user_type,
                password: formData.password
            };
            if (formData.source_user_id.trim()) payload.source_user_id = formData.source_user_id.trim();
            await (0, $2b61471e8e825f6c$export$2e2bcd8739ae039).createUser(payload);
            reset();
            onSuccess();
            onClose();
        } catch (err) {
            setApiError(err.message || 'Failed to create user');
        } finally{
            setLoading(false);
        }
    };
    const handleClose = ()=>{
        if (!loading) {
            reset();
            onClose();
        }
    };
    const set = (field)=>(e)=>{
            setFormData((prev)=>({
                    ...prev,
                    [field]: e.target.value
                }));
            if (errors[field]) setErrors((prev)=>{
                const n = {
                    ...prev
                };
                delete n[field];
                return n;
            });
        };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $52a3fcb397c31455$export$2b77a92f1a5ad772), {
        open: open,
        onClose: handleClose,
        title: "Create New User",
        size: "md",
        footer: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                    variant: "outline",
                    size: "sm",
                    onClick: handleClose,
                    disabled: loading,
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                    variant: "primary",
                    size: "sm",
                    onClick: handleSubmit,
                    disabled: loading,
                    children: loading ? "Creating\u2026" : 'Create User'
                })
            ]
        }),
        children: [
            apiError && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$3b4e64e77073e307), {
                variant: "error",
                onClose: ()=>setApiError(null),
                className: "mb-4",
                children: apiError
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "flex flex-col gap-3.5",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$56e87bf42978147a), {
                        label: "Email",
                        required: true,
                        error: errors.email,
                        hint: "User will log in with this email",
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input,
                            type: "email",
                            value: formData.email,
                            onChange: set('email'),
                            disabled: loading
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "grid grid-cols-2 gap-3",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$56e87bf42978147a), {
                                label: "First Name",
                                required: true,
                                error: errors.first_name,
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                                    className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input,
                                    value: formData.first_name,
                                    onChange: set('first_name'),
                                    disabled: loading
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$56e87bf42978147a), {
                                label: "Last Name",
                                required: true,
                                error: errors.last_name,
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                                    className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input,
                                    value: formData.last_name,
                                    onChange: set('last_name'),
                                    disabled: loading
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$56e87bf42978147a), {
                        label: "Password",
                        required: true,
                        error: errors.password,
                        hint: "Min 8 chars, 1 uppercase, 1 lowercase, 1 digit",
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                            className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).inputWrap} flex items-center`,
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                                    className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input} pr-[38px]`,
                                    type: showPassword ? 'text' : 'password',
                                    value: formData.password,
                                    onChange: set('password'),
                                    disabled: loading
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                                    type: "button",
                                    className: "absolute right-2.5 top-1/2 -translate-y-1/2 bg-transparent border-0 cursor-pointer p-0 text-[#7A7A76] hover:text-[#333]",
                                    onClick: ()=>setShowPassword((v)=>!v),
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                        name: showPassword ? 'eye-off' : 'eye',
                                        size: 15
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$56e87bf42978147a), {
                        label: "Role",
                        required: true,
                        hint: $8d00e4fd6941735d$var$ROLE_HINTS[formData.role],
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("select", {
                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input,
                            value: formData.role,
                            onChange: set('role'),
                            disabled: loading,
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                    value: "normal",
                                    children: "Normal"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                    value: "super",
                                    children: "Super (Read-only)"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                    value: "admin",
                                    children: "Admin (Full Access)"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$56e87bf42978147a), {
                        label: "User Type",
                        required: true,
                        hint: "Determines portfolio access permissions",
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("select", {
                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input,
                            value: formData.user_type,
                            onChange: set('user_type'),
                            disabled: loading,
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                    value: "RM",
                                    children: "RM (Relationship Manager)"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                    value: "IC",
                                    children: "IC (Investment Counselor)"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                    value: "ARM",
                                    children: "ARM (Assistant RM)"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                    value: "ADMIN",
                                    children: "ADMIN"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                    value: "SUPER",
                                    children: "SUPER"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                    value: "COMPLIANCE",
                                    children: "COMPLIANCE"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                    value: "OPS",
                                    children: "OPS"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$56e87bf42978147a), {
                        label: "Source User ID",
                        hint: "Links to upstream system user_access_info.user_id",
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input,
                            value: formData.source_user_id,
                            onChange: set('source_user_id'),
                            disabled: loading
                        })
                    })
                ]
            })
        ]
    });
};
var $8d00e4fd6941735d$export$2e2bcd8739ae039 = $8d00e4fd6941735d$var$UserCreateDialog;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");



const $5cfb3a1471fc9b43$var$ROLE_HINTS = {
    admin: 'Full access to all operations',
    super: 'Can view all data but cannot modify',
    normal: 'Standard user access'
};
const $5cfb3a1471fc9b43$var$UserEditDialog = ({ open: open, user: user, onClose: onClose, onSuccess: onSuccess })=>{
    const [formData, setFormData] = (0, $7fPBF.useState)({
        first_name: '',
        last_name: '',
        role: 'normal',
        user_type: 'RM',
        is_active: true,
        source_user_id: ''
    });
    const [errors, setErrors] = (0, $7fPBF.useState)({});
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [apiError, setApiError] = (0, $7fPBF.useState)(null);
    (0, $7fPBF.useEffect)(()=>{
        if (user) {
            setFormData({
                first_name: user.first_name || '',
                last_name: user.last_name || '',
                role: user.role,
                user_type: user.user_type,
                is_active: user.is_active,
                source_user_id: user.source_user_id || ''
            });
            setErrors({});
            setApiError(null);
        }
    }, [
        user
    ]);
    const validate = ()=>{
        const e = {};
        if (!formData.first_name.trim()) e.first_name = 'First name is required';
        if (!formData.last_name.trim()) e.last_name = 'Last name is required';
        setErrors(e);
        return !Object.keys(e).length;
    };
    const handleSubmit = async ()=>{
        if (!user || !validate()) return;
        setLoading(true);
        setApiError(null);
        try {
            const payload = {
                first_name: formData.first_name.trim(),
                last_name: formData.last_name.trim(),
                role: formData.role,
                user_type: formData.user_type,
                is_active: formData.is_active
            };
            if (formData.source_user_id.trim()) payload.source_user_id = formData.source_user_id.trim();
            await (0, $2b61471e8e825f6c$export$2e2bcd8739ae039).updateUser(user.id, payload);
            onSuccess();
            onClose();
        } catch (err) {
            setApiError(err.message || 'Failed to update user');
        } finally{
            setLoading(false);
        }
    };
    const handleClose = ()=>{
        if (!loading) {
            setErrors({});
            setApiError(null);
            onClose();
        }
    };
    const setField = (field)=>(e)=>{
            setFormData((prev)=>({
                    ...prev,
                    [field]: e.target.value
                }));
            if (errors[field]) setErrors((prev)=>{
                const n = {
                    ...prev
                };
                delete n[field];
                return n;
            });
        };
    if (!user) return null;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $52a3fcb397c31455$export$2b77a92f1a5ad772), {
        open: open,
        onClose: handleClose,
        title: "Edit User",
        size: "md",
        footer: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                    variant: "outline",
                    size: "sm",
                    onClick: handleClose,
                    disabled: loading,
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                    variant: "primary",
                    size: "sm",
                    onClick: handleSubmit,
                    disabled: loading,
                    children: loading ? "Saving\u2026" : 'Save Changes'
                })
            ]
        }),
        children: [
            apiError && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$3b4e64e77073e307), {
                variant: "error",
                onClose: ()=>setApiError(null),
                className: "mb-4",
                children: apiError
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "flex flex-col gap-3.5",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$56e87bf42978147a), {
                        label: "Email",
                        hint: "Email cannot be changed after creation",
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                            className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input} opacity-60`,
                            value: user.email,
                            disabled: true,
                            readOnly: true
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "grid grid-cols-2 gap-3",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$56e87bf42978147a), {
                                label: "First Name",
                                required: true,
                                error: errors.first_name,
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                                    className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input,
                                    value: formData.first_name,
                                    onChange: setField('first_name'),
                                    disabled: loading
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$56e87bf42978147a), {
                                label: "Last Name",
                                required: true,
                                error: errors.last_name,
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                                    className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input,
                                    value: formData.last_name,
                                    onChange: setField('last_name'),
                                    disabled: loading
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$56e87bf42978147a), {
                        label: "Role",
                        required: true,
                        hint: $5cfb3a1471fc9b43$var$ROLE_HINTS[formData.role],
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("select", {
                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input,
                            value: formData.role,
                            onChange: setField('role'),
                            disabled: loading,
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                    value: "normal",
                                    children: "Normal"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                    value: "super",
                                    children: "Super (Read-only)"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                    value: "admin",
                                    children: "Admin (Full Access)"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$56e87bf42978147a), {
                        label: "User Type",
                        required: true,
                        hint: "Determines portfolio access permissions",
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("select", {
                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input,
                            value: formData.user_type,
                            onChange: setField('user_type'),
                            disabled: loading,
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                    value: "RM",
                                    children: "RM (Relationship Manager)"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                    value: "IC",
                                    children: "IC (Investment Counselor)"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                    value: "ARM",
                                    children: "ARM (Assistant RM)"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                    value: "ADMIN",
                                    children: "ADMIN"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                    value: "SUPER",
                                    children: "SUPER"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                    value: "COMPLIANCE",
                                    children: "COMPLIANCE"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                    value: "OPS",
                                    children: "OPS"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$56e87bf42978147a), {
                        label: "Source User ID",
                        hint: "Links to upstream system user_access_info.user_id",
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input,
                            value: formData.source_user_id,
                            onChange: setField('source_user_id'),
                            disabled: loading
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "flex items-center justify-between py-2.5 px-3.5 border border-black/[0.12] bg-[#FAF9F8]",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                        className: "text-[12.5px] font-semibold text-[#333]",
                                        children: "Account Status"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                        className: "text-[11px] text-[#7A7A76] mt-0.5",
                                        children: formData.is_active ? 'User can log in' : 'User cannot log in'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                                type: "button",
                                onClick: ()=>setFormData((prev)=>({
                                            ...prev,
                                            is_active: !prev.is_active
                                        })),
                                disabled: loading,
                                className: `relative inline-flex h-5 w-9 items-center rounded-full transition-colors border-0 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed ${formData.is_active ? 'bg-[#1f8a4a]' : 'bg-[#CCC6BE]'}`,
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                    className: `inline-block h-3.5 w-3.5 transform rounded-full bg-white transition-transform ${formData.is_active ? 'translate-x-4' : 'translate-x-0.5'}`
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $52a3fcb397c31455$export$3b4e64e77073e307), {
                        variant: "info",
                        className: "",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("strong", {
                                children: "Note:"
                            }),
                            ' To change the password, use the "Reset Password" action in the user list.'
                        ]
                    })
                ]
            })
        ]
    });
};
var $5cfb3a1471fc9b43$export$2e2bcd8739ae039 = $5cfb3a1471fc9b43$var$UserEditDialog;



var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");


const $6ac2bb4b88dd69db$var$ConfirmationDialog = ({ open: open, title: title, message: message, confirmLabel: confirmLabel = 'Confirm', cancelLabel: cancelLabel = 'Cancel', severity: severity = 'warning', onConfirm: onConfirm, onCancel: onCancel })=>/*#__PURE__*/ (0, $bbzbN.jsxs)((0, $52a3fcb397c31455$export$2b77a92f1a5ad772), {
        open: open,
        onClose: onCancel,
        title: title,
        size: "sm",
        footer: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                    variant: "outline",
                    size: "sm",
                    onClick: onCancel,
                    children: cancelLabel
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                    variant: "primary",
                    size: "sm",
                    onClick: onConfirm,
                    children: confirmLabel
                })
            ]
        }),
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$3b4e64e77073e307), {
                variant: severity === 'error' ? 'error' : severity === 'warning' ? 'warn' : 'info',
                className: "mb-3",
                children: message
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                className: "text-[13px] text-[#555] m-0",
                children: "This action cannot be undone. Are you sure you want to continue?"
            })
        ]
    });
var $6ac2bb4b88dd69db$export$2e2bcd8739ae039 = $6ac2bb4b88dd69db$var$ConfirmationDialog;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");


const $fb2de5e4a565aa6a$var$PasswordResetDialog = ({ open: open, email: email, newPassword: newPassword, onClose: onClose })=>{
    const [copied, setCopied] = (0, $7fPBF.useState)(false);
    const handleCopy = ()=>{
        navigator.clipboard.writeText(newPassword);
        setCopied(true);
        setTimeout(()=>setCopied(false), 2000);
    };
    const handleClose = ()=>{
        setCopied(false);
        onClose();
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $52a3fcb397c31455$export$2b77a92f1a5ad772), {
        open: open,
        onClose: handleClose,
        title: "Password Reset Successful",
        size: "sm",
        footer: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
            variant: "primary",
            size: "sm",
            onClick: handleClose,
            children: "Close"
        }),
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $52a3fcb397c31455$export$3b4e64e77073e307), {
                variant: "success",
                className: "mb-3",
                children: [
                    "Password has been reset for ",
                    /*#__PURE__*/ (0, $bbzbN.jsx)("strong", {
                        children: email
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $52a3fcb397c31455$export$3b4e64e77073e307), {
                variant: "warn",
                className: "mb-3",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("strong", {
                        children: "Important:"
                    }),
                    " Save this password securely. It will not be shown again!"
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "flex gap-2 items-stretch mb-3",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input} font-mono flex-1`,
                        value: newPassword,
                        readOnly: true
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                        onClick: handleCopy,
                        className: "px-3 py-2 text-[11px] font-bold tracking-[0.08em] uppercase border border-black/[0.16] bg-white hover:bg-[#FAF9F8] transition-colors cursor-pointer shrink-0",
                        children: copied ? 'Copied!' : 'Copy'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$3b4e64e77073e307), {
                variant: "info",
                className: "",
                children: "Share this password with the user securely. They should change it after their first login."
            })
        ]
    });
};
var $fb2de5e4a565aa6a$export$2e2bcd8739ae039 = $fb2de5e4a565aa6a$var$PasswordResetDialog;


const $5b93540a907aee00$var$UserList = ()=>{
    const { user: currentUser } = (0, $d0020511b775fb45$export$1d39dc5b47e56ff0)();
    const [users, setUsers] = (0, $7fPBF.useState)([]);
    const [total, setTotal] = (0, $7fPBF.useState)(0);
    const [page, setPage] = (0, $7fPBF.useState)(0);
    const [pageSize, setPageSize] = (0, $7fPBF.useState)(25);
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const [success, setSuccess] = (0, $7fPBF.useState)(null);
    const [searchTerm, setSearchTerm] = (0, $7fPBF.useState)('');
    const [roleFilter, setRoleFilter] = (0, $7fPBF.useState)('');
    const [userTypeFilter, setUserTypeFilter] = (0, $7fPBF.useState)('');
    const [activeFilter, setActiveFilter] = (0, $7fPBF.useState)('');
    const [createOpen, setCreateOpen] = (0, $7fPBF.useState)(false);
    const [editOpen, setEditOpen] = (0, $7fPBF.useState)(false);
    const [selectedUser, setSelectedUser] = (0, $7fPBF.useState)(null);
    const [confirm, setConfirm] = (0, $7fPBF.useState)({
        open: false,
        title: '',
        message: '',
        onConfirm: ()=>{},
        severity: 'warning'
    });
    const [pwReset, setPwReset] = (0, $7fPBF.useState)({
        open: false,
        email: '',
        password: ''
    });
    const fetchUsers = async ()=>{
        setLoading(true);
        setError(null);
        try {
            const params = {
                page: page + 1,
                page_size: pageSize
            };
            if (searchTerm) params.search = searchTerm;
            if (roleFilter) params.role = roleFilter;
            if (userTypeFilter) params.user_type = userTypeFilter;
            if (activeFilter) params.is_active = activeFilter === 'true';
            const data = await (0, $2b61471e8e825f6c$export$2e2bcd8739ae039).getUsers(params);
            setUsers(data.users);
            setTotal(data.total);
        } catch (err) {
            setError(err.message || 'Failed to fetch users');
        } finally{
            setLoading(false);
        }
    };
    (0, $7fPBF.useEffect)(()=>{
        fetchUsers();
    }, [
        page,
        pageSize,
        searchTerm,
        roleFilter,
        userTypeFilter,
        activeFilter
    ]);
    const isSuperUser = currentUser?.role === 'super';
    const handleEdit = (u)=>{
        setSelectedUser(u);
        setEditOpen(true);
    };
    const handleResetPassword = (u)=>setConfirm({
            open: true,
            title: 'Reset Password',
            severity: 'warning',
            message: `Reset password for ${u.email}? A new random password will be generated.`,
            onConfirm: async ()=>{
                setConfirm((p)=>({
                        ...p,
                        open: false
                    }));
                try {
                    const result = await (0, $2b61471e8e825f6c$export$2e2bcd8739ae039).resetUserPassword(u.id);
                    setPwReset({
                        open: true,
                        email: u.email,
                        password: result.password
                    });
                } catch (err) {
                    setError(err.message || 'Failed to reset password');
                }
            }
        });
    const handleDeactivate = (u)=>setConfirm({
            open: true,
            title: 'Deactivate User',
            severity: 'error',
            message: `Deactivate ${u.email}? The user will not be able to log in until reactivated.`,
            onConfirm: async ()=>{
                setConfirm((p)=>({
                        ...p,
                        open: false
                    }));
                try {
                    await (0, $2b61471e8e825f6c$export$2e2bcd8739ae039).deactivateUser(u.id);
                    setSuccess(`User ${u.email} deactivated`);
                    fetchUsers();
                } catch (err) {
                    setError(err.message || 'Failed to deactivate user');
                }
            }
        });
    const handleActivate = (u)=>setConfirm({
            open: true,
            title: 'Activate User',
            severity: 'info',
            message: `Activate ${u.email}? The user will be able to log in.`,
            onConfirm: async ()=>{
                setConfirm((p)=>({
                        ...p,
                        open: false
                    }));
                try {
                    await (0, $2b61471e8e825f6c$export$2e2bcd8739ae039).activateUser(u.id);
                    setSuccess(`User ${u.email} activated`);
                    fetchUsers();
                } catch (err) {
                    setError(err.message || 'Failed to activate user');
                }
            }
        });
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "flex flex-col h-full min-h-0",
        children: [
            error && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$3b4e64e77073e307), {
                variant: "error",
                onClose: ()=>setError(null),
                className: "mb-3",
                children: error
            }),
            success && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$3b4e64e77073e307), {
                variant: "success",
                onClose: ()=>setSuccess(null),
                className: "mb-3",
                children: success
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $52a3fcb397c31455$export$4c260019440d418f), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$ca183fc7c8e0e04a), {
                        value: searchTerm,
                        onChange: setSearchTerm,
                        placeholder: "Email, name, username\u2026"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$12d9e482a4de9a59), {
                        value: roleFilter,
                        onChange: setRoleFilter,
                        placeholder: "All roles",
                        options: [
                            {
                                value: 'admin',
                                label: 'Admin'
                            },
                            {
                                value: 'super',
                                label: 'Super'
                            },
                            {
                                value: 'normal',
                                label: 'Normal'
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$12d9e482a4de9a59), {
                        value: userTypeFilter,
                        onChange: setUserTypeFilter,
                        placeholder: "All types",
                        options: [
                            {
                                value: 'RM',
                                label: 'RM'
                            },
                            {
                                value: 'IC',
                                label: 'IC'
                            },
                            {
                                value: 'ARM',
                                label: 'ARM'
                            },
                            {
                                value: 'ADMIN',
                                label: 'ADMIN'
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$12d9e482a4de9a59), {
                        value: activeFilter,
                        onChange: setActiveFilter,
                        placeholder: "All statuses",
                        options: [
                            {
                                value: 'true',
                                label: 'Active'
                            },
                            {
                                value: 'false',
                                label: 'Inactive'
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$d5de21f9becf2375), {}),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).iconBtn,
                        onClick: fetchUsers,
                        title: "Refresh",
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                            name: "refresh",
                            size: 14
                        })
                    }),
                    !isSuperUser && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                        variant: "primary",
                        size: "sm",
                        onClick: ()=>setCreateOpen(true),
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                name: "plus",
                                size: 12
                            }),
                            " Create User"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "flex-1 min-h-0 flex flex-col border border-black/[0.08] bg-white",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "flex-1 min-h-0 overflow-auto",
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("table", {
                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).table,
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                                style: {
                                                    width: 60
                                                },
                                                children: "ID"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                                children: "Email"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                                children: "Name"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                                children: "Role"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                                children: "Type"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                                children: "Status"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th} text-right`,
                                                children: "Actions"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsxs)("tbody", {
                                    children: [
                                        loading && /*#__PURE__*/ (0, $bbzbN.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                colSpan: 7,
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).muted} text-center py-8`,
                                                children: "Loading\u2026"
                                            })
                                        }),
                                        !loading && users.length === 0 && /*#__PURE__*/ (0, $bbzbN.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                colSpan: 7,
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).muted} text-center py-8`,
                                                children: "No users found."
                                            })
                                        }),
                                        !loading && users.map((u)=>/*#__PURE__*/ (0, $bbzbN.jsxs)("tr", {
                                                className: "hover:bg-[#FAF9F8] transition-colors",
                                                children: [
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdMono} text-[#7A7A76]`,
                                                        children: u.id
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                        children: u.email
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                        children: u.first_name || u.last_name ? `${u.first_name || ''} ${u.last_name || ''}`.trim() : "\u2014"
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$b061d3bc5141c982), {
                                                            role: u.role
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                            className: "text-[11px] font-semibold text-[#555] bg-black/[0.05] px-2 py-0.5",
                                                            children: u.user_type
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$5720c1871db44880), {
                                                            active: u.is_active
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} text-right`,
                                                        children: isSuperUser ? /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                            className: "text-[11px] text-[#7A7A76]",
                                                            children: "Read-only"
                                                        }) : /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                                            className: "flex items-center justify-end gap-0.5",
                                                            children: [
                                                                /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                                                                    className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).iconBtn,
                                                                    onClick: ()=>handleEdit(u),
                                                                    title: "Edit User",
                                                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                                                        name: "edit",
                                                                        size: 13
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                                                                    className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).iconBtn,
                                                                    onClick: ()=>handleResetPassword(u),
                                                                    title: "Reset Password",
                                                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                                                        name: "key",
                                                                        size: 13
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                                                                    className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).iconBtn} ${u.is_active ? 'hover:text-[#E50025]' : 'hover:text-[#1f8a4a]'}`,
                                                                    onClick: ()=>u.is_active ? handleDeactivate(u) : handleActivate(u),
                                                                    title: u.is_active ? 'Deactivate' : 'Activate',
                                                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                                                        name: u.is_active ? 'close' : 'check',
                                                                        size: 13
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }, u.id))
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$68f5e1453c188a82), {
                        page: page,
                        pageSize: pageSize,
                        total: total,
                        onChange: (p, ps)=>{
                            setPage(p);
                            setPageSize(ps);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8d00e4fd6941735d$export$2e2bcd8739ae039), {
                open: createOpen,
                onClose: ()=>setCreateOpen(false),
                onSuccess: ()=>{
                    setSuccess('User created successfully');
                    fetchUsers();
                }
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5cfb3a1471fc9b43$export$2e2bcd8739ae039), {
                open: editOpen,
                user: selectedUser,
                onClose: ()=>{
                    setEditOpen(false);
                    setSelectedUser(null);
                },
                onSuccess: ()=>{
                    setSuccess('User updated successfully');
                    fetchUsers();
                }
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6ac2bb4b88dd69db$export$2e2bcd8739ae039), {
                open: confirm.open,
                title: confirm.title,
                message: confirm.message,
                severity: confirm.severity,
                onConfirm: confirm.onConfirm,
                onCancel: ()=>setConfirm((p)=>({
                            ...p,
                            open: false
                        }))
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fb2de5e4a565aa6a$export$2e2bcd8739ae039), {
                open: pwReset.open,
                email: pwReset.email,
                newPassword: pwReset.password,
                onClose: ()=>setPwReset({
                        open: false,
                        email: '',
                        password: ''
                    })
            })
        ]
    });
};
var $5b93540a907aee00$export$2e2bcd8739ae039 = $5b93540a907aee00$var$UserList;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");





var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");



const $625d6c7e9a5505de$var$CreateARMAssignmentDialog = ({ open: open, onClose: onClose, onSuccess: onSuccess })=>{
    const [formData, setFormData] = (0, $7fPBF.useState)({
        arm_user_id: null,
        rm_user_id: null,
        notes: ''
    });
    const [armUsers, setArmUsers] = (0, $7fPBF.useState)([]);
    const [rmUsers, setRmUsers] = (0, $7fPBF.useState)([]);
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [fetchingUsers, setFetchingUsers] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const [valErrors, setValErrors] = (0, $7fPBF.useState)({});
    (0, $7fPBF.useEffect)(()=>{
        if (open) {
            setFormData({
                arm_user_id: null,
                rm_user_id: null,
                notes: ''
            });
            setError(null);
            setValErrors({});
            fetchUsers();
        }
    }, [
        open
    ]);
    const fetchUsers = async ()=>{
        setFetchingUsers(true);
        try {
            const [armsData, rmsData] = await Promise.all([
                (0, $2b61471e8e825f6c$export$2e2bcd8739ae039).getARMUsers(),
                (0, $2b61471e8e825f6c$export$2e2bcd8739ae039).getRMUsers()
            ]);
            setArmUsers(armsData);
            setRmUsers(rmsData);
            if (!armsData.length) setError('No ARM users found. Please create users with user_type="ARM" first.');
            else if (!rmsData.length) setError('No RM users found. Please create users with user_type="RM" first.');
        } catch (err) {
            setError(err.message || 'Failed to fetch users');
        } finally{
            setFetchingUsers(false);
        }
    };
    const validate = ()=>{
        const e = {};
        if (!formData.arm_user_id) e.arm_user_id = 'ARM User is required';
        if (!formData.rm_user_id) e.rm_user_id = 'RM User is required';
        setValErrors(e);
        return !Object.keys(e).length;
    };
    const handleSubmit = async ()=>{
        if (!validate()) return;
        setLoading(true);
        setError(null);
        try {
            const payload = {
                arm_user_id: formData.arm_user_id,
                rm_user_id: formData.rm_user_id
            };
            if (formData.notes.trim()) payload.notes = formData.notes.trim();
            await (0, $2b61471e8e825f6c$export$2e2bcd8739ae039).createARMAssignment(payload);
            onSuccess();
        } catch (err) {
            setError(err.message || 'Failed to create assignment');
        } finally{
            setLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $52a3fcb397c31455$export$2b77a92f1a5ad772), {
        open: open,
        onClose: ()=>!loading && onClose(),
        title: "Create ARM Assignment",
        size: "md",
        footer: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                    variant: "outline",
                    size: "sm",
                    onClick: ()=>!loading && onClose(),
                    disabled: loading,
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                    variant: "primary",
                    size: "sm",
                    onClick: handleSubmit,
                    disabled: loading || fetchingUsers || !armUsers.length || !rmUsers.length,
                    children: loading ? "Creating\u2026" : 'Create Assignment'
                })
            ]
        }),
        children: [
            error && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$3b4e64e77073e307), {
                variant: "error",
                className: "mb-4",
                children: error
            }),
            fetchingUsers ? /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "flex justify-center py-6 text-[#7A7A76] text-[13px]",
                children: "Loading users\u2026"
            }) : /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "flex flex-col gap-3.5",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$56e87bf42978147a), {
                        label: "ARM User",
                        required: true,
                        error: valErrors.arm_user_id,
                        hint: "Select Assistant Relationship Manager",
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("select", {
                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input,
                            value: formData.arm_user_id ?? '',
                            onChange: (e)=>{
                                setFormData((p)=>({
                                        ...p,
                                        arm_user_id: e.target.value ? Number(e.target.value) : null
                                    }));
                                if (e.target.value) setValErrors((p)=>({
                                        ...p,
                                        arm_user_id: undefined
                                    }));
                            },
                            disabled: loading || !armUsers.length,
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                    value: "",
                                    children: "\u2014 Select ARM User \u2014"
                                }),
                                armUsers.map((u)=>/*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                        value: u.id,
                                        children: u.label
                                    }, u.id))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$56e87bf42978147a), {
                        label: "RM User",
                        required: true,
                        error: valErrors.rm_user_id,
                        hint: "Select Relationship Manager",
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("select", {
                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input,
                            value: formData.rm_user_id ?? '',
                            onChange: (e)=>{
                                setFormData((p)=>({
                                        ...p,
                                        rm_user_id: e.target.value ? Number(e.target.value) : null
                                    }));
                                if (e.target.value) setValErrors((p)=>({
                                        ...p,
                                        rm_user_id: undefined
                                    }));
                            },
                            disabled: loading || !rmUsers.length,
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                    value: "",
                                    children: "\u2014 Select RM User \u2014"
                                }),
                                rmUsers.map((u)=>/*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                        value: u.id,
                                        children: u.label
                                    }, u.id))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$56e87bf42978147a), {
                        label: "Notes",
                        hint: "Optional notes about this assignment (max 500 characters)",
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)("textarea", {
                            className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input} min-h-[80px] resize-y`,
                            value: formData.notes,
                            onChange: (e)=>setFormData((p)=>({
                                        ...p,
                                        notes: e.target.value
                                    })),
                            maxLength: 500,
                            disabled: loading
                        })
                    })
                ]
            })
        ]
    });
};
var $625d6c7e9a5505de$export$2e2bcd8739ae039 = $625d6c7e9a5505de$var$CreateARMAssignmentDialog;



const $13ea3d39f77be8c5$var$ARMAssignments = ()=>{
    const { user: currentUser } = (0, $d0020511b775fb45$export$1d39dc5b47e56ff0)();
    const [assignments, setAssignments] = (0, $7fPBF.useState)([]);
    const [total, setTotal] = (0, $7fPBF.useState)(0);
    const [page, setPage] = (0, $7fPBF.useState)(0);
    const [pageSize, setPageSize] = (0, $7fPBF.useState)(25);
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const [success, setSuccess] = (0, $7fPBF.useState)(null);
    const [searchTerm, setSearchTerm] = (0, $7fPBF.useState)('');
    const [activeFilter, setActiveFilter] = (0, $7fPBF.useState)('true');
    const [createOpen, setCreateOpen] = (0, $7fPBF.useState)(false);
    const [confirm, setConfirm] = (0, $7fPBF.useState)({
        open: false,
        title: '',
        message: '',
        onConfirm: ()=>{},
        severity: 'warning'
    });
    const isSuperUser = currentUser?.role === 'super';
    const fetchARMAssignments = async ()=>{
        setLoading(true);
        setError(null);
        try {
            const params = {
                page: page + 1,
                page_size: pageSize
            };
            if (searchTerm) params.search = searchTerm;
            if (activeFilter) params.is_active = activeFilter === 'true';
            const data = await (0, $2b61471e8e825f6c$export$2e2bcd8739ae039).getARMAssignments(params);
            setAssignments(data.assignments);
            setTotal(data.total);
        } catch (err) {
            setError(err.message || 'Failed to fetch ARM assignments');
        } finally{
            setLoading(false);
        }
    };
    (0, $7fPBF.useEffect)(()=>{
        fetchARMAssignments();
    }, [
        page,
        pageSize,
        searchTerm,
        activeFilter
    ]);
    const handleDeactivate = (a)=>setConfirm({
            open: true,
            title: 'Deactivate ARM Assignment',
            severity: 'warning',
            message: `Deactivate the assignment between ${a.arm_user.full_name} (ARM) and ${a.rm_user.full_name} (RM)? This is preserved for audit purposes.`,
            onConfirm: async ()=>{
                try {
                    await (0, $2b61471e8e825f6c$export$2e2bcd8739ae039).deactivateARMAssignment(a.id);
                    setSuccess(`Assignment between ${a.arm_user.full_name} and ${a.rm_user.full_name} deactivated`);
                    fetchARMAssignments();
                } catch (err) {
                    setError(err.message || 'Failed to deactivate');
                }
                setConfirm((p)=>({
                        ...p,
                        open: false
                    }));
            }
        });
    const handleActivate = (a)=>setConfirm({
            open: true,
            title: 'Activate ARM Assignment',
            severity: 'info',
            message: `Activate the assignment between ${a.arm_user.full_name} (ARM) and ${a.rm_user.full_name} (RM)?`,
            onConfirm: async ()=>{
                try {
                    await (0, $2b61471e8e825f6c$export$2e2bcd8739ae039).activateARMAssignment(a.id);
                    setSuccess(`Assignment between ${a.arm_user.full_name} and ${a.rm_user.full_name} activated`);
                    fetchARMAssignments();
                } catch (err) {
                    setError(err.message || 'Failed to activate');
                }
                setConfirm((p)=>({
                        ...p,
                        open: false
                    }));
            }
        });
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "flex flex-col h-full min-h-0",
        children: [
            error && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$3b4e64e77073e307), {
                variant: "error",
                onClose: ()=>setError(null),
                className: "mb-3",
                children: error
            }),
            success && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$3b4e64e77073e307), {
                variant: "success",
                onClose: ()=>setSuccess(null),
                className: "mb-3",
                children: success
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $52a3fcb397c31455$export$4c260019440d418f), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$ca183fc7c8e0e04a), {
                        value: searchTerm,
                        onChange: setSearchTerm,
                        placeholder: "Search by name or email\u2026"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$12d9e482a4de9a59), {
                        value: activeFilter,
                        onChange: setActiveFilter,
                        placeholder: "All statuses",
                        options: [
                            {
                                value: 'true',
                                label: 'Active'
                            },
                            {
                                value: 'false',
                                label: 'Inactive'
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$d5de21f9becf2375), {}),
                    !isSuperUser && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                        variant: "primary",
                        size: "sm",
                        onClick: ()=>setCreateOpen(true),
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                name: "plus",
                                size: 12
                            }),
                            " Create Assignment"
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).iconBtn,
                        onClick: fetchARMAssignments,
                        title: "Refresh",
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                            name: "refresh",
                            size: 14
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "flex-1 min-h-0 flex flex-col border border-black/[0.08] bg-white",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "flex-1 min-h-0 overflow-auto",
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("table", {
                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).table,
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                                style: {
                                                    width: 60
                                                },
                                                children: "ID"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                                children: "ARM User"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                                children: "RM User"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                                children: "Assigned Date"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                                children: "Assigned By"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                                children: "Status"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                                children: "Notes"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th} text-right`,
                                                children: "Actions"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsxs)("tbody", {
                                    children: [
                                        loading && /*#__PURE__*/ (0, $bbzbN.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                colSpan: 8,
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).muted} text-center py-8`,
                                                children: "Loading\u2026"
                                            })
                                        }),
                                        !loading && assignments.length === 0 && /*#__PURE__*/ (0, $bbzbN.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                colSpan: 8,
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).muted} text-center py-8`,
                                                children: "No ARM assignments found."
                                            })
                                        }),
                                        !loading && assignments.map((a)=>/*#__PURE__*/ (0, $bbzbN.jsxs)("tr", {
                                                className: "hover:bg-[#FAF9F8] transition-colors",
                                                children: [
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdMono} text-[#7A7A76]`,
                                                        children: a.id
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                        children: a.arm_user.full_name
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                        children: a.rm_user.full_name
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                        children: new Date(a.assigned_date).toLocaleDateString()
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                        children: a.assigned_by?.full_name || 'System'
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$5720c1871db44880), {
                                                            active: a.is_active
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} max-w-[200px]`,
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                            className: "block truncate text-[12px] text-[#555]",
                                                            children: a.notes || "\u2014"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} text-right`,
                                                        children: !isSuperUser && (a.is_active ? /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                                                            className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).iconBtn} hover:text-[#E50025]`,
                                                            onClick: ()=>handleDeactivate(a),
                                                            title: "Deactivate",
                                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                                                name: "close",
                                                                size: 13
                                                            })
                                                        }) : /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                                                            className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).iconBtn} hover:text-[#1f8a4a]`,
                                                            onClick: ()=>handleActivate(a),
                                                            title: "Activate",
                                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                                                name: "check",
                                                                size: 13
                                                            })
                                                        }))
                                                    })
                                                ]
                                            }, a.id))
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$68f5e1453c188a82), {
                        page: page,
                        pageSize: pageSize,
                        total: total,
                        onChange: (p, ps)=>{
                            setPage(p);
                            setPageSize(ps);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $625d6c7e9a5505de$export$2e2bcd8739ae039), {
                open: createOpen,
                onClose: ()=>setCreateOpen(false),
                onSuccess: ()=>{
                    setCreateOpen(false);
                    setSuccess('ARM assignment created successfully');
                    fetchARMAssignments();
                }
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6ac2bb4b88dd69db$export$2e2bcd8739ae039), {
                open: confirm.open,
                title: confirm.title,
                message: confirm.message,
                severity: confirm.severity,
                onConfirm: confirm.onConfirm,
                onCancel: ()=>setConfirm((p)=>({
                            ...p,
                            open: false
                        }))
            })
        ]
    });
};
var $13ea3d39f77be8c5$export$2e2bcd8739ae039 = $13ea3d39f77be8c5$var$ARMAssignments;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");





var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");



const $4ee75ac3f23a04f4$var$ICOverrideDialog = ({ open: open, mode: mode, editingOverride: editingOverride, onClose: onClose, onSuccess: onSuccess })=>{
    const [formData, setFormData] = (0, $7fPBF.useState)({
        portfolio_id_lig: '',
        override_ic_user_id: 0,
        reason: '',
        effective_date: new Date().toISOString().split('T')[0]
    });
    const [portfolios, setPortfolios] = (0, $7fPBF.useState)([]);
    const [icUsers, setICUsers] = (0, $7fPBF.useState)([]);
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [fetchingData, setFetchingData] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const [valErrors, setValErrors] = (0, $7fPBF.useState)({});
    (0, $7fPBF.useEffect)(()=>{
        if (open) {
            fetchData();
            if (mode === 'edit' && editingOverride) setFormData({
                portfolio_id_lig: editingOverride.portfolio_id_lig,
                override_ic_user_id: editingOverride.override_ic_user_id,
                reason: editingOverride.reason,
                effective_date: editingOverride.effective_date.split('T')[0]
            });
            else setFormData({
                portfolio_id_lig: '',
                override_ic_user_id: 0,
                reason: '',
                effective_date: new Date().toISOString().split('T')[0]
            });
            setValErrors({});
            setError(null);
        }
    }, [
        open,
        mode,
        editingOverride
    ]);
    const fetchData = async ()=>{
        setFetchingData(true);
        try {
            const [pData, icData] = await Promise.all([
                (0, $2b61471e8e825f6c$export$2e2bcd8739ae039).getAdminPortfolios(),
                (0, $2b61471e8e825f6c$export$2e2bcd8739ae039).getICUsers()
            ]);
            setPortfolios(pData);
            setICUsers(icData);
            if (!pData.length) setError('No portfolios found.');
            else if (!icData.length) setError('No IC users found. Please create users with user_type="IC" first.');
        } catch (err) {
            setError(err.message || 'Failed to fetch data');
        } finally{
            setFetchingData(false);
        }
    };
    const validate = ()=>{
        const e = {};
        if (!formData.portfolio_id_lig) e.portfolio_id_lig = 'Portfolio is required';
        if (!formData.override_ic_user_id) e.override_ic_user_id = 'IC User is required';
        if (!formData.reason?.trim()) e.reason = 'Reason is required';
        else if (formData.reason.length > 1000) e.reason = 'Reason must be less than 1000 characters';
        if (!formData.effective_date) e.effective_date = 'Effective date is required';
        setValErrors(e);
        return !Object.keys(e).length;
    };
    const handleSubmit = async ()=>{
        if (!validate()) return;
        setLoading(true);
        setError(null);
        try {
            if (mode === 'create') await (0, $2b61471e8e825f6c$export$2e2bcd8739ae039).createICOverride(formData);
            else if (editingOverride) {
                const update = {};
                if (formData.override_ic_user_id !== editingOverride.override_ic_user_id) update.override_ic_user_id = formData.override_ic_user_id;
                if (formData.reason !== editingOverride.reason) update.reason = formData.reason;
                if (formData.effective_date !== editingOverride.effective_date.split('T')[0]) update.effective_date = formData.effective_date;
                if (Object.keys(update).length) await (0, $2b61471e8e825f6c$export$2e2bcd8739ae039).updateICOverride(editingOverride.id, update);
            }
            onSuccess();
        } catch (err) {
            setError(err.message || `Failed to ${mode} IC override`);
        } finally{
            setLoading(false);
        }
    };
    const handleCancel = ()=>{
        setValErrors({});
        setError(null);
        onClose();
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $52a3fcb397c31455$export$2b77a92f1a5ad772), {
        open: open,
        onClose: handleCancel,
        title: mode === 'create' ? 'Create IC Override' : 'Edit IC Override',
        size: "lg",
        footer: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                    variant: "outline",
                    size: "sm",
                    onClick: handleCancel,
                    disabled: loading,
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                    variant: "primary",
                    size: "sm",
                    onClick: handleSubmit,
                    disabled: loading || fetchingData,
                    children: loading ? mode === 'create' ? "Creating\u2026" : "Updating\u2026" : mode === 'create' ? 'Create Override' : 'Update Override'
                })
            ]
        }),
        children: [
            error && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$3b4e64e77073e307), {
                variant: "error",
                onClose: ()=>setError(null),
                className: "mb-4",
                children: error
            }),
            fetchingData ? /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "flex justify-center py-6 text-[#7A7A76] text-[13px]",
                children: "Loading data\u2026"
            }) : /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "flex flex-col gap-3.5",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$56e87bf42978147a), {
                        label: "Portfolio",
                        required: true,
                        error: valErrors.portfolio_id_lig,
                        hint: mode === 'edit' ? 'Portfolio cannot be changed in edit mode' : 'Select the portfolio to override IC for',
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("select", {
                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input,
                            value: formData.portfolio_id_lig,
                            onChange: (e)=>setFormData((p)=>({
                                        ...p,
                                        portfolio_id_lig: e.target.value
                                    })),
                            disabled: loading || mode === 'edit',
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                    value: "",
                                    children: "\u2014 Select Portfolio \u2014"
                                }),
                                portfolios.map((p)=>/*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                        value: p.portfolio_id_lig,
                                        children: p.label
                                    }, p.portfolio_id_lig))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$56e87bf42978147a), {
                        label: "IC User",
                        required: true,
                        error: valErrors.override_ic_user_id,
                        hint: "Select the IC user to override with",
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("select", {
                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input,
                            value: formData.override_ic_user_id || '',
                            onChange: (e)=>setFormData((p)=>({
                                        ...p,
                                        override_ic_user_id: Number(e.target.value)
                                    })),
                            disabled: loading,
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                    value: "",
                                    children: "\u2014 Select IC User \u2014"
                                }),
                                icUsers.map((u)=>/*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                        value: u.id,
                                        children: u.label
                                    }, u.id))
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$56e87bf42978147a), {
                        label: "Reason",
                        required: true,
                        error: valErrors.reason,
                        hint: `Required for audit trail (${formData.reason.length}/1000 characters)`,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)("textarea", {
                            className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input} min-h-[100px] resize-y`,
                            value: formData.reason,
                            onChange: (e)=>setFormData((p)=>({
                                        ...p,
                                        reason: e.target.value
                                    })),
                            disabled: loading,
                            maxLength: 1000
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$56e87bf42978147a), {
                        label: "Effective Date",
                        required: true,
                        error: valErrors.effective_date,
                        hint: "Date when override takes effect",
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input,
                            type: "date",
                            value: formData.effective_date,
                            onChange: (e)=>setFormData((p)=>({
                                        ...p,
                                        effective_date: e.target.value
                                    })),
                            disabled: loading
                        })
                    })
                ]
            })
        ]
    });
};
var $4ee75ac3f23a04f4$export$2e2bcd8739ae039 = $4ee75ac3f23a04f4$var$ICOverrideDialog;



const $c51968fca3e6be74$var$ICOverrides = ()=>{
    const { user: currentUser } = (0, $d0020511b775fb45$export$1d39dc5b47e56ff0)();
    const [overrides, setOverrides] = (0, $7fPBF.useState)([]);
    const [total, setTotal] = (0, $7fPBF.useState)(0);
    const [page, setPage] = (0, $7fPBF.useState)(0);
    const [pageSize, setPageSize] = (0, $7fPBF.useState)(25);
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const [success, setSuccess] = (0, $7fPBF.useState)(null);
    const [searchTerm, setSearchTerm] = (0, $7fPBF.useState)('');
    const [activeFilter, setActiveFilter] = (0, $7fPBF.useState)('true');
    const [dialogOpen, setDialogOpen] = (0, $7fPBF.useState)(false);
    const [dialogMode, setDialogMode] = (0, $7fPBF.useState)('create');
    const [editingOverride, setEditingOverride] = (0, $7fPBF.useState)(null);
    const [confirm, setConfirm] = (0, $7fPBF.useState)({
        open: false,
        title: '',
        message: '',
        onConfirm: ()=>{},
        severity: 'warning'
    });
    const isSuperUser = currentUser?.role === 'super';
    const fetchICOverrides = async ()=>{
        setLoading(true);
        setError(null);
        try {
            const params = {
                page: page + 1,
                page_size: pageSize
            };
            if (searchTerm) params.search = searchTerm;
            if (activeFilter) params.is_active = activeFilter === 'true';
            const data = await (0, $2b61471e8e825f6c$export$2e2bcd8739ae039).getICOverrides(params);
            setOverrides(data.overrides);
            setTotal(data.total);
        } catch (err) {
            setError(err.message || 'Failed to fetch IC overrides');
        } finally{
            setLoading(false);
        }
    };
    (0, $7fPBF.useEffect)(()=>{
        fetchICOverrides();
    }, [
        page,
        pageSize,
        searchTerm,
        activeFilter
    ]);
    const handleCreate = ()=>{
        setDialogMode('create');
        setEditingOverride(null);
        setDialogOpen(true);
    };
    const handleEdit = (o)=>{
        setDialogMode('edit');
        setEditingOverride(o);
        setDialogOpen(true);
    };
    const handleDeactivate = (o)=>setConfirm({
            open: true,
            title: 'Deactivate IC Override',
            severity: 'warning',
            message: `Deactivate IC override for portfolio "${o.portfolio_id_lig}"? The portfolio will revert to the official IC.`,
            onConfirm: async ()=>{
                try {
                    await (0, $2b61471e8e825f6c$export$2e2bcd8739ae039).deactivateICOverride(o.id);
                    setSuccess(`IC override for "${o.portfolio_id_lig}" deactivated`);
                    fetchICOverrides();
                } catch (err) {
                    setError(err.message || 'Failed to deactivate');
                }
                setConfirm((p)=>({
                        ...p,
                        open: false
                    }));
            }
        });
    const handleActivate = (o)=>setConfirm({
            open: true,
            title: 'Activate IC Override',
            severity: 'info',
            message: `Activate IC override for portfolio "${o.portfolio_id_lig}"?`,
            onConfirm: async ()=>{
                try {
                    await (0, $2b61471e8e825f6c$export$2e2bcd8739ae039).activateICOverride(o.id);
                    setSuccess(`IC override for "${o.portfolio_id_lig}" activated`);
                    fetchICOverrides();
                } catch (err) {
                    setError(err.message || 'Failed to activate');
                }
                setConfirm((p)=>({
                        ...p,
                        open: false
                    }));
            }
        });
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "flex flex-col h-full min-h-0",
        children: [
            error && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$3b4e64e77073e307), {
                variant: "error",
                onClose: ()=>setError(null),
                className: "mb-3",
                children: error
            }),
            success && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$3b4e64e77073e307), {
                variant: "success",
                onClose: ()=>setSuccess(null),
                className: "mb-3",
                children: success
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $52a3fcb397c31455$export$4c260019440d418f), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$ca183fc7c8e0e04a), {
                        value: searchTerm,
                        onChange: setSearchTerm,
                        placeholder: "Search portfolio ID, client, or IC\u2026"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$12d9e482a4de9a59), {
                        value: activeFilter,
                        onChange: setActiveFilter,
                        placeholder: "All statuses",
                        options: [
                            {
                                value: 'true',
                                label: 'Active'
                            },
                            {
                                value: 'false',
                                label: 'Inactive'
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$d5de21f9becf2375), {}),
                    !isSuperUser && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                        variant: "primary",
                        size: "sm",
                        onClick: handleCreate,
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                name: "plus",
                                size: 12
                            }),
                            " Create Override"
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).iconBtn,
                        onClick: fetchICOverrides,
                        title: "Refresh",
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                            name: "refresh",
                            size: 14
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "flex-1 min-h-0 flex flex-col border border-black/[0.08] bg-white",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "flex-1 min-h-0 overflow-auto",
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("table", {
                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).table,
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                                style: {
                                                    width: 60
                                                },
                                                children: "ID"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                                children: "Portfolio ID"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                                children: "Client Name"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                                children: "Override IC"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                                children: "Reason"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                                children: "Effective Date"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                                children: "Created By"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                                children: "Status"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th} text-right`,
                                                children: "Actions"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsxs)("tbody", {
                                    children: [
                                        loading && /*#__PURE__*/ (0, $bbzbN.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                colSpan: 9,
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).muted} text-center py-8`,
                                                children: "Loading\u2026"
                                            })
                                        }),
                                        !loading && overrides.length === 0 && /*#__PURE__*/ (0, $bbzbN.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                colSpan: 9,
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).muted} text-center py-8`,
                                                children: "No IC overrides found."
                                            })
                                        }),
                                        !loading && overrides.map((o)=>/*#__PURE__*/ (0, $bbzbN.jsxs)("tr", {
                                                className: "hover:bg-[#FAF9F8] transition-colors",
                                                children: [
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdMono} text-[#7A7A76]`,
                                                        children: o.id
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdMono}`,
                                                        children: o.portfolio_id_lig
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                        children: o.portfolio?.client_name || "\u2014"
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                        children: o.override_ic_user.full_name
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} max-w-[220px]`,
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                            className: "block truncate text-[12px]",
                                                            children: o.reason
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                        children: new Date(o.effective_date).toLocaleDateString()
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                        children: o.created_by?.full_name || 'System'
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$5720c1871db44880), {
                                                            active: o.is_active
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} text-right`,
                                                        children: !isSuperUser && /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                                            className: "flex items-center justify-end gap-0.5",
                                                            children: [
                                                                /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                                                                    className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).iconBtn,
                                                                    onClick: ()=>handleEdit(o),
                                                                    title: "Edit Override",
                                                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                                                        name: "edit",
                                                                        size: 13
                                                                    })
                                                                }),
                                                                o.is_active ? /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                                                                    className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).iconBtn} hover:text-[#E50025]`,
                                                                    onClick: ()=>handleDeactivate(o),
                                                                    title: "Deactivate",
                                                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                                                        name: "close",
                                                                        size: 13
                                                                    })
                                                                }) : /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                                                                    className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).iconBtn} hover:text-[#1f8a4a]`,
                                                                    onClick: ()=>handleActivate(o),
                                                                    title: "Activate",
                                                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                                                        name: "check",
                                                                        size: 13
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }, o.id))
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$68f5e1453c188a82), {
                        page: page,
                        pageSize: pageSize,
                        total: total,
                        onChange: (p, ps)=>{
                            setPage(p);
                            setPageSize(ps);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4ee75ac3f23a04f4$export$2e2bcd8739ae039), {
                open: dialogOpen,
                mode: dialogMode,
                editingOverride: editingOverride,
                onClose: ()=>setDialogOpen(false),
                onSuccess: ()=>{
                    setDialogOpen(false);
                    setSuccess(`IC override ${dialogMode === 'create' ? 'created' : 'updated'} successfully`);
                    fetchICOverrides();
                }
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6ac2bb4b88dd69db$export$2e2bcd8739ae039), {
                open: confirm.open,
                title: confirm.title,
                message: confirm.message,
                severity: confirm.severity,
                onConfirm: confirm.onConfirm,
                onCancel: ()=>setConfirm((p)=>({
                            ...p,
                            open: false
                        }))
            })
        ]
    });
};
var $c51968fca3e6be74$export$2e2bcd8739ae039 = $c51968fca3e6be74$var$ICOverrides;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");




const $d06229554f503268$var$MarginTradingOverridesTab = ()=>{
    const { user: user } = (0, $d0020511b775fb45$export$1d39dc5b47e56ff0)();
    const [portfolios, setPortfolios] = (0, $7fPBF.useState)([]);
    const [overrides, setOverrides] = (0, $7fPBF.useState)(new Map());
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const [dialogOpen, setDialogOpen] = (0, $7fPBF.useState)(false);
    const [selectedPortfolio, setSelectedPortfolio] = (0, $7fPBF.useState)(null);
    const [overrideStatus, setOverrideStatus] = (0, $7fPBF.useState)('AUTO');
    const [notes, setNotes] = (0, $7fPBF.useState)('');
    const [saving, setSaving] = (0, $7fPBF.useState)(false);
    const fetchData = (0, $7fPBF.useCallback)(async ()=>{
        setLoading(true);
        setError(null);
        try {
            const portfoliosData = await (0, $2b61471e8e825f6c$export$2e2bcd8739ae039).getPortfolios();
            setPortfolios(portfoliosData.filter((p)=>p.has_margin_account === true));
            const overridesData = await (0, $2b61471e8e825f6c$export$2e2bcd8739ae039).getMarginTradingOverrides();
            const map = new Map();
            overridesData.forEach((o)=>map.set(o.portfolio_id_lig, o));
            setOverrides(map);
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Failed to fetch data');
        } finally{
            setLoading(false);
        }
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    const handleOpenDialog = (portfolio)=>{
        setSelectedPortfolio(portfolio);
        const existing = overrides.get(portfolio.portfolio_id_lig);
        setOverrideStatus(existing?.override_status || 'AUTO');
        setNotes(existing?.notes || '');
        setDialogOpen(true);
    };
    const handleCloseDialog = ()=>{
        setDialogOpen(false);
        setSelectedPortfolio(null);
        setOverrideStatus('AUTO');
        setNotes('');
    };
    const handleSaveOverride = async ()=>{
        if (!selectedPortfolio || !user) return;
        setSaving(true);
        try {
            await (0, $2b61471e8e825f6c$export$2e2bcd8739ae039).setMarginTradingOverride({
                portfolio_id_lig: selectedPortfolio.portfolio_id_lig,
                override_status: overrideStatus,
                notes: notes || undefined,
                overridden_by: user.email
            });
            await fetchData();
            handleCloseDialog();
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Failed to save override');
        } finally{
            setSaving(false);
        }
    };
    const handleDeleteOverride = async (portfolioId)=>{
        if (!window.confirm('Remove this override?')) return;
        try {
            await (0, $2b61471e8e825f6c$export$2e2bcd8739ae039).deleteMarginTradingOverride(portfolioId);
            await fetchData();
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Failed to delete override');
        }
    };
    const getStatusBadge = (portfolio)=>{
        const override = overrides.get(portfolio.portfolio_id_lig);
        if (override) {
            if (override.override_status === 'AUTO') return /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                className: "text-[11px] font-semibold text-[#555] bg-black/[0.05] px-2 py-0.5",
                children: [
                    "AUTO (",
                    portfolio.is_margin_trading ? 'YES' : 'NO',
                    ")"
                ]
            });
            const isOverridden = override.override_value;
            return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "flex items-center gap-1.5",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        style: {
                            color: isOverridden ? '#b6770b' : '#1f8a4a',
                            background: isOverridden ? 'rgba(255,191,0,0.12)' : 'rgba(31,138,74,0.10)',
                            border: `1px solid ${isOverridden ? 'rgba(182,119,11,0.30)' : 'rgba(31,138,74,0.30)'}`
                        },
                        className: "inline-flex items-center px-[7px] py-[2px] text-[9.5px] font-bold tracking-[0.06em] uppercase whitespace-nowrap",
                        children: isOverridden ? 'YES (Manual)' : 'NO (Manual)'
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                        className: "text-[10px] text-[#7A7A76]",
                        children: [
                            "(Sys: ",
                            portfolio.system_is_margin_trading ? 'YES' : 'NO',
                            ")"
                        ]
                    })
                ]
            });
        }
        const v = portfolio.is_margin_trading;
        return /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
            style: {
                color: v ? '#b6770b' : '#7A7A76',
                background: v ? 'rgba(255,191,0,0.12)' : 'transparent',
                border: `1px solid ${v ? 'rgba(182,119,11,0.30)' : 'rgba(0,0,0,0.15)'}`
            },
            className: "inline-flex items-center px-[7px] py-[2px] text-[9.5px] font-bold tracking-[0.06em] uppercase whitespace-nowrap",
            children: v ? 'YES' : 'NO'
        });
    };
    const getOverrideBadge = (portfolio)=>{
        const override = overrides.get(portfolio.portfolio_id_lig);
        if (!override) return /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
            className: "text-[11px] text-[#7A7A76]",
            children: "NONE"
        });
        const isManual = override.override_status !== 'AUTO';
        return /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
            style: {
                color: isManual ? '#6464E6' : '#555',
                background: isManual ? 'rgba(100,100,230,0.08)' : 'rgba(0,0,0,0.04)',
                border: `1px solid ${isManual ? 'rgba(100,100,230,0.25)' : 'rgba(0,0,0,0.15)'}`
            },
            className: "inline-flex items-center px-[7px] py-[2px] text-[9.5px] font-bold tracking-[0.06em] uppercase whitespace-nowrap",
            children: override.override_status
        });
    };
    if (loading) return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: "flex justify-center items-center min-h-[400px] text-[#7A7A76] text-[13px]",
        children: "Loading\u2026"
    });
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "flex items-start justify-between gap-4 mb-4",
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                    variant: "outline",
                    size: "sm",
                    onClick: fetchData,
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                            name: "refresh",
                            size: 12
                        }),
                        " Refresh"
                    ]
                })
            }),
            error && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$3b4e64e77073e307), {
                variant: "error",
                onClose: ()=>setError(null),
                className: "mb-3",
                children: error
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $52a3fcb397c31455$export$3b4e64e77073e307), {
                variant: "info",
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("strong", {
                        children: "Override Modes: "
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("strong", {
                        children: "TRUE"
                    }),
                    " \u2014 Force margin trading = YES;",
                    ' ',
                    /*#__PURE__*/ (0, $bbzbN.jsx)("strong", {
                        children: "FALSE"
                    }),
                    " \u2014 Force margin trading = NO;",
                    ' ',
                    /*#__PURE__*/ (0, $bbzbN.jsx)("strong", {
                        children: "AUTO"
                    }),
                    " \u2014 Use system automatic detection (no override)"
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tableWrap,
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)("table", {
                    className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).table,
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                        children: "Portfolio ID"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                        children: "Client Name"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                        children: "Margin Trading"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                        children: "Override Mode"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                        children: "Overridden By"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                        children: "Override Date"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                        children: "Notes"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th} text-right`,
                                        children: "Actions"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("tbody", {
                            children: portfolios.length === 0 ? /*#__PURE__*/ (0, $bbzbN.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                    colSpan: 8,
                                    className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).muted} text-center py-8`,
                                    children: "No portfolios with margin accounts found."
                                })
                            }) : portfolios.map((portfolio)=>{
                                const override = overrides.get(portfolio.portfolio_id_lig);
                                return /*#__PURE__*/ (0, $bbzbN.jsxs)("tr", {
                                    className: "hover:bg-[#FAF9F8] transition-colors",
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                            className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdMono}`,
                                            children: portfolio.portfolio_id_lig
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                            children: portfolio.client_name
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                            children: getStatusBadge(portfolio)
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                            children: getOverrideBadge(portfolio)
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                            children: override?.overridden_by || "\u2014"
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                            children: override ? new Date(override.overridden_at).toLocaleString() : "\u2014"
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                            className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} max-w-[200px]`,
                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                className: "block truncate text-[12px] text-[#555]",
                                                children: override?.notes || "\u2014"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                            className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} text-right`,
                                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                                className: "flex items-center justify-end gap-0.5",
                                                children: [
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).iconBtn,
                                                        onClick: ()=>handleOpenDialog(portfolio),
                                                        title: "Set Override",
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                                            name: "edit",
                                                            size: 13
                                                        })
                                                    }),
                                                    override && override.override_status !== 'AUTO' && /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).iconBtn} hover:text-[#E50025]`,
                                                        onClick: ()=>handleDeleteOverride(portfolio.portfolio_id_lig),
                                                        title: "Remove Override",
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                                            name: "trash",
                                                            size: 13
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }, portfolio.portfolio_id_lig);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$2b77a92f1a5ad772), {
                open: dialogOpen,
                onClose: handleCloseDialog,
                title: selectedPortfolio ? `Override \u{2014} ${selectedPortfolio.portfolio_id_lig}` : 'Set Override',
                size: "md",
                footer: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                            variant: "outline",
                            size: "sm",
                            onClick: handleCloseDialog,
                            disabled: saving,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                            variant: "primary",
                            size: "sm",
                            onClick: handleSaveOverride,
                            disabled: saving,
                            children: saving ? "Saving\u2026" : 'Save Override'
                        })
                    ]
                }),
                children: selectedPortfolio && /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    className: "flex flex-col gap-3.5",
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $52a3fcb397c31455$export$3b4e64e77073e307), {
                            variant: "info",
                            className: "",
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)("strong", {
                                    children: "Client:"
                                }),
                                " ",
                                selectedPortfolio.client_name,
                                /*#__PURE__*/ (0, $bbzbN.jsx)("br", {}),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("strong", {
                                    children: "System Detection:"
                                }),
                                ' ',
                                selectedPortfolio.is_margin_trading ? 'YES (Margin Trading)' : 'NO (Not Margin Trading)'
                            ]
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$56e87bf42978147a), {
                            label: "Override Mode",
                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)("select", {
                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input,
                                value: overrideStatus,
                                onChange: (e)=>setOverrideStatus(e.target.value),
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                        value: "AUTO",
                                        children: "AUTO (Use System Detection)"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                        value: "TRUE",
                                        children: "TRUE (Force Margin Trading = YES)"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                        value: "FALSE",
                                        children: "FALSE (Force Margin Trading = NO)"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$56e87bf42978147a), {
                            label: "Notes",
                            hint: "Optional \u2014 explain why this override is needed",
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)("textarea", {
                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input} min-h-[80px] resize-y`,
                                placeholder: "Explain why this override is needed\u2026",
                                value: notes,
                                onChange: (e)=>setNotes(e.target.value)
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $52a3fcb397c31455$export$3b4e64e77073e307), {
                            variant: "info",
                            className: "",
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)("strong", {
                                    children: "Overridden by:"
                                }),
                                " ",
                                user?.email || 'Unknown user'
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var $d06229554f503268$export$2e2bcd8739ae039 = $d06229554f503268$var$MarginTradingOverridesTab;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");



const $2614abc3cd2a6416$var$ALERT_STATUSES = [
    'Amber Alert',
    'Red Alert',
    'Critical',
    'House Call'
];
const $2614abc3cd2a6416$var$USER_ROLES = [
    'admin',
    'rm'
];
const $2614abc3cd2a6416$var$STATUS_STYLE = {
    'Amber Alert': {
        color: '#b6770b',
        bg: 'rgba(255,191,0,0.12)',
        border: 'rgba(182,119,11,0.30)'
    },
    'Red Alert': {
        color: '#E50025',
        bg: 'rgba(229,0,37,0.08)',
        border: 'rgba(229,0,37,0.30)'
    },
    'Critical': {
        color: '#B80020',
        bg: 'rgba(184,0,32,0.08)',
        border: 'rgba(184,0,32,0.30)'
    },
    'House Call': {
        color: '#B80020',
        bg: 'rgba(184,0,32,0.08)',
        border: 'rgba(184,0,32,0.30)'
    }
};
const $2614abc3cd2a6416$var$getRoleLabel = (role)=>role === 'admin' ? 'Admin' : 'Relationship Manager';
const $2614abc3cd2a6416$var$EmailTemplates = ()=>{
    const [templates, setTemplates] = (0, $7fPBF.useState)([]);
    const [editingTemplate, setEditingTemplate] = (0, $7fPBF.useState)(null);
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [saving, setSaving] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const [success, setSuccess] = (0, $7fPBF.useState)(null);
    (0, $7fPBF.useEffect)(()=>{
        loadTemplates();
    }, []);
    const loadTemplates = async ()=>{
        setLoading(true);
        try {
            setTemplates(await (0, $2b61471e8e825f6c$export$c421df4b0a387416).getAll());
            setError(null);
        } catch (err) {
            setError(err.message || 'Failed to load email templates');
        } finally{
            setLoading(false);
        }
    };
    const handleSave = async ()=>{
        if (!editingTemplate) return;
        setSaving(true);
        try {
            await (0, $2b61471e8e825f6c$export$c421df4b0a387416).update(editingTemplate.id, {
                subject_template: editingTemplate.subject_template,
                body_template: editingTemplate.body_template
            });
            await loadTemplates();
            setEditingTemplate(null);
            setSuccess('Template updated successfully');
            setError(null);
        } catch (err) {
            setError(err.message || 'Failed to update template');
        } finally{
            setSaving(false);
        }
    };
    if (loading) return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: "flex justify-center items-center min-h-[400px] text-[#7A7A76] text-[13px]",
        children: "Loading templates\u2026"
    });
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        children: [
            error && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$3b4e64e77073e307), {
                variant: "error",
                onClose: ()=>setError(null),
                className: "mb-3",
                children: error
            }),
            success && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $52a3fcb397c31455$export$3b4e64e77073e307), {
                variant: "success",
                onClose: ()=>setSuccess(null),
                className: "mb-3",
                children: success
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $52a3fcb397c31455$export$3b4e64e77073e307), {
                variant: "info",
                className: "mb-4",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("strong", {
                        children: "Template Variables Available:"
                    }),
                    ' ',
                    /*#__PURE__*/ (0, $bbzbN.jsx)("code", {
                        className: "text-[11px] bg-black/[0.06] px-1",
                        children: "portfolio_id"
                    }),
                    ",",
                    ' ',
                    /*#__PURE__*/ (0, $bbzbN.jsx)("code", {
                        className: "text-[11px] bg-black/[0.06] px-1",
                        children: "client_name"
                    }),
                    ",",
                    ' ',
                    /*#__PURE__*/ (0, $bbzbN.jsx)("code", {
                        className: "text-[11px] bg-black/[0.06] px-1",
                        children: "previous_status"
                    }),
                    ",",
                    ' ',
                    /*#__PURE__*/ (0, $bbzbN.jsx)("code", {
                        className: "text-[11px] bg-black/[0.06] px-1",
                        children: "current_status"
                    }),
                    ",",
                    ' ',
                    /*#__PURE__*/ (0, $bbzbN.jsx)("code", {
                        className: "text-[11px] bg-black/[0.06] px-1",
                        children: "current_cushion_pct"
                    }),
                    ",",
                    ' ',
                    /*#__PURE__*/ (0, $bbzbN.jsx)("code", {
                        className: "text-[11px] bg-black/[0.06] px-1",
                        children: "aum_line"
                    }),
                    ",",
                    ' ',
                    /*#__PURE__*/ (0, $bbzbN.jsx)("code", {
                        className: "text-[11px] bg-black/[0.06] px-1",
                        children: "margin_req_line"
                    }),
                    ",",
                    ' ',
                    /*#__PURE__*/ (0, $bbzbN.jsx)("code", {
                        className: "text-[11px] bg-black/[0.06] px-1",
                        children: "alert_time"
                    }),
                    ". Use curly braces:",
                    ' ',
                    /*#__PURE__*/ (0, $bbzbN.jsx)("code", {
                        className: "text-[11px] bg-black/[0.06] px-1",
                        children: "Alert for {portfolio_id}"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "flex flex-col gap-4",
                children: $2614abc3cd2a6416$var$ALERT_STATUSES.flatMap((alertStatus)=>$2614abc3cd2a6416$var$USER_ROLES.map((role)=>{
                        const template = templates.find((t)=>t.alert_status === alertStatus && t.user_role === role);
                        if (!template) return null;
                        const isEditing = editingTemplate?.id === template.id;
                        const s = $2614abc3cd2a6416$var$STATUS_STYLE[alertStatus] || {
                            color: '#555',
                            bg: 'transparent',
                            border: '#bbb'
                        };
                        return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                            className: "border border-black/[0.08] bg-white",
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                    className: "flex items-center justify-between gap-3 px-4 py-3 border-b border-black/[0.06] bg-[#FAF9F8]",
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                            className: "flex items-center gap-2.5 flex-wrap",
                                            children: [
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                                    name: "mail",
                                                    size: 14,
                                                    className: "text-[#7A7A76] shrink-0"
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                                                    className: "font-semibold text-[13.5px]",
                                                    children: [
                                                        alertStatus,
                                                        " \u2014 ",
                                                        $2614abc3cd2a6416$var$getRoleLabel(role)
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                    style: {
                                                        color: s.color,
                                                        background: s.bg,
                                                        border: `1px solid ${s.border}`
                                                    },
                                                    className: "inline-flex items-center px-[7px] py-[2px] text-[9.5px] font-bold tracking-[0.06em] uppercase whitespace-nowrap",
                                                    children: alertStatus
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                    className: "inline-flex items-center px-[7px] py-[2px] text-[9.5px] font-bold tracking-[0.06em] uppercase whitespace-nowrap text-[#6464E6] bg-[rgba(100,100,230,0.08)] border border-[rgba(100,100,230,0.25)]",
                                                    children: $2614abc3cd2a6416$var$getRoleLabel(role)
                                                })
                                            ]
                                        }),
                                        !isEditing && /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                                            variant: "outline",
                                            size: "sm",
                                            onClick: ()=>setEditingTemplate({
                                                    ...template
                                                }),
                                            children: "Edit"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                    className: "px-4 py-3.5",
                                    children: isEditing ? /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                        className: "flex flex-col gap-3",
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).field,
                                                children: [
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("label", {
                                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).fieldLabel,
                                                        children: "Subject Template"
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input,
                                                        value: editingTemplate.subject_template,
                                                        onChange: (e)=>setEditingTemplate({
                                                                ...editingTemplate,
                                                                subject_template: e.target.value
                                                            })
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                        className: "text-[11px] text-[#7A7A76] mt-0.5",
                                                        children: "Subject line for the email"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).field,
                                                children: [
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("label", {
                                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).fieldLabel,
                                                        children: "Body Template"
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("textarea", {
                                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input} min-h-[260px] resize-y font-mono text-[12px]`,
                                                        value: editingTemplate.body_template,
                                                        onChange: (e)=>setEditingTemplate({
                                                                ...editingTemplate,
                                                                body_template: e.target.value
                                                            })
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                        className: "text-[11px] text-[#7A7A76] mt-0.5",
                                                        children: "Email body content (use template variables)"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                                className: "flex gap-2",
                                                children: [
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                                                        variant: "primary",
                                                        size: "sm",
                                                        onClick: handleSave,
                                                        disabled: saving,
                                                        children: saving ? "Saving\u2026" : 'Save'
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                                                        variant: "outline",
                                                        size: "sm",
                                                        onClick: ()=>setEditingTemplate(null),
                                                        disabled: saving,
                                                        children: "Cancel"
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                        className: "flex flex-col gap-2.5",
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                        className: "text-[10px] font-bold tracking-[0.12em] uppercase text-[#7A7A76] mb-1.5",
                                                        children: "Subject"
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                        className: "bg-[#FAF9F8] border border-black/[0.06] px-3 py-2 font-mono text-[12px] text-[#333]",
                                                        children: template.subject_template
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("hr", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).hr
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                        className: "text-[10px] font-bold tracking-[0.12em] uppercase text-[#7A7A76] mb-1.5",
                                                        children: "Body"
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("pre", {
                                                        className: "bg-[#FAF9F8] border border-black/[0.06] px-3 py-2 font-mono text-[12px] text-[#333] whitespace-pre-wrap break-words m-0",
                                                        children: template.body_template
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                                className: "text-[11px] text-[#7A7A76]",
                                                children: [
                                                    "Last updated: ",
                                                    new Date(template.updated_at).toLocaleString()
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }, `${alertStatus}-${role}`);
                    }).filter(Boolean))
            })
        ]
    });
};
var $2614abc3cd2a6416$export$2e2bcd8739ae039 = $2614abc3cd2a6416$var$EmailTemplates;


const $6d2ffebabcd587a0$var$TABS = [
    {
        id: 'user-management',
        label: 'User Management',
        icon: 'admin',
        description: 'Manage user accounts, roles, and permissions'
    },
    {
        id: 'arm-assignments',
        label: 'ARM Assignments',
        icon: 'arrow',
        description: 'Manage ARM to RM assignments'
    },
    {
        id: 'ic-overrides',
        label: 'IC Overrides',
        icon: 'check',
        description: 'Override IC assignments for portfolios'
    },
    {
        id: 'email-templates',
        label: 'Email Templates',
        icon: 'mail',
        description: 'Configure email templates for margin alerts'
    },
    {
        id: 'asset-types',
        label: 'Asset Type Add-Ons',
        icon: 'exposure',
        description: 'LC house add-ons to Pershing requirements by asset type'
    },
    {
        id: 'market-cap',
        label: 'Market Cap & Volatility',
        icon: 'dashboard',
        description: 'Market cap categories and volatility thresholds'
    },
    {
        id: 'concentration',
        label: 'Concentration Rules',
        icon: 'warn',
        description: 'Add-ons for concentrated positions and portfolio limits'
    },
    {
        id: 'warning-thresholds',
        label: 'Warning Thresholds',
        icon: 'alerts',
        description: 'Surplus cushion thresholds for status classification'
    },
    {
        id: 'margin-trading-overrides',
        label: 'Margin Trading Overrides',
        icon: 'refresh',
        description: 'Override automatic margin trading detection'
    }
];
const $6d2ffebabcd587a0$var$CONFIG_TABS = new Set([
    'asset-types',
    'market-cap',
    'concentration',
    'warning-thresholds'
]);
/* ── Reusable primitives ─────────────────────────────────────── */ const $6d2ffebabcd587a0$var$Section = ({ title: title, sub: sub, children: children })=>/*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "bg-white border border-black/[0.08] mb-4",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "px-5 py-3.5 border-b border-black/[0.06]",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "font-semibold text-[13.5px] text-black",
                        children: title
                    }),
                    sub && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "text-[12px] text-[#7A7A76] mt-0.5",
                        children: sub
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "p-5",
                children: children
            })
        ]
    });
const $6d2ffebabcd587a0$var$FieldGrid = ({ children: children, cols: cols = 2 })=>/*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: `grid gap-4 ${cols === 2 ? 'grid-cols-2 max-[768px]:grid-cols-1' : 'grid-cols-1 max-w-sm'}`,
        children: children
    });
const $6d2ffebabcd587a0$var$Field = ({ label: label, hint: hint, value: value, onChange: onChange, prefix: prefix, suffix: suffix })=>/*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).field,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("label", {
                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).fieldLabel,
                children: label
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "flex items-stretch border border-black/[0.16] bg-white focus-within:border-[#E50025] transition-colors",
                children: [
                    prefix && /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        className: "flex items-center px-3 text-[13px] text-[#7A7A76] border-r border-black/[0.10] bg-[#FAF9F8] shrink-0 select-none",
                        children: prefix
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                        type: "number",
                        className: "flex-1 font-[inherit] text-[13.5px] font-light px-3 py-[9px] bg-transparent text-black focus:outline-none w-0 min-w-0",
                        value: value,
                        onChange: (e)=>onChange(Number(e.target.value))
                    }),
                    suffix && /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        className: "flex items-center px-3 text-[13px] text-[#7A7A76] border-l border-black/[0.10] bg-[#FAF9F8] shrink-0 select-none",
                        children: suffix
                    })
                ]
            }),
            hint && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "text-[11px] text-[#7A7A76] mt-1",
                children: hint
            })
        ]
    });
const $6d2ffebabcd587a0$var$InfoBanner = ({ children: children, variant: variant = 'info' })=>/*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: `flex items-start gap-2.5 px-4 py-3 text-[12.5px] leading-relaxed mt-2 ${variant === 'warn' ? 'bg-[rgba(255,191,0,0.10)] border border-[rgba(182,119,11,0.30)] text-[#b6770b]' : 'bg-[rgba(100,100,230,0.06)] border border-[rgba(100,100,230,0.25)] text-[#4444b0]'}`,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                name: variant === 'warn' ? 'warn' : 'error',
                size: 14,
                className: "shrink-0 mt-0.5"
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                children: children
            })
        ]
    });
/* ── Tab content renderers ───────────────────────────────────── */ function $6d2ffebabcd587a0$var$AssetTypesTab({ config: config, onChange: onChange }) {
    const ch = (f, v)=>onChange('assetTypeAddOns', f, v);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)($6d2ffebabcd587a0$var$Section, {
                title: "Equity Categories",
                sub: "Add-on percentages for different equity types based on market cap",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)($6d2ffebabcd587a0$var$FieldGrid, {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)($6d2ffebabcd587a0$var$Field, {
                                label: "Large Cap Add-On",
                                value: config.assetTypeAddOns.largeCap,
                                onChange: (v)=>ch('largeCap', v),
                                suffix: "%",
                                hint: ">$10B market cap"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)($6d2ffebabcd587a0$var$Field, {
                                label: "Mid Cap Add-On",
                                value: config.assetTypeAddOns.midCap,
                                onChange: (v)=>ch('midCap', v),
                                suffix: "%",
                                hint: "$2\u201310B market cap"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)($6d2ffebabcd587a0$var$Field, {
                                label: "Small Cap Add-On",
                                value: config.assetTypeAddOns.smallCap,
                                onChange: (v)=>ch('smallCap', v),
                                suffix: "%",
                                hint: "<$2B market cap"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)($6d2ffebabcd587a0$var$Field, {
                                label: "Volatile Stocks Add-On",
                                value: config.assetTypeAddOns.volatile,
                                onChange: (v)=>ch('volatile', v),
                                suffix: "%",
                                hint: ">40% 30-day volatility"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)($6d2ffebabcd587a0$var$FieldGrid, {
                        cols: 1,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)($6d2ffebabcd587a0$var$Field, {
                            label: "Penny Stocks Requirement",
                            value: config.assetTypeAddOns.pennyStocks,
                            onChange: (v)=>ch('pennyStocks', v),
                            suffix: "%",
                            hint: "<$5 per share (typically 100% \u2014 no margin)"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)($6d2ffebabcd587a0$var$Section, {
                title: "Other Asset Types",
                sub: "Add-on percentages for non-equity securities",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)($6d2ffebabcd587a0$var$FieldGrid, {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)($6d2ffebabcd587a0$var$Field, {
                                label: "ETFs Add-On",
                                value: config.assetTypeAddOns.etfs,
                                onChange: (v)=>ch('etfs', v),
                                suffix: "%",
                                hint: "All ETF types"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)($6d2ffebabcd587a0$var$Field, {
                                label: "Bonds Add-On",
                                value: config.assetTypeAddOns.bonds,
                                onChange: (v)=>ch('bonds', v),
                                suffix: "%",
                                hint: "All bond types"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)($6d2ffebabcd587a0$var$Field, {
                                label: "Mutual Funds Add-On",
                                value: config.assetTypeAddOns.mutualFunds,
                                onChange: (v)=>ch('mutualFunds', v),
                                suffix: "%",
                                hint: "Standard mutual funds"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)($6d2ffebabcd587a0$var$Field, {
                                label: "Options Add-On",
                                value: config.assetTypeAddOns.options,
                                onChange: (v)=>ch('options', v),
                                suffix: "%",
                                hint: "Options strategies"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)($6d2ffebabcd587a0$var$FieldGrid, {
                        cols: 1,
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)($6d2ffebabcd587a0$var$Field, {
                            label: "Other Securities Add-On",
                            value: config.assetTypeAddOns.other,
                            onChange: (v)=>ch('other', v),
                            suffix: "%",
                            hint: "Other marginable securities"
                        })
                    })
                ]
            })
        ]
    });
}
function $6d2ffebabcd587a0$var$MarketCapTab({ config: config, onChange: onChange }) {
    const fmtNum = (v)=>new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 0
        }).format(v);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "grid grid-cols-2 gap-4 max-[768px]:grid-cols-1",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)($6d2ffebabcd587a0$var$Section, {
                title: "Market Cap Definitions",
                sub: "Define thresholds for equity categorisation",
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    className: "flex flex-col gap-4",
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)($6d2ffebabcd587a0$var$Field, {
                            label: "Large Cap Threshold",
                            value: config.marketCapDefinitions.largeCap,
                            onChange: (v)=>onChange('marketCapDefinitions', 'largeCap', v),
                            prefix: "$",
                            hint: `Currently: ${fmtNum(config.marketCapDefinitions.largeCap)}`
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)($6d2ffebabcd587a0$var$Field, {
                            label: "Mid Cap Lower Threshold",
                            value: config.marketCapDefinitions.midCap,
                            onChange: (v)=>onChange('marketCapDefinitions', 'midCap', v),
                            prefix: "$",
                            hint: `Currently: ${fmtNum(config.marketCapDefinitions.midCap)}`
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                            className: "text-[12px] text-[#7A7A76] mt-1",
                            children: [
                                "Small cap is defined as below ",
                                fmtNum(config.marketCapDefinitions.smallCap)
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)($6d2ffebabcd587a0$var$Section, {
                title: "Volatility & Price Thresholds",
                sub: "Define risk classification thresholds",
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    className: "flex flex-col gap-4",
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)($6d2ffebabcd587a0$var$Field, {
                            label: "Volatile Stock Threshold",
                            value: config.volatilityThresholds.volatileStock,
                            onChange: (v)=>onChange('volatilityThresholds', 'volatileStock', v),
                            suffix: "%",
                            hint: "30-day annualised volatility threshold"
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)($6d2ffebabcd587a0$var$Field, {
                            label: "Penny Stock Price Threshold",
                            value: config.volatilityThresholds.pennyStock,
                            onChange: (v)=>onChange('volatilityThresholds', 'pennyStock', v),
                            prefix: "$",
                            hint: "Below this price = penny stock"
                        })
                    ]
                })
            })
        ]
    });
}
function $6d2ffebabcd587a0$var$ConcentrationTab({ config: config, onChange: onChange }) {
    const ch = (f, v)=>onChange('concentrationAddOns', f, v);
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: "max-w-[640px]",
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($6d2ffebabcd587a0$var$Section, {
            title: "Concentration Add-Ons",
            sub: "Additional requirements for concentrated positions",
            children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "flex flex-col gap-4",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)($6d2ffebabcd587a0$var$Field, {
                        label: "Single Position >30% Add-On",
                        value: config.concentrationAddOns.singlePosition30Percent,
                        onChange: (v)=>ch('singlePosition30Percent', v),
                        suffix: "%",
                        hint: "Applied when a single position exceeds 30% of the portfolio"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)($6d2ffebabcd587a0$var$Field, {
                        label: "Single Position >50% Add-On",
                        value: config.concentrationAddOns.singlePosition50Percent,
                        onChange: (v)=>ch('singlePosition50Percent', v),
                        suffix: "%",
                        hint: "Applied when a single position exceeds 50% of the portfolio"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)($6d2ffebabcd587a0$var$Field, {
                        label: "Top 3 Positions >70% Add-On",
                        value: config.concentrationAddOns.top3Positions70Percent,
                        onChange: (v)=>ch('top3Positions70Percent', v),
                        suffix: "%",
                        hint: "Applied to concentrated positions when top 3 combined exceed 70%"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)($6d2ffebabcd587a0$var$InfoBanner, {
                        children: "The higher of single position add-ons will be applied. The top 3 positions add-on applies to positions with individual weight greater than 20%."
                    })
                ]
            })
        })
    });
}
function $6d2ffebabcd587a0$var$WarningThresholdsTab({ config: config, onChange: onChange }) {
    const ch = (f, v)=>onChange('warningThresholds', f, v);
    return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: "max-w-[640px]",
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)($6d2ffebabcd587a0$var$Section, {
            title: "Warning Thresholds",
            sub: "Surplus cushion thresholds for alert generation",
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsxs)($6d2ffebabcd587a0$var$FieldGrid, {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)($6d2ffebabcd587a0$var$Field, {
                            label: "Green Zone (Safe)",
                            value: config.warningThresholds.greenZone,
                            onChange: (v)=>ch('greenZone', v),
                            suffix: "%",
                            hint: "Above this = Green status"
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)($6d2ffebabcd587a0$var$Field, {
                            label: "Amber Alert Zone",
                            value: config.warningThresholds.amberAlertZone,
                            onChange: (v)=>ch('amberAlertZone', v),
                            suffix: "%",
                            hint: "Down to this = Amber Alert status"
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)($6d2ffebabcd587a0$var$Field, {
                            label: "Red Alert Zone",
                            value: config.warningThresholds.redAlertZone,
                            onChange: (v)=>ch('redAlertZone', v),
                            suffix: "%",
                            hint: "Down to this = Red Alert status"
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)($6d2ffebabcd587a0$var$Field, {
                            label: "Critical Zone",
                            value: config.warningThresholds.criticalZone,
                            onChange: (v)=>ch('criticalZone', v),
                            suffix: "%",
                            hint: "At or below = Critical status"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)($6d2ffebabcd587a0$var$InfoBanner, {
                    variant: "warn",
                    children: "Critical alerts and potential liquidation procedures are triggered when a portfolio enters the Critical Zone."
                })
            ]
        })
    });
}
/* ── Main component ──────────────────────────────────────────── */ const $6d2ffebabcd587a0$var$AdminPanel = ()=>{
    const [config, setConfig] = (0, $7fPBF.useState)((0, $0cb5891b02835d37$export$b555d33f86028caa));
    const [isDirty, setIsDirty] = (0, $7fPBF.useState)(false);
    const [saveSuccess, setSaveSuccess] = (0, $7fPBF.useState)(false);
    const [activeTab, setActiveTab] = (0, $7fPBF.useState)('user-management');
    const handleChange = (section, field, value)=>{
        setConfig((prev)=>({
                ...prev,
                [section]: {
                    ...prev[section],
                    [field]: value
                }
            }));
        setIsDirty(true);
    };
    const handleSave = ()=>{
        setConfig((prev)=>({
                ...prev,
                lastUpdated: new Date(),
                updatedBy: 'Relationship Manager'
            }));
        setIsDirty(false);
        setSaveSuccess(true);
        setTimeout(()=>setSaveSuccess(false), 4000);
    };
    const handleReset = ()=>{
        setConfig((0, $0cb5891b02835d37$export$b555d33f86028caa));
        setIsDirty(true);
    };
    const activeTabConfig = $6d2ffebabcd587a0$var$TABS.find((t)=>t.id === activeTab);
    const showActions = $6d2ffebabcd587a0$var$CONFIG_TABS.has(activeTab);
    const renderContent = ()=>{
        switch(activeTab){
            case 'user-management':
                return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5b93540a907aee00$export$2e2bcd8739ae039), {});
            case 'arm-assignments':
                return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $13ea3d39f77be8c5$export$2e2bcd8739ae039), {});
            case 'ic-overrides':
                return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c51968fca3e6be74$export$2e2bcd8739ae039), {});
            case 'email-templates':
                return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2614abc3cd2a6416$export$2e2bcd8739ae039), {});
            case 'asset-types':
                return /*#__PURE__*/ (0, $bbzbN.jsx)($6d2ffebabcd587a0$var$AssetTypesTab, {
                    config: config,
                    onChange: handleChange
                });
            case 'market-cap':
                return /*#__PURE__*/ (0, $bbzbN.jsx)($6d2ffebabcd587a0$var$MarketCapTab, {
                    config: config,
                    onChange: handleChange
                });
            case 'concentration':
                return /*#__PURE__*/ (0, $bbzbN.jsx)($6d2ffebabcd587a0$var$ConcentrationTab, {
                    config: config,
                    onChange: handleChange
                });
            case 'warning-thresholds':
                return /*#__PURE__*/ (0, $bbzbN.jsx)($6d2ffebabcd587a0$var$WarningThresholdsTab, {
                    config: config,
                    onChange: handleChange
                });
            case 'margin-trading-overrides':
                return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d06229554f503268$export$2e2bcd8739ae039), {});
            default:
                return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5b93540a907aee00$export$2e2bcd8739ae039), {});
        }
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "flex min-h-screen overflow-hidden",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("aside", {
                className: "w-[260px] min-w-[260px] bg-white border-r border-black/[0.08] flex flex-col sticky top-0 h-screen",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "px-4 pt-4 pb-3.5 border-b border-black/[0.06] shrink-0",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "text-[9.5px] font-bold tracking-[0.14em] uppercase text-[#E50025]",
                                children: "Admin Panel"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "text-[12px] text-[#7A7A76] mt-1",
                                children: "Select a category to configure"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("nav", {
                        className: "flex flex-col gap-px p-2.5 flex-1 overflow-y-auto",
                        children: $6d2ffebabcd587a0$var$TABS.map((tab)=>{
                            const active = activeTab === tab.id;
                            return /*#__PURE__*/ (0, $bbzbN.jsxs)("button", {
                                onClick: ()=>setActiveTab(tab.id),
                                className: `flex items-start gap-3 px-3 py-2.5 text-left w-full border-0 bg-transparent cursor-pointer rounded-sm relative transition-colors duration-[120ms] ${active ? 'bg-[#FAF9F8] text-[#E50025]' : 'text-[#333] hover:bg-[#FAF9F8] hover:text-black'}`,
                                children: [
                                    active && /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                        className: "absolute left-0 top-2 bottom-2 w-0.5 bg-[#E50025]"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                        name: tab.icon,
                                        size: 14,
                                        className: `shrink-0 mt-0.5 ${active ? 'opacity-100' : 'opacity-60'}`
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                        className: "min-w-0",
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                className: `text-[13px] leading-snug ${active ? 'font-semibold' : 'font-normal'}`,
                                                children: tab.label
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                className: "text-[11px] text-[#7A7A76] mt-0.5 leading-snug",
                                                children: tab.description
                                            })
                                        ]
                                    })
                                ]
                            }, tab.id);
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "border-t border-black/[0.06] px-4 py-3 shrink-0",
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                            className: "text-[10.5px] text-[#7A7A76]",
                            children: [
                                "Last saved: ",
                                config.lastUpdated.toLocaleString()
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "flex-1 flex flex-col overflow-hidden min-w-0",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "bg-white border-b border-black/[0.08] px-6 py-4 flex items-start justify-between gap-4 shrink-0",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("h2", {
                                        className: "font-serif text-[26px] font-normal tracking-[-0.01em] leading-tight m-0",
                                        children: activeTabConfig?.label
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                        className: "text-[13px] text-[#7A7A76] mt-1",
                                        children: activeTabConfig?.description
                                    })
                                ]
                            }),
                            showActions && /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                className: "flex gap-2 shrink-0 mt-1",
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                                        variant: "outline",
                                        size: "sm",
                                        onClick: handleReset,
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                                name: "refresh",
                                                size: 12
                                            }),
                                            " Reset to Defaults"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                                        variant: "primary",
                                        size: "sm",
                                        onClick: handleSave,
                                        disabled: !isDirty,
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                                name: "check",
                                                size: 12
                                            }),
                                            " Save Configuration"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    isDirty && showActions && /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "flex items-center gap-2.5 px-6 py-2.5 text-[12.5px] font-medium text-[#b6770b] bg-[rgba(255,191,0,0.10)] border-b border-[rgba(182,119,11,0.28)] shrink-0",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                name: "warn",
                                size: 14,
                                className: "shrink-0"
                            }),
                            "Unsaved changes \u2014 save before switching tabs or leaving this page."
                        ]
                    }),
                    saveSuccess && /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "flex items-center gap-2.5 px-6 py-2.5 text-[12.5px] font-medium text-[#1f8a4a] bg-[rgba(31,138,74,0.08)] border-b border-[rgba(31,138,74,0.28)] shrink-0",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                name: "check",
                                size: 14,
                                className: "shrink-0"
                            }),
                            "Configuration saved successfully."
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "flex-1 overflow-auto p-6",
                        children: renderContent()
                    })
                ]
            })
        ]
    });
};
var $6d2ffebabcd587a0$export$2e2bcd8739ae039 = $6d2ffebabcd587a0$var$AdminPanel;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");




const $fc99a9134d54b89c$var$ExposureAnalysis = ()=>{
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const [view, setView] = (0, $7fPBF.useState)('security');
    const [search, setSearch] = (0, $7fPBF.useState)('');
    const [expanded, setExpanded] = (0, $7fPBF.useState)(new Set());
    const [sortField, setSortField] = (0, $7fPBF.useState)('total_mv');
    const [sortDir, setSortDir] = (0, $7fPBF.useState)('desc');
    const [holderSortField, setHolderSortField] = (0, $7fPBF.useState)('mkt_val');
    const [holderSortDir, setHolderSortDir] = (0, $7fPBF.useState)('desc');
    const [portfoliosData, setPortfoliosData] = (0, $7fPBF.useState)([]);
    const [portfolioDetails, setPortfolioDetails] = (0, $7fPBF.useState)(new Map());
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const fetchData = (0, $7fPBF.useCallback)(async ()=>{
        try {
            setLoading(true);
            setError(null);
            const [portfolios, details] = await Promise.all([
                (0, $2b61471e8e825f6c$export$2e2bcd8739ae039).getPortfolios(),
                (0, $2b61471e8e825f6c$export$2e2bcd8739ae039).getAllPortfolioDetails()
            ]);
            setPortfoliosData(portfolios);
            const detailsMap = new Map();
            details.forEach((d)=>detailsMap.set(d.portfolio_id_lig, d));
            setPortfolioDetails(detailsMap);
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Failed to fetch data');
        } finally{
            setLoading(false);
        }
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        fetchData();
    }, [
        fetchData
    ]);
    const bySecurity = (0, $7fPBF.useMemo)(()=>{
        const totalAUM = portfoliosData.reduce((s, p)=>s + (p.cash_account_equity || 0) + (p.margin_account_equity || 0), 0);
        const map = {};
        portfolioDetails.forEach((detail, portfolioId)=>{
            const summary = portfoliosData.find((p)=>p.portfolio_id_lig === portfolioId);
            detail.positions.forEach((pos)=>{
                const k = pos.cusip || pos.security_name;
                if (!map[k]) map[k] = {
                    cusip: pos.cusip,
                    ticker: pos.ticker,
                    name: pos.security_name,
                    type: pos.security_type,
                    total_mv: 0,
                    total_qty: 0,
                    total_margin_req: 0,
                    total_lc_req: 0,
                    risk_contribution: 0,
                    concentration_risk: 'LOW',
                    holders: []
                };
                map[k].total_mv += pos.market_value || 0;
                map[k].total_qty += pos.quantity || 0;
                map[k].total_margin_req += pos.pershing_requirement || 0;
                map[k].total_lc_req += pos.position_lc_margin_requirement || 0;
                map[k].holders.push({
                    portfolio_id: portfolioId,
                    client: summary?.client_name || 'Unknown',
                    rm: summary?.rm_name || null,
                    quantity: pos.quantity,
                    market_value: pos.market_value,
                    weight: pos.weight
                });
            });
        });
        return Object.values(map).map((s)=>{
            const weight = totalAUM > 0 ? s.total_mv / totalAUM * 100 : 0;
            s.risk_contribution = totalAUM > 0 ? s.total_lc_req / totalAUM * 100 : 0;
            s.concentration_risk = weight > 5 || s.holders.length > 3 ? 'HIGH' : weight > 2 || s.holders.length > 2 ? 'MEDIUM' : 'LOW';
            return s;
        }).sort((a, b)=>b.total_mv - a.total_mv);
    }, [
        portfoliosData,
        portfolioDetails
    ]);
    const byType = (0, $7fPBF.useMemo)(()=>{
        const map = {};
        bySecurity.forEach((s)=>{
            const t = s.type || 'OTHER';
            if (!map[t]) map[t] = {
                type: t,
                mv: 0,
                securities: 0,
                holders: 0
            };
            map[t].mv += s.total_mv;
            map[t].securities++;
            map[t].holders += s.holders.length;
        });
        return Object.values(map).sort((a, b)=>b.mv - a.mv);
    }, [
        bySecurity
    ]);
    const totalMV = bySecurity.reduce((s, x)=>s + x.total_mv, 0);
    const onSort = (f)=>{
        const field = f;
        if (sortField === field) setSortDir((d)=>d === 'asc' ? 'desc' : 'asc');
        else {
            setSortField(field);
            setSortDir('desc');
        }
    };
    const onHolderSort = (f)=>{
        const field = f;
        if (holderSortField === field) setHolderSortDir((d)=>d === 'asc' ? 'desc' : 'asc');
        else {
            setHolderSortField(field);
            setHolderSortDir('desc');
        }
    };
    const sortHolders = (holders)=>{
        return [
            ...holders
        ].sort((a, b)=>{
            let av, bv;
            switch(holderSortField){
                case 'portfolio':
                    av = a.portfolio_id;
                    bv = b.portfolio_id;
                    break;
                case 'client':
                    av = a.client;
                    bv = b.client;
                    break;
                case 'rm':
                    av = a.rm ?? '';
                    bv = b.rm ?? '';
                    break;
                case 'qty':
                    av = a.quantity ?? 0;
                    bv = b.quantity ?? 0;
                    break;
                case 'mkt_val':
                    av = a.market_value ?? 0;
                    bv = b.market_value ?? 0;
                    break;
                case 'weight':
                    av = a.weight ?? 0;
                    bv = b.weight ?? 0;
                    break;
                default:
                    return 0;
            }
            if (av < bv) return holderSortDir === 'asc' ? -1 : 1;
            if (av > bv) return holderSortDir === 'asc' ? 1 : -1;
            return 0;
        });
    };
    const filtered = (0, $7fPBF.useMemo)(()=>{
        let arr = bySecurity.filter((s)=>{
            if (!search) return true;
            const q = search.toLowerCase();
            return (s.name || '').toLowerCase().includes(q) || (s.cusip || '').toLowerCase().includes(q) || (s.ticker || '').toLowerCase().includes(q);
        });
        arr.sort((a, b)=>{
            let av, bv;
            switch(sortField){
                case 'name':
                    av = a.name;
                    bv = b.name;
                    break;
                case 'total_mv':
                    av = a.total_mv;
                    bv = b.total_mv;
                    break;
                case 'total_qty':
                    av = a.total_qty;
                    bv = b.total_qty;
                    break;
                case 'holders':
                    av = a.holders.length;
                    bv = b.holders.length;
                    break;
                case 'pct':
                    av = a.total_mv;
                    bv = b.total_mv;
                    break;
                case 'margin_req':
                    av = a.total_margin_req;
                    bv = b.total_margin_req;
                    break;
                case 'lc_req':
                    av = a.total_lc_req;
                    bv = b.total_lc_req;
                    break;
                case 'risk_contrib':
                    av = a.risk_contribution;
                    bv = b.risk_contribution;
                    break;
                default:
                    av = 0;
                    bv = 0;
            }
            if (av < bv) return sortDir === 'asc' ? -1 : 1;
            if (av > bv) return sortDir === 'asc' ? 1 : -1;
            return 0;
        });
        return arr;
    }, [
        bySecurity,
        search,
        sortField,
        sortDir
    ]);
    const toggle = (key)=>{
        setExpanded((prev)=>{
            const n = new Set(prev);
            n.has(key) ? n.delete(key) : n.add(key);
            return n;
        });
    };
    if (loading) return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).page} flex items-center justify-center min-h-[400px] flex-col gap-3`,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).muted,
            children: "Loading exposure data\u2026 This may take a moment."
        })
    });
    if (error) return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).page,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "bg-[rgba(229,0,37,0.06)] border border-[#E50025] px-[22px] py-[18px] mb-4",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "font-bold text-[#E50025] text-[12px] tracking-[0.12em] uppercase mb-1.5",
                        children: "Error"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        style: {
                            fontSize: 13
                        },
                        children: error
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                variant: "primary",
                size: "sm",
                onClick: fetchData,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                        name: "refresh",
                        size: 12
                    }),
                    " Retry"
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).page,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).pageHead,
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)("h1", {
                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).pageH1,
                            children: "Exposure Analysis"
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).pageSub,
                            children: "Cross-portfolio exposure by security or asset class \u2014 drill in to see every holder."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "flex flex-wrap gap-3 mb-[18px]",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "bg-white border border-black/[0.06] border-t-2 border-t-[#E50025] p-[12px_14px] flex flex-col relative flex-[1_1_140px] min-w-0",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "text-[9.5px] font-bold tracking-[0.14em] uppercase text-[#7A7A76]",
                                children: "Total Exposure"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "font-serif font-normal text-[22px] leading-tight mt-1.5 tracking-[-0.01em] [font-feature-settings:'tnum']",
                                children: (0, $e4bf7e7a647cb901$export$217e472da3f6c211)(totalMV)
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                className: "mt-1.5 text-[10.5px] text-[#7A7A76]",
                                children: [
                                    "across ",
                                    bySecurity.length,
                                    " securities"
                                ]
                            })
                        ]
                    }),
                    byType.slice(0, 3).map((t)=>/*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                            className: "bg-white border border-black/[0.06] p-[12px_14px] flex flex-col relative flex-[1_1_140px] min-w-0",
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                    className: "text-[9.5px] font-bold tracking-[0.14em] uppercase text-[#7A7A76]",
                                    children: t.type
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                    className: "font-serif font-normal text-[22px] leading-tight mt-1.5 tracking-[-0.01em] [font-feature-settings:'tnum']",
                                    children: (0, $e4bf7e7a647cb901$export$217e472da3f6c211)(t.mv)
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                    className: "mt-1.5 text-[10.5px] text-[#7A7A76]",
                                    children: [
                                        t.securities,
                                        " securities \xb7 ",
                                        (0, $e4bf7e7a647cb901$export$850409532323fff)(totalMV > 0 ? t.mv / totalMV : 0, 1),
                                        " of total"
                                    ]
                                })
                            ]
                        }, t.type))
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "flex gap-0 border-b border-black/10 mb-[22px]",
                children: [
                    'security',
                    'type'
                ].map((v, i)=>/*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                        className: `bg-transparent border-0 px-[18px] py-3 text-[12px] font-semibold tracking-[0.04em] cursor-pointer relative inline-flex items-center gap-2 transition-colors ${view === v ? 'text-[#E50025] after:absolute after:content-[\'\'] after:left-3 after:right-3 after:-bottom-px after:h-0.5 after:bg-[#E50025]' : 'text-[#333] hover:text-black'}`,
                        onClick: ()=>setView(v),
                        children: v === 'security' ? 'By Security' : 'By Asset Class'
                    }, v))
            }),
            view === 'security' && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).surface} p-[14px_16px] mb-3.5`,
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).field,
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)("label", {
                                    className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).fieldLabel,
                                    children: "Search"
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                    className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).inputWrap,
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                            name: "search",
                                            size: 14,
                                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).inputIco
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                                            className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input} pl-[38px]`,
                                            placeholder: "Security, CUSIP, ticker\u2026",
                                            value: search,
                                            onChange: (e)=>setSearch(e.target.value)
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tableWrap,
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("table", {
                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).table,
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)("thead", {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                                style: {
                                                    width: 110
                                                },
                                                children: "CUSIP"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$f8f69345c94a0646), {
                                                label: "Security",
                                                field: "name",
                                                active: sortField === 'name',
                                                dir: sortDir,
                                                onClick: onSort
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                                children: "Type"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$f8f69345c94a0646), {
                                                label: "Total Exposure",
                                                field: "total_mv",
                                                active: sortField === 'total_mv',
                                                dir: sortDir,
                                                onClick: onSort,
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$f8f69345c94a0646), {
                                                label: "Total Weight",
                                                field: "pct",
                                                active: sortField === 'pct',
                                                dir: sortDir,
                                                onClick: onSort,
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$f8f69345c94a0646), {
                                                label: "Pershing Req",
                                                field: "margin_req",
                                                active: sortField === 'margin_req',
                                                dir: sortDir,
                                                onClick: onSort,
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$f8f69345c94a0646), {
                                                label: "LC Req",
                                                field: "lc_req",
                                                active: sortField === 'lc_req',
                                                dir: sortDir,
                                                onClick: onSort,
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$f8f69345c94a0646), {
                                                label: "Risk Contrib",
                                                field: "risk_contrib",
                                                active: sortField === 'risk_contrib',
                                                dir: sortDir,
                                                onClick: onSort,
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                                children: "Conc. Risk"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$f8f69345c94a0646), {
                                                label: "Portfolios",
                                                field: "holders",
                                                active: sortField === 'holders',
                                                dir: sortDir,
                                                onClick: onSort,
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                                style: {
                                                    width: 40
                                                }
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $bbzbN.jsxs)("tbody", {
                                    children: [
                                        filtered.map((s)=>{
                                            const key = s.cusip || s.name;
                                            const isExpanded = expanded.has(key);
                                            return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0, $bbzbN.jsxs)("tr", {
                                                        className: "group cursor-pointer transition-colors hover:bg-[rgba(229,0,37,0.04)]",
                                                        onClick: ()=>toggle(key),
                                                        children: [
                                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdMono}`,
                                                                children: s.cusip || "\u2014"
                                                            }),
                                                            /*#__PURE__*/ (0, $bbzbN.jsxs)("td", {
                                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                                children: [
                                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                                        className: "font-medium",
                                                                        children: s.name
                                                                    }),
                                                                    s.ticker && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdMono} text-[10px] ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).muted}`,
                                                                        children: s.ticker
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$de784d3a9b38c570), {
                                                                    variant: "outline",
                                                                    label: s.type || "\u2014"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum} font-semibold`,
                                                                children: (0, $e4bf7e7a647cb901$export$217e472da3f6c211)(s.total_mv)
                                                            }),
                                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                                                children: totalMV > 0 ? (0, $e4bf7e7a647cb901$export$850409532323fff)(s.total_mv / totalMV, 2) : "\u2014"
                                                            }),
                                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                                                children: (0, $e4bf7e7a647cb901$export$217e472da3f6c211)(s.total_margin_req)
                                                            }),
                                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                                                children: (0, $e4bf7e7a647cb901$export$217e472da3f6c211)(s.total_lc_req)
                                                            }),
                                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                                                children: (0, $e4bf7e7a647cb901$export$850409532323fff)(s.risk_contribution / 100, 2)
                                                            }),
                                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                                    className: `inline-flex items-center px-[7px] py-[2px] text-[9.5px] font-bold tracking-[0.06em] uppercase text-white ${s.concentration_risk === 'HIGH' ? 'bg-[#E50025]' : s.concentration_risk === 'MEDIUM' ? 'bg-[#F5A623]' : 'bg-[#1f8a4a]'}`,
                                                                    children: s.concentration_risk
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                                                children: s.holders.length
                                                            }),
                                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                                                    name: "chevron",
                                                                    size: 14,
                                                                    className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).muted} block transition-transform ${isExpanded ? 'rotate-180' : ''}`
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    isExpanded && /*#__PURE__*/ (0, $bbzbN.jsx)("tr", {
                                                        className: "bg-[#FAF9F8]",
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("td", {
                                                            colSpan: 11,
                                                            className: "px-[22px] py-4",
                                                            children: [
                                                                /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                                                    className: "text-[10px] font-bold tracking-[0.16em] uppercase text-[#7A7A76] mb-2",
                                                                    children: [
                                                                        "Portfolios (",
                                                                        s.holders.length,
                                                                        ")"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $bbzbN.jsxs)("table", {
                                                                    className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).table} bg-transparent`,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, $bbzbN.jsx)("thead", {
                                                                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)("tr", {
                                                                                style: {
                                                                                    background: 'transparent'
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$f8f69345c94a0646), {
                                                                                        label: "Portfolio",
                                                                                        field: "portfolio",
                                                                                        active: holderSortField === 'portfolio',
                                                                                        dir: holderSortDir,
                                                                                        onClick: onHolderSort
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$f8f69345c94a0646), {
                                                                                        label: "Client",
                                                                                        field: "client",
                                                                                        active: holderSortField === 'client',
                                                                                        dir: holderSortDir,
                                                                                        onClick: onHolderSort
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$f8f69345c94a0646), {
                                                                                        label: "RM",
                                                                                        field: "rm",
                                                                                        active: holderSortField === 'rm',
                                                                                        dir: holderSortDir,
                                                                                        onClick: onHolderSort
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$f8f69345c94a0646), {
                                                                                        label: "Quantity",
                                                                                        field: "qty",
                                                                                        active: holderSortField === 'qty',
                                                                                        dir: holderSortDir,
                                                                                        onClick: onHolderSort,
                                                                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$f8f69345c94a0646), {
                                                                                        label: "Market Value",
                                                                                        field: "mkt_val",
                                                                                        active: holderSortField === 'mkt_val',
                                                                                        dir: holderSortDir,
                                                                                        onClick: onHolderSort,
                                                                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$f8f69345c94a0646), {
                                                                                        label: "Weight",
                                                                                        field: "weight",
                                                                                        active: holderSortField === 'weight',
                                                                                        dir: holderSortDir,
                                                                                        onClick: onHolderSort,
                                                                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, $bbzbN.jsx)("tbody", {
                                                                            children: sortHolders(s.holders).map((h, i)=>/*#__PURE__*/ (0, $bbzbN.jsxs)("tr", {
                                                                                    className: "group cursor-pointer transition-colors hover:bg-[rgba(229,0,37,0.04)]",
                                                                                    onClick: (e)=>{
                                                                                        e.stopPropagation();
                                                                                        navigate(`/portfolio/${h.portfolio_id}`);
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                                                            className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdMono}`,
                                                                                            children: h.portfolio_id
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                                                            className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdClient}`,
                                                                                            children: h.client
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                                                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                                                            children: h.rm || "\u2014"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                                                            className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                                                                            children: (0, $e4bf7e7a647cb901$export$79b4d5b1a469ce61)(h.quantity)
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                                                            className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                                                                            children: (0, $e4bf7e7a647cb901$export$217e472da3f6c211)(h.market_value)
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                                                            className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                                                                            children: h.weight != null ? `${(h.weight * 100).toFixed(2)}%` : "\u2014"
                                                                                        })
                                                                                    ]
                                                                                }, i))
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }, key);
                                        }),
                                        filtered.length === 0 && /*#__PURE__*/ (0, $bbzbN.jsx)("tr", {
                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                colSpan: 11,
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).muted}`,
                                                style: {
                                                    padding: 30,
                                                    textAlign: 'center'
                                                },
                                                children: "No securities match."
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            view === 'type' && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tableWrap,
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)("table", {
                    className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).table,
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                        children: "Asset Class"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                        children: "Distribution"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                        children: "Total Exposure"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                        children: "Securities"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                        children: "Holdings"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                        children: "% of Book"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("tbody", {
                            children: byType.map((t)=>/*#__PURE__*/ (0, $bbzbN.jsxs)("tr", {
                                    className: "transition-colors hover:bg-[#FAF9F8]",
                                    children: [
                                        /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$de784d3a9b38c570), {
                                                variant: "outline",
                                                label: t.type
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                className: "h-2 bg-black/[0.06] w-[280px] relative",
                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                    className: "absolute inset-0 bg-[#E50025]",
                                                    style: {
                                                        width: `${totalMV > 0 ? t.mv / totalMV * 100 : 0}%`
                                                    }
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                            className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum} font-semibold`,
                                            children: (0, $e4bf7e7a647cb901$export$217e472da3f6c211)(t.mv)
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                            className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                            children: t.securities
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                            className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                            children: t.holders
                                        }),
                                        /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                            className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                            children: totalMV > 0 ? (0, $e4bf7e7a647cb901$export$850409532323fff)(t.mv / totalMV, 2) : "\u2014"
                                        })
                                    ]
                                }, t.type))
                        })
                    ]
                })
            })
        ]
    });
};
var $fc99a9134d54b89c$export$2e2bcd8739ae039 = $fc99a9134d54b89c$var$ExposureAnalysis;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");




function $22dce6565050ebe5$var$timeAgo(ts) {
    const m = Math.floor((Date.now() - new Date(ts).getTime()) / 60000);
    if (m < 1) return 'just now';
    if (m < 60) return `${m}m ago`;
    const h = Math.floor(m / 60);
    if (h < 24) return `${h}h ago`;
    return `${Math.floor(h / 24)}d ago`;
}
function $22dce6565050ebe5$var$fmtPctVal(v) {
    if (v == null) return "\u2014";
    return `${(v * 100).toFixed(2)}%`;
}
function $22dce6565050ebe5$var$normalizeStatus(s) {
    if (!s) return '';
    return s.toUpperCase().replace(/ /g, '_');
}
const $22dce6565050ebe5$var$SEVERITY_ORDER = [
    'HOUSE_CALL',
    'CRITICAL',
    'RED_ALERT',
    'AMBER_ALERT',
    'GREEN'
];
const $22dce6565050ebe5$var$AlertsView = ()=>{
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const [alerts, setAlerts] = (0, $7fPBF.useState)([]);
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const [acknowledgingAlerts, setAcknowledgingAlerts] = (0, $7fPBF.useState)(new Set());
    const [successMessage, setSuccessMessage] = (0, $7fPBF.useState)(null);
    (0, $7fPBF.useEffect)(()=>{
        fetchAlerts();
        const interval = setInterval(fetchAlerts, 30000);
        return ()=>clearInterval(interval);
    }, []);
    const fetchAlerts = async ()=>{
        try {
            const data = await (0, $2b61471e8e825f6c$export$d0204b1ddc8ee140).getAlerts();
            setAlerts(data);
            setError(null);
        } catch (err) {
            setError('Failed to fetch alerts. Please try again.');
        } finally{
            setLoading(false);
        }
    };
    const handleAcknowledge = async (portfolioId)=>{
        setAcknowledgingAlerts((prev)=>new Set(prev).add(portfolioId));
        try {
            await (0, $2b61471e8e825f6c$export$d0204b1ddc8ee140).acknowledgeAlert(portfolioId);
            setSuccessMessage(`Alert acknowledged and email sent for ${portfolioId}`);
            setTimeout(()=>setSuccessMessage(null), 5000);
            await fetchAlerts();
        } catch (err) {
            const msg = err?.response?.data?.detail || err?.message || 'Unknown error';
            setError(`Failed to acknowledge alert for ${portfolioId}: ${msg}`);
        } finally{
            setAcknowledgingAlerts((prev)=>{
                const n = new Set(prev);
                n.delete(portfolioId);
                return n;
            });
        }
    };
    const counts = alerts.reduce((acc, a)=>{
        const s = $22dce6565050ebe5$var$normalizeStatus(a.current_status);
        acc[s] = (acc[s] || 0) + 1;
        return acc;
    }, {});
    const sortedAlerts = [
        ...alerts
    ].sort((a, b)=>{
        const ai = $22dce6565050ebe5$var$SEVERITY_ORDER.indexOf($22dce6565050ebe5$var$normalizeStatus(a.current_status));
        const bi = $22dce6565050ebe5$var$SEVERITY_ORDER.indexOf($22dce6565050ebe5$var$normalizeStatus(b.current_status));
        return (ai === -1 ? 99 : ai) - (bi === -1 ? 99 : bi);
    });
    if (loading) return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).page} flex items-center justify-center min-h-[400px]`,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).muted,
            children: "Loading alerts\u2026"
        })
    });
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).page,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).pageHead,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("h1", {
                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).pageH1,
                                children: "Margin Alerts"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).pageSub,
                                children: "Active margin escalations \u2014 portfolios actively margin trading with cushion (incl. cash) below thresholds."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).metaRow,
                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).meta,
                            children: [
                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                    name: "refresh",
                                    size: 14
                                }),
                                " Refreshing every 30s"
                            ]
                        })
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "bg-[rgba(229,0,37,0.06)] border border-[#E50025] px-4 py-3 mb-4 flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        style: {
                            fontSize: 13
                        },
                        children: error
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).iconBtn,
                        onClick: ()=>setError(null),
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                            name: "close",
                            size: 14
                        })
                    })
                ]
            }),
            successMessage && /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "bg-[rgba(31,138,74,0.08)] border border-[#1f8a4a] px-4 py-3 mb-4 flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        style: {
                            fontSize: 13,
                            color: '#1f8a4a'
                        },
                        children: successMessage
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).iconBtn,
                        onClick: ()=>setSuccessMessage(null),
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                            name: "close",
                            size: 14
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "grid grid-cols-5 gap-3 mb-[18px] max-[768px]:grid-cols-3 max-[480px]:grid-cols-2",
                children: $22dce6565050ebe5$var$SEVERITY_ORDER.map((s)=>/*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "bg-white border border-black/[0.06] px-4 py-3.5 flex items-center gap-3",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "w-1.5 self-stretch",
                                style: {
                                    background: (0, $e4bf7e7a647cb901$export$70f8d8d5d8881b35)[s]
                                }
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                        className: "font-serif text-[30px] font-normal leading-none",
                                        children: counts[s] || 0
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                        className: "text-[10px] font-bold tracking-[0.12em] uppercase text-[#7A7A76]",
                                        children: (0, $e4bf7e7a647cb901$export$a1176940376eb77f)[s]
                                    })
                                ]
                            })
                        ]
                    }, s))
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tableWrap,
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)("table", {
                    className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).table,
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $bbzbN.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                        children: "Created"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                        children: "Portfolio ID"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                        children: "Client"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                        children: "Status"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                        children: "Cushion (w/ Cash)"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                        children: "Initial Cushion"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                        children: "Change"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                        children: "LC Req."
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                        children: "Total AUM"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                        children: "RM"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("th", {
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).th,
                                        style: {
                                            textAlign: 'right',
                                            width: 160
                                        },
                                        children: "Actions"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsxs)("tbody", {
                            children: [
                                sortedAlerts.map((a)=>{
                                    const change = a.surplus_cushion_with_cash_change;
                                    return /*#__PURE__*/ (0, $bbzbN.jsxs)("tr", {
                                        className: "transition-colors hover:bg-[#FAF9F8]",
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).muted}`,
                                                style: {
                                                    whiteSpace: 'nowrap'
                                                },
                                                children: $22dce6565050ebe5$var$timeAgo(a.alert_created_at)
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdMono}`,
                                                children: a.portfolio_id_lig
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdClient}`,
                                                children: a.client_name || "\u2014"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$de784d3a9b38c570), {
                                                    status: a.current_status
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                                style: {
                                                    fontWeight: 600
                                                },
                                                children: $22dce6565050ebe5$var$fmtPctVal(a.surplus_cushion_with_cash)
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).muted}`,
                                                children: $22dce6565050ebe5$var$fmtPctVal(a.initial_surplus_cushion_with_cash)
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                                style: {
                                                    color: change != null ? change < 0 ? '#E50025' : '#1f8a4a' : undefined
                                                },
                                                children: change != null ? `${change < 0 ? "\u25BC" : "\u25B2"} ${Math.abs(change * 100).toFixed(2)}%` : "\u2014"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                                children: (0, $e4bf7e7a647cb901$export$217e472da3f6c211)(a.lc_margin_requirement)
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).tdNum}`,
                                                children: (0, $e4bf7e7a647cb901$export$217e472da3f6c211)(a.total_aum)
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                children: a.rm_name || "\u2014"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsxs)("td", {
                                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td,
                                                style: {
                                                    textAlign: 'right'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                                                        variant: "ghost",
                                                        size: "sm",
                                                        onClick: ()=>navigate(`/portfolio/${a.portfolio_id_lig}`),
                                                        children: [
                                                            "View ",
                                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                                                name: "arrow",
                                                                size: 12
                                                            })
                                                        ]
                                                    }),
                                                    a.is_acknowledged ? /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).chip} bg-transparent border border-black/[0.18] text-[#1f8a4a] border-[rgba(31,138,74,0.32)] ml-2`,
                                                        children: [
                                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                                                name: "check",
                                                                size: 11
                                                            }),
                                                            " Acknowledged"
                                                        ]
                                                    }) : /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                                                        variant: "primary",
                                                        size: "sm",
                                                        className: "ml-2",
                                                        onClick: ()=>handleAcknowledge(a.portfolio_id_lig),
                                                        disabled: acknowledgingAlerts.has(a.portfolio_id_lig),
                                                        children: [
                                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                                                name: "mail",
                                                                size: 12
                                                            }),
                                                            acknowledgingAlerts.has(a.portfolio_id_lig) ? "\u2026" : 'Acknowledge'
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, a.id);
                                }),
                                sortedAlerts.length === 0 && /*#__PURE__*/ (0, $bbzbN.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)("td", {
                                        colSpan: 11,
                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).td} ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).muted}`,
                                        style: {
                                            padding: 30,
                                            textAlign: 'center'
                                        },
                                        children: "No active alerts at this time."
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: `mt-6 text-[12px] ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).muted} leading-[1.7]`,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "font-bold mb-1 uppercase tracking-[0.1em] text-[10px]",
                        children: "Column Notes"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("strong", {
                                children: "Cushion (w/ Cash):"
                            }),
                            " Latest surplus cushion including cash & cash equivalents \u2014 used for alert triggering."
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("strong", {
                                children: "Initial Cushion:"
                            }),
                            " Cushion when current status level was entered (resets on status change)."
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("strong", {
                                children: "Change:"
                            }),
                            " Delta since entering current status level."
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "mt-1.5",
                        children: "Alerts are removed when portfolios return to Green or stop margin trading."
                    })
                ]
            })
        ]
    });
};
var $22dce6565050ebe5$export$2e2bcd8739ae039 = $22dce6565050ebe5$var$AlertsView;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");





const $689aec7135517418$var$fmtTs = (ts)=>new Date(ts).toLocaleString('en-US', {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
    });
function $689aec7135517418$var$surplusStyle(v) {
    if (v == null) return {
        color: '#7A7A76',
        borderColor: 'rgba(0,0,0,0.15)',
        background: 'transparent'
    };
    const pct = v * 100;
    if (pct > 25) return {
        color: '#1f8a4a',
        borderColor: 'rgba(31,138,74,0.35)',
        background: 'rgba(31,138,74,0.08)'
    };
    if (pct > 20) return {
        color: '#b6770b',
        borderColor: 'rgba(182,119,11,0.35)',
        background: 'rgba(255,191,0,0.10)'
    };
    if (pct > 15) return {
        color: '#E50025',
        borderColor: 'rgba(229,0,37,0.35)',
        background: 'rgba(229,0,37,0.07)'
    };
    return {
        color: '#B80020',
        borderColor: 'rgba(184,0,32,0.35)',
        background: 'rgba(184,0,32,0.09)'
    };
}
const $689aec7135517418$var$Chip = ({ label: label, color: color = '#555', border: border = '#bbb', bg: bg = 'transparent' })=>/*#__PURE__*/ (0, $bbzbN.jsx)("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            fontSize: 11,
            fontWeight: 600,
            letterSpacing: '0.03em',
            padding: '2px 8px',
            border: `1px solid ${border}`,
            color: color,
            background: bg,
            borderRadius: 999,
            whiteSpace: 'nowrap'
        },
        children: label
    });
const $689aec7135517418$var$RoleBadge = ({ role: role })=>/*#__PURE__*/ (0, $bbzbN.jsx)("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            fontSize: 10,
            fontWeight: 700,
            letterSpacing: '0.08em',
            padding: '2px 7px',
            background: '#EFECE8',
            color: '#555',
            borderRadius: 999,
            whiteSpace: 'nowrap',
            textTransform: 'uppercase'
        },
        children: role
    });
const $689aec7135517418$var$CategoryBadge = ({ category: category })=>/*#__PURE__*/ (0, $bbzbN.jsx)("span", {
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            fontSize: 10,
            fontWeight: 600,
            letterSpacing: '0.04em',
            padding: '2px 8px',
            border: '1px solid #6464E6',
            color: '#6464E6',
            background: 'rgba(100,100,230,0.06)',
            borderRadius: 999,
            whiteSpace: 'nowrap'
        },
        children: category
    });
function $689aec7135517418$var$CommentCard({ comment: comment }) {
    const [repliesOpen, setRepliesOpen] = (0, $7fPBF.useState)(false);
    const hasReplies = comment.replies.length > 0;
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "bg-white border border-black/[0.08] px-4 py-3.5",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "flex flex-wrap items-center gap-2 mb-2",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        className: "font-semibold text-[13.5px]",
                        children: comment.user_name
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)($689aec7135517418$var$RoleBadge, {
                        role: comment.user_role
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)($689aec7135517418$var$CategoryBadge, {
                        category: comment.category
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        className: "text-[11px] text-[#7A7A76]",
                        children: $689aec7135517418$var$fmtTs(comment.created_at)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "text-[13px] leading-relaxed",
                children: comment.content
            }),
            hasReplies && /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "mt-3",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("button", {
                        className: "inline-flex items-center gap-1.5 text-[12px] font-semibold text-[#6464E6] bg-transparent border-0 cursor-pointer p-0 hover:underline",
                        onClick: ()=>setRepliesOpen((v)=>!v),
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                name: "chevron",
                                size: 13,
                                className: `transition-transform ${repliesOpen ? 'rotate-180' : ''}`
                            }),
                            comment.replies.length,
                            " ",
                            comment.replies.length === 1 ? 'Reply' : 'Replies'
                        ]
                    }),
                    repliesOpen && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "mt-3 ml-8 flex flex-col gap-2.5",
                        children: comment.replies.map((reply)=>/*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                className: "bg-[#FAF9F8] border border-black/[0.07] px-3.5 py-2.5",
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                        className: "flex flex-wrap items-center gap-2 mb-1.5",
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                className: "font-semibold text-[13px]",
                                                children: reply.user_name
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)($689aec7135517418$var$RoleBadge, {
                                                role: reply.user_role
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                className: "text-[11px] text-[#7A7A76]",
                                                children: $689aec7135517418$var$fmtTs(reply.created_at)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                        className: "text-[13px] leading-relaxed",
                                        children: reply.content
                                    })
                                ]
                            }, reply.comment_id))
                    })
                ]
            })
        ]
    });
}
const $689aec7135517418$var$CommentsPage = ()=>{
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const [allComments, setAllComments] = (0, $7fPBF.useState)([]);
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const [search, setSearch] = (0, $7fPBF.useState)('');
    const [categoryFilter, setCategoryFilter] = (0, $7fPBF.useState)('');
    const [expandedPortfolios, setExpandedPortfolios] = (0, $7fPBF.useState)(new Set());
    (0, $7fPBF.useEffect)(()=>{
        fetchAllComments();
    }, []);
    const fetchAllComments = async ()=>{
        try {
            setLoading(true);
            setError(null);
            const data = await (0, $2b61471e8e825f6c$export$d0204b1ddc8ee140).getAllComments({});
            setAllComments(data);
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Failed to fetch comments');
        } finally{
            setLoading(false);
        }
    };
    const togglePortfolio = (id)=>setExpandedPortfolios((prev)=>{
            const n = new Set(prev);
            n.has(id) ? n.delete(id) : n.add(id);
            return n;
        });
    const filtered = (0, $7fPBF.useMemo)(()=>{
        return allComments.map((p)=>{
            let comments = p.comments;
            if (categoryFilter) comments = comments.filter((c)=>c.category === categoryFilter);
            if (search) {
                const q = search.toLowerCase();
                comments = comments.filter((c)=>c.content.toLowerCase().includes(q) || c.user_name.toLowerCase().includes(q) || (p.client_name || '').toLowerCase().includes(q) || p.portfolio_id.toLowerCase().includes(q));
            }
            return {
                ...p,
                comments: comments
            };
        }).filter((p)=>p.comments.length > 0);
    }, [
        allComments,
        search,
        categoryFilter
    ]);
    if (loading) return /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).page} flex items-center justify-center min-h-[400px]`,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).muted,
            children: "Loading comments\u2026"
        })
    });
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).page,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).pageHead,
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)("h1", {
                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).pageH1,
                            children: "All Comments"
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                            className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).pageSub,
                            children: "Every comment across all portfolios \u2014 search, filter, and jump to context."
                        })
                    ]
                })
            }),
            error && /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "bg-[rgba(229,0,37,0.06)] border border-[#E50025] px-4 py-3 mb-4 flex justify-between items-center",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        style: {
                            fontSize: 13
                        },
                        children: error
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).iconBtn,
                        onClick: ()=>setError(null),
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                            name: "close",
                            size: 14
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).surface} p-[14px_16px] mb-4 grid [grid-template-columns:2fr_1fr] gap-3`,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).field,
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("label", {
                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).fieldLabel,
                                children: "Search Comments"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).inputWrap,
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                        name: "search",
                                        size: 14,
                                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).inputIco
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                                        className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input} pl-[38px]`,
                                        placeholder: "Body, author, or client name\u2026",
                                        value: search,
                                        onChange: (e)=>setSearch(e.target.value)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).field,
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("label", {
                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).fieldLabel,
                                children: "Category"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("select", {
                                className: (0, $e4bf7e7a647cb901$export$7139adf9d3bace41).input,
                                value: categoryFilter,
                                onChange: (e)=>setCategoryFilter(e.target.value),
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                        value: "",
                                        children: "All categories"
                                    }),
                                    (0, $f213e983270415ba$export$b9f0c4cf5e81d842).map((c)=>/*#__PURE__*/ (0, $bbzbN.jsx)("option", {
                                            value: c,
                                            children: c
                                        }, c))
                                ]
                            })
                        ]
                    })
                ]
            }),
            filtered.length === 0 && !loading && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: `${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).surface} px-6 py-10 text-center ${(0, $e4bf7e7a647cb901$export$7139adf9d3bace41).muted}`,
                style: {
                    fontSize: 13
                },
                children: allComments.length === 0 ? 'No comments yet.' : 'No comments match.'
            }),
            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "flex flex-col gap-3",
                children: filtered.map((p)=>{
                    const isOpen = expandedPortfolios.has(p.portfolio_id);
                    const sc = p.surplus_cushion_with_cash;
                    const scStyle = $689aec7135517418$var$surplusStyle(sc);
                    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "bg-white border border-black/[0.08]",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                className: "flex items-start justify-between gap-4 px-5 py-4 cursor-pointer select-none hover:bg-[#FAF9F8] transition-colors",
                                onClick: ()=>togglePortfolio(p.portfolio_id),
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                        className: "flex items-start gap-3 min-w-0",
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                                className: "w-8 h-8 rounded-full border border-black/[0.12] flex items-center justify-center shrink-0 mt-0.5 text-[#7A7A76]",
                                                children: /*#__PURE__*/ (0, $bbzbN.jsxs)("svg", {
                                                    width: "16",
                                                    height: "16",
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    strokeWidth: "1.5",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    children: [
                                                        /*#__PURE__*/ (0, $bbzbN.jsx)("circle", {
                                                            cx: "12",
                                                            cy: "8",
                                                            r: "4"
                                                        }),
                                                        /*#__PURE__*/ (0, $bbzbN.jsx)("path", {
                                                            d: "M4 20c0-4 3.6-7 8-7s8 3 8 7"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                                className: "min-w-0",
                                                children: [
                                                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                                        className: "flex flex-wrap items-center gap-2 mb-1.5",
                                                        children: [
                                                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                                className: "font-bold text-[14.5px] leading-snug",
                                                                children: p.client_name || "\u2014"
                                                            }),
                                                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                                className: "font-mono text-[11px] text-[#7A7A76] bg-black/[0.05] px-1.5 py-0.5 rounded-sm shrink-0",
                                                                children: p.portfolio_id
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                                        className: "flex flex-wrap items-center gap-1.5",
                                                        children: [
                                                            /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                                                                className: "text-[12px] text-[#7A7A76] mr-0.5",
                                                                children: [
                                                                    p.comments.length,
                                                                    " ",
                                                                    p.comments.length === 1 ? 'comment' : 'comments'
                                                                ]
                                                            }),
                                                            sc != null && /*#__PURE__*/ (0, $bbzbN.jsx)($689aec7135517418$var$Chip, {
                                                                label: `Surplus: ${(0, $e4bf7e7a647cb901$export$850409532323fff)(sc, 2)}`,
                                                                color: scStyle.color,
                                                                border: scStyle.borderColor,
                                                                bg: scStyle.background
                                                            }),
                                                            /*#__PURE__*/ (0, $bbzbN.jsx)($689aec7135517418$var$Chip, {
                                                                label: p.is_margin_trading ? 'Margin Trading' : 'No Margin Trading',
                                                                color: p.is_margin_trading ? '#E50025' : '#7A7A76',
                                                                border: p.is_margin_trading ? 'rgba(229,0,37,0.35)' : 'rgba(0,0,0,0.15)',
                                                                bg: p.is_margin_trading ? 'rgba(229,0,37,0.07)' : '#EFECE8'
                                                            }),
                                                            p.total_aum != null && /*#__PURE__*/ (0, $bbzbN.jsx)($689aec7135517418$var$Chip, {
                                                                label: `AUM: ${(0, $e4bf7e7a647cb901$export$217e472da3f6c211)(p.total_aum)}`,
                                                                color: "#333",
                                                                border: "rgba(0,0,0,0.18)",
                                                                bg: "transparent"
                                                            }),
                                                            p.margin_account_equity != null && /*#__PURE__*/ (0, $bbzbN.jsx)($689aec7135517418$var$Chip, {
                                                                label: `Equity: ${(0, $e4bf7e7a647cb901$export$217e472da3f6c211)(p.margin_account_equity)}`,
                                                                color: "#333",
                                                                border: "rgba(0,0,0,0.18)",
                                                                bg: "transparent"
                                                            }),
                                                            p.lc_margin_requirement != null && /*#__PURE__*/ (0, $bbzbN.jsx)($689aec7135517418$var$Chip, {
                                                                label: `LC Req: ${(0, $e4bf7e7a647cb901$export$217e472da3f6c211)(p.lc_margin_requirement)}`,
                                                                color: "#E50025",
                                                                border: "rgba(229,0,37,0.35)",
                                                                bg: "rgba(229,0,37,0.07)"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                        className: "flex items-center gap-2 shrink-0 mt-0.5",
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e4bf7e7a647cb901$export$9a6eab314e3821cc), {
                                                variant: "outline",
                                                size: "sm",
                                                onClick: (e)=>{
                                                    e.stopPropagation();
                                                    navigate(`/portfolio/${p.portfolio_id}`);
                                                },
                                                children: "View Portfolio"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                                name: "chevron",
                                                size: 16,
                                                className: `text-[#7A7A76] transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isOpen && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "border-t border-black/[0.06] bg-[#FAF9F8] px-5 py-4 flex flex-col gap-3",
                                children: p.comments.map((c)=>/*#__PURE__*/ (0, $bbzbN.jsx)($689aec7135517418$var$CommentCard, {
                                        comment: c
                                    }, c.comment_id))
                            })
                        ]
                    }, p.portfolio_id);
                })
            })
        ]
    });
};
var $689aec7135517418$export$2e2bcd8739ae039 = $689aec7135517418$var$CommentsPage;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");





// Too complex for a Tailwind arbitrary value (multi-stop radial gradients with commas)
const $e3ce077e6a7799de$var$EDITORIAL_GLOW = {
    background: [
        'radial-gradient(1100px 700px at 25% 45%, rgba(229, 0, 37, 0.09), transparent 60%)',
        'radial-gradient(800px 600px at 85% 90%, rgba(255, 255, 255, 0.04), transparent 60%)'
    ].join(', ')
};
const $e3ce077e6a7799de$var$Login = ()=>{
    const [email, setEmail] = (0, $7fPBF.useState)('');
    const [password, setPassword] = (0, $7fPBF.useState)('');
    const [showPw, setShowPw] = (0, $7fPBF.useState)(false);
    const [showPwForm, setShowPwForm] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)('');
    const [isLoading, setIsLoading] = (0, $7fPBF.useState)(false);
    const [isSSOLoading, setIsSSOLoading] = (0, $7fPBF.useState)(false);
    const { login: login, loginWithSSO: loginWithSSO } = (0, $d0020511b775fb45$export$1d39dc5b47e56ff0)();
    const { instance: instance } = (0, $f8cae32216c5cd58$export$f41558044a1dd55)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const from = location.state?.from?.pathname || '/';
    const busy = isLoading || isSSOLoading;
    const ssoAvailable = (0, $7752dec9fa956b3a$export$642df60507c564d3)();
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setError('');
        setIsLoading(true);
        try {
            await login(email, password);
            navigate(from, {
                replace: true
            });
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Login failed. Please try again.');
        } finally{
            setIsLoading(false);
        }
    };
    const handleSSOLogin = async ()=>{
        setError('');
        setIsSSOLoading(true);
        try {
            const clientId = "66b387a7-0731-4dd1-9992-d6d15033dac9";
            const tenantId = "c24167bc-ce54-479c-b126-59e68ab033ea";
            if (!clientId || !tenantId) throw new Error('Microsoft SSO is not configured. Please set REACT_APP_AZURE_CLIENT_ID and REACT_APP_AZURE_TENANT_ID.');
            const response = await instance.loginPopup((0, $7752dec9fa956b3a$export$be6c432b2463c5eb));
            if (response?.idToken) {
                await loginWithSSO(response.idToken);
                navigate(from, {
                    replace: true
                });
            } else throw new Error('No ID token received from Microsoft');
        } catch (err) {
            let msg = 'SSO login failed. Please try again.';
            if (err instanceof Error) msg = err.message.includes('AADSTS900144') || err.message.includes('client_id') ? 'Azure AD configuration error: Missing client_id. Please configure REACT_APP_AZURE_CLIENT_ID.' : err.message;
            setError(msg);
        } finally{
            setIsSSOLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "grid grid-cols-[2fr_1fr] min-h-screen max-[1400px]:grid-cols-[3fr_2fr] max-[1100px]:grid-cols-1",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("section", {
                className: "relative bg-[#0f1419] text-white flex flex-col overflow-hidden pt-[56px] px-[80px] pb-[48px] max-[1400px]:px-[48px] max-[1400px]:pt-[36px] max-[1400px]:pb-[32px] max-[1100px]:hidden",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                        className: "absolute inset-0 pointer-events-none",
                        style: $e3ce077e6a7799de$var$EDITORIAL_GLOW
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("svg", {
                        className: "absolute inset-0 w-full h-full opacity-[0.05] pointer-events-none",
                        "aria-hidden": "true",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("defs", {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)("pattern", {
                                    id: "login-editorial-grid",
                                    width: "88",
                                    height: "88",
                                    patternUnits: "userSpaceOnUse",
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)("path", {
                                        d: "M88 0H0V88",
                                        fill: "none",
                                        stroke: "#ffffff",
                                        strokeWidth: "0.5"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("rect", {
                                width: "100%",
                                height: "100%",
                                fill: "url(#login-editorial-grid)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "relative z-10 flex items-center gap-[14px]",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "w-[44px] h-[44px] bg-[#E50025] shrink-0 grid place-items-center text-white font-serif text-[24px] font-medium leading-none max-[1400px]:w-[34px] max-[1400px]:h-[34px] max-[1400px]:text-[18px]",
                                children: "L"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                className: "font-serif text-[19px] leading-[1.1] text-white max-[1400px]:text-[15px]",
                                children: "Lighthouse Canton"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "relative z-10 flex-1 flex flex-col justify-center min-h-0 max-w-[720px]",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "font-serif font-normal text-[26px] leading-[1.2] tracking-[-0.005em] text-white/90 mb-[18px] max-[1400px]:text-[17px] max-[1400px]:mb-[12px]",
                                children: "Margin Risk Management System"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "w-[56px] h-[2px] bg-[#E50025] mb-[26px] max-[1400px]:mb-[16px]"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("h1", {
                                className: "font-serif font-normal text-[60px] leading-[1.06] tracking-[-0.018em] text-white text-balance m-0 max-[1400px]:text-[34px]",
                                children: [
                                    "Margin Risk \u2014",
                                    ' ',
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("em", {
                                        className: "not-italic text-white/[72]",
                                        children: "tracked, measured, and controlled"
                                    }),
                                    ' ',
                                    "against limits, every day."
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                                className: "text-[17px] leading-[1.6] text-white/60 mt-[32px] max-w-[580px] m-0 max-[1400px]:text-[13px] max-[1400px]:mt-[16px]",
                                children: "Real-time monitoring of margin requirements, surplus cushions, and house-call triggers across every Pershing-held portfolio. Cross-book exposure analysis, RM-actionable alerts, and a full audit trail of margin events."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "relative z-10 flex justify-between items-center mt-[40px] pt-[24px] border-t border-white/[0.08] max-[1400px]:mt-[20px] max-[1400px]:pt-[16px]",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                className: "flex items-center gap-[14px]",
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                        className: "text-[10.5px] font-bold tracking-[0.18em] uppercase text-white/40",
                                        children: "Regulated by"
                                    }),
                                    [
                                        'MAS',
                                        'DFSA',
                                        'SEBI',
                                        'FCA'
                                    ].map((r)=>/*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                            className: "text-[11px] font-bold tracking-[0.22em] text-white/55 px-[10px] py-[5px] border border-white/[0.14]",
                                            children: r
                                        }, r))
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                className: "flex flex-col items-end gap-[3px]",
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("em", {
                                        className: "font-serif not-italic text-[11.5px] text-white/[42]",
                                        children: "A product of AI Lab"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                                        className: "text-[11px] text-white/30 font-mono tracking-[0.04em]",
                                        children: [
                                            "MRMS \xb7 ",
                                            new Date().toLocaleDateString('en-US', {
                                                month: 'long',
                                                year: 'numeric'
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("section", {
                className: "flex flex-col bg-[#f5f3ee] pt-[48px] px-[80px] pb-[36px] border-l border-black/[0.08] overflow-y-auto max-[1400px]:pt-[32px] max-[1400px]:px-[56px] max-[1400px]:pb-[24px] max-[1100px]:px-8 max-[1100px]:py-9",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "flex-1 flex flex-col justify-center mx-auto w-full max-w-[440px]",
                        children: [
                            error && /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                className: "flex items-start gap-2.5 px-[12px] py-[10px] mb-5 text-[12.5px] leading-relaxed border-l-[3px] border-[#c62828] bg-[#fdecec] text-[#8a1b1b]",
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                        name: "error",
                                        size: 14,
                                        className: "shrink-0 mt-0.5"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                        className: "flex-1",
                                        children: error
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                                        className: "bg-transparent border-0 cursor-pointer p-0 text-inherit opacity-60 hover:opacity-100 shrink-0",
                                        onClick: ()=>setError(''),
                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                            name: "close",
                                            size: 12
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                                className: "text-[11px] font-bold tracking-[0.2em] uppercase text-[#E50025] m-0 mb-[14px]",
                                children: "Secure access \xb7 Single sign-on"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("h2", {
                                className: "font-serif font-normal text-[52px] leading-[1.02] tracking-[-0.018em] text-black m-0 mb-[16px] max-[1400px]:text-[40px]",
                                children: "Sign in"
                            }),
                            ssoAvailable && !showPwForm && /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                                className: "text-[15px] leading-[1.55] text-[#7A7A76] max-w-[380px] m-0 mb-[38px] max-[1400px]:mb-[24px]",
                                children: "Use your Lighthouse Canton Microsoft account. MRMS inherits your firm role and margin-account access automatically."
                            }),
                            ssoAvailable && !showPwForm && /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $bbzbN.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)("button", {
                                        onClick: handleSSOLogin,
                                        disabled: busy,
                                        className: "flex items-center justify-center gap-[14px] w-full px-[20px] py-[16px] bg-[#E50025] text-white text-[16px] font-medium tracking-[-0.01em] border-0 cursor-pointer transition-colors hover:bg-[#B80020] disabled:opacity-50 disabled:cursor-not-allowed",
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsxs)("svg", {
                                                width: "19",
                                                height: "19",
                                                viewBox: "0 0 23 23",
                                                "aria-hidden": "true",
                                                className: "shrink-0",
                                                children: [
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("rect", {
                                                        x: "1",
                                                        y: "1",
                                                        width: "10",
                                                        height: "10",
                                                        fill: "#F25022"
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("rect", {
                                                        x: "12",
                                                        y: "1",
                                                        width: "10",
                                                        height: "10",
                                                        fill: "#7FBA00"
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("rect", {
                                                        x: "1",
                                                        y: "12",
                                                        width: "10",
                                                        height: "10",
                                                        fill: "#00A4EF"
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("rect", {
                                                        x: "12",
                                                        y: "12",
                                                        width: "10",
                                                        height: "10",
                                                        fill: "#FFB900"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                                className: "flex-1 text-left",
                                                children: isSSOLoading ? "Signing in\u2026" : 'Continue with LC Account'
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("svg", {
                                                width: "16",
                                                height: "16",
                                                viewBox: "0 0 14 14",
                                                fill: "none",
                                                stroke: "currentColor",
                                                strokeWidth: "1.8",
                                                strokeLinecap: "round",
                                                className: "ml-[4px] shrink-0",
                                                children: /*#__PURE__*/ (0, $bbzbN.jsx)("path", {
                                                    d: "M3 7h8M7 3l4 4-4 4"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)("p", {
                                        className: "text-[12px] text-[#7A7A76] mt-[18px] leading-[1.5] m-0",
                                        children: [
                                            "Sign in with your",
                                            ' ',
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("strong", {
                                                className: "text-black",
                                                children: "@lighthouse-canton.com"
                                            }),
                                            ' ',
                                            "or",
                                            ' ',
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("strong", {
                                                className: "text-black",
                                                children: "@keenaiglobal.com"
                                            }),
                                            ' ',
                                            "account."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                        className: "mt-[20px] pt-[20px] border-t border-black/[0.08]",
                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                                            className: "text-[11.5px] text-[#7A7A76] hover:text-[#333] bg-transparent border-0 p-0 cursor-pointer transition-colors",
                                            onClick: ()=>setShowPwForm(true),
                                            children: "Use email / password instead \u2192"
                                        })
                                    })
                                ]
                            }),
                            (!ssoAvailable || showPwForm) && /*#__PURE__*/ (0, $bbzbN.jsxs)("form", {
                                onSubmit: handleSubmit,
                                className: "flex flex-col gap-4 mt-1",
                                children: [
                                    showPwForm && /*#__PURE__*/ (0, $bbzbN.jsx)("p", {
                                        className: "text-[13px] leading-[1.65] text-[#7A7A76] m-0",
                                        children: "Sign in with your MRMS account credentials."
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                        className: "flex flex-col gap-1.5",
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("label", {
                                                className: "text-[10px] tracking-[0.16em] uppercase font-bold text-[#333]",
                                                htmlFor: "login-email",
                                                children: "Email"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                                                id: "login-email",
                                                type: "email",
                                                autoComplete: "email",
                                                autoFocus: true,
                                                required: true,
                                                disabled: busy,
                                                value: email,
                                                onChange: (e)=>setEmail(e.target.value),
                                                placeholder: "you@lighthouse-canton.com",
                                                className: "w-full text-[13.5px] font-light px-[12px] py-[10px] rounded-none bg-white text-black border border-black/[0.16] focus:outline-none focus:border-[#E50025] disabled:opacity-50 transition-colors"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                        className: "flex flex-col gap-1.5",
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)("label", {
                                                className: "text-[10px] tracking-[0.16em] uppercase font-bold text-[#333]",
                                                htmlFor: "login-password",
                                                children: "Password"
                                            }),
                                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                                className: "relative",
                                                children: [
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("input", {
                                                        id: "login-password",
                                                        type: showPw ? 'text' : 'password',
                                                        autoComplete: "current-password",
                                                        required: true,
                                                        disabled: busy,
                                                        value: password,
                                                        onChange: (e)=>setPassword(e.target.value),
                                                        placeholder: "\u2022\u2022\u2022\u2022\u2022\u2022\u2022\u2022",
                                                        className: "w-full text-[13.5px] font-light pl-[12px] pr-[42px] py-[10px] rounded-none bg-white text-black border border-black/[0.16] focus:outline-none focus:border-[#E50025] disabled:opacity-50 transition-colors"
                                                    }),
                                                    /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                                                        type: "button",
                                                        tabIndex: -1,
                                                        className: "absolute right-3 top-1/2 -translate-y-1/2 bg-transparent border-0 p-0 cursor-pointer text-[#7A7A76] hover:text-[#333] transition-colors",
                                                        onClick: ()=>setShowPw((v)=>!v),
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                                            name: showPw ? 'eye-off' : 'eye',
                                                            size: 15
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                                        type: "submit",
                                        disabled: busy,
                                        className: "flex items-center justify-center w-full px-[20px] py-[14px] bg-[#E50025] text-white text-[14px] font-medium border-0 cursor-pointer hover:bg-[#B80020] transition-colors disabled:opacity-50 disabled:cursor-not-allowed mt-1",
                                        children: isLoading ? "Signing in\u2026" : 'Sign In'
                                    }),
                                    showPwForm && ssoAvailable && /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                                        type: "button",
                                        className: "text-[11.5px] text-[#7A7A76] hover:text-[#333] bg-transparent border-0 p-0 cursor-pointer transition-colors text-left",
                                        onClick: ()=>{
                                            setShowPwForm(false);
                                            setError('');
                                        },
                                        children: "\u2190 Back to SSO sign-in"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "flex justify-between items-center pt-[24px] border-t border-black/[0.08] text-[12px] text-[#7A7A76]",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                                children: [
                                    "Trouble signing in?",
                                    ' ',
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("a", {
                                        href: "mailto:risk.lcpl@lighthouse-canton.com",
                                        className: "text-[#E50025] font-semibold border-b border-[#E50025] pb-[1px]",
                                        children: "Risk & CPL Support"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                                className: "font-mono",
                                children: [
                                    "\xa9 ",
                                    new Date().getFullYear(),
                                    " Lighthouse Canton"
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $e3ce077e6a7799de$export$2e2bcd8739ae039 = $e3ce077e6a7799de$var$Login;


/**
 * Auth Callback Component
 * Handles the redirect callback from Azure AD after SSO authentication
 */ 
var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");





var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $k6RDS = parcelRequire("k6RDS");

var $cFCqu = parcelRequire("cFCqu");

var $iCiVn = parcelRequire("iCiVn");

var $gjk5S = parcelRequire("gjk5S");
function $249f9015c4a2303b$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $gjk5S.default)(theme.components[name].defaultProps, props);
}



'use client';
function $71102aa90e2b2620$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $328672c8d07e1c59$export$2e2bcd8739ae039)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    const mergedProps = (0, $249f9015c4a2303b$export$2e2bcd8739ae039)({
        theme: theme,
        name: name,
        props: props
    });
    return mergedProps;
}



var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $5VCcJ = parcelRequire("5VCcJ");

var $3wRTY = parcelRequire("3wRTY");



var $2G6xE = parcelRequire("2G6xE");

var $8M6a3 = parcelRequire("8M6a3");
const $0aa19929000e58fe$var$_excluded = [
    "ownerState"
], $0aa19929000e58fe$var$_excluded2 = [
    "variants"
], $0aa19929000e58fe$var$_excluded3 = [
    "name",
    "slot",
    "skipVariantsResolver",
    "skipSx",
    "overridesResolver"
];
function $0aa19929000e58fe$var$isEmpty(obj) {
    return Object.keys(obj).length === 0;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $0aa19929000e58fe$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $0aa19929000e58fe$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $0aa19929000e58fe$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
const $0aa19929000e58fe$export$35e57303dbd8a66 = (0, $2G6xE.default)();
const $0aa19929000e58fe$var$lowercaseFirstLetter = (string)=>{
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
};
function $0aa19929000e58fe$var$resolveTheme({ defaultTheme: defaultTheme, theme: theme, themeId: themeId }) {
    return $0aa19929000e58fe$var$isEmpty(theme) ? defaultTheme : theme[themeId] || theme;
}
function $0aa19929000e58fe$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (props, styles)=>styles[slot];
}
function $0aa19929000e58fe$var$processStyleArg(callableStyle, _ref, layerName) {
    let { ownerState: ownerState } = _ref, props = (0, $cFLic.default)(_ref, $0aa19929000e58fe$var$_excluded);
    const resolvedStylesArg = typeof callableStyle === 'function' ? callableStyle((0, $kY3Ke.default)({
        ownerState: ownerState
    }, props)) : callableStyle;
    if (Array.isArray(resolvedStylesArg)) return resolvedStylesArg.flatMap((resolvedStyle)=>$0aa19929000e58fe$var$processStyleArg(resolvedStyle, (0, $kY3Ke.default)({
            ownerState: ownerState
        }, props), layerName));
    if (!!resolvedStylesArg && typeof resolvedStylesArg === 'object' && Array.isArray(resolvedStylesArg.variants)) {
        const { variants: variants = [] } = resolvedStylesArg, otherStyles = (0, $cFLic.default)(resolvedStylesArg, $0aa19929000e58fe$var$_excluded2);
        let result = otherStyles;
        variants.forEach((variant)=>{
            let isMatch = true;
            if (typeof variant.props === 'function') isMatch = variant.props((0, $kY3Ke.default)({
                ownerState: ownerState
            }, props, ownerState));
            else Object.keys(variant.props).forEach((key)=>{
                if ((ownerState == null ? void 0 : ownerState[key]) !== variant.props[key] && props[key] !== variant.props[key]) isMatch = false;
            });
            if (isMatch) {
                if (!Array.isArray(result)) result = [
                    result
                ];
                const variantStyle = typeof variant.style === 'function' ? variant.style((0, $kY3Ke.default)({
                    ownerState: ownerState
                }, props, ownerState)) : variant.style;
                result.push(layerName ? $0aa19929000e58fe$var$shallowLayer((0, $5VCcJ.internal_serializeStyles)(variantStyle), layerName) : variantStyle);
            }
        });
        return result;
    }
    return layerName ? $0aa19929000e58fe$var$shallowLayer((0, $5VCcJ.internal_serializeStyles)(resolvedStylesArg), layerName) : resolvedStylesArg;
}
function $0aa19929000e58fe$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $0aa19929000e58fe$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $0aa19929000e58fe$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $0aa19929000e58fe$export$3ba67b570e26eea0 } = input;
    const systemSx = (props)=>{
        return (0, $8M6a3.default)((0, $kY3Ke.default)({}, props, {
            theme: $0aa19929000e58fe$var$resolveTheme((0, $kY3Ke.default)({}, props, {
                defaultTheme: defaultTheme,
                themeId: themeId
            }))
        }));
    };
    systemSx.__mui_systemSx = true;
    return (tag, inputOptions = {})=>{
        // Filter out the `sx` style function from the previous styled component to prevent unnecessary styles generated by the composite components.
        (0, $5VCcJ.internal_processStyles)(tag, (styles)=>styles.filter((style)=>!(style != null && style.__mui_systemSx)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $0aa19929000e58fe$var$defaultOverridesResolver($0aa19929000e58fe$var$lowercaseFirstLetter(componentSlot)) } = inputOptions, options = (0, $cFLic.default)(inputOptions, $0aa19929000e58fe$var$_excluded3);
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let label;
        let shouldForwardPropOption = $0aa19929000e58fe$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($0aa19929000e58fe$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $5VCcJ.default)(tag, (0, $kY3Ke.default)({
            shouldForwardProp: shouldForwardPropOption,
            label: label
        }, options));
        const transformStyleArg = (stylesArg)=>{
            // On the server Emotion doesn't use React.forwardRef for creating components, so the created
            // component stays as a function. This condition makes sure that we do not interpolate functions
            // which are basically components used as a selectors.
            if (typeof stylesArg === 'function' && stylesArg.__emotion_real !== stylesArg || (0, $3wRTY.isPlainObject)(stylesArg)) return (props)=>{
                const theme = $0aa19929000e58fe$var$resolveTheme({
                    theme: props.theme,
                    defaultTheme: defaultTheme,
                    themeId: themeId
                });
                return $0aa19929000e58fe$var$processStyleArg(stylesArg, (0, $kY3Ke.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? layerName : undefined);
            };
            return stylesArg;
        };
        const muiStyledResolver = (styleArg, ...expressions)=>{
            let transformedStyleArg = transformStyleArg(styleArg);
            const expressionsWithDefaultTheme = expressions ? expressions.map(transformStyleArg) : [];
            if (componentName && overridesResolver) expressionsWithDefaultTheme.push((props)=>{
                const theme = $0aa19929000e58fe$var$resolveTheme((0, $kY3Ke.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                if (!theme.components || !theme.components[componentName] || !theme.components[componentName].styleOverrides) return null;
                const styleOverrides = theme.components[componentName].styleOverrides;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                Object.entries(styleOverrides).forEach(([slotKey, slotStyle])=>{
                    resolvedStyleOverrides[slotKey] = $0aa19929000e58fe$var$processStyleArg(slotStyle, (0, $kY3Ke.default)({}, props, {
                        theme: theme
                    }), theme.modularCssLayers ? 'theme' : undefined);
                });
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsWithDefaultTheme.push((props)=>{
                var _theme$components;
                const theme = $0aa19929000e58fe$var$resolveTheme((0, $kY3Ke.default)({}, props, {
                    defaultTheme: defaultTheme,
                    themeId: themeId
                }));
                const themeVariants = theme == null || (_theme$components = theme.components) == null || (_theme$components = _theme$components[componentName]) == null ? void 0 : _theme$components.variants;
                return $0aa19929000e58fe$var$processStyleArg({
                    variants: themeVariants
                }, (0, $kY3Ke.default)({}, props, {
                    theme: theme
                }), theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsWithDefaultTheme.push(systemSx);
            const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;
            if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
                const placeholders = new Array(numOfCustomFnsApplied).fill('');
                // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.
                transformedStyleArg = [
                    ...styleArg,
                    ...placeholders
                ];
                transformedStyleArg.raw = [
                    ...styleArg.raw,
                    ...placeholders
                ];
            }
            const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
}


const $81df530a7daa801f$var$styled = (0, $0aa19929000e58fe$export$2e2bcd8739ae039)();
var $81df530a7daa801f$export$2e2bcd8739ae039 = $81df530a7daa801f$var$styled;



var $2G6xE = parcelRequire("2G6xE");

var $bbzbN = parcelRequire("bbzbN");
const $7fa748e340d672b7$var$_excluded = [
    "className",
    "component",
    "disableGutters",
    "fixed",
    "maxWidth",
    "classes"
];
const $7fa748e340d672b7$var$defaultTheme = (0, $2G6xE.default)();
const $7fa748e340d672b7$var$defaultCreateStyledComponent = (0, $81df530a7daa801f$export$2e2bcd8739ae039)('div', {
    name: 'MuiContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, $iCiVn.default)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const $7fa748e340d672b7$var$useThemePropsDefault = (inProps)=>(0, $71102aa90e2b2620$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiContainer',
        defaultTheme: $7fa748e340d672b7$var$defaultTheme
    });
const $7fa748e340d672b7$var$useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, $k6RDS.default)(componentName, slot);
    };
    const { classes: classes, fixed: fixed, disableGutters: disableGutters, maxWidth: maxWidth } = ownerState;
    const slots = {
        root: [
            'root',
            maxWidth && `maxWidth${(0, $iCiVn.default)(String(maxWidth))}`,
            fixed && 'fixed',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $cFCqu.default)(slots, getContainerUtilityClass, classes);
};
function $7fa748e340d672b7$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $7fa748e340d672b7$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $7fa748e340d672b7$var$useThemePropsDefault, componentName: componentName = 'MuiContainer' } = options;
    const ContainerRoot = createStyledComponent(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
            width: '100%',
            marginLeft: 'auto',
            boxSizing: 'border-box',
            marginRight: 'auto',
            display: 'block'
        }, !ownerState.disableGutters && {
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up('sm')]: {
                paddingLeft: theme.spacing(3),
                paddingRight: theme.spacing(3)
            }
        }), ({ theme: theme, ownerState: ownerState })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({}, ownerState.maxWidth === 'xs' && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up('xs')]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: Math.max(theme.breakpoints.values.xs, 444)
            }
        }, ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
        ownerState.maxWidth !== 'xs' && {
            // @ts-ignore module augmentation fails if custom breakpoints are used
            [theme.breakpoints.up(ownerState.maxWidth)]: {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
            }
        }));
    const Container = /*#__PURE__*/ $7fPBF.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className: className, component: component = 'div', disableGutters: disableGutters = false, fixed: fixed = false, maxWidth: maxWidth = 'lg' } = props, other = (0, $cFLic.default)(props, $7fa748e340d672b7$var$_excluded);
        const ownerState = (0, $kY3Ke.default)({}, props, {
            component: component,
            disableGutters: disableGutters,
            fixed: fixed,
            maxWidth: maxWidth
        });
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = $7fa748e340d672b7$var$useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, $bbzbN.jsx)(ContainerRoot, (0, $kY3Ke.default)({
            as: component,
            ownerState: ownerState,
            className: (0, $hngXp.default)(classes.root, className),
            ref: ref
        }, other)));
    });
    return Container;
}



var $b6UUh = parcelRequire("b6UUh");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");
'use client';
const $a224e7f09a1cd55c$var$Container = (0, $7fa748e340d672b7$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $kDBhE.default)('div', {
        name: 'MuiContainer',
        slot: 'Root',
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                styles[`maxWidth${(0, $b6UUh.default)(String(ownerState.maxWidth))}`],
                ownerState.fixed && styles.fixed,
                ownerState.disableGutters && styles.disableGutters
            ];
        }
    }),
    useThemeProps: (inProps)=>(0, $iVAEr.useDefaultProps)({
            props: inProps,
            name: 'MuiContainer'
        })
});
var $a224e7f09a1cd55c$export$2e2bcd8739ae039 = $a224e7f09a1cd55c$var$Container;


var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");

var $hngXp = parcelRequire("hngXp");

var $5VCcJ = parcelRequire("5VCcJ");

var $8M6a3 = parcelRequire("8M6a3");
var $mqrnX = parcelRequire("mqrnX");


var $bbzbN = parcelRequire("bbzbN");
'use client';
const $bd7b6b8695507478$var$_excluded = [
    "className",
    "component"
];
function $bd7b6b8695507478$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $5VCcJ.default)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $8M6a3.default));
    const Box = /*#__PURE__*/ $7fPBF.forwardRef(function Box(inProps, ref) {
        const theme = (0, $328672c8d07e1c59$export$2e2bcd8739ae039)(defaultTheme);
        const _extendSxProp = (0, $mqrnX.default)(inProps), { className: className, component: component = 'div' } = _extendSxProp, other = (0, $cFLic.default)(_extendSxProp, $bd7b6b8695507478$var$_excluded);
        return /*#__PURE__*/ (0, $bbzbN.jsx)(BoxRoot, (0, $kY3Ke.default)({
            as: component,
            ref: ref,
            className: (0, $hngXp.default)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme
        }, other));
    });
    return Box;
}




var $kU6nt = parcelRequire("kU6nt");

var $hmhHQ = parcelRequire("hmhHQ");

var $jwhZE = parcelRequire("jwhZE");

var $4jzsB = parcelRequire("4jzsB");
const $9dbabfa00f5ea67f$var$boxClasses = (0, $4jzsB.default)('MuiBox', [
    'root'
]);
var $9dbabfa00f5ea67f$export$2e2bcd8739ae039 = $9dbabfa00f5ea67f$var$boxClasses;


'use client';
const $77ec199cefd4182a$var$defaultTheme = (0, $hmhHQ.default)();
const $77ec199cefd4182a$var$Box = (0, $bd7b6b8695507478$export$2e2bcd8739ae039)({
    themeId: (0, $jwhZE.default),
    defaultTheme: $77ec199cefd4182a$var$defaultTheme,
    defaultClassName: (0, $9dbabfa00f5ea67f$export$2e2bcd8739ae039).root,
    generateClassName: (0, $kU6nt.default).generate
});
var $77ec199cefd4182a$export$2e2bcd8739ae039 = $77ec199cefd4182a$var$Box;


var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");

var $5nUae = parcelRequire("5nUae");

var $b6UUh = parcelRequire("b6UUh");

var $iVAEr = parcelRequire("iVAEr");

var $kDBhE = parcelRequire("kDBhE");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $978389e4a0c045ec$export$29cad1383b3f235d(slot) {
    return (0, $k6RDS.default)('MuiCircularProgress', slot);
}
const $978389e4a0c045ec$var$circularProgressClasses = (0, $4jzsB.default)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $978389e4a0c045ec$export$2e2bcd8739ae039 = $978389e4a0c045ec$var$circularProgressClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $d513166e63c42433$var$_excluded = [
    "className",
    "color",
    "disableShrink",
    "size",
    "style",
    "thickness",
    "value",
    "variant"
];
let $d513166e63c42433$var$_ = (t)=>t, $d513166e63c42433$var$_t, $d513166e63c42433$var$_t2, $d513166e63c42433$var$_t3, $d513166e63c42433$var$_t4;
const $d513166e63c42433$var$SIZE = 44;
const $d513166e63c42433$var$circularRotateKeyframe = (0, $5nUae.keyframes)($d513166e63c42433$var$_t || ($d513166e63c42433$var$_t = $d513166e63c42433$var$_`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const $d513166e63c42433$var$circularDashKeyframe = (0, $5nUae.keyframes)($d513166e63c42433$var$_t2 || ($d513166e63c42433$var$_t2 = $d513166e63c42433$var$_`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));
const $d513166e63c42433$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $b6UUh.default)(color)}`
        ],
        svg: [
            'svg'
        ],
        circle: [
            'circle',
            `circle${(0, $b6UUh.default)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $978389e4a0c045ec$export$29cad1383b3f235d), classes);
};
const $d513166e63c42433$var$CircularProgressRoot = (0, $kDBhE.default)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $b6UUh.default)(ownerState.color)}`]
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $kY3Ke.default)({
        display: 'inline-block'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('transform')
    }, ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && (0, $5nUae.css)($d513166e63c42433$var$_t3 || ($d513166e63c42433$var$_t3 = $d513166e63c42433$var$_`
      animation: ${0} 1.4s linear infinite;
    `), $d513166e63c42433$var$circularRotateKeyframe));
const $d513166e63c42433$var$CircularProgressSVG = (0, $kDBhE.default)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg',
    overridesResolver: (props, styles)=>styles.svg
})({
    display: 'block' // Keeps the progress centered
});
const $d513166e63c42433$var$CircularProgressCircle = (0, $kDBhE.default)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $b6UUh.default)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})(({ ownerState: ownerState, theme: theme })=>(0, $kY3Ke.default)({
        stroke: 'currentColor'
    }, ownerState.variant === 'determinate' && {
        transition: theme.transitions.create('stroke-dashoffset')
    }, ownerState.variant === 'indeterminate' && {
        // Some default value that looks fine waiting for the animation to kicks in.
        strokeDasharray: '80px, 200px',
        strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
    }), ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink && (0, $5nUae.css)($d513166e63c42433$var$_t4 || ($d513166e63c42433$var$_t4 = $d513166e63c42433$var$_`
      animation: ${0} 1.4s ease-in-out infinite;
    `), $d513166e63c42433$var$circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $d513166e63c42433$var$CircularProgress = /*#__PURE__*/ $7fPBF.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate' } = props, other = (0, $cFLic.default)(props, $d513166e63c42433$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant
    });
    const classes = $d513166e63c42433$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($d513166e63c42433$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $bbzbN.jsx)($d513166e63c42433$var$CircularProgressRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        style: (0, $kY3Ke.default)({
            width: size,
            height: size
        }, rootStyle, style),
        ownerState: ownerState,
        ref: ref,
        role: "progressbar"
    }, rootProps, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)($d513166e63c42433$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$d513166e63c42433$var$SIZE / 2} ${$d513166e63c42433$var$SIZE / 2} ${$d513166e63c42433$var$SIZE} ${$d513166e63c42433$var$SIZE}`,
            children: /*#__PURE__*/ (0, $bbzbN.jsx)($d513166e63c42433$var$CircularProgressCircle, {
                className: classes.circle,
                style: circleStyle,
                ownerState: ownerState,
                cx: $d513166e63c42433$var$SIZE,
                cy: $d513166e63c42433$var$SIZE,
                r: ($d513166e63c42433$var$SIZE - thickness) / 2,
                fill: "none",
                strokeWidth: thickness
            })
        })
    }));
});
var $d513166e63c42433$export$2e2bcd8739ae039 = $d513166e63c42433$var$CircularProgress;


var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $mqrnX = parcelRequire("mqrnX");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $b6UUh = parcelRequire("b6UUh");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $d9914d0380157c73$export$24c1f8f60cbac79e(slot) {
    return (0, $k6RDS.default)('MuiTypography', slot);
}
const $d9914d0380157c73$var$typographyClasses = (0, $4jzsB.default)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $d9914d0380157c73$export$2e2bcd8739ae039 = $d9914d0380157c73$var$typographyClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $26f68e516ee75fc4$var$_excluded = [
    "align",
    "className",
    "component",
    "gutterBottom",
    "noWrap",
    "paragraph",
    "variant",
    "variantMapping"
];
const $26f68e516ee75fc4$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $b6UUh.default)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $d9914d0380157c73$export$24c1f8f60cbac79e), classes);
};
const $26f68e516ee75fc4$export$140e2f5526d3cad8 = (0, $kDBhE.default)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $b6UUh.default)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        margin: 0
    }, ownerState.variant === 'inherit' && {
        // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
        font: 'inherit'
    }, ownerState.variant !== 'inherit' && theme.typography[ownerState.variant], ownerState.align !== 'inherit' && {
        textAlign: ownerState.align
    }, ownerState.noWrap && {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, ownerState.gutterBottom && {
        marginBottom: '0.35em'
    }, ownerState.paragraph && {
        marginBottom: 16
    }));
const $26f68e516ee75fc4$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
// TODO v6: deprecate these color values in v5.x and remove the transformation in v6
const $26f68e516ee75fc4$var$colorTransformations = {
    primary: 'primary.main',
    textPrimary: 'text.primary',
    secondary: 'secondary.main',
    textSecondary: 'text.secondary',
    error: 'error.main'
};
const $26f68e516ee75fc4$var$transformDeprecatedColors = (color)=>{
    return $26f68e516ee75fc4$var$colorTransformations[color] || color;
};
const $26f68e516ee75fc4$var$Typography = /*#__PURE__*/ $7fPBF.forwardRef(function Typography(inProps, ref) {
    const themeProps = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiTypography'
    });
    const color = $26f68e516ee75fc4$var$transformDeprecatedColors(themeProps.color);
    const props = (0, $mqrnX.default)((0, $kY3Ke.default)({}, themeProps, {
        color: color
    }));
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $26f68e516ee75fc4$var$defaultVariantMapping } = props, other = (0, $cFLic.default)(props, $26f68e516ee75fc4$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    });
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $26f68e516ee75fc4$var$defaultVariantMapping[variant]) || 'span';
    const classes = $26f68e516ee75fc4$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($26f68e516ee75fc4$export$140e2f5526d3cad8, (0, $kY3Ke.default)({
        as: Component,
        ref: ref,
        ownerState: ownerState,
        className: (0, $hngXp.default)(classes.root, className)
    }, other));
});
var $26f68e516ee75fc4$export$2e2bcd8739ae039 = $26f68e516ee75fc4$var$Typography;


const $e1d9792cfae08246$var$AuthCallback = ()=>{
    const { instance: instance } = (0, $f8cae32216c5cd58$export$f41558044a1dd55)();
    const { loginWithSSO: loginWithSSO } = (0, $d0020511b775fb45$export$1d39dc5b47e56ff0)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    (0, $7fPBF.useEffect)(()=>{
        const handleRedirect = async ()=>{
            try {
                // Handle the redirect response
                const response = await instance.handleRedirectPromise();
                if (response && response.idToken) {
                    // Send ID token to backend for validation
                    await loginWithSSO(response.idToken);
                    // Redirect to dashboard
                    navigate('/', {
                        replace: true
                    });
                } else // No token received, redirect to login
                navigate('/login', {
                    replace: true
                });
            } catch (error) {
                console.error('Auth callback error:', error);
                navigate('/login', {
                    replace: true,
                    state: {
                        error: 'Authentication failed'
                    }
                });
            }
        };
        handleRedirect();
    }, [
        instance,
        loginWithSSO,
        navigate
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a224e7f09a1cd55c$export$2e2bcd8739ae039), {
        maxWidth: "sm",
        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
            sx: {
                minHeight: '100vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
            },
            children: [
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d513166e63c42433$export$2e2bcd8739ae039), {
                    size: 48
                }),
                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                    variant: "body1",
                    sx: {
                        mt: 3
                    },
                    children: "Completing sign in..."
                })
            ]
        })
    });
};
var $e1d9792cfae08246$export$2e2bcd8739ae039 = $e1d9792cfae08246$var$AuthCallback;


/**
 * Unauthorized Page
 * Displayed when user tries to access a resource they don't have permission for
 */ 
var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");


var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");



var $cFCqu = parcelRequire("cFCqu");

var $7jL4F = parcelRequire("7jL4F");

var $kDBhE = parcelRequire("kDBhE");
// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
const $8fa7ddbbf42193a7$var$getOverlayAlpha = (elevation)=>{
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return (alphaValue / 100).toFixed(2);
};
var $8fa7ddbbf42193a7$export$2e2bcd8739ae039 = $8fa7ddbbf42193a7$var$getOverlayAlpha;



var $iVAEr = parcelRequire("iVAEr");


var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $bde3e2fffcaea664$export$29cdb466b9b6f20b(slot) {
    return (0, $k6RDS.default)('MuiPaper', slot);
}
const $bde3e2fffcaea664$var$paperClasses = (0, $4jzsB.default)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $bde3e2fffcaea664$export$2e2bcd8739ae039 = $bde3e2fffcaea664$var$paperClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $74e245c78e363f11$var$_excluded = [
    "className",
    "component",
    "elevation",
    "square",
    "variant"
];
const $74e245c78e363f11$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $bde3e2fffcaea664$export$29cdb466b9b6f20b), classes);
};
const $74e245c78e363f11$var$PaperRoot = (0, $kDBhE.default)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$vars$overlays;
    return (0, $kY3Ke.default)({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow')
    }, !ownerState.square && {
        borderRadius: theme.shape.borderRadius
    }, ownerState.variant === 'outlined' && {
        border: `1px solid ${(theme.vars || theme).palette.divider}`
    }, ownerState.variant === 'elevation' && (0, $kY3Ke.default)({
        boxShadow: (theme.vars || theme).shadows[ownerState.elevation]
    }, !theme.vars && theme.palette.mode === 'dark' && {
        backgroundImage: `linear-gradient(${(0, $7jL4F.alpha)('#fff', (0, $8fa7ddbbf42193a7$export$2e2bcd8739ae039)(ownerState.elevation))}, ${(0, $7jL4F.alpha)('#fff', (0, $8fa7ddbbf42193a7$export$2e2bcd8739ae039)(ownerState.elevation))})`
    }, theme.vars && {
        backgroundImage: (_theme$vars$overlays = theme.vars.overlays) == null ? void 0 : _theme$vars$overlays[ownerState.elevation]
    }));
});
const $74e245c78e363f11$var$Paper = /*#__PURE__*/ $7fPBF.forwardRef(function Paper(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiPaper'
    });
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation' } = props, other = (0, $cFLic.default)(props, $74e245c78e363f11$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    });
    const classes = $74e245c78e363f11$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($74e245c78e363f11$var$PaperRoot, (0, $kY3Ke.default)({
        as: component,
        ownerState: ownerState,
        className: (0, $hngXp.default)(classes.root, className),
        ref: ref
    }, other));
});
var $74e245c78e363f11$export$2e2bcd8739ae039 = $74e245c78e363f11$var$Paper;


var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $gjk5S = parcelRequire("gjk5S");

var $cFCqu = parcelRequire("cFCqu");

var $7jL4F = parcelRequire("7jL4F");

var $kDBhE = parcelRequire("kDBhE");
var $HgAeG = parcelRequire("HgAeG");

var $iVAEr = parcelRequire("iVAEr");

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");



var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $7fPBF = parcelRequire("7fPBF");
/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $e91b37e03c9e5276$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}


'use client';
function $e7adb12ba33c17bd$export$2e2bcd8739ae039(...refs) {
    /**
   * This will create a new function if the refs passed to this hook change and are all defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */ return $7fPBF.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (instance)=>{
            refs.forEach((ref)=>{
                (0, $e91b37e03c9e5276$export$2e2bcd8739ae039)(ref, instance);
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


'use client';
var $4f30d4c1188a58e6$export$2e2bcd8739ae039 = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039);



var $7fPBF = parcelRequire("7fPBF");

'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $bddccca9f6cee29b$var$useEventCallback(fn) {
    const ref = $7fPBF.useRef(fn);
    (0, $fd3794ae41ea97a8$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $7fPBF.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $bddccca9f6cee29b$export$2e2bcd8739ae039 = $bddccca9f6cee29b$var$useEventCallback;


'use client';
var $16db65b1f19e65f7$export$2e2bcd8739ae039 = (0, $bddccca9f6cee29b$export$2e2bcd8739ae039);



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
'use client';
const $890b21ec8e20082a$var$UNINITIALIZED = {};
function $890b21ec8e20082a$export$2e2bcd8739ae039(init, initArg) {
    const ref = $7fPBF.useRef($890b21ec8e20082a$var$UNINITIALIZED);
    if (ref.current === $890b21ec8e20082a$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}



var $7fPBF = parcelRequire("7fPBF");
'use client';
const $1d2095ad20314533$var$EMPTY = [];
function $1d2095ad20314533$export$2e2bcd8739ae039(fn) {
    /* eslint-disable react-hooks/exhaustive-deps */ $7fPBF.useEffect(fn, $1d2095ad20314533$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


'use client';
class $9a1088a9a7141b09$export$786b4da70f00938b {
    constructor(){
        this.currentId = null;
        this.clear = ()=>{
            if (this.currentId !== null) {
                clearTimeout(this.currentId);
                this.currentId = null;
            }
        };
        this.disposeEffect = ()=>{
            return this.clear;
        };
    }
    static create() {
        return new $9a1088a9a7141b09$export$786b4da70f00938b();
    }
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
}
function $9a1088a9a7141b09$export$2e2bcd8739ae039() {
    const timeout = (0, $890b21ec8e20082a$export$2e2bcd8739ae039)($9a1088a9a7141b09$export$786b4da70f00938b.create).current;
    (0, $1d2095ad20314533$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}


'use client';
let $52b16131f46e7800$var$hadKeyboardEvent = true;
let $52b16131f46e7800$var$hadFocusVisibleRecently = false;
const $52b16131f46e7800$var$hadFocusVisibleRecentlyTimeout = new (0, $9a1088a9a7141b09$export$786b4da70f00938b)();
const $52b16131f46e7800$var$inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */ function $52b16131f46e7800$var$focusTriggersKeyboardModality(node) {
    const { type: type, tagName: tagName } = node;
    if (tagName === 'INPUT' && $52b16131f46e7800$var$inputTypesWhitelist[type] && !node.readOnly) return true;
    if (tagName === 'TEXTAREA' && !node.readOnly) return true;
    if (node.isContentEditable) return true;
    return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */ function $52b16131f46e7800$var$handleKeyDown(event) {
    if (event.metaKey || event.altKey || event.ctrlKey) return;
    $52b16131f46e7800$var$hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */ function $52b16131f46e7800$var$handlePointerDown() {
    $52b16131f46e7800$var$hadKeyboardEvent = false;
}
function $52b16131f46e7800$var$handleVisibilityChange() {
    if (this.visibilityState === 'hidden') // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    {
        if ($52b16131f46e7800$var$hadFocusVisibleRecently) $52b16131f46e7800$var$hadKeyboardEvent = true;
    }
}
function $52b16131f46e7800$var$prepare(doc) {
    doc.addEventListener('keydown', $52b16131f46e7800$var$handleKeyDown, true);
    doc.addEventListener('mousedown', $52b16131f46e7800$var$handlePointerDown, true);
    doc.addEventListener('pointerdown', $52b16131f46e7800$var$handlePointerDown, true);
    doc.addEventListener('touchstart', $52b16131f46e7800$var$handlePointerDown, true);
    doc.addEventListener('visibilitychange', $52b16131f46e7800$var$handleVisibilityChange, true);
}
function $52b16131f46e7800$export$4794d9b1949031cf(doc) {
    doc.removeEventListener('keydown', $52b16131f46e7800$var$handleKeyDown, true);
    doc.removeEventListener('mousedown', $52b16131f46e7800$var$handlePointerDown, true);
    doc.removeEventListener('pointerdown', $52b16131f46e7800$var$handlePointerDown, true);
    doc.removeEventListener('touchstart', $52b16131f46e7800$var$handlePointerDown, true);
    doc.removeEventListener('visibilitychange', $52b16131f46e7800$var$handleVisibilityChange, true);
}
function $52b16131f46e7800$var$isFocusVisible(event) {
    const { target: target } = event;
    try {
        return target.matches(':focus-visible');
    } catch (error) {
    // Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
    }
    // No need for validFocusTarget check. The user does that by attaching it to
    // focusable events only.
    return $52b16131f46e7800$var$hadKeyboardEvent || $52b16131f46e7800$var$focusTriggersKeyboardModality(target);
}
function $52b16131f46e7800$export$2e2bcd8739ae039() {
    const ref = $7fPBF.useCallback((node)=>{
        if (node != null) $52b16131f46e7800$var$prepare(node.ownerDocument);
    }, []);
    const isFocusVisibleRef = $7fPBF.useRef(false);
    /**
   * Should be called if a blur event is fired
   */ function handleBlurVisible() {
        // checking against potential state variable does not suffice if we focus and blur synchronously.
        // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
        // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
        // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
        // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
        if (isFocusVisibleRef.current) {
            // To detect a tab/window switch, we look for a blur event followed
            // rapidly by a visibility change.
            // If we don't see a visibility change within 100ms, it's probably a
            // regular focus change.
            $52b16131f46e7800$var$hadFocusVisibleRecently = true;
            $52b16131f46e7800$var$hadFocusVisibleRecentlyTimeout.start(100, ()=>{
                $52b16131f46e7800$var$hadFocusVisibleRecently = false;
            });
            isFocusVisibleRef.current = false;
            return true;
        }
        return false;
    }
    /**
   * Should be called if a blur event is fired
   */ function handleFocusVisible(event) {
        if ($52b16131f46e7800$var$isFocusVisible(event)) {
            isFocusVisibleRef.current = true;
            return true;
        }
        return false;
    }
    return {
        isFocusVisibleRef: isFocusVisibleRef,
        onFocus: handleFocusVisible,
        onBlur: handleBlurVisible,
        ref: ref
    };
}


'use client';
var $77c51d9bab7ec5dd$export$2e2bcd8739ae039 = (0, $52b16131f46e7800$export$2e2bcd8739ae039);



var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");
function $298ff58efa174465$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $da27c96857818bcc$export$2e2bcd8739ae039(t, e) {
    return $da27c96857818bcc$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $da27c96857818bcc$export$2e2bcd8739ae039(t, e);
}


function $146ee816144a450d$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $da27c96857818bcc$export$2e2bcd8739ae039)(t, o);
}




var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $61c94efb1735eff6$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(null);



var $7fPBF = parcelRequire("7fPBF");
function $2a31251aa5f7eb4f$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $7fPBF.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $7fPBF.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $2a31251aa5f7eb4f$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $2a31251aa5f7eb4f$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $2a31251aa5f7eb4f$export$fa71e2345c31d7a2(props, onExited) {
    return $2a31251aa5f7eb4f$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $2a31251aa5f7eb4f$var$getProp(child, 'appear', props),
            enter: $2a31251aa5f7eb4f$var$getProp(child, 'enter', props),
            exit: $2a31251aa5f7eb4f$var$getProp(child, 'exit', props)
        });
    });
}
function $2a31251aa5f7eb4f$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $2a31251aa5f7eb4f$export$bbc8a025727ea824(nextProps.children);
    var children = $2a31251aa5f7eb4f$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $7fPBF.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $7fPBF.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $2a31251aa5f7eb4f$var$getProp(child, 'exit', nextProps),
            enter: $2a31251aa5f7eb4f$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $7fPBF.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $7fPBF.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $2a31251aa5f7eb4f$var$getProp(child, 'exit', nextProps),
            enter: $2a31251aa5f7eb4f$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $30921f11ad4ef55c$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $30921f11ad4ef55c$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $30921f11ad4ef55c$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $146ee816144a450d$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $298ff58efa174465$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $2a31251aa5f7eb4f$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $2a31251aa5f7eb4f$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $2a31251aa5f7eb4f$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $kY3Ke.default)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $cFLic.default)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $30921f11ad4ef55c$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $61c94efb1735eff6$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $61c94efb1735eff6$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Component);
$30921f11ad4ef55c$var$TransitionGroup.propTypes = {};
$30921f11ad4ef55c$var$TransitionGroup.defaultProps = $30921f11ad4ef55c$var$defaultProps;
var $30921f11ad4ef55c$export$2e2bcd8739ae039 = $30921f11ad4ef55c$var$TransitionGroup;



var $hngXp = parcelRequire("hngXp");

var $5nUae = parcelRequire("5nUae");


var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $bbzbN = parcelRequire("bbzbN");
'use client';
function $3d4a0ced9cf2c3c7$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $7fPBF.useState(false);
    const rippleClassName = (0, $hngXp.default)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $hngXp.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $7fPBF.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
            className: childClassName
        })
    });
}
var $3d4a0ced9cf2c3c7$export$2e2bcd8739ae039 = $3d4a0ced9cf2c3c7$var$Ripple;



var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $fbda7a0931c56f58$export$b464606f735ab902(slot) {
    return (0, $k6RDS.default)('MuiTouchRipple', slot);
}
const $fbda7a0931c56f58$var$touchRippleClasses = (0, $4jzsB.default)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $fbda7a0931c56f58$export$2e2bcd8739ae039 = $fbda7a0931c56f58$var$touchRippleClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $3f5ffa895ad4456e$var$_excluded = [
    "center",
    "classes",
    "className"
];
let $3f5ffa895ad4456e$var$_ = (t)=>t, $3f5ffa895ad4456e$var$_t, $3f5ffa895ad4456e$var$_t2, $3f5ffa895ad4456e$var$_t3, $3f5ffa895ad4456e$var$_t4;
const $3f5ffa895ad4456e$var$DURATION = 550;
const $3f5ffa895ad4456e$export$95d0c9356b2231a3 = 80;
const $3f5ffa895ad4456e$var$enterKeyframe = (0, $5nUae.keyframes)($3f5ffa895ad4456e$var$_t || ($3f5ffa895ad4456e$var$_t = $3f5ffa895ad4456e$var$_`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const $3f5ffa895ad4456e$var$exitKeyframe = (0, $5nUae.keyframes)($3f5ffa895ad4456e$var$_t2 || ($3f5ffa895ad4456e$var$_t2 = $3f5ffa895ad4456e$var$_`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const $3f5ffa895ad4456e$var$pulsateKeyframe = (0, $5nUae.keyframes)($3f5ffa895ad4456e$var$_t3 || ($3f5ffa895ad4456e$var$_t3 = $3f5ffa895ad4456e$var$_`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const $3f5ffa895ad4456e$export$f6b7418508c72c25 = (0, $kDBhE.default)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $3f5ffa895ad4456e$export$676cfe7b12693c4b = (0, $kDBhE.default)((0, $3d4a0ced9cf2c3c7$export$2e2bcd8739ae039), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})($3f5ffa895ad4456e$var$_t4 || ($3f5ffa895ad4456e$var$_t4 = $3f5ffa895ad4456e$var$_`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).rippleVisible, $3f5ffa895ad4456e$var$enterKeyframe, $3f5ffa895ad4456e$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).ripplePulsate, ({ theme: theme })=>theme.transitions.duration.shorter, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).child, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).childLeaving, $3f5ffa895ad4456e$var$exitKeyframe, $3f5ffa895ad4456e$var$DURATION, ({ theme: theme })=>theme.transitions.easing.easeInOut, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).childPulsate, $3f5ffa895ad4456e$var$pulsateKeyframe, ({ theme: theme })=>theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $3f5ffa895ad4456e$var$TouchRipple = /*#__PURE__*/ $7fPBF.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className } = props, other = (0, $cFLic.default)(props, $3f5ffa895ad4456e$var$_excluded);
    const [ripples, setRipples] = $7fPBF.useState([]);
    const nextKey = $7fPBF.useRef(0);
    const rippleCallback = $7fPBF.useRef(null);
    $7fPBF.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $7fPBF.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $9a1088a9a7141b09$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $7fPBF.useRef(null);
    const container = $7fPBF.useRef(null);
    const startCommit = $7fPBF.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $bbzbN.jsx)($3f5ffa895ad4456e$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $hngXp.default)(classes.ripple, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $hngXp.default)(classes.rippleVisible, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $hngXp.default)(classes.ripplePulsate, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $hngXp.default)(classes.child, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $hngXp.default)(classes.childLeaving, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $hngXp.default)(classes.childPulsate, (0, $fbda7a0931c56f58$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $3f5ffa895ad4456e$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $7fPBF.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if ((event == null ? void 0 : event.type) === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if ((event == null ? void 0 : event.type) === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event != null && event.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($3f5ffa895ad4456e$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $7fPBF.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $7fPBF.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if ((event == null ? void 0 : event.type) === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $7fPBF.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($3f5ffa895ad4456e$export$f6b7418508c72c25, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)((0, $fbda7a0931c56f58$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container
    }, other, {
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $30921f11ad4ef55c$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    }));
});
var $3f5ffa895ad4456e$export$2e2bcd8739ae039 = $3f5ffa895ad4456e$var$TouchRipple;



var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $d365e8bde1350eb0$export$fccb0498dcd99783(slot) {
    return (0, $k6RDS.default)('MuiButtonBase', slot);
}
const $d365e8bde1350eb0$var$buttonBaseClasses = (0, $4jzsB.default)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $d365e8bde1350eb0$export$2e2bcd8739ae039 = $d365e8bde1350eb0$var$buttonBaseClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $2d0c76ae9ca5c817$var$_excluded = [
    "action",
    "centerRipple",
    "children",
    "className",
    "component",
    "disabled",
    "disableRipple",
    "disableTouchRipple",
    "focusRipple",
    "focusVisibleClassName",
    "LinkComponent",
    "onBlur",
    "onClick",
    "onContextMenu",
    "onDragLeave",
    "onFocus",
    "onFocusVisible",
    "onKeyDown",
    "onKeyUp",
    "onMouseDown",
    "onMouseLeave",
    "onMouseUp",
    "onTouchEnd",
    "onTouchMove",
    "onTouchStart",
    "tabIndex",
    "TouchRippleProps",
    "touchRippleRef",
    "type"
];
const $2d0c76ae9ca5c817$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $d365e8bde1350eb0$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $2d0c76ae9ca5c817$export$7ec0dcc5e3cdcd36 = (0, $kDBhE.default)('button', {
    name: 'MuiButtonBase',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $d365e8bde1350eb0$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $2d0c76ae9ca5c817$var$ButtonBase = /*#__PURE__*/ $7fPBF.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type } = props, other = (0, $cFLic.default)(props, $2d0c76ae9ca5c817$var$_excluded);
    const buttonRef = $7fPBF.useRef(null);
    const rippleRef = $7fPBF.useRef(null);
    const handleRippleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(rippleRef, touchRippleRef);
    const { isFocusVisibleRef: isFocusVisibleRef, onFocus: handleFocusVisible, onBlur: handleBlurVisible, ref: focusVisibleRef } = (0, $77c51d9bab7ec5dd$export$2e2bcd8739ae039)();
    const [focusVisible, setFocusVisible] = $7fPBF.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $7fPBF.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const [mountedState, setMountedState] = $7fPBF.useState(false);
    $7fPBF.useEffect(()=>{
        setMountedState(true);
    }, []);
    const enableTouchRipple = mountedState && !disableRipple && !disabled;
    $7fPBF.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple && mountedState) rippleRef.current.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        mountedState
    ]);
    function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
        return (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)((event)=>{
            if (eventCallback) eventCallback(event);
            const ignore = skipRippleAction;
            if (!ignore && rippleRef.current) rippleRef.current[rippleAction](event);
            return true;
        });
    }
    const handleMouseDown = useRippleHandler('start', onMouseDown);
    const handleContextMenu = useRippleHandler('stop', onContextMenu);
    const handleDragLeave = useRippleHandler('stop', onDragLeave);
    const handleMouseUp = useRippleHandler('stop', onMouseUp);
    const handleMouseLeave = useRippleHandler('stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    });
    const handleTouchStart = useRippleHandler('start', onTouchStart);
    const handleTouchEnd = useRippleHandler('stop', onTouchEnd);
    const handleTouchMove = useRippleHandler('stop', onTouchMove);
    const handleBlur = useRippleHandler('stop', (event)=>{
        handleBlurVisible(event);
        if (isFocusVisibleRef.current === false) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        handleFocusVisible(event);
        if (isFocusVisibleRef.current === true) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */ const keydownRef = $7fPBF.useRef(false);
    const handleKeyDown = (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
            keydownRef.current = true;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.start(event);
            });
        }
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $16db65b1f19e65f7$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
            keydownRef.current = false;
            rippleRef.current.stop(event, ()=>{
                rippleRef.current.pulsate(event);
            });
        }
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $4f30d4c1188a58e6$export$2e2bcd8739ae039)(ref, focusVisibleRef, buttonRef);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    });
    const classes = $2d0c76ae9ca5c817$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($2d0c76ae9ca5c817$export$7ec0dcc5e3cdcd36, (0, $kY3Ke.default)({
        as: ComponentProp,
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type
    }, buttonProps, other, {
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ /* TouchRipple is only needed client-side, x2 boost on the server. */ (0, $bbzbN.jsx)((0, $3f5ffa895ad4456e$export$2e2bcd8739ae039), (0, $kY3Ke.default)({
                ref: handleRippleRef,
                center: centerRipple
            }, TouchRippleProps)) : null
        ]
    }));
});
var $2d0c76ae9ca5c817$export$2e2bcd8739ae039 = $2d0c76ae9ca5c817$var$ButtonBase;



var $b6UUh = parcelRequire("b6UUh");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $bf96407f1f5b4126$export$5a6f9035944c8119(slot) {
    return (0, $k6RDS.default)('MuiButton', slot);
}
const $bf96407f1f5b4126$var$buttonClasses = (0, $4jzsB.default)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge'
]);
var $bf96407f1f5b4126$export$2e2bcd8739ae039 = $bf96407f1f5b4126$var$buttonClasses;



var $7fPBF = parcelRequire("7fPBF");
/**
 * @ignore - internal component.
 */ const $40ed7573a59c2be9$var$ButtonGroupContext = /*#__PURE__*/ $7fPBF.createContext({});
var $40ed7573a59c2be9$export$2e2bcd8739ae039 = $40ed7573a59c2be9$var$ButtonGroupContext;



var $7fPBF = parcelRequire("7fPBF");
/**
 * @ignore - internal component.
 */ const $e319f5c3a4402058$var$ButtonGroupButtonContext = /*#__PURE__*/ $7fPBF.createContext(undefined);
var $e319f5c3a4402058$export$2e2bcd8739ae039 = $e319f5c3a4402058$var$ButtonGroupButtonContext;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $45be1777d6a28263$var$_excluded = [
    "children",
    "color",
    "component",
    "className",
    "disabled",
    "disableElevation",
    "disableFocusRipple",
    "endIcon",
    "focusVisibleClassName",
    "fullWidth",
    "size",
    "startIcon",
    "type",
    "variant"
];
const $45be1777d6a28263$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `${variant}${(0, $b6UUh.default)(color)}`,
            `size${(0, $b6UUh.default)(size)}`,
            `${variant}Size${(0, $b6UUh.default)(size)}`,
            `color${(0, $b6UUh.default)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth'
        ],
        label: [
            'label'
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $b6UUh.default)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $b6UUh.default)(size)}`
        ]
    };
    const composedClasses = (0, $cFCqu.default)(slots, (0, $bf96407f1f5b4126$export$5a6f9035944c8119), classes);
    return (0, $kY3Ke.default)({}, classes, composedClasses);
};
const $45be1777d6a28263$var$commonIconStyles = (ownerState)=>(0, $kY3Ke.default)({}, ownerState.size === 'small' && {
        '& > *:nth-of-type(1)': {
            fontSize: 18
        }
    }, ownerState.size === 'medium' && {
        '& > *:nth-of-type(1)': {
            fontSize: 20
        }
    }, ownerState.size === 'large' && {
        '& > *:nth-of-type(1)': {
            fontSize: 22
        }
    });
const $45be1777d6a28263$var$ButtonRoot = (0, $kDBhE.default)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $HgAeG.default)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $b6UUh.default)(ownerState.color)}`],
            styles[`size${(0, $b6UUh.default)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $b6UUh.default)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>{
    var _theme$palette$getCon, _theme$palette;
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return (0, $kY3Ke.default)({}, theme.typography.button, {
        minWidth: 64,
        padding: '6px 16px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': (0, $kY3Ke.default)({
            textDecoration: 'none',
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.text.primaryChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7jL4F.alpha)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7jL4F.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
            border: `1px solid ${(theme.vars || theme).palette[ownerState.color].main}`,
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette[ownerState.color].mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7jL4F.alpha)(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }, ownerState.variant === 'contained' && {
            backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
            boxShadow: (theme.vars || theme).shadows[4],
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                boxShadow: (theme.vars || theme).shadows[2],
                backgroundColor: (theme.vars || theme).palette.grey[300]
            }
        }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
            backgroundColor: (theme.vars || theme).palette[ownerState.color].dark,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: (theme.vars || theme).palette[ownerState.color].main
            }
        }),
        '&:active': (0, $kY3Ke.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[8]
        }),
        [`&.${(0, $bf96407f1f5b4126$export$2e2bcd8739ae039).focusVisible}`]: (0, $kY3Ke.default)({}, ownerState.variant === 'contained' && {
            boxShadow: (theme.vars || theme).shadows[6]
        }),
        [`&.${(0, $bf96407f1f5b4126$export$2e2bcd8739ae039).disabled}`]: (0, $kY3Ke.default)({
            color: (theme.vars || theme).palette.action.disabled
        }, ownerState.variant === 'outlined' && {
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        }, ownerState.variant === 'contained' && {
            color: (theme.vars || theme).palette.action.disabled,
            boxShadow: (theme.vars || theme).shadows[0],
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        })
    }, ownerState.variant === 'text' && {
        padding: '6px 8px'
    }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.variant === 'outlined' && {
        padding: '5px 15px',
        border: '1px solid currentColor'
    }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].main,
        border: theme.vars ? `1px solid rgba(${theme.vars.palette[ownerState.color].mainChannel} / 0.5)` : `1px solid ${(0, $7jL4F.alpha)(theme.palette[ownerState.color].main, 0.5)}`
    }, ownerState.variant === 'contained' && {
        color: theme.vars ? // this is safe because grey does not change between default light/dark mode
        theme.vars.palette.text.primary : (_theme$palette$getCon = (_theme$palette = theme.palette).getContrastText) == null ? void 0 : _theme$palette$getCon.call(_theme$palette, theme.palette.grey[300]),
        backgroundColor: theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
        boxShadow: (theme.vars || theme).shadows[2]
    }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
        color: (theme.vars || theme).palette[ownerState.color].contrastText,
        backgroundColor: (theme.vars || theme).palette[ownerState.color].main
    }, ownerState.color === 'inherit' && {
        color: 'inherit',
        borderColor: 'currentColor'
    }, ownerState.size === 'small' && ownerState.variant === 'text' && {
        padding: '4px 5px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'text' && {
        padding: '8px 11px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
        padding: '3px 9px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'outlined' && {
        padding: '7px 21px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.size === 'small' && ownerState.variant === 'contained' && {
        padding: '4px 10px',
        fontSize: theme.typography.pxToRem(13)
    }, ownerState.size === 'large' && ownerState.variant === 'contained' && {
        padding: '8px 22px',
        fontSize: theme.typography.pxToRem(15)
    }, ownerState.fullWidth && {
        width: '100%'
    });
}, ({ ownerState: ownerState })=>ownerState.disableElevation && {
        boxShadow: 'none',
        '&:hover': {
            boxShadow: 'none'
        },
        [`&.${(0, $bf96407f1f5b4126$export$2e2bcd8739ae039).focusVisible}`]: {
            boxShadow: 'none'
        },
        '&:active': {
            boxShadow: 'none'
        },
        [`&.${(0, $bf96407f1f5b4126$export$2e2bcd8739ae039).disabled}`]: {
            boxShadow: 'none'
        }
    });
const $45be1777d6a28263$var$ButtonStartIcon = (0, $kDBhE.default)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            styles[`iconSize${(0, $b6UUh.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4
    }, ownerState.size === 'small' && {
        marginLeft: -2
    }, $45be1777d6a28263$var$commonIconStyles(ownerState)));
const $45be1777d6a28263$var$ButtonEndIcon = (0, $kDBhE.default)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            styles[`iconSize${(0, $b6UUh.default)(ownerState.size)}`]
        ];
    }
})(({ ownerState: ownerState })=>(0, $kY3Ke.default)({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8
    }, ownerState.size === 'small' && {
        marginRight: -2
    }, $45be1777d6a28263$var$commonIconStyles(ownerState)));
const $45be1777d6a28263$var$Button = /*#__PURE__*/ $7fPBF.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $7fPBF.useContext((0, $40ed7573a59c2be9$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $7fPBF.useContext((0, $e319f5c3a4402058$export$2e2bcd8739ae039));
    const resolvedProps = (0, $gjk5S.default)(contextProps, inProps);
    const props = (0, $iVAEr.useDefaultProps)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text' } = props, other = (0, $cFLic.default)(props, $45be1777d6a28263$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size,
        type: type,
        variant: variant
    });
    const classes = $45be1777d6a28263$var$useUtilityClasses(ownerState);
    const startIcon = startIconProp && /*#__PURE__*/ (0, $bbzbN.jsx)($45be1777d6a28263$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp
    });
    const endIcon = endIconProp && /*#__PURE__*/ (0, $bbzbN.jsx)($45be1777d6a28263$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($45be1777d6a28263$var$ButtonRoot, (0, $kY3Ke.default)({
        ownerState: ownerState,
        className: (0, $hngXp.default)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $hngXp.default)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type
    }, other, {
        classes: classes,
        children: [
            startIcon,
            children,
            endIcon
        ]
    }));
});
var $45be1777d6a28263$export$2e2bcd8739ae039 = $45be1777d6a28263$var$Button;


var $639cf2d093bbb4ad$exports = {};
"use strict";
"use client";

var $62qsu = parcelRequire("62qsu");
Object.defineProperty($639cf2d093bbb4ad$exports, "__esModule", {
    value: true
});
$639cf2d093bbb4ad$exports.default = void 0;

var $639cf2d093bbb4ad$var$_createSvgIcon = $62qsu((parcelRequire("3xowt")));

var $bbzbN = parcelRequire("bbzbN");
var $639cf2d093bbb4ad$var$_default = $639cf2d093bbb4ad$exports.default = (0, $639cf2d093bbb4ad$var$_createSvgIcon.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2m-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2m3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1z"
}), 'Lock');


const $b89333b7d3d5e162$var$Unauthorized = ()=>{
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const state = location.state;
    const getMessage = ()=>{
        switch(state?.reason){
            case 'inactive':
                return 'Your account has been deactivated. Please contact your administrator.';
            case 'insufficient_permissions':
                return 'You do not have permission to access this resource.';
            default:
                return 'Access denied.';
        }
    };
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a224e7f09a1cd55c$export$2e2bcd8739ae039), {
        maxWidth: "sm",
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
            sx: {
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            },
            children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $74e245c78e363f11$export$2e2bcd8739ae039), {
                elevation: 3,
                sx: {
                    p: 4,
                    width: '100%',
                    borderRadius: 2,
                    textAlign: 'center'
                },
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        sx: {
                            mb: 3,
                            display: 'flex',
                            justifyContent: 'center'
                        },
                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                            sx: {
                                width: 80,
                                height: 80,
                                borderRadius: '50%',
                                backgroundColor: 'error.light',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            },
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($639cf2d093bbb4ad$exports))), {
                                sx: {
                                    fontSize: 40,
                                    color: 'white'
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                        variant: "h4",
                        component: "h1",
                        gutterBottom: true,
                        fontWeight: 600,
                        children: "Access Denied"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                        variant: "body1",
                        color: "text.secondary",
                        sx: {
                            mb: 3
                        },
                        children: getMessage()
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
                        sx: {
                            display: 'flex',
                            gap: 2,
                            justifyContent: 'center'
                        },
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                                variant: "outlined",
                                onClick: ()=>navigate(-1),
                                children: "Go Back"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                                variant: "contained",
                                onClick: ()=>navigate('/'),
                                children: "Go to Dashboard"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var $b89333b7d3d5e162$export$2e2bcd8739ae039 = $b89333b7d3d5e162$var$Unauthorized;


/**
 * ProtectedRoute Component
 * Wraps routes that require authentication
 * Redirects to login if user is not authenticated
 * Optionally checks for specific roles
 */ 
var $bbzbN = parcelRequire("bbzbN");
parcelRequire("7fPBF");



const $4f8bd3ca50416f0f$var$ProtectedRoute = ({ children: children, requiredRole: requiredRole, requireAdmin: requireAdmin = false })=>{
    const { user: user, isAuthenticated: isAuthenticated, isLoading: isLoading } = (0, $d0020511b775fb45$export$1d39dc5b47e56ff0)();
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    // Show loading spinner while checking authentication
    if (isLoading) return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d513166e63c42433$export$2e2bcd8739ae039), {})
    });
    // Not authenticated - redirect to login
    if (!isAuthenticated || !user) return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d9fd026bfea79ab9$export$444b3ab0cb9aec40), {
        to: "/login",
        state: {
            from: location
        },
        replace: true
    });
    // Check if user account is active
    if (!user.is_active) return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d9fd026bfea79ab9$export$444b3ab0cb9aec40), {
        to: "/unauthorized",
        state: {
            reason: 'inactive'
        },
        replace: true
    });
    // Check for admin requirement
    if (requireAdmin && user.role !== 'admin' && user.role !== 'super') return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d9fd026bfea79ab9$export$444b3ab0cb9aec40), {
        to: "/unauthorized",
        state: {
            reason: 'insufficient_permissions'
        },
        replace: true
    });
    // Check for specific role requirement
    if (requiredRole && user.role !== requiredRole && user.role !== 'admin') return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d9fd026bfea79ab9$export$444b3ab0cb9aec40), {
        to: "/unauthorized",
        state: {
            reason: 'insufficient_permissions'
        },
        replace: true
    });
    // All checks passed - render the protected component
    return children;
};
var $4f8bd3ca50416f0f$export$2e2bcd8739ae039 = $4f8bd3ca50416f0f$var$ProtectedRoute;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");



const $550e366f11f56e36$var$NAV = [
    {
        id: 'dashboard',
        label: 'Portfolio Dashboard',
        icon: 'dashboard',
        path: '/'
    },
    {
        id: 'alerts',
        label: 'Margin Alerts',
        icon: 'alerts',
        path: '/alerts'
    },
    {
        id: 'exposure',
        label: 'Exposure Analysis',
        icon: 'exposure',
        path: '/exposure'
    },
    {
        id: 'comments',
        label: 'All Comments',
        icon: 'comments',
        path: '/comments'
    },
    {
        id: 'admin',
        label: 'Admin Panel',
        icon: 'admin',
        path: '/admin',
        adminOnly: true
    }
];
function $550e366f11f56e36$var$MarketStatus() {
    const [now, setNow] = (0, $7fPBF.useState)(new Date());
    (0, $7fPBF.useEffect)(()=>{
        const t = setInterval(()=>setNow(new Date()), 1000);
        return ()=>clearInterval(t);
    }, []);
    const ny = new Date(now.toLocaleString('en-US', {
        timeZone: 'America/New_York'
    }));
    const mins = ny.getHours() * 60 + ny.getMinutes();
    const open = mins >= 570 && mins <= 960;
    const time = ny.toLocaleTimeString('en-US', {
        hour12: false
    });
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "flex flex-col gap-1.5",
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "flex items-center justify-between text-[11px] text-[#7A7A76]",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        className: "tracking-[0.06em] uppercase font-bold text-[9.5px]",
                        children: "Market"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                        className: `inline-flex items-center gap-[5px] text-[10px] font-bold px-[7px] py-[2px] tracking-[0.08em] uppercase ${open ? 'text-[#1f8a4a] bg-[rgba(31,138,74,0.10)]' : 'text-[#999591] bg-black/[0.06]'}`,
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                className: "w-1.5 h-1.5 rounded-full bg-current"
                            }),
                            open ? 'Open' : 'Closed'
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: "flex items-center justify-between text-[11px] text-[#7A7A76]",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        className: "tracking-[0.06em] uppercase font-bold text-[9.5px]",
                        children: "EST"
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                        style: {
                            fontFamily: 'ui-monospace, Menlo, monospace',
                            fontSize: 11,
                            color: '#333'
                        },
                        children: time
                    })
                ]
            })
        ]
    });
}
const $550e366f11f56e36$var$SidebarLayout = ({ children: children })=>{
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const { user: user, logout: logout } = (0, $d0020511b775fb45$export$1d39dc5b47e56ff0)();
    const [privacyMode, setPrivacyMode] = (0, $7fPBF.useState)(false);
    const [changePasswordOpen, setChangePasswordOpen] = (0, $7fPBF.useState)(false);
    const [sidebarOpen, setSidebarOpen] = (0, $7fPBF.useState)(false);
    const canAccessAdmin = user?.role === 'admin' || user?.role === 'super';
    (0, $7fPBF.useEffect)(()=>{
        document.body.dataset['privacy'] = privacyMode ? 'on' : 'off';
    }, [
        privacyMode
    ]);
    (0, $7fPBF.useEffect)(()=>{
        setSidebarOpen(false);
    }, [
        location.pathname
    ]);
    const isActive = (path)=>path === '/' ? location.pathname === '/' : location.pathname.startsWith(path);
    const getUserDisplayName = ()=>{
        if (user?.first_name && user?.last_name) return `${user.first_name} ${user.last_name}`;
        if (user?.email) return user.email.split('@')[0];
        return 'User';
    };
    const getUserRole = ()=>{
        if (!user?.role) return 'User';
        return user.role.charAt(0).toUpperCase() + user.role.slice(1);
    };
    const handleLogout = async ()=>{
        await logout();
        navigate('/login');
    };
    return /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
        className: "grid min-h-screen max-[768px]:grid-cols-1 [grid-template-columns:224px_1fr]",
        children: [
            sidebarOpen && /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                className: "fixed inset-0 bg-black/[0.36] z-[199]",
                onClick: ()=>setSidebarOpen(false)
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                className: `bg-white border-r border-black/[0.08] flex flex-col sticky top-0 h-screen max-[768px]:fixed max-[768px]:left-0 max-[768px]:top-0 max-[768px]:h-screen max-[768px]:w-[224px] max-[768px]:z-[200] max-[768px]:transition-transform max-[768px]:duration-[220ms] ${sidebarOpen ? 'max-[768px]:translate-x-0' : 'max-[768px]:-translate-x-full'}`,
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "flex items-center gap-2.5 px-[18px] pt-[18px] pb-[22px] border-b border-black/[0.06] shrink-0",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "w-9 h-9 bg-[#E50025] grid place-items-center text-white font-serif font-[800] text-[18px] tracking-[-0.02em] shrink-0",
                                children: "M"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                className: "h-9 flex flex-col leading-none justify-between",
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                        className: "text-[10px] font-bold tracking-[0.14em] uppercase text-[#E50025]",
                                        children: "Lighthouse Canton"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                        className: "text-[15px] font-medium font-serif text-black mt-1 tracking-[-0.005em]",
                                        children: "Margin Risk System"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsx)("nav", {
                        className: "flex flex-col gap-px px-2.5 py-3.5 flex-1 overflow-y-auto",
                        children: $550e366f11f56e36$var$NAV.filter((item)=>!item.adminOnly || canAccessAdmin).map((item)=>{
                            const active = isActive(item.path) || item.path === '/' && location.pathname.startsWith('/portfolio');
                            return /*#__PURE__*/ (0, $bbzbN.jsxs)("button", {
                                className: `flex items-center gap-3 px-3 py-[9px] text-[13.5px] cursor-pointer border-0 bg-transparent text-left w-full rounded-sm relative transition-colors duration-[120ms] ${active ? 'text-[#E50025] font-semibold bg-[#FAF9F8]' : 'font-normal text-[#333] hover:bg-[#FAF9F8] hover:text-black'}`,
                                onClick: ()=>navigate(item.path),
                                children: [
                                    active && /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                        className: "absolute left-0 top-1.5 bottom-1.5 w-0.5 bg-[#E50025]"
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                        name: item.icon,
                                        size: 17,
                                        className: `shrink-0 ${active ? 'opacity-100' : 'opacity-85'}`
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                        children: item.label
                                    })
                                ]
                            }, item.id);
                        })
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "border-t border-black/[0.06] px-3.5 py-3 pb-4 flex flex-col gap-3 shrink-0",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                className: "flex items-center justify-between py-1",
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)("span", {
                                        className: "flex items-center gap-2 text-[12.5px] text-[#333]",
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                                name: "eye",
                                                size: 14
                                            }),
                                            "Privacy Mode"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                        className: `lc-switch${privacyMode ? ' on' : ''}`,
                                        onClick: ()=>setPrivacyMode((v)=>!v),
                                        role: "switch",
                                        "aria-checked": privacyMode
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)($550e366f11f56e36$var$MarketStatus, {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "flex flex-col py-1 border-t border-black/[0.06] px-3.5 py-3 pb-4 flex flex-col gap-2 shrink-0",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "text-[13px] font-bold text-black tracking-[-0.005em]",
                                children: getUserDisplayName()
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                                className: "flex justify-between mt-2 text-[11.5px] font-normal text-[#7A7A76]",
                                children: [
                                    /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                        className: "tracking-[0.06em] uppercase font-bold text-[9.5px]",
                                        children: getUserRole()
                                    }),
                                    /*#__PURE__*/ (0, $bbzbN.jsxs)("a", {
                                        href: "#",
                                        className: "inline-flex items-center text-inherit hover:text-[#E50025] hover:no-underline",
                                        onClick: (e)=>{
                                            e.preventDefault();
                                            handleLogout();
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $8598e7256be7fb3c$export$2e2bcd8739ae039), {
                                                name: "logout",
                                                size: 12
                                            }),
                                            " Logout"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bbzbN.jsxs)("main", {
                className: "flex flex-col min-h-screen min-w-0 overflow-x-hidden",
                children: [
                    /*#__PURE__*/ (0, $bbzbN.jsxs)("div", {
                        className: "hidden max-[768px]:flex items-center gap-3 px-4 py-2.5 bg-white border-b border-black/[0.08] sticky top-0 z-[50] shrink-0",
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)("button", {
                                className: "bg-transparent border-0 cursor-pointer p-1.5 text-black flex items-center justify-center shrink-0 hover:text-[#E50025]",
                                onClick: ()=>setSidebarOpen((v)=>!v),
                                "aria-label": "Toggle menu",
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)("svg", {
                                    width: "20",
                                    height: "20",
                                    viewBox: "0 0 20 20",
                                    fill: "none",
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)("path", {
                                        d: "M3 5h14M3 10h14M3 15h14",
                                        stroke: "currentColor",
                                        strokeWidth: "1.5",
                                        strokeLinecap: "round"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                className: "w-7 h-7 bg-[#E50025] grid place-items-center text-white font-sans font-[800] text-[14px] shrink-0",
                                children: "L"
                            }),
                            /*#__PURE__*/ (0, $bbzbN.jsx)("span", {
                                className: "text-[13px] font-semibold text-black flex-1 tracking-[-0.01em]",
                                children: "Lighthouse Canton"
                            })
                        ]
                    }),
                    children
                ]
            })
        ]
    });
};
var $550e366f11f56e36$export$2e2bcd8739ae039 = $550e366f11f56e36$var$SidebarLayout;



var $bbzbN = parcelRequire("bbzbN");

var $7fPBF = parcelRequire("7fPBF");

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");


var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $833ef9b800b82ea7$export$f3b76d2cce458caa(slot) {
    return (0, $k6RDS.default)('MuiCard', slot);
}
const $833ef9b800b82ea7$var$cardClasses = (0, $4jzsB.default)('MuiCard', [
    'root'
]);
var $833ef9b800b82ea7$export$2e2bcd8739ae039 = $833ef9b800b82ea7$var$cardClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $bfb223886c302418$var$_excluded = [
    "className",
    "raised"
];
const $bfb223886c302418$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $833ef9b800b82ea7$export$f3b76d2cce458caa), classes);
};
const $bfb223886c302418$var$CardRoot = (0, $kDBhE.default)((0, $74e245c78e363f11$export$2e2bcd8739ae039), {
    name: 'MuiCard',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        overflow: 'hidden'
    };
});
const $bfb223886c302418$var$Card = /*#__PURE__*/ $7fPBF.forwardRef(function Card(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiCard'
    });
    const { className: className, raised: raised = false } = props, other = (0, $cFLic.default)(props, $bfb223886c302418$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        raised: raised
    });
    const classes = $bfb223886c302418$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($bfb223886c302418$var$CardRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState
    }, other));
});
var $bfb223886c302418$export$2e2bcd8739ae039 = $bfb223886c302418$var$Card;


var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $c2cdbecd165cb878$export$964336739a8c7119(slot) {
    return (0, $k6RDS.default)('MuiCardContent', slot);
}
const $c2cdbecd165cb878$var$cardContentClasses = (0, $4jzsB.default)('MuiCardContent', [
    'root'
]);
var $c2cdbecd165cb878$export$2e2bcd8739ae039 = $c2cdbecd165cb878$var$cardContentClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $8bffaacbbee0c705$var$_excluded = [
    "className",
    "component"
];
const $8bffaacbbee0c705$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $c2cdbecd165cb878$export$964336739a8c7119), classes);
};
const $8bffaacbbee0c705$var$CardContentRoot = (0, $kDBhE.default)('div', {
    name: 'MuiCardContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>styles.root
})(()=>{
    return {
        padding: 16,
        '&:last-child': {
            paddingBottom: 24
        }
    };
});
const $8bffaacbbee0c705$var$CardContent = /*#__PURE__*/ $7fPBF.forwardRef(function CardContent(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiCardContent'
    });
    const { className: className, component: component = 'div' } = props, other = (0, $cFLic.default)(props, $8bffaacbbee0c705$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        component: component
    });
    const classes = $8bffaacbbee0c705$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($8bffaacbbee0c705$var$CardContentRoot, (0, $kY3Ke.default)({
        as: component,
        className: (0, $hngXp.default)(classes.root, className),
        ownerState: ownerState,
        ref: ref
    }, other));
});
var $8bffaacbbee0c705$export$2e2bcd8739ae039 = $8bffaacbbee0c705$var$CardContent;


var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");

var $cFCqu = parcelRequire("cFCqu");

var $7jL4F = parcelRequire("7jL4F");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");

var $kY3Ke = parcelRequire("kY3Ke");

var $cFLic = parcelRequire("cFLic");


var $kY3Ke = parcelRequire("kY3Ke");
/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $b4522a0df256fb21$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $b4522a0df256fb21$export$2e2bcd8739ae039 = $b4522a0df256fb21$var$isHostComponent;


/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $4520d0f80a3f7305$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $b4522a0df256fb21$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return (0, $kY3Ke.default)({}, otherProps, {
        ownerState: (0, $kY3Ke.default)({}, otherProps.ownerState, ownerState)
    });
}
var $4520d0f80a3f7305$export$2e2bcd8739ae039 = $4520d0f80a3f7305$var$appendOwnerState;


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $ae0f0ccae9f4b3cc$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $ae0f0ccae9f4b3cc$export$2e2bcd8739ae039 = $ae0f0ccae9f4b3cc$var$resolveComponentProps;



var $kY3Ke = parcelRequire("kY3Ke");

var $hngXp = parcelRequire("hngXp");
/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $7a075a443b93da2d$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $7a075a443b93da2d$export$2e2bcd8739ae039 = $7a075a443b93da2d$var$extractEventHandlers;


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $16d23e6599aa60ec$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $16d23e6599aa60ec$export$2e2bcd8739ae039 = $16d23e6599aa60ec$var$omitEventHandlers;


/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $a945a7a9a1371b8c$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $hngXp.default)(additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
        const mergedStyle = (0, $kY3Ke.default)({}, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
        const props = (0, $kY3Ke.default)({}, additionalProps, externalForwardedProps, externalSlotProps);
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $7a075a443b93da2d$export$2e2bcd8739ae039)((0, $kY3Ke.default)({}, externalForwardedProps, externalSlotProps));
    const componentsPropsWithoutEventHandlers = (0, $16d23e6599aa60ec$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $16d23e6599aa60ec$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $hngXp.default)(internalSlotProps == null ? void 0 : internalSlotProps.className, additionalProps == null ? void 0 : additionalProps.className, className, externalForwardedProps == null ? void 0 : externalForwardedProps.className, externalSlotProps == null ? void 0 : externalSlotProps.className);
    const mergedStyle = (0, $kY3Ke.default)({}, internalSlotProps == null ? void 0 : internalSlotProps.style, additionalProps == null ? void 0 : additionalProps.style, externalForwardedProps == null ? void 0 : externalForwardedProps.style, externalSlotProps == null ? void 0 : externalSlotProps.style);
    const props = (0, $kY3Ke.default)({}, internalSlotProps, additionalProps, otherPropsWithoutEventHandlers, componentsPropsWithoutEventHandlers);
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $a945a7a9a1371b8c$export$2e2bcd8739ae039 = $a945a7a9a1371b8c$var$mergeSlotProps;


'use client';
const $6a8e6231295d6b22$var$_excluded = [
    "className",
    "elementType",
    "ownerState",
    "externalForwardedProps",
    "getSlotOwnerState",
    "internalForwardedProps"
], $6a8e6231295d6b22$var$_excluded2 = [
    "component",
    "slots",
    "slotProps"
], $6a8e6231295d6b22$var$_excluded3 = [
    "component"
];
function $6a8e6231295d6b22$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, getSlotOwnerState: getSlotOwnerState, internalForwardedProps: internalForwardedProps } = parameters, useSlotPropsParams = (0, $cFLic.default)(parameters, $6a8e6231295d6b22$var$_excluded);
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    } } = externalForwardedProps, other = (0, $cFLic.default)(externalForwardedProps, $6a8e6231295d6b22$var$_excluded2);
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $ae0f0ccae9f4b3cc$export$2e2bcd8739ae039)(slotProps[name], ownerState);
    const _mergeSlotProps = (0, $a945a7a9a1371b8c$export$2e2bcd8739ae039)((0, $kY3Ke.default)({
        className: className
    }, useSlotPropsParams, {
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    })), { props: { component: slotComponent }, internalRef: internalRef } = _mergeSlotProps, mergedProps = (0, $cFLic.default)(_mergeSlotProps.props, $6a8e6231295d6b22$var$_excluded3);
    const ref = (0, $e7adb12ba33c17bd$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps == null ? void 0 : resolvedComponentsProps.ref, parameters.ref);
    const slotOwnerState = getSlotOwnerState ? getSlotOwnerState(mergedProps) : {};
    const finalOwnerState = (0, $kY3Ke.default)({}, ownerState, slotOwnerState);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $4520d0f80a3f7305$export$2e2bcd8739ae039)(elementType, (0, $kY3Ke.default)({}, name === 'root' && !rootComponent && !slots[name] && internalForwardedProps, name !== 'root' && !slots[name] && internalForwardedProps, mergedProps, LeafComponent && {
        as: LeafComponent
    }, {
        ref: ref
    }), finalOwnerState);
    Object.keys(slotOwnerState).forEach((propName)=>{
        delete props[propName];
    });
    return [
        elementType,
        props
    ];
}



var $b6UUh = parcelRequire("b6UUh");


var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $565e939c768ed837$export$69aecd24bc2cf7e3(slot) {
    return (0, $k6RDS.default)('MuiAlert', slot);
}
const $565e939c768ed837$var$alertClasses = (0, $4jzsB.default)('MuiAlert', [
    'root',
    'action',
    'icon',
    'message',
    'filled',
    'colorSuccess',
    'colorInfo',
    'colorWarning',
    'colorError',
    'filledSuccess',
    'filledInfo',
    'filledWarning',
    'filledError',
    'outlined',
    'outlinedSuccess',
    'outlinedInfo',
    'outlinedWarning',
    'outlinedError',
    'standard',
    'standardSuccess',
    'standardInfo',
    'standardWarning',
    'standardError'
]);
var $565e939c768ed837$export$2e2bcd8739ae039 = $565e939c768ed837$var$alertClasses;



var $cFLic = parcelRequire("cFLic");

var $kY3Ke = parcelRequire("kY3Ke");

var $7fPBF = parcelRequire("7fPBF");


var $hngXp = parcelRequire("hngXp");


var $cFCqu = parcelRequire("cFCqu");

var $7jL4F = parcelRequire("7jL4F");

var $kDBhE = parcelRequire("kDBhE");

var $iVAEr = parcelRequire("iVAEr");


var $b6UUh = parcelRequire("b6UUh");

var $4jzsB = parcelRequire("4jzsB");

var $k6RDS = parcelRequire("k6RDS");
function $0bca18aab596affa$export$5e8702d71474f093(slot) {
    return (0, $k6RDS.default)('MuiIconButton', slot);
}
const $0bca18aab596affa$var$iconButtonClasses = (0, $4jzsB.default)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge'
]);
var $0bca18aab596affa$export$2e2bcd8739ae039 = $0bca18aab596affa$var$iconButtonClasses;



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $67a243c492197f3b$var$_excluded = [
    "edge",
    "children",
    "className",
    "color",
    "disabled",
    "disableFocusRipple",
    "size"
];
const $67a243c492197f3b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $b6UUh.default)(color)}`,
            edge && `edge${(0, $b6UUh.default)(edge)}`,
            `size${(0, $b6UUh.default)(size)}`
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $0bca18aab596affa$export$5e8702d71474f093), classes);
};
const $67a243c492197f3b$var$IconButtonRoot = (0, $kDBhE.default)((0, $2d0c76ae9ca5c817$export$2e2bcd8739ae039), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $b6UUh.default)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $b6UUh.default)(ownerState.edge)}`],
            styles[`size${(0, $b6UUh.default)(ownerState.size)}`]
        ];
    }
})(({ theme: theme, ownerState: ownerState })=>(0, $kY3Ke.default)({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        overflow: 'visible',
        // Explicitly set the default value to solve a bug on IE11.
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        })
    }, !ownerState.disableRipple && {
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7jL4F.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        }
    }, ownerState.edge === 'start' && {
        marginLeft: ownerState.size === 'small' ? -3 : -12
    }, ownerState.edge === 'end' && {
        marginRight: ownerState.size === 'small' ? -3 : -12
    }), ({ theme: theme, ownerState: ownerState })=>{
    var _palette;
    const palette = (_palette = (theme.vars || theme).palette) == null ? void 0 : _palette[ownerState.color];
    return (0, $kY3Ke.default)({}, ownerState.color === 'inherit' && {
        color: 'inherit'
    }, ownerState.color !== 'inherit' && ownerState.color !== 'default' && (0, $kY3Ke.default)({
        color: palette == null ? void 0 : palette.main
    }, !ownerState.disableRipple && {
        '&:hover': (0, $kY3Ke.default)({}, palette && {
            backgroundColor: theme.vars ? `rgba(${palette.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7jL4F.alpha)(palette.main, theme.palette.action.hoverOpacity)
        }, {
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        })
    }), ownerState.size === 'small' && {
        padding: 5,
        fontSize: theme.typography.pxToRem(18)
    }, ownerState.size === 'large' && {
        padding: 12,
        fontSize: theme.typography.pxToRem(28)
    }, {
        [`&.${(0, $0bca18aab596affa$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        }
    });
});
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $67a243c492197f3b$var$IconButton = /*#__PURE__*/ $7fPBF.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium' } = props, other = (0, $cFLic.default)(props, $67a243c492197f3b$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        size: size
    });
    const classes = $67a243c492197f3b$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $bbzbN.jsx)($67a243c492197f3b$var$IconButtonRoot, (0, $kY3Ke.default)({
        className: (0, $hngXp.default)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled,
        ref: ref
    }, other, {
        ownerState: ownerState,
        children: children
    }));
});
var $67a243c492197f3b$export$2e2bcd8739ae039 = $67a243c492197f3b$var$IconButton;


parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
'use client';
var $4b1f521fdeb04ba7$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');


parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
'use client';
var $a8adb66ebb93bcb3$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');


parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
'use client';
var $ac73453dd233d58d$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');


parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
'use client';
var $f3c8ba0a935153e4$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');


parcelRequire("7fPBF");

var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
'use client';
var $8b028f185c60f26d$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');



var $bbzbN = parcelRequire("bbzbN");
'use client';
const $c181cff0789717b3$var$_excluded = [
    "action",
    "children",
    "className",
    "closeText",
    "color",
    "components",
    "componentsProps",
    "icon",
    "iconMapping",
    "onClose",
    "role",
    "severity",
    "slotProps",
    "slots",
    "variant"
];
const $c181cff0789717b3$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $b6UUh.default)(color || severity)}`,
            `${variant}${(0, $b6UUh.default)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            'icon'
        ],
        message: [
            'message'
        ],
        action: [
            'action'
        ]
    };
    return (0, $cFCqu.default)(slots, (0, $565e939c768ed837$export$69aecd24bc2cf7e3), classes);
};
const $c181cff0789717b3$var$AlertRoot = (0, $kDBhE.default)((0, $74e245c78e363f11$export$2e2bcd8739ae039), {
    name: 'MuiAlert',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $b6UUh.default)(ownerState.color || ownerState.severity)}`]
        ];
    }
})(({ theme: theme })=>{
    const getColor = theme.palette.mode === 'light' ? (0, $7jL4F.darken) : (0, $7jL4F.lighten);
    const getBackgroundColor = theme.palette.mode === 'light' ? (0, $7jL4F.lighten) : (0, $7jL4F.darken);
    return (0, $kY3Ke.default)({}, theme.typography.body2, {
        backgroundColor: 'transparent',
        display: 'flex',
        padding: '6px 16px',
        variants: [
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'standard'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
                        [`& .${(0, $565e939c768ed837$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.light).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'outlined'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
                        [`& .${(0, $565e939c768ed837$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter(([, value])=>value.main && value.dark).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'filled'
                    },
                    style: (0, $kY3Ke.default)({
                        fontWeight: theme.typography.fontWeightMedium
                    }, theme.vars ? {
                        color: theme.vars.palette.Alert[`${color}FilledColor`],
                        backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
                    } : {
                        backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main,
                        color: theme.palette.getContrastText(theme.palette[color].main)
                    })
                }))
        ]
    });
});
const $c181cff0789717b3$var$AlertIcon = (0, $kDBhE.default)('div', {
    name: 'MuiAlert',
    slot: 'Icon',
    overridesResolver: (props, styles)=>styles.icon
})({
    marginRight: 12,
    padding: '7px 0',
    display: 'flex',
    fontSize: 22,
    opacity: 0.9
});
const $c181cff0789717b3$var$AlertMessage = (0, $kDBhE.default)('div', {
    name: 'MuiAlert',
    slot: 'Message',
    overridesResolver: (props, styles)=>styles.message
})({
    padding: '8px 0',
    minWidth: 0,
    overflow: 'auto'
});
const $c181cff0789717b3$var$AlertAction = (0, $kDBhE.default)('div', {
    name: 'MuiAlert',
    slot: 'Action',
    overridesResolver: (props, styles)=>styles.action
})({
    display: 'flex',
    alignItems: 'flex-start',
    padding: '4px 0 0 16px',
    marginLeft: 'auto',
    marginRight: -8
});
const $c181cff0789717b3$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4b1f521fdeb04ba7$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a8adb66ebb93bcb3$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $ac73453dd233d58d$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $f3c8ba0a935153e4$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    })
};
const $c181cff0789717b3$var$Alert = /*#__PURE__*/ $7fPBF.forwardRef(function Alert(inProps, ref) {
    const props = (0, $iVAEr.useDefaultProps)({
        props: inProps,
        name: 'MuiAlert'
    });
    const { action: action, children: children, className: className, closeText: closeText = 'Close', color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $c181cff0789717b3$var$defaultIconMapping, onClose: onClose, role: role = 'alert', severity: severity = 'success', slotProps: slotProps = {}, slots: slots = {}, variant: variant = 'standard' } = props, other = (0, $cFLic.default)(props, $c181cff0789717b3$var$_excluded);
    const ownerState = (0, $kY3Ke.default)({}, props, {
        color: color,
        severity: severity,
        variant: variant,
        colorSeverity: color || severity
    });
    const classes = $c181cff0789717b3$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: (0, $kY3Ke.default)({
            closeButton: components.CloseButton,
            closeIcon: components.CloseIcon
        }, slots),
        slotProps: (0, $kY3Ke.default)({}, componentsProps, slotProps)
    };
    const [CloseButtonSlot, closeButtonProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('closeButton', {
        elementType: (0, $67a243c492197f3b$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseIconSlot, closeIconProps] = (0, $6a8e6231295d6b22$export$2e2bcd8739ae039)('closeIcon', {
        elementType: (0, $8b028f185c60f26d$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $bbzbN.jsxs)($c181cff0789717b3$var$AlertRoot, (0, $kY3Ke.default)({
        role: role,
        elevation: 0,
        ownerState: ownerState,
        className: (0, $hngXp.default)(classes.root, className),
        ref: ref
    }, other, {
        children: [
            icon !== false ? /*#__PURE__*/ (0, $bbzbN.jsx)($c181cff0789717b3$var$AlertIcon, {
                ownerState: ownerState,
                className: classes.icon,
                children: icon || iconMapping[severity] || $c181cff0789717b3$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $bbzbN.jsx)($c181cff0789717b3$var$AlertMessage, {
                ownerState: ownerState,
                className: classes.message,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $bbzbN.jsx)($c181cff0789717b3$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $bbzbN.jsx)($c181cff0789717b3$var$AlertAction, {
                ownerState: ownerState,
                className: classes.action,
                children: /*#__PURE__*/ (0, $bbzbN.jsx)(CloseButtonSlot, (0, $kY3Ke.default)({
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose
                }, closeButtonProps, {
                    children: /*#__PURE__*/ (0, $bbzbN.jsx)(CloseIconSlot, (0, $kY3Ke.default)({
                        fontSize: "small"
                    }, closeIconProps))
                }))
            }) : null
        ]
    }));
});
var $c181cff0789717b3$export$2e2bcd8739ae039 = $c181cff0789717b3$var$Alert;



var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $4b7fdab16653327b$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-2h2zm0-4h-2V7h2z"
}), 'Error');


var $6PKLM = parcelRequire("6PKLM");

var $bbzbN = parcelRequire("bbzbN");
"use client";
var $22fbde4b08159ff8$export$2e2bcd8739ae039 = (0, $6PKLM.default)(/*#__PURE__*/ (0, $bbzbN.jsx)("path", {
    d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4z"
}), 'Refresh');


class $0bd0a860d8274452$var$ErrorBoundary extends (0, $7fPBF.Component) {
    static getDerivedStateFromError(_) {
        return {
            hasError: true,
            error: null,
            errorInfo: null
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error('Uncaught error:', error, errorInfo);
        this.setState({
            error: error,
            errorInfo: errorInfo
        });
    }
    render() {
        if (this.state.hasError) return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $77ec199cefd4182a$export$2e2bcd8739ae039), {
            sx: {
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                p: 3
            },
            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $bfb223886c302418$export$2e2bcd8739ae039), {
                sx: {
                    maxWidth: 600
                },
                children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $8bffaacbbee0c705$export$2e2bcd8739ae039), {
                    sx: {
                        textAlign: 'center',
                        p: 4
                    },
                    children: [
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4b7fdab16653327b$export$2e2bcd8739ae039), {
                            color: "error",
                            sx: {
                                fontSize: 64,
                                mb: 2
                            }
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                            variant: "h4",
                            gutterBottom: true,
                            children: "Something went wrong"
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                            variant: "body1",
                            color: "text.secondary",
                            sx: {
                                mb: 3
                            },
                            children: "We're sorry, but something unexpected happened. Please try refreshing the page."
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $c181cff0789717b3$export$2e2bcd8739ae039), {
                            severity: "error",
                            sx: {
                                mb: 3,
                                textAlign: 'left'
                            },
                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $26f68e516ee75fc4$export$2e2bcd8739ae039), {
                                variant: "body2",
                                children: this.state.error?.message || 'An unexpected error occurred'
                            })
                        }),
                        /*#__PURE__*/ (0, $bbzbN.jsx)((0, $45be1777d6a28263$export$2e2bcd8739ae039), {
                            variant: "contained",
                            startIcon: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $22fbde4b08159ff8$export$2e2bcd8739ae039), {}),
                            onClick: this.handleRefresh,
                            size: "large",
                            children: "Refresh Page"
                        }),
                        false
                    ]
                })
            })
        });
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            hasError: false,
            error: null,
            errorInfo: null
        }, this.handleRefresh = ()=>{
            window.location.reload();
        };
    }
}
var $0bd0a860d8274452$export$2e2bcd8739ae039 = $0bd0a860d8274452$var$ErrorBoundary;







var $7fPBF = parcelRequire("7fPBF");
const $7a71ad640b3d5334$var$WIDGET_SCRIPT_ID = 'lc-feedback-widget-script';
const $7a71ad640b3d5334$var$WIDGET_SRC = 'https://ai-lab.lighthouse-canton.com/static/widget/lc-widget.js';
function $7a71ad640b3d5334$export$2e2bcd8739ae039({ email: email }) {
    (0, $7fPBF.useEffect)(()=>{
        if (!email || document.getElementById($7a71ad640b3d5334$var$WIDGET_SCRIPT_ID)) return;
        const script = document.createElement('script');
        script.id = $7a71ad640b3d5334$var$WIDGET_SCRIPT_ID;
        script.src = $7a71ad640b3d5334$var$WIDGET_SRC;
        script.defer = true;
        document.head.appendChild(script);
    }, [
        email
    ]);
    if (!email) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement('lc-feedback-widget', {
        'app-id': 'mrms',
        'user-email': email
    });
}


// Create MSAL instance
const $5c121a02b943fe91$var$msalInstance = new (0, $c99e07903adb4e65$export$89f4855ef88b7920)((0, $7752dec9fa956b3a$export$f6d610d2730cbf1a));
function $5c121a02b943fe91$var$AuthenticatedFeedbackWidget() {
    const { user: user } = (0, $d0020511b775fb45$export$1d39dc5b47e56ff0)();
    return /*#__PURE__*/ (0, $bbzbN.jsx)((0, $7a71ad640b3d5334$export$2e2bcd8739ae039), {
        email: user?.email ?? ''
    });
}
const $5c121a02b943fe91$var$theme = (0, $hmhHQ.default)({
    palette: {
        mode: 'light',
        primary: {
            main: '#1976d2',
            dark: '#115293',
            light: '#42a5f5'
        },
        secondary: {
            main: '#dc004e'
        },
        background: {
            default: '#f5f5f5',
            paper: '#ffffff'
        },
        error: {
            main: '#f44336'
        },
        warning: {
            main: '#ff9800'
        },
        success: {
            main: '#4caf50'
        }
    },
    typography: {
        fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
        h4: {
            fontWeight: 600
        },
        h5: {
            fontWeight: 600
        },
        h6: {
            fontWeight: 500
        }
    },
    components: {
        MuiCard: {
            styleOverrides: {
                root: {
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                    borderRadius: 8
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    borderRadius: 6
                }
            }
        }
    }
});
function $5c121a02b943fe91$var$App() {
    return /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $b8226d5132dedede$export$2e2bcd8739ae039), {
        theme: $5c121a02b943fe91$var$theme,
        children: [
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $81465d564338b8cb$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $0bd0a860d8274452$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $3e5b0bdd73df37c9$export$25bac41dc3d78d47), {
                    instance: $5c121a02b943fe91$var$msalInstance,
                    children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $d0020511b775fb45$export$87091915187a1a85), {
                        children: [
                            /*#__PURE__*/ (0, $bbzbN.jsx)($5c121a02b943fe91$var$AuthenticatedFeedbackWidget, {}),
                            /*#__PURE__*/ (0, $bbzbN.jsx)((0, $2f198502e2232dfa$export$5579c65002f1fbcb), {
                                children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $a0cf24fd73ae067c$export$9ba4e89fdfa1fc54), {
                                    children: /*#__PURE__*/ (0, $bbzbN.jsx)("div", {
                                        className: "App",
                                        children: /*#__PURE__*/ (0, $bbzbN.jsxs)((0, $d9fd026bfea79ab9$export$3565eb3d00ca5a74), {
                                            children: [
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                    path: "/login",
                                                    element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e3ce077e6a7799de$export$2e2bcd8739ae039), {})
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                    path: "/auth/callback",
                                                    element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $e1d9792cfae08246$export$2e2bcd8739ae039), {})
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                    path: "/unauthorized",
                                                    element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $b89333b7d3d5e162$export$2e2bcd8739ae039), {})
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                    path: "/",
                                                    element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4f8bd3ca50416f0f$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $550e366f11f56e36$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4d3334a83e1f9fa9$export$2e2bcd8739ae039), {})
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                    path: "/portfolio/:portfolioId",
                                                    element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4f8bd3ca50416f0f$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $550e366f11f56e36$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $27e49bc84ecf2fec$export$2e2bcd8739ae039), {})
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                    path: "/alerts",
                                                    element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4f8bd3ca50416f0f$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $550e366f11f56e36$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $22dce6565050ebe5$export$2e2bcd8739ae039), {})
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                    path: "/comments",
                                                    element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4f8bd3ca50416f0f$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $550e366f11f56e36$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $689aec7135517418$export$2e2bcd8739ae039), {})
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                    path: "/exposure",
                                                    element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4f8bd3ca50416f0f$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $550e366f11f56e36$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $fc99a9134d54b89c$export$2e2bcd8739ae039), {})
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $bbzbN.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                    path: "/admin",
                                                    element: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $4f8bd3ca50416f0f$export$2e2bcd8739ae039), {
                                                        requireAdmin: true,
                                                        children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $550e366f11f56e36$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $6d2ffebabcd587a0$export$2e2bcd8739ae039), {})
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}
var $5c121a02b943fe91$export$2e2bcd8739ae039 = $5c121a02b943fe91$var$App;


const $d7ff3ee147cb4273$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($f11ec298ebcca059$exports))).createRoot(document.getElementById('root'));
$d7ff3ee147cb4273$var$root.render(/*#__PURE__*/ (0, $bbzbN.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).StrictMode, {
    children: /*#__PURE__*/ (0, $bbzbN.jsx)((0, $5c121a02b943fe91$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=frontend.98cd0221.js.map
